import ractive from 'https://cdn.jsdelivr.net/npm/ractive@1.4.4/runtime.min.mjs';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
// eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) ||
// eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
// eslint-disable-next-line no-new-func -- fallback
function () {
  return this;
}() || Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, {
    get: function () {
      return 7;
    }
  })[1] !== 7;
});

var functionBindNative = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = function () {/* empty */}.bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var call$2 = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var functionCall = functionBindNative ? call$2.bind(call$2) : function () {
  return call$2.apply(call$2, arguments);
};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({
  1: 2
}, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f$5 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;
var objectPropertyIsEnumerable = {
  f: f$5
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var FunctionPrototype$2 = Function.prototype;
var call$1 = FunctionPrototype$2.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = functionBindNative && FunctionPrototype$2.bind.bind(call$1, call$1);
var functionUncurryThis = functionBindNative ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$1.apply(fn, arguments);
  };
};

var toString$1 = functionUncurryThis({}.toString);
var stringSlice = functionUncurryThis(''.slice);
var classofRaw = function (it) {
  return stringSlice(toString$1(it), 8, -1);
};

var $Object$4 = Object;
var split = functionUncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined = function (it) {
  return it === null || it === undefined;
};

var $TypeError$f = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError$f("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings

var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isObject = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};
var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis_1[namespace]) : globalThis_1[namespace] && globalThis_1[namespace][method];
};

var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

var navigator = globalThis_1.navigator;
var userAgent = navigator && navigator.userAgent;
var environmentUserAgent = userAgent ? String(userAgent) : '';

var process = globalThis_1.process;
var Deno = globalThis_1.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && environmentUserAgent) {
  match = environmentUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = environmentUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}
var environmentV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var $String$5 = globalThis_1.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && environmentV8Version && environmentV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var useSymbolAsUid = symbolConstructorDetection && !Symbol.sham && typeof Symbol.iterator == 'symbol';

var $Object$3 = Object;
var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;
var tryToString = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$e = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError$e(tryToString(argument) + ' is not a function');
};

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var $TypeError$d = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  throw new $TypeError$d("Can't convert object to primitive value");
};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;
var defineGlobalProperty = function (key, value) {
  try {
    defineProperty$2(globalThis_1, key, {
      value: value,
      configurable: true,
      writable: true
    });
  } catch (error) {
    globalThis_1[key] = value;
  }
  return value;
};

var sharedStore = createCommonjsModule(function (module) {

  var SHARED = '__core-js_shared__';
  var store = module.exports = globalThis_1[SHARED] || defineGlobalProperty(SHARED, {});
  (store.versions || (store.versions = [])).push({
    version: '3.47.0',
    mode: 'global',
    copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)',
    license: 'https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
  });
});

var shared = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value || {});
};

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return $Object$2(requireObjectCoercible(argument));
};

var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

var id = 0;
var postfix = Math.random();
var toString = functionUncurryThis(1.1.toString);
var uid = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

var Symbol$1 = globalThis_1.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;
var wellKnownSymbol = function (name) {
  if (!hasOwnProperty_1(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name) ? Symbol$1[name] : createWellKnownSymbol('Symbol.' + name);
  }
  return WellKnownSymbolsStore[name];
};

var $TypeError$c = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError$c("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var document$1 = globalThis_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject(document$1) && isObject(document$1.createElement);
var documentCreateElement = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () {
      return 7;
    }
  }).a !== 7;
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$4 = descriptors ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) {/* empty */}
  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};
var objectGetOwnPropertyDescriptor = {
  f: f$4
};

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = descriptors && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () {/* empty */}, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var $String$3 = String;
var $TypeError$b = TypeError;

// `Assert: Type(argument) is Object`
var anObject = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError$b($String$3(argument) + ' is not an object');
};

var $TypeError$a = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$3 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  }
  return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$a('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var objectDefineProperty = {
  f: f$3
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwnProperty_1(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && function something() {/* empty */}.name === 'something';
var CONFIGURABLE = EXISTS && (!descriptors || descriptors && getDescriptor(FunctionPrototype$1, 'name').configurable);
var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var functionToString = functionUncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(sharedStore.inspectSource)) {
  sharedStore.inspectSource = function (it) {
    return functionToString(it);
  };
}
var inspectSource = sharedStore.inspectSource;

var WeakMap$1 = globalThis_1.WeakMap;
var weakMapBasicDetection = isCallable(WeakMap$1) && /native code/.test(String(WeakMap$1));

var keys$1 = shared('keys');
var sharedKey = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

var hiddenKeys$1 = {};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = globalThis_1.TypeError;
var WeakMap = globalThis_1.WeakMap;
var set, get, has$7;
var enforce = function (it) {
  return has$7(it) ? get(it) : set(it, {});
};
var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    }
    return state;
  };
};
if (weakMapBasicDetection || sharedStore.state) {
  var store = sharedStore.state || (sharedStore.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has$7 = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$1[STATE] = true;
  set = function (it, metadata) {
    if (hasOwnProperty_1(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
  };
  has$7 = function (it) {
    return hasOwnProperty_1(it, STATE);
  };
}
var internalState = {
  set: set,
  get: get,
  has: has$7,
  enforce: enforce,
  getterFor: getterFor
};

var makeBuiltIn_1 = createCommonjsModule(function (module) {

  var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
  var enforceInternalState = internalState.enforce;
  var getInternalState = internalState.get;
  var $String = String;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  var defineProperty = Object.defineProperty;
  var stringSlice = functionUncurryThis(''.slice);
  var replace = functionUncurryThis(''.replace);
  var join = functionUncurryThis([].join);
  var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
    return defineProperty(function () {/* empty */}, 'length', {
      value: 8
    }).length !== 8;
  });
  var TEMPLATE = String(String).split('String');
  var makeBuiltIn = module.exports = function (value, name, options) {
    if (stringSlice($String(name), 0, 7) === 'Symbol(') {
      name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    }
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!hasOwnProperty_1(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
      if (descriptors) defineProperty(value, 'name', {
        value: name,
        configurable: true
      });else value.name = name;
    }
    if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
      defineProperty(value, 'length', {
        value: options.arity
      });
    }
    try {
      if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
        if (descriptors) defineProperty(value, 'prototype', {
          writable: false
        });
        // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
      } else if (value.prototype) value.prototype = undefined;
    } catch (error) {/* empty */}
    var state = enforceInternalState(value);
    if (!hasOwnProperty_1(state, 'source')) {
      state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
    }
    return value;
  };

  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  // eslint-disable-next-line no-extend-native -- required
  Function.prototype.toString = makeBuiltIn(function toString() {
    return isCallable(this) && getInternalState(this).source || inspectSource(this);
  }, 'toString');
});

var defineBuiltIn = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn_1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
    } catch (error) {/* empty */}
    if (simple) O[key] = value;else objectDefineProperty.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  }
  return O;
};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : mathTrunc(number);
};

var max$1 = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max$1(integer + length, 0) : min$1(integer, length);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike = function (obj) {
  return toLength(obj.length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};
var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;
var push$3 = functionUncurryThis([].push);
var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwnProperty_1(hiddenKeys$1, key) && hasOwnProperty_1(O, key) && push$3(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
    ~indexOf(result, key) || push$3(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$2 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys);
};
var objectGetOwnPropertyNames = {
  f: f$2
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$1 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols = {
  f: f$1
};

var concat = functionUncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement = /#|\.prototype\./;
var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
var isForced_1 = isForced;

var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis_1;
  } else if (STATIC) {
    target = globalThis_1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis_1[TARGET] && globalThis_1[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

var $TypeError$9 = TypeError;
var anInstance = function (it, Prototype) {
  if (objectIsPrototypeOf(Prototype, it)) return it;
  throw new $TypeError$9('Incorrect invocation');
};

var correctPrototypeGetter = !fails(function () {
  function F() {/* empty */}
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }
  return object instanceof $Object$1 ? ObjectPrototype : null;
};

var defineBuiltInAccessor = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, {
    getter: true
  });
  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, {
    setter: true
  });
  return objectDefineProperty.f(target, name, descriptor);
};

var createProperty = function (object, key, value) {
  if (descriptors) objectDefineProperty.f(object, key, createPropertyDescriptor(0, value));else object[key] = value;
};

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var f = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
  return O;
};
var objectDefineProperties = {
  f: f
};

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');
var EmptyConstructor = function () {/* empty */};
var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) {/* ignore */}
  NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};
hiddenKeys$1[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
};

var ITERATOR$3 = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}
var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype$2) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$3].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype$2[ITERATOR$3])) {
  defineBuiltIn(IteratorPrototype$2, ITERATOR$3, function () {
    return this;
  });
}
var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var CONSTRUCTOR = 'constructor';
var ITERATOR$2 = 'Iterator';
var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
var $TypeError$8 = TypeError;
var NativeIterator = globalThis_1[ITERATOR$2];

// FF56- have non-standard global helper `Iterator`
var FORCED$8 = !isCallable(NativeIterator) || NativeIterator.prototype !== IteratorPrototype$1
// FF44- non-standard `Iterator` passes previous tests
|| !fails(function () {
  NativeIterator({});
});
var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorPrototype$1);
  if (objectGetPrototypeOf(this) === IteratorPrototype$1) throw new $TypeError$8('Abstract class Iterator not directly constructable');
};
var defineIteratorPrototypeAccessor = function (key, value) {
  if (descriptors) {
    defineBuiltInAccessor(IteratorPrototype$1, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject(this);
        if (this === IteratorPrototype$1) throw new $TypeError$8("You can't redefine this property");
        if (hasOwnProperty_1(this, key)) this[key] = replacement;else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype$1[key] = value;
};
if (!hasOwnProperty_1(IteratorPrototype$1, TO_STRING_TAG$3)) defineIteratorPrototypeAccessor(TO_STRING_TAG$3, ITERATOR$2);
if (FORCED$8 || !hasOwnProperty_1(IteratorPrototype$1, CONSTRUCTOR) || IteratorPrototype$1[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}
IteratorConstructor.prototype = IteratorPrototype$1;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
_export({
  global: true,
  constructor: true,
  forced: FORCED$8
}, {
  Iterator: IteratorConstructor
});

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return functionUncurryThis(fn);
};

var bind = functionUncurryThisClause(functionUncurryThisClause.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : functionBindNative ? bind(fn, that) : function /* ...args */
  () {
    return fn.apply(that, arguments);
  };
};

var iterators = {};

var ITERATOR$1 = wellKnownSymbol('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR$1] === it);
};

var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
var test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
test[TO_STRING_TAG$2] = 'z';
var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () {
  return arguments;
}()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) {/* empty */}
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$1)) == 'string' ? tag
  // builtinTag case
  : CORRECT_ARGUMENTS ? classofRaw(O)
  // ES3 arguments fallback
  : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var ITERATOR = wellKnownSymbol('iterator');
var getIteratorMethod = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || iterators[classof(it)];
};

var $TypeError$7 = TypeError;
var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw new $TypeError$7(tryToString(argument) + ' is not iterable');
};

var iteratorClose = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = functionCall(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

var $TypeError$6 = TypeError;
var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};
var ResultPrototype = Result.prototype;
var iterate = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;
  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal');
    return new Result(true, condition);
  };
  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }
    return INTERRUPTED ? fn(value, stop) : fn(value);
  };
  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError$6(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
      }
      return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }
  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = functionCall(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
  }
  return new Result(false);
};

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/ecma262/#sec-getiteratordirect
var getIteratorDirect = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};

// https://github.com/tc39/ecma262/pull/3467
var iteratorHelperWithoutClosingOnEarlyError = function (METHOD_NAME, ExpectedError) {
  var Iterator = globalThis_1.Iterator;
  var IteratorPrototype = Iterator && Iterator.prototype;
  var method = IteratorPrototype && IteratorPrototype[METHOD_NAME];
  var CLOSED = false;
  if (method) try {
    method.call({
      next: function () {
        return {
          done: true
        };
      },
      'return': function () {
        CLOSED = true;
      }
    }, -1);
  } catch (error) {
    // https://bugs.webkit.org/show_bug.cgi?id=291195
    if (!(error instanceof ExpectedError)) CLOSED = false;
  }
  if (!CLOSED) return method;
};

var forEachWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('forEach', TypeError);

// `Iterator.prototype.forEach` method
// https://tc39.es/ecma262/#sec-iterator.prototype.foreach
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: forEachWithoutClosingOnEarlyError
}, {
  forEach: function forEach(fn) {
    anObject(this);
    try {
      aCallable(fn);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (forEachWithoutClosingOnEarlyError) return functionCall(forEachWithoutClosingOnEarlyError, this, fn);
    var record = getIteratorDirect(this);
    var counter = 0;
    iterate(record, function (value) {
      fn(value, counter++);
    }, {
      IS_RECORD: true
    });
  }
});

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(argument) {
  return classofRaw(argument) === 'Array';
};

var $String$2 = String;
var toString_1 = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$2(argument);
};

var $SyntaxError = SyntaxError;
var $parseInt = parseInt;
var fromCharCode = String.fromCharCode;
var at$1 = functionUncurryThis(''.charAt);
var slice$2 = functionUncurryThis(''.slice);
var exec$2 = functionUncurryThis(/./.exec);
var codePoints = {
  '\\"': '"',
  '\\\\': '\\',
  '\\/': '/',
  '\\b': '\b',
  '\\f': '\f',
  '\\n': '\n',
  '\\r': '\r',
  '\\t': '\t'
};
var IS_4_HEX_DIGITS = /^[\da-f]{4}$/i;
// eslint-disable-next-line regexp/no-control-character -- safe
var IS_C0_CONTROL_CODE = /^[\u0000-\u001F]$/;
var parseJsonString = function (source, i) {
  var unterminated = true;
  var value = '';
  while (i < source.length) {
    var chr = at$1(source, i);
    if (chr === '\\') {
      var twoChars = slice$2(source, i, i + 2);
      if (hasOwnProperty_1(codePoints, twoChars)) {
        value += codePoints[twoChars];
        i += 2;
      } else if (twoChars === '\\u') {
        i += 2;
        var fourHexDigits = slice$2(source, i, i + 4);
        if (!exec$2(IS_4_HEX_DIGITS, fourHexDigits)) throw new $SyntaxError('Bad Unicode escape at: ' + i);
        value += fromCharCode($parseInt(fourHexDigits, 16));
        i += 4;
      } else throw new $SyntaxError('Unknown escape sequence: "' + twoChars + '"');
    } else if (chr === '"') {
      unterminated = false;
      i++;
      break;
    } else {
      if (exec$2(IS_C0_CONTROL_CODE, chr)) throw new $SyntaxError('Bad control character in string literal at: ' + i);
      value += chr;
      i++;
    }
  }
  if (unterminated) throw new $SyntaxError('Unterminated string at: ' + i);
  return {
    value: value,
    end: i
  };
};

var JSON$1 = globalThis_1.JSON;
var Number$1 = globalThis_1.Number;
var SyntaxError$1 = globalThis_1.SyntaxError;
var nativeParse = JSON$1 && JSON$1.parse;
var enumerableOwnProperties = getBuiltIn('Object', 'keys');
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var at = functionUncurryThis(''.charAt);
var slice$1 = functionUncurryThis(''.slice);
var exec$1 = functionUncurryThis(/./.exec);
var push$2 = functionUncurryThis([].push);
var IS_DIGIT = /^\d$/;
var IS_NON_ZERO_DIGIT = /^[1-9]$/;
var IS_NUMBER_START = /^[\d-]$/;
var IS_WHITESPACE = /^[\t\n\r ]$/;
var PRIMITIVE = 0;
var OBJECT = 1;
var $parse = function (source, reviver) {
  source = toString_1(source);
  var context = new Context(source, 0);
  var root = context.parse();
  var value = root.value;
  var endIndex = context.skip(IS_WHITESPACE, root.end);
  if (endIndex < source.length) {
    throw new SyntaxError$1('Unexpected extra character: "' + at(source, endIndex) + '" after the parsed data at: ' + endIndex);
  }
  return isCallable(reviver) ? internalize({
    '': value
  }, '', reviver, root) : value;
};
var internalize = function (holder, name, reviver, node) {
  var val = holder[name];
  var unmodified = node && val === node.value;
  var context = unmodified && typeof node.source == 'string' ? {
    source: node.source
  } : {};
  var elementRecordsLen, keys, len, i, P;
  if (isObject(val)) {
    var nodeIsArray = isArray(val);
    var nodes = unmodified ? node.nodes : nodeIsArray ? [] : {};
    if (nodeIsArray) {
      elementRecordsLen = nodes.length;
      len = lengthOfArrayLike(val);
      for (i = 0; i < len; i++) {
        internalizeProperty(val, i, internalize(val, '' + i, reviver, i < elementRecordsLen ? nodes[i] : undefined));
      }
    } else {
      keys = enumerableOwnProperties(val);
      len = lengthOfArrayLike(keys);
      for (i = 0; i < len; i++) {
        P = keys[i];
        internalizeProperty(val, P, internalize(val, P, reviver, hasOwnProperty_1(nodes, P) ? nodes[P] : undefined));
      }
    }
  }
  return functionCall(reviver, holder, name, val, context);
};
var internalizeProperty = function (object, key, value) {
  if (descriptors) {
    var descriptor = getOwnPropertyDescriptor$1(object, key);
    if (descriptor && !descriptor.configurable) return;
  }
  if (value === undefined) delete object[key];else createProperty(object, key, value);
};
var Node = function (value, end, source, nodes) {
  this.value = value;
  this.end = end;
  this.source = source;
  this.nodes = nodes;
};
var Context = function (source, index) {
  this.source = source;
  this.index = index;
};

// https://www.json.org/json-en.html
Context.prototype = {
  fork: function (nextIndex) {
    return new Context(this.source, nextIndex);
  },
  parse: function () {
    var source = this.source;
    var i = this.skip(IS_WHITESPACE, this.index);
    var fork = this.fork(i);
    var chr = at(source, i);
    if (exec$1(IS_NUMBER_START, chr)) return fork.number();
    switch (chr) {
      case '{':
        return fork.object();
      case '[':
        return fork.array();
      case '"':
        return fork.string();
      case 't':
        return fork.keyword(true);
      case 'f':
        return fork.keyword(false);
      case 'n':
        return fork.keyword(null);
    }
    throw new SyntaxError$1('Unexpected character: "' + chr + '" at: ' + i);
  },
  node: function (type, value, start, end, nodes) {
    return new Node(value, end, type ? null : slice$1(this.source, start, end), nodes);
  },
  object: function () {
    var source = this.source;
    var i = this.index + 1;
    var expectKeypair = false;
    var object = {};
    var nodes = {};
    while (i < source.length) {
      i = this.until(['"', '}'], i);
      if (at(source, i) === '}' && !expectKeypair) {
        i++;
        break;
      }
      // Parsing the key
      var result = this.fork(i).string();
      var key = result.value;
      i = result.end;
      i = this.until([':'], i) + 1;
      // Parsing value
      i = this.skip(IS_WHITESPACE, i);
      result = this.fork(i).parse();
      createProperty(nodes, key, result);
      createProperty(object, key, result.value);
      i = this.until([',', '}'], result.end);
      var chr = at(source, i);
      if (chr === ',') {
        expectKeypair = true;
        i++;
      } else if (chr === '}') {
        i++;
        break;
      }
    }
    return this.node(OBJECT, object, this.index, i, nodes);
  },
  array: function () {
    var source = this.source;
    var i = this.index + 1;
    var expectElement = false;
    var array = [];
    var nodes = [];
    while (i < source.length) {
      i = this.skip(IS_WHITESPACE, i);
      if (at(source, i) === ']' && !expectElement) {
        i++;
        break;
      }
      var result = this.fork(i).parse();
      push$2(nodes, result);
      push$2(array, result.value);
      i = this.until([',', ']'], result.end);
      if (at(source, i) === ',') {
        expectElement = true;
        i++;
      } else if (at(source, i) === ']') {
        i++;
        break;
      }
    }
    return this.node(OBJECT, array, this.index, i, nodes);
  },
  string: function () {
    var index = this.index;
    var parsed = parseJsonString(this.source, this.index + 1);
    return this.node(PRIMITIVE, parsed.value, index, parsed.end);
  },
  number: function () {
    var source = this.source;
    var startIndex = this.index;
    var i = startIndex;
    if (at(source, i) === '-') i++;
    if (at(source, i) === '0') i++;else if (exec$1(IS_NON_ZERO_DIGIT, at(source, i))) i = this.skip(IS_DIGIT, i + 1);else throw new SyntaxError$1('Failed to parse number at: ' + i);
    if (at(source, i) === '.') i = this.skip(IS_DIGIT, i + 1);
    if (at(source, i) === 'e' || at(source, i) === 'E') {
      i++;
      if (at(source, i) === '+' || at(source, i) === '-') i++;
      var exponentStartIndex = i;
      i = this.skip(IS_DIGIT, i);
      if (exponentStartIndex === i) throw new SyntaxError$1("Failed to parse number's exponent value at: " + i);
    }
    return this.node(PRIMITIVE, Number$1(slice$1(source, startIndex, i)), startIndex, i);
  },
  keyword: function (value) {
    var keyword = '' + value;
    var index = this.index;
    var endIndex = index + keyword.length;
    if (slice$1(this.source, index, endIndex) !== keyword) throw new SyntaxError$1('Failed to parse value at: ' + index);
    return this.node(PRIMITIVE, value, index, endIndex);
  },
  skip: function (regex, i) {
    var source = this.source;
    for (; i < source.length; i++) if (!exec$1(regex, at(source, i))) break;
    return i;
  },
  until: function (array, i) {
    i = this.skip(IS_WHITESPACE, i);
    var chr = at(this.source, i);
    for (var j = 0; j < array.length; j++) if (array[j] === chr) return i;
    throw new SyntaxError$1('Unexpected character: "' + chr + '" at: ' + i);
  }
};
var NO_SOURCE_SUPPORT = fails(function () {
  var unsafeInt = '9007199254740993';
  var source;
  nativeParse(unsafeInt, function (key, value, context) {
    source = context.source;
  });
  return source !== unsafeInt;
});
var PROPER_BASE_PARSE = symbolConstructorDetection && !fails(function () {
  // Safari 9 bug
  return 1 / nativeParse('-0 \t') !== -Infinity;
});

// `JSON.parse` method
// https://tc39.es/ecma262/#sec-json.parse
// https://github.com/tc39/proposal-json-parse-with-source
_export({
  target: 'JSON',
  stat: true,
  forced: NO_SOURCE_SUPPORT
}, {
  parse: function parse(text, reviver) {
    return PROPER_BASE_PARSE && !isCallable(reviver) ? nativeParse(text) : $parse(text, reviver);
  }
});

var $TypeError$5 = TypeError;
var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw new $TypeError$5('Not enough arguments');
  return passed;
};

var $URLSearchParams$1 = URLSearchParams;
var URLSearchParamsPrototype$2 = $URLSearchParams$1.prototype;
var append = functionUncurryThis(URLSearchParamsPrototype$2.append);
var $delete = functionUncurryThis(URLSearchParamsPrototype$2['delete']);
var forEach$2 = functionUncurryThis(URLSearchParamsPrototype$2.forEach);
var push$1 = functionUncurryThis([].push);
var params$1 = new $URLSearchParams$1('a=1&a=2&b=3');
params$1['delete']('a', 1);
// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
params$1['delete']('b', undefined);
if (params$1 + '' !== 'a=2') {
  defineBuiltIn(URLSearchParamsPrototype$2, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach$2(this, function (v, k) {
      // also validates `this`
      push$1(entries, {
        key: k,
        value: v
      });
    });
    validateArgumentsLength(length, 1);
    var key = toString_1(name);
    var value = toString_1($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, {
    enumerable: true,
    unsafe: true
  });
}

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype$1 = $URLSearchParams.prototype;
var getAll = functionUncurryThis(URLSearchParamsPrototype$1.getAll);
var $has = functionUncurryThis(URLSearchParamsPrototype$1.has);
var params = new $URLSearchParams('a=1');

// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
if (params.has('a', 2) || !params.has('a', undefined)) {
  defineBuiltIn(URLSearchParamsPrototype$1, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString_1($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    }
    return false;
  }, {
    enumerable: true,
    unsafe: true
  });
}

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach$1 = functionUncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (descriptors && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach$1(this, function () {
        count++;
      });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}

Math.log10 = Math.log10 || function (x) {
  return Math.log(x) * Math.LOG10E;
};

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});

var getInternalState = internalState.get;
var isRawJson = function isRawJSON(O) {
  if (!isObject(O)) return false;
  var state = getInternalState(O);
  return !!state && state.type === 'RawJSON';
};

var arraySlice = functionUncurryThis([].slice);

/* eslint-disable es/no-json -- safe */

var nativeRawJson = !fails(function () {
  var unsafeInt = '9007199254740993';
  // eslint-disable-next-line es/no-nonstandard-json-properties -- feature detection
  var raw = JSON.rawJSON(unsafeInt);
  // eslint-disable-next-line es/no-nonstandard-json-properties -- feature detection
  return !JSON.isRawJSON(raw) || JSON.stringify(raw) !== unsafeInt;
});

var $String$1 = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = functionUncurryThis(/./.exec);
var charAt = functionUncurryThis(''.charAt);
var charCodeAt = functionUncurryThis(''.charCodeAt);
var replace$1 = functionUncurryThis(''.replace);
var slice = functionUncurryThis(''.slice);
var push = functionUncurryThis([].push);
var numberToString = functionUncurryThis(1.1.toString);
var surrogates = /[\uD800-\uDFFF]/g;
var lowSurrogates = /^[\uD800-\uDBFF]$/;
var hiSurrogates = /^[\uDC00-\uDFFF]$/;
var MARK = uid();
var MARK_LENGTH = MARK.length;
var WRONG_SYMBOLS_CONVERSION = !symbolConstructorDetection || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
  // WebKit converts symbol values to JSON as null
  || $stringify({
    a: symbol
  }) !== '{}'
  // V8 throws on boxed symbols
  || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $stringify('\uDEAD') !== '"\\udead"';
});
var stringifyWithProperSymbolsConversion = WRONG_SYMBOLS_CONVERSION ? function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = functionCall($replacer, this, $String$1(key), value);
    if (!isSymbol(value)) return value;
  };
  return functionApply($stringify, null, args);
} : $stringify;
var fixIllFormedJSON = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if (exec(lowSurrogates, match) && !exec(hiSurrogates, next) || exec(hiSurrogates, match) && !exec(lowSurrogates, prev)) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  }
  return match;
};
var getReplacerFunction = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);else if (typeof element == 'number' || classofRaw(element) === 'Number' || classofRaw(element) === 'String') push(keys, toString_1(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};

// `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
// https://github.com/tc39/proposal-json-parse-with-source
if ($stringify) _export({
  target: 'JSON',
  stat: true,
  arity: 3,
  forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE || !nativeRawJson
}, {
  stringify: function stringify(text, replacer, space) {
    var replacerFunction = getReplacerFunction(replacer);
    var rawStrings = [];
    var json = stringifyWithProperSymbolsConversion(text, function (key, value) {
      // some old implementations (like WebKit) could pass numbers as keys
      var v = isCallable(replacerFunction) ? functionCall(replacerFunction, this, $String$1(key), value) : value;
      return !nativeRawJson && isRawJson(v) ? MARK + (push(rawStrings, v.rawJSON) - 1) : v;
    }, space);
    if (typeof json != 'string') return json;
    if (ILL_FORMED_UNICODE) json = replace$1(json, surrogates, fixIllFormedJSON);
    if (nativeRawJson) return json;
    var result = '';
    var length = json.length;
    for (var i = 0; i < length; i++) {
      var chr = charAt(json, i);
      if (chr === '"') {
        var end = parseJsonString(json, ++i).end - 1;
        var string = slice(json, i, end);
        result += slice(string, 0, MARK_LENGTH) === MARK ? rawStrings[slice(string, MARK_LENGTH)] : '"' + string + '"';
        i = end;
      } else result += chr;
    }
    return result;
  }
});

var $TypeError$4 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = descriptors && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();
var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError$4('Cannot set read only .length');
  }
  return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $TypeError$3 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$3('Maximum allowed index exceeded');
  return it;
};

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({
    length: 0x100000000
  }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};
var FORCED$7 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
_export({
  target: 'Array',
  proto: true,
  arity: 1,
  forced: FORCED$7
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    arraySetLength(O, len);
    return len;
  }
});

var arrayFromConstructorAndList = function (Constructor, list, $length) {
  var index = 0;
  var length = arguments.length > 2 ? $length : lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var getBuiltInPrototypeMethod = function (CONSTRUCTOR, METHOD) {
  var Constructor = globalThis_1[CONSTRUCTOR];
  var Prototype = Constructor && Constructor.prototype;
  return Prototype && Prototype[METHOD];
};

var defineProperty$1 = objectDefineProperty.f;
var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$1(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $Array = Array;
var sort = functionUncurryThis(getBuiltInPrototypeMethod('Array', 'sort'));

// `Array.prototype.toSorted` method
// https://tc39.es/ecma262/#sec-array.prototype.tosorted
_export({
  target: 'Array',
  proto: true
}, {
  toSorted: function toSorted(compareFn) {
    if (compareFn !== undefined) aCallable(compareFn);
    var O = toIndexedObject(this);
    var A = arrayFromConstructorAndList($Array, O);
    return sort(A, compareFn);
  }
});
addToUnscopables('toSorted');

var defineBuiltIns = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject = function (value, done) {
  return {
    value: value,
    done: done
  };
};

var iteratorCloseAll = function (iters, kind, value) {
  for (var i = iters.length - 1; i >= 0; i--) {
    if (iters[i] === undefined) continue;
    try {
      value = iteratorClose(iters[i].iterator, kind, value);
    } catch (error) {
      kind = 'throw';
      value = error;
    }
  }
  if (kind === 'throw') throw value;
  return value;
};

var IteratorPrototype = iteratorsCore.IteratorPrototype;
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var NORMAL = 'normal';
var THROW = 'throw';
var setInternalState = internalState.set;
var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = internalState.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);
  return defineBuiltIns(objectCreate(IteratorPrototype), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      if (state.done) return createIterResultObject(undefined, true);
      try {
        var result = state.nextHandler();
        return state.returnHandlerResult ? result : createIterResultObject(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod(iterator, 'return');
        return returnMethod ? functionCall(returnMethod, iterator) : createIterResultObject(undefined, true);
      }
      if (state.inner) try {
        iteratorClose(state.inner.iterator, NORMAL);
      } catch (error) {
        return iteratorClose(iterator, THROW, error);
      }
      if (state.openIters) try {
        iteratorCloseAll(state.openIters, NORMAL);
      } catch (error) {
        return iteratorClose(iterator, THROW, error);
      }
      if (iterator) iteratorClose(iterator, NORMAL);
      return createIterResultObject(undefined, true);
    }
  });
};
var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);
createNonEnumerableProperty(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');
var iteratorCreateProxy = function (nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState(this, state);
  };
  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;
  return IteratorProxy;
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

// Should throw an error on invalid iterator
// https://issues.chromium.org/issues/336839115
var iteratorHelperThrowsOnInvalidIterator = function (methodName, argument) {
  // eslint-disable-next-line es/no-iterator -- required for testing
  var method = typeof Iterator == 'function' && Iterator.prototype[methodName];
  if (method) try {
    method.call({
      next: null
    }, argument).next();
  } catch (error) {
    return true;
  }
};

var FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('filter', function () {/* empty */});
var filterWithoutClosingOnEarlyError = !FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError('filter', TypeError);
var FORCED$6 = FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR || filterWithoutClosingOnEarlyError;
var IteratorProxy$3 = iteratorCreateProxy(function () {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject(functionCall(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
  }
});

// `Iterator.prototype.filter` method
// https://tc39.es/ecma262/#sec-iterator.prototype.filter
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: FORCED$6
}, {
  filter: function filter(predicate) {
    anObject(this);
    try {
      aCallable(predicate);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (filterWithoutClosingOnEarlyError) return functionCall(filterWithoutClosingOnEarlyError, this, predicate);
    return new IteratorProxy$3(getIteratorDirect(this), {
      predicate: predicate
    });
  }
});

var MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('map', function () {/* empty */});
var mapWithoutClosingOnEarlyError = !MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError('map', TypeError);
var FORCED$5 = MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR || mapWithoutClosingOnEarlyError;
var IteratorProxy$2 = iteratorCreateProxy(function () {
  var iterator = this.iterator;
  var result = anObject(functionCall(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
});

// `Iterator.prototype.map` method
// https://tc39.es/ecma262/#sec-iterator.prototype.map
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: FORCED$5
}, {
  map: function map(mapper) {
    anObject(this);
    try {
      aCallable(mapper);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (mapWithoutClosingOnEarlyError) return functionCall(mapWithoutClosingOnEarlyError, this, mapper);
    return new IteratorProxy$2(getIteratorDirect(this), {
      mapper: mapper
    });
  }
});

var $TypeError$2 = TypeError;

// https://bugs.webkit.org/show_bug.cgi?id=291651
var FAILS_ON_INITIAL_UNDEFINED = fails(function () {
  // eslint-disable-next-line es/no-iterator-prototype-reduce, es/no-array-prototype-keys, array-callback-return -- required for testing
  [].keys().reduce(function () {/* empty */}, undefined);
});
var reduceWithoutClosingOnEarlyError = !FAILS_ON_INITIAL_UNDEFINED && iteratorHelperWithoutClosingOnEarlyError('reduce', $TypeError$2);

// `Iterator.prototype.reduce` method
// https://tc39.es/ecma262/#sec-iterator.prototype.reduce
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: FAILS_ON_INITIAL_UNDEFINED || reduceWithoutClosingOnEarlyError
}, {
  reduce: function reduce(reducer /* , initialValue */) {
    anObject(this);
    try {
      aCallable(reducer);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    if (reduceWithoutClosingOnEarlyError) {
      return functionApply(reduceWithoutClosingOnEarlyError, this, noInitial ? [reducer] : [reducer, accumulator]);
    }
    var record = getIteratorDirect(this);
    var counter = 0;
    iterate(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value, counter);
      }
      counter++;
    }, {
      IS_RECORD: true
    });
    if (noInitial) throw new $TypeError$2('Reduce of empty iterator with no initial value');
    return accumulator;
  }
});

var newHost = "img.jsdelivr.com";
var hosts = [
	"cloud.githubusercontent.com",
	"img.shields.io",
	"img.badgesize.io",
	"raw.githubusercontent.com",
	"github.com",
	"upload.wikimedia.org",
	"opencollective.com",
	"flat.badgen.net",
	"images.opencollective.com",
	"avatars.githubusercontent.com",
	"badgen.net"
];
var optimizedHosts$1 = {
	newHost: newHost,
	hosts: hosts
};

var optimizedHosts$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	newHost: newHost,
	hosts: hosts,
	'default': optimizedHosts$1
});

var countries$1 = [
	{
		code: "AD",
		name: "Andorra"
	},
	{
		code: "AE",
		name: "United Arab Emirates"
	},
	{
		code: "AF",
		name: "Afghanistan"
	},
	{
		code: "AG",
		name: "Antigua and Barbuda"
	},
	{
		code: "AI",
		name: "Anguilla"
	},
	{
		code: "AL",
		name: "Albania"
	},
	{
		code: "AM",
		name: "Armenia"
	},
	{
		code: "AO",
		name: "Angola"
	},
	{
		code: "AQ",
		name: "Antarctica"
	},
	{
		code: "AR",
		name: "Argentina"
	},
	{
		code: "AS",
		name: "American Samoa"
	},
	{
		code: "AT",
		name: "Austria"
	},
	{
		code: "AU",
		name: "Australia"
	},
	{
		code: "AW",
		name: "Aruba"
	},
	{
		code: "AX",
		name: "Åland"
	},
	{
		code: "AZ",
		name: "Azerbaijan"
	},
	{
		code: "BA",
		name: "Bosnia and Herzegovina"
	},
	{
		code: "BB",
		name: "Barbados"
	},
	{
		code: "BD",
		name: "Bangladesh"
	},
	{
		code: "BE",
		name: "Belgium"
	},
	{
		code: "BF",
		name: "Burkina Faso"
	},
	{
		code: "BG",
		name: "Bulgaria"
	},
	{
		code: "BH",
		name: "Bahrain"
	},
	{
		code: "BI",
		name: "Burundi"
	},
	{
		code: "BJ",
		name: "Benin"
	},
	{
		code: "BL",
		name: "Saint Barthélemy"
	},
	{
		code: "BM",
		name: "Bermuda"
	},
	{
		code: "BN",
		name: "Brunei"
	},
	{
		code: "BO",
		name: "Bolivia"
	},
	{
		code: "BQ",
		name: "Bonaire"
	},
	{
		code: "BR",
		name: "Brazil"
	},
	{
		code: "BS",
		name: "Bahamas"
	},
	{
		code: "BT",
		name: "Bhutan"
	},
	{
		code: "BV",
		name: "Bouvet Island"
	},
	{
		code: "BW",
		name: "Botswana"
	},
	{
		code: "BY",
		name: "Belarus"
	},
	{
		code: "BZ",
		name: "Belize"
	},
	{
		code: "CA",
		name: "Canada"
	},
	{
		code: "CC",
		name: "Cocos (Keeling) Islands"
	},
	{
		code: "CD",
		name: "Democratic Republic of the Congo"
	},
	{
		code: "CF",
		name: "Central African Republic"
	},
	{
		code: "CG",
		name: "Republic of the Congo"
	},
	{
		code: "CH",
		name: "Switzerland"
	},
	{
		code: "CI",
		name: "Ivory Coast"
	},
	{
		code: "CK",
		name: "Cook Islands"
	},
	{
		code: "CL",
		name: "Chile"
	},
	{
		code: "CM",
		name: "Cameroon"
	},
	{
		code: "CN",
		name: "China"
	},
	{
		code: "CO",
		name: "Colombia"
	},
	{
		code: "CR",
		name: "Costa Rica"
	},
	{
		code: "CU",
		name: "Cuba"
	},
	{
		code: "CV",
		name: "Cape Verde"
	},
	{
		code: "CW",
		name: "Curacao"
	},
	{
		code: "CX",
		name: "Christmas Island"
	},
	{
		code: "CY",
		name: "Cyprus"
	},
	{
		code: "CZ",
		name: "Czech Republic"
	},
	{
		code: "DE",
		name: "Germany"
	},
	{
		code: "DJ",
		name: "Djibouti"
	},
	{
		code: "DK",
		name: "Denmark"
	},
	{
		code: "DM",
		name: "Dominica"
	},
	{
		code: "DO",
		name: "Dominican Republic"
	},
	{
		code: "DZ",
		name: "Algeria"
	},
	{
		code: "EC",
		name: "Ecuador"
	},
	{
		code: "EE",
		name: "Estonia"
	},
	{
		code: "EG",
		name: "Egypt"
	},
	{
		code: "EH",
		name: "Western Sahara"
	},
	{
		code: "ER",
		name: "Eritrea"
	},
	{
		code: "ES",
		name: "Spain"
	},
	{
		code: "ET",
		name: "Ethiopia"
	},
	{
		code: "FI",
		name: "Finland"
	},
	{
		code: "FJ",
		name: "Fiji"
	},
	{
		code: "FK",
		name: "Falkland Islands"
	},
	{
		code: "FM",
		name: "Micronesia"
	},
	{
		code: "FO",
		name: "Faroe Islands"
	},
	{
		code: "FR",
		name: "France"
	},
	{
		code: "GA",
		name: "Gabon"
	},
	{
		code: "GB",
		name: "United Kingdom"
	},
	{
		code: "GD",
		name: "Grenada"
	},
	{
		code: "GE",
		name: "Georgia"
	},
	{
		code: "GF",
		name: "French Guiana"
	},
	{
		code: "GG",
		name: "Guernsey"
	},
	{
		code: "GH",
		name: "Ghana"
	},
	{
		code: "GI",
		name: "Gibraltar"
	},
	{
		code: "GL",
		name: "Greenland"
	},
	{
		code: "GM",
		name: "Gambia"
	},
	{
		code: "GN",
		name: "Guinea"
	},
	{
		code: "GP",
		name: "Guadeloupe"
	},
	{
		code: "GQ",
		name: "Equatorial Guinea"
	},
	{
		code: "GR",
		name: "Greece"
	},
	{
		code: "GS",
		name: "South Georgia and the South Sandwich Islands"
	},
	{
		code: "GT",
		name: "Guatemala"
	},
	{
		code: "GU",
		name: "Guam"
	},
	{
		code: "GW",
		name: "Guinea-Bissau"
	},
	{
		code: "GY",
		name: "Guyana"
	},
	{
		code: "HK",
		name: "Hong Kong"
	},
	{
		code: "HM",
		name: "Heard Island and McDonald Islands"
	},
	{
		code: "HN",
		name: "Honduras"
	},
	{
		code: "HR",
		name: "Croatia"
	},
	{
		code: "HT",
		name: "Haiti"
	},
	{
		code: "HU",
		name: "Hungary"
	},
	{
		code: "ID",
		name: "Indonesia"
	},
	{
		code: "IE",
		name: "Ireland"
	},
	{
		code: "IL",
		name: "Israel"
	},
	{
		code: "IM",
		name: "Isle of Man"
	},
	{
		code: "IN",
		name: "India"
	},
	{
		code: "IO",
		name: "British Indian Ocean Territory"
	},
	{
		code: "IQ",
		name: "Iraq"
	},
	{
		code: "IR",
		name: "Iran"
	},
	{
		code: "IS",
		name: "Iceland"
	},
	{
		code: "IT",
		name: "Italy"
	},
	{
		code: "JE",
		name: "Jersey"
	},
	{
		code: "JM",
		name: "Jamaica"
	},
	{
		code: "JO",
		name: "Jordan"
	},
	{
		code: "JP",
		name: "Japan"
	},
	{
		code: "KE",
		name: "Kenya"
	},
	{
		code: "KG",
		name: "Kyrgyzstan"
	},
	{
		code: "KH",
		name: "Cambodia"
	},
	{
		code: "KI",
		name: "Kiribati"
	},
	{
		code: "KM",
		name: "Comoros"
	},
	{
		code: "KN",
		name: "Saint Kitts and Nevis"
	},
	{
		code: "KP",
		name: "North Korea"
	},
	{
		code: "KR",
		name: "South Korea"
	},
	{
		code: "KW",
		name: "Kuwait"
	},
	{
		code: "KY",
		name: "Cayman Islands"
	},
	{
		code: "KZ",
		name: "Kazakhstan"
	},
	{
		code: "LA",
		name: "Laos"
	},
	{
		code: "LB",
		name: "Lebanon"
	},
	{
		code: "LC",
		name: "Saint Lucia"
	},
	{
		code: "LI",
		name: "Liechtenstein"
	},
	{
		code: "LK",
		name: "Sri Lanka"
	},
	{
		code: "LR",
		name: "Liberia"
	},
	{
		code: "LS",
		name: "Lesotho"
	},
	{
		code: "LT",
		name: "Lithuania"
	},
	{
		code: "LU",
		name: "Luxembourg"
	},
	{
		code: "LV",
		name: "Latvia"
	},
	{
		code: "LY",
		name: "Libya"
	},
	{
		code: "MA",
		name: "Morocco"
	},
	{
		code: "MC",
		name: "Monaco"
	},
	{
		code: "MD",
		name: "Moldova"
	},
	{
		code: "ME",
		name: "Montenegro"
	},
	{
		code: "MF",
		name: "Saint Martin"
	},
	{
		code: "MG",
		name: "Madagascar"
	},
	{
		code: "MH",
		name: "Marshall Islands"
	},
	{
		code: "MK",
		name: "North Macedonia"
	},
	{
		code: "ML",
		name: "Mali"
	},
	{
		code: "MM",
		name: "Myanmar (Burma)"
	},
	{
		code: "MN",
		name: "Mongolia"
	},
	{
		code: "MO",
		name: "Macao"
	},
	{
		code: "MP",
		name: "Northern Mariana Islands"
	},
	{
		code: "MQ",
		name: "Martinique"
	},
	{
		code: "MR",
		name: "Mauritania"
	},
	{
		code: "MS",
		name: "Montserrat"
	},
	{
		code: "MT",
		name: "Malta"
	},
	{
		code: "MU",
		name: "Mauritius"
	},
	{
		code: "MV",
		name: "Maldives"
	},
	{
		code: "MW",
		name: "Malawi"
	},
	{
		code: "MX",
		name: "Mexico"
	},
	{
		code: "MY",
		name: "Malaysia"
	},
	{
		code: "MZ",
		name: "Mozambique"
	},
	{
		code: "NA",
		name: "Namibia"
	},
	{
		code: "NC",
		name: "New Caledonia"
	},
	{
		code: "NE",
		name: "Niger"
	},
	{
		code: "NF",
		name: "Norfolk Island"
	},
	{
		code: "NG",
		name: "Nigeria"
	},
	{
		code: "NI",
		name: "Nicaragua"
	},
	{
		code: "NL",
		name: "Netherlands"
	},
	{
		code: "NO",
		name: "Norway"
	},
	{
		code: "NP",
		name: "Nepal"
	},
	{
		code: "NR",
		name: "Nauru"
	},
	{
		code: "NU",
		name: "Niue"
	},
	{
		code: "NZ",
		name: "New Zealand"
	},
	{
		code: "OM",
		name: "Oman"
	},
	{
		code: "PA",
		name: "Panama"
	},
	{
		code: "PE",
		name: "Peru"
	},
	{
		code: "PF",
		name: "French Polynesia"
	},
	{
		code: "PG",
		name: "Papua New Guinea"
	},
	{
		code: "PH",
		name: "Philippines"
	},
	{
		code: "PK",
		name: "Pakistan"
	},
	{
		code: "PL",
		name: "Poland"
	},
	{
		code: "PM",
		name: "Saint Pierre and Miquelon"
	},
	{
		code: "PN",
		name: "Pitcairn Islands"
	},
	{
		code: "PR",
		name: "Puerto Rico"
	},
	{
		code: "PS",
		name: "Palestine"
	},
	{
		code: "PT",
		name: "Portugal"
	},
	{
		code: "PW",
		name: "Palau"
	},
	{
		code: "PY",
		name: "Paraguay"
	},
	{
		code: "QA",
		name: "Qatar"
	},
	{
		code: "RE",
		name: "Réunion"
	},
	{
		code: "RO",
		name: "Romania"
	},
	{
		code: "RS",
		name: "Serbia"
	},
	{
		code: "RU",
		name: "Russia"
	},
	{
		code: "RW",
		name: "Rwanda"
	},
	{
		code: "SA",
		name: "Saudi Arabia"
	},
	{
		code: "SB",
		name: "Solomon Islands"
	},
	{
		code: "SC",
		name: "Seychelles"
	},
	{
		code: "SD",
		name: "Sudan"
	},
	{
		code: "SE",
		name: "Sweden"
	},
	{
		code: "SG",
		name: "Singapore"
	},
	{
		code: "SH",
		name: "Saint Helena"
	},
	{
		code: "SI",
		name: "Slovenia"
	},
	{
		code: "SJ",
		name: "Svalbard and Jan Mayen"
	},
	{
		code: "SK",
		name: "Slovakia"
	},
	{
		code: "SL",
		name: "Sierra Leone"
	},
	{
		code: "SM",
		name: "San Marino"
	},
	{
		code: "SN",
		name: "Senegal"
	},
	{
		code: "SO",
		name: "Somalia"
	},
	{
		code: "SR",
		name: "Suriname"
	},
	{
		code: "SS",
		name: "South Sudan"
	},
	{
		code: "ST",
		name: "São Tomé and Príncipe"
	},
	{
		code: "SV",
		name: "El Salvador"
	},
	{
		code: "SX",
		name: "Sint Maarten"
	},
	{
		code: "SY",
		name: "Syria"
	},
	{
		code: "SZ",
		name: "Eswatini"
	},
	{
		code: "TC",
		name: "Turks and Caicos Islands"
	},
	{
		code: "TD",
		name: "Chad"
	},
	{
		code: "TF",
		name: "French Southern Territories"
	},
	{
		code: "TG",
		name: "Togo"
	},
	{
		code: "TH",
		name: "Thailand"
	},
	{
		code: "TJ",
		name: "Tajikistan"
	},
	{
		code: "TK",
		name: "Tokelau"
	},
	{
		code: "TL",
		name: "East Timor"
	},
	{
		code: "TM",
		name: "Turkmenistan"
	},
	{
		code: "TN",
		name: "Tunisia"
	},
	{
		code: "TO",
		name: "Tonga"
	},
	{
		code: "TR",
		name: "Turkey"
	},
	{
		code: "TT",
		name: "Trinidad and Tobago"
	},
	{
		code: "TV",
		name: "Tuvalu"
	},
	{
		code: "TW",
		name: "Taiwan"
	},
	{
		code: "TZ",
		name: "Tanzania"
	},
	{
		code: "UA",
		name: "Ukraine"
	},
	{
		code: "UG",
		name: "Uganda"
	},
	{
		code: "UM",
		name: "U.S. Minor Outlying Islands"
	},
	{
		code: "US",
		name: "United States"
	},
	{
		code: "UY",
		name: "Uruguay"
	},
	{
		code: "UZ",
		name: "Uzbekistan"
	},
	{
		code: "VA",
		name: "Vatican City"
	},
	{
		code: "VC",
		name: "Saint Vincent and the Grenadines"
	},
	{
		code: "VE",
		name: "Venezuela"
	},
	{
		code: "VG",
		name: "British Virgin Islands"
	},
	{
		code: "VI",
		name: "U.S. Virgin Islands"
	},
	{
		code: "VN",
		name: "Vietnam"
	},
	{
		code: "VU",
		name: "Vanuatu"
	},
	{
		code: "WF",
		name: "Wallis and Futuna"
	},
	{
		code: "WS",
		name: "Samoa"
	},
	{
		code: "XK",
		name: "Kosovo"
	},
	{
		code: "YE",
		name: "Yemen"
	},
	{
		code: "YT",
		name: "Mayotte"
	},
	{
		code: "ZA",
		name: "South Africa"
	},
	{
		code: "ZM",
		name: "Zambia"
	},
	{
		code: "ZW",
		name: "Zimbabwe"
	}
];

var countries$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': countries$1
});

var optimizedHosts = getCjsExportFromNamespace(optimizedHosts$2);

var countries = getCjsExportFromNamespace(countries$2);

const screenType = {
  mobile: 480,
  tablet: 768,
  mdDesktop: 992,
  lgDesktop: 1200,
  xlDesktop: 1400
};
const PROBE_NO_TIMING_VALUE$4 = 'time out';
const PROBE_STATUS_FAILED$2 = 'failed';
const PROBE_STATUS_OFFLINE$5 = 'offline';
const PROBE_STATUS_DNS_ERROR = 'dns-error';
const PROBE_STATUS_HTTP_ERROR = 'http-error';
const PROBE_STATUS_ERROR_COLOR = '#9b51e0';
const COUNTRIES_MAP$2 = countries.reduce((acc, country) => {
  acc[country.code] = country.name;
  return acc;
}, {});
const COUNTRY_CODE_MAP = countries.reduce((acc, country) => {
  acc[country.name] = country.code;
  return acc;
}, {});
var _ = {
  screenType,
  isTabletScreen() {
    return screen.width > screenType.mobile && screen.width <= screenType.tablet;
  },
  isMobileScreen() {
    return screen.width <= screenType.mobile;
  },
  formatDate(date, format = 'long') {
    if (!date) {
      return '';
    }
    if (typeof date === 'string') {
      date = new Date(date);
    }
    if (format === 'short') {
      return date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short'
      });
    }
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  },
  formatDateTime(date) {
    if (!date) {
      return '';
    }
    if (typeof date === 'string') {
      date = new Date(date);
    }
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    });
  },
  formatNumber(number) {
    return Math.floor(number).toString().replace(/\d(?=(?:\d{3})+$)/g, '$& ');
  },
  makeHTTPRequest(obj) {
    let {
      method = 'GET',
      rawResponse = false,
      body,
      url,
      headers,
      responseHeadersToGet = null,
      withCredentials = false
    } = obj;
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open(method || 'GET', method === 'GET' && body ? url + this.createQueryString(body) : url);
      if (method === 'POST') {
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
      }
      if (headers) {
        Object.keys(headers).forEach(key => xhr.setRequestHeader(key, headers[key]));
      }
      if (withCredentials) {
        xhr.withCredentials = true;
      }
      xhr.onerror = xhr.onload = () => {
        let response = xhr.response;
        if (!rawResponse) {
          try {
            response = JSON.parse(response);
          } catch (e) {
            console.error(e);
          }
        }
        let responseHeaders = responseHeadersToGet ? responseHeadersToGet.reduce((headerValuePairs, headerName) => {
          headerValuePairs[headerName] = xhr.getResponseHeader(headerName);
          return headerValuePairs;
        }, {}) : null;
        if (xhr.status >= 200 && xhr.status < 300) {
          let resolveData;
          if (responseHeaders && Object.keys(responseHeaders).length) {
            resolveData = {
              response,
              responseHeaders
            };
          } else {
            resolveData = response;
          }
          resolve(resolveData);
        } else {
          let rejectData = {
            ...response,
            responseStatusCode: xhr.status
          };
          if (responseHeaders && Object.keys(responseHeaders).length) {
            rejectData = {
              ...rejectData,
              responseHeaders
            };
          }
          reject(rejectData);
        }
      };
      if (method === 'GET') {
        xhr.send();
      } else if (method === 'POST') {
        xhr.send(JSON.stringify(body));
      }
    });
  },
  createQueryString(params) {
    let keys = Object.keys(params);
    if (!keys.length) {
      return '';
    }
    return '?' + keys.filter(key => params[key]).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
  },
  deepExtend(out = {}, ...rest) {
    for (let i = 0; i < rest.length; i++) {
      let obj = rest[i];
      if (!obj) {
        continue;
      }
      for (let key in obj) {
        if (Object.hasOwn(obj, key)) {
          if (typeof obj[key] === 'object' && obj[key] !== null) {
            if (obj[key] instanceof Array) {
              out[key] = obj[key].slice(0);
            } else {
              out[key] = this.deepExtend(out[key], obj[key]);
            }
          } else {
            out[key] = obj[key];
          }
        }
      }
    }
    return out;
  },
  onDocumentReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  },
  optimizeSrc(url, github) {
    let {
      newHost,
      hosts
    } = optimizedHosts;
    let base = github ? `https://cdn.jsdelivr.net/gh/${github.user}/${github.project}@${github.head}/` : typeof location !== 'undefined' ? location.href : undefined;
    let parsed = new URL(url.replace(/^\/+/, ''), base);
    if (hosts.includes(parsed.hostname)) {
      parsed.pathname = parsed.hostname + parsed.pathname;
      parsed.hostname = newHost;
    }
    return parsed.toString();
  },
  normalizeHref(url, idPrefix) {
    try {
      let parsed = new URL(url.replace(/^\/+/, ''), location.href);
      if (parsed.origin === location.origin && parsed.pathname === location.pathname) {
        if (parsed.hash) {
          parsed.hash = `#${idPrefix}${parsed.hash.substr(1)}`;
        }
      }
      return parsed.toString();
    } catch {
      return url;
    }
  },
  isExternalLink(url) {
    try {
      let parsed = new URL(url.replace(/^\/+/, ''), location.href);
      return parsed.hostname !== location.hostname;
    } catch {
      return false;
    }
  },
  getGpProbeLastTiming(testType, result) {
    let lastTiming;
    let {
      timings = []
    } = result;
    if (testType === 'ping') {
      lastTiming = timings[timings.length - 1] ? timings[timings.length - 1].rtt : PROBE_NO_TIMING_VALUE$4;
    }
    return lastTiming;
  },
  getGpTargetTiming(targetData) {
    if (!targetData) {
      return null;
    }
    let {
      avgTiming,
      isFailed,
      isOffline,
      areTimingsReady
    } = targetData;
    if (isFailed) {
      return PROBE_STATUS_FAILED$2;
    } else if (isOffline) {
      return PROBE_STATUS_OFFLINE$5;
    } else if (typeof avgTiming === 'number') {
      return `${Math.round(avgTiming)} ms`;
    } else if (areTimingsReady) {
      return avgTiming;
    }
    return null;
  },
  calcGpTestResTiming(testType, testResData, dnsTraceEnabled = false, units = ' ms') {
    let resTiming;
    let lastTiming;
    let extraValues = {};
    let lowCaseTestName = testType.toLowerCase();
    lastTiming = this.getGpProbeLastTiming(testType, testResData.result);
    if (testResData.result?.status === PROBE_STATUS_FAILED$2) {
      return {
        value: PROBE_STATUS_FAILED$2,
        extraValues,
        fullText: PROBE_STATUS_FAILED$2,
        isFailed: true
      };
    } else if (testResData.result?.status === PROBE_STATUS_OFFLINE$5) {
      return {
        value: PROBE_STATUS_OFFLINE$5,
        extraValues,
        fullText: PROBE_STATUS_OFFLINE$5,
        isFailed: false
      };
    }
    if (lowCaseTestName === 'ping') {
      resTiming = testResData.result?.stats?.avg;
      if (typeof testResData.result?.stats?.loss === 'number') {
        extraValues.loss = {
          text: 'Loss',
          value: testResData.result?.stats?.loss,
          units: '%'
        };
      }
    } else if (lowCaseTestName === 'traceroute') {
      let {
        timings
      } = testResData.result.hops ? testResData.result.hops[testResData.result.hops.length - 1] : {};
      extraValues.hops = {
        text: 'Hops',
        value: testResData.result.hops?.length ?? 0,
        units: ''
      };
      if (timings && timings.length) {
        let timingsCalc = timings.reduce((res, timing) => {
          if (typeof timing.rtt === 'number') {
            return {
              sum: res.sum + Number(timing.rtt),
              cnt: res.cnt + 1
            };
          }
          return res;
        }, {
          sum: 0,
          cnt: 0
        });
        if (timingsCalc.cnt) {
          resTiming = Number((timingsCalc.sum / timingsCalc.cnt).toFixed(3));
        }
      }
    } else if (lowCaseTestName === 'dns') {
      let dnsResult = testResData.result;
      if (dnsTraceEnabled) {
        let lastHop = testResData.result.hops ? testResData.result.hops[testResData.result.hops.length - 1] : {};
        if (lastHop) {
          resTiming = lastHop.timings.total;
          dnsResult = lastHop;
        }
      } else {
        resTiming = testResData.result.timings.total;
      }
      let answersCount = dnsResult.answers?.length ?? 0;
      let dnsStatus = dnsResult.statusCodeName ?? dnsResult.statusCode;
      extraValues.answers = {
        text: 'Answers',
        value: answersCount,
        units: ''
      };
      if (dnsStatus !== null && typeof dnsStatus !== 'undefined') {
        extraValues.dnsStatus = {
          text: dnsResult.statusCodeName ? '' : 'Status',
          value: dnsStatus,
          units: ''
        };
      }
      if (typeof dnsStatus !== 'undefined' && dnsStatus !== 'NOERROR' || answersCount === 0) {
        extraValues.errorStatus = PROBE_STATUS_DNS_ERROR;
      }
    } else if (lowCaseTestName === 'mtr') {
      let lastHop = testResData.result.hops ? testResData.result.hops[testResData.result.hops.length - 1] : {};
      extraValues.hops = {
        text: 'Hops',
        value: testResData.result.hops?.length ?? 0,
        units: ''
      };
      if (lastHop) {
        resTiming = lastHop.stats.avg;
      }
    } else if (lowCaseTestName === 'http') {
      if (typeof testResData.result.statusCode === 'number') {
        resTiming = testResData.result?.timings?.total;
        extraValues.httpStatus = {
          text: 'HTTP',
          value: testResData.result.statusCode,
          units: ''
        };
        if (testResData.result.statusCode >= 400) {
          extraValues.errorStatus = PROBE_STATUS_HTTP_ERROR;
        }
        if (typeof testResData.result?.timings?.dns === 'number') {
          extraValues.dns = {
            text: 'DNS',
            value: testResData.result.timings.dns,
            units: ' ms'
          };
        }
        if (typeof testResData.result?.timings?.tcp === 'number') {
          extraValues.tcp = {
            text: 'TCP',
            value: testResData.result.timings.tcp,
            units: ' ms'
          };
        }
        if (typeof testResData.result?.timings?.tls === 'number') {
          extraValues.tls = {
            text: 'TLS',
            value: testResData.result.timings.tls,
            units: ' ms'
          };
        }
        if (typeof testResData.result?.timings?.firstByte === 'number') {
          extraValues.firstByte = {
            text: 'TTFB',
            value: testResData.result.timings.firstByte,
            units: ' ms'
          };
        }
        if (typeof testResData.result?.timings?.download === 'number') {
          extraValues.download = {
            text: 'Download',
            value: testResData.result.timings.download,
            units: ' ms'
          };
        }
      }
    }
    if (typeof resTiming === 'number') {
      let note = '';
      switch (lowCaseTestName) {
        case 'traceroute':
        case 'mtr':
          note = '(average)';
          break;
        case 'dns':
        case 'http':
          note = '(total)';
          break;
      }
      return {
        value: resTiming,
        extraValues,
        units,
        note,
        fullText: note ? `${Math.round(resTiming)}${units} ${note}` : `${Math.round(resTiming)}${units}`,
        lastTiming
      };
    }
    return {
      value: PROBE_NO_TIMING_VALUE$4,
      extraValues,
      fullText: PROBE_NO_TIMING_VALUE$4,
      isFailed: testResData.result?.status === PROBE_STATUS_FAILED$2,
      lastTiming: PROBE_NO_TIMING_VALUE$4
    };
  },
  getProbeTimeOutValue() {
    return PROBE_NO_TIMING_VALUE$4;
  },
  getProbeStatusFailedValue() {
    return PROBE_STATUS_FAILED$2;
  },
  getProbeStatusOfflineValue() {
    return PROBE_STATUS_OFFLINE$5;
  },
  getProbeStatusDnsErrorValue() {
    return PROBE_STATUS_DNS_ERROR;
  },
  getProbeStatusHttpErrorValue() {
    return PROBE_STATUS_HTTP_ERROR;
  },
  capitalizeFirstLetter(word) {
    return word ? word[0].toUpperCase() + word.slice(1) : '';
  },
  capitalizeStrEveryFirstLetter(string, exclude = []) {
    return string.split(' ').reduce((res, w) => {
      if (exclude.includes(w)) {
        res.push(w);
      } else {
        res.push(this.capitalizeFirstLetter(w));
      }
      return res;
    }, []).join(' ');
  },
  removeDuplicatedTargets(arr) {
    return arr.reduce((uniquesArr, item) => {
      if (uniquesArr.indexOf(item) < 0) {
        uniquesArr.push(item);
      }
      return uniquesArr;
    }, []);
  },
  parseGpRawOutputForTimings(raw) {
    let packets = [];
    let timeMatch, noAnswerMatch;
    let timeRegex = /(?:icmp_seq|tcp_conn)=(\d+).*time=(\d+(\.\d+)?)/;
    let noAnswerRegex = /(?:no answer yet for|No reply from)*(?:icmp_seq|tcp_conn)=(\d+)/;
    let lines = raw.split('\n').filter(l => l);
    for (let i = 0; i < lines.length; i++) {
      if (i === 0) {
        continue;
      }
      if (lines[i].includes('---')) {
        break;
      }
      timeMatch = timeRegex.exec(lines[i]);
      noAnswerMatch = noAnswerRegex.exec(lines[i]);
      if (timeMatch) {
        packets[timeMatch[1] - 1] = parseFloat(timeMatch[2]);
      } else if (noAnswerMatch) {
        if (!packets[noAnswerMatch[1] - 1]) {
          packets[noAnswerMatch[1] - 1] = PROBE_NO_TIMING_VALUE$4;
        }
      } else ;
    }
    return {
      packetsRtt: packets,
      packetsDrop: packets.filter(p => p === PROBE_NO_TIMING_VALUE$4).length,
      packetsTotal: packets.length
    };
  },
  memoize(func) {
    let cache = new Map();
    return function (...args) {
      let key = JSON.stringify(args);
      if (!cache.has(key)) {
        cache.set(key, func.apply(this, args));
      }
      return cache.get(key);
    };
  },
  getGpProbeStatusColor(timing, probesMaxTiming = 200, probesMinTiming = 5) {
    // return default GREY color while probe has no timing yet
    if (typeof timing === 'undefined' || timing === null) {
      return '#c0c0c0';
    }

    // return default color for timed out probe
    if (timing === PROBE_NO_TIMING_VALUE$4 || timing === PROBE_STATUS_FAILED$2 || timing === PROBE_STATUS_OFFLINE$5) {
      return '#17233A';
    }
    if (timing === PROBE_STATUS_DNS_ERROR || timing === PROBE_STATUS_HTTP_ERROR) {
      return PROBE_STATUS_ERROR_COLOR;
    }
    function getColorFromGradient(quotient, start, middle, end) {
      return quotient >= 0.5 ? linear(middle, end, (quotient - 0.5) * 2) : linear(start, middle, quotient * 2);
    }
    function linear(startColor, endColor, quotient) {
      let redColor = byteLinear(startColor[1] + startColor[2], endColor[1] + endColor[2], quotient);
      let greenColor = byteLinear(startColor[3] + startColor[4], endColor[3] + endColor[4], quotient);
      let blueColor = byteLinear(startColor[5] + startColor[6], endColor[5] + endColor[6], quotient);
      return `#${redColor}${greenColor}${blueColor}`;
    }
    function byteLinear(partOne, partTwo, quotient) {
      let color = Math.floor(('0x' + partOne) * (1 - quotient) + ('0x' + partTwo) * quotient);
      return color.toString(16).padStart(2, '0');
    }
    let pureTimingValue = parseInt(timing);

    // '#17d4a7', '#ffb800', '#e64e3d' - colors are used for timings scale on the map
    if (pureTimingValue <= probesMinTiming) {
      return '#17d4a7';
    }
    if (pureTimingValue >= probesMaxTiming) {
      return '#e64e3d';
    }
    return getColorFromGradient(pureTimingValue / probesMaxTiming, '#17d4a7', '#ffb800', '#e64e3d');
  },
  pluralize(singular, countOrPlural, countOrUndefined) {
    let count = typeof countOrPlural === 'string' ? countOrUndefined : countOrPlural;
    let plural = typeof countOrPlural === 'string' ? countOrPlural : singular + 's';
    return count === 1 ? singular : plural;
  },
  createMeasCreditsErrMsg(responseHeaders, hasToken = false, isInfinite = false, hasResults = false, isSecondTarget = false, primaryTarget = '') {
    // do not show err msg if we get a 429 and have results for infinite measurement
    if (hasResults && isInfinite) {
      return null;
    }
    if (hasResults && isSecondTarget && primaryTarget) {
      return `Not enough credits to test both targets, showing results for ${primaryTarget} only. You can get higher limits by creating an account.`;
    }
    let minutes = responseHeaders['x-ratelimit-reset'] / 60;
    let timeToReset = minutes < 1 ? '< 1 minute' : `${Math.ceil(minutes)} minutes`;
    let remainingCredits = Number(responseHeaders['x-ratelimit-remaining'] || 0) + Number(responseHeaders['x-credits-remaining'] || 0);
    let requiredCredits = Number(responseHeaders['x-request-cost'] || 0);
    if (isInfinite === false && remainingCredits) {
      let msg = `<span>You only have ${remainingCredits} credits remaining, and ${requiredCredits} were required.</span>`;
      msg += `<span>Try requesting fewer probes or wait ${timeToReset} for the limit to reset.</span>`;
      if (hasToken) {
        msg += '<span>You can get higher limits by sponsoring us or hosting probes</span>';
      } else {
        msg += '<span>You can get higher limits by creating an account. <a href="https://dash.globalping.io">Sign up</a><span>';
      }
      return msg;
    } else if (isInfinite && !hasResults || !remainingCredits) {
      let msg = `<span>You have run out of credits for this session.</span>`;
      msg += `<span>You can wait ${timeToReset} for the limit to reset or get higher limits by`;
      if (hasToken) {
        msg += ` sponsoring us or hosting probes.</span>`;
      } else {
        msg += ` creating an account. <a href='https://dash.globalping.io'>Sign up</a></span>`;
      }
      return msg;
    }
    return 'All tests failed. Maybe you specified a non-existing endpoint?';
  },
  parseValidationErrors(errorBody, target = '') {
    let prefix = target ? `${target}: ` : '';
    return Object.keys(errorBody.params || {}).reduce((res, key) => {
      let fieldName = key.split('.')[key.split('.').length - 1];
      if (['locations', 'magic'].includes(fieldName)) {
        fieldName = 'location';
      }
      res[fieldName] = `${prefix}${this.capitalizeFirstLetter(errorBody.params[key].replace(/".*"/, fieldName))}`;
      return res;
    }, {});
  },
  sortGpMeasurementResults(results, by, order, targetIdx) {
    let sortCoeff = order === 'desc' ? -1 : 1;
    let sortToFieldMap = {
      'avg': 'avgTiming',
      'max': 'maxTiming',
      'min': 'minTiming',
      'rtt-last': 'lastTiming'
    };
    let getLocationStr = loc => {
      return `${loc.city}${loc.country}${loc.continent}${loc.network}`;
    };
    let getFieldVal = (loc, field) => {
      let value = loc.statsPerTarget[targetIdx][field];
      if (typeof value !== 'number' || Number.isNaN(value)) {
        return Infinity;
      }
      return value;
    };
    switch (by) {
      case 'location':
        {
          return results.toSorted((a, b) => sortCoeff * getLocationStr(a).localeCompare(getLocationStr(b)));
        }
      case 'quality':
        {
          return results.toSorted((a, b) => {
            let totalLhs = getFieldVal(a, 'statsTotal');
            let totalRhs = getFieldVal(b, 'statsTotal');
            if (totalLhs === 0 || totalRhs === 0) {
              return 0;
            }
            return -sortCoeff * (getFieldVal(a, 'statsDrop') / totalLhs - getFieldVal(b, 'statsDrop') / totalRhs);
          });
        }
      default:
        {
          if (!Object.hasOwn(sortToFieldMap, by)) {
            return results;
          }
          return results.toSorted((a, b) => sortCoeff * (getFieldVal(a, sortToFieldMap[by]) - getFieldVal(b, sortToFieldMap[by])));
        }
    }
  },
  isTagCloudRegion(tag) {
    return /^(gcp|aws|azure|oci)-\S+/.test(tag);
  },
  injectGlobalStyle(href) {
    if (typeof document === 'undefined') {
      return;
    }
    for (let link of document.getElementsByTagName('link')) {
      if (link.href === href) {
        return;
      }
    }
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  },
  networkNameToKey(network) {
    return network.replace(/\./g, '').replace(/[\W]|_/g, ' ').replace(/\s\s+|_/g, ' ').trim().split(' ').join('-').toLowerCase();
  },
  clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
  },
  createLocationString(newLocation, locationFilter) {
    let targetLoc;
    let locations = locationFilter.replace(/^world$/i, '').split(',').map(location => location.trim()).filter(Boolean);
    if (!locations.length) {
      targetLoc = newLocation;
    } else {
      targetLoc = locations.reduce((shortestLoc, location) => {
        let filteredParts = location.split(/[+%]/).map(part => part.trim()).filter(part => {
          let countryCode = COUNTRIES_MAP$2[part];
          let countryName = COUNTRY_CODE_MAP[part];
          let isRedundant = newLocation.includes(part) || countryCode && newLocation.includes(countryCode) || countryName && newLocation.includes(countryName);
          return !isRedundant;
        });
        let candidateLoc = [newLocation, ...filteredParts].join('+');
        return !shortestLoc || candidateLoc.length < shortestLoc.length ? candidateLoc : shortestLoc;
      }, '');
    }
    return targetLoc;
  },
  escapeLocationString(location) {
    return location.replace(/[%&<>"']/g, ch => ({
      '%': '+',
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#39;'
    })[ch]);
  },
  numericalFieldWidth(value, minWidth = 1) {
    let optimalWidth = Math.floor(Math.log10(Math.abs(value))) + (value < 0 ? 1 : 0) + 1;
    return Math.max(optimalWidth, minWidth);
  },
  isTouchDevice() {
    return !!window?.matchMedia('(hover: none), (pointer: coarse)')?.matches;
  },
  shouldCollapseResponseBody(body, charsPerLine) {
    if (!body) {
      return false;
    }
    let lines = String(body).split('\n');
    if (lines.length > 3) {
      return true;
    }
    return lines.slice(0, 3).reduce((acc, line) => acc + Math.ceil(line.length / charsPerLine), 0) > 3;
  },
  isEqual(obj1, obj2) {
    if (Object.is(obj1, obj2)) {
      return true;
    }
    if (obj1 === null || obj2 === null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
      return false;
    }
    let isArray1 = Array.isArray(obj1);
    let isArray2 = Array.isArray(obj2);
    if (isArray1 || isArray2) {
      if (!isArray1 || !isArray2 || obj1.length !== obj2.length) {
        return false;
      }
      for (let i = 0; i < obj1.length; i++) {
        if (!this.isEqual(obj1[i], obj2[i])) {
          return false;
        }
      }
      return true;
    }
    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (let key of keys1) {
      if (!Object.hasOwn(obj2, key) || !this.isEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  }
};
_.screenType;
_.isTabletScreen;
_.isMobileScreen;
_.formatDate;
_.formatDateTime;
_.formatNumber;
_.makeHTTPRequest;
_.createQueryString;
_.deepExtend;
_.onDocumentReady;
_.optimizeSrc;
_.normalizeHref;
_.isExternalLink;
_.getGpProbeLastTiming;
_.getGpTargetTiming;
_.calcGpTestResTiming;
_.getProbeTimeOutValue;
_.getProbeStatusFailedValue;
_.getProbeStatusOfflineValue;
_.getProbeStatusDnsErrorValue;
_.getProbeStatusHttpErrorValue;
_.capitalizeFirstLetter;
_.capitalizeStrEveryFirstLetter;
_.removeDuplicatedTargets;
_.parseGpRawOutputForTimings;
_.memoize;
_.getGpProbeStatusColor;
_.pluralize;
_.createMeasCreditsErrMsg;
_.parseValidationErrors;
_.sortGpMeasurementResults;
_.isTagCloudRegion;
_.injectGlobalStyle;
_.networkNameToKey;
_.clamp;
_.createLocationString;
_.escapeLocationString;
_.numericalFieldWidth;
_.isTouchDevice;
_.shouldCollapseResponseBody;
_.isEqual;

var has$6 = {
  localStorage() {
    try {
      localStorage.setItem('localStorageTest', 1);
      localStorage.removeItem('localStorageTest');
    } catch {
      return false;
    }
    return true;
  },
  sessionStorage() {
    try {
      sessionStorage.setItem('sessionStorageTest', 1);
      sessionStorage.removeItem('sessionStorageTest');
    } catch {
      return false;
    }
    return true;
  }
};

var getCache$1 = (key, ttl, getDefaultValue, revalidate = false, onRevalidate = undefined) => {
  if (!has$6.sessionStorage()) {
    return getDefaultValue().then(value => {
      sessionStorage.setItem(key, JSON.stringify({
        data: value,
        ttl: Date.now() + ttl
      }));
      return value;
    });
  }
  let value;
  try {
    value = JSON.parse(sessionStorage.getItem(key) || '{}');
  } catch {}
  if (value && value.ttl && value.ttl > Date.now()) {
    revalidate && getDefaultValue().then(value => {
      sessionStorage.setItem(key, JSON.stringify({
        data: value,
        ttl: Date.now() + ttl
      }));
      onRevalidate && onRevalidate(value);
    });
    return Promise.resolve(value.data);
  }
  return getDefaultValue().then(value => {
    sessionStorage.setItem(key, JSON.stringify({
      data: value,
      ttl: Date.now() + ttl
    }));
    return value;
  });
};
var dataCache = {
  getCache: getCache$1
};

const {
  getCache
} = dataCache;
const API_HOST = 'https://api.globalping.io';
const DASH_HOST = 'https://dash-directus.globalping.io';
var fetchGlobalpingProbes = () => {
  return _.makeHTTPRequest({
    url: `${API_HOST}/v1/probes`
  });
};
var postGlobalpingMeasurement = (opts, responseHeadersToGet) => {
  let params = {
    method: 'POST',
    url: `${API_HOST}/v1/measurements`,
    body: opts,
    withCredentials: /(?:^|\.)globalping\.io$/.test(location.hostname)
  };
  if (responseHeadersToGet) {
    params = {
      ...params,
      responseHeadersToGet
    };
  }
  return _.makeHTTPRequest(params);
};
var getGlobalpingMeasurement = id => {
  return _.makeHTTPRequest({
    url: `${API_HOST}/v1/measurements/${id}`
  });
};
var getGPBlogRss = () => {
  return _.makeHTTPRequest({
    url: `https://blog.globalping.io/rss/`,
    rawResponse: true
  });
};
var getGlobalpingUser$1 = onRevalidate => {
  // Note: The authentication won't work out of the box on localhost because the cookie is set with SameSite=Strict
  // If you need to test the page as an authenticated user (and don't want to set up a local dash and API),
  // just set the production cookie "dash_session_token" (.globalping.io) to SameSite=None via devtools.
  return getCache('gp-user', 1000 * 60 * 60 * 24, () => _.makeHTTPRequest({
    url: `${DASH_HOST}/users/me`,
    withCredentials: true
  }).then(body => body.data).catch(() => null), true, onRevalidate);
};
var getSponsorshipDetails = userId => {
  return _.makeHTTPRequest({
    url: `${DASH_HOST}/sponsorship-details`,
    withCredentials: true,
    body: {
      userId
    }
  });
};
var gpLogOut = () => {
  return _.makeHTTPRequest({
    method: 'POST',
    url: `${DASH_HOST}/auth/logout`,
    body: {
      mode: 'session'
    },
    withCredentials: true,
    rawResponse: true
  }).then(() => {
    window.sessionStorage.setItem('gp-user', JSON.stringify({
      data: null,
      ttl: Date.now() + 1000 * 60 * 60 * 24
    }));
  });
};
var getDomainFromASN = asn => {
  return _.makeHTTPRequest({
    url: `/asn-to-domain/${asn}`
  });
};
var getNetworkFromIP = ip => {
  return _.makeHTTPRequest({
    url: `/ip-to-network/${encodeURIComponent(ip)}`
  });
};
var getNetworkDomainMap = () => {
  return _.makeHTTPRequest({
    url: `/network-to-domain`
  });
};
var http = {
  fetchGlobalpingProbes: fetchGlobalpingProbes,
  postGlobalpingMeasurement: postGlobalpingMeasurement,
  getGlobalpingMeasurement: getGlobalpingMeasurement,
  getGPBlogRss: getGPBlogRss,
  getGlobalpingUser: getGlobalpingUser$1,
  getSponsorshipDetails: getSponsorshipDetails,
  gpLogOut: gpLogOut,
  getDomainFromASN: getDomainFromASN,
  getNetworkFromIP: getNetworkFromIP,
  getNetworkDomainMap: getNetworkDomainMap
};

// eslint-disable-next-line es/no-set -- safe
var SetPrototype$1 = Set.prototype;
var setHelpers = {
  // eslint-disable-next-line es/no-set -- safe
  Set: Set,
  add: functionUncurryThis(SetPrototype$1.add),
  has: functionUncurryThis(SetPrototype$1.has),
  remove: functionUncurryThis(SetPrototype$1['delete']),
  proto: SetPrototype$1
};

var has$5 = setHelpers.has;

// Perform ? RequireInternalSlot(M, [[SetData]])
var aSet = function (it) {
  has$5(it);
  return it;
};

var iterateSimple = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
  var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
  var next = record.next;
  var step, result;
  while (!(step = functionCall(next, iterator)).done) {
    result = fn(step.value);
    if (result !== undefined) return result;
  }
};

var Set$3 = setHelpers.Set;
var SetPrototype = setHelpers.proto;
var forEach = functionUncurryThis(SetPrototype.forEach);
var keys = functionUncurryThis(SetPrototype.keys);
var next = keys(new Set$3()).next;
var setIterate = function (set, fn, interruptible) {
  return interruptible ? iterateSimple({
    iterator: keys(set),
    next: next
  }, fn) : forEach(set, fn);
};

var Set$2 = setHelpers.Set;
var add$3 = setHelpers.add;
var setClone = function (set) {
  var result = new Set$2();
  setIterate(set, function (it) {
    add$3(result, it);
  });
  return result;
};

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return functionUncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) {/* empty */}
};

var setSize = functionUncurryThisAccessor(setHelpers.proto, 'size', 'get') || function (set) {
  return set.size;
};

var INVALID_SIZE = 'Invalid size';
var $RangeError$2 = RangeError;
var $TypeError$1 = TypeError;
var max = Math.max;
var SetRecord = function (set, intSize) {
  this.set = set;
  this.size = max(intSize, 0);
  this.has = aCallable(set.has);
  this.keys = aCallable(set.keys);
};
SetRecord.prototype = {
  getIterator: function () {
    return getIteratorDirect(anObject(functionCall(this.keys, this.set)));
  },
  includes: function (it) {
    return functionCall(this.has, this.set, it);
  }
};

// `GetSetRecord` abstract operation
// https://tc39.es/proposal-set-methods/#sec-getsetrecord
var getSetRecord = function (obj) {
  anObject(obj);
  var numSize = +obj.size;
  // NOTE: If size is undefined, then numSize will be NaN
  // eslint-disable-next-line no-self-compare -- NaN check
  if (numSize !== numSize) throw new $TypeError$1(INVALID_SIZE);
  var intSize = toIntegerOrInfinity(numSize);
  if (intSize < 0) throw new $RangeError$2(INVALID_SIZE);
  return new SetRecord(obj, intSize);
};

var has$4 = setHelpers.has;
var remove$1 = setHelpers.remove;

// `Set.prototype.difference` method
// https://tc39.es/ecma262/#sec-set.prototype.difference
var setDifference = function difference(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  var result = setClone(O);
  if (setSize(O) <= otherRec.size) setIterate(O, function (e) {
    if (otherRec.includes(e)) remove$1(result, e);
  });else iterateSimple(otherRec.getIterator(), function (e) {
    if (has$4(result, e)) remove$1(result, e);
  });
  return result;
};

var createSetLike = function (size) {
  return {
    size: size,
    has: function () {
      return false;
    },
    keys: function () {
      return {
        next: function () {
          return {
            done: true
          };
        }
      };
    }
  };
};
var createSetLikeWithInfinitySize = function (size) {
  return {
    size: size,
    has: function () {
      return true;
    },
    keys: function () {
      throw new Error('e');
    }
  };
};
var setMethodAcceptSetLike = function (name, callback) {
  var Set = getBuiltIn('Set');
  try {
    new Set()[name](createSetLike(0));
    try {
      // late spec change, early WebKit ~ Safari 17 implementation does not pass it
      // https://github.com/tc39/proposal-set-methods/pull/88
      // also covered engines with
      // https://bugs.webkit.org/show_bug.cgi?id=272679
      new Set()[name](createSetLike(-1));
      return false;
    } catch (error2) {
      if (!callback) return true;
      // early V8 implementation bug
      // https://issues.chromium.org/issues/351332634
      try {
        new Set()[name](createSetLikeWithInfinitySize(-Infinity));
        return false;
      } catch (error) {
        var set = new Set([1, 2]);
        return callback(set[name](createSetLikeWithInfinitySize(Infinity)));
      }
    }
  } catch (error) {
    return false;
  }
};

var SET_LIKE_INCORRECT_BEHAVIOR = !setMethodAcceptSetLike('difference', function (result) {
  return result.size === 0;
});
var FORCED$4 = SET_LIKE_INCORRECT_BEHAVIOR || fails(function () {
  // https://bugs.webkit.org/show_bug.cgi?id=288595
  var setLike = {
    size: 1,
    has: function () {
      return true;
    },
    keys: function () {
      var index = 0;
      return {
        next: function () {
          var done = index++ > 1;
          if (baseSet.has(1)) baseSet.clear();
          return {
            done: done,
            value: 2
          };
        }
      };
    }
  };
  // eslint-disable-next-line es/no-set -- testing
  var baseSet = new Set([1, 2, 3, 4]);
  // eslint-disable-next-line es/no-set-prototype-difference -- testing
  return baseSet.difference(setLike).size !== 3;
});

// `Set.prototype.difference` method
// https://tc39.es/ecma262/#sec-set.prototype.difference
_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: FORCED$4
}, {
  difference: setDifference
});

var Set$1 = setHelpers.Set;
var add$2 = setHelpers.add;
var has$3 = setHelpers.has;

// `Set.prototype.intersection` method
// https://tc39.es/ecma262/#sec-set.prototype.intersection
var setIntersection = function intersection(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  var result = new Set$1();
  if (setSize(O) > otherRec.size) {
    iterateSimple(otherRec.getIterator(), function (e) {
      if (has$3(O, e)) add$2(result, e);
    });
  } else {
    setIterate(O, function (e) {
      if (otherRec.includes(e)) add$2(result, e);
    });
  }
  return result;
};

var INCORRECT$3 = !setMethodAcceptSetLike('intersection', function (result) {
  return result.size === 2 && result.has(1) && result.has(2);
}) || fails(function () {
  // eslint-disable-next-line es/no-array-from, es/no-set, es/no-set-prototype-intersection -- testing
  return String(Array.from(new Set([1, 2, 3]).intersection(new Set([3, 2])))) !== '3,2';
});

// `Set.prototype.intersection` method
// https://tc39.es/ecma262/#sec-set.prototype.intersection
_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: INCORRECT$3
}, {
  intersection: setIntersection
});

var has$2 = setHelpers.has;

// `Set.prototype.isDisjointFrom` method
// https://tc39.es/ecma262/#sec-set.prototype.isdisjointfrom
var setIsDisjointFrom = function isDisjointFrom(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  if (setSize(O) <= otherRec.size) return setIterate(O, function (e) {
    if (otherRec.includes(e)) return false;
  }, true) !== false;
  var iterator = otherRec.getIterator();
  return iterateSimple(iterator, function (e) {
    if (has$2(O, e)) return iteratorClose(iterator, 'normal', false);
  }) !== false;
};

var INCORRECT$2 = !setMethodAcceptSetLike('isDisjointFrom', function (result) {
  return !result;
});

// `Set.prototype.isDisjointFrom` method
// https://tc39.es/ecma262/#sec-set.prototype.isdisjointfrom
_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: INCORRECT$2
}, {
  isDisjointFrom: setIsDisjointFrom
});

// `Set.prototype.isSubsetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issubsetof
var setIsSubsetOf = function isSubsetOf(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  if (setSize(O) > otherRec.size) return false;
  return setIterate(O, function (e) {
    if (!otherRec.includes(e)) return false;
  }, true) !== false;
};

var INCORRECT$1 = !setMethodAcceptSetLike('isSubsetOf', function (result) {
  return result;
});

// `Set.prototype.isSubsetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issubsetof
_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: INCORRECT$1
}, {
  isSubsetOf: setIsSubsetOf
});

var has$1 = setHelpers.has;

// `Set.prototype.isSupersetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issupersetof
var setIsSupersetOf = function isSupersetOf(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  if (setSize(O) < otherRec.size) return false;
  var iterator = otherRec.getIterator();
  return iterateSimple(iterator, function (e) {
    if (!has$1(O, e)) return iteratorClose(iterator, 'normal', false);
  }) !== false;
};

var INCORRECT = !setMethodAcceptSetLike('isSupersetOf', function (result) {
  return !result;
});

// `Set.prototype.isSupersetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issupersetof
_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: INCORRECT
}, {
  isSupersetOf: setIsSupersetOf
});

var add$1 = setHelpers.add;
var has = setHelpers.has;
var remove = setHelpers.remove;

// `Set.prototype.symmetricDifference` method
// https://tc39.es/ecma262/#sec-set.prototype.symmetricdifference
var setSymmetricDifference = function symmetricDifference(other) {
  var O = aSet(this);
  var keysIter = getSetRecord(other).getIterator();
  var result = setClone(O);
  iterateSimple(keysIter, function (e) {
    if (has(O, e)) remove(result, e);else add$1(result, e);
  });
  return result;
};

// Should get iterator record of a set-like object before cloning this
// https://bugs.webkit.org/show_bug.cgi?id=289430
var setMethodGetKeysBeforeCloningDetection = function (METHOD_NAME) {
  try {
    // eslint-disable-next-line es/no-set -- needed for test
    var baseSet = new Set();
    var setLike = {
      size: 0,
      has: function () {
        return true;
      },
      keys: function () {
        // eslint-disable-next-line es/no-object-defineproperty -- needed for test
        return Object.defineProperty({}, 'next', {
          get: function () {
            baseSet.clear();
            baseSet.add(4);
            return function () {
              return {
                done: true
              };
            };
          }
        });
      }
    };
    var result = baseSet[METHOD_NAME](setLike);
    return result.size === 1 && result.values().next().value === 4;
  } catch (error) {
    return false;
  }
};

var FORCED$3 = !setMethodAcceptSetLike('symmetricDifference') || !setMethodGetKeysBeforeCloningDetection('symmetricDifference');

// `Set.prototype.symmetricDifference` method
// https://tc39.es/ecma262/#sec-set.prototype.symmetricdifference
_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: FORCED$3
}, {
  symmetricDifference: setSymmetricDifference
});

var add = setHelpers.add;

// `Set.prototype.union` method
// https://tc39.es/ecma262/#sec-set.prototype.union
var setUnion = function union(other) {
  var O = aSet(this);
  var keysIter = getSetRecord(other).getIterator();
  var result = setClone(O);
  iterateSimple(keysIter, function (it) {
    add(result, it);
  });
  return result;
};

var FORCED$2 = !setMethodAcceptSetLike('union') || !setMethodGetKeysBeforeCloningDetection('union');

// `Set.prototype.union` method
// https://tc39.es/ecma262/#sec-set.prototype.union
_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: FORCED$2
}, {
  union: setUnion
});

var $RangeError$1 = RangeError;
var notANan = function (it) {
  // eslint-disable-next-line no-self-compare -- NaN check
  if (it === it) return it;
  throw new $RangeError$1('NaN is not allowed');
};

var $RangeError = RangeError;
var toPositiveInteger = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw new $RangeError("The argument can't be less than 0");
  return result;
};

var DROP_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('drop', 0);
var dropWithoutClosingOnEarlyError = !DROP_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError('drop', RangeError);
var FORCED$1 = DROP_WITHOUT_THROWING_ON_INVALID_ITERATOR || dropWithoutClosingOnEarlyError;
var IteratorProxy$1 = iteratorCreateProxy(function () {
  var iterator = this.iterator;
  var next = this.next;
  var result, done;
  while (this.remaining) {
    this.remaining--;
    result = anObject(functionCall(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
  }
  result = anObject(functionCall(next, iterator));
  done = this.done = !!result.done;
  if (!done) return result.value;
});

// `Iterator.prototype.drop` method
// https://tc39.es/ecma262/#sec-iterator.prototype.drop
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: FORCED$1
}, {
  drop: function drop(limit) {
    anObject(this);
    var remaining;
    try {
      remaining = toPositiveInteger(notANan(+limit));
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (dropWithoutClosingOnEarlyError) return functionCall(dropWithoutClosingOnEarlyError, this, remaining);
    return new IteratorProxy$1(getIteratorDirect(this), {
      remaining: remaining
    });
  }
});

var everyWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('every', TypeError);

// `Iterator.prototype.every` method
// https://tc39.es/ecma262/#sec-iterator.prototype.every
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: everyWithoutClosingOnEarlyError
}, {
  every: function every(predicate) {
    anObject(this);
    try {
      aCallable(predicate);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (everyWithoutClosingOnEarlyError) return functionCall(everyWithoutClosingOnEarlyError, this, predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return !iterate(record, function (value, stop) {
      if (!predicate(value, counter++)) return stop();
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).stopped;
  }
});

var findWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('find', TypeError);

// `Iterator.prototype.find` method
// https://tc39.es/ecma262/#sec-iterator.prototype.find
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: findWithoutClosingOnEarlyError
}, {
  find: function find(predicate) {
    anObject(this);
    try {
      aCallable(predicate);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (findWithoutClosingOnEarlyError) return functionCall(findWithoutClosingOnEarlyError, this, predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return iterate(record, function (value, stop) {
      if (predicate(value, counter++)) return stop(value);
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).result;
  }
});

var someWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('some', TypeError);

// `Iterator.prototype.some` method
// https://tc39.es/ecma262/#sec-iterator.prototype.some
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: someWithoutClosingOnEarlyError
}, {
  some: function some(predicate) {
    anObject(this);
    try {
      aCallable(predicate);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (someWithoutClosingOnEarlyError) return functionCall(someWithoutClosingOnEarlyError, this, predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return iterate(record, function (value, stop) {
      if (predicate(value, counter++)) return stop();
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).stopped;
  }
});

var isPossiblePrototype = function (argument) {
  return isObject(argument) || argument === null;
};

var $String = String;
var $TypeError = TypeError;
var aPossiblePrototype = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = functionUncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {/* empty */}
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined);

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
  // it can work only with native `setPrototypeOf`
  objectSetPrototypeOf &&
  // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
  isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var normalizeStringArgument = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString_1(argument);
};

var domExceptionConstants = {
  IndexSizeError: {
    s: 'INDEX_SIZE_ERR',
    c: 1,
    m: 1
  },
  DOMStringSizeError: {
    s: 'DOMSTRING_SIZE_ERR',
    c: 2,
    m: 0
  },
  HierarchyRequestError: {
    s: 'HIERARCHY_REQUEST_ERR',
    c: 3,
    m: 1
  },
  WrongDocumentError: {
    s: 'WRONG_DOCUMENT_ERR',
    c: 4,
    m: 1
  },
  InvalidCharacterError: {
    s: 'INVALID_CHARACTER_ERR',
    c: 5,
    m: 1
  },
  NoDataAllowedError: {
    s: 'NO_DATA_ALLOWED_ERR',
    c: 6,
    m: 0
  },
  NoModificationAllowedError: {
    s: 'NO_MODIFICATION_ALLOWED_ERR',
    c: 7,
    m: 1
  },
  NotFoundError: {
    s: 'NOT_FOUND_ERR',
    c: 8,
    m: 1
  },
  NotSupportedError: {
    s: 'NOT_SUPPORTED_ERR',
    c: 9,
    m: 1
  },
  InUseAttributeError: {
    s: 'INUSE_ATTRIBUTE_ERR',
    c: 10,
    m: 1
  },
  InvalidStateError: {
    s: 'INVALID_STATE_ERR',
    c: 11,
    m: 1
  },
  SyntaxError: {
    s: 'SYNTAX_ERR',
    c: 12,
    m: 1
  },
  InvalidModificationError: {
    s: 'INVALID_MODIFICATION_ERR',
    c: 13,
    m: 1
  },
  NamespaceError: {
    s: 'NAMESPACE_ERR',
    c: 14,
    m: 1
  },
  InvalidAccessError: {
    s: 'INVALID_ACCESS_ERR',
    c: 15,
    m: 1
  },
  ValidationError: {
    s: 'VALIDATION_ERR',
    c: 16,
    m: 0
  },
  TypeMismatchError: {
    s: 'TYPE_MISMATCH_ERR',
    c: 17,
    m: 1
  },
  SecurityError: {
    s: 'SECURITY_ERR',
    c: 18,
    m: 1
  },
  NetworkError: {
    s: 'NETWORK_ERR',
    c: 19,
    m: 1
  },
  AbortError: {
    s: 'ABORT_ERR',
    c: 20,
    m: 1
  },
  URLMismatchError: {
    s: 'URL_MISMATCH_ERR',
    c: 21,
    m: 1
  },
  QuotaExceededError: {
    s: 'QUOTA_EXCEEDED_ERR',
    c: 22,
    m: 1
  },
  TimeoutError: {
    s: 'TIMEOUT_ERR',
    c: 23,
    m: 1
  },
  InvalidNodeTypeError: {
    s: 'INVALID_NODE_TYPE_ERR',
    c: 24,
    m: 1
  },
  DataCloneError: {
    s: 'DATA_CLONE_ERR',
    c: 25,
    m: 1
  }
};
domExceptionConstants.IndexSizeError;
domExceptionConstants.DOMStringSizeError;
domExceptionConstants.HierarchyRequestError;
domExceptionConstants.WrongDocumentError;
domExceptionConstants.InvalidCharacterError;
domExceptionConstants.NoDataAllowedError;
domExceptionConstants.NoModificationAllowedError;
domExceptionConstants.NotFoundError;
domExceptionConstants.NotSupportedError;
domExceptionConstants.InUseAttributeError;
domExceptionConstants.InvalidStateError;
domExceptionConstants.InvalidModificationError;
domExceptionConstants.NamespaceError;
domExceptionConstants.InvalidAccessError;
domExceptionConstants.ValidationError;
domExceptionConstants.TypeMismatchError;
domExceptionConstants.SecurityError;
domExceptionConstants.NetworkError;
domExceptionConstants.AbortError;
domExceptionConstants.URLMismatchError;
domExceptionConstants.QuotaExceededError;
domExceptionConstants.TimeoutError;
domExceptionConstants.InvalidNodeTypeError;
domExceptionConstants.DataCloneError;

var $Error = Error;
var replace = functionUncurryThis(''.replace);
var TEST = function (arg) {
  return String(new $Error(arg).stack);
}('zxcasd');
// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
var errorStackClear = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  }
  return stack;
};

var defineProperty = objectDefineProperty.f;
var DOM_EXCEPTION = 'DOMException';
var Error$1 = getBuiltIn('Error');
var NativeDOMException = getBuiltIn(DOM_EXCEPTION);
var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var that = new NativeDOMException(message, name);
  var error = new Error$1(message);
  error.name = DOM_EXCEPTION;
  defineProperty(that, 'stack', createPropertyDescriptor(1, errorStackClear(error.stack, 1)));
  inheritIfRequired(that, this, $DOMException);
  return that;
};
var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;
var ERROR_HAS_STACK = 'stack' in new Error$1(DOM_EXCEPTION);
var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var descriptor = NativeDOMException && descriptors && Object.getOwnPropertyDescriptor(globalThis_1, DOM_EXCEPTION);

// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
// https://github.com/Jarred-Sumner/bun/issues/399
var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);
var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;

// `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
_export({
  global: true,
  constructor: true,
  forced: FORCED_CONSTRUCTOR
}, {
  // TODO: fix export logic
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});
var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;
if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
  {
    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
  }
  for (var key in domExceptionConstants) if (hasOwnProperty_1(domExceptionConstants, key)) {
    var constant = domExceptionConstants[key];
    var constantName = constant.s;
    if (!hasOwnProperty_1(PolyfilledDOMException, constantName)) {
      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
    }
  }
}

var component$I = {
  exports: {}
};
const VIDEO_MODAL_VIEW = 'video';
const VIDEO_MODAL_IFRAME_SRC = 'https://player.mediadelivery.net/embed/628851/9446ae1d-4d0a-436c-9b0d-e84b2e9fe2af?autoplay=false&loop=false&muted=false&preload=true&responsive=true';
const VIDEO_MODAL_IFRAME_AUTOPLAY_SRC = VIDEO_MODAL_IFRAME_SRC.replace('autoplay=false', 'autoplay=true');
const VIDEO_MODAL_PLAYERJS_SRC = 'https://assets.mediadelivery.net/playerjs/playerjs-latest.min.js';
component$I.exports = {
  oncomplete() {
    if (ractive.isServer) {
      return;
    }
    this.setupVideoModal();
    if (this.get('view') === VIDEO_MODAL_VIEW) {
      this.openVideoModal();
    }
  },
  onteardown() {
    this.teardownVideoModal();
  },
  openVideoModal({
    autoplay = false
  } = {}) {
    let {
      modal,
      $modal
    } = this._videoModalHandlers || {};
    if (!modal) {
      return false;
    }
    this._shouldPlayVideoModalOnShow ||= autoplay;
    if (!$modal.hasClass('in') && document.activeElement instanceof HTMLElement) {
      this._videoModalReturnFocusEl = document.activeElement;
    }
    if (this.get('view') !== VIDEO_MODAL_VIEW) {
      app.router.replaceQueryParam('view', VIDEO_MODAL_VIEW);
    }
    $modal.modal('show');
    return false;
  },
  loadVideoModalPlayerApi() {
    if (window.playerjs?.Player) {
      return Promise.resolve(window.playerjs);
    }
    if (this._videoModalPlayerApiPromise) {
      return this._videoModalPlayerApiPromise;
    }
    this._videoModalPlayerApiPromise = new Promise(resolve => {
      let script = document.querySelector('script[data-gp-video-modal-playerjs]');
      let handleLoad = () => {
        script?.setAttribute('data-loaded', 'true');
        resolve(window.playerjs ?? null);
      };
      let handleError = () => {
        this._videoModalPlayerApiPromise = null;
        this._videoModalPlayerPromise = null;
        script?.remove();
        resolve(null);
      };
      if (script?.getAttribute('data-loaded') === 'true') {
        handleLoad();
        return;
      }
      if (!script) {
        script = document.createElement('script');
        script.src = VIDEO_MODAL_PLAYERJS_SRC;
        script.async = true;
        script.dataset.gpVideoModalPlayerjs = 'true';
        document.head.appendChild(script);
      }
      script.addEventListener('load', handleLoad);
      script.addEventListener('error', handleError);
    });
    return this._videoModalPlayerApiPromise;
  },
  getVideoModalPlayer(videoFrame = this._videoModalHandlers?.videoFrame) {
    if (!videoFrame) {
      return Promise.resolve(null);
    }
    if (this._videoModalPlayerPromise) {
      return this._videoModalPlayerPromise;
    }
    this._videoModalPlayerPromise = this.loadVideoModalPlayerApi().then(playerjs => {
      if (!playerjs?.Player) {
        this._videoModalPlayerPromise = null;
        return null;
      }
      return new Promise(resolve => {
        let player = new playerjs.Player(videoFrame);
        let readyTimeout = null;
        let markReady = () => {
          clearTimeout(readyTimeout);
          resolve(player);
        };
        try {
          player.on('ready', markReady);
        } catch {
          markReady();
          return;
        }
        readyTimeout = setTimeout(markReady, 3000);
      });
    }).catch(() => {
      this._videoModalPlayerPromise = null;
      return null;
    });
    return this._videoModalPlayerPromise;
  },
  resetVideoModalPlayback() {
    let videoFrame = this._videoModalHandlers?.videoFrame;
    let hasVideoSrc = !!videoFrame?.getAttribute('src');
    if (!hasVideoSrc && !this._videoModalPlayerPromise) {
      return;
    }
    this.getVideoModalPlayer(videoFrame).then(player => {
      if (!player || this._isVideoModalFrameActive) {
        return;
      }
      player.pause?.();
      player.setCurrentTime?.(0);
    }).catch(() => null);
  },
  activateVideoModalFrame() {
    let videoFrame = this._videoModalHandlers?.videoFrame;
    let iframeSrc = this._shouldPlayVideoModalOnShow ? VIDEO_MODAL_IFRAME_AUTOPLAY_SRC : VIDEO_MODAL_IFRAME_SRC;
    this._isVideoModalFrameActive = true;
    if (!videoFrame) {
      return;
    }
    if (videoFrame.getAttribute('src') !== iframeSrc) {
      videoFrame.setAttribute('src', iframeSrc);
    }
    this.getVideoModalPlayer(videoFrame).then(player => {
      if (this._isVideoModalFrameActive && this._shouldPlayVideoModalOnShow) {
        player?.play?.();
      }
    }).catch(() => null);
  },
  moveVideoModalFocusOut(modal = this._videoModalHandlers?.modal) {
    let activeElement = document.activeElement;
    let hasReturnFocusEl = this._videoModalReturnFocusEl instanceof HTMLElement && document.contains(this._videoModalReturnFocusEl);
    if (!(activeElement instanceof HTMLElement) || !modal?.contains(activeElement)) {
      return;
    }
    if (hasReturnFocusEl) {
      this._videoModalReturnFocusEl.focus();
      return;
    }
    activeElement.blur();
  },
  resetVideoModalState({
    restoreFocus = false
  } = {}) {
    let hasReturnFocusEl = this._videoModalReturnFocusEl instanceof HTMLElement;
    let shouldClearReturnFocusEl = !hasReturnFocusEl || !document.contains(this._videoModalReturnFocusEl);
    this._isVideoModalFrameActive = false;
    this._shouldPlayVideoModalOnShow = false;
    this.resetVideoModalPlayback();
    if (this.get('view') === VIDEO_MODAL_VIEW) {
      app.router.replaceQueryParam('view', this.get('measurement') ? 'home' : null);
    }
    if (restoreFocus && hasReturnFocusEl && !shouldClearReturnFocusEl) {
      this._videoModalReturnFocusEl.focus();
    }
    if (restoreFocus || shouldClearReturnFocusEl) {
      this._videoModalReturnFocusEl = null;
    }
  },
  forceHideVideoModal(modal = this._videoModalHandlers?.modal) {
    if (modal) {
      this.moveVideoModalFocusOut(modal);
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
      $(modal).removeClass('in');
      $(modal).removeData('bs.modal');
    }
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('padding-right');
    document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());
  },
  setupVideoModal() {
    if (this._videoModalHandlers) {
      return;
    }
    let modal = this.find('.c-gp-video-modal_modal');
    let videoFrame = this.find('.c-gp-video-modal_iframe');
    if (!modal) {
      return;
    }
    document.body.appendChild(modal);
    document.documentElement.classList.add('scrollbar-stable');
    let $modal = $(modal);
    this.observe('view', view => {
      if (view === VIDEO_MODAL_VIEW) {
        this.openVideoModal();
      } else if ($modal.hasClass('in')) {
        $modal.modal('hide');
      }
    }, {
      init: false
    });
    let showHandler = () => {
      this.activateVideoModalFrame();
    };
    let hideHandler = () => {
      this.moveVideoModalFocusOut(modal);
    };
    let loadHandler = () => {
      if (videoFrame.getAttribute('src')) {
        videoFrame.classList.add('video-loaded');
        this.getVideoModalPlayer(videoFrame);
        return;
      }
      videoFrame.classList.remove('video-loaded');
    };
    let hiddenHandler = () => {
      this.resetVideoModalState({
        restoreFocus: true
      });
    };
    $modal.on('show.bs.modal', showHandler);
    $modal.on('hide.bs.modal', hideHandler);
    $modal.on('hidden.bs.modal', hiddenHandler);
    videoFrame?.addEventListener('load', loadHandler);
    this._videoModalHandlers = {
      modal,
      $modal,
      videoFrame,
      loadHandler,
      hideHandler,
      showHandler,
      hiddenHandler
    };
  },
  teardownVideoModal() {
    if (!this._videoModalHandlers) {
      return;
    }
    let {
      modal,
      $modal,
      videoFrame,
      loadHandler,
      hideHandler,
      showHandler,
      hiddenHandler
    } = this._videoModalHandlers;
    this.resetVideoModalState();
    $modal.off('show.bs.modal', showHandler);
    $modal.off('hide.bs.modal', hideHandler);
    $modal.off('hidden.bs.modal', hiddenHandler);
    videoFrame?.removeEventListener('load', loadHandler);
    this.forceHideVideoModal(modal);
    modal.remove();
    document.documentElement.classList.remove('scrollbar-stable');
    this._videoModalPlayerPromise = null;
    this._videoModalPlayerApiPromise = null;
    this._videoModalReturnFocusEl = null;
    this._videoModalHandlers = null;
  }
};
component$I.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-gp-video-modal",
      g: 1
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "c-gp-video-modal_trigger",
        g: 1
      }],
      f: [{
        t: 7,
        e: "button",
        m: [{
          t: 13,
          n: "class",
          f: "c-gp-video-modal_button",
          g: 1
        }, {
          n: "type",
          f: "button",
          t: 13,
          g: 1
        }, {
          n: ["click"],
          t: 70,
          f: {
            r: ["@this"],
            s: "[_0.openVideoModal({autoplay:true})]"
          }
        }, {
          n: "aria-label",
          f: "Watch the What is Globalping video",
          t: 13,
          g: 1
        }],
        f: [{
          t: 7,
          e: "img",
          m: [{
            n: "alt",
            f: "",
            t: 13,
            g: 1
          }, {
            n: "width",
            f: "12",
            t: 13,
            g: 1
          }, {
            n: "height",
            f: "15",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/img/play-triangle.svg"],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "span",
          f: ["What is Globalping"]
        }]
      }, " ", {
        t: 7,
        e: "span",
        m: [{
          t: 13,
          n: "class",
          f: "c-gp-video-modal_text",
          g: 1
        }],
        f: ["1 minute video"]
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "modal fade c-gp-video-modal_modal",
        g: 1
      }, {
        n: "tabindex",
        f: "-1",
        t: 13,
        g: 1
      }, {
        n: "role",
        f: "dialog",
        t: 13,
        g: 1
      }, {
        n: "aria-labelledby",
        f: "gp-video-modal-title",
        t: 13,
        g: 1
      }, {
        n: "aria-hidden",
        f: "true",
        t: 13,
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "modal-dialog",
          g: 1
        }, {
          n: "role",
          f: "document",
          t: 13,
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "modal-content",
            g: 1
          }],
          f: [{
            t: 7,
            e: "h2",
            m: [{
              t: 13,
              n: "class",
              f: "sr-only",
              g: 1
            }, {
              n: "id",
              f: "gp-video-modal-title",
              t: 13,
              g: 1
            }],
            f: ["What is Globalping video"]
          }, " ", {
            t: 7,
            e: "button",
            m: [{
              t: 13,
              n: "class",
              f: "c-gp-video-modal_close",
              g: 1
            }, {
              n: "type",
              f: "button",
              t: 13,
              g: 1
            }, {
              n: "data-dismiss",
              f: "modal",
              t: 13,
              g: 1
            }, {
              n: "aria-label",
              f: "Close video player",
              t: 13,
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                n: "aria-hidden",
                f: "true",
                t: 13,
                g: 1
              }],
              f: ["×"]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "c-gp-video-modal_player",
              g: 1
            }],
            f: [{
              t: 7,
              e: "iframe",
              m: [{
                t: 13,
                n: "class",
                f: "c-gp-video-modal_iframe",
                g: 1
              }, {
                n: "loading",
                f: "lazy",
                t: 13,
                g: 1
              }, {
                n: "allow",
                f: "accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;",
                t: 13,
                g: 1
              }, {
                n: "allowfullscreen",
                f: "allowfullscreen",
                t: 13,
                g: 1
              }],
              f: []
            }]
          }]
        }]
      }]
    }]
  }],
  e: {
    "[_0.openVideoModal({autoplay:true})]": function (_0) {
      return [_0.openVideoModal({
        autoplay: true
      })];
    }
  }
};
var videoModal = ractive.extend(component$I.exports);

var component$H = {
  exports: {}
};
const ID_PREFIX$1 = 'id-';
component$H.exports = {
  data() {
    return {
      _,
      html: '',
      safeHtmlToRender: ''
    };
  },
  oninit() {
    if (!ractive.isServer) {
      _.injectGlobalStyle('https://cdn.jsdelivr.net/gh/highlightjs/cdn-release@11.7.0/build/styles/github.min.css');
      Promise.all([
      // eslint-disable-next-line n/no-missing-import
      import('https://cdn.jsdelivr.net/npm/dompurify@2.4.3/+esm')]).then(([{
        default: DOMPurify
      }]) => {
        let _this = this;
        DOMPurify.removeAllHooks();
        DOMPurify.addHook('afterSanitizeAttributes', node => {
          if (node.hasAttribute('href')) {
            node.setAttribute('href', _.normalizeHref(node.getAttribute('href'), ID_PREFIX$1));
          }
          if (node.hasAttribute('src')) {
            node.setAttribute('src', _.optimizeSrc(node.getAttribute('src'), _this.get('github')));
            node.setAttribute('loading', 'lazy');
          }
          if ('target' in node) {
            if (_.isExternalLink(node.getAttribute('href'))) {
              node.setAttribute('target', '_blank');
            }
            node.setAttribute('rel', 'nofollow noopener noreferrer');
            node.classList.add('router-ignore');
          }
        });

        // if page URL has a hash then scroll page to the anchor
        this.observe('safeHtmlToRender', () => {
          // it appears the observer sometimes executes too soon despite defer: true, so we delay by one cycle here
          setTimeout(() => {
            let anchor = app.router.uri.hash;
            let el = anchor ? this.find(anchor) : null;
            if (el) {
              if (document.visibilityState === 'visible') {
                el.scrollIntoView({
                  behavior: 'smooth'
                });
              } else {
                document.addEventListener('visibilitychange', function listener() {
                  el.scrollIntoView({
                    behavior: 'smooth'
                  });
                  document.removeEventListener('visibilitychange', listener);
                });
              }
            }
          });
        }, {
          init: false,
          defer: true
        });
        this.observe('html', html => {
          this.set('safeHtmlToRender', DOMPurify.sanitize(html));
        });
      });
    }
  }
};
component$H.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-html",
      g: 1
    }],
    f: [{
      t: 3,
      r: "safeHtmlToRender"
    }]
  }]
};
var html = ractive.extend(component$H.exports);

var component$G = {
  exports: {}
};
component$G.exports = {
  data() {
    return {
      testExamples: [{
        title: 'Ping from Amazon+Virginia',
        icon: 'ping.svg',
        opts: {
          type: 'ping',
          target: 'cdn.jsdelivr.net',
          location: 'Amazon.com+US-VA',
          limit: 10,
          ipVersion: 4
        }
      }, {
        title: 'Compare bing.com to google.com from Eastern Europe',
        icon: 'compare.svg',
        opts: {
          type: 'ping',
          target: 'bing.com,google.com',
          location: 'Eastern Europe',
          limit: 10,
          ipVersion: 4
        }
      }, {
        title: 'Infinite Ping from Berlin',
        icon: 'infiniteping.svg',
        opts: {
          type: 'ping',
          target: 'cdn.jsdelivr.net',
          location: 'Berlin',
          limit: 5,
          ipVersion: 4,
          infinite: true
        }
      }, {
        title: 'IPv6 HTTP GET from USA, Canada, Mexico',
        icon: 'ipv6.svg',
        opts: {
          type: 'HTTP',
          target: 'cdn.jsdelivr.net',
          location: 'USA, Canada, Mexico',
          limit: 10,
          ipVersion: 6
        }
      }, {
        title: 'TCP Ping from California+Eyeball',
        icon: 'tcpping.svg',
        opts: {
          type: 'ping',
          target: 'cdn.jsdelivr.net',
          location: 'California+eyeball-network',
          limit: 10,
          ipVersion: 4,
          extended: {
            protocol: 'TCP'
          }
        }
      }, {
        title: 'DNS Resolve from China',
        icon: 'dns.svg',
        opts: {
          type: 'DNS',
          target: 'cdn.jsdelivr.net',
          location: 'China',
          limit: 10
        }
      }]
    };
  }
};
component$G.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-test-examples",
      g: 1
    }],
    f: [{
      t: 7,
      e: "h4",
      f: ["Quick examples you can run instantly"]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "c-test-examples_container",
        g: 1
      }],
      f: [{
        t: 4,
        f: [{
          t: 7,
          e: "button",
          m: [{
            t: 13,
            n: "class",
            f: "c-test-examples_item",
            g: 1
          }, {
            n: ["click"],
            t: 70,
            f: {
              r: ["onExampleClick", "opts"],
              s: "[_0(_1)]"
            }
          }],
          f: [{
            t: 7,
            e: "img",
            m: [{
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/quick-examples/", {
                t: 2,
                r: "icon"
              }],
              t: 13
            }, {
              n: "alt",
              f: "",
              t: 13,
              g: 1
            }, {
              n: "width",
              f: "14",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "14",
              t: 13,
              g: 1
            }]
          }, " ", {
            t: 2,
            r: "title"
          }]
        }],
        n: 52,
        r: "testExamples"
      }]
    }]
  }],
  e: {
    "[_0(_1)]": function (_0, _1) {
      return [_0(_1)];
    }
  }
};
component$G.exports.components = {
  "c-html": html
};
var testExamples = ractive.extend(component$G.exports);

var debounce = (fn, wait = 100) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(fn, wait, ...args);
  };
};

var throttle = (fn, wait = 100) => {
  let lastCalled, timeout;
  return (...args) => {
    let now = Date.now();
    if (lastCalled && now - lastCalled < wait) {
      clearTimeout(timeout);
      return timeout = setTimeout(fn, wait - (now - lastCalled), ...args);
    }
    lastCalled = now;
    clearTimeout(timeout);
    fn(...args);
  };
};

const addManagedListener$2 = (component, target, event, handler) => {
  if (!target || typeof target.addEventListener !== 'function' || typeof target.removeEventListener !== 'function') {
    console.warn('Invalid target passed to addManagedListener');
    return;
  }
  target.addEventListener(event, handler);
  if (!component || typeof component.on !== 'function') {
    console.warn('Invalid component passed to addManagedListener');
    return;
  }
  component.on('unrender', () => {
    target.removeEventListener(event, handler);
  });
};
var addManagedListener_1 = addManagedListener$2;
var screenWidthListener = component => {
  component.set('screenWidth', window.innerWidth);
  addManagedListener$2(component, window, 'resize', debounce(throttle(() => component.set('screenWidth', window.innerWidth), 200)));
};
var stickySidebarScrollListener = component => {
  let sidebar = document.querySelector('.page-content_side-menu');
  if (sidebar) {
    let top = sidebar.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
    let handleStickySidebarScroll = () => {
      let y = document.scrollingElement.scrollTop;
      let currentSidebarTop = sidebar.getBoundingClientRect().top;
      if (currentSidebarTop <= 20 && currentSidebarTop >= 0 || y > top) {
        sidebar.setAttribute('style', 'position: sticky; top: 20px');
      } else {
        sidebar.removeAttribute('style');
      }
    };
    addManagedListener$2(component, window, 'scroll', handleStickySidebarScroll);
    handleStickySidebarScroll();
  }
};
var listeners = {
  addManagedListener: addManagedListener_1,
  screenWidthListener: screenWidthListener,
  stickySidebarScrollListener: stickySidebarScrollListener
};

var component$F = {
  exports: {}
};

/** This component renders a spinning globe video with a fallback poster in variable resolutions.
* This behavior is not achievable natively, hence the need for custom js.
* */
const {
  addManagedListener: addManagedListener$1
} = listeners;
component$F.exports = {
  onrender() {
    if (ractive.isServer) {
      return;
    }
    let defaultVideo = this.find('.c-gp-globe_video--default');
    let highResolutionVideo = this.find('.c-gp-globe_video--high-resolution');
    let desktopQuery = window.matchMedia('(min-width: 768px)');
    let prefersReducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeVideo = desktopQuery.matches ? highResolutionVideo : defaultVideo;
    let pendingVideo;
    let highResolutionVideoLoaded = desktopQuery.matches;
    let playVideo = video => {
      if (!prefersReducedMotionQuery.matches) {
        video.play().catch(() => {});
      }
    };
    let waitForVideoFrame = (video, onFrame) => {
      // do not expose the video until it has a real frame to paint over the poster
      if (video.requestVideoFrameCallback) {
        video.requestVideoFrameCallback(onFrame);
        return;
      }
      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        onFrame();
        return;
      }
      addManagedListener$1(this, video, 'loadeddata', onFrame);
    };
    let loadVideo = (video, startTime, onFrame) => {
      let isCurrentVideo = () => video === activeVideo || video === pendingVideo;

      // load and seek the inactive video before placing it above the active one
      let startVideo = () => {
        if (!isCurrentVideo()) {
          return;
        }
        let showVideo = () => {
          if (!isCurrentVideo()) {
            return;
          }
          video.classList.add('is-ready');
          onFrame();
        };
        if (startTime > 0) {
          addManagedListener$1(this, video, 'seeked', () => {
            if (!isCurrentVideo()) {
              return;
            }
            waitForVideoFrame(video, showVideo);
            playVideo(video);
          });
          video.currentTime = startTime;
          return;
        }
        waitForVideoFrame(video, showVideo);
        playVideo(video);
      };
      addManagedListener$1(this, video, 'loadedmetadata', startVideo);
      video.src = video.dataset.src;
      video.load();
    };
    loadVideo(activeVideo, 0, () => {});

    // when the client window resolution exceeds the desktop threshold, upgrade to a higher-res video
    // never reduce the video resolution
    addManagedListener$1(this, desktopQuery, 'change', event => {
      if (!event.matches || highResolutionVideoLoaded) {
        return;
      }
      highResolutionVideoLoaded = true;
      pendingVideo = highResolutionVideo;
      loadVideo(highResolutionVideo, defaultVideo.currentTime, () => {
        defaultVideo.pause();
        activeVideo = highResolutionVideo;
        pendingVideo = undefined;
      });
    });

    // handle prefers reduced motion
    let handleReducedMotionChange = event => {
      if (event.matches) {
        activeVideo.pause();
        if (pendingVideo) {
          pendingVideo.pause();
        }
        return;
      }
      playVideo(activeVideo);
      if (pendingVideo) {
        playVideo(pendingVideo);
      }
    };
    handleReducedMotionChange(prefersReducedMotionQuery);
    addManagedListener$1(this, prefersReducedMotionQuery, 'change', handleReducedMotionChange);
    let resumeVideoPlayback = () => {
      if (document.hidden || prefersReducedMotionQuery.matches) {
        return;
      }
      playVideo(activeVideo);
      if (pendingVideo) {
        playVideo(pendingVideo);
      }
    };
    addManagedListener$1(this, document, 'visibilitychange', resumeVideoPlayback);
    addManagedListener$1(this, window, 'focus', resumeVideoPlayback);
  }
};
component$F.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      n: "class",
      f: ["c-gp-globe ", {
        t: 2,
        r: "className"
      }],
      t: 13
    }, {
      n: "aria-hidden",
      f: "true",
      t: 13,
      g: 1
    }],
    f: [{
      t: 7,
      e: "picture",
      m: [{
        t: 13,
        n: "class",
        f: "c-gp-globe_poster",
        g: 1
      }],
      f: [{
        t: 7,
        e: "source",
        m: [{
          n: "media",
          f: "(min-width: 768px)",
          t: 13,
          g: 1
        }, {
          n: "srcset",
          f: [{
            t: 2,
            r: "@shared.assetsHost"
          }, "/img/globe-poster@2x.webp"],
          t: 13
        }]
      }, " ", {
        t: 7,
        e: "img",
        m: [{
          n: "src",
          f: [{
            t: 2,
            r: "@shared.assetsHost"
          }, "/img/globe-poster.webp"],
          t: 13
        }, {
          n: "alt",
          f: "",
          t: 13,
          g: 1
        }, {
          n: "fetchpriority",
          f: "high",
          t: 13,
          g: 1
        }]
      }]
    }, " ", {
      t: 7,
      e: "video",
      m: [{
        t: 13,
        n: "class",
        f: "c-gp-globe_video c-gp-globe_video--default",
        g: 1
      }, {
        n: "loop",
        f: 0,
        t: 13
      }, {
        n: "muted",
        f: 0,
        t: 13
      }, {
        n: "playsinline",
        f: 0,
        t: 13
      }, {
        n: "preload",
        f: "metadata",
        t: 13,
        g: 1
      }, {
        n: "data-src",
        f: [{
          t: 2,
          r: "@shared.assetsHost"
        }, "/img/globe-video.webm"],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "video",
      m: [{
        t: 13,
        n: "class",
        f: "c-gp-globe_video c-gp-globe_video--high-resolution",
        g: 1
      }, {
        n: "loop",
        f: 0,
        t: 13
      }, {
        n: "muted",
        f: 0,
        t: 13
      }, {
        n: "playsinline",
        f: 0,
        t: 13
      }, {
        n: "preload",
        f: "metadata",
        t: 13,
        g: 1
      }, {
        n: "data-src",
        f: [{
          t: 2,
          r: "@shared.assetsHost"
        }, "/img/globe-video@2x.webm"],
        t: 13
      }]
    }]
  }]
};
var globe = ractive.extend(component$F.exports);

var component$E = {
  exports: {}
};
component$E.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      n: "class",
      f: ["c-gp-jumbotron ", {
        t: 2,
        r: "className"
      }],
      t: 13
    }],
    f: [{
      t: 4,
      f: [{
        t: 7,
        e: "c-gp-globe",
        m: [{
          n: "className",
          f: "jumbotron_globe",
          t: 13,
          g: 1
        }, {
          n: "visibleRowsPercent",
          f: "75",
          t: 13,
          g: 1
        }]
      }],
      n: 50,
      x: {
        r: ["gridType"],
        s: "_0===\"globe\""
      }
    }, {
      t: 4,
      f: [{
        t: 7,
        e: "img",
        m: [{
          t: 13,
          n: "class",
          f: "jumbotron_grid",
          g: 1
        }, {
          n: "alt",
          f: "",
          t: 13,
          g: 1
        }, {
          n: "width",
          f: "2016",
          t: 13,
          g: 1
        }, {
          n: "height",
          f: "745",
          t: 13,
          g: 1
        }, {
          n: "src",
          f: [{
            t: 2,
            r: "@shared.assetsHost"
          }, "/img/globalping-grid-type-1.svg"],
          t: 13
        }]
      }, " "],
      n: 50,
      x: {
        r: ["gridType"],
        s: "_0===\"type1\""
      },
      l: 1
    }, {
      t: 4,
      f: [" ", {
        t: 7,
        e: "img",
        m: [{
          t: 13,
          n: "class",
          f: "jumbotron_grid",
          g: 1
        }, {
          n: "alt",
          f: "",
          t: 13,
          g: 1
        }, {
          n: "width",
          f: "1440",
          t: 13,
          g: 1
        }, {
          n: "height",
          f: "600",
          t: 13,
          g: 1
        }, {
          n: "src",
          f: [{
            t: 2,
            r: "@shared.assetsHost"
          }, "/img/globalping-grid-type-2.svg"],
          t: 13
        }]
      }, " "],
      n: 50,
      x: {
        r: ["gridType"],
        s: "_0===\"type2\""
      },
      l: 1
    }, {
      t: 4,
      f: [" ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "grid-type-3",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "grid-type-3_under-header",
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "grid-type-3_grid-wrapper",
            g: 1
          }],
          f: [{
            t: 7,
            e: "img",
            m: [{
              t: 13,
              n: "class",
              f: "jumbotron_grid",
              g: 1
            }, {
              n: "alt",
              f: "",
              t: 13,
              g: 1
            }, {
              n: "width",
              f: "1150",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "689",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/globalping-grid-type-3.svg"],
              t: 13
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "grid-type-3_gradient",
            g: 1
          }]
        }]
      }, " "],
      n: 50,
      x: {
        r: ["gridType"],
        s: "_0===\"type3\""
      },
      l: 1
    }, {
      t: 4,
      f: [" ", {
        t: 7,
        e: "img",
        m: [{
          t: 13,
          n: "class",
          f: "jumbotron_grid",
          g: 1
        }, {
          n: "alt",
          f: "",
          t: 13,
          g: 1
        }, {
          n: "width",
          f: "1150",
          t: 13,
          g: 1
        }, {
          n: "height",
          f: "625",
          t: 13,
          g: 1
        }, {
          n: "src",
          f: [{
            t: 2,
            r: "@shared.assetsHost"
          }, "/img/globalping-grid-type-4.svg"],
          t: 13
        }]
      }],
      n: 50,
      x: {
        r: ["gridType"],
        s: "_0===\"type4\""
      },
      l: 1
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "jumbotron_blur",
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "jumbotron_blur_circle-one",
          g: 1
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "jumbotron_blur_circle-two",
          g: 1
        }]
      }]
    }]
  }],
  e: {
    "_0===\"globe\"": function (_0) {
      return _0 === "globe";
    },
    "_0===\"type1\"": function (_0) {
      return _0 === "type1";
    },
    "_0===\"type2\"": function (_0) {
      return _0 === "type2";
    },
    "_0===\"type3\"": function (_0) {
      return _0 === "type3";
    },
    "_0===\"type4\"": function (_0) {
      return _0 === "type4";
    }
  }
};
component$E.exports.components = {
  "c-gp-globe": globe
};
var jumbotron = ractive.extend(component$E.exports);

const {
  isTouchDevice
} = _;
let activeTooltip = null;
let tooltipDecorator = (node, content, position = 'top', rawHtml = false, elementName = 'div', className, offsetX, offsetY) => {
  let tooltip, handlers, eventName, initialNodeTop, rafId, longPressTimer;
  let handleOutsideClick = e => {
    if (tooltip && !node.contains(e.target) && !tooltip.contains(e.target)) {
      removeTooltip();
    }
  };
  let createTooltip = () => {
    if (tooltip) {
      return;
    }
    activeTooltip?.remove();
    initialNodeTop = Math.round(node.getBoundingClientRect().top);
    tooltip = document.createElement(elementName);
    tooltip.className = `ractive-tooltip ${getPositionClass(position)}${className ? ` ${className}` : ''}`;
    if (rawHtml) {
      let preTag = document.createElement('pre');
      tooltip.classList.add('raw');
      preTag.textContent = content;
      tooltip.appendChild(preTag);
    } else {
      if (!Array.isArray(content)) {
        tooltip.textContent = content;
      } else {
        content.forEach(line => {
          tooltip.appendChild(document.createTextNode(line));
          tooltip.appendChild(document.createElement('br'));
        });
      }
    }
    tooltip.id = 'ractive-tooltip-instance';
    document.body.appendChild(tooltip);
    activeTooltip = {
      node,
      remove: removeTooltip
    };
    document.addEventListener('click', handleOutsideClick, true);
    document.addEventListener('touchstart', handleOutsideClick, true);
    monitorPosition();
  };
  let monitorPosition = () => {
    if (!tooltip) {
      return;
    }
    let currentTop = Math.round(node.getBoundingClientRect().top);
    if (currentTop !== initialNodeTop) {
      removeTooltip();
      return;
    }
    rafId = requestAnimationFrame(monitorPosition);
  };
  let positionTooltip = () => {
    if (!tooltip) {
      return;
    }
    tooltip.style.left = `${offsetX ? offsetX : getXPos(position)}px`;
    tooltip.style.top = `${offsetY ? offsetY : getYPos(position)}px`;
  };
  let removeTooltip = () => {
    if (!tooltip) {
      return;
    }
    if (typeof rafId === 'number') {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    clearTimeout(longPressTimer);
    document.removeEventListener('click', handleOutsideClick, true);
    document.removeEventListener('touchstart', handleOutsideClick, true);
    if (tooltip.parentElement) {
      tooltip.parentElement.removeChild(tooltip);
    }
    if (activeTooltip?.node === node) {
      activeTooltip = null;
    }
    tooltip = null;
  };
  let getPositionClass = position => {
    let resClass;
    switch (position) {
      case 'top':
        resClass = 'ractive-tooltip-top';
        break;
      case 'left':
        resClass = 'ractive-tooltip-left';
        break;
      case 'right':
        resClass = 'ractive-tooltip-right';
        break;
      default:
        resClass = 'ractive-tooltip-bottom';
    }
    return resClass;
  };
  let getYPos = position => {
    let yPos;
    let {
      top,
      bottom
    } = node.getBoundingClientRect();
    switch (position) {
      case 'top':
        yPos = top - tooltip.clientHeight - 10;
        break;
      case 'left':
      case 'right':
        yPos = (top + bottom) / 2 - tooltip.clientHeight / 2;
        break;
      default:
        yPos = bottom + 10;
    }
    return Math.round(yPos);
  };
  let getXPos = position => {
    let xPos;
    let {
      left,
      right
    } = node.getBoundingClientRect();
    switch (position) {
      case 'left':
        xPos = left - tooltip.clientWidth - 10;
        break;
      case 'right':
        xPos = right + 10;
        break;
      default:
        xPos = left + (right - left) / 2 - tooltip.clientWidth / 2;
    }
    return Math.round(xPos);
  };
  handlers = {
    mouseover() {
      createTooltip();
      positionTooltip();
    },
    mousemove() {
      positionTooltip();
    },
    mouseleave() {
      removeTooltip();
    },
    touchstart() {
      if (!isTouchDevice()) {
        return;
      }
      longPressTimer = setTimeout(() => {
        removeTooltip();
        createTooltip();
        positionTooltip();
      }, 100);
    },
    contextmenu(e) {
      if (!isTouchDevice()) {
        return;
      }
      e.preventDefault();
    }
  };
  for (eventName in handlers) {
    if (Object.hasOwn(handlers, eventName)) {
      node.addEventListener(eventName, handlers[eventName], false);
    }
  }
  return {
    teardown() {
      for (eventName in handlers) {
        if (Object.hasOwn(handlers, eventName)) {
          node.removeEventListener(eventName, handlers[eventName], false);
        }
      }
      clearTimeout(longPressTimer);
      removeTooltip();
    }
  };
};
var tooltip = tooltipDecorator;

var component$D = {
  exports: {}
};
component$D.exports = {
  decorators: {
    tooltip
  },
  data() {
    return {
      consumingValue: null,
      remainingRequests: null,
      availableRequests: null,
      consumedRateLimit: null,
      remainingCredits: null,
      consumedCredits: null,
      resetsInStr: null,
      creditsDataPresented: false,
      overallProbesCount: 0,
      sessionTimestampStart: null,
      sessionTimestampCurrent: null
    };
  },
  oninit() {
    if (!ractive.isServer) {
      // set session start time when test is started
      // SHOULD BE THE FIRST OBSERVE
      this.observe('testInProgress', testInProgress => {
        if (testInProgress) {
          this.set('sessionTimestampStart', Date.now());
          this.set('sessionTimestampCurrent', Date.now());
          this.set('consumedRateLimit', 0);
          this.set('consumedCredits', 0);
        } else {
          this.set('sessionTimestampStart', null);
          this.set('sessionTimestampCurrent', null);
          this.set('overallProbesCount', 0);
        }
      });
      this.observe('rateCreditsData', rateCreditsData => {
        if (rateCreditsData && rateCreditsData['x-ratelimit-limit']) {
          let rateLimitConsumed = Number(rateCreditsData['x-ratelimit-consumed']) || 0;
          let rateLimitRemaining = Number(rateCreditsData['x-ratelimit-remaining']) || 0;
          let rateLimitLimit = Number(rateCreditsData['x-ratelimit-limit']) || 0;
          let rateLimitReset = Number(rateCreditsData['x-ratelimit-reset']) || 0;
          let currentProbesCount = Number(rateCreditsData['x-request-cost']) || 0;
          let rateCreditsConsumed = Number(rateCreditsData['x-credits-consumed']) || 0;
          let rateCreditsRemaining = Number(rateCreditsData['x-credits-remaining']) || 0;
          if (this.get('isInfiniteModeRes')) {
            rateLimitConsumed += this.get('consumedRateLimit') || 0;
            rateCreditsConsumed += this.get('consumedCredits') || 0;
          }
          this.set('currentProbesCount', currentProbesCount);

          // handle RateLimit headers
          this.set('remainingRequests', rateLimitRemaining);
          this.set('availableRequests', rateLimitLimit);
          this.set('resetsInStr', this.createResetInStr(rateLimitReset));
          this.set('overallProbesCount', this.get('overallProbesCount') + currentProbesCount);
          this.set('consumedRateLimit', rateLimitConsumed);

          // handle Credits headers

          if (rateCreditsRemaining) {
            this.set('creditsDataPresented', true);
            this.set('consumedCredits', rateCreditsConsumed);
            this.set('remainingCredits', rateCreditsRemaining);
          } else {
            this.set('creditsDataPresented', false);
          }
        } else {
          // reset to default for a new measurement
          this.set('consumingValue', null);
          this.set('remainingRequests', null);
          this.set('availableRequests', null);
          this.set('consumedRateLimit', null);
          this.set('remainingCredits', null);
          this.set('consumedCredits', null);
          this.set('resetsInStr', null);
          this.set('creditsDataPresented', false);
          this.set('overallProbesCount', 0);
          this.set('sessionTimestampStart', null);
          this.set('sessionTimestampCurrent', null);
        }
      });

      // update current timestamp on receiving testResults
      this.observe('testResults', testResults => {
        if (testResults) {
          this.set('sessionTimestampCurrent', Date.now());
        }
      });

      // calculate consuming value
      this.observe('testResults.length', () => {
        let measurementsCount = this.get('testResults.length');
        if (measurementsCount < 2) {
          return;
        }
        let sessionTimestampCurrent = this.get('sessionTimestampCurrent');
        let overallProbesCount = this.get('overallProbesCount');
        let sessionTimestampStart = this.get('sessionTimestampStart');
        let sessionTime = Math.round((sessionTimestampCurrent - sessionTimestampStart) / 1000);
        let consumingValuePerSecond = (overallProbesCount - this.get('currentProbesCount')) / (sessionTime || 1);
        this.set('consumingValue', Math.round(consumingValuePerSecond * 60));
      }, {
        init: false
      });
    }
  },
  createResetInStr(seconds) {
    let minutes = seconds / 60;
    if (minutes < 1) {
      return '< 1 minute';
    }
    return `${Math.ceil(minutes)} minutes`;
  }
};
component$D.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      n: "class",
      f: ["c-gp-credits ", {
        t: 4,
        f: ["over-the-map"],
        n: 50,
        r: "mapOpened"
      }],
      t: 13
    }],
    f: [{
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "credits-wrapper",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "credits_data",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "credits_data_rate",
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "credits_data_rate_header",
                g: 1
              }],
              f: ["Rate limit:"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "credits_data_rate_details",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "credits_data_rate_details_numbers",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "credits_data_rate_details_numbers_credits-count",
                    g: 1
                  }],
                  f: [{
                    t: 2,
                    r: "remainingRequests"
                  }, "/", {
                    t: 2,
                    r: "availableRequests"
                  }]
                }, " ", {
                  t: 4,
                  f: [{
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "credits_data_rate_details_numbers_probes-count",
                      g: 1
                    }],
                    f: ["(-", {
                      t: 2,
                      r: "consumedRateLimit"
                    }, ")"]
                  }],
                  n: 50,
                  r: "consumedRateLimit"
                }]
              }, " ", {
                t: 7,
                e: "img",
                m: [{
                  n: "tooltip",
                  t: 71,
                  f: {
                    r: ["resetsInStr"],
                    s: "[\"Resets in \"+_0]"
                  }
                }, {
                  n: "width",
                  f: "14",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "14",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/help-icon.svg"],
                  t: 13
                }]
              }]
            }]
          }, " ", {
            t: 4,
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "credits_data_credits",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "credits_data_credits_header",
                  g: 1
                }],
                f: ["Credits:"]
              }, " ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "credits_data_rate_details",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "credits_data_rate_details_remaining-credits",
                    g: 1
                  }],
                  f: [{
                    t: 2,
                    r: "remainingCredits"
                  }]
                }, " ", {
                  t: 4,
                  f: [{
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "credits_data_rate_details_consumed-credits",
                      g: 1
                    }],
                    f: ["(-", {
                      t: 2,
                      r: "consumedCredits"
                    }, ")"]
                  }],
                  n: 50,
                  r: "consumedCredits"
                }]
              }]
            }],
            n: 50,
            r: "creditsDataPresented"
          }]
        }, " ", {
          t: 7,
          e: "a",
          m: [{
            t: 13,
            n: "class",
            f: "credits_add",
            g: 1
          }, {
            n: "href",
            f: "https://dash.globalping.io?view=add-credits",
            t: 13,
            g: 1
          }, {
            n: "target",
            f: "_blank",
            t: 13,
            g: 1
          }],
          f: ["+ Add Credits"]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "credits_consuming",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "14",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "14",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/alert-icon-alt.svg"],
                t: 13
              }]
            }, " ", {
              t: 7,
              e: "span",
              f: ["Consuming ~", {
                t: 2,
                r: "consumingValue"
              }, " API credits/minute"]
            }]
          }],
          n: 50,
          x: {
            r: ["testInProgress", "isInfiniteModeRes", "consumingValue"],
            s: "_0&&_1&&_2"
          }
        }]
      }],
      n: 50,
      x: {
        r: ["remainingRequests", "availableRequests", "resetsInStr"],
        s: "_0!==null&&_1!==null&&_2!==null"
      }
    }]
  }],
  e: {
    "[\"Resets in \"+_0]": function (_0) {
      return ["Resets in " + _0];
    },
    "_0&&_1&&_2": function (_0, _1, _2) {
      return _0 && _1 && _2;
    },
    "_0!==null&&_1!==null&&_2!==null": function (_0, _1, _2) {
      return _0 !== null && _1 !== null && _2 !== null;
    }
  }
};
var credits$1 = ractive.extend(component$D.exports);

var component$C = {
  exports: {}
};
component$C.exports = {
  data() {
    return {
      message: null
    };
  },
  oninit() {
    if (!ractive.isServer) {
      this.observe('rateCreditsData measurementErrMsg', () => {
        let rateCreditsData = this.get('rateCreditsData');
        let measurementErrMsg = this.get('measurementErrMsg');
        if (measurementErrMsg) {
          this.set('message', measurementErrMsg);
          return;
        }
        if (rateCreditsData) {
          let message;
          let hasToken = this.get('@shared.user');
          let resetsInPart = this.createResetInStr(rateCreditsData['x-ratelimit-reset']);
          if (hasToken) {
            message = this.createTokenCaseMsg(resetsInPart);
          } else {
            message = this.createNoTokenCaseMsg(resetsInPart);
          }
          this.set('message', message);
        }
      });
    }
  },
  oncomplete() {
    let el = document.querySelector('.c-gp-credits-message');
    setTimeout(() => {
      el.classList.add('show-msg');
    }, 200);
  },
  createResetInStr(seconds) {
    let minutes = seconds / 60;
    if (minutes < 1) {
      return '< 1 minute';
    }
    return `${Math.ceil(minutes)} minutes`;
  },
  createNoTokenCaseMsg(resetPart) {
    return `You have run out of credits for this session. You can wait ${resetPart} for the limit to reset or get higher limits by creating an account.`;
  },
  createTokenCaseMsg(resetPart) {
    return `You have run out of credits for this session. You can wait ${resetPart} for the limit to reset or get higher limits by sponsoring us or hosting probes.`;
  }
};
component$C.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-gp-credits-message",
      g: 1
    }],
    f: [{
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "msg-wrapper",
          g: 1
        }],
        f: [{
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "msg-wrapper_msg",
            g: 1
          }],
          f: [{
            t: 2,
            r: "message"
          }]
        }, " ", {
          t: 7,
          e: "a",
          m: [{
            t: 13,
            n: "class",
            f: "msg-wrapper_sign-up",
            g: 1
          }, {
            n: "href",
            f: "https://globalping.io?view=add-credits",
            t: 13,
            g: 1
          }],
          f: ["Sign up"]
        }]
      }],
      n: 50,
      r: "message"
    }]
  }]
};
var creditsMessage = ractive.extend(component$C.exports);

var clipboard = (node, title = 'Copy to Clipboard', tooltipPlacement = 'top', nodeSelector) => {
  let clipboard = new ClipboardJS(node);
  let $node = nodeSelector ? $(node).parents(nodeSelector).first() : $(node);
  let tooltipOptions = {
    title,
    placement: tooltipPlacement,
    trigger: 'hover',
    container: 'body',
    animation: false
  };
  function onDocumentClick(e) {
    if (e.srcElement !== $node[0] && !$(e.srcElement).closest($node[0]).length) {
      setDefaultTooltip();
    }
  }
  function setDefaultTooltip() {
    $node.tooltip('destroy').tooltip(tooltipOptions);
  }
  setDefaultTooltip();
  document.addEventListener('click', onDocumentClick);
  clipboard.on('success', () => {
    $node.tooltip('destroy').tooltip(Object.assign({}, tooltipOptions, {
      trigger: 'manual',
      title: 'Copied!'
    })).tooltip('show');
    setTimeout(setDefaultTooltip, 1000);
  });
  clipboard.on('error', () => {
    $node.tooltip('destroy').tooltip(Object.assign({}, tooltipOptions, {
      trigger: 'manual',
      title: 'Press Ctrl+C to copy'
    })).tooltip('show');
    setTimeout(setDefaultTooltip, 1000);
  });
  return {
    teardown: () => {
      document.removeEventListener('click', onDocumentClick);
    }
  };
};

var component$B = {
  exports: {}
};
const PROBE_STATUS_OFFLINE$4 = _.getProbeStatusOfflineValue();
const {
  addManagedListener
} = listeners;
component$B.exports = {
  decorators: {
    clipboard
  },
  data() {
    return {
      shareResMsg: '',
      markdownResults: '',
      measurementLink: '',
      cliCommand: '',
      showMarkdownResults: false,
      showLogoDevAttribution: false
    };
  },
  onrender() {
    if (!ractive.isServer) {
      addManagedListener(this, window, 'historyChange', this.createMeasLink.bind(this));

      // select all share-res text of link on click
      this.observe('testInProgress', testInProgress => {
        if (!testInProgress) {
          let shareResTextEl = this.find('#share-res-text');
          shareResTextEl.addEventListener('click', () => {
            window.getSelection().selectAllChildren(shareResTextEl);
          });
        }
      }, {
        defer: true
      });
      this.observe('isInfiniteModeRes measurementsMetadata', () => {
        this.createMeasLink();
      });
      this.observe('isInfiniteModeRes measurementsMetadata testReqParams', () => {
        this.createCliCommand();
      });
      this.observe('preparedTestResults testReqParams measurementsMetadata measurementLink', () => {
        this.createMarkdownResults();
      });
    }
  },
  createMeasLink() {
    let measurementsMetadata = this.get('measurementsMetadata');
    let isInfiniteModeRes = this.get('isInfiniteModeRes');
    let origin = this.get('@global.location.origin');
    // regular measurement IDs should be separated by a comma
    let idsDelimiter = ',';
    let measIDsArr = Object.values(measurementsMetadata).map(v => v.measurementId);
    let preparedMeasIDsArr = measIDsArr;
    this.set('shareResMsg', '');
    if (isInfiniteModeRes) {
      // the infinite one by a dot
      idsDelimiter = '.';

      // for infinite get last 10 IDs from oldest to newest
      preparedMeasIDsArr = measIDsArr.slice(-10);

      // show related message for such case
      if (measIDsArr.length >= 10) {
        this.set('shareResMsg', 'For long-running continuous mode measurements, only the last 160 packets are shared via URL.');
      }
    }
    let textToCopy = preparedMeasIDsArr.join(idsDelimiter);
    let urlSearchParams = new URLSearchParams(location.search);
    urlSearchParams.set('measurement', textToCopy);
    this.set('measurementLink', `${origin}?${urlSearchParams.toString()}`);
  },
  createCliCommand() {
    let params = this.get('testReqParams');
    let measurementsMetadata = this.get('measurementsMetadata');
    let targetsCnt = Object.values(measurementsMetadata).map(v => v.target).length;
    let isInfiniteModeRes = this.get('isInfiniteModeRes');
    if (targetsCnt >= 2 && !isInfiniteModeRes) {
      this.set('cliCommand', 'Not supported yet');
      return;
    }
    let cmd = Object.keys(params).reduce((cmd, key) => {
      // test type part
      if (key === 'type') {
        cmd.typePart += ` ${params[key]} ${params.target}`;
        if (params.locations && params.locations.length) {
          let locationStr = params.locations.reduce((str, loc, idx) => {
            let locPart = loc.magic.trim();
            if (idx === 0) {
              return str += locPart;
            }
            return str += `, ${locPart}`;
          }, '');
          cmd.typePart += ` from ${locationStr}`;
        }
        if (params.measurementOptions) {
          let str = Object.keys(params.measurementOptions).reduce((str, key) => {
            switch (key) {
              case 'packets':
                if (!isInfiniteModeRes) {
                  str += ` --packets ${params.measurementOptions.packets}`;
                }
                break;
              case 'port':
                str += ` --port ${params.measurementOptions.port}`;
                break;
              case 'protocol':
                str += ` --protocol ${params.measurementOptions.protocol}`;
                break;
              case 'type':
                str += ` --type ${params.measurementOptions.type}`;
                break;
              case 'trace':
                if (params.type.toLowerCase() === 'dns' && params.measurementOptions.trace) {
                  str += ' --trace';
                }
                break;
              case 'resolver':
                str += ` --resolver ${params.measurementOptions.resolver}`;
                break;
              case 'request':
                if (params.measurementOptions.request.host) {
                  str += ` --host ${params.measurementOptions.request.host}`;
                }
                if (params.measurementOptions.request.path) {
                  let path = params.measurementOptions.request.path;
                  path = path[0] === '/' ? path : `/${path}`;
                  str += ` --path '${path}'`;
                }
                if (params.measurementOptions.request.query) {
                  str += ` --query '${params.measurementOptions.request.query}'`;
                }
                if (params.measurementOptions.request.method) {
                  str += ` --method ${params.measurementOptions.request.method}`;
                }
                break;
            }
            return str;
          }, '');
          cmd.typePart += str;
        }
      }

      // global flags part
      if (key === 'limit') {
        cmd.globalPart += ` --limit ${params[key]}`;
      }
      return cmd;
    }, {
      base: 'globalping',
      typePart: '',
      globalPart: ''
    });

    // add infinite flag for the Infinite flow
    if (isInfiniteModeRes) {
      cmd.globalPart += ' --infinite';
    }
    this.set('cliCommand', cmd.base + cmd.typePart + cmd.globalPart);
  },
  createMarkdownResults() {
    let results = this.get('preparedTestResults');
    let testReqParams = this.get('testReqParams');
    let measurementsMetadata = this.get('measurementsMetadata');
    this.set('showMarkdownResults', false);

    // create result title consisting of the test type and locations
    let locationStr = testReqParams.locations.map(location => Object.values(location).join('+').trim()).join(', ');
    let testMethod = testReqParams.measurementOptions?.request?.method;
    let dnsTestType = testReqParams.measurementOptions?.query?.type;
    let extraTestInfo = testMethod || dnsTestType;
    let testType = testReqParams.type.toUpperCase();
    let testStr = `${testType}${extraTestInfo ? ` (${extraTestInfo})` : ''}`;
    let resultTitle = `## Globalping: \`${testStr}\` from ${locationStr}\n`;

    // create markdown for each target
    let targetStrings = [];
    let targetNames = Array.from(new Set(Object.values(measurementsMetadata).map(m => m.target)));
    for (let targetIdx = 0; targetIdx < targetNames.length; ++targetIdx) {
      // add target header and iterate over each result (probe)
      let currentTarget = targetNames[targetIdx];
      let targetHeader = `### Target: ${currentTarget}\n\n`;
      let perProbe = results.map(probeStats => {
        let targetStats = probeStats.statsPerTarget.find(measurement => measurement.target === currentTarget);
        if (!targetStats) {
          return '';
        }

        // HEADER
        let header = `#### ${probeStats.city}, ${probeStats.country}, ${probeStats.continent} - ${probeStats.network} (AS${probeStats.asn})\n`;

        // SUBHEADER (timing etc.)
        let subheaderParts = [];
        let timing = _.getGpTargetTiming(targetStats);
        if (timing) {
          subheaderParts.push({
            title: 'Time',
            value: timing
          });
        }
        if (!targetStats.isFailed && targetStats.avgTiming !== PROBE_STATUS_OFFLINE$4 && targetStats.extraValues) {
          Object.keys(targetStats.extraValues).forEach(key => {
            let extraVal = targetStats.extraValues[key];
            subheaderParts.push({
              title: extraVal.text,
              value: `${extraVal.value}${extraVal.units}`
            });
          });
        }
        if (testReqParams.type === 'http' && targetStats.ipAddr) {
          subheaderParts.push({
            title: 'Resolved address',
            value: targetStats.ipAddr
          });
        }
        let subheader = subheaderParts.map(({
          title,
          value
        }) => `${title}: \`${value}\``).join('&nbsp;&nbsp;&nbsp;');
        if (subheader) {
          subheader += '\n';
        }

        // RAW OUTPUT
        let responseBody = targetStats.responseBody ? `\n\n${targetStats.responseBody}` : '';
        let rawOutputContent = ((targetStats.rawOutput ?? '') + responseBody).trim();
        let tickCount = 3;
        for (let tickSequence of rawOutputContent.matchAll(/`+/g)) {
          tickCount = Math.max(tickCount, tickSequence[0].length + 1);
        }
        let tickWrapper = '`'.repeat(tickCount);
        let rawOutputBlock = `${tickWrapper}\n${rawOutputContent}\n${tickWrapper}`;
        let hasContent = !!subheader || !!rawOutputContent;

        // COMPLETE THE STRING
        return hasContent ? `${header}${subheader}${rawOutputBlock}` : '';
      }).filter(Boolean).join('\n\n');
      if (perProbe) {
        this.set('showMarkdownResults', true);
        targetStrings.push(targetHeader + perProbe);
      }
    }
    let targetStr = targetStrings.join('\n\n---\n\n');
    let link = this.get('measurementLink');
    let footer = link ? `\n\nYou can also view the results at ${link}\n` : '';
    this.set('markdownResults', resultTitle + targetStr + footer);
  }
};
component$B.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-gp-results-share",
      g: 1
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "c-gp-results-share_content",
        g: 1
      }],
      f: [{
        t: 7,
        e: "button",
        m: [{
          n: "clipboard",
          t: 71
        }, {
          n: "data-clipboard-text",
          f: [{
            t: 2,
            r: "measurementLink"
          }],
          t: 13
        }],
        f: [{
          t: 7,
          e: "img",
          m: [{
            n: "width",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "height",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/img/url-icon.svg"],
            t: 13
          }]
        }, " Copy URL"]
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "button",
          m: [{
            n: "clipboard",
            t: 71
          }, {
            n: "data-clipboard-text",
            f: [{
              t: 2,
              r: "markdownResults"
            }],
            t: 13
          }],
          f: [{
            t: 7,
            e: "img",
            m: [{
              n: "width",
              f: "20",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "20",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/markdown-icon.svg"],
              t: 13
            }]
          }, " Copy Markdown"]
        }],
        n: 50,
        r: "showMarkdownResults"
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "c-gp-results-share_content_command",
          g: 1
        }],
        f: [{
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "c-gp-results-share_content_command_label",
            g: 1
          }],
          f: [{
            t: 7,
            e: "i",
            m: [{
              t: 13,
              n: "class",
              f: "fa fa-terminal",
              g: 1
            }, {
              n: "aria-hidden",
              f: "true",
              t: 13,
              g: 1
            }]
          }, " ", {
            t: 7,
            e: "span",
            f: ["Replicate in CLI"]
          }]
        }, " ", {
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "c-gp-results-share_content_command_value",
            g: 1
          }, {
            n: "id",
            f: "share-res-text",
            t: 13,
            g: 1
          }],
          f: [{
            t: 2,
            r: "cliCommand"
          }]
        }, " ", {
          t: 7,
          e: "button",
          m: [{
            n: "clipboard",
            t: 71
          }, {
            n: "data-clipboard-text",
            f: [{
              t: 2,
              r: "cliCommand"
            }],
            t: 13
          }],
          f: [{
            t: 7,
            e: "img",
            m: [{
              n: "width",
              f: "20",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "20",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/copy-icon-black.svg"],
              t: 13
            }]
          }]
        }]
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "c-gp-results-share_warning",
          g: 1
        }],
        f: [{
          t: 2,
          r: "shareResMsg"
        }]
      }],
      n: 50,
      r: "shareResMsg"
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "a",
        m: [{
          t: 13,
          n: "class",
          f: "c-gp-results-share_logo-dev",
          g: 1
        }, {
          n: "href",
          f: "https://logo.dev",
          t: 13,
          g: 1
        }, {
          n: "target",
          f: "_blank",
          t: 13,
          g: 1
        }, {
          n: "rel",
          f: "noopener noreferrer",
          t: 13,
          g: 1
        }],
        f: ["Network logos provided by Logo.dev"]
      }],
      n: 50,
      r: "showLogoDevAttribution"
    }]
  }]
};
var resultsShare = ractive.extend(component$B.exports);

var component$A = {
  exports: {}
};
component$A.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-placeholder-skeleton",
      g: 1
    }],
    f: [{
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "skeleton-header",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "skeleton_animated",
            g: 1
          }]
        }]
      }],
      n: 50,
      x: {
        r: ["type"],
        s: "_0===\"header\""
      }
    }, {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "skeleton-subheader",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "skeleton-subheader_content-wrapper",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "skeleton_animated",
              g: 1
            }]
          }]
        }]
      }, " "],
      n: 50,
      x: {
        r: ["type"],
        s: "_0===\"subheader\""
      },
      l: 1
    }, {
      t: 4,
      f: [" ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "skeleton-descr",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "skeleton_animated",
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "skeleton_animated",
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "skeleton_animated",
            g: 1
          }]
        }]
      }, " "],
      n: 50,
      x: {
        r: ["type"],
        s: "_0===\"descr\""
      },
      l: 1
    }, {
      t: 4,
      f: [" ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "skeleton-list",
          g: 1
        }],
        f: [{
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "skeleton-list_content-wrapper",
              g: 1
            }],
            f: [{
              t: 7,
              e: "li",
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "skeleton_animated",
                  g: 1
                }]
              }]
            }]
          }],
          n: 52,
          r: "content"
        }]
      }],
      n: 50,
      x: {
        r: ["type"],
        s: "_0===\"list\""
      },
      l: 1
    }]
  }],
  e: {
    "_0===\"header\"": function (_0) {
      return _0 === "header";
    },
    "_0===\"subheader\"": function (_0) {
      return _0 === "subheader";
    },
    "_0===\"descr\"": function (_0) {
      return _0 === "descr";
    },
    "_0===\"list\"": function (_0) {
      return _0 === "list";
    }
  }
};
var placeholderSkeleton = ractive.extend(component$A.exports);

var component$z = {
  exports: {}
};
const PROBE_MAX_TIMING = 200;
const PROBE_MIN_TIMING = 5;
const PROBE_NO_TIMING_VALUE$3 = _.getProbeTimeOutValue();
const PROBE_OFFLINE_TEXT$1 = 'Probe offline';
const PROBE_FAILED_TEXT = 'Probe failed';
component$z.exports = {
  decorators: {
    tooltip
  },
  data() {
    return {
      _,
      loadingProbeResults: [],
      targets: [],
      PROBE_NO_TIMING_VALUE: PROBE_NO_TIMING_VALUE$3,
      PROBE_OFFLINE_TEXT: PROBE_OFFLINE_TEXT$1,
      PROBE_FAILED_TEXT,
      splitIPv6(address) {
        let segments = address.split(':');
        if (segments.filter(Boolean).length <= 4) {
          return [address];
        }
        let splitAt = segments[3] ? 4 : 3;
        return [segments.slice(0, splitAt).join(':'), ':' + segments.slice(splitAt).join(':')];
      },
      chartMaxHeight: 0,
      sortBy: 'location',
      sortOrder: 'asc',
      floatingSetLocationButton: {
        visible: false,
        top: 0,
        left: 0,
        height: 0,
        buttonTop: 0,
        probeData: null
      },
      itemFocused: false,
      justFocusedItem: false
    };
  },
  onrender() {
    if (!ractive.isServer) {
      this.observe('preparedTestResults', () => {
        let preparedTestResults = this.get('preparedTestResults') || [];
        if (!preparedTestResults.length) {
          return;
        }
        this.setChartMaxHeight(preparedTestResults);
      });
      this.observe('sortOrder sortBy', () => {
        let listWrapperEl = this.find('.results-table-wrapper');
        if (listWrapperEl) {
          listWrapperEl.scrollTop = 0;
        }
      }, {
        init: false
      });
      this._onSetLocationViewportChange = event => {
        this.hideSetLocationButton(event);
      };
      listeners.addManagedListener(this, window, 'resize', this._onSetLocationViewportChange);
      listeners.addManagedListener(this, window, 'scroll', this._onSetLocationViewportChange);
    }
  },
  // --- set location button logic ---
  isSetLocationFocusActive(setLocationButton) {
    let activeElement = document.activeElement;
    return setLocationButton && setLocationButton.contains(activeElement) || activeElement?.classList.contains('results-table_row');
  },
  showSetLocationButton(clientSideId) {
    let probeData = this.get('preparedTestResults').find(item => item.clientSideId === clientSideId);
    let rowNode = document.querySelector(`.item-id-${clientSideId}`);
    let rowLocation = rowNode?.querySelector('.results-table_row_location');
    let container = this.find('.c-gp-results-table-output');
    let listContainer = this.find('.results-table-wrapper');
    this.set('itemFocused', false);
    if (!rowNode || !rowLocation || !container || !listContainer) {
      return;
    }
    let listRect = listContainer.getBoundingClientRect();
    let rowLocationRect = rowLocation.getBoundingClientRect();
    let visibilityOverflowTolerancePx = 15;
    let isRowLocationVisible = rowLocationRect.top >= listRect.top - visibilityOverflowTolerancePx && rowLocationRect.bottom <= listRect.bottom + visibilityOverflowTolerancePx;
    if (!isRowLocationVisible) {
      this.set('floatingSetLocationButton.visible', false);
      return;
    }
    let rowRect = rowNode.getBoundingClientRect();
    let containerRect = container.getBoundingClientRect();
    let relativeTop = rowRect.top - containerRect.top;
    let relativeLeft = rowLocationRect.left - containerRect.left;
    this.set('floatingSetLocationButton', {
      visible: true,
      probeData,
      top: relativeTop,
      left: relativeLeft - 26,
      height: rowRect.height,
      buttonTop: rowLocationRect.top - rowRect.top + rowLocationRect.height / 2 - 13
    });
  },
  hideSetLocationButton(event) {
    if (this.get('justFocusedItem')) {
      if (event?.type !== 'scroll') {
        this.set('justFocusedItem', false);
      }
      return;
    }
    if (event?.type === 'scroll') {
      this.set('floatingSetLocationButton.visible', false);
      this.set('itemFocused', false);
      return;
    }
    if (!this.get('floatingSetLocationButton.visible') && !this.get('itemFocused')) {
      return;
    }
    let setLocationButton = this.find('.c-gp-results-table-output_set-location');
    let setLocationHitarea = this.find('.c-gp-results-table-output_set-location-hitarea');
    if (event?.type === 'blur' && !event.relatedTarget) {
      requestAnimationFrame(() => {
        this.hideSetLocationButton();
      });
      return;
    }
    if (this.isSetLocationFocusActive(setLocationButton)) {
      return;
    }
    if (event?.type === 'blur' && setLocationButton?.contains(event.relatedTarget)) {
      return;
    }
    if (event && event.relatedTarget && event.type !== 'blur') {
      let container = event.target.closest('.results-table_row');
      let relatedContainer = event.relatedTarget.closest?.('.results-table_row');
      if (container && container.contains(event.relatedTarget) || relatedContainer || setLocationHitarea && setLocationHitarea.contains(event.relatedTarget)) {
        return;
      }
    }
    this.set('floatingSetLocationButton.visible', false);
    this.set('itemFocused', false);
  },
  setProbeAsLocation(probeData = this.get('floatingSetLocationButton.probeData')) {
    if (!probeData) {
      return;
    }
    this.set('currSearchLocation', `AS${probeData.asn}+${probeData.city}`);
    this.set('floatingSetLocationButton.visible', false);
  },
  enableItemFocused(event, clientSideId) {
    if (!event.target?.classList.contains('results-table_row')) {
      return;
    }
    this.showSetLocationButton(clientSideId);
    this.set('itemFocused', true);
    this.set('justFocusedItem', true);
    requestAnimationFrame(() => {
      this.set('justFocusedItem', false);
    });
  },
  headerKeydownHandler(event, clientSideId) {
    if (!event.target?.classList.contains('results-table_row')) {
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      let probeData = this.get('preparedTestResults').find(item => item.clientSideId === clientSideId);
      this.setProbeAsLocation(probeData);
    }
  },
  setChartMaxHeight(results) {
    let allPacketRtt = results.map(test => Array.isArray(test.statsPerTarget) ? test.statsPerTarget.map(target => target.packetsRtt).flat() : []).flat();
    this.set('chartMaxHeight', Math.max(...allPacketRtt.filter(v => typeof v === 'number')));
  },
  createRealTimeGraph(data, svgWidth = 48, svgHeight = 24, svgBgColor = '#F4F4F4', barWidth = 2, gap = 1) {
    let maxValue = this.get('chartMaxHeight');
    if (!data || maxValue === 0) {
      return;
    }
    let maxBars = Math.floor(svgWidth / (barWidth + gap));
    let startIndex = Math.max(data.length - maxBars, 0);
    let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', svgWidth);
    svg.setAttribute('height', svgHeight);
    svg.style.backgroundColor = svgBgColor;
    for (let i = startIndex; i < data.length; i++) {
      let percentage = data[i] === maxValue || data[i] === PROBE_NO_TIMING_VALUE$3 ? 1 : data[i] / maxValue;
      let barHeight = percentage * svgHeight;
      let x = svgWidth - (data.length - 1 - i) * (barWidth + gap) - barWidth;
      let y = svgHeight - barHeight;
      if (x >= 0) {
        let rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        rect.setAttribute('x', x);
        rect.setAttribute('y', y);
        rect.setAttribute('width', barWidth);
        rect.setAttribute('height', barHeight);
        rect.setAttribute('fill', this.pickBarColor(data[i]));
        svg.appendChild(rect);
      }
    }
    return svg.outerHTML;
  },
  createRegularGraph(data, svgWidth = 48, svgHeight = 24, svgBgColor = '#F4F4F4') {
    let maxValue = this.get('chartMaxHeight');
    if (!data || data.length === 0 || maxValue === 0) {
      return;
    }
    data = data.slice(-20);
    let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    let numBars = data.length;
    let spaceWidth = 1;
    let barWidth = Math.round(svgWidth / numBars - spaceWidth);
    let actualWidth = barWidth * numBars + (numBars - 1) * spaceWidth;
    svg.setAttribute('width', actualWidth > svgWidth ? actualWidth : svgWidth);
    svg.setAttribute('height', svgHeight);
    svg.style.backgroundColor = svgBgColor;
    data.forEach((value, index) => {
      let barHeight = value === PROBE_NO_TIMING_VALUE$3 ? svgHeight : value / maxValue * svgHeight;
      let xPosition = index * spaceWidth + index * barWidth;
      let rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      rect.setAttribute('x', xPosition);
      rect.setAttribute('y', svgHeight - barHeight);
      rect.setAttribute('width', barWidth);
      rect.setAttribute('height', barHeight);
      rect.setAttribute('fill', this.pickBarColor(value));
      svg.appendChild(rect);
    });
    return svg.outerHTML;
  },
  pickBarColor(timing) {
    // return default color for timed out probe
    if (timing === PROBE_NO_TIMING_VALUE$3) {
      return '#17233A';
    }
    function getColorFromGradient(quotient, start, middle, end) {
      return quotient >= 0.5 ? linear(middle, end, (quotient - 0.5) * 2) : linear(start, middle, quotient * 2);
    }
    function linear(startColor, endColor, quotient) {
      let redColor = byteLinear(startColor[1] + startColor[2], endColor[1] + endColor[2], quotient);
      let greenColor = byteLinear(startColor[3] + startColor[4], endColor[3] + endColor[4], quotient);
      let blueColor = byteLinear(startColor[5] + startColor[6], endColor[5] + endColor[6], quotient);
      return `#${redColor}${greenColor}${blueColor}`;
    }
    function byteLinear(partOne, partTwo, quotient) {
      let color = Math.floor(('0x' + partOne) * (1 - quotient) + ('0x' + partTwo) * quotient);
      return color.toString(16).padStart(2, '0');
    }
    let pureTimingValue = parseInt(timing);

    // '#17d4a7', '#ffb800', '#e64e3d' - colors are used for timings scale on the map
    if (pureTimingValue <= PROBE_MIN_TIMING) {
      return '#17d4a7';
    }
    if (pureTimingValue >= PROBE_MAX_TIMING) {
      return '#e64e3d';
    }
    return getColorFromGradient(pureTimingValue / PROBE_MAX_TIMING, '#17d4a7', '#ffb800', '#e64e3d');
  },
  calcQuality(statsTotal, statsDrop) {
    if (typeof statsTotal === 'undefined' || typeof statsDrop === 'undefined' || statsTotal === 0) {
      return {
        qualityPercentage: null,
        actualAmount: null
      };
    }
    let actualAmount = Math.max(statsTotal - statsDrop, 0);
    let qualityPercentage = Math.round(actualAmount / statsTotal * 100);
    return {
      qualityPercentage,
      actualAmount
    };
  },
  createGraph(packetsRtt) {
    let isInfiniteModeRes = this.get('isInfiniteModeRes');
    let memoizedCreateGraph;
    if (isInfiniteModeRes) {
      memoizedCreateGraph = _.memoize(this.createRealTimeGraph.bind(this));
    } else {
      memoizedCreateGraph = _.memoize(this.createRegularGraph.bind(this));
    }
    return memoizedCreateGraph(packetsRtt);
  },
  formatTimingValue(value) {
    if (typeof value !== 'number' || isNaN(value)) {
      return value;
    }
    if (value < 10) {
      return value.toFixed(2);
    } else if (value < 100) {
      return value.toFixed(1);
    }
    return Math.round(value);
  },
  onSortClick(field) {
    if (field === this.get('sortBy')) {
      this.set('sortOrder', this.get('sortOrder') === 'asc' ? 'desc' : 'asc');
    } else {
      this.set('sortBy', field);
      this.set('sortOrder', 'asc');
    }
  },
  toggleSortOrder() {
    this.set('sortOrder', this.get('sortOrder') === 'asc' ? 'desc' : 'asc');
  },
  getSortIcon(field) {
    if (field === this.get('sortBy')) {
      return `sort-${this.get('sortOrder')}-sm.svg`;
    }
    return 'sort-none.svg';
  }
};
component$z.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-gp-results-table-output",
      g: 1
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "results-table-wrapper",
        g: 1
      }, {
        n: ["scroll"],
        t: 70,
        f: {
          r: ["@this", "@event"],
          s: "[_0.hideSetLocationButton(_1)]"
        }
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          n: "class",
          f: ["results-table ", {
            t: 4,
            f: ["single-target"],
            n: 50,
            x: {
              r: ["targetsCnt"],
              s: "_0===1"
            }
          }],
          t: 13
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "results-table_header",
            g: 1
          }],
          f: [{
            t: 7,
            e: "button",
            m: [{
              t: 13,
              n: "class",
              f: "results-table_header_cell location",
              g: 1
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this"],
                s: "[_0.onSortClick(\"location\")]"
              }
            }],
            f: ["Location ", {
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "8",
                t: 13,
                g: 1
              }, {
                n: "alt",
                f: "",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/", {
                  t: 2,
                  x: {
                    r: ["@this"],
                    s: "_0.getSortIcon(\"location\")"
                  }
                }],
                t: 13
              }]
            }]
          }, " ", {
            t: 4,
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "results-table_header_cell targets",
                g: 1
              }]
            }],
            n: 50,
            x: {
              r: ["targetsCnt"],
              s: "_0>1"
            }
          }, " ", {
            t: 7,
            e: "button",
            m: [{
              t: 13,
              n: "class",
              f: "results-table_header_cell quality",
              g: 1
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this"],
                s: "[_0.onSortClick(\"quality\")]"
              }
            }],
            f: ["Quality ", {
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "8",
                t: 13,
                g: 1
              }, {
                n: "alt",
                f: "",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/", {
                  t: 2,
                  x: {
                    r: ["@this"],
                    s: "_0.getSortIcon(\"quality\")"
                  }
                }],
                t: 13
              }]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "results-table_header_cell rtt",
              g: 1
            }],
            f: [{
              t: 7,
              e: "button",
              m: [{
                t: 13,
                n: "class",
                f: "rtt_text",
                g: 1
              }, {
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this"],
                  s: "[_0.onSortClick(\"rtt-last\")]"
                }
              }],
              f: ["rtt last ", {
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "8",
                  t: 13,
                  g: 1
                }, {
                  n: "alt",
                  f: "",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/", {
                    t: 2,
                    x: {
                      r: ["@this"],
                      s: "_0.getSortIcon(\"rtt-last\")"
                    }
                  }],
                  t: 13
                }]
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "rtt_separator",
                g: 1
              }],
              f: ["/"]
            }, " ", {
              t: 7,
              e: "button",
              m: [{
                t: 13,
                n: "class",
                f: "rtt_text",
                g: 1
              }, {
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this"],
                  s: "[_0.onSortClick(\"min\")]"
                }
              }],
              f: ["min ", {
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "8",
                  t: 13,
                  g: 1
                }, {
                  n: "alt",
                  f: "",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/", {
                    t: 2,
                    x: {
                      r: ["@this"],
                      s: "_0.getSortIcon(\"min\")"
                    }
                  }],
                  t: 13
                }]
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "rtt_separator",
                g: 1
              }],
              f: ["/"]
            }, " ", {
              t: 7,
              e: "button",
              m: [{
                t: 13,
                n: "class",
                f: "rtt_text",
                g: 1
              }, {
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this"],
                  s: "[_0.onSortClick(\"avg\")]"
                }
              }],
              f: ["avg ", {
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "8",
                  t: 13,
                  g: 1
                }, {
                  n: "alt",
                  f: "",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/", {
                    t: 2,
                    x: {
                      r: ["@this"],
                      s: "_0.getSortIcon(\"avg\")"
                    }
                  }],
                  t: 13
                }]
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "rtt_separator",
                g: 1
              }],
              f: ["/"]
            }, " ", {
              t: 7,
              e: "button",
              m: [{
                t: 13,
                n: "class",
                f: "rtt_text",
                g: 1
              }, {
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this"],
                  s: "[_0.onSortClick(\"max\")]"
                }
              }],
              f: ["max ", {
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "8",
                  t: 13,
                  g: 1
                }, {
                  n: "alt",
                  f: "",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/", {
                    t: 2,
                    x: {
                      r: ["@this"],
                      s: "_0.getSortIcon(\"max\")"
                    }
                  }],
                  t: 13
                }]
              }]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "results-table_header_cell ip",
              g: 1
            }],
            f: ["Resolved IP"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "results-table_header_cell graph",
              g: 1
            }],
            f: ["Graph"]
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              n: "class",
              f: ["results-table_row row-num-", {
                t: 2,
                r: "./clientSideId"
              }, " item-id-", {
                t: 2,
                r: "./clientSideId"
              }],
              t: 13
            }, {
              n: "tabindex",
              f: "0",
              t: 13,
              g: 1
            }, {
              n: "role",
              f: "button",
              t: 13,
              g: 1
            }, {
              n: "aria-label",
              f: "Set as location for the next test",
              t: 13,
              g: 1
            }, {
              n: ["focus"],
              t: 70,
              f: {
                r: ["@this", "@event", "./clientSideId"],
                s: "[_0.enableItemFocused(_1,_2)]"
              }
            }, {
              n: ["blur"],
              t: 70,
              f: {
                r: ["@this", "@event"],
                s: "[_0.hideSetLocationButton(_1)]"
              }
            }, {
              n: ["keydown"],
              t: 70,
              f: {
                r: ["@this", "@event", "./clientSideId"],
                s: "[_0.headerKeydownHandler(_1,_2)]"
              }
            }, {
              n: ["mouseenter"],
              t: 70,
              f: {
                r: ["@this", "./clientSideId"],
                s: "[_0.showSetLocationButton(_1)]"
              }
            }, {
              n: ["mouseleave"],
              t: 70,
              f: {
                r: ["@this", "@event"],
                s: "[_0.hideSetLocationButton(_1)]"
              }
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "results-table_row_location",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "results-table_row_location_status-line",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "results-table_row_location_status-line_top",
                    g: 1
                  }, {
                    n: "style",
                    f: ["background-color: ", {
                      t: 2,
                      x: {
                        r: ["_", "./statsPerTarget.0.avgTiming"],
                        s: "_0.getGpProbeStatusColor(_1)"
                      }
                    }],
                    t: 13
                  }],
                  f: []
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "results-table_row_location_status-line_bottom",
                    g: 1
                  }, {
                    n: "style",
                    f: ["background-color: ", {
                      t: 2,
                      x: {
                        r: ["_", "./statsPerTarget.1", "./statsPerTarget.1.avgTiming", "./statsPerTarget.0.avgTiming"],
                        s: "_0.getGpProbeStatusColor(_1?_2:_3)"
                      }
                    }],
                    t: 13
                  }],
                  f: []
                }]
              }, " ", {
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "28",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "20",
                  t: 13,
                  g: 1
                }, {
                  n: "alt",
                  f: "",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
                    t: 2,
                    r: "./country"
                  }, ".svg"],
                  t: 13
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "results-table_row_location_data",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  f: [{
                    t: 2,
                    r: "./city"
                  }, ", ", {
                    t: 2,
                    r: "./country"
                  }, ", ", {
                    t: 2,
                    r: "./continent"
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  f: [{
                    t: 2,
                    r: "./network"
                  }]
                }]
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "results-table_row_stats",
                g: 1
              }],
              f: [{
                t: 4,
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "results-table_row_stats_subrow",
                    g: 1
                  }],
                  f: [{
                    t: 4,
                    f: [{
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "results-table_row_stats_subrow_cell targets",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "results-table_row_stats_subrow_cell_value",
                          g: 1
                        }],
                        f: [{
                          t: 4,
                          f: [{
                            t: 7,
                            e: "span",
                            f: [{
                              t: 2,
                              r: "./target"
                            }]
                          }],
                          n: 50,
                          r: "./target"
                        }, {
                          t: 4,
                          f: [{
                            t: 7,
                            e: "c-placeholder-skeleton",
                            m: [{
                              n: "type",
                              f: "subheader",
                              t: 13,
                              g: 1
                            }]
                          }, " "],
                          n: 50,
                          r: "testInProgress",
                          l: 1
                        }, {
                          t: 4,
                          f: [" ", {
                            t: 7,
                            e: "span",
                            f: ["—"]
                          }],
                          n: 51,
                          l: 1
                        }]
                      }]
                    }],
                    n: 50,
                    x: {
                      r: ["targetsCnt"],
                      s: "_0>1"
                    }
                  }, " ", {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "results-table_row_stats_subrow_cell probe-failed",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "span",
                        f: [{
                          t: 2,
                          r: "PROBE_FAILED_TEXT"
                        }]
                      }, " ", {
                        t: 7,
                        e: "div",
                        m: [{
                          n: "tooltip",
                          t: 71,
                          f: {
                            r: ["./failureRawOutput"],
                            s: "[(\"\"+(_0)),\"top\",true]"
                          }
                        }],
                        f: [{
                          t: 7,
                          e: "img",
                          m: [{
                            n: "width",
                            f: "20",
                            t: 13,
                            g: 1
                          }, {
                            n: "height",
                            f: "20",
                            t: 13,
                            g: 1
                          }, {
                            n: "alt",
                            f: "",
                            t: 13,
                            g: 1
                          }, {
                            n: "src",
                            f: [{
                              t: 2,
                              r: "@shared.assetsHost"
                            }, "/img/target-icon.svg"],
                            t: 13
                          }]
                        }]
                      }]
                    }],
                    n: 50,
                    r: "./isFailed"
                  }, {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "results-table_row_stats_subrow_cell probe-offline",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "span",
                        f: [{
                          t: 2,
                          r: "PROBE_OFFLINE_TEXT"
                        }]
                      }]
                    }, " "],
                    n: 50,
                    x: {
                      r: ["./isOffline", "isInfiniteModeRes"],
                      s: "_0&&!_1"
                    },
                    l: 1
                  }, {
                    t: 4,
                    f: [" ", {
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "results-table_row_stats_subrow_cell quality",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "results-table_row_stats_subrow_cell_value",
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "span",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "results-table_row_stats_subrow_cell_value_header",
                            g: 1
                          }],
                          f: ["Quality"]
                        }, " ", {
                          t: 4,
                          f: [{
                            t: 7,
                            e: "span",
                            f: [{
                              t: 2,
                              r: "./qualityStr"
                            }]
                          }],
                          n: 50,
                          r: "./qualityStr"
                        }, {
                          t: 4,
                          f: [{
                            t: 7,
                            e: "c-placeholder-skeleton",
                            m: [{
                              n: "type",
                              f: "subheader",
                              t: 13,
                              g: 1
                            }]
                          }, " "],
                          n: 50,
                          r: "testInProgress",
                          l: 1
                        }, {
                          t: 4,
                          f: [" ", {
                            t: 7,
                            e: "span",
                            f: ["—"]
                          }],
                          n: 51,
                          l: 1
                        }]
                      }]
                    }, " ", {
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "results-table_row_stats_subrow_cell rtt",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "results-table_row_stats_subrow_cell_value",
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "span",
                          m: [{
                            n: "class",
                            f: ["timings ", {
                              t: 4,
                              f: ["no-value"],
                              n: 51,
                              r: "areTimingsReady"
                            }],
                            t: 13
                          }],
                          f: [{
                            t: 7,
                            e: "span",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "timings_header",
                              g: 1
                            }],
                            f: [{
                              t: 7,
                              e: "span",
                              f: ["rtt "]
                            }, " ", {
                              t: 7,
                              e: "span",
                              f: ["last"]
                            }]
                          }, " ", {
                            t: 4,
                            f: [{
                              t: 7,
                              e: "span",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "timings_value",
                                g: 1
                              }],
                              f: [{
                                t: 2,
                                x: {
                                  r: ["@this", "./lastTiming"],
                                  s: "_0.formatTimingValue(_1)"
                                }
                              }, " ", {
                                t: 4,
                                f: [{
                                  t: 7,
                                  e: "span",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "timings_units",
                                    g: 1
                                  }],
                                  f: ["ms"]
                                }],
                                n: 50,
                                x: {
                                  r: ["./lastTiming", "PROBE_NO_TIMING_VALUE"],
                                  s: "_0!==_1"
                                }
                              }]
                            }],
                            n: 50,
                            r: "./areTimingsReady"
                          }, {
                            t: 4,
                            f: [{
                              t: 7,
                              e: "c-placeholder-skeleton",
                              m: [{
                                n: "type",
                                f: "subheader",
                                t: 13,
                                g: 1
                              }]
                            }, " "],
                            n: 50,
                            x: {
                              r: ["./areTimingsReady", "testInProgress"],
                              s: "!_0&&_1"
                            },
                            l: 1
                          }, {
                            t: 4,
                            f: [" ", {
                              t: 7,
                              e: "span",
                              f: ["—"]
                            }],
                            n: 51,
                            l: 1
                          }]
                        }, " ", {
                          t: 7,
                          e: "span",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "timings_separator",
                            g: 1
                          }],
                          f: ["/"]
                        }, " ", {
                          t: 7,
                          e: "span",
                          m: [{
                            n: "class",
                            f: ["timings ", {
                              t: 4,
                              f: ["no-value"],
                              n: 51,
                              r: "areTimingsReady"
                            }],
                            t: 13
                          }],
                          f: [{
                            t: 7,
                            e: "span",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "timings_header",
                              g: 1
                            }],
                            f: [{
                              t: 7,
                              e: "span",
                              f: ["rtt "]
                            }, " ", {
                              t: 7,
                              e: "span",
                              f: ["min"]
                            }]
                          }, " ", {
                            t: 4,
                            f: [{
                              t: 7,
                              e: "span",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "timings_value",
                                g: 1
                              }],
                              f: [{
                                t: 2,
                                x: {
                                  r: ["@this", "./minTiming"],
                                  s: "_0.formatTimingValue(_1)"
                                }
                              }, " ", {
                                t: 4,
                                f: [{
                                  t: 7,
                                  e: "span",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "timings_units",
                                    g: 1
                                  }],
                                  f: ["ms"]
                                }],
                                n: 50,
                                x: {
                                  r: ["./minTiming", "PROBE_NO_TIMING_VALUE"],
                                  s: "_0!==_1"
                                }
                              }]
                            }],
                            n: 50,
                            r: "./areTimingsReady"
                          }, {
                            t: 4,
                            f: [{
                              t: 7,
                              e: "c-placeholder-skeleton",
                              m: [{
                                n: "type",
                                f: "subheader",
                                t: 13,
                                g: 1
                              }]
                            }, " "],
                            n: 50,
                            x: {
                              r: ["./areTimingsReady", "testInProgress"],
                              s: "!_0&&_1"
                            },
                            l: 1
                          }, {
                            t: 4,
                            f: [" ", {
                              t: 7,
                              e: "span",
                              f: ["—"]
                            }],
                            n: 51,
                            l: 1
                          }]
                        }, " ", {
                          t: 7,
                          e: "span",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "timings_separator",
                            g: 1
                          }],
                          f: ["/"]
                        }, " ", {
                          t: 7,
                          e: "span",
                          m: [{
                            n: "class",
                            f: ["timings ", {
                              t: 4,
                              f: ["no-value"],
                              n: 51,
                              r: "areTimingsReady"
                            }],
                            t: 13
                          }],
                          f: [{
                            t: 7,
                            e: "span",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "timings_header",
                              g: 1
                            }],
                            f: [{
                              t: 7,
                              e: "span",
                              f: ["rtt "]
                            }, " ", {
                              t: 7,
                              e: "span",
                              f: ["avg"]
                            }]
                          }, " ", {
                            t: 4,
                            f: [{
                              t: 7,
                              e: "span",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "timings_value",
                                g: 1
                              }],
                              f: [{
                                t: 2,
                                x: {
                                  r: ["@this", "./avgTiming"],
                                  s: "_0.formatTimingValue(_1)"
                                }
                              }, " ", {
                                t: 4,
                                f: [{
                                  t: 7,
                                  e: "span",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "timings_units",
                                    g: 1
                                  }],
                                  f: ["ms"]
                                }],
                                n: 50,
                                x: {
                                  r: ["./avgTiming", "PROBE_NO_TIMING_VALUE"],
                                  s: "_0!==_1"
                                }
                              }]
                            }],
                            n: 50,
                            r: "./areTimingsReady"
                          }, {
                            t: 4,
                            f: [{
                              t: 7,
                              e: "c-placeholder-skeleton",
                              m: [{
                                n: "type",
                                f: "subheader",
                                t: 13,
                                g: 1
                              }]
                            }, " "],
                            n: 50,
                            x: {
                              r: ["./areTimingsReady", "testInProgress"],
                              s: "!_0&&_1"
                            },
                            l: 1
                          }, {
                            t: 4,
                            f: [" ", {
                              t: 7,
                              e: "span",
                              f: ["—"]
                            }],
                            n: 51,
                            l: 1
                          }]
                        }, " ", {
                          t: 7,
                          e: "span",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "timings_separator",
                            g: 1
                          }],
                          f: ["/"]
                        }, " ", {
                          t: 7,
                          e: "span",
                          m: [{
                            n: "class",
                            f: ["timings ", {
                              t: 4,
                              f: ["no-value"],
                              n: 51,
                              r: "areTimingsReady"
                            }],
                            t: 13
                          }],
                          f: [{
                            t: 7,
                            e: "span",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "timings_header",
                              g: 1
                            }],
                            f: [{
                              t: 7,
                              e: "span",
                              f: ["rtt "]
                            }, " ", {
                              t: 7,
                              e: "span",
                              f: ["max"]
                            }]
                          }, " ", {
                            t: 4,
                            f: [{
                              t: 7,
                              e: "span",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "timings_value",
                                g: 1
                              }],
                              f: [{
                                t: 2,
                                x: {
                                  r: ["@this", "./maxTiming"],
                                  s: "_0.formatTimingValue(_1)"
                                }
                              }, " ", {
                                t: 4,
                                f: [{
                                  t: 7,
                                  e: "span",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "timings_units",
                                    g: 1
                                  }],
                                  f: ["ms"]
                                }],
                                n: 50,
                                x: {
                                  r: ["./maxTiming", "PROBE_NO_TIMING_VALUE"],
                                  s: "_0!==_1"
                                }
                              }]
                            }],
                            n: 50,
                            r: "./areTimingsReady"
                          }, {
                            t: 4,
                            f: [{
                              t: 7,
                              e: "c-placeholder-skeleton",
                              m: [{
                                n: "type",
                                f: "subheader",
                                t: 13,
                                g: 1
                              }]
                            }, " "],
                            n: 50,
                            x: {
                              r: ["./areTimingsReady", "testInProgress"],
                              s: "!_0&&_1"
                            },
                            l: 1
                          }, {
                            t: 4,
                            f: [" ", {
                              t: 7,
                              e: "span",
                              f: ["—"]
                            }],
                            n: 51,
                            l: 1
                          }]
                        }, " ", {
                          t: 4,
                          f: [{
                            t: 7,
                            e: "span",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "lg-screen-units",
                              g: 1
                            }],
                            f: ["ms"]
                          }],
                          n: 50,
                          x: {
                            r: ["./areTimingsReady", "./minTiming", "./avgTiming", "./maxTiming", "PROBE_NO_TIMING_VALUE"],
                            s: "_0&&_1!==_4&&_2!==_4&&_3!==_4"
                          }
                        }]
                      }]
                    }, " ", {
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "results-table_row_stats_subrow_cell ip",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "results-table_row_stats_subrow_cell_value",
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "span",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "results-table_row_stats_subrow_cell_value_header",
                            g: 1
                          }],
                          f: [{
                            t: 7,
                            e: "span",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "hidden-xs",
                              g: 1
                            }],
                            f: ["Resolved "]
                          }, "IP"]
                        }, " ", {
                          t: 4,
                          f: [{
                            t: 7,
                            e: "span",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "visible-lg",
                              g: 1
                            }],
                            f: [{
                              t: 9,
                              c: " We break in two lines if the value has more than 4 non-empty groups. "
                            }, " ", {
                              t: 4,
                              f: [{
                                t: 2,
                                r: "."
                              }, {
                                t: 7,
                                e: "br"
                              }],
                              n: 52,
                              x: {
                                r: ["splitIPv6", "ipAddr"],
                                s: "_0(_1)"
                              }
                            }]
                          }, " ", {
                            t: 7,
                            e: "span",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "hidden-lg text-ellipsis",
                              g: 1
                            }],
                            f: [{
                              t: 2,
                              r: "./ipAddr"
                            }]
                          }],
                          n: 50,
                          r: "./ipAddr"
                        }, {
                          t: 4,
                          f: [{
                            t: 7,
                            e: "c-placeholder-skeleton",
                            m: [{
                              n: "type",
                              f: "subheader",
                              t: 13,
                              g: 1
                            }]
                          }, " "],
                          n: 50,
                          x: {
                            r: ["./ipAddr", "testInProgress"],
                            s: "!_0&&_1"
                          },
                          l: 1
                        }, {
                          t: 4,
                          f: [" ", {
                            t: 7,
                            e: "span",
                            f: ["—"]
                          }],
                          n: 51,
                          l: 1
                        }]
                      }]
                    }, " ", {
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "results-table_row_stats_subrow_cell graph",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "results-table_row_stats_subrow_cell_value",
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "span",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "results-table_row_stats_subrow_cell_value_header",
                            g: 1
                          }],
                          f: ["Graph"]
                        }, " ", {
                          t: 4,
                          f: [{
                            t: 7,
                            e: "div",
                            f: [{
                              t: 3,
                              x: {
                                r: ["@this", "./packetsRtt"],
                                s: "_0.createGraph(_1)"
                              }
                            }]
                          }],
                          n: 50,
                          x: {
                            r: ["./packetsRtt", "./packetsRtt.length"],
                            s: "typeof _0!==\"undefined\"&&_1"
                          }
                        }, {
                          t: 4,
                          f: [{
                            t: 7,
                            e: "c-placeholder-skeleton",
                            m: [{
                              n: "type",
                              f: "subheader",
                              t: 13,
                              g: 1
                            }]
                          }, " "],
                          n: 50,
                          x: {
                            r: ["testInProgress"],
                            s: "_0&&_0"
                          },
                          l: 1
                        }, {
                          t: 4,
                          f: [" ", {
                            t: 7,
                            e: "span",
                            f: ["—"]
                          }],
                          n: 51,
                          l: 1
                        }]
                      }]
                    }],
                    n: 51,
                    l: 1
                  }]
                }],
                n: 52,
                r: "./statsPerTarget"
              }]
            }]
          }],
          n: 52,
          r: "preparedTestResults"
        }, " ", {
          t: 4,
          f: [{
            t: 4,
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "results-table_row results-table_row_loading",
                g: 1
              }, {
                n: "aria-hidden",
                f: "true",
                t: 13,
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "results-table_row_location",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "results-table_row_location_status-line",
                    g: 1
                  }]
                }, " ", {
                  t: 7,
                  e: "c-placeholder-skeleton",
                  m: [{
                    n: "type",
                    f: "subheader",
                    t: 13,
                    g: 1
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "results-table_row_stats",
                  g: 1
                }],
                f: [{
                  t: 4,
                  f: [{
                    t: 7,
                    e: "div",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "results-table_row_stats_subrow",
                      g: 1
                    }],
                    f: [{
                      t: 4,
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "results-table_row_stats_subrow_cell targets",
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "div",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "results-table_row_stats_subrow_cell_value",
                            g: 1
                          }],
                          f: [{
                            t: 7,
                            e: "c-placeholder-skeleton",
                            m: [{
                              n: "type",
                              f: "subheader",
                              t: 13,
                              g: 1
                            }]
                          }]
                        }]
                      }],
                      n: 50,
                      x: {
                        r: ["targetsCnt"],
                        s: "_0>1"
                      }
                    }, " ", {
                      t: 4,
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          n: "class",
                          f: ["results-table_row_stats_subrow_cell ", {
                            t: 2,
                            r: "."
                          }],
                          t: 13
                        }],
                        f: [{
                          t: 7,
                          e: "div",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "results-table_row_stats_subrow_cell_value",
                            g: 1
                          }],
                          f: [{
                            t: 7,
                            e: "c-placeholder-skeleton",
                            m: [{
                              n: "type",
                              f: "subheader",
                              t: 13,
                              g: 1
                            }]
                          }]
                        }]
                      }],
                      n: 52,
                      x: {
                        r: [],
                        s: "[\"quality\",\"rtt\",\"ip\",\"graph\"]"
                      }
                    }]
                  }],
                  n: 52,
                  r: "targets"
                }]
              }]
            }],
            n: 52,
            r: "loadingProbeResults"
          }],
          n: 50,
          r: "testInProgress"
        }]
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "c-gp-results-table-output_set-location-hitarea",
          g: 1
        }, {
          n: "style",
          f: ["top: ", {
            t: 2,
            r: "floatingSetLocationButton.top"
          }, "px; left: ", {
            t: 2,
            x: {
              r: ["floatingSetLocationButton.left"],
              s: "_0-4"
            }
          }, "px; height: ", {
            t: 2,
            r: "floatingSetLocationButton.height"
          }, "px;"],
          t: 13
        }, {
          n: ["mouseleave"],
          t: 70,
          f: {
            r: ["@this", "@event"],
            s: "[_0.hideSetLocationButton(_1)]"
          }
        }],
        f: [{
          t: 7,
          e: "button",
          m: [{
            n: "class",
            f: ["c-gp-results-table-output_set-location ", {
              t: 4,
              f: ["focus-outline"],
              n: 50,
              r: "itemFocused"
            }],
            t: 13
          }, {
            n: "type",
            f: "button",
            t: 13,
            g: 1
          }, {
            n: "tabindex",
            f: "-1",
            t: 13,
            g: 1
          }, {
            n: "style",
            f: ["top: ", {
              t: 2,
              r: "floatingSetLocationButton.buttonTop"
            }, "px;"],
            t: 13
          }, {
            n: "tooltip",
            t: 71,
            f: {
              r: [],
              s: "[\"Set as location for the next test\",\"right\"]"
            }
          }, {
            n: ["focus"],
            t: 70,
            f: {
              r: ["@this"],
              s: "[_0.set(\"itemFocused\",true)]"
            }
          }, {
            n: ["blur"],
            t: 70,
            f: {
              r: ["@this", "@event"],
              s: "[_0.hideSetLocationButton(_1)]"
            }
          }, {
            n: ["click"],
            t: 70,
            f: {
              r: ["@this"],
              s: "[_0.setProbeAsLocation()]"
            }
          }, {
            n: "aria-label",
            f: "Set as location for the next test",
            t: 13,
            g: 1
          }],
          f: [{
            t: 7,
            e: "i",
            m: [{
              t: 13,
              n: "class",
              f: "fa fa-map-marker",
              g: 1
            }, {
              n: "aria-hidden",
              f: "true",
              t: 13,
              g: 1
            }]
          }]
        }]
      }],
      n: 50,
      r: "floatingSetLocationButton.visible"
    }]
  }],
  e: {
    "[_0.hideSetLocationButton(_1)]": function (_0, _1) {
      return [_0.hideSetLocationButton(_1)];
    },
    "_0===1": function (_0) {
      return _0 === 1;
    },
    "[_0.onSortClick(\"location\")]": function (_0) {
      return [_0.onSortClick("location")];
    },
    "_0.getSortIcon(\"location\")": function (_0) {
      return _0.getSortIcon("location");
    },
    "_0>1": function (_0) {
      return _0 > 1;
    },
    "[_0.onSortClick(\"quality\")]": function (_0) {
      return [_0.onSortClick("quality")];
    },
    "_0.getSortIcon(\"quality\")": function (_0) {
      return _0.getSortIcon("quality");
    },
    "[_0.onSortClick(\"rtt-last\")]": function (_0) {
      return [_0.onSortClick("rtt-last")];
    },
    "_0.getSortIcon(\"rtt-last\")": function (_0) {
      return _0.getSortIcon("rtt-last");
    },
    "[_0.onSortClick(\"min\")]": function (_0) {
      return [_0.onSortClick("min")];
    },
    "_0.getSortIcon(\"min\")": function (_0) {
      return _0.getSortIcon("min");
    },
    "[_0.onSortClick(\"avg\")]": function (_0) {
      return [_0.onSortClick("avg")];
    },
    "_0.getSortIcon(\"avg\")": function (_0) {
      return _0.getSortIcon("avg");
    },
    "[_0.onSortClick(\"max\")]": function (_0) {
      return [_0.onSortClick("max")];
    },
    "_0.getSortIcon(\"max\")": function (_0) {
      return _0.getSortIcon("max");
    },
    "[_0.enableItemFocused(_1,_2)]": function (_0, _1, _2) {
      return [_0.enableItemFocused(_1, _2)];
    },
    "[_0.headerKeydownHandler(_1,_2)]": function (_0, _1, _2) {
      return [_0.headerKeydownHandler(_1, _2)];
    },
    "[_0.showSetLocationButton(_1)]": function (_0, _1) {
      return [_0.showSetLocationButton(_1)];
    },
    "_0.getGpProbeStatusColor(_1)": function (_0, _1) {
      return _0.getGpProbeStatusColor(_1);
    },
    "_0.getGpProbeStatusColor(_1?_2:_3)": function (_0, _1, _2, _3) {
      return _0.getGpProbeStatusColor(_1 ? _2 : _3);
    },
    "[(\"\"+(_0)),\"top\",true]": function (_0) {
      return ["" + _0, "top", true];
    },
    "_0&&!_1": function (_0, _1) {
      return _0 && !_1;
    },
    "_0.formatTimingValue(_1)": function (_0, _1) {
      return _0.formatTimingValue(_1);
    },
    "_0!==_1": function (_0, _1) {
      return _0 !== _1;
    },
    "!_0&&_1": function (_0, _1) {
      return !_0 && _1;
    },
    "_0&&_1!==_4&&_2!==_4&&_3!==_4": function (_0, _1, _2, _3, _4) {
      return _0 && _1 !== _4 && _2 !== _4 && _3 !== _4;
    },
    "_0(_1)": function (_0, _1) {
      return _0(_1);
    },
    "_0.createGraph(_1)": function (_0, _1) {
      return _0.createGraph(_1);
    },
    "typeof _0!==\"undefined\"&&_1": function (_0, _1) {
      return typeof _0 !== "undefined" && _1;
    },
    "_0&&_0": function (_0) {
      return _0 && _0;
    },
    "[\"quality\",\"rtt\",\"ip\",\"graph\"]": function () {
      return ["quality", "rtt", "ip", "graph"];
    },
    "_0-4": function (_0) {
      return _0 - 4;
    },
    "[\"Set as location for the next test\",\"right\"]": function () {
      return ["Set as location for the next test", "right"];
    },
    "[_0.set(\"itemFocused\",true)]": function (_0) {
      return [_0.set("itemFocused", true)];
    },
    "[_0.setProbeAsLocation()]": function (_0) {
      return [_0.setProbeAsLocation()];
    }
  }
};
component$z.exports.components = {
  "c-placeholder-skeleton": placeholderSkeleton
};
var resultsTableOutput = ractive.extend(component$z.exports);

var component$y = {
  exports: {}
};
component$y.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "span",
    m: [{
      t: 13,
      n: "class",
      f: "c-dot-loader",
      g: 1
    }],
    f: [{
      t: 7,
      e: "span"
    }, " ", {
      t: 7,
      e: "span"
    }, " ", {
      t: 7,
      e: "span"
    }]
  }]
};
var dotLoader = ractive.extend(component$y.exports);

var component$x = {
  exports: {}
};
component$x.exports = {
  data() {
    return {
      _
    };
  },
  computed: {
    placement() {
      return this.get('screenWidth') >= 1200 ? 'right' : 'top';
    },
    template() {
      return `<div class="popover ${this.get('tls.authorized') ? '' : 'popover-danger'}" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>`;
    }
  },
  onrender() {
    if (!ractive.isServer) {
      this.observe('placement', (newValue, oldValue) => {
        if (oldValue) {
          $(this.find('button')).popover('destroy');
        }
        clearTimeout(this.popoverInitTimeout);
        this.popoverInitTimeout = setTimeout(() => {
          this.popoverInitTimeout = null;
          let button = this.find('button');
          let closeHandler = e => {
            if (e.target !== button && $(e.target).closest('.popover').length === 0) {
              button.click();
            }
          };
          let unbind = () => {
            $(document).off('click', closeHandler);
            $(document).off('resize', closeHandler);
            $('.c-gp-results-raw-output_list').off('scroll', closeHandler);
          };
          $(button).on('show.bs.popover', () => {
            $(document).on('click', closeHandler);
            $(document).on('resize', closeHandler);
            $('.c-gp-results-raw-output_list').on('scroll', closeHandler);
          }).on('hide.bs.popover', unbind);
          this.on('unrender', unbind);
        }, 600);
      }, {
        defer: true
      });
    }
  },
  onunrender() {
    clearTimeout(this.popoverInitTimeout);
    this.popoverInitTimeout = null;
  },
  ondetach() {
    if (!ractive.isServer) {
      $(this.find('button')).popover('destroy');
    }
  },
  togglePopover() {
    $(this.find('button')).popover({
      placement: this.get('placement'),
      template: this.get('template')
    }).popover('toggle');
  },
  getTlsString(tls) {
    let esc = value => this.get('@shared.escape')(String(value ?? ''));
    let subject = tls.subject || {};
    let issuer = tls.issuer || {};
    return `
				<table class="table tls-table" style="margin-bottom: 0; overflow-wrap: anywhere;">
					${tls.authorized ? '' : `<tr style="color: #eb3333;">
						<th>Error</th>
						<td>${esc(tls.error)}</td>
					</tr>`}
					<tr>
						<th style="min-width: 86px;">Subject</th>
						<td>${esc(subject.CN)}; ${esc(subject.alt)}</td>
					</tr>
					<tr>
						<th>Issuer</th>
						<td>${esc(issuer.CN)}; ${esc(issuer.O)}; ${esc(issuer.C)}</td>
					</tr>
					<tr>
						<th>Validity</th>
						<td>${_.formatDateTime(tls.createdAt)}; ${_.formatDateTime(tls.expiresAt)}</td>
					</tr>
					<tr>
						<th>Serial number</th>
						<td>${esc(tls.serialNumber)}</td>
					</tr>
					<tr>
						<th>Fingerprint</th>
						<td>${esc(tls.fingerprint256)}</td>
					</tr>
					<tr>
						<th>Key type</th>
						<td>${esc(tls.keyType)}${esc(tls.keyBits)}</td>
					</tr>
				</table>
			`;
  }
};
component$x.exports.template = {
  v: 4,
  t: [{
    t: 4,
    f: [{
      t: 7,
      e: "button",
      m: [{
        n: "type",
        f: "button",
        t: 13,
        g: 1
      }, {
        n: ["click"],
        t: 70,
        f: {
          r: ["@this"],
          s: "[_0.togglePopover()]"
        }
      }, {
        n: "class",
        f: ["btn gp-tls-details ", {
          t: 4,
          f: ["tls-error"],
          n: 51,
          r: "tls.authorized"
        }],
        t: 13
      }, {
        n: "aria-label",
        f: "TLS Details",
        t: 13,
        g: 1
      }, {
        n: "title",
        f: [{
          t: 2,
          r: "tls.protocol"
        }, " - ", {
          t: 2,
          r: "tls.cipherName"
        }],
        t: 13
      }, {
        n: "data-content",
        f: [{
          t: 2,
          x: {
            r: ["@this", "tls"],
            s: "_0.getTlsString(_1)"
          }
        }],
        t: 13
      }, {
        n: "data-html",
        f: "true",
        t: 13,
        g: 1
      }, {
        n: "data-container",
        f: ".c-gp-results-raw-output",
        t: 13,
        g: 1
      }],
      f: [{
        t: 7,
        e: "i",
        m: [{
          n: "class",
          f: ["fa ", {
            t: 4,
            f: ["fa-lock"],
            n: 50,
            r: "tls.authorized"
          }, {
            t: 4,
            f: ["fa-unlock-alt"],
            n: 51,
            l: 1
          }],
          t: 13
        }, {
          n: "aria-hidden",
          f: "true",
          t: 13,
          g: 1
        }]
      }, " TLS"]
    }],
    n: 50,
    r: "tls"
  }],
  e: {
    "[_0.togglePopover()]": function (_0) {
      return [_0.togglePopover()];
    },
    "_0.getTlsString(_1)": function (_0, _1) {
      return _0.getTlsString(_1);
    }
  }
};
var tlsDetails = ractive.extend(component$x.exports);

var component$w = {
  exports: {}
};
const PROBE_STATUS_FAILED$1 = _.getProbeStatusFailedValue();
const PROBE_STATUS_OFFLINE$3 = _.getProbeStatusOfflineValue();
const MIN_OUTPUT_HEIGHT = 400;
component$w.exports = {
  decorators: {
    tooltip
  },
  data() {
    return {
      _,
      loadingProbeResults: [],
      activeTargetIdx: 0,
      hiddenTestResults: {
        0: [],
        1: []
      },
      hiddenResponseBodies: {
        0: [],
        1: []
      },
      networkDataByIp: Object.create(null),
      logoErrors: new Set(),
      networkLookupsActive: false,
      PROBE_STATUS_FAILED: PROBE_STATUS_FAILED$1,
      PROBE_STATUS_OFFLINE: PROBE_STATUS_OFFLINE$3,
      pendingNetworkLookups: new Set(),
      showingNetworkLogos: false,
      allowResultsBlockShrink: false,
      resultsBlockHeightShapeSignature: null,
      skipNextResize: false,
      headerInfoCharWidths: null,
      headerInfoFallbackCharWidth: 7,
      headerInfoListWidth: 0,
      headerInfoOverflowByResultId: new Set(),
      headerInfoEntityWidthsByKey: new Map(),
      floatingSetLocationButton: {
        visible: false,
        top: 0,
        left: 0,
        height: 0,
        buttonTop: 0,
        clientSideId: null,
        probeData: null
      },
      showSetLocationButton: true,
      itemFocused: false,
      justFocusedItem: false
    };
  },
  computed: {
    responseBodyCharsPerLine() {
      let listWidth = this.get('expandedListWidth') || this.get('headerInfoListWidth') || 0;
      let outputHorizontalPadding = 32 * 2;
      let outputListMargin = 24 * 2;
      let contentWidth = listWidth ? Math.max(1, listWidth - outputHorizontalPadding) : Math.min(1240, window.innerWidth - outputListMargin - outputHorizontalPadding);
      let charWidth = this.get('responseBodyCharWidth') || 7;
      return Math.max(1, Math.floor(contentWidth / charWidth));
    },
    headerInfoAvailableHalfWidth() {
      let listWidth = this.get('headerInfoListWidth') || 0;
      let containerHorizontalPadding = 24 * 2;
      let containerWidth = listWidth - containerHorizontalPadding;
      let arrowMinWidth = 110;
      let arrowMarginRight = 32;
      return containerWidth / 2 - (arrowMinWidth + arrowMarginRight) / 2;
    }
  },
  onrender() {
    if (!ractive.isServer) {
      this.set('networkLookupsActive', true);
      this._resizeHeaderInfoHandler = () => {
        this.recalculateHeaderInfoLayoutStates();
      };
      this.initHeaderInfoCharWidths();
      this.recalculateHeaderInfoLayoutStates();
      listeners.addManagedListener(this, window, 'resize', this._resizeHeaderInfoHandler);

      // open a specific item if it was scrolled to from the parent component
      this.observe('scrolledToResId', clientSideId => {
        if (clientSideId === null) {
          return;
        }
        let activeTargetIdx = this.get('activeTargetIdx');
        let hiddenTestResults = this.get(`hiddenTestResults[${activeTargetIdx}]`);
        let targetId = hiddenTestResults.find(resId => resId === clientSideId);
        if (typeof targetId === 'number') {
          if (this.get('allowResultsBlockShrink')) {
            this.set('skipNextResize', true);
          }
          this.hideShowTestResult(targetId);
        }
        this.set('scrolledToResId', null);
      }, {
        init: false
      });
      this.observe('preparedTestResults testInProgress', () => {
        this.resetHeaderInfoEntityWidthCache();
        this.populateNetworkData();
        this.recalculateHeaderInfoLayoutStates({
          allowShrink: this.shouldAllowResultsBlockShrink()
        });
        requestAnimationFrame(() => {
          this.hideSetLocationButtonIfMoved();
        });
      }, {
        deep: true,
        defer: true
      });
      this.observe('hiddenTestResults', () => {
        if (this.get('skipNextResize')) {
          this.set('skipNextResize', false);
          return;
        }
        this.setResultsBlockHeight({
          allowShrink: false
        });
      }, {
        deep: true,
        defer: true,
        init: false
      });
      this.observe('hiddenResponseBodies', () => {
        this.setResultsBlockHeight({
          allowShrink: false
        });
      }, {
        deep: true,
        defer: true,
        init: false
      });
      this.observe('activeTargetIdx', () => {
        this.resetHeaderInfoEntityWidthCache();
        this.populateNetworkData();
        this.recalculateHeaderInfoLayoutStates({
          allowShrink: false
        });
      });
      this.observe('sortOrder sortBy activeTargetIdx', () => {
        let listEl = this.find('.c-gp-results-raw-output_list');
        if (listEl) {
          listEl.scrollTop = 0;
        }
        this.recalculateHeaderInfoLayoutStates();
      }, {
        init: false
      });
      this.observe('expandedListWidth limitLayoutToFirstResult', () => {
        this.recalculateHeaderInfoLayoutStates({
          allowShrink: false
        });
      }, {
        init: false
      });
      this._onSetLocationViewportChange = event => {
        this.hideSetLocationButton(event);
      };
      this._setLocationListEl = this.find('.c-gp-results-raw-output_list');
      listeners.addManagedListener(this, window, 'resize', this._onSetLocationViewportChange);
      listeners.addManagedListener(this, window, 'scroll', this._onSetLocationViewportChange);
      if (this._setLocationListEl) {
        listeners.addManagedListener(this, this._setLocationListEl, 'scroll', this._onSetLocationViewportChange);
      }
    }
  },
  onunrender() {
    this.set('networkLookupsActive', false);
    if (this.pendingNetworkDataUpdatesFlushTimeout) {
      clearTimeout(this.pendingNetworkDataUpdatesFlushTimeout);
      this.pendingNetworkDataUpdatesFlushTimeout = null;
    }
    if (this.pendingResultsBlockHeightFrame) {
      cancelAnimationFrame(this.pendingResultsBlockHeightFrame);
      this.pendingResultsBlockHeightFrame = null;
      this.pendingResultsBlockHeightAllowShrink = false;
    }
  },
  // --- set location button logic ---
  isSetLocationFocusActive(setLocationButton) {
    let activeElement = document.activeElement;
    return setLocationButton && setLocationButton.contains(activeElement) || activeElement?.classList.contains('c-gp-results-raw-output_list_item');
  },
  showSetLocationButton(clientSideId) {
    if (!this.get('showSetLocationButton')) {
      return;
    }
    let probeData = this.get('preparedTestResults').find(item => item.clientSideId === clientSideId);
    let node = document.querySelector(`.item-id-${clientSideId}`);
    let nodeHeader = node?.querySelector('.c-gp-results-raw-output_list_item_header_info');
    let container = this.find('.c-gp-results-raw-output');
    let listContainer = this.find('.c-gp-results-raw-output_list');
    this.set('itemFocused', false);
    if (!node || !nodeHeader || !container || !listContainer) {
      return;
    }
    let listRect = listContainer.getBoundingClientRect();
    let nodeHeaderRect = nodeHeader.getBoundingClientRect();
    let visibilityOverflowTolerancePx = 15;
    let isNodeHeaderFullyVisible = nodeHeaderRect.top >= listRect.top - visibilityOverflowTolerancePx && nodeHeaderRect.bottom <= listRect.bottom + visibilityOverflowTolerancePx;
    if (!isNodeHeaderFullyVisible) {
      this.set('floatingSetLocationButton.visible', false);
      return;
    }
    let nodeRect = node.getBoundingClientRect();
    let containerRect = container.getBoundingClientRect();
    let nodeHeaderHeight = nodeHeaderRect.height;
    let relativeTop = nodeRect.top - containerRect.top;
    let relativeLeft = nodeRect.left - containerRect.left;
    this.set('floatingSetLocationButton', {
      visible: true,
      clientSideId,
      probeData,
      top: relativeTop,
      left: relativeLeft - 26,
      height: nodeRect.height,
      buttonTop: nodeHeaderHeight / 2 - 13
    });
  },
  hideSetLocationButtonIfMoved() {
    let floatingSetLocationButton = this.get('floatingSetLocationButton');
    if (!floatingSetLocationButton.visible) {
      return;
    }
    let node = this.find(`.item-id-${floatingSetLocationButton.clientSideId}`);
    let nodeHeader = node?.querySelector('.c-gp-results-raw-output_list_item_header_info');
    let container = this.find('.c-gp-results-raw-output');
    if (!node || !nodeHeader || !container) {
      this.set('itemFocused', false);
      this.set('floatingSetLocationButton.visible', false);
      return;
    }
    let nodeRect = node.getBoundingClientRect();
    let nodeHeaderRect = nodeHeader.getBoundingClientRect();
    let containerRect = container.getBoundingClientRect();
    let top = nodeRect.top - containerRect.top;
    let left = nodeRect.left - containerRect.left - 26;
    let height = nodeRect.height;
    let buttonTop = nodeHeaderRect.height / 2 - 13;
    if (top !== floatingSetLocationButton.top || left !== floatingSetLocationButton.left || height !== floatingSetLocationButton.height || buttonTop !== floatingSetLocationButton.buttonTop) {
      this.set('itemFocused', false);
      this.set('floatingSetLocationButton.visible', false);
    }
  },
  hideSetLocationButton(event) {
    if (!this.get('showSetLocationButton')) {
      return;
    }
    if (this.get('justFocusedItem')) {
      if (event?.type !== 'scroll') {
        this.set('justFocusedItem', false);
      }
      return;
    }
    if (event?.type === 'scroll') {
      if (!this.get('itemFocused') && !this.get('floatingSetLocationButton.visible')) {
        return;
      }
      this.set('itemFocused', false);
      this.set('floatingSetLocationButton.visible', false);
      return;
    }
    let setLocationButton = this.find('.c-gp-results-raw-output_set-location');
    let setLocationHitarea = this.find('.c-gp-results-raw-output_set-location-hitarea');
    if (event?.type === 'blur' && !event.relatedTarget) {
      requestAnimationFrame(() => {
        this.hideSetLocationButton();
      });
      return;
    }
    if (this.isSetLocationFocusActive(setLocationButton)) {
      return;
    }
    if (event?.type === 'blur' && setLocationButton?.contains(event.relatedTarget)) {
      return;
    }
    if (event && event.relatedTarget && event.type !== 'blur') {
      let container = event.target.closest('.c-gp-results-raw-output_list_item');
      let relatedContainer = event.relatedTarget.closest?.('.c-gp-results-raw-output_list_item');
      if (container && container.contains(event.relatedTarget) || relatedContainer || setLocationHitarea && setLocationHitarea.contains(event.relatedTarget)) {
        return;
      }
    }
    this.set('itemFocused', false);
    this.set('floatingSetLocationButton.visible', false);
  },
  setProbeAsLocation(probeData = this.get('floatingSetLocationButton.probeData')) {
    if (!this.get('showSetLocationButton') || !probeData) {
      return;
    }
    this.set('currSearchLocation', `AS${probeData.asn}+${probeData.city}`);
    this.set('floatingSetLocationButton.visible', false);
  },
  enableItemFocused(event, clientSideId) {
    if (!this.get('showSetLocationButton')) {
      return;
    }
    if (!event.target?.classList.contains('c-gp-results-raw-output_list_item')) {
      return;
    }
    this.showSetLocationButton(clientSideId);
    this.set('itemFocused', true);
    this.set('justFocusedItem', true);
    requestAnimationFrame(() => {
      this.set('justFocusedItem', false);
    });
  },
  headerKeydownHandler(event, clientSideId) {
    if (!this.get('showSetLocationButton')) {
      return;
    }
    if (!event.target?.classList.contains('c-gp-results-raw-output_list_item')) {
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      let probeData = this.get('preparedTestResults').find(item => item.clientSideId === clientSideId);
      this.setProbeAsLocation(probeData);
    }
  },
  // --- Logic to determine whether to (always) show the HTTP response body ---
  isResponseBodyHidden(result) {
    let activeTargetIdx = this.get('activeTargetIdx');
    let body = result?.statsPerTarget?.[activeTargetIdx]?.responseBody || '';
    if (this.get('limitLayoutToFirstResult') && result?.clientSideId !== this.get('preparedTestResults.0.clientSideId')) {
      return true;
    }
    if (!_.shouldCollapseResponseBody(body, this.get('responseBodyCharsPerLine'))) {
      return false;
    }
    let hidden = this.get(`hiddenResponseBodies[${activeTargetIdx}]`) ?? [];
    return hidden.includes(result?.clientSideId);
  },
  // --- Output list height setter
  getResultsBlockHeightShapeSignature() {
    let preparedTestResults = this.get('preparedTestResults') || [];
    let measurementsMetadata = this.get('measurementsMetadata') || {};
    let measurementIds = Object.keys(measurementsMetadata).sort().map(key => measurementsMetadata[key]?.measurementId || '').join(',');
    let expectedTargetsCnt = this.get('targetsCnt') || preparedTestResults[0]?.statsPerTarget?.length || 0;
    return `${measurementIds}:${expectedTargetsCnt}:${preparedTestResults.length}`;
  },
  shouldAllowResultsBlockShrink() {
    if (!this.get('allowResultsBlockShrink')) {
      return false;
    }
    let currentSignature = this.getResultsBlockHeightShapeSignature();
    let previousSignature = this.get('resultsBlockHeightShapeSignature');
    this.set('resultsBlockHeightShapeSignature', currentSignature);
    return currentSignature !== previousSignature;
  },
  setResultsBlockHeight({
    allowShrink = true
  } = {}) {
    if (!this.get('allowResultsBlockShrink')) {
      return;
    }
    this.pendingResultsBlockHeightAllowShrink = this.pendingResultsBlockHeightFrame ? this.pendingResultsBlockHeightAllowShrink && allowShrink : allowShrink;
    if (this.pendingResultsBlockHeightFrame) {
      return;
    }
    this.pendingResultsBlockHeightFrame = requestAnimationFrame(() => {
      let pendingAllowShrink = this.pendingResultsBlockHeightAllowShrink;
      this.pendingResultsBlockHeightAllowShrink = false;
      this.pendingResultsBlockHeightFrame = null;
      let listEl;
      try {
        listEl = this.find('.c-gp-results-raw-output_list');
      } catch {
        return;
      }
      if (listEl) {
        let currentHeight = parseFloat(listEl.style.height) || 0;
        let currentScrollTop = listEl.scrollTop;
        let items = listEl.querySelectorAll('.c-gp-results-raw-output_list_item');
        let itemsAmount = items.length;
        if (itemsAmount === 0) {
          return;
        }
        let targetHeight = 0;
        let limit = Math.min(itemsAmount, 3);
        for (let i = 0; i < limit; i++) {
          targetHeight += items[i].offsetHeight;
        }
        let totalItemHeight = targetHeight;
        for (let i = limit; i < itemsAmount; i++) {
          totalItemHeight += items[i].offsetHeight;
        }
        targetHeight = Math.ceil(targetHeight);
        totalItemHeight = Math.ceil(totalItemHeight);
        if (MIN_OUTPUT_HEIGHT > targetHeight && MIN_OUTPUT_HEIGHT <= totalItemHeight) {
          targetHeight = MIN_OUTPUT_HEIGHT;
        }

        // Collapse-only updates keep the current height; structural updates may shrink empty space.
        let shouldUpdateHeight = targetHeight > currentHeight || pendingAllowShrink && targetHeight !== currentHeight && totalItemHeight < currentHeight;
        if (shouldUpdateHeight) {
          listEl.style.height = `${targetHeight}px`;
        }
        if (listEl.scrollTop !== currentScrollTop) {
          listEl.scrollTop = currentScrollTop;
        }
      }
    });
  },
  // --- Logic to determine whether to wrap the header info ---
  // First, calculate current character widths for the font used in the header info
  // Then, use these widths to calculate the width of the header info text for each entity
  // If one entity takes up too much space, wrap the header info
  // Recalculate the overflow states for each entity on window resize
  initHeaderInfoCharWidths() {
    let measureNode = document.createElement('span');
    measureNode.className = 'c-gp-results-raw-output_list_item_header_info_entity_field';
    measureNode.style.position = 'absolute';
    measureNode.style.visibility = 'hidden';
    measureNode.style.whiteSpace = 'pre';
    measureNode.style.pointerEvents = 'none';
    measureNode.style.display = 'inline-block';
    measureNode.style.margin = '0';
    measureNode.style.padding = '0';
    measureNode.style.border = '0';
    measureNode.style.letterSpacing = 'normal';
    measureNode.style.fontFamily = 'Lexend, sans-serif';
    measureNode.style.fontSize = '13px';
    measureNode.style.fontWeight = '400';
    measureNode.textContent = 'M';
    document.body.appendChild(measureNode);
    let fallbackCharWidth = measureNode.getBoundingClientRect().width || 7;
    this.set('headerInfoFallbackCharWidth', fallbackCharWidth);
    let cacheKey = 'header-char-widths';
    let cached = null;
    try {
      cached = JSON.parse(sessionStorage.getItem(cacheKey) || '{}');
    } catch {
      cached = {};
    }
    if (Object.keys(cached).length === 256) {
      measureNode.remove();
      this.set('headerInfoCharWidths', cached);
      return;
    }
    let charWidths = Object.create(null);
    let basePairWidth = 0;
    let noSpacePairWidth = 0;
    measureNode.textContent = 'a a';
    basePairWidth = measureNode.getBoundingClientRect().width || 0;
    measureNode.textContent = 'aa';
    noSpacePairWidth = measureNode.getBoundingClientRect().width || 0;
    for (let charCode = 0; charCode <= 255; charCode++) {
      if (charCode === 32) {
        charWidths[charCode] = basePairWidth - noSpacePairWidth || fallbackCharWidth * 0.5;
        continue;
      }
      measureNode.textContent = String.fromCharCode(charCode);
      charWidths[charCode] = measureNode.getBoundingClientRect().width || fallbackCharWidth;
    }
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify(charWidths));
    } catch {
      // ignore storage errors
    }
    measureNode.remove();
    this.set('headerInfoCharWidths', charWidths);
  },
  measureHeaderInfoTextWidth(value = '') {
    let charWidths = this.get('headerInfoCharWidths');
    let fallbackCharWidth = this.get('headerInfoFallbackCharWidth');
    let text = String(value ?? '');
    let totalWidth = 0;
    for (let i = 0; i < text.length; i++) {
      let charCode = text.charCodeAt(i);
      totalWidth += charWidths[charCode] ?? fallbackCharWidth;
    }
    return totalWidth;
  },
  getHeaderInfoSourceEntityWidth(result) {
    let asnText = `AS${result?.asn ?? ''}`;
    let locationText = [result?.city, result?.state, result?.country].filter(Boolean).join(', ');
    let networkText = result?.network || '';
    let fieldsTextWidth = this.measureHeaderInfoTextWidth(asnText) + this.measureHeaderInfoTextWidth(locationText) + this.measureHeaderInfoTextWidth(networkText);
    let iconWidths = 16 + 21 + 18;
    let textIconGaps = 6 * 3;
    let fieldsGap = 16 * 2;
    let entityHorizontalPadding = 8 * 2;
    return fieldsTextWidth + iconWidths + textIconGaps + fieldsGap + entityHorizontalPadding;
  },
  getHeaderInfoTargetEntityWidth(result) {
    let activeTargetIdx = this.get('activeTargetIdx');
    let ipAddr = result?.statsPerTarget?.[activeTargetIdx]?.ipAddr;
    if (!ipAddr) {
      return 0;
    }
    let ipTextWidth = this.measureHeaderInfoTextWidth(ipAddr);
    let locationLabel = this.isAnycastIp(ipAddr) ? 'Anycast' : this.getIpLocationLabel(ipAddr) || '';
    let hasLocationField = !!locationLabel;
    let locationTextWidth = hasLocationField ? this.measureHeaderInfoTextWidth(locationLabel) : 0;
    let networkName = this.getNetworkName(ipAddr) || '';
    let networkTextWidth = this.measureHeaderInfoTextWidth(networkName);
    let isNetworkInfoLoading = this.isTargetNetworkInfoLoading(ipAddr);
    let hasLocationPlaceholder = !hasLocationField && isNetworkInfoLoading;
    let hasNetworkPlaceholder = !networkName && isNetworkInfoLoading;
    let loadingPlaceholderWidth = 77 * ((hasLocationPlaceholder ? 1 : 0) + (hasNetworkPlaceholder ? 1 : 0));
    let fieldCount = 1 + (hasLocationField ? 1 : 0) + (networkName ? 1 : 0) + (hasLocationPlaceholder ? 1 : 0) + (hasNetworkPlaceholder ? 1 : 0);
    let hasLocationIcon = this.isAnycastIp(ipAddr) || !!this.getIpLocationCountryCode(ipAddr);
    let locationIconWidth = hasLocationField ? this.isAnycastIp(ipAddr) ? 22 : this.getIpLocationCountryCode(ipAddr) ? 21 : 0 : 0;
    let iconCount = 1 + (hasLocationIcon ? 1 : 0) + (networkName ? 1 : 0);
    let iconWidths = 16 + locationIconWidth + (networkName ? 18 : 0);
    let textIconGaps = iconCount * 6;
    let fieldsGap = 16 * Math.max(fieldCount - 1, 0);
    let entityHorizontalPadding = 8 * 2;
    return ipTextWidth + locationTextWidth + networkTextWidth + loadingPlaceholderWidth + iconWidths + textIconGaps + fieldsGap + entityHorizontalPadding;
  },
  getHeaderInfoEntityWidthCacheKey(result, activeTargetIdx = this.get('activeTargetIdx')) {
    return `${activeTargetIdx}:${result?.clientSideId ?? ''}`;
  },
  resetHeaderInfoEntityWidthCache(ipAddresses = null) {
    if (ipAddresses === null) {
      this.set('headerInfoEntityWidthsByKey', new Map());
      return;
    }
    if (ipAddresses.length === 0) {
      return;
    }
    let activeTargetIdx = this.get('activeTargetIdx');
    let ipAddressSet = new Set(ipAddresses);
    let preparedTestResults = this.get('preparedTestResults') || [];
    let headerInfoEntityWidthsByKey = this.get('headerInfoEntityWidthsByKey');
    preparedTestResults.forEach(result => {
      let ipAddr = result?.statsPerTarget?.[activeTargetIdx]?.ipAddr;
      if (ipAddressSet.has(ipAddr)) {
        headerInfoEntityWidthsByKey.delete(this.getHeaderInfoEntityWidthCacheKey(result));
      }
    });
  },
  getHeaderInfoEntityWidths(result) {
    let cacheKey = this.getHeaderInfoEntityWidthCacheKey(result);
    let headerInfoEntityWidthsByKey = this.get('headerInfoEntityWidthsByKey');
    let cached = headerInfoEntityWidthsByKey.get(cacheKey);
    if (cached) {
      return cached;
    }
    let target = this.getHeaderInfoTargetEntityWidth(result);
    let source = target ? this.getHeaderInfoSourceEntityWidth(result) : 0;
    let widths = {
      target,
      source
    };
    headerInfoEntityWidthsByKey.set(cacheKey, widths);
    return widths;
  },
  recalculateHeaderInfoLayoutStates({
    allowShrink = true
  } = {}) {
    let listEl = this.find('.c-gp-results-raw-output_list');
    let listWidth = this.get('expandedListWidth') || listEl?.offsetWidth || 0;
    let preparedTestResults = this.get('preparedTestResults') || [];
    let resultsToRecalculate = this.get('limitLayoutToFirstResult') ? preparedTestResults.slice(0, 1) : preparedTestResults;
    let previousListWidth = this.get('headerInfoListWidth') || 0;
    let headerInfoEntityWidthsByKey = this.get('headerInfoEntityWidthsByKey');
    if (listWidth !== previousListWidth && this.get('limitLayoutToFirstResult')) {
      this.resetHeaderInfoEntityWidthCache();
      headerInfoEntityWidthsByKey = this.get('headerInfoEntityWidthsByKey');
    }
    let shouldRecalculateCachedOverflow = listWidth !== previousListWidth || headerInfoEntityWidthsByKey.size === 0;
    let previousOverflowByResultId = this.get('headerInfoOverflowByResultId') || new Set();
    let overflowByResultId = shouldRecalculateCachedOverflow ? new Set() : new Set(previousOverflowByResultId);
    let didUpdateOverflow = shouldRecalculateCachedOverflow;
    if (shouldRecalculateCachedOverflow) {
      this.set('headerInfoListWidth', listWidth);
    }
    let availableHalfWidth = this.get('headerInfoAvailableHalfWidth');
    resultsToRecalculate.forEach(result => {
      let resultId = result.clientSideId;
      let wasWidthCached = headerInfoEntityWidthsByKey.has(this.getHeaderInfoEntityWidthCacheKey(result));
      let widths = this.getHeaderInfoEntityWidths(result);
      let targetEntityWidth = widths.target;
      if (!targetEntityWidth) {
        if (overflowByResultId.has(resultId)) {
          overflowByResultId.delete(resultId);
          didUpdateOverflow = true;
        }
        return;
      }
      if (wasWidthCached && !shouldRecalculateCachedOverflow) {
        return;
      }
      let sourceEntityWidth = widths.source;
      let shouldUseOverflowLayout = sourceEntityWidth > availableHalfWidth || targetEntityWidth > availableHalfWidth;
      if (overflowByResultId.has(resultId) !== shouldUseOverflowLayout) {
        didUpdateOverflow = true;
      }
      if (shouldUseOverflowLayout) {
        overflowByResultId.add(resultId);
      } else {
        overflowByResultId.delete(resultId);
      }
    });
    if (didUpdateOverflow) {
      this.set('headerInfoOverflowByResultId', overflowByResultId);
    }
    this.setResultsBlockHeight({
      allowShrink
    });
  },
  shouldUseOverflowLayout(result) {
    let overflowByResultId = this.get('headerInfoOverflowByResultId') || new Set();
    return overflowByResultId.has(result?.clientSideId);
  },
  recalculateHeaderInfoLayoutStatesAfterNetworkLookup() {
    if (this.get('pendingNetworkLookups').size > 0) {
      return;
    }
    if (this.pendingNetworkDataUpdatesFlushTimeout) {
      clearTimeout(this.pendingNetworkDataUpdatesFlushTimeout);
      this.pendingNetworkDataUpdatesFlushTimeout = null;
    }
    this.resetHeaderInfoEntityWidthCache(this.flushNetworkDataUpdates());
    this.recalculateHeaderInfoLayoutStates({
      allowShrink: false
    });
  },
  // --- Fetching and caching network data + related getters ---
  queueNetworkDataByIp(ipAddr, networkData) {
    if (!this.get('networkLookupsActive')) {
      return;
    }
    this.pendingNetworkDataUpdatesByIp = this.pendingNetworkDataUpdatesByIp || new Map();
    this.pendingNetworkDataUpdatesByIp.set(ipAddr, networkData);
    this.scheduleNetworkDataUpdatesFlush();
  },
  scheduleNetworkDataUpdatesFlush() {
    if (!this.get('networkLookupsActive')) {
      return;
    }
    if (this.pendingNetworkDataUpdatesFlushTimeout) {
      return;
    }
    this.pendingNetworkDataUpdatesFlushTimeout = setTimeout(() => {
      if (!this.get('networkLookupsActive')) {
        return;
      }
      this.pendingNetworkDataUpdatesFlushTimeout = null;
      this.resetHeaderInfoEntityWidthCache(this.flushNetworkDataUpdates());
      this.recalculateHeaderInfoLayoutStates({
        allowShrink: false
      });
    }, 500);
  },
  flushNetworkDataUpdates() {
    let networkDataUpdatesByIp = this.pendingNetworkDataUpdatesByIp || new Map();
    let hasIpUpdates = networkDataUpdatesByIp.size > 0;
    if (hasIpUpdates) {
      this.set('networkDataByIp', {
        ...this.get('networkDataByIp'),
        ...Object.fromEntries(networkDataUpdatesByIp)
      });
      this.pendingNetworkDataUpdatesByIp = new Map();
    }
    if (hasIpUpdates) {
      this.set('showingNetworkLogos', this.get('showingNetworkLogos') || Array.from(networkDataUpdatesByIp.values()).some(networkData => !!networkData?.asn));
    }
    return Array.from(networkDataUpdatesByIp.keys());
  },
  populateNetworkData() {
    let preparedTestResults = this.get('preparedTestResults') || [];
    let activeTargetIdx = this.get('activeTargetIdx');
    let ipAddresses = new Set();
    preparedTestResults.forEach(result => {
      let ipAddr = result?.statsPerTarget?.[activeTargetIdx]?.ipAddr;
      if (ipAddr) {
        ipAddresses.add(ipAddr);
      }
    });
    for (let ipAddr of ipAddresses) {
      this.fetchNetworkByIp(ipAddr);
    }
  },
  fetchNetworkByIp(ipAddr) {
    let networkDataByIp = this.get('networkDataByIp');
    let pendingNetworkLookups = this.get('pendingNetworkLookups');
    if (!ipAddr || Object.hasOwn(networkDataByIp, ipAddr) || pendingNetworkLookups.has(ipAddr)) {
      return;
    }
    pendingNetworkLookups.add(ipAddr);
    this.update('pendingNetworkLookups');
    http.getNetworkFromIP(ipAddr).then(res => {
      if (!this.get('networkLookupsActive')) {
        return;
      }
      this.queueNetworkDataByIp(ipAddr, res);
    }).catch(() => {
      if (!this.get('networkLookupsActive')) {
        return;
      }
      this.queueNetworkDataByIp(ipAddr, null);
    }).finally(() => {
      if (!this.get('networkLookupsActive')) {
        return;
      }
      pendingNetworkLookups.delete(ipAddr);
      this.recalculateHeaderInfoLayoutStatesAfterNetworkLookup();
    });
  },
  getNetworkDataByIp(ipAddr) {
    return ipAddr ? this.get('networkDataByIp')[ipAddr] : null;
  },
  getNetworkAsnByIp(ipAddr) {
    let network = this.getNetworkDataByIp(ipAddr);
    return network?.asn || null;
  },
  getNetworkName(ipAddr) {
    let network = this.getNetworkDataByIp(ipAddr);
    return network?.name || network?.domain || null;
  },
  isTargetNetworkInfoLoading(ipAddr) {
    return this.get('pendingNetworkLookups').has(ipAddr);
  },
  getLocationByIp(ipAddr) {
    return this.getNetworkDataByIp(ipAddr)?.location || null;
  },
  isAnycastIp(ipAddr) {
    return this.getLocationByIp(ipAddr)?.isAnycast || false;
  },
  getIpLocationCountryCode(ipAddr) {
    return this.getLocationByIp(ipAddr)?.country || null;
  },
  getIpLocationLabel(ipAddr) {
    let location = this.getLocationByIp(ipAddr);
    if (!location || location.isAnycast) {
      return null;
    }
    let values = [location.city, location.state, location.country].filter(Boolean);
    return values.length ? values.join(', ') : null;
  },
  shouldRenderTargetNetwork(ipAddr) {
    return this.getNetworkAsnByIp(ipAddr) && this.getNetworkName(ipAddr);
  },
  logoError(logoKey) {
    return this.get('logoErrors').has(logoKey);
  },
  setLogoError(logoKey) {
    this.get('logoErrors').add(logoKey);
    this.update('logoErrors');
  },
  // --- Other functions ---
  getStatusColor(targetStats) {
    if (targetStats.extraValues?.errorStatus) {
      return _.getGpProbeStatusColor(targetStats.extraValues.errorStatus);
    }
    return _.getGpProbeStatusColor(targetStats.avgTiming, this.get('testReqParams').type === 'http' ? 1000 : 200);
  },
  getHeaderPrimaryMetrics(extraValues = {}) {
    return [extraValues.dnsStatus, extraValues.httpStatus, extraValues.answers].filter(Boolean);
  },
  getHeaderSecondaryMetrics(extraValues = {}) {
    return Object.keys(extraValues).filter(key => !['answers', 'dnsStatus', 'httpStatus', 'errorStatus'].includes(key)).map(key => extraValues[key]).filter(Boolean);
  },
  hideShowTestResult(resultId) {
    let activeTargetIdx = this.get('activeTargetIdx');
    let hidden = this.get(`hiddenTestResults[${activeTargetIdx}]`) ?? [];
    let hiddenContent = this.get(`hiddenResponseBodies[${activeTargetIdx}]`) ?? [];
    let preparedTestResults = this.get('preparedTestResults') || [];
    let result = preparedTestResults.find(item => item.clientSideId === resultId);
    let body = result?.statsPerTarget?.[activeTargetIdx]?.responseBody || '';
    let isOpening = hidden.includes(resultId);
    let updated = isOpening ? hidden.filter(clientSideId => clientSideId !== resultId) : [...hidden, resultId];
    this.set(`hiddenTestResults[${activeTargetIdx}]`, updated);

    // Reset the content state when closing output, but keep the current response-body state when opening it.
    if (!isOpening && !hiddenContent.includes(resultId) && _.shouldCollapseResponseBody(body, this.get('responseBodyCharsPerLine'))) {
      this.set(`hiddenResponseBodies[${activeTargetIdx}]`, [...hiddenContent, resultId]);
    }
  }
};
component$w.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      n: "class",
      f: ["c-gp-results-raw-output ", {
        t: 4,
        f: ["is-height-shrink-enabled"],
        n: 50,
        r: "allowResultsBlockShrink"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        n: "class",
        f: ["c-gp-results-raw-output_list ", {
          t: 4,
          f: ["round-bottom"],
          n: 50,
          r: "testInProgress"
        }],
        t: 13
      }, {
        n: ["scroll"],
        t: 70,
        f: {
          r: ["@this", "@event"],
          s: "[_0.hideSetLocationButton(_1)]"
        }
      }],
      f: [{
        t: 4,
        f: [{
          t: 7,
          e: "div",
          m: [{
            n: "class",
            f: ["c-gp-results-raw-output_list_item item-id-", {
              t: 2,
              r: "./clientSideId"
            }],
            t: 13
          }, {
            t: 4,
            f: [{
              n: "tabindex",
              f: "0",
              t: 13
            }, {
              n: "role",
              f: "button",
              t: 13
            }, {
              n: "aria-label",
              f: "Set as location for the next test",
              t: 13
            }, {
              n: ["focus"],
              t: 70,
              f: {
                r: ["@this", "@event", "./clientSideId"],
                s: "[_0.enableItemFocused(_1,_2)]"
              }
            }, {
              n: ["blur"],
              t: 70,
              f: {
                r: ["@this", "@event"],
                s: "[_0.hideSetLocationButton(_1)]"
              }
            }, {
              n: ["keydown"],
              t: 70,
              f: {
                r: ["@this", "@event", "./clientSideId"],
                s: "[_0.headerKeydownHandler(_1,_2)]"
              }
            }, {
              n: ["mouseenter"],
              t: 70,
              f: {
                r: ["@this", "./clientSideId"],
                s: "[_0.showSetLocationButton(_1)]"
              }
            }, {
              n: ["mouseleave"],
              t: 70,
              f: {
                r: ["@this", "@event"],
                s: "[_0.hideSetLocationButton(_1)]"
              }
            }],
            n: 50,
            r: "showSetLocationButton"
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "c-gp-results-raw-output_list_item_header",
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                n: "class",
                f: ["c-gp-results-raw-output_list_item_header_info ", {
                  t: 4,
                  f: ["is-overflow-layout"],
                  n: 50,
                  x: {
                    r: ["@this", "."],
                    s: "_0.shouldUseOverflowLayout(_1)"
                  }
                }],
                t: 13
              }, {
                n: "style",
                f: ["border-left: 6px solid ", {
                  t: 2,
                  x: {
                    r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                    s: "_0.getStatusColor(_2[_1])"
                  }
                }, "; background: linear-gradient(to right, ", {
                  t: 2,
                  x: {
                    r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                    s: "_0.getStatusColor(_2[_1])"
                  }
                }, "0C, transparent 50%);"],
                t: 13
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "c-gp-results-raw-output_list_item_header_info_entity",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "c-gp-results-raw-output_list_item_header_info_entity_field",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "height",
                      f: "16",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "16",
                      t: 13,
                      g: 1
                    }, {
                      n: "alt",
                      f: "",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/gp-logo.svg"],
                      t: 13
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    f: ["AS", {
                      t: 2,
                      r: "./asn"
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "c-gp-results-raw-output_list_item_header_info_entity_field",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "width",
                      f: "21",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "14",
                      t: 13,
                      g: 1
                    }, {
                      n: "alt",
                      f: "",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
                        t: 2,
                        r: "./country"
                      }, ".svg"],
                      t: 13
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    f: [{
                      t: 2,
                      r: "./city"
                    }, ", ", {
                      t: 4,
                      f: [{
                        t: 2,
                        r: "./state"
                      }, ", "],
                      n: 50,
                      r: "./state"
                    }, {
                      t: 2,
                      r: "./country"
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "c-gp-results-raw-output_list_item_header_info_entity_field",
                    g: 1
                  }],
                  f: [{
                    t: 4,
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "width",
                        f: "18",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "18",
                        t: 13,
                        g: 1
                      }, {
                        n: "alt",
                        f: "",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: ["/asn-logo/AS", {
                          t: 2,
                          r: "./asn"
                        }, "?v=", {
                          t: 2,
                          r: "@shared.assetsVersion"
                        }, "&size=36&padding=0"],
                        t: 13
                      }, {
                        n: ["load"],
                        t: 70,
                        f: {
                          r: ["@this"],
                          s: "[_0.set(\"showingNetworkLogos\",true)]"
                        }
                      }, {
                        n: ["error"],
                        t: 70,
                        f: {
                          r: ["@this", "./asn"],
                          s: "[_0.setLogoError(_1)]"
                        }
                      }]
                    }],
                    n: 50,
                    x: {
                      r: ["@this", "./asn"],
                      s: "!_0.logoError(_1)"
                    }
                  }, {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "c-gp-results-raw-output_list_item_header_info_entity_logo-placeholder",
                        g: 1
                      }],
                      f: [{
                        t: 2,
                        r: "./network.0"
                      }]
                    }],
                    n: 51,
                    l: 1
                  }, " ", {
                    t: 7,
                    e: "span",
                    f: [{
                      t: 2,
                      r: "./network"
                    }]
                  }]
                }]
              }, " ", {
                t: 4,
                f: [{
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "c-gp-results-raw-output_list_item_header_info_arrow",
                    g: 1
                  }]
                }, " ", {
                  t: 7,
                  e: "c-gp-tls-details",
                  m: [{
                    n: "tls",
                    f: [{
                      t: 2,
                      rx: {
                        r: "./statsPerTarget",
                        m: [{
                          t: 30,
                          n: "activeTargetIdx"
                        }, "tls"]
                      }
                    }],
                    t: 13
                  }, {
                    n: "screenWidth",
                    f: [{
                      t: 2,
                      r: "screenWidth"
                    }],
                    t: 13
                  }]
                }, " ", {
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "c-gp-results-raw-output_list_item_header_info_entity",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "c-gp-results-raw-output_list_item_header_info_entity_field",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "i",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-server",
                        g: 1
                      }, {
                        n: "aria-hidden",
                        f: "true",
                        t: 13,
                        g: 1
                      }]
                    }, " ", {
                      t: 7,
                      e: "span",
                      f: [{
                        t: 2,
                        rx: {
                          r: "./statsPerTarget",
                          m: [{
                            t: 30,
                            n: "activeTargetIdx"
                          }, "ipAddr"]
                        }
                      }]
                    }]
                  }, " ", {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "c-gp-results-raw-output_list_item_header_info_entity_field",
                        g: 1
                      }],
                      f: [{
                        t: 4,
                        f: [{
                          t: 7,
                          e: "img",
                          m: [{
                            n: "width",
                            f: "22",
                            t: 13,
                            g: 1
                          }, {
                            n: "height",
                            f: "16",
                            t: 13,
                            g: 1
                          }, {
                            n: "alt",
                            f: "",
                            t: 13,
                            g: 1
                          }, {
                            n: "src",
                            f: [{
                              t: 2,
                              r: "@shared.assetsHost"
                            }, "/img/anycast.svg"],
                            t: 13
                          }]
                        }, " Anycast"],
                        n: 50,
                        x: {
                          r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                          s: "_0.isAnycastIp(_2[_1].ipAddr)"
                        }
                      }, {
                        t: 4,
                        f: [{
                          t: 4,
                          f: [{
                            t: 7,
                            e: "img",
                            m: [{
                              n: "width",
                              f: "21",
                              t: 13,
                              g: 1
                            }, {
                              n: "height",
                              f: "14",
                              t: 13,
                              g: 1
                            }, {
                              n: "alt",
                              f: "",
                              t: 13,
                              g: 1
                            }, {
                              n: "src",
                              f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
                                t: 2,
                                x: {
                                  r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                                  s: "_0.getIpLocationCountryCode(_2[_1].ipAddr)"
                                }
                              }, ".svg"],
                              t: 13
                            }]
                          }],
                          n: 50,
                          x: {
                            r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                            s: "_0.getIpLocationCountryCode(_2[_1].ipAddr)"
                          }
                        }, " ", {
                          t: 7,
                          e: "span",
                          f: [{
                            t: 2,
                            x: {
                              r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                              s: "_0.getIpLocationLabel(_2[_1].ipAddr)"
                            }
                          }]
                        }],
                        n: 51,
                        l: 1
                      }]
                    }],
                    n: 50,
                    x: {
                      r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                      s: "_0.isAnycastIp(_2[_1].ipAddr)||_0.getIpLocationLabel(_2[_1].ipAddr)"
                    }
                  }, {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "c-gp-results-raw-output_list_item_header_info_entity_field",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "span",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "c-gp-results-raw-output_list_item_header_info_entity_loading-placeholder",
                          g: 1
                        }]
                      }]
                    }],
                    n: 50,
                    x: {
                      r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                      s: "_0.isTargetNetworkInfoLoading(_2[_1].ipAddr)"
                    },
                    l: 1
                  }, " ", {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "c-gp-results-raw-output_list_item_header_info_entity_field",
                        g: 1
                      }],
                      f: [{
                        t: 4,
                        f: [{
                          t: 7,
                          e: "img",
                          m: [{
                            n: "width",
                            f: "18",
                            t: 13,
                            g: 1
                          }, {
                            n: "height",
                            f: "18",
                            t: 13,
                            g: 1
                          }, {
                            n: "src",
                            f: ["/asn-logo/", {
                              t: 2,
                              x: {
                                r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                                s: "_0.getNetworkAsnByIp(_2[_1].ipAddr)"
                              }
                            }, "?v=", {
                              t: 2,
                              r: "@shared.assetsVersion"
                            }, "&size=36&padding=0"],
                            t: 13
                          }, {
                            n: "alt",
                            f: [{
                              t: 2,
                              x: {
                                r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                                s: "_0.getNetworkName(_2[_1].ipAddr)"
                              }
                            }, " logo"],
                            t: 13
                          }, {
                            n: ["error"],
                            t: 70,
                            f: {
                              r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                              s: "[_0.setLogoError(_0.getNetworkAsnByIp(_2[_1].ipAddr))]"
                            }
                          }]
                        }],
                        n: 50,
                        x: {
                          r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                          s: "_0.getNetworkAsnByIp(_2[_1].ipAddr)&&!_0.logoError(_0.getNetworkAsnByIp(_2[_1].ipAddr))"
                        }
                      }, {
                        t: 4,
                        f: [{
                          t: 7,
                          e: "span",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "c-gp-results-raw-output_list_item_header_info_entity_logo-placeholder",
                            g: 1
                          }],
                          f: [{
                            t: 2,
                            x: {
                              r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                              s: "_0.getNetworkName(_2[_1].ipAddr)[0]"
                            }
                          }]
                        }],
                        n: 51,
                        l: 1
                      }, " ", {
                        t: 7,
                        e: "span",
                        f: [{
                          t: 2,
                          x: {
                            r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                            s: "_0.getNetworkName(_2[_1].ipAddr)"
                          }
                        }]
                      }]
                    }],
                    n: 50,
                    x: {
                      r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                      s: "_0.getNetworkName(_2[_1].ipAddr)"
                    }
                  }, {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "c-gp-results-raw-output_list_item_header_info_entity_field",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "span",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "c-gp-results-raw-output_list_item_header_info_entity_loading-placeholder",
                          g: 1
                        }]
                      }]
                    }],
                    n: 50,
                    x: {
                      r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                      s: "_0.isTargetNetworkInfoLoading(_2[_1].ipAddr)"
                    },
                    l: 1
                  }]
                }],
                n: 50,
                rx: {
                  r: "./statsPerTarget",
                  m: [{
                    t: 30,
                    n: "activeTargetIdx"
                  }, "ipAddr"]
                }
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "c-gp-results-raw-output_list_item_header_metrics-controls",
                g: 1
              }],
              f: [{
                t: 4,
                f: [{
                  t: 7,
                  e: "c-dot-loader"
                }],
                n: 50,
                x: {
                  r: ["activeTargetIdx", "./statsPerTarget"],
                  s: "!_1[_0].rawOutput"
                }
              }, {
                t: 4,
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "c-gp-results-raw-output_list_item_header_metrics-controls_metrics",
                    g: 1
                  }],
                  f: [{
                    t: 4,
                    f: [{
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "c-gp-results-raw-output_list_item_header_metrics-controls_metric",
                        g: 1
                      }],
                      f: [{
                        t: 2,
                        r: "./text"
                      }, " ", {
                        t: 7,
                        e: "b",
                        f: [{
                          t: 2,
                          r: "./value"
                        }, {
                          t: 2,
                          r: "./units"
                        }]
                      }]
                    }],
                    n: 52,
                    x: {
                      r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                      s: "_0.getHeaderPrimaryMetrics(_2[_1].extraValues)"
                    }
                  }, " ", {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "c-gp-results-raw-output_list_item_header_metrics-controls_metric",
                        g: 1
                      }],
                      f: ["Time ", {
                        t: 7,
                        e: "b",
                        f: [{
                          t: 2,
                          x: {
                            r: ["_", "activeTargetIdx", "./statsPerTarget"],
                            s: "_0.getGpTargetTiming(_2[_1])"
                          }
                        }]
                      }]
                    }],
                    n: 50,
                    x: {
                      r: ["_", "activeTargetIdx", "./statsPerTarget"],
                      s: "_0.getGpTargetTiming(_2[_1])"
                    }
                  }, " ", {
                    t: 4,
                    f: [{
                      t: 4,
                      f: [{
                        t: 7,
                        e: "span",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "c-gp-results-raw-output_list_item_header_metrics-controls_metric",
                          g: 1
                        }],
                        f: [{
                          t: 2,
                          r: "./text"
                        }, " ", {
                          t: 7,
                          e: "b",
                          f: [{
                            t: 2,
                            r: "./value"
                          }, {
                            t: 2,
                            r: "./units"
                          }]
                        }]
                      }],
                      n: 52,
                      x: {
                        r: ["@this", "activeTargetIdx", "./statsPerTarget"],
                        s: "_0.getHeaderSecondaryMetrics(_2[_1].extraValues)"
                      }
                    }],
                    n: 51,
                    x: {
                      r: ["activeTargetIdx", "./statsPerTarget", "PROBE_STATUS_OFFLINE"],
                      s: "_1[_0].isFailed||_1[_0].avgTiming===_2"
                    }
                  }]
                }, " ", {
                  t: 7,
                  e: "button",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "c-gp-results-raw-output_list_item_header_metrics-controls_dropdown",
                    g: 1
                  }, {
                    n: ["click"],
                    t: 70,
                    f: {
                      r: ["@this", "./clientSideId"],
                      s: "[_0.hideShowTestResult(_1)]"
                    }
                  }, {
                    n: "role",
                    f: "button",
                    t: 13,
                    g: 1
                  }, {
                    n: "aria-label",
                    f: [{
                      t: 4,
                      f: ["Expand"],
                      n: 50,
                      x: {
                        r: ["activeTargetIdx", "hiddenTestResults", "./clientSideId"],
                        s: "_1[_0].includes(_2)"
                      }
                    }, {
                      t: 4,
                      f: ["Collapse"],
                      n: 51,
                      l: 1
                    }, " output"],
                    t: 13
                  }],
                  f: [{
                    t: 7,
                    e: "i",
                    m: [{
                      n: "class",
                      f: ["fa fa-chevron-", {
                        t: 4,
                        f: ["down"],
                        n: 50,
                        x: {
                          r: ["activeTargetIdx", "hiddenTestResults", "./clientSideId"],
                          s: "_1[_0].includes(_2)"
                        }
                      }, {
                        t: 4,
                        f: ["up"],
                        n: 51,
                        l: 1
                      }],
                      t: 13
                    }, {
                      n: "aria-hidden",
                      f: "true",
                      t: 13,
                      g: 1
                    }]
                  }]
                }],
                n: 51,
                l: 1
              }]
            }]
          }, " ", {
            t: 4,
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "c-gp-results-raw-output_list_item_output",
                g: 1
              }],
              f: [{
                t: 7,
                e: "pre",
                m: [{
                  n: "class",
                  f: [{
                    t: 4,
                    f: ["hide-code"],
                    n: 50,
                    x: {
                      r: ["activeTargetIdx", "hiddenTestResults", "./clientSideId"],
                      s: "_1[_0].includes(_2)"
                    }
                  }],
                  t: 13
                }],
                f: [{
                  t: 2,
                  rx: {
                    r: "./statsPerTarget",
                    m: [{
                      t: 30,
                      n: "activeTargetIdx"
                    }, "rawOutput"]
                  }
                }]
              }, " ", {
                t: 4,
                f: [{
                  t: 7,
                  e: "button",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "c-gp-results-raw-output_list_item_expand-output",
                    g: 1
                  }, {
                    n: "type",
                    f: "button",
                    t: 13,
                    g: 1
                  }, {
                    n: "tabindex",
                    f: "-1",
                    t: 13,
                    g: 1
                  }, {
                    n: ["click"],
                    t: 70,
                    f: {
                      r: ["@this", "./clientSideId"],
                      s: "[_0.hideShowTestResult(_1)]"
                    }
                  }, {
                    n: "aria-label",
                    f: "Click to expand",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "span",
                    f: ["Click to expand"]
                  }]
                }],
                n: 50,
                x: {
                  r: ["activeTargetIdx", "hiddenTestResults", "./clientSideId"],
                  s: "_1[_0].includes(_2)"
                }
              }, " ", {
                t: 4,
                f: [{
                  t: 4,
                  f: [{
                    t: 7,
                    e: "button",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "c-gp-results-raw-output_list_item_content-toggle",
                      g: 1
                    }, {
                      n: "type",
                      f: "button",
                      t: 13,
                      g: 1
                    }, {
                      n: ["click"],
                      t: 70,
                      f: {
                        r: ["expandAllRawOutput"],
                        s: "[_0({responseBodyOnly:true})]"
                      }
                    }, {
                      n: "aria-label",
                      f: "Show response bodies",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "i",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-chevron-down",
                        g: 1
                      }, {
                        n: "aria-hidden",
                        f: "true",
                        t: 13,
                        g: 1
                      }]
                    }, " Show response bodies"]
                  }],
                  n: 50,
                  x: {
                    r: ["@this", "."],
                    s: "_0.isResponseBodyHidden(_1)"
                  }
                }, " ", {
                  t: 7,
                  e: "br"
                }, " ", {
                  t: 7,
                  e: "pre",
                  m: [{
                    n: "class",
                    f: [{
                      t: 4,
                      f: ["hide-code"],
                      n: 50,
                      x: {
                        r: ["@this", "."],
                        s: "_0.isResponseBodyHidden(_1)"
                      }
                    }, " response-body"],
                    t: 13
                  }],
                  f: [{
                    t: 2,
                    rx: {
                      r: "./statsPerTarget",
                      m: [{
                        t: 30,
                        n: "activeTargetIdx"
                      }, "responseBody"]
                    }
                  }]
                }],
                n: 50,
                x: {
                  r: ["./statsPerTarget", "activeTargetIdx", "hiddenTestResults", "./clientSideId"],
                  s: "_0[_1].responseBody&&!_2[_1].includes(_3)"
                }
              }, {
                t: 4,
                f: [{
                  t: 7,
                  e: "pre",
                  m: [{
                    n: "class",
                    f: [{
                      t: 4,
                      f: ["hidden"],
                      n: 50,
                      x: {
                        r: ["activeTargetIdx", "hiddenTestResults", "./clientSideId"],
                        s: "_1[_0].includes(_2)"
                      }
                    }],
                    t: 13
                  }],
                  f: [{
                    t: 2,
                    rx: {
                      r: "./statsPerTarget",
                      m: [{
                        t: 30,
                        n: "activeTargetIdx"
                      }, "rawFooter"]
                    }
                  }]
                }],
                n: 50,
                x: {
                  r: ["testInProgress", "isInfiniteModeRes"],
                  s: "_0===false&&_1"
                },
                l: 1
              }]
            }],
            n: 50,
            rx: {
              r: "./statsPerTarget",
              m: [{
                t: 30,
                n: "activeTargetIdx"
              }, "rawOutput"]
            }
          }]
        }],
        n: 52,
        r: "preparedTestResults"
      }, " ", {
        t: 4,
        f: [{
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "c-gp-results-raw-output_list_item c-gp-results-raw-output_list_item_loading",
              g: 1
            }, {
              n: "aria-hidden",
              f: "true",
              t: 13,
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "c-gp-results-raw-output_list_item_header",
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "c-gp-results-raw-output_list_item_header_info",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "c-gp-results-raw-output_list_item_header_info_entity",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "c-gp-results-raw-output_list_item_header_info_entity_field",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "c-gp-results-raw-output_list_item_header_info_entity_loading-placeholder",
                        g: 1
                      }]
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "c-gp-results-raw-output_list_item_header_info_entity_field",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "c-gp-results-raw-output_list_item_header_info_entity_loading-placeholder",
                        g: 1
                      }]
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "c-gp-results-raw-output_list_item_header_info_entity_field",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "c-gp-results-raw-output_list_item_header_info_entity_loading-placeholder",
                        g: 1
                      }]
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "c-gp-results-raw-output_list_item_header_metrics-controls",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "c-dot-loader"
                }]
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "c-gp-results-raw-output_list_item_output",
                g: 1
              }],
              f: [{
                t: 7,
                e: "c-placeholder-skeleton",
                m: [{
                  n: "type",
                  f: "descr",
                  t: 13,
                  g: 1
                }]
              }]
            }]
          }],
          n: 52,
          r: "loadingProbeResults"
        }],
        n: 50,
        r: "testInProgress"
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "c-gp-results-raw-output_set-location-hitarea",
          g: 1
        }, {
          n: "style",
          f: ["top: ", {
            t: 2,
            r: "floatingSetLocationButton.top"
          }, "px; left: ", {
            t: 2,
            x: {
              r: ["floatingSetLocationButton.left"],
              s: "_0-4"
            }
          }, "px; height: ", {
            t: 2,
            r: "floatingSetLocationButton.height"
          }, "px;"],
          t: 13
        }, {
          n: ["mouseleave"],
          t: 70,
          f: {
            r: ["@this", "@event"],
            s: "[_0.hideSetLocationButton(_1)]"
          }
        }],
        f: [{
          t: 7,
          e: "button",
          m: [{
            n: "class",
            f: ["c-gp-results-raw-output_set-location ", {
              t: 4,
              f: ["focus-outline"],
              n: 50,
              r: "itemFocused"
            }],
            t: 13
          }, {
            n: "type",
            f: "button",
            t: 13,
            g: 1
          }, {
            n: "tabindex",
            f: "-1",
            t: 13,
            g: 1
          }, {
            n: "style",
            f: ["top: ", {
              t: 2,
              r: "floatingSetLocationButton.buttonTop"
            }, "px;"],
            t: 13
          }, {
            n: "tooltip",
            t: 71,
            f: {
              r: [],
              s: "[\"Set as location for the next test\",\"right\"]"
            }
          }, {
            n: ["focus"],
            t: 70,
            f: {
              r: ["@this"],
              s: "[_0.set(\"itemFocused\",true)]"
            }
          }, {
            n: ["blur"],
            t: 70,
            f: {
              r: ["@this", "@event"],
              s: "[_0.hideSetLocationButton(_1)]"
            }
          }, {
            n: ["click"],
            t: 70,
            f: {
              r: ["@this"],
              s: "[_0.setProbeAsLocation()]"
            }
          }, {
            n: "aria-label",
            f: "Set as location for the next test",
            t: 13,
            g: 1
          }],
          f: [{
            t: 7,
            e: "i",
            m: [{
              t: 13,
              n: "class",
              f: "fa fa-map-marker",
              g: 1
            }, {
              n: "aria-hidden",
              f: "true",
              t: 13,
              g: 1
            }]
          }]
        }]
      }],
      n: 50,
      x: {
        r: ["showSetLocationButton", "floatingSetLocationButton.visible"],
        s: "_0&&_1"
      }
    }]
  }],
  e: {
    "[_0.hideSetLocationButton(_1)]": function (_0, _1) {
      return [_0.hideSetLocationButton(_1)];
    },
    "[_0.enableItemFocused(_1,_2)]": function (_0, _1, _2) {
      return [_0.enableItemFocused(_1, _2)];
    },
    "[_0.headerKeydownHandler(_1,_2)]": function (_0, _1, _2) {
      return [_0.headerKeydownHandler(_1, _2)];
    },
    "[_0.showSetLocationButton(_1)]": function (_0, _1) {
      return [_0.showSetLocationButton(_1)];
    },
    "_0.shouldUseOverflowLayout(_1)": function (_0, _1) {
      return _0.shouldUseOverflowLayout(_1);
    },
    "_0.getStatusColor(_2[_1])": function (_0, _1, _2) {
      return _0.getStatusColor(_2[_1]);
    },
    "[_0.set(\"showingNetworkLogos\",true)]": function (_0) {
      return [_0.set("showingNetworkLogos", true)];
    },
    "[_0.setLogoError(_1)]": function (_0, _1) {
      return [_0.setLogoError(_1)];
    },
    "!_0.logoError(_1)": function (_0, _1) {
      return !_0.logoError(_1);
    },
    "_0.isAnycastIp(_2[_1].ipAddr)": function (_0, _1, _2) {
      return _0.isAnycastIp(_2[_1].ipAddr);
    },
    "_0.getIpLocationCountryCode(_2[_1].ipAddr)": function (_0, _1, _2) {
      return _0.getIpLocationCountryCode(_2[_1].ipAddr);
    },
    "_0.getIpLocationLabel(_2[_1].ipAddr)": function (_0, _1, _2) {
      return _0.getIpLocationLabel(_2[_1].ipAddr);
    },
    "_0.isAnycastIp(_2[_1].ipAddr)||_0.getIpLocationLabel(_2[_1].ipAddr)": function (_0, _1, _2) {
      return _0.isAnycastIp(_2[_1].ipAddr) || _0.getIpLocationLabel(_2[_1].ipAddr);
    },
    "_0.isTargetNetworkInfoLoading(_2[_1].ipAddr)": function (_0, _1, _2) {
      return _0.isTargetNetworkInfoLoading(_2[_1].ipAddr);
    },
    "_0.getNetworkAsnByIp(_2[_1].ipAddr)": function (_0, _1, _2) {
      return _0.getNetworkAsnByIp(_2[_1].ipAddr);
    },
    "_0.getNetworkName(_2[_1].ipAddr)": function (_0, _1, _2) {
      return _0.getNetworkName(_2[_1].ipAddr);
    },
    "[_0.setLogoError(_0.getNetworkAsnByIp(_2[_1].ipAddr))]": function (_0, _1, _2) {
      return [_0.setLogoError(_0.getNetworkAsnByIp(_2[_1].ipAddr))];
    },
    "_0.getNetworkAsnByIp(_2[_1].ipAddr)&&!_0.logoError(_0.getNetworkAsnByIp(_2[_1].ipAddr))": function (_0, _1, _2) {
      return _0.getNetworkAsnByIp(_2[_1].ipAddr) && !_0.logoError(_0.getNetworkAsnByIp(_2[_1].ipAddr));
    },
    "_0.getNetworkName(_2[_1].ipAddr)[0]": function (_0, _1, _2) {
      return _0.getNetworkName(_2[_1].ipAddr)[0];
    },
    "!_1[_0].rawOutput": function (_0, _1) {
      return !_1[_0].rawOutput;
    },
    "_0.getHeaderPrimaryMetrics(_2[_1].extraValues)": function (_0, _1, _2) {
      return _0.getHeaderPrimaryMetrics(_2[_1].extraValues);
    },
    "_0.getGpTargetTiming(_2[_1])": function (_0, _1, _2) {
      return _0.getGpTargetTiming(_2[_1]);
    },
    "_0.getHeaderSecondaryMetrics(_2[_1].extraValues)": function (_0, _1, _2) {
      return _0.getHeaderSecondaryMetrics(_2[_1].extraValues);
    },
    "_1[_0].isFailed||_1[_0].avgTiming===_2": function (_0, _1, _2) {
      return _1[_0].isFailed || _1[_0].avgTiming === _2;
    },
    "[_0.hideShowTestResult(_1)]": function (_0, _1) {
      return [_0.hideShowTestResult(_1)];
    },
    "_1[_0].includes(_2)": function (_0, _1, _2) {
      return _1[_0].includes(_2);
    },
    "[_0({responseBodyOnly:true})]": function (_0) {
      return [_0({
        responseBodyOnly: true
      })];
    },
    "_0.isResponseBodyHidden(_1)": function (_0, _1) {
      return _0.isResponseBodyHidden(_1);
    },
    "_0[_1].responseBody&&!_2[_1].includes(_3)": function (_0, _1, _2, _3) {
      return _0[_1].responseBody && !_2[_1].includes(_3);
    },
    "_0===false&&_1": function (_0, _1) {
      return _0 === false && _1;
    },
    "_0-4": function (_0) {
      return _0 - 4;
    },
    "[\"Set as location for the next test\",\"right\"]": function () {
      return ["Set as location for the next test", "right"];
    },
    "[_0.set(\"itemFocused\",true)]": function (_0) {
      return [_0.set("itemFocused", true)];
    },
    "[_0.setProbeAsLocation()]": function (_0) {
      return [_0.setProbeAsLocation()];
    },
    "_0&&_1": function (_0, _1) {
      return _0 && _1;
    }
  }
};
component$w.exports.components = {
  "c-placeholder-skeleton": placeholderSkeleton,
  "c-dot-loader": dotLoader,
  "c-gp-tls-details": tlsDetails
};
var resultsRawOutput = ractive.extend(component$w.exports);

var component$v = {
  exports: {}
};
component$v.exports = {
  decorators: {
    tooltip
  },
  data() {
    return {
      collapseOutput: () => null,
      expandOutput: () => null,
      allCollapsed: false
    };
  },
  computed: {
    collapseTooltip() {
      return this.get('allCollapsed') ? 'Expand all output' : 'Collapse all output';
    }
  },
  handleTabSwitch(idx) {
    if (this.get('rawOutputMode')) {
      this.set('activeTargetIdx', idx);
    }
  },
  handleDisplayTypeInputClick(event) {
    event.preventDefault();
    this.handleDisplayTypeSwitch(!this.get('rawOutputMode'));
  },
  handleDisplayTypeInputKeyDown(event) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      this.handleDisplayTypeSwitch(!this.get('rawOutputMode'));
    }
  },
  handleDisplayTypeLabelClick(event) {
    event.preventDefault();
  },
  handleDisplayTypeSwitch(rawOutputMode) {
    if (this.get('testType') !== 'ping') {
      return;
    }
    this.set('rawOutputMode', rawOutputMode);
  },
  onSortOptionSelect(field) {
    if (this.get('sortBy') === field) {
      this.set('sortOrder', this.get('sortOrder') === 'asc' ? 'desc' : 'asc');
    } else {
      this.set('sortBy', field);
      this.set('sortOrder', 'asc');
    }
    return false;
  }
};
component$v.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-gp-results-controls",
      g: 1
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "content-wrapper",
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          n: "class",
          f: ["content-wrapper_tabs ", {
            t: 4,
            f: ["single-target"],
            n: 50,
            x: {
              r: ["targets", "targets.length"],
              s: "_0&&_1===1"
            }
          }, " ", {
            t: 4,
            f: ["table-mode"],
            n: 51,
            r: "rawOutputMode"
          }],
          t: 13
        }],
        f: [{
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              n: ["click"],
              t: 70,
              f: {
                r: ["@this", "idx"],
                s: "[_0.handleTabSwitch(_1)]"
              }
            }, {
              n: "class",
              f: ["content-wrapper_tabs_tab ", {
                t: 4,
                f: ["active"],
                n: 50,
                x: {
                  r: ["idx", "activeTargetIdx", "rawOutputMode"],
                  s: "_0===_1&&_2"
                }
              }, " ", {
                t: 4,
                f: ["disabled"],
                n: 51,
                r: "rawOutputMode"
              }],
              t: 13
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "content-wrapper_tabs_tab_text",
                g: 1
              }],
              f: [{
                t: 2,
                r: "."
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "active-tab-bar",
                g: 1
              }]
            }]
          }],
          n: 52,
          i: "idx",
          r: "targets"
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "content-wrapper_ctrls",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            n: "class",
            f: ["content-wrapper_ctrls_switch ", {
              t: 4,
              f: ["content-wrapper_ctrls_switch--disabled"],
              n: 50,
              x: {
                r: ["testType"],
                s: "_0!==\"ping\""
              }
            }],
            t: 13
          }, {
            n: "data-testid",
            f: "results-display-switch",
            t: 13,
            g: 1
          }],
          f: [{
            t: 7,
            e: "input",
            m: [{
              n: "id",
              f: "display-type",
              t: 13
            }, {
              n: "type",
              f: "checkbox",
              t: 13
            }, {
              n: "checked",
              f: [{
                t: 2,
                r: "rawOutputMode"
              }],
              t: 13
            }, {
              t: 73,
              v: "t",
              f: "false"
            }, {
              n: "disabled",
              f: [{
                t: 2,
                x: {
                  r: ["testType"],
                  s: "_0!==\"ping\""
                }
              }],
              t: 13
            }, {
              n: "class",
              f: ["switch-input ", {
                t: 4,
                f: ["table"],
                n: 51,
                r: "rawOutputMode"
              }],
              t: 13
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this", "@event"],
                s: "[_0.handleDisplayTypeInputClick(_1)]"
              }
            }, {
              n: ["keydown"],
              t: 70,
              f: {
                r: ["@this", "@event"],
                s: "[_0.handleDisplayTypeInputKeyDown(_1)]"
              }
            }]
          }, " ", {
            t: 7,
            e: "label",
            m: [{
              n: "for",
              f: "display-type",
              t: 13,
              g: 1
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this", "@event"],
                s: "[_0.handleDisplayTypeLabelClick(_1)]"
              }
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this"],
                  s: "[_0.handleDisplayTypeSwitch(true)]"
                }
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "16",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "16",
                  t: 13,
                  g: 1
                }, {
                  n: "alt",
                  f: "",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/raw-output-icon", {
                    t: 4,
                    f: [".active"],
                    n: 50,
                    r: "rawOutputMode"
                  }, ".svg"],
                  t: 13
                }]
              }, " List"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this"],
                  s: "[_0.handleDisplayTypeSwitch(false)]"
                }
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "16",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "16",
                  t: 13,
                  g: 1
                }, {
                  n: "alt",
                  f: "",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/table-output-icon", {
                    t: 4,
                    f: [".active"],
                    n: 51,
                    r: "rawOutputMode"
                  }, ".svg"],
                  t: 13
                }]
              }, " Table"]
            }]
          }]
        }, " ", {
          t: 7,
          e: "button",
          m: [{
            n: "class",
            f: ["content-wrapper_ctrls_map-switch ", {
              t: 4,
              f: ["content-wrapper_ctrls_map-switch--active"],
              n: 50,
              r: "showMap"
            }],
            t: 13
          }, {
            n: "type",
            f: "button",
            t: 13,
            g: 1
          }, {
            n: "data-testid",
            f: "map-switch",
            t: 13,
            g: 1
          }, {
            n: "tooltip",
            t: 71,
            f: {
              r: ["showMap"],
              s: "[_0?\"Hide map\":\"Show map\"]"
            }
          }, {
            n: "aria-label",
            f: [{
              t: 4,
              f: ["Hide map"],
              n: 50,
              r: "showMap"
            }, {
              t: 4,
              f: ["Show map"],
              n: 51,
              l: 1
            }],
            t: 13
          }, {
            n: ["click"],
            t: 70,
            f: {
              r: ["@this", "showMap"],
              s: "[_0.set(\"originalShowMap\",!_1),_0.set(\"showMap\",!_1)]"
            }
          }],
          f: [{
            t: 7,
            e: "img",
            m: [{
              n: "width",
              f: "13",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "13",
              t: 13,
              g: 1
            }, {
              n: "alt",
              f: "",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/map-icon", {
                t: 4,
                f: [".active"],
                n: 50,
                r: "showMap"
              }, ".svg"],
              t: 13
            }]
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "content-wrapper_ctrls_sort-options desktop-hidden dropdown",
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "btn-group",
                g: 1
              }],
              f: [{
                t: 7,
                e: "button",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-toggle content-wrapper_ctrls_btn",
                  g: 1
                }, {
                  n: "type",
                  f: "button",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-label",
                  f: "Sort results",
                  t: 13,
                  g: 1
                }, {
                  n: "data-toggle",
                  f: "dropdown",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-haspopup",
                  f: "true",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-expanded",
                  f: "false",
                  t: 13,
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "img",
                  m: [{
                    n: "width",
                    f: "18",
                    t: 13,
                    g: 1
                  }, {
                    n: "height",
                    f: "18",
                    t: 13,
                    g: 1
                  }, {
                    n: "alt",
                    f: "",
                    t: 13,
                    g: 1
                  }, {
                    n: "src",
                    f: [{
                      t: 2,
                      r: "@shared.assetsHost"
                    }, "/img/sort-", {
                      t: 2,
                      r: "sortOrder"
                    }, ".svg"],
                    t: 13
                  }]
                }]
              }, " ", {
                t: 7,
                e: "ul",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-menu dropdown-menu-right",
                  g: 1
                }, {
                  n: "role",
                  f: "listbox",
                  t: 13,
                  g: 1
                }],
                f: [{
                  t: 4,
                  f: [{
                    t: 7,
                    e: "li",
                    m: [{
                      n: "role",
                      f: "option",
                      t: 13,
                      g: 1
                    }, {
                      n: "aria-selected",
                      f: [{
                        t: 2,
                        x: {
                          r: ["sortBy", "./value"],
                          s: "_0===_1"
                        }
                      }],
                      t: 13
                    }, {
                      n: ["click"],
                      t: 70,
                      f: {
                        r: ["@this", "./value"],
                        s: "[_0.onSortOptionSelect(_1)]"
                      }
                    }, {
                      n: "class",
                      f: ["dropdown-item ", {
                        t: 4,
                        f: ["selected"],
                        n: 50,
                        x: {
                          r: ["sortBy", "./value"],
                          s: "_0===_1"
                        }
                      }],
                      t: 13
                    }],
                    f: [{
                      t: 2,
                      r: "./name"
                    }, " ", {
                      t: 4,
                      f: [{
                        t: 7,
                        e: "img",
                        m: [{
                          n: "width",
                          f: "9",
                          t: 13,
                          g: 1
                        }, {
                          n: "alt",
                          f: [{
                            t: 2,
                            r: "sortOrder"
                          }],
                          t: 13
                        }, {
                          n: "src",
                          f: [{
                            t: 2,
                            r: "@shared.assetsHost"
                          }, "/img/sort-", {
                            t: 2,
                            r: "sortOrder"
                          }, "-sm.svg"],
                          t: 13
                        }]
                      }],
                      n: 50,
                      x: {
                        r: ["sortBy", "./value"],
                        s: "_0===_1"
                      }
                    }]
                  }],
                  n: 52,
                  r: "sortByOpts"
                }]
              }]
            }]
          }],
          n: 50,
          x: {
            r: ["testType"],
            s: "_0===\"ping\""
          }
        }, " ", {
          t: 7,
          e: "button",
          m: [{
            t: 13,
            n: "class",
            f: "content-wrapper_ctrls_collapse",
            g: 1
          }, {
            n: "type",
            f: "button",
            t: 13,
            g: 1
          }, {
            n: "disabled",
            f: [{
              t: 2,
              x: {
                r: ["rawOutputMode"],
                s: "!_0"
              }
            }],
            t: 13
          }, {
            t: 4,
            f: [{
              n: "tooltip",
              t: 71,
              f: {
                r: ["collapseTooltip"],
                s: "[_0]"
              }
            }, {
              n: "aria-label",
              f: [{
                t: 2,
                r: "collapseTooltip"
              }],
              t: 13
            }],
            n: 50,
            r: "rawOutputMode"
          }, {
            n: ["click"],
            t: 70,
            f: {
              r: ["allCollapsed", "expandOutput", "collapseOutput"],
              s: "[_0?_1():_2()]"
            }
          }],
          f: [{
            t: 4,
            f: [{
              t: 7,
              e: "i",
              m: [{
                t: 13,
                n: "class",
                f: "fa fa-chevron-down",
                g: 1
              }]
            }, " ", {
              t: 7,
              e: "i",
              m: [{
                t: 13,
                n: "class",
                f: "fa fa-chevron-down",
                g: 1
              }]
            }],
            n: 50,
            r: "allCollapsed"
          }, {
            t: 4,
            f: [{
              t: 7,
              e: "i",
              m: [{
                t: 13,
                n: "class",
                f: "fa fa-chevron-up",
                g: 1
              }]
            }, " ", {
              t: 7,
              e: "i",
              m: [{
                t: 13,
                n: "class",
                f: "fa fa-chevron-up",
                g: 1
              }]
            }],
            n: 51,
            l: 1
          }]
        }]
      }]
    }]
  }],
  e: {
    "_0&&_1===1": function (_0, _1) {
      return _0 && _1 === 1;
    },
    "[_0.handleTabSwitch(_1)]": function (_0, _1) {
      return [_0.handleTabSwitch(_1)];
    },
    "_0===_1&&_2": function (_0, _1, _2) {
      return _0 === _1 && _2;
    },
    "_0!==\"ping\"": function (_0) {
      return _0 !== "ping";
    },
    "[_0.handleDisplayTypeInputClick(_1)]": function (_0, _1) {
      return [_0.handleDisplayTypeInputClick(_1)];
    },
    "[_0.handleDisplayTypeInputKeyDown(_1)]": function (_0, _1) {
      return [_0.handleDisplayTypeInputKeyDown(_1)];
    },
    "[_0.handleDisplayTypeLabelClick(_1)]": function (_0, _1) {
      return [_0.handleDisplayTypeLabelClick(_1)];
    },
    "[_0.handleDisplayTypeSwitch(true)]": function (_0) {
      return [_0.handleDisplayTypeSwitch(true)];
    },
    "[_0.handleDisplayTypeSwitch(false)]": function (_0) {
      return [_0.handleDisplayTypeSwitch(false)];
    },
    "[_0?\"Hide map\":\"Show map\"]": function (_0) {
      return [_0 ? "Hide map" : "Show map"];
    },
    "[_0.set(\"originalShowMap\",!_1),_0.set(\"showMap\",!_1)]": function (_0, _1) {
      return [_0.set("originalShowMap", !_1), _0.set("showMap", !_1)];
    },
    "_0===_1": function (_0, _1) {
      return _0 === _1;
    },
    "[_0.onSortOptionSelect(_1)]": function (_0, _1) {
      return [_0.onSortOptionSelect(_1)];
    },
    "_0===\"ping\"": function (_0) {
      return _0 === "ping";
    },
    "!_0": function (_0) {
      return !_0;
    },
    "[_0]": function (_0) {
      return [_0];
    },
    "[_0?_1():_2()]": function (_0, _1, _2) {
      return [_0 ? _1() : _2()];
    }
  }
};
var resultsControls = ractive.extend(component$v.exports);

// MIT licensed from https://www.npmjs.com/package/ip-regex
const word = '[a-fA-F\\d:]';
const boundary = options => options && options.includeBoundaries ? `(?:(?<=\\s|^)(?=${word})|(?<=${word})(?=\\s|$))` : '';
const v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
const v6segment = '[a-fA-F\\d]{1,4}';
const v6 = `
(?:
(?:${v6segment}:){7}(?:${v6segment}|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:${v6segment}:){6}(?:${v4}|:${v6segment}|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:${v6segment}:){5}(?::${v4}|(?::${v6segment}){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:${v6segment}:){4}(?:(?::${v6segment}){0,1}:${v4}|(?::${v6segment}){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:${v6segment}:){3}(?:(?::${v6segment}){0,2}:${v4}|(?::${v6segment}){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:${v6segment}:){2}(?:(?::${v6segment}){0,3}:${v4}|(?::${v6segment}){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:${v6segment}:){1}(?:(?::${v6segment}){0,4}:${v4}|(?::${v6segment}){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::${v6segment}){0,5}:${v4}|(?::${v6segment}){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`.replace(/\s*\/\/.*$/gm, '').replace(/\n/g, '').trim();

// Pre-compile only the exact regexes because adding a global flag make regexes stateful
const v46Exact = new RegExp(`(?:^${v4}$)|(?:^${v6}$)`);
const v46ExactOrV6Bracketed = new RegExp(`^(?:${v4}|${v6}|\\[${v6}\\])$`);
const v4exact = new RegExp(`^${v4}$`);
const v6exact = new RegExp(`^${v6}$`);
const v6exactOrBracketed = new RegExp(`^(?:\\[${v6}\\]|${v6})$`);
const ipRegex = options => options && options.exact ? options?.allowBrackets ? v46ExactOrV6Bracketed : v46Exact : options?.allowBrackets ? new RegExp(`(?:${boundary(options)}${v4}${boundary(options)})|(?:${boundary(options)}${v6}${boundary(options)})|(?:${boundary(options)}\\[${v6}\\]${boundary(options)})`, 'g') : new RegExp(`(?:${boundary(options)}${v4}${boundary(options)})|(?:${boundary(options)}${v6}${boundary(options)})`, 'g');
ipRegex.v4 = options => options && options.exact ? v4exact : new RegExp(`${boundary(options)}${v4}${boundary(options)}`, 'g');
ipRegex.v6 = options => options?.exact ? options?.allowBrackets ? v6exactOrBracketed : v6exact : options?.allowBrackets ? new RegExp(`(?:${boundary(options)}${v6}${boundary(options)})|(?:${boundary(options)}\\[${v6}\\]${boundary(options)})`, 'g') : new RegExp(`${boundary(options)}${v6}${boundary(options)}`, 'g');
var ipRegex_1 = ipRegex;

var component$u = {
  exports: {}
};
const IP_V4_VALUE = 4;
const IP_V6_VALUE = 6;
component$u.exports = {
  decorators: {
    tooltip
  },
  data() {
    return {
      invalidValue: null,
      errMsgTopPos: false,
      inputValue: '',
      inputWrapperIdPrefix: 'tags-block-',
      valuesDelimiter: ',',
      maxTagsAllowed: 2,
      tagsArr: [],
      isDisabled: false,
      useGpTargetHandler: false,
      // ipVersion should be set only for 1 target when it is a domain name
      ipVersion: null,
      ipVersionDisplayed: null,
      ipSwitchLocked: false,
      IP_V4_VALUE,
      IP_V6_VALUE
    };
  },
  oninit() {
    if (!ractive.isServer) {
      this.observe('error', error => {
        if (error) {
          this.set('invalidValue', this.get('value'));
          this.set('ipVersion', null);
          this.set('ipVersionDisplayed', null);
        } else {
          this.handleIpSwitchState();
        }
      }, {
        init: false
      });
      this.observe('value', value => {
        let invalidValue = this.get('invalidValue');
        let error = this.get('error');
        if (error && invalidValue !== value) {
          this.set('error', undefined);
        }
      });
      this.observe('screenWidth', screenWidth => {
        if ((screenWidth || window.innerWidth) < 768) {
          this.set('errMsgTopPos', true);
        } else {
          this.set('errMsgTopPos', false);
        }
      });
      this.observe('value', value => {
        let valuesDelimiter = this.get('valuesDelimiter');
        this.set('tagsArr', value ? value.split(valuesDelimiter).map(tag => tag.trim()) : []);
      });

      // handle ip type switch
      this.observe('tagsArr', () => {
        this.handleIpSwitchState();
      });

      // set default value is it was passed as prop
      this.observe('defaultValue', defaultValue => {
        let setDefaultValueInitially = this.get('setDefaultValueInitially');
        if (defaultValue && setDefaultValueInitially) {
          this.set('value', defaultValue);
        }
      });

      // for share-results case we need to set displayed value
      this.observe('ipVersion', ipVersion => {
        this.set('ipVersionDisplayed', ipVersion);
      });
    }
  },
  onrender() {
    listeners.screenWidthListener(this);
  },
  oncomplete() {
    if (!ractive.isServer) {
      let inputWrapperIdPrefix = this.get('inputWrapperIdPrefix');
      let inputId = this.get('inputId');
      let inputEl = this.find(`#${inputId}`);
      let ipTypeSwitchEl = this.find('.switch-ip-type-wrapper');
      let tagsBlockEl = this.find(`#${inputWrapperIdPrefix + inputId}`);

      // handle input changes
      inputEl.addEventListener('keydown', e => {
        let currMaxTagsAllowed = this.get('maxTagsAllowed');
        let currTagsArr = this.get('tagsArr');
        let inputValue = this.get('inputValue');
        let defaultValue = this.get('defaultValue');
        if (this.get('isDisabled')) {
          e.preventDefault();
          return;
        }

        // while there are already max tags and key is not Backspace - ignore input changes
        if (currTagsArr.length === currMaxTagsAllowed && e.key !== 'Tab' && e.key !== 'Backspace' && e.key !== 'Enter') {
          e.preventDefault();
          return;
        }

        // if input has some value which is not added as tag yet - add tag on Enter/Tab, on second Enter/Tab run measurement/switch to the next field
        // if user did not passed any value, on Enter add default one, if presented, and run measurement
        // handle keys for adding new tags, removing tags, allow to bubble event on Enter key etc.
        if (['Enter', 'Tab'].includes(e.key) && !inputValue) {
          if (defaultValue && currTagsArr.length === 0) {
            this.set('value', defaultValue);
          }
          tagsBlockEl.classList.remove('focused');
        } else if (['Enter', 'Tab', ' ', ','].includes(e.key)) {
          this.addTag();

          // Prevent Enter always and Tab when only 1 target is filled
          if (e.key === 'Enter') {
            e.preventDefault();
          }
          if (e.key === 'Tab') {
            if (currTagsArr.length < currMaxTagsAllowed) {
              e.preventDefault();
            } else {
              tagsBlockEl.classList.remove('focused');
            }
          }
        } else if (e.key === 'Backspace') {
          this.removeLastTag();
        }
      });

      // on focusout add the content of the input as a tag if it matches conditions
      inputEl.addEventListener('focusout', () => {
        let inputValue = this.get('inputValue');
        let tagsArr = this.get('tagsArr');
        let defaultValue = this.get('defaultValue');

        // set default value if user did not fill in something and focusout
        if (defaultValue && !inputValue && tagsArr.length === 0) {
          this.set('value', defaultValue);
        } else {
          this.addTag();
        }
      });

      // handle focus styles
      tagsBlockEl.addEventListener('click', e => {
        let switchIpTypeEl = this.find('.switch-ip-type-wrapper');
        if (!switchIpTypeEl.contains(e.target)) {
          this.handleInputFocus(tagsBlockEl);
        }
      });
      inputEl.addEventListener('focus', () => {
        this.handleInputFocus(tagsBlockEl);
      });
      let handleOnClickOutside = e => {
        if (e.target.isConnected && !tagsBlockEl.contains(e.target)) {
          tagsBlockEl.classList.remove('focused');
        }
      };
      listeners.addManagedListener(this, document, 'click', handleOnClickOutside);
      this.observe('isDisabled', isDisabled => {
        if (isDisabled) {
          tagsBlockEl.classList.remove('focused');
        }
      });

      // handle paste event
      inputEl.addEventListener('paste', event => {
        event.preventDefault();
        let rawPasteContent = (event.clipboardData || window.clipboardData).getData('text').trim();
        let tagsArr = this.get('tagsArr');
        let valuesDelimiter = this.get('valuesDelimiter');
        this.handleOptsOnTargetInputFullURL(rawPasteContent, tagsArr, valuesDelimiter);
      });

      // toggle IP version switch on SPACE
      ipTypeSwitchEl.addEventListener('keydown', e => {
        if ([' '].includes(e.key)) {
          e.stopPropagation();
          e.preventDefault();
          let ipVersion = this.get('ipVersion');
          let ipVersionDisplayed = this.get('ipVersionDisplayed') || IP_V4_VALUE;
          let ipSwitchLocked = this.get('ipSwitchLocked');
          if (!ipSwitchLocked) {
            this.set('ipVersion', ipVersion === null ? ipVersion : ipVersion === IP_V4_VALUE ? IP_V6_VALUE : IP_V4_VALUE);
            this.set('ipVersionDisplayed', ipVersionDisplayed === IP_V4_VALUE ? IP_V6_VALUE : IP_V4_VALUE);
          }
        }
      });
      ipTypeSwitchEl.addEventListener('focus', e => {
        this.handleIpTypeSwitchFocus(e, tagsBlockEl);
      });
    }
  },
  addTag(clearInput = true) {
    let maxTagsAllowed = this.get('maxTagsAllowed');
    let valuesDelimiter = this.get('valuesDelimiter');
    let inputValue = this.get('inputValue').trim();
    let tagsArr = this.get('tagsArr');
    if (tagsArr.length < maxTagsAllowed) {
      if (!tagsArr.includes(inputValue) && inputValue !== '') {
        let updTagsArr = [...tagsArr, inputValue];
        let targetInputValue = updTagsArr.join(valuesDelimiter);
        if (this.get('useGpTargetHandler')) {
          this.handleOptsOnTargetInputFullURL(inputValue, tagsArr, valuesDelimiter);
        } else {
          this.set('value', targetInputValue);
        }
      }

      // to overwrite inputValues as ',' or '' set by browser we should call it via setTimeout
      if (clearInput) {
        setTimeout(() => {
          this.set('inputValue', '');
        }, 4);
      }
    }
  },
  removeLastTag() {
    let valuesDelimiter = this.get('valuesDelimiter');
    let inputValue = this.get('inputValue');
    let tagsArr = this.get('tagsArr');
    if (inputValue === '') {
      tagsArr.pop();
      this.set('value', tagsArr.join(valuesDelimiter));
    }
  },
  removeTagByIdx(tagIdx) {
    if (this.get('isDisabled')) {
      return;
    }
    let valuesDelimiter = this.get('valuesDelimiter');
    let tagsArr = this.get('tagsArr');
    tagsArr.splice(tagIdx, 1);
    this.set('value', tagsArr.join(valuesDelimiter));

    // set back focus to the input
    let inputId = this.get('inputId');
    let inputEl = this.find(`#${inputId}`);
    inputEl.focus();
  },
  handleInputFocus(tagsBlockEl) {
    let isDisabled = this.get('isDisabled');
    let defaultValue = this.get('defaultValue');
    let currentValue = this.get('value');
    if (!isDisabled && !tagsBlockEl.classList.contains('focused')) {
      tagsBlockEl.classList.add('focused');

      // clear default tag on focus
      if (defaultValue && currentValue && currentValue === defaultValue) {
        this.set('value', '');
      }
    }
  },
  onTagClick(index) {
    this.addTag(false);
    this.set('inputValue', this.get('tagsArr')[index]);
    this.removeTagByIdx(index);
  },
  handleOptsOnTargetInputFullURL(url, tagsArr = null, delimiter = null) {
    try {
      let {
        protocol,
        port,
        pathname,
        hostname,
        search
      } = new URL(url);
      pathname = pathname !== '/' ? pathname : '';
      search = search.replace('?', '');
      if (!hostname) {
        // Just one extra check. The constructor above may throw too.
        throw new Error('Invalid URL');
      }
      if (pathname || search) {
        this.set('gpMainOpts.type', 'HTTP');
      }
      if (this.get('gpMainOpts.type') === 'HTTP') {
        this.set('gpHttpOpts.protocol', protocol.replace(':', '').toUpperCase());
        this.set('gpNotAppliedOpts.request.path', pathname);
        this.set('gpNotAppliedOpts.request.query', search);
      }
      this.set('gpMainOpts.target', tagsArr ? [...tagsArr, hostname].join(delimiter) : hostname);
      this.set('gpNotAppliedOpts.port', port);
      this.set('tagsArr', tagsArr ? [...tagsArr, hostname] : [hostname]);
    } catch {
      this.set('gpMainOpts.target', tagsArr ? [...tagsArr, url].join(delimiter) : url);
      this.set('tagsArr', tagsArr ? [...tagsArr, url] : [url]);
    } finally {
      let gpUrlHandlerCb = this.get('gpUrlHandlerCb');
      gpUrlHandlerCb();
    }
  },
  handleIpVersionSwitch(ipVersion) {
    let isDisabled = this.get('isDisabled');
    let ipSwitchLocked = this.get('ipSwitchLocked');
    if (isDisabled || ipSwitchLocked) {
      return;
    }
    this.set('ipVersion', ipVersion);
    this.set('ipVersionDisplayed', ipVersion);
  },
  handleIpTypeSwitchFocus(e, tagsBlockEl) {
    tagsBlockEl.classList.remove('focused');
  },
  handleIpSwitchState() {
    let tagsArr = this.get('tagsArr');
    let ipv4regex = ipRegex_1.v4({
      exact: true
    });
    let ipv6regex = ipRegex_1.v6({
      exact: true,
      allowBrackets: true
    });
    if (tagsArr.length && tagsArr.every(target => ipv4regex.test(target))) {
      this.set('ipVersion', null);
      this.set('ipVersionDisplayed', IP_V4_VALUE);
      this.set('ipSwitchLocked', true);
    } else if (tagsArr.length && tagsArr.every(target => ipv6regex.test(target))) {
      this.set('ipVersion', null);
      this.set('ipVersionDisplayed', IP_V6_VALUE);
      this.set('ipSwitchLocked', true);
    } else if (tagsArr.some(target => ipv4regex.test(target) || ipv6regex.test(target))) {
      // hide the IP switch in the case IP versions are mixed, or there is one domain and one IP address
      let currIpVersionDisplayed = this.get('ipVersionDisplayed');
      this.set('ipVersion', null);
      this.set('ipVersionDisplayed', null);
      this.set('ipSwitchLocked', true);
      if (currIpVersionDisplayed) {
        this.set('prevIpVersionDisplayed', currIpVersionDisplayed);
      }
    } else {
      let ipVersionDisplayed = this.get('ipVersion') || this.get('ipVersionDisplayed') || this.get('prevIpVersionDisplayed') || IP_V4_VALUE;
      this.set('ipVersion', ipVersionDisplayed);
      this.set('ipVersionDisplayed', ipVersionDisplayed);
      this.set('ipSwitchLocked', false);
    }
  }
};
component$u.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      n: "class",
      f: ["c-tags-input ", {
        t: 2,
        r: "classList"
      }, " ", {
        t: 4,
        f: ["with-input-icon"],
        n: 50,
        r: "inputIcon"
      }, " ", {
        t: 4,
        f: ["no-values"],
        n: 51,
        r: "value"
      }, " ", {
        t: 4,
        f: ["error"],
        n: 50,
        r: "error"
      }, " ", {
        t: 4,
        f: ["disabled"],
        n: 50,
        r: "isDisabled"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "c-tags-input_info",
        g: 1
      }],
      f: [{
        t: 7,
        e: "span",
        m: [{
          t: 13,
          n: "class",
          f: "c-tags-input_info_label",
          g: 1
        }],
        f: [{
          t: 2,
          r: "labelText"
        }, " ", {
          t: 4,
          f: [{
            t: 8,
            r: "labelIcon"
          }],
          n: 50,
          r: "@this.partials.labelIcon"
        }]
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "c-tags-input_info_errorMsg",
            g: 1
          }],
          f: [{
            t: 2,
            r: "error"
          }]
        }],
        n: 50,
        r: "error"
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        n: "class",
        f: ["c-tags-input_tags-block ", {
          t: 4,
          f: ["full"],
          n: 50,
          x: {
            r: ["tagsArr", "tagsArr.length", "./maxTagsAllowed"],
            s: "_0&&_1===_2"
          }
        }, " ", {
          t: 4,
          f: ["has-error"],
          n: 50,
          r: "error"
        }],
        t: 13
      }, {
        n: "id",
        f: [{
          t: 2,
          x: {
            r: ["inputWrapperIdPrefix", "inputId"],
            s: "_0+_1"
          }
        }],
        t: 13
      }],
      f: [{
        t: 4,
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "c-tags-input_tags-block_tags-list",
            g: 1
          }],
          f: [{
            t: 4,
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "c-tags-input_tags-block_tags-list_tag",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "c-tags-input_tags-block_tags-list_tag_text",
                  g: 1
                }, {
                  n: ["click"],
                  t: 70,
                  f: {
                    r: ["@this", "tagIdx"],
                    s: "[_0.onTagClick(_1)]"
                  }
                }],
                f: [{
                  t: 2,
                  r: "."
                }]
              }, " ", {
                t: 7,
                e: "img",
                m: [{
                  t: 13,
                  n: "class",
                  f: "c-tags-input_tags-block_tags-list_tag_close-icon",
                  g: 1
                }, {
                  n: "width",
                  f: "16",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "16",
                  t: 13,
                  g: 1
                }, {
                  n: ["click"],
                  t: 70,
                  f: {
                    r: ["@this", "tagIdx"],
                    s: "[_0.removeTagByIdx(_1)]"
                  }
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/tag-input-close-icon.svg"],
                  t: 13
                }]
              }]
            }],
            n: 52,
            i: "tagIdx",
            r: "tagsArr"
          }]
        }],
        n: 50,
        x: {
          r: ["tagsArr", "tagsArr.length"],
          s: "_0&&_1"
        }
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "img",
          m: [{
            t: 13,
            n: "class",
            f: "c-tags-input_input-icon",
            g: 1
          }, {
            n: "width",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "height",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/img/", {
              t: 2,
              r: "inputIcon"
            }],
            t: 13
          }]
        }],
        n: 50,
        x: {
          r: ["value", "inputIcon"],
          s: "!_0&&_1"
        }
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "img",
          m: [{
            t: 13,
            n: "class",
            f: "c-tags-input_tags-block_err-icon",
            g: 1
          }, {
            n: "width",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "height",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/img/alert-icon.svg"],
            t: 13
          }]
        }],
        n: 50,
        r: "error"
      }, " ", {
        t: 7,
        e: "input",
        m: [{
          n: "id",
          f: [{
            t: 2,
            r: "inputId"
          }],
          t: 13
        }, {
          n: "value",
          f: [{
            t: 2,
            r: "inputValue"
          }],
          t: 13
        }, {
          n: "type",
          f: "text",
          t: 13
        }, {
          n: "placeholder",
          f: [{
            t: 2,
            r: "placeholder"
          }],
          t: 13
        }, {
          n: "class",
          f: [{
            t: 4,
            f: ["tags-limit"],
            n: 50,
            x: {
              r: ["tagsArr.length", "maxTagsAllowed"],
              s: "_0>=_1"
            }
          }, " ", {
            t: 4,
            f: ["disabled-input"],
            n: 50,
            r: "isDisabled"
          }],
          t: 13
        }]
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "div",
          m: [{
            n: "tabindex",
            f: "0",
            t: 13,
            g: 1
          }, {
            n: "class",
            f: ["switch-ip-type-wrapper ", {
              t: 4,
              f: ["disabled"],
              n: 50,
              r: "isDisabled"
            }, " ", {
              t: 4,
              f: ["hidden"],
              n: 51,
              r: "ipVersionDisplayed"
            }, " ", {
              t: 4,
              f: ["locked"],
              n: 50,
              r: "ipSwitchLocked"
            }],
            t: 13
          }],
          f: [{
            t: 7,
            e: "input",
            m: [{
              n: "id",
              f: "switch-ip-type",
              t: 13
            }, {
              n: "type",
              f: "checkbox",
              t: 13
            }, {
              t: 73,
              v: "t",
              f: "false"
            }, {
              n: "class",
              f: ["switch-input ", {
                t: 4,
                f: ["checked"],
                n: 51,
                x: {
                  r: ["ipVersionDisplayed", "IP_V4_VALUE"],
                  s: "_0===_1"
                }
              }],
              t: 13
            }]
          }, " ", {
            t: 7,
            e: "label",
            m: [{
              n: "for",
              f: "switch-ip-type",
              t: 13,
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this", "IP_V4_VALUE"],
                  s: "[_0.handleIpVersionSwitch(_1)]"
                }
              }],
              f: ["IPv4"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this", "IP_V6_VALUE"],
                  s: "[_0.handleIpVersionSwitch(_1)]"
                }
              }],
              f: ["IPv6"]
            }]
          }]
        }],
        n: 50,
        r: "showIPSwitch"
      }]
    }]
  }],
  e: {
    "_0&&_1===_2": function (_0, _1, _2) {
      return _0 && _1 === _2;
    },
    "_0+_1": function (_0, _1) {
      return _0 + _1;
    },
    "[_0.onTagClick(_1)]": function (_0, _1) {
      return [_0.onTagClick(_1)];
    },
    "[_0.removeTagByIdx(_1)]": function (_0, _1) {
      return [_0.removeTagByIdx(_1)];
    },
    "_0&&_1": function (_0, _1) {
      return _0 && _1;
    },
    "!_0&&_1": function (_0, _1) {
      return !_0 && _1;
    },
    "_0>=_1": function (_0, _1) {
      return _0 >= _1;
    },
    "_0===_1": function (_0, _1) {
      return _0 === _1;
    },
    "[_0.handleIpVersionSwitch(_1)]": function (_0, _1) {
      return [_0.handleIpVersionSwitch(_1)];
    }
  }
};
var tagsInput = ractive.extend(component$u.exports);

var component$t = {
  exports: {}
};
const DEFAULT_TEXTAREA_ROWS_AMOUNT = 2;
component$t.exports = {
  data() {
    return {
      invalidValue: null,
      errMsgTopPos: false,
      taRowsAmount: DEFAULT_TEXTAREA_ROWS_AMOUNT,
      taValue: null
    };
  },
  oninit() {
    if (!ractive.isServer) {
      this.observeOnce('error', () => {
        this.set('invalidValue', this.get('value'));
      }, {
        init: false
      });
      this.observe('value', value => {
        let invalidValue = this.get('invalidValue');
        let error = this.get('error');
        if (error && invalidValue !== value) {
          this.set('error', undefined);
        }
      });
      this.observe('screenWidth', screenWidth => {
        if ((screenWidth || window.innerWidth) < 768) {
          this.set('errMsgTopPos', true);
        } else {
          this.set('errMsgTopPos', false);
        }
      });

      // parse passed textarea value (expected input { <any-key>: string }) to taValue
      this.observe('value', value => {
        let currTaElCnt = (this.get('taValue') || '').split(/(\r\n|\n|\r)/).filter(Boolean);
        if (value && Object.keys(value) && currTaElCnt < Object.keys(value).length) {
          let taValue = Object.keys(value).reduce((str, key) => {
            return str += `${key}: ${value[key]}\n`;
          }, '');
          this.set('taValue', taValue);
        }
      });

      // handle Textarea rows value based on the content
      this.observe('taValue', (taValue = '') => {
        if (taValue === null) {
          return;
        }
        let taRowsAmount = DEFAULT_TEXTAREA_ROWS_AMOUNT;
        let newLines = taValue.match(/(\r\n|\n|\r)/g);
        if (newLines && newLines.length + 1 >= DEFAULT_TEXTAREA_ROWS_AMOUNT) {
          taRowsAmount = newLines.length + 2;
        }
        this.set('taRowsAmount', taRowsAmount);
      });

      // parse Textarea taValue and set value
      this.observe('taValue', (taValue = '') => {
        if (taValue === null) {
          return;
        }
        let rows = taValue.split(/(\r\n|\n|\r)/).filter(Boolean);
        let parsedHeaders = rows.reduce((res, row) => {
          let keyValueRegex = /^([^:]+):(.+)$/;
          let match = row.trim().match(keyValueRegex);
          if (match) {
            let key = match[1].trim();
            let value = match[2].trim();
            if (key && value) {
              res[key] = value;
            }
          }
          return res;
        }, {});
        this.set('value', parsedHeaders);
      });
    }
  },
  onrender() {
    listeners.screenWidthListener(this);
  }
};
component$t.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "label",
    m: [{
      n: "class",
      f: ["c-controlled-textarea ", {
        t: 2,
        r: "classList"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "c-controlled-textarea_info",
        g: 1
      }],
      f: [{
        t: 7,
        e: "span",
        m: [{
          t: 13,
          n: "class",
          f: "c-controlled-textarea_info_label",
          g: 1
        }],
        f: [{
          t: 2,
          r: "labelText"
        }, " ", {
          t: 4,
          f: [{
            t: 8,
            r: "labelIcon"
          }],
          n: 50,
          x: {
            r: ["@this.partials.labelIcon", "hideLabelIcon"],
            s: "_0&&!_1"
          }
        }]
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "c-controlled-textarea_info_errorMsg",
            g: 1
          }],
          f: [{
            t: 2,
            r: "error"
          }]
        }, " ", {
          t: 7,
          e: "img",
          m: [{
            t: 13,
            n: "class",
            f: "c-controlled-textarea_err-icon",
            g: 1
          }, {
            n: "width",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "height",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/img/alert-icon.svg"],
            t: 13
          }]
        }],
        n: 50,
        r: "error"
      }]
    }, " ", {
      t: 7,
      e: "textarea",
      m: [{
        t: 4,
        f: [{
          n: "id",
          f: [{
            t: 2,
            r: "id"
          }],
          t: 13
        }],
        n: 50,
        r: "id"
      }, {
        n: "rows",
        f: [{
          t: 2,
          r: "taRowsAmount"
        }],
        t: 13
      }, {
        n: "value",
        f: [{
          t: 2,
          r: "taValue"
        }],
        t: 13
      }, {
        n: "placeholder",
        f: [{
          t: 2,
          r: "placeholder"
        }],
        t: 13
      }, {
        n: "class",
        f: [{
          t: 4,
          f: ["has-error"],
          n: 50,
          r: "error"
        }, {
          t: 4,
          f: ["is-disabled"],
          n: 50,
          r: "disabled"
        }],
        t: 13
      }, {
        n: "disabled",
        f: [{
          t: 2,
          r: "disabled"
        }],
        t: 13
      }],
      f: ["\t"]
    }]
  }],
  e: {
    "_0&&!_1": function (_0, _1) {
      return _0 && !_1;
    }
  }
};
var controlledTextarea = ractive.extend(component$t.exports);

var usaStates$1 = [
	{
		code: "AL",
		name: "Alabama"
	},
	{
		code: "AK",
		name: "Alaska"
	},
	{
		code: "AS",
		name: "American Samoa"
	},
	{
		code: "AZ",
		name: "Arizona"
	},
	{
		code: "AR",
		name: "Arkansas"
	},
	{
		code: "CA",
		name: "California"
	},
	{
		code: "CO",
		name: "Colorado"
	},
	{
		code: "CT",
		name: "Connecticut"
	},
	{
		code: "DE",
		name: "Delaware"
	},
	{
		code: "DC",
		name: "Washington, D.C."
	},
	{
		code: "DC",
		name: "District Of Columbia"
	},
	{
		code: "FM",
		name: "Federated States Of Micronesia"
	},
	{
		code: "FL",
		name: "Florida"
	},
	{
		code: "GA",
		name: "Georgia"
	},
	{
		code: "GU",
		name: "Guam"
	},
	{
		code: "HI",
		name: "Hawaii"
	},
	{
		code: "ID",
		name: "Idaho"
	},
	{
		code: "IL",
		name: "Illinois"
	},
	{
		code: "IN",
		name: "Indiana"
	},
	{
		code: "IA",
		name: "Iowa"
	},
	{
		code: "KS",
		name: "Kansas"
	},
	{
		code: "KY",
		name: "Kentucky"
	},
	{
		code: "LA",
		name: "Louisiana"
	},
	{
		code: "ME",
		name: "Maine"
	},
	{
		code: "MH",
		name: "Marshall Islands"
	},
	{
		code: "MD",
		name: "Maryland"
	},
	{
		code: "MA",
		name: "Massachusetts"
	},
	{
		code: "MI",
		name: "Michigan"
	},
	{
		code: "MN",
		name: "Minnesota"
	},
	{
		code: "MS",
		name: "Mississippi"
	},
	{
		code: "MO",
		name: "Missouri"
	},
	{
		code: "MT",
		name: "Montana"
	},
	{
		code: "NE",
		name: "Nebraska"
	},
	{
		code: "NV",
		name: "Nevada"
	},
	{
		code: "NH",
		name: "New Hampshire"
	},
	{
		code: "NJ",
		name: "New Jersey"
	},
	{
		code: "NM",
		name: "New Mexico"
	},
	{
		code: "NY",
		name: "New York"
	},
	{
		code: "NC",
		name: "North Carolina"
	},
	{
		code: "ND",
		name: "North Dakota"
	},
	{
		code: "MP",
		name: "Northern Mariana Islands"
	},
	{
		code: "OH",
		name: "Ohio"
	},
	{
		code: "OK",
		name: "Oklahoma"
	},
	{
		code: "OR",
		name: "Oregon"
	},
	{
		code: "PW",
		name: "Palau"
	},
	{
		code: "PA",
		name: "Pennsylvania"
	},
	{
		code: "PR",
		name: "Puerto Rico"
	},
	{
		code: "RI",
		name: "Rhode Island"
	},
	{
		code: "SC",
		name: "South Carolina"
	},
	{
		code: "SD",
		name: "South Dakota"
	},
	{
		code: "TN",
		name: "Tennessee"
	},
	{
		code: "TX",
		name: "Texas"
	},
	{
		code: "UT",
		name: "Utah"
	},
	{
		code: "VT",
		name: "Vermont"
	},
	{
		code: "VI",
		name: "Virgin Islands"
	},
	{
		code: "VA",
		name: "Virginia"
	},
	{
		code: "WA",
		name: "Washington"
	},
	{
		code: "WV",
		name: "West Virginia"
	},
	{
		code: "WI",
		name: "Wisconsin"
	},
	{
		code: "WY",
		name: "Wyoming"
	}
];

var usaStates$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': usaStates$1
});

var continents = [
	{
		code: "AN",
		name: "Antarctica"
	},
	{
		code: "AS",
		name: "Asia"
	},
	{
		code: "EU",
		name: "Europe"
	},
	{
		code: "NA",
		name: "North America"
	},
	{
		code: "OC",
		name: "Oceania"
	},
	{
		code: "SA",
		name: "South America"
	},
	{
		code: "AF",
		name: "Africa"
	}
];

var continents$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': continents
});

var usaStates = getCjsExportFromNamespace(usaStates$2);

var CONTINENTS = getCjsExportFromNamespace(continents$1);

var component$s = {
  exports: {}
};
const statesByCode = Object.fromEntries(usaStates.map(state => [`US-${state.code}`, state]));
const countriesByCode = Object.fromEntries(countries.map(country => [country.code, country]));
const continentsByCode = Object.fromEntries(CONTINENTS.map(continent => [continent.code, continent]));
const escapeRegExp = string => string.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
component$s.exports = {
  decorators: {
    tooltip
  },
  data() {
    return {
      invalidValue: null,
      errMsgTopPos: false,
      rawProbes: [],
      exposeProbes: false,
      results: [],
      completedValue: '',
      supportedFeaturesMessage: '',
      reshapeResults: sources => sources
    };
  },
  oninit() {
    if (!ractive.isServer) {
      this.observeOnce('error', () => {
        this.set('invalidValue', this.get('value'));
      }, {
        init: false
      });
      this.observe('value', value => {
        let invalidValue = this.get('invalidValue');
        let error = this.get('error');
        if (error && invalidValue !== value) {
          this.set('error', undefined);
        }
      });
      this.observe('screenWidth', screenWidth => {
        if ((screenWidth || window.innerWidth) < 768) {
          this.set('errMsgTopPos', true);
        } else {
          this.set('errMsgTopPos', false);
        }
      });
    }
  },
  onrender() {
    listeners.screenWidthListener(this);
    if (!ractive.isServer) {
      let normalizedProbes = [];
      let indexForConditions;
      let initLimit = value => function runLimit(rawSources) {
        let sources = rawSources.flat().filter(Boolean);
        let nonEmptySources = 0;
        let totalItems = 0;
        sources.forEach(source => {
          nonEmptySources += source.count ? 1 : 0;
          totalItems += source.count;
        });
        if (totalItems === 0) {
          return [];
        }
        let minLimitPerSource = Math.ceil(value / nonEmptySources);
        let maxLimitPerSource = Math.max(Math.min(totalItems, value), minLimitPerSource);
        let limitedSources;
        for (let currentLimit = minLimitPerSource; currentLimit <= maxLimitPerSource; currentLimit++) {
          let sharedLimitRemaining = value;
          limitedSources = sources.map((source, index) => {
            let isLastSource = index === sources.length - 1;
            let sourceLimit = isLastSource ? sharedLimitRemaining : Math.min(currentLimit, sharedLimitRemaining);
            let items = source.getItems().slice(0, sourceLimit);
            sharedLimitRemaining = Math.max(sharedLimitRemaining - items.length, 0);
            return {
              ...source,
              getItems() {
                return items;
              }
            };
          });
          if (!sharedLimitRemaining) {
            return limitedSources;
          }
        }
        return limitedSources;
      };
      let columns = (html, left, right) => html`
					<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
						<div>${left}</div>
						<div class="aa-gp-item-count">${right}</div>
					</div>
				`;
      let limit = initLimit(12);
      let {
        autocomplete
      } = window['@algolia/autocomplete-js'];
      let customTabHandlingActive = false;
      let overrideState = false;
      let isAsyncOpen = false;
      let activeItemId;
      let currentCompletion;
      let currentCollections;
      let prevStateIsOpen;
      let {
        setQuery,
        setActiveItemId,
        destroy
      } = autocomplete({
        container: this.find('.aa-gp-container'),
        onStateChange: ({
          state
        }) => {
          // hide autofill popover when user types
          if (this.get('locationAutofilled')) {
            let isQueryDifferent = state.query !== this.get('value');
            if (isQueryDifferent) {
              this.set('locationAutofilled', false);
            }
          }
          if (!state.isOpen && prevStateIsOpen && this.get('exposeProbes') && normalizedProbes) {
            setTimeout(() => {
              filterProbesByCurrentParts(state.query);
              this.set('completedValue', state.query);
            }, 0);
          }
          prevStateIsOpen = state.isOpen;
          activeItemId = state.activeItemId;
          setTimeout(() => isAsyncOpen = state.isOpen);
          if (overrideState) {
            overrideState = false;
            return;
          }
          if (state.isOpen) {
            currentCompletion = state.completion;
            currentCollections = state.collections;
            if (state.query && !currentCompletion && activeItemId === null) {
              setActiveItemId(0);
              customTabHandlingActive = true;
            } else if (state.activeItemId !== 0) {
              customTabHandlingActive = false;
            }
          }
          this.set('value', state.isOpen ? state.query : state.completion || state.query);
        },
        onSubmit: () => {
          this.fire('enter');
        },
        detachedMediaQuery: 'none',
        placeholder: this.get('placeholder'),
        openOnFocus: true,
        classNames: {
          panelLayout: 'dropdown-menu',
          input: this.get('error') ? 'has-error' : ''
        },
        render({
          sections,
          render,
          html
        }, root) {
          render(html`
							<div class="aa-PanelLayout aa-Panel--scrollable">
								<section class="aa-gp-info"><i class="fa fa-lightbulb-o" aria-hidden="true"></i> Try one of these suggestions or use your own value.</section>
								${sections}
							</div>`, root);
        },
        renderNoResults: ({
          html,
          render,
          state
        }, root) => {
          return render(html`
							<div class="aa-PanelLayout">
								<section class="aa-gp-info">
									Search for <code>${state.query}</code> across all probes.
								</section>

								<div class="aa-gp-no-results">
									${this.get('supportedFeaturesMessage') || 'Our magic search supports names of continents, regions, countries, US states, cities, networks, and custom tags.'}
									<br/><br/>
									Use <code>+</code> to combine multiple filters, and <code>,</code> to select multiple locations.
								</div>
							</div>
						`, root);
        },
        reshape: ({
          sources
        }) => {
          return [limit(this.get('reshapeResults')(sources))];
        },
        shouldPanelOpen: () => {
          return !this.get('locationAutofilled');
        },
        getSources: ({
          query
        }) => {
          if (!indexForConditions) {
            return;
          }

          // The input allows several queries separated by a comma.
          // Each query may have multiple parts separated by a plus sign.
          // We always operate on the last part of the last query but need to preserve anything before it.
          let queries = query.split(',');
          let previousQueries = queries.length > 1 ? queries.slice(0, -1) : [];
          let currentQuery = queries.at(-1);
          let currentQueryParts = currentQuery.split('+');
          let currentQueryPrevParts = currentQueryParts.length > 1 ? currentQueryParts.slice(0, -1) : [];
          let currentQueryPrevPartsNormalized = currentQueryPrevParts.map(q => q.trim()).filter(v => v).map(s => s.toLowerCase()).sort();
          let currentQueryPrevPartsNormalizedString = currentQueryPrevPartsNormalized.join('+');
          let currentQueryCurrentPart = currentQueryParts.at(-1) || '';
          let currentQueryCurrentPartLeadingWhitespace = currentQueryCurrentPart.match(/^\s+/)?.[0] || '';
          let currentQueryCurrentPartTrimmed = currentQueryCurrentPart.trim();
          let escapedQuery = escapeRegExp(currentQueryCurrentPartTrimmed);
          let queryPrefix = previousQueries.join(',');
          if (queryPrefix) {
            queryPrefix += ',';
          }
          if (currentQueryPrevParts.length) {
            queryPrefix += `${currentQueryPrevParts.join('+')}+`;
          }
          queryPrefix += currentQueryCurrentPartLeadingWhitespace;
          if (!indexForConditions[currentQueryPrevPartsNormalizedString]) {
            createIndexFor(filterProbes(normalizedProbes, currentQueryPrevPartsNormalized), currentQueryPrevPartsNormalized);
          }
          let index = indexForConditions[currentQueryPrevPartsNormalizedString];
          let rankedPatterns = escapedQuery ? [new RegExp(`^${escapedQuery}$`, 'im'),
          // new RegExp(`^${escapedQuery}\\b`, 'im'),
          new RegExp(`^${escapedQuery}`, 'im'), new RegExp(`\\b${escapedQuery}\\b`, 'im'), new RegExp(`\\b${escapedQuery}`, 'im'), new RegExp(`${escapedQuery}`, 'im')] : [/./];
          let initSource = (name, properties) => {
            return _.deepExtend({
              sourceId: name,
              getItems: () => {
                return index[name];
              },
              getItemInputValue({
                item
              }) {
                // Some items have multiple valid ways to refer to them, e.g., EU and Europe. Preserve the existing value in that case.
                let allowedValue = item.inputValues?.find(v => v.toLowerCase() === currentQueryCurrentPartTrimmed.toLowerCase());

                // Cities are composed of two parts, which requires special handling to avoid duplicating one of them.
                let valueToAdd = allowedValue || item.value;
                let partsToAdd = valueToAdd.split('+').filter(v => !currentQueryPrevPartsNormalized.includes(v.toLowerCase()));
                return queryPrefix + partsToAdd.join('+');
              },
              templates: {
                header() {
                  return _.capitalizeFirstLetter(name);
                }
              }
            }, properties);
          };
          let filterSourceResults = source => {
            let filtered = [];
            let bestRank = Infinity;
            for (let item of source.getItems()) {
              if (item.count > index.countCap && (!index.countCap || source.sourceId !== 'cities' || source.getItemInputValue({
                item
              }) === queryPrefix)) {
                continue;
              }
              for (let i = 0; i < rankedPatterns.length; i++) {
                if (rankedPatterns[i].test(item.normalizedValue)) {
                  filtered.push({
                    ...item,
                    rank: i
                  });
                  if (i < bestRank) {
                    bestRank = i;
                  }
                  break;
                }
              }
            }
            filtered.sort((a, b) => {
              if (a.rank === b.rank) {
                return b.count - a.count;
              }
              return a.rank - b.rank;
            });
            return {
              ...source,
              getItems: () => filtered,
              count: filtered.length,
              rank: bestRank
            };
          };
          return [initSource('tags', {
            templates: {
              item({
                item,
                html
              }) {
                return columns(html, item.value, `${item.count}`);
              }
            }
          }), initSource('countries', {
            templates: {
              item({
                item,
                html
              }) {
                return columns(html, html`${item.value}<span class="aa-gp-item-extra"> (${item.countryCode})</span>`, `${item.count}`);
              }
            }
          }), initSource('continents', {
            templates: {
              item({
                item,
                html
              }) {
                return columns(html, `${item.value}`, `${item.count}`);
              }
            }
          }), initSource('cities', {
            templates: {
              item({
                item,
                html
              }) {
                return columns(html, html`${item.displayValue}<span class="aa-gp-item-extra">, ${item.state || item.country}</span>`, `${item.count}`);
              }
            }
          }), initSource('regions', {
            templates: {
              item({
                item,
                html
              }) {
                return columns(html, `${item.value}`, `${item.count}`);
              }
            }
          }), initSource('states', {
            templates: {
              item({
                item,
                html
              }) {
                return columns(html, html`${item.displayValue}<span class="aa-gp-item-extra"> (${item.stateCode})</span>`, `${item.count}`);
              }
            }
          }), initSource('networks', {
            templates: {
              item({
                item,
                html
              }) {
                return columns(html, `${item.value}`, `${item.count}`);
              }
            }
          })].map(source => {
            return filterSourceResults(source);
          }).sort((a, b) => {
            // For sections with the same rank, order by the number of probes in the first location.
            if (a.rank === b.rank) {
              return (b.getItems()[0]?.count || 0) - (a.getItems()[0]?.count || 0);
            }
            return a.rank - b.rank;
          });
        }
      });
      let input = this.el.querySelector('.aa-Input');

      // Enter handling - run the measurement.
      let handleEnter = event => {
        if (event.key === 'Enter' && !isAsyncOpen) {
          this.fire('enter');
        }
      };
      input.addEventListener('keydown', handleEnter);
      this.on('unrender', () => input.removeEventListener('keydown', handleEnter));

      // Tab handling - autocomplete.
      let handleTab = event => {
        if (event.key === 'Tab' && customTabHandlingActive) {
          let collection = currentCollections.find(c => c.items.length);
          if (collection) {
            setQuery(collection.source.getItemInputValue({
              item: collection.items[0]
            }));
          }
        } else if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
          // Preserve the original unfinished query at "null" position (default behavior without our modifications).
          if (activeItemId === 0 && !currentCompletion) {
            overrideState = true;
            customTabHandlingActive = false;
            setActiveItemId(null);
          }
        }
      };
      input.addEventListener('keydown', handleTab);
      this.on('unrender', () => input.removeEventListener('keydown', handleTab));

      // Focus handling - select the text.
      let handleFocus = () => {
        if (this.get('value').toLowerCase() === 'world') {
          input.select();
        }
      };
      input.addEventListener('focus', handleFocus);
      this.on('unrender', () => input.removeEventListener('focus', handleFocus));

      // Propagate state changes.
      this.observe('value', newValue => {
        setQuery(newValue);
      });
      this.observe('disabled', newValue => {
        input.classList.toggle('is-disabled', !!newValue);
        input.disabled = !!newValue;
      }, {
        init: false
      });
      this.observe('error', newValue => {
        input.classList.toggle('has-error', !!newValue);
      }, {
        init: false
      });

      // Fill in the initial value and show the input.
      setQuery(this.get('value') || '');
      setTimeout(() => {
        this.set('swapInputs', true);
      });

      // Prepare the source data.
      let uniqCountSortNormalize = (values, caseInsensitive = false) => {
        let countValues = values.reduce((acc, value) => {
          let key = caseInsensitive ? value.toLowerCase() : value;
          if (!Object.hasOwn(acc, key)) {
            acc[key] = {
              count: 0,
              value
            };
          }
          acc[key].count += 1;
          return acc;
        }, {});
        return Object.keys(countValues).map(key => ({
          value: countValues[key].value,
          normalizedValue: key.toLowerCase(),
          count: countValues[key].count
        })).sort((a, b) => b.count - a.count);
      };
      let createNormalizedProbeList = probes => {
        normalizedProbes = probes.map(probe => {
          let countryName = countriesByCode[probe.location.country]?.name || probe.location.country;
          let continentName = continentsByCode[probe.location.continent]?.name || probe.location.continent;
          let normalizedProbe = {
            city: `${probe.location.city}\n${probe.location.state ? `US-${probe.location.state}\n` : '\n'}${countryName}\n${probe.location.country}`,
            region: probe.location.region,
            state: probe.location.state ? `US-${probe.location.state}` : '',
            country: `${countryName}\n${probe.location.country}`,
            continent: `${continentName}\n${probe.location.continent}`,
            network: probe.location.network.trim(),
            tags: probe.tags.filter(tag => !tag.startsWith('u-'))
          };
          if (probe.location.country === 'GB') {
            normalizedProbe.country += `\nUK\nGreat Britain\nEngland`.toLowerCase();
          }
          return {
            ...normalizedProbe,
            original: probe,
            allValues: Object.values(normalizedProbe).map(value => Array.isArray(value) ? value.join('\n').toLowerCase() : value.toLowerCase()).join('\n')
          };
        });
        indexForConditions = Object.create(null);
      };
      let filterProbesByCurrentParts = query => {
        if (!this.get('exposeProbes')) {
          return;
        }
        let uniq = new Set();
        query.split(',').forEach(part => {
          let partNormalized = part.split('+').map(q => q.trim()).filter(v => v).map(s => s.toLowerCase()).sort();
          filterProbes(normalizedProbes, partNormalized).forEach(p => uniq.add(p.original));
        });
        this.set('results', Array.from(uniq));
      };
      let filterProbes = (normalizedProbes, conditions) => {
        return conditions.reduce((filteredProbes, condition) => {
          if (condition === 'world') {
            return normalizedProbes;
          }
          let exactPattern = new RegExp(`(?:^|\n)${escapeRegExp(condition)}(?:$|\n)`, 'm');
          let exactMatchFound = false;
          let looseMatchFound = false;
          filteredProbes = filteredProbes.filter(probe => {
            if (!probe.allValues.includes(condition)) {
              return false;
            }
            if (exactPattern.test(probe.allValues)) {
              exactMatchFound = true;
            } else {
              looseMatchFound = true;
            }
            return true;
          });
          if (exactMatchFound && looseMatchFound) {
            filteredProbes = filteredProbes.filter(probe => exactPattern.test(probe.allValues));
          }
          return filteredProbes;
        }, normalizedProbes);
      };
      let createIndexFor = (filteredProbes, conditions) => {
        let index = {};
        index.global = ['World'];
        index.tags = filteredProbes.map(probe => probe.tags).flat();
        index.cities = filteredProbes.map(probe => probe.city);
        index.countries = filteredProbes.map(probe => probe.country);
        index.continents = filteredProbes.map(probe => probe.continent);
        index.regions = filteredProbes.map(probe => probe.region);
        index.states = filteredProbes.map(probe => probe.state).filter(v => v);
        index.networks = filteredProbes.map(probe => probe.network).filter(network => network && !network.includes(','));
        Object.keys(index).forEach(key => {
          index[key] = uniqCountSortNormalize(index[key], key === 'networks');
        });
        index.cities = index.cities.map(cityRow => {
          let [city, stateCode, countryName, countryCode] = cityRow.value.split('\n');
          let stateName = statesByCode[stateCode]?.name || stateCode;
          return {
            ...cityRow,
            value: `${city}+${stateCode || countryCode}`,
            normalizedValue: `${cityRow.normalizedValue}\n${stateName.toLowerCase()}`,
            displayValue: `${city}`,
            country: `${countryName} (${countryCode})`,
            state: stateName ? `${stateName} (${stateCode})` : ''
          };
        });
        index.countries = index.countries.map(countryRow => {
          let [countryName, countryCode] = countryRow.value.split('\n');
          return {
            ...countryRow,
            value: countryName,
            inputValues: [countryName, countryCode],
            countryCode
          };
        });
        index.continents = index.continents.map(continentRow => {
          let [continentName] = continentRow.value.split('\n');
          return {
            ...continentRow,
            value: continentName,
            inputValues: [continentName]
          };
        });
        index.states = index.states.map(stateRow => {
          let stateCode = stateRow.value;
          let stateName = statesByCode[stateCode]?.name || stateCode;
          return {
            ...stateRow,
            value: stateCode,
            normalizedValue: `${stateRow.normalizedValue}\n${stateName.toLowerCase()}`,
            displayValue: stateName,
            stateCode
          };
        });
        index.count = filteredProbes.length;
        index.countCap = conditions.length ? index.count - 1 : index.count;
        index.tags.unshift(...index.global);
        index.tags[0].count = filteredProbes.length;
        indexForConditions[conditions.join('+')] = index;
      };
      this.observe('rawProbes', probes => {
        createNormalizedProbeList(probes);
        filterProbesByCurrentParts(this.get('value') || '');

        // for testing
        if (probes.length) {
          input.setAttribute('data-testid', 'autocomplete-input');
        }
      });
      this.on('outsideLocationChange', () => {
        // When exposing probes, we need to update the list state regardless of the dropdown state.
        setTimeout(() => {
          filterProbesByCurrentParts(this.get('value') || '');
          this.set('completedValue', this.get('value') || '');
        }, 0);
      });
      this.on('unrender', () => destroy());
    }
  }
};
component$s.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      n: "class",
      f: ["c-controlled-input ", {
        t: 2,
        r: "classList"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "span",
      m: [{
        t: 13,
        n: "class",
        f: "c-controlled-input_label",
        g: 1
      }],
      f: [{
        t: 2,
        r: "labelText"
      }, " ", {
        t: 4,
        f: [{
          t: 8,
          r: "labelIcon"
        }],
        n: 50,
        x: {
          r: ["@this.partials.labelIcon", "hideLabelIcon"],
          s: "_0&&!_1"
        }
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "c-controlled-input_wrapper",
        g: 1
      }],
      f: [{
        t: 9,
        c: " Use a server-rendered input and swap it for the real on init to avoid having visible empty space here during init. "
      }, " ", {
        t: 7,
        e: "input",
        m: [{
          n: "type",
          f: "text",
          t: 13
        }, {
          n: "value",
          f: [{
            t: 2,
            r: "value"
          }],
          t: 13
        }, {
          n: "placeholder",
          f: [{
            t: 2,
            r: "placeholder"
          }],
          t: 13
        }, {
          n: "class",
          f: [{
            t: 4,
            f: ["hidden"],
            n: 50,
            r: "swapInputs"
          }, " c-controlled-input_input"],
          t: 13
        }]
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "popover top fade in gp-autofill-popover",
            g: 1
          }],
          f: [{
            t: 7,
            e: "h3",
            m: [{
              t: 13,
              n: "class",
              f: "popover-title",
              g: 1
            }],
            f: [{
              t: 7,
              e: "i",
              m: [{
                t: 13,
                n: "class",
                f: "fa fa-magic",
                g: 1
              }, {
                n: "aria-hidden",
                f: "true",
                t: 13,
                g: 1
              }]
            }, " Location autofilled"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "popover-content",
              g: 1
            }],
            f: ["We have automatically filled in your selected location.", {
              t: 7,
              e: "br"
            }, {
              t: 7,
              e: "br"
            }, " Press ", {
              t: 7,
              e: "strong",
              f: ["Enter"]
            }, " to run the test or copy the value into any of our other tools."]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "arrow",
              g: 1
            }]
          }]
        }],
        n: 50,
        r: "locationAutofilled"
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          n: "class",
          f: ["aa-gp-container ", {
            t: 4,
            f: ["hidden"],
            n: 51,
            r: "swapInputs"
          }],
          t: 13
        }]
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "img",
          m: [{
            t: 13,
            n: "class",
            f: "c-controlled-input_err-icon",
            g: 1
          }, {
            n: "width",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "height",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/img/alert-icon.svg"],
            t: 13
          }]
        }],
        n: 50,
        r: "error"
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "span",
        m: [{
          t: 13,
          n: "class",
          f: "c-controlled-input_error",
          g: 1
        }],
        f: [{
          t: 2,
          r: "error"
        }]
      }],
      n: 50,
      r: "error"
    }]
  }],
  e: {
    "_0&&!_1": function (_0, _1) {
      return _0 && !_1;
    }
  }
};
var locationInput = ractive.extend(component$s.exports);

var component$r = {
  exports: {}
};
component$r.exports = {
  decorators: {
    tooltip,
    clipboard
  },
  data() {
    return {
      invalidValue: null,
      errMsgTopPos: false
    };
  },
  oninit() {
    if (!ractive.isServer) {
      this.observeOnce('error', () => {
        this.set('invalidValue', this.get('value'));
      }, {
        init: false
      });
      this.observe('value', value => {
        let invalidValue = this.get('invalidValue');
        let error = this.get('error');
        if (error && invalidValue !== value) {
          this.set('error', undefined);
        }
      });
      this.observe('screenWidth', screenWidth => {
        if ((screenWidth || window.innerWidth) < 768) {
          this.set('errMsgTopPos', true);
        } else {
          this.set('errMsgTopPos', false);
        }
      });
    }
  },
  onrender() {
    listeners.screenWidthListener(this);
  }
};
component$r.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      n: "class",
      f: ["c-controlled-input ", {
        t: 2,
        r: "classList"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "span",
      m: [{
        t: 13,
        n: "class",
        f: "c-controlled-input_label",
        g: 1
      }],
      f: [{
        t: 2,
        r: "labelText"
      }, " ", {
        t: 4,
        f: [{
          t: 8,
          r: "labelIcon"
        }],
        n: 50,
        x: {
          r: ["@this.partials.labelIcon", "hideLabelIcon"],
          s: "_0&&!_1"
        }
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 8,
        r: "copyBtn"
      }],
      n: 50,
      r: "@this.partials.copyBtn"
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "c-controlled-input_wrapper",
        g: 1
      }],
      f: [{
        t: 7,
        e: "input",
        m: [{
          t: 4,
          f: [{
            n: "id",
            f: [{
              t: 2,
              r: "id"
            }],
            t: 13
          }],
          n: 50,
          r: "id"
        }, {
          n: "value",
          f: [{
            t: 2,
            r: "value"
          }],
          t: 13
        }, {
          n: "type",
          f: "text",
          t: 13
        }, {
          n: "placeholder",
          f: [{
            t: 2,
            r: "placeholder"
          }],
          t: 13
        }, {
          n: "class",
          f: [{
            t: 4,
            f: ["has-error"],
            n: 50,
            r: "error"
          }, {
            t: 4,
            f: ["is-disabled"],
            n: 50,
            r: "disabled"
          }, " c-controlled-input_input"],
          t: 13
        }, {
          t: 4,
          f: [{
            n: "readonly",
            f: [{
              t: 2,
              x: {
                r: ["locked"],
                s: "_0?true:false"
              }
            }],
            t: 13
          }],
          n: 50,
          r: "locked"
        }, {
          n: "disabled",
          f: [{
            t: 2,
            r: "disabled"
          }],
          t: 13
        }]
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "img",
          m: [{
            t: 13,
            n: "class",
            f: "c-controlled-input_err-icon",
            g: 1
          }, {
            n: "width",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "height",
            f: "20",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/img/alert-icon.svg"],
            t: 13
          }]
        }],
        n: 50,
        r: "error"
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "span",
        m: [{
          t: 13,
          n: "class",
          f: "c-controlled-input_error",
          g: 1
        }],
        f: [{
          t: 2,
          r: "error"
        }]
      }],
      n: 50,
      r: "error"
    }]
  }],
  e: {
    "_0&&!_1": function (_0, _1) {
      return _0 && !_1;
    },
    "_0?true:false": function (_0) {
      return _0 ? true : false;
    }
  }
};
var controlledInput = ractive.extend(component$r.exports);

var component$q = {
  exports: {}
};
const notificationKey = 'job-1-notificationSeen';
component$q.exports = {
  data() {
    return {
      notificationSeen: true
    };
  },
  oninit() {
    if (ractive.isServer) {
      this.set('notificationSeen', true);
    } else {
      if (has$6.localStorage()) {
        if (localStorage.getItem(notificationKey)) {
          this.set('notificationSeen', true);
        }
        this.observe('notificationSeen', newValue => {
          localStorage.setItem(notificationKey, JSON.stringify(newValue));
        }, {
          init: false
        });
      }

      // this.observe('notificationSeen', (newValue) => {
      // 	document.body.classList[newValue ? 'remove' : 'add']('c-notification-visible');
      // });
    }
  }
};
component$q.exports.template = {
  v: 4,
  t: [{
    t: 4,
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "c-notification",
        g: 1
      }],
      f: [{
        t: 7,
        e: "i",
        m: [{
          t: 13,
          n: "class",
          f: "fa fa-bullhorn",
          g: 1
        }, {
          n: "aria-hidden",
          f: "true",
          t: 13,
          g: 1
        }]
      }, " ", {
        t: 7,
        e: "a",
        m: [{
          n: "href",
          f: "https://gist.github.com/jimaek/de24cee25048de8bbe3f0d811695cdf7",
          t: 13,
          g: 1
        }, {
          n: "target",
          f: "_blank",
          t: 13,
          g: 1
        }],
        f: ["We're looking for a Senior Node.js Engineer to help expand our open-source projects!"]
      }, " ", {
        t: 7,
        e: "a",
        m: [{
          n: ["click"],
          t: 70,
          f: {
            r: ["@this"],
            s: "[_0.set(\"notificationSeen\",true)]"
          }
        }, {
          n: "aria-label",
          f: "Close",
          t: 13,
          g: 1
        }],
        f: [{
          t: 7,
          e: "i",
          m: [{
            t: 13,
            n: "class",
            f: "fa fa-times",
            g: 1
          }, {
            n: "aria-hidden",
            f: "true",
            t: 13,
            g: 1
          }]
        }]
      }]
    }],
    n: 50,
    x: {
      r: ["notificationSeen"],
      s: "!_0"
    }
  }],
  e: {
    "[_0.set(\"notificationSeen\",true)]": function (_0) {
      return [_0.set("notificationSeen", true)];
    },
    "!_0": function (_0) {
      return !_0;
    }
  }
};
var notification = ractive.extend(component$q.exports);

var component$p = {
  exports: {}
};
component$p.exports = {
  data() {
    return {
      date: new Date(),
      docInnerHtml: null,
      gpLinksData: [[{
        text: 'Ping from Europe',
        url: '/network-tools/ping-from-europe'
      }, {
        text: 'Ping from USA',
        url: '/network-tools/ping-from-united-states'
      }, {
        text: 'Ping globally',
        url: '/network-tools/ping'
      }, {
        text: 'Ping from AWS',
        url: '/network-tools/ping-from-amazoncom'
      }], [{
        text: 'Traceroute from Europe',
        url: '/network-tools/traceroute-from-europe'
      }, {
        text: 'Traceroute from USA',
        url: '/network-tools/traceroute-from-united-states'
      }, {
        text: 'Traceroute globally',
        url: '/network-tools/traceroute'
      }, {
        text: 'Traceroute from AWS',
        url: '/network-tools/traceroute-from-amazoncom'
      }], [{
        text: 'DNS/dig resolve from Europe',
        url: '/network-tools/dns-from-europe'
      }, {
        text: 'DNS/dig resolve from USA',
        url: '/network-tools/dns-from-united-states'
      }, {
        text: 'DNS/dig resolve globally',
        url: '/network-tools/dns'
      }, {
        text: 'DNS/dig resolve from AWS',
        url: '/network-tools/dns-from-amazoncom'
      }], [{
        text: 'HTTP/curl from Europe',
        url: '/network-tools/http-from-europe'
      }, {
        text: 'HTTP/curl from USA',
        url: '/network-tools/http-from-united-states'
      }, {
        text: 'HTTP/curl globally',
        url: '/network-tools/http'
      }, {
        text: 'HTTP/curl from AWS',
        url: '/network-tools/http-from-amazoncom'
      }]],
      blogLinksData: null
    };
  },
  oninit() {
    if (!ractive.isServer) {
      http.getGPBlogRss().then(response => {
        if (response) {
          let document = new window.DOMParser().parseFromString(response, 'text/xml');
          let items = document.documentElement.childNodes[0].getElementsByTagName('item');
          let data = [];
          for (let i = 0; i < items.length; i++) {
            let currItemNodesList = items[i].childNodes;
            let currItemTitle;
            let currItemLink;
            let currItemPubDate;
            for (let k = 0; k < currItemNodesList.length; k++) {
              if (currItemNodesList[k].nodeName === 'title') {
                currItemTitle = currItemNodesList[k].textContent;
              } else if (currItemNodesList[k].nodeName === 'link') {
                currItemLink = currItemNodesList[k].textContent;
              } else if (currItemNodesList[k].nodeName === 'pubDate') {
                currItemPubDate = currItemNodesList[k].textContent;
              }
            }
            data.push({
              text: currItemTitle,
              url: currItemLink,
              date: new Date(currItemPubDate).getTime()
            });
          }
          data.sort((a, b) => b.date - a.date);
          this.set('blogLinksData', data.slice(0, 5));
        }
      }).catch(() => {});
    }
  }
};
component$p.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "footer",
    m: [{
      t: 13,
      n: "class",
      f: "c-footer c-gp-footer",
      g: 1
    }, {
      n: "inert",
      f: [{
        t: 2,
        r: "isInert"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "wrapper",
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "container-fluid container-mw",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "row block-main",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "col-xs-12 col-sm-4 main-left",
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "style",
                f: "padding: 0;",
                g: 1
              }, {
                t: 13,
                n: "class",
                f: "block-list",
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "title-copy op-64",
                  g: 1
                }],
                f: ["© globalping.io, 2022 - ", {
                  t: 2,
                  x: {
                    r: ["date"],
                    s: "_0.getFullYear()"
                  }
                }]
              }]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "col-xs-12 col-sm-8 main-right",
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "main-right-container",
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "style",
                  f: "padding: 0;",
                  g: 1
                }, {
                  t: 13,
                  n: "class",
                  f: "block-list",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "row list-primary list-small-row",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "div",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "col-sm-12",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "ul",
                      f: [{
                        t: 7,
                        e: "li",
                        f: [{
                          t: 7,
                          e: "a",
                          m: [{
                            n: "href",
                            f: "/about-us",
                            t: 13,
                            g: 1
                          }],
                          f: ["About"]
                        }]
                      }, " ", {
                        t: 7,
                        e: "li",
                        f: [{
                          t: 7,
                          e: "a",
                          m: [{
                            n: "href",
                            f: "/sponsors",
                            t: 13,
                            g: 1
                          }],
                          f: ["Our Sponsors"]
                        }]
                      }, " ", {
                        t: 7,
                        e: "li",
                        f: [{
                          t: 7,
                          e: "a",
                          m: [{
                            n: "href",
                            f: "/terms",
                            t: 13,
                            g: 1
                          }],
                          f: ["Terms & Policies"]
                        }]
                      }, " ", {
                        t: 7,
                        e: "li",
                        f: [{
                          t: 7,
                          e: "a",
                          m: [{
                            n: "href",
                            f: "mailto:d@globalping.io",
                            t: 13,
                            g: 1
                          }],
                          f: ["d@globalping.io"]
                        }]
                      }]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "footer-separator",
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "row block-main",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "col-xs-12 col-sm-8 main-left",
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "style",
                f: "padding: 0;",
                g: 1
              }, {
                t: 13,
                n: "class",
                f: "block-list",
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "title-copy-bottom op-64",
                  g: 1
                }],
                f: ["Integrations"]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "row list-primary",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "col-sm-12",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "div",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "title-copy op-64",
                      g: 1
                    }],
                    f: ["Integrations"]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "row list-second list-small-column",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "col-sm-12",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "ul",
                    f: [{
                      t: 7,
                      e: "li",
                      f: [{
                        t: 7,
                        e: "a",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "router-ignore",
                          g: 1
                        }, {
                          n: "href",
                          f: "/docs/api.globalping.io",
                          t: 13,
                          g: 1
                        }],
                        f: ["REST API"]
                      }]
                    }, " ", {
                      t: 7,
                      e: "li",
                      f: [{
                        t: 7,
                        e: "a",
                        m: [{
                          n: "href",
                          f: "/cli",
                          t: 13,
                          g: 1
                        }],
                        f: ["CLI"]
                      }]
                    }, " ", {
                      t: 7,
                      e: "li",
                      f: [{
                        t: 7,
                        e: "a",
                        m: [{
                          n: "href",
                          f: "/slack",
                          t: 13,
                          g: 1
                        }],
                        f: ["Slack App"]
                      }]
                    }, " ", {
                      t: 7,
                      e: "li",
                      f: [{
                        t: 7,
                        e: "a",
                        m: [{
                          n: "href",
                          f: "/discord",
                          t: 13,
                          g: 1
                        }],
                        f: ["Discord App"]
                      }]
                    }, " ", {
                      t: 7,
                      e: "li",
                      f: [{
                        t: 7,
                        e: "a",
                        m: [{
                          n: "href",
                          f: "https://github.com/globalping",
                          t: 13,
                          g: 1
                        }, {
                          n: "target",
                          f: "_blank",
                          t: 13,
                          g: 1
                        }],
                        f: ["GitHub Bot ", {
                          t: 7,
                          e: "i",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "fa fa-external-link",
                            g: 1
                          }, {
                            n: "aria-hidden",
                            f: "true",
                            t: 13,
                            g: 1
                          }]
                        }]
                      }]
                    }]
                  }]
                }]
              }]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "col-xs-12 col-sm-4 main-right",
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "main-right-container",
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "subscribe-header",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "text-footer-14",
                    g: 1
                  }],
                  f: ["Sign up to our newsletter"]
                }]
              }, " ", {
                t: 7,
                e: "form",
                m: [{
                  t: 13,
                  n: "class",
                  f: "form-inline subscribe-content",
                  g: 1
                }, {
                  n: "action",
                  f: "https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736",
                  t: 13,
                  g: 1
                }, {
                  n: "method",
                  f: "POST",
                  t: 13,
                  g: 1
                }, {
                  n: "target",
                  f: "_blank",
                  t: 13,
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "form-group",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "input",
                    m: [{
                      n: "type",
                      f: "email",
                      t: 13
                    }, {
                      n: "autocomplete",
                      f: "email",
                      t: 13
                    }, {
                      n: "class",
                      f: "form-control",
                      t: 13
                    }, {
                      n: "name",
                      f: "MERGE0",
                      t: 13
                    }, {
                      n: "id",
                      f: "new-email",
                      t: 13
                    }, {
                      n: "placeholder",
                      f: "Enter your e-mail",
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "button",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "btn btn-default semi-bold",
                    g: 1
                  }, {
                    n: "type",
                    f: "submit",
                    t: 13,
                    g: 1
                  }],
                  f: ["Subscribe"]
                }]
              }]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "footer-separator",
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "footer-blog-links",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "footer-blog-links_title op-64",
              g: 1
            }],
            f: ["From our Blog"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "footer-blog-links_block",
              g: 1
            }],
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "a",
                m: [{
                  t: 13,
                  n: "class",
                  f: "router-ignore",
                  g: 1
                }, {
                  n: "target",
                  f: "_blank",
                  t: 13,
                  g: 1
                }, {
                  n: "href",
                  f: [{
                    t: 2,
                    r: "./url"
                  }],
                  t: 13
                }],
                f: [{
                  t: 2,
                  r: "./text"
                }]
              }],
              n: 52,
              r: "blogLinksData"
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "footer-separator",
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "footer-gp-links",
            g: 1
          }],
          f: [{
            t: 4,
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "footer-gp-links_block",
                g: 1
              }],
              f: [{
                t: 4,
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "router-ignore",
                    g: 1
                  }, {
                    n: "href",
                    f: [{
                      t: 2,
                      r: "@shared.serverHost"
                    }, {
                      t: 2,
                      r: "./url"
                    }],
                    t: 13
                  }],
                  f: [{
                    t: 2,
                    r: "./text"
                  }]
                }],
                n: 52,
                r: "."
              }]
            }],
            n: 52,
            r: "gpLinksData"
          }]
        }]
      }]
    }]
  }],
  e: {
    "_0.getFullYear()": function (_0) {
      return _0.getFullYear();
    }
  }
};
var footer = ractive.extend(component$p.exports);

var component$o = {
  exports: {}
};
component$o.exports = {
  data() {
    return {
      class: '',
      top: '0',
      size: '',
      src: ''
    };
  }
};
component$o.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "span",
    m: [{
      t: 13,
      n: "class",
      f: "c-dropdown-icon",
      g: 1
    }],
    f: [{
      t: 4,
      f: [{
        t: 7,
        e: "i",
        m: [{
          n: "class",
          f: [{
            t: 2,
            r: "class"
          }],
          t: 13
        }, {
          n: "aria-hidden",
          f: "true",
          t: 13,
          g: 1
        }, {
          n: "style-font-size",
          f: [{
            t: 2,
            r: "size"
          }],
          t: 13
        }, {
          n: "style-margin-top",
          f: [{
            t: 2,
            r: "top"
          }],
          t: 13
        }]
      }],
      n: 50,
      r: "class"
    }, {
      t: 4,
      f: [{
        t: 7,
        e: "img",
        m: [{
          n: "src",
          f: [{
            t: 2,
            r: "src"
          }],
          t: 13
        }, {
          n: "style-width",
          f: [{
            t: 2,
            r: "size"
          }],
          t: 13
        }, {
          n: "style-margin-top",
          f: [{
            t: 2,
            r: "top"
          }, ";"],
          t: 13
        }, {
          n: "alt",
          f: "",
          t: 13,
          g: 1
        }]
      }],
      n: 50,
      r: "src",
      l: 1
    }]
  }]
};
var dropdownIcon = ractive.extend(component$o.exports);

var component$n = {
  exports: {}
};
component$n.exports = {
  data() {
    return {};
  }
};
component$n.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "header",
    m: [{
      n: "class",
      f: ["c-header ", {
        t: 4,
        f: [{
          t: 2,
          r: "additionalClasses"
        }],
        n: 50,
        r: "additionalClasses"
      }],
      t: 13
    }, {
      n: "inert",
      f: [{
        t: 2,
        r: "isInert"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "nav",
      m: [{
        t: 13,
        n: "class",
        f: "navbar navbar-default navbar-filled",
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "container-fluid container-mw",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "navbar-header",
            g: 1
          }],
          f: [{
            t: 7,
            e: "a",
            m: [{
              t: 13,
              n: "class",
              f: "main-logo",
              g: 1
            }, {
              n: "href",
              f: "/",
              t: 13,
              g: 1
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this"],
                s: "[_0.fire(\"main-logo-click\")]"
              }
            }],
            f: [{
              t: 9,
              c: "\n\t\t\t\t\t\tLooking for the logo?\n\t\t\t\t\t\tGet all versions here: https://github.com/jsdelivr/globalping-media\n\t\t\t\t\t"
            }, " ", {
              t: 4,
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "138",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "34",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/", {
                    t: 2,
                    r: "mainLogoName"
                  }],
                  t: 13
                }, {
                  n: "title",
                  f: "Globalping",
                  t: 13,
                  g: 1
                }]
              }],
              n: 50,
              r: "mainLogoName"
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "138",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "34",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/globalping.svg"],
                  t: 13
                }, {
                  n: "title",
                  f: "Globalping",
                  t: 13,
                  g: 1
                }]
              }],
              n: 51,
              l: 1
            }]
          }, " ", {
            t: 7,
            e: "a",
            m: [{
              t: 13,
              n: "class",
              f: "main-logo_text globalping",
              g: 1
            }, {
              n: "href",
              f: "https://www.jsdelivr.com",
              t: 13,
              g: 1
            }],
            f: ["by jsDelivr"]
          }, " ", {
            t: 7,
            e: "button",
            m: [{
              t: 13,
              n: "class",
              f: "navbar-toggle collapsed",
              g: 1
            }, {
              n: "type",
              f: "button",
              t: 13,
              g: 1
            }, {
              n: "data-toggle",
              f: "collapse",
              t: 13,
              g: 1
            }, {
              n: "data-target",
              f: "#main-navbar",
              t: 13,
              g: 1
            }, {
              n: "aria-expanded",
              f: "false",
              t: 13,
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "sr-only",
                g: 1
              }],
              f: ["Toggle navigation"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "icon-bar",
                g: 1
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "icon-bar",
                g: 1
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "icon-bar",
                g: 1
              }]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "collapse navbar-collapse",
            g: 1
          }, {
            n: "id",
            f: "main-navbar",
            t: 13,
            g: 1
          }],
          f: [{
            t: 7,
            e: "ul",
            m: [{
              n: "class",
              f: ["nav navbar-nav navbar-right ", {
                t: 2,
                x: {
                  r: ["@shared.actualPath"],
                  s: "!_0?\"navbar-hidden\":\"about-navbar-right\""
                }
              }],
              t: 13
            }],
            f: [{
              t: 7,
              e: "li",
              f: [{
                t: 7,
                e: "a",
                m: [{
                  n: "href",
                  f: "/cli",
                  t: 13,
                  g: 1
                }],
                f: ["CLI"]
              }]
            }, " ", {
              t: 7,
              e: "li",
              m: [{
                t: 13,
                n: "class",
                f: "dropdown",
                g: 1
              }],
              f: [{
                t: 7,
                e: "a",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-toggle",
                  g: 1
                }, {
                  n: "data-toggle",
                  f: "dropdown",
                  t: 13,
                  g: 1
                }, {
                  n: "role",
                  f: "button",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-haspopup",
                  f: "true",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-expanded",
                  f: "false",
                  t: 13,
                  g: 1
                }, {
                  n: "tabindex",
                  f: "0",
                  t: 13,
                  g: 1
                }],
                f: ["Integrations ", {
                  t: 7,
                  e: "i",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "fa fa-angle-down",
                    g: 1
                  }, {
                    n: "aria-hidden",
                    f: "true",
                    t: 13,
                    g: 1
                  }]
                }]
              }, " ", {
                t: 7,
                e: "ul",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-menu",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/slack",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/slack-icon-dark.svg"],
                        t: 13
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }]
                    }, "Slack App"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/discord",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/discord-icon-dark.svg"],
                        t: 13
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }, {
                        n: "top",
                        f: "1px",
                        t: 13,
                        g: 1
                      }]
                    }, "Discord App"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "router-ignore",
                      g: 1
                    }, {
                      n: "href",
                      f: "/docs/api.globalping.io",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/code-icon-dark.svg"],
                        t: 13
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }]
                    }, "REST API"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "divider",
                    g: 1
                  }, {
                    n: "role",
                    f: "separator",
                    t: 13,
                    g: 1
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/integrations",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/list-icon-dark.svg"],
                        t: 13
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }]
                    }, "All Integrations"]
                  }]
                }]
              }]
            }, " ", {
              t: 7,
              e: "li",
              f: [{
                t: 7,
                e: "a",
                m: [{
                  n: "href",
                  f: "/credits",
                  t: 13,
                  g: 1
                }],
                f: ["Credits"]
              }]
            }, " ", {
              t: 7,
              e: "li",
              m: [{
                t: 13,
                n: "class",
                f: "dropdown",
                g: 1
              }],
              f: [{
                t: 7,
                e: "a",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-toggle",
                  g: 1
                }, {
                  n: "data-toggle",
                  f: "dropdown",
                  t: 13,
                  g: 1
                }, {
                  n: "role",
                  f: "button",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-haspopup",
                  f: "true",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-expanded",
                  f: "false",
                  t: 13,
                  g: 1
                }, {
                  n: "tabindex",
                  f: "0",
                  t: 13,
                  g: 1
                }],
                f: ["Explore ", {
                  t: 7,
                  e: "i",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "fa fa-angle-down",
                    g: 1
                  }, {
                    n: "aria-hidden",
                    f: "true",
                    t: 13,
                    g: 1
                  }]
                }]
              }, " ", {
                t: 7,
                e: "ul",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-menu",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/network",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/radio.svg"],
                        t: 13
                      }, {
                        n: "size",
                        f: "14px",
                        t: 13,
                        g: 1
                      }]
                    }, "Probe Network"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/network-providers",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-server",
                        g: 1
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }, {
                        n: "top",
                        f: "2px",
                        t: 13,
                        g: 1
                      }]
                    }, "Network Providers"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/leaderboard",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-trophy",
                        g: 1
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }, {
                        n: "top",
                        f: "1px",
                        t: 13,
                        g: 1
                      }]
                    }, "User Leaderboard"]
                  }]
                }]
              }]
            }, " ", {
              t: 7,
              e: "li",
              f: [{
                t: 7,
                e: "a",
                m: [{
                  n: "href",
                  f: "/sponsors",
                  t: 13,
                  g: 1
                }],
                f: ["Sponsors"]
              }]
            }, " ", {
              t: 7,
              e: "li",
              m: [{
                t: 13,
                n: "class",
                f: "dropdown",
                g: 1
              }],
              f: [{
                t: 7,
                e: "a",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-toggle",
                  g: 1
                }, {
                  n: "data-toggle",
                  f: "dropdown",
                  t: 13,
                  g: 1
                }, {
                  n: "role",
                  f: "button",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-haspopup",
                  f: "true",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-expanded",
                  f: "false",
                  t: 13,
                  g: 1
                }, {
                  n: "tabindex",
                  f: "0",
                  t: 13,
                  g: 1
                }],
                f: ["The Project ", {
                  t: 7,
                  e: "i",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "fa fa-angle-down",
                    g: 1
                  }, {
                    n: "aria-hidden",
                    f: "true",
                    t: 13,
                    g: 1
                  }]
                }]
              }, " ", {
                t: 7,
                e: "ul",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-menu",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/about-us",
                      t: 13,
                      g: 1
                    }],
                    f: ["About Us"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "divider",
                    g: 1
                  }, {
                    n: "role",
                    f: "separator",
                    t: 13,
                    g: 1
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "router-ignore",
                      g: 1
                    }, {
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "href",
                      f: "https://blog.globalping.io",
                      t: 13,
                      g: 1
                    }],
                    f: ["Blog ", {
                      t: 7,
                      e: "i",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-external-link",
                        g: 1
                      }, {
                        n: "aria-hidden",
                        f: "true",
                        t: 13,
                        g: 1
                      }]
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "router-ignore",
                      g: 1
                    }, {
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "href",
                      f: "https://github.com/jsdelivr/globalping",
                      t: 13,
                      g: 1
                    }],
                    f: ["GitHub ", {
                      t: 7,
                      e: "i",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-external-link",
                        g: 1
                      }, {
                        n: "aria-hidden",
                        f: "true",
                        t: 13,
                        g: 1
                      }]
                    }]
                  }]
                }]
              }]
            }, " ", {
              t: 7,
              e: "li",
              f: [{
                t: 7,
                e: "a",
                m: [{
                  n: "target",
                  f: "_blank",
                  t: 13,
                  g: 1
                }, {
                  n: "rel",
                  f: "noopener noreferrer",
                  t: 13,
                  g: 1
                }, {
                  n: "href",
                  f: "https://twitter.com/jsDelivr",
                  t: 13,
                  g: 1
                }, {
                  n: "title",
                  f: "Twitter",
                  t: 13,
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "i",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "fa fa-twitter",
                    g: 1
                  }, {
                    n: "aria-hidden",
                    f: "true",
                    t: 13,
                    g: 1
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "icon-label-mobile",
                    g: 1
                  }],
                  f: ["Twitter"]
                }]
              }]
            }, " ", {
              t: 4,
              f: [{
                t: 7,
                e: "li",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dashboard-section",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "btn btn-dash",
                    g: 1
                  }, {
                    n: "href",
                    f: "https://dash.globalping.io",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "svg",
                    m: [{
                      t: 13,
                      n: "style",
                      f: "margin-right: 8px;",
                      g: 1
                    }, {
                      n: "width",
                      f: "14",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "14",
                      t: 13,
                      g: 1
                    }, {
                      n: "viewBox",
                      f: "0 0 20 20",
                      t: 13,
                      g: 1
                    }, {
                      n: "fill",
                      f: "none",
                      t: 13,
                      g: 1
                    }, {
                      n: "stroke",
                      f: "currentColor",
                      t: 13,
                      g: 1
                    }, {
                      n: "xmlns",
                      f: "http://www.w3.org/2000/svg",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "path",
                      m: [{
                        n: "d",
                        f: "M8.33333 2.5H2.5V8.33333H8.33333V2.5Z",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-width",
                        f: "2",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linecap",
                        f: "round",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linejoin",
                        f: "round",
                        t: 13,
                        g: 1
                      }]
                    }, " ", {
                      t: 7,
                      e: "path",
                      m: [{
                        n: "d",
                        f: "M17.5 2.5H11.6667V8.33333H17.5V2.5Z",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-width",
                        f: "2",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linecap",
                        f: "round",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linejoin",
                        f: "round",
                        t: 13,
                        g: 1
                      }]
                    }, " ", {
                      t: 7,
                      e: "path",
                      m: [{
                        n: "d",
                        f: "M17.5 11.6667H11.6667V17.5001H17.5V11.6667Z",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-width",
                        f: "2",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linecap",
                        f: "round",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linejoin",
                        f: "round",
                        t: 13,
                        g: 1
                      }]
                    }, " ", {
                      t: 7,
                      e: "path",
                      m: [{
                        n: "d",
                        f: "M8.33333 11.6667H2.5V17.5001H8.33333V11.6667Z",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-width",
                        f: "2",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linecap",
                        f: "round",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linejoin",
                        f: "round",
                        t: 13,
                        g: 1
                      }]
                    }]
                  }, " Dashboard"]
                }, " ", {
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "dropdown",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "button",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "btn dropdown-toggle hidden-xs hidden-sm",
                      g: 1
                    }, {
                      n: "type",
                      f: "button",
                      t: 13,
                      g: 1
                    }, {
                      n: "data-toggle",
                      f: "dropdown",
                      t: 13,
                      g: 1
                    }, {
                      n: "aria-haspopup",
                      f: "true",
                      t: 13,
                      g: 1
                    }, {
                      n: "aria-expanded",
                      f: "false",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "svg",
                      m: [{
                        t: 13,
                        n: "style",
                        f: "vertical-align: middle;",
                        g: 1
                      }, {
                        n: "fill",
                        f: "currentColor",
                        t: 13,
                        g: 1
                      }, {
                        n: "width",
                        f: "20px",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "20px",
                        t: 13,
                        g: 1
                      }, {
                        n: "xmlns",
                        f: "http://www.w3.org/2000/svg",
                        t: 13,
                        g: 1
                      }, {
                        n: "viewBox",
                        f: "0 0 24 24",
                        t: 13,
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "g",
                        m: [{
                          n: "id",
                          f: "user",
                          t: 13,
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "path",
                          m: [{
                            n: "d",
                            f: "M12,12.25A3.75,3.75,0,1,1,15.75,8.5,3.75,3.75,0,0,1,12,12.25Zm0-6A2.25,2.25,0,1,0,14.25,8.5,2.25,2.25,0,0,0,12,6.25Z",
                            t: 13,
                            g: 1
                          }]
                        }, " ", {
                          t: 7,
                          e: "path",
                          m: [{
                            n: "d",
                            f: "M19,19.25a.76.76,0,0,1-.75-.75c0-1.95-1.06-3.25-6.25-3.25s-6.25,1.3-6.25,3.25a.75.75,0,0,1-1.5,0c0-4.75,5.43-4.75,7.75-4.75s7.75,0,7.75,4.75A.76.76,0,0,1,19,19.25Z",
                            t: 13,
                            g: 1
                          }]
                        }]
                      }]
                    }, " ", {
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "caret",
                        g: 1
                      }]
                    }, " ", {
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "sr-only",
                        g: 1
                      }],
                      f: ["Toggle Dropdown"]
                    }]
                  }, " ", {
                    t: 7,
                    e: "ul",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "dropdown-menu",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "li",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "current-user",
                        g: 1
                      }],
                      f: [{
                        t: 2,
                        r: "@shared.user.github_username"
                      }]
                    }, " ", {
                      t: 7,
                      e: "li",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "divider",
                        g: 1
                      }, {
                        n: "role",
                        f: "separator",
                        t: 13,
                        g: 1
                      }]
                    }, " ", {
                      t: 7,
                      e: "li",
                      f: [{
                        t: 7,
                        e: "a",
                        m: [{
                          n: ["click"],
                          t: 70,
                          f: {
                            r: ["@global.app"],
                            s: "[_0.signOut()]"
                          }
                        }],
                        f: ["Sign Out"]
                      }]
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "li",
                m: [{
                  t: 13,
                  n: "class",
                  f: "hidden-md hidden-lg",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: ["click"],
                    t: 70,
                    f: {
                      r: ["@global.app"],
                      s: "[_0.signOut()]"
                    }
                  }],
                  f: [{
                    t: 7,
                    e: "i",
                    m: [{
                      t: 13,
                      n: "style",
                      f: "margin-right: 8px;",
                      g: 1
                    }, {
                      t: 13,
                      n: "class",
                      f: "fa fa-sign-out",
                      g: 1
                    }]
                  }, "Sign Out"]
                }]
              }],
              n: 50,
              r: "@shared.user"
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "li",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dashboard-section",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "btn btn-sign-in",
                    g: 1
                  }, {
                    n: ["click"],
                    t: 70,
                    f: {
                      r: ["@global.app"],
                      s: "[_0.signIn()]"
                    }
                  }],
                  f: [{
                    t: 7,
                    e: "i",
                    m: [{
                      t: 13,
                      n: "style",
                      f: "margin-right: 8px;",
                      g: 1
                    }, {
                      t: 13,
                      n: "class",
                      f: "fa fa-sign-in hidden-md hidden-lg",
                      g: 1
                    }]
                  }, " Sign in ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "hidden-md hidden-lg",
                      g: 1
                    }],
                    f: [" with GitHub"]
                  }, {
                    t: 7,
                    e: "i",
                    m: [{
                      t: 13,
                      n: "style",
                      f: "margin-left: 8px;",
                      g: 1
                    }, {
                      t: 13,
                      n: "class",
                      f: "fa fa-github hidden-xs hidden-sm",
                      g: 1
                    }]
                  }]
                }]
              }, " "],
              n: 50,
              x: {
                r: ["@shared.user"],
                s: "_0===null"
              },
              l: 1
            }, {
              t: 4,
              f: [" ", {
                t: 7,
                e: "li",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dashboard-section",
                  g: 1
                }]
              }],
              n: 51,
              l: 1
            }]
          }]
        }]
      }]
    }]
  }],
  e: {
    "[_0.fire(\"main-logo-click\")]": function (_0) {
      return [_0.fire("main-logo-click")];
    },
    "!_0?\"navbar-hidden\":\"about-navbar-right\"": function (_0) {
      return !_0 ? "navbar-hidden" : "about-navbar-right";
    },
    "[_0.signOut()]": function (_0) {
      return [_0.signOut()];
    },
    "[_0.signIn()]": function (_0) {
      return [_0.signIn()];
    },
    "_0===null": function (_0) {
      return _0 === null;
    }
  }
};
component$n.exports.components = {
  "c-dropdown-icon": dropdownIcon
};
var header = ractive.extend(component$n.exports);

var component$m = {
  exports: {}
};
component$m.exports.template = {
  v: 4,
  t: [{
    t: 4,
    f: [{
      t: 7,
      e: "script",
      m: [{
        n: "type",
        f: "text/plain",
        t: 13,
        g: 1
      }, {
        n: "id",
        f: "ractive-data",
        t: 13,
        g: 1
      }],
      f: ["\t\t<<RACTIVE_SERIALIZED_DATA>>\n\t"]
    }, " ", {
      t: 7,
      e: "script",
      m: [{
        n: "type",
        f: "text/plain",
        t: 13,
        g: 1
      }, {
        n: "id",
        f: "ractive-shared",
        t: 13,
        g: 1
      }],
      f: ["\t\t", {
        t: 2,
        x: {
          r: ["@shared", "@shared.serverHost", "@shared.assetsHost", "@shared.apiDocsHost", "@shared.assetsVersion", "@shared.route", "@shared.params", "@shared.qsParams", "@shared.options"],
          s: "_0.escape(JSON.stringify({serverHost:_1,assetsHost:_2,apiDocsHost:_3,assetsVersion:_4,route:_5,params:_6,qsParams:_7,options:_8}))"
        }
      }, "\n\t"]
    }],
    n: 50,
    r: "@shared.isServer"
  }],
  e: {
    "_0.escape(JSON.stringify({serverHost:_1,assetsHost:_2,apiDocsHost:_3,assetsVersion:_4,route:_5,params:_6,qsParams:_7,options:_8}))": function (_0, _1, _2, _3, _4, _5, _6, _7, _8) {
      return _0.escape(JSON.stringify({
        serverHost: _1,
        assetsHost: _2,
        apiDocsHost: _3,
        assetsVersion: _4,
        route: _5,
        params: _6,
        qsParams: _7,
        options: _8
      }));
    }
  }
};
var rSerialize = ractive.extend(component$m.exports);

var component$l = {
  exports: {}
};
const R_META_CLASS = 'r-meta-e';
ractive.sharedSet('R_META_CLASS', R_META_CLASS);
component$l.exports = {
  oninit() {
    let rPage = this.findParent('r-page');
    let tMeta = rPage.partials.meta;
    let tSeo = rPage.partials.seo;
    let filterNodes = (o, predicate) => {
      if (Array.isArray(o)) {
        return o.filter(predicate).map(n => filterNodes(n, predicate));
      } else if (o && typeof o === 'object') {
        return Object.fromEntries(Object.entries(o).map(([key, value]) => {
          return [key, filterNodes(value, predicate)];
        }));
      }
      return o;
    };
    let walkElements = (o, callback) => {
      if (Array.isArray(o)) {
        o.forEach(i => walkElements(i, callback));
      } else if (o && typeof o === 'object') {
        if (o.t === 7) {
          callback(o);
        }
        Object.values(o).forEach(v => walkElements(v, callback));
      }
    };
    if (!tMeta._metaDecorated) {
      tMeta = filterNodes(tMeta, n => n.t !== 9);
      walkElements(tMeta, e => {
        e.m = e.m || [];
        e.m.push({
          t: 13,
          n: 'class',
          f: R_META_CLASS
        });
      });
      tMeta._metaDecorated = true;
    }
    if (tSeo && !tSeo._metaDecorated) {
      tSeo = filterNodes(tSeo, n => n.t !== 9);
      walkElements(tSeo, e => {
        e.m = e.m || [];
        e.m.push({
          t: 13,
          n: 'class',
          f: R_META_CLASS
        });
      });
      tSeo._metaDecorated = true;
    }

    // We need a way to identify the nodes rendered by the component via SSR
    // when running on the client. We do this by injecting a special class into
    // all elements in the template.
    rPage.partials.seo = tSeo;
    rPage.partials.meta = tMeta;
    this.partials = rPage.partials;
    this.resetPartial('meta', tMeta);

    // A bit of context hacking:
    // the meta partial itself renders with the context of r-page
    // the seo partial renders with the context of the current page (root context)
    this.link('', 'rootContext', {
      instance: rPage.parent
    });
    this.link('', 'rPageContext', {
      instance: rPage
    });

    // Update the shared path on page switch.
    this.set('@shared.actualPath', this.get('@shared')?.app?.router?.uri?.path);
  }
};
component$l.exports.template = {
  v: 4,
  t: [{
    t: 8,
    r: "meta",
    c: {
      r: "rPageContext"
    }
  }]
};
var rMeta = ractive.extend(component$l.exports);

var component$k = {
  exports: {}
};
component$k.exports = {
  data() {
    return {
      publicRoot: ''
    };
  },
  onrender() {
    document.querySelectorAll(`.${ractive.sharedGet('R_META_CLASS')}`).forEach(e => e.remove());
    // eslint-disable-next-line new-cap
    app.meta = new this.components['r-meta']({
      el: document.head,
      append: document.querySelector('meta').nextElementSibling,
      parent: this
    });
  },
  onunrender() {
    app.meta.teardown();
  }
};
component$k.exports.template = {
  v: 4,
  t: [{
    t: 4,
    f: [{
      t: 16
    }],
    n: 50,
    x: {
      r: ["@shared.isServer"],
      s: "!_0"
    }
  }, {
    t: 4,
    f: [{
      t: 18,
      a: " html"
    }, " ", {
      t: 7,
      e: "html",
      m: [{
        n: "lang",
        f: "en",
        t: 13,
        g: 1
      }],
      f: [{
        t: 7,
        e: "head",
        f: [{
          t: 7,
          e: "meta",
          m: [{
            n: "charset",
            f: "utf-8",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "r-meta"
        }, " ", {
          t: 9,
          c: " Static part that doesn't change after the initial render. "
        }, " ", {
          t: 9,
          c: " Maybe will be useful in Firefox at some point. "
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "dns-prefetch",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: "https://cdn.jsdelivr.net/",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 9,
          c: "\t\t\t<link rel=\"dns-prefetch\" href=\"https://datum.jsdelivr.com/\">"
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "preconnect",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: "https://cdn.jsdelivr.net/",
            t: 13,
            g: 1
          }, {
            n: "crossorigin",
            f: "anonymous",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 9,
          c: "\t\t\t<link rel=\"preconnect\" href=\"https://datum.jsdelivr.com/\" crossorigin=\"anonymous\">"
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "stylesheet",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/css/app.css?v=", {
              t: 2,
              r: "@shared.assetsVersion"
            }],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "stylesheet",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: "https://cdn.jsdelivr.net/npm/font-awesome@4.7.0/css/font-awesome.min.css",
            t: 13,
            g: 1
          }, {
            n: "media",
            f: "print",
            t: 13,
            g: 1
          }, {
            n: "onload",
            f: "this.media='all'",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "sitemap",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: "/sitemap/index.xml",
            t: 13,
            g: 1
          }, {
            n: "type",
            f: "application/xml",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "style",
          f: ["\t\t\t\t@font-face {\n\t\t\t\t\tfont-family: 'Lexend';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 100 900;\n\t\t\t\t\tsrc: url(https://cdn.jsdelivr.net/fontsource/fonts/lexend:vf@latest/latin-wght-normal.woff2) format('woff2-variations');\n\t\t\t\t}\n\n\t\t\t\t@font-face {\n\t\t\t\t\tfont-family: 'Source Code Pro';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 200 900;\n\t\t\t\t\tsrc: url(https://cdn.jsdelivr.net/fontsource/fonts/source-code-pro:vf@latest/latin-wght-normal.woff2) format('woff2-variations');\n\t\t\t\t}\n\t\t\t"]
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            n: "type",
            f: "application/ld+json",
            t: 13,
            g: 1
          }],
          f: ["\t\t\t\t{\n\t\t\t\t\t\"@context\": \"https://schema.org\",\n\t\t\t\t\t\"@type\": \"Organization\",\n\t\t\t\t\t\"name\": \"Globalping\",\n\t\t\t\t\t\"alternateName\": \"globalping\",\n\t\t\t\t\t\"description\": \"A global, open source, network testing and monitoring platform\",\n\t\t\t\t\t\"url\": \"https://globalping.io\",\n\t\t\t\t\t\"logo\": \"https://cdn.jsdelivr.net/gh/jsdelivr/globalping-media@refs/heads/master/logo/full_colored_dark.svg\",\n\t\t\t\t\t\"sameAs\": [\n\t\t\t\t\t\t\"https://x.com/jsdelivr\",\n\t\t\t\t\t\t\"https://www.linkedin.com/company/globalping/\",\n\t\t\t\t\t\t\"https://github.com/jsdelivr/globalping\"\n\t\t\t\t\t]\n\t\t\t\t}\n\t\t\t"]
        }, " ", {
          t: 16,
          r: "css"
        }]
      }, " ", {
        t: 7,
        e: "body",
        f: [{
          t: 7,
          e: "div",
          m: [{
            n: "id",
            f: "page",
            t: 13,
            g: 1
          }],
          f: [{
            t: 4,
            f: [{
              t: 16
            }],
            n: 51,
            r: "noYield"
          }]
        }, " ", {
          t: 7,
          e: "r-serialize"
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            t: 13,
            n: "class",
            f: "prerequisite-script",
            g: 1
          }, {
            n: "src",
            f: "https://cdn.jsdelivr.net/npm/jquery@3.6.3/dist/jquery.slim.min.js",
            t: 13,
            g: 1
          }, {
            n: "onload",
            f: "this.loaded=true",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            t: 13,
            n: "class",
            f: "prerequisite-script",
            g: 1
          }, {
            n: "src",
            f: "https://cdn.jsdelivr.net/npm/bootstrap@3.3.7/dist/js/bootstrap.js",
            t: 13,
            g: 1
          }, {
            n: "onload",
            f: "this.loaded=true",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            t: 13,
            n: "class",
            f: "prerequisite-script",
            g: 1
          }, {
            n: "src",
            f: "https://cdn.jsdelivr.net/npm/clipboard@2.0.11/dist/clipboard.min.js",
            t: 13,
            g: 1
          }, {
            n: "onload",
            f: "this.loaded=true",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            n: "src",
            f: "https://cdn.jsdelivr.net/npm/@algolia/autocomplete-js@1.18.1/dist/umd/index.production.min.js",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 16,
          r: "js"
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            n: "type",
            f: "module",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/js/app.js?v=", {
              t: 2,
              r: "@shared.assetsVersion"
            }],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            n: "defer",
            f: 0,
            t: 13
          }, {
            n: "data-domain",
            f: "globalping.io",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: "https://datum.jsdelivr.com/js/script.js",
            t: 13,
            g: 1
          }]
        }]
      }]
    }],
    n: 51,
    l: 1
  }],
  p: {
    meta: [{
      t: 9,
      c: " Dynamic metadata that may change between pages. "
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "viewport",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "width=device-width, initial-scale=1",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "description",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: [{
          t: 2,
          x: {
            r: ["description"],
            s: "_0||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\""
          }
        }],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "keywords",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "globalping, jsdelivr, free, open source, oss",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "property",
        f: "og:locale",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "en_US",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "property",
        f: "og:type",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "website",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "property",
        f: "og:title",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: [{
          t: 2,
          x: {
            r: ["ogTitle", "title"],
            s: "_0||_1||\"Globalping - Internet and web infrastructure monitoring and benchmarking\""
          }
        }],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "property",
        f: "og:description",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: [{
          t: 2,
          x: {
            r: ["ogDescription", "description"],
            s: "_0||_1||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\""
          }
        }],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "property",
        f: "og:url",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: [{
          t: 2,
          r: "@shared.serverHost"
        }, {
          t: 2,
          r: "@shared.actualPath"
        }],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "property",
        f: "og:site_name",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "Globalping",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "meta",
        m: [{
          n: "property",
          f: "og:image",
          t: 13,
          g: 1
        }, {
          n: "content",
          f: [{
            t: 2,
            r: "openGraphImage"
          }],
          t: 13
        }]
      }, " ", {
        t: 7,
        e: "meta",
        m: [{
          n: "property",
          f: "og:image:secure_url",
          t: 13,
          g: 1
        }, {
          n: "content",
          f: [{
            t: 2,
            r: "openGraphImage"
          }],
          t: 13
        }]
      }, " ", {
        t: 7,
        e: "meta",
        m: [{
          n: "property",
          f: "og:image:width",
          t: 13,
          g: 1
        }, {
          n: "content",
          f: "1280",
          t: 13,
          g: 1
        }]
      }, " ", {
        t: 7,
        e: "meta",
        m: [{
          n: "property",
          f: "og:image:height",
          t: 13,
          g: 1
        }, {
          n: "content",
          f: "640",
          t: 13,
          g: 1
        }]
      }, " ", {
        t: 7,
        e: "meta",
        m: [{
          n: "name",
          f: "twitter:image",
          t: 13,
          g: 1
        }, {
          n: "content",
          f: [{
            t: 2,
            r: "openGraphImage"
          }],
          t: 13
        }]
      }],
      n: 50,
      r: "openGraphImage"
    }, {
      t: 4,
      f: [{
        t: 7,
        e: "meta",
        m: [{
          n: "property",
          f: "og:image",
          t: 13,
          g: 1
        }, {
          n: "content",
          f: [{
            t: 2,
            r: "@shared.assetsHost"
          }, "/img/og-globalping.png"],
          t: 13
        }]
      }, " ", {
        t: 7,
        e: "meta",
        m: [{
          n: "property",
          f: "og:image:secure_url",
          t: 13,
          g: 1
        }, {
          n: "content",
          f: [{
            t: 2,
            r: "@shared.assetsHost"
          }, "/img/og-globalping.png"],
          t: 13
        }]
      }, " ", {
        t: 7,
        e: "meta",
        m: [{
          n: "property",
          f: "og:image:width",
          t: 13,
          g: 1
        }, {
          n: "content",
          f: "1280",
          t: 13,
          g: 1
        }]
      }, " ", {
        t: 7,
        e: "meta",
        m: [{
          n: "property",
          f: "og:image:height",
          t: 13,
          g: 1
        }, {
          n: "content",
          f: "640",
          t: 13,
          g: 1
        }]
      }, " ", {
        t: 7,
        e: "meta",
        m: [{
          n: "name",
          f: "twitter:image",
          t: 13,
          g: 1
        }, {
          n: "content",
          f: [{
            t: 2,
            r: "@shared.assetsHost"
          }, "/img/og-globalping.png"],
          t: 13
        }]
      }],
      n: 51,
      l: 1
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "twitter:card",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "summary_large_image",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "twitter:title",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: [{
          t: 2,
          x: {
            r: ["ogTitle", "title"],
            s: "_0||_1||\"Globalping - Internet and web infrastructure monitoring and benchmarking\""
          }
        }],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "twitter:description",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: [{
          t: 2,
          x: {
            r: ["ogDescription", "description"],
            s: "_0||_1||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\""
          }
        }],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "twitter:site",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "@jsdelivr",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "twitter:creator",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "@jsdelivr",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "title",
      f: [{
        t: 2,
        x: {
          r: ["title"],
          s: "_0||\"Globalping - Internet and web infrastructure monitoring and benchmarking\""
        }
      }]
    }, " ", {
      t: 7,
      e: "link",
      m: [{
        n: "rel",
        f: "icon",
        t: 13,
        g: 1
      }, {
        n: "type",
        f: "image/x-icon",
        t: 13,
        g: 1
      }, {
        n: "href",
        f: [{
          t: 2,
          r: "publicRoot"
        }, "/icons/favicon.ico"],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "link",
      m: [{
        n: "rel",
        f: "icon",
        t: 13,
        g: 1
      }, {
        n: "type",
        f: "image/svg+xml",
        t: 13,
        g: 1
      }, {
        n: "href",
        f: [{
          t: 2,
          r: "publicRoot"
        }, "/icons/favicon.svg"],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "link",
      m: [{
        n: "rel",
        f: "icon",
        t: 13,
        g: 1
      }, {
        n: "type",
        f: "image/png",
        t: 13,
        g: 1
      }, {
        n: "sizes",
        f: "48x48",
        t: 13,
        g: 1
      }, {
        n: "href",
        f: [{
          t: 2,
          r: "publicRoot"
        }, "/icons/favicon-48x48.png"],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "link",
      m: [{
        n: "rel",
        f: "icon",
        t: 13,
        g: 1
      }, {
        n: "type",
        f: "image/png",
        t: 13,
        g: 1
      }, {
        n: "sizes",
        f: "32x32",
        t: 13,
        g: 1
      }, {
        n: "href",
        f: [{
          t: 2,
          r: "publicRoot"
        }, "/icons/favicon-32x32.png"],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "link",
      m: [{
        n: "rel",
        f: "icon",
        t: 13,
        g: 1
      }, {
        n: "type",
        f: "image/png",
        t: 13,
        g: 1
      }, {
        n: "sizes",
        f: "16x16",
        t: 13,
        g: 1
      }, {
        n: "href",
        f: [{
          t: 2,
          r: "publicRoot"
        }, "/icons/favicon-16x16.png"],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "link",
      m: [{
        n: "rel",
        f: "apple-touch-icon",
        t: 13,
        g: 1
      }, {
        n: "sizes",
        f: "180x180",
        t: 13,
        g: 1
      }, {
        n: "href",
        f: [{
          t: 2,
          r: "publicRoot"
        }, "/icons/apple-touch-icon.png"],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "link",
      m: [{
        n: "rel",
        f: "manifest",
        t: 13,
        g: 1
      }, {
        n: "href",
        f: [{
          t: 2,
          r: "publicRoot"
        }, "/icons/site.webmanifest"],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "link",
      m: [{
        n: "rel",
        f: "mask-icon",
        t: 13,
        g: 1
      }, {
        n: "href",
        f: [{
          t: 2,
          r: "publicRoot"
        }, "/icons/safari-pinned-tab.svg"],
        t: 13
      }, {
        n: "color",
        f: "#e64e3d",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "apple-mobile-web-app-title",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "Globalping",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "application-name",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "Globalping",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "msapplication-TileColor",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "#ffffff",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "msapplication-config",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: [{
          t: 2,
          r: "publicRoot"
        }, "/icons/browserconfig.xml"],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "meta",
      m: [{
        n: "name",
        f: "theme-color",
        t: 13,
        g: 1
      }, {
        n: "content",
        f: "#ffffff",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 8,
      r: "seo",
      c: {
        r: "~/rootContext"
      }
    }]
  },
  e: {
    "!_0": function (_0) {
      return !_0;
    },
    "_0||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\"": function (_0) {
      return _0 || "Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.";
    },
    "_0||_1||\"Globalping - Internet and web infrastructure monitoring and benchmarking\"": function (_0, _1) {
      return _0 || _1 || "Globalping - Internet and web infrastructure monitoring and benchmarking";
    },
    "_0||_1||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\"": function (_0, _1) {
      return _0 || _1 || "Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.";
    },
    "_0||\"Globalping - Internet and web infrastructure monitoring and benchmarking\"": function (_0) {
      return _0 || "Globalping - Internet and web infrastructure monitoring and benchmarking";
    }
  }
};
component$k.exports.components = {
  "r-serialize": rSerialize,
  "r-meta": rMeta
};
var rPage = ractive.extend(component$k.exports);

var component$j = {
  exports: {}
};
const CLIENT_DEFAULT_PING_OPTS = {
  protocol: 'ICMP'
};
const API_DEFAULT_PING_OPTS = {
  protocol: 'ICMP'
};
const CLIENT_DEFAULT_TRACEROUTE_OPTS = {
  protocol: 'ICMP'
};
const API_DEFAULT_TRACEROUTE_OPTS = {
  protocol: 'ICMP'
};
const CLIENT_DEFAULT_DNS_OPTS = {
  protocol: 'UDP',
  query: {
    type: 'A'
  },
  trace: false
};
const API_DEFAULT_DNS_OPTS = {
  protocol: 'UDP',
  query: {
    type: 'A'
  },
  trace: false
};
const CLIENT_DEFAULT_MTR_OPTS = {
  protocol: 'ICMP'
};
const API_DEFAULT_MTR_OPTS = {
  protocol: 'ICMP'
};
const CLIENT_DEFAULT_HTTP_OPTS = {
  protocol: 'HTTPS',
  request: {
    method: 'GET'
  }
};
const API_DEFAULT_HTTP_OPTS = {
  protocol: 'HTTPS',
  request: {
    method: 'HEAD'
  }
};
const DEFAULT_PACKETS_AMOUNT = 3;
const DEFAULT_LIMIT$2 = 1;
const DOCKER_CMD_CONTENT = 'docker run -d --log-driver local --network host --restart=always --name globalping-probe globalping/globalping-probe';
const DOCKER_CMD_CONTENT_FULL = [{
  cmd: 'docker run -d \\',
  comment: ' # Make sure the container runs on boot'
}, {
  cmd: '--log-driver local \\',
  comment: ' # Use the modern logging driver to ensure old logs are deleted'
}, {
  cmd: '--network host \\',
  comment: ' # Bypass overlay and mesh networking to ensure they dont impact latency tests'
}, {
  cmd: '--restart=always \\',
  comment: ' # Restart the container if it crashes'
}, {
  cmd: '--name globalping-probe globalping/globalping-probe',
  comment: ''
}];
const PODMAN_CMD_CONTENT = 'sudo podman run -d --cap-add=NET_RAW --network host --restart=always --name globalping-probe globalping/globalping-probe';
const PODMAN_CMD_CONTENT_FULL = [{
  cmd: 'sudo \\',
  comment: ' # Allows the --cap-add=NET_RAW option to work properly'
}, {
  cmd: 'podman run -d \\',
  comment: ' # The container will NOT start on boot. You need to create a systemd service first.'
}, {
  cmd: '--cap-add=NET_RAW \\',
  comment: ' # Network permissions to run ping'
}, {
  cmd: '--network host \\',
  comment: '# Bypass overlay and mesh networking to ensure they dont impact latency tests'
}, {
  cmd: '--restart=always \\',
  comment: ' # Restart the container if it crashes'
}, {
  cmd: '--name globalping-probe globalping/globalping-probe',
  comment: ''
}];
const INITIAL_MAIN_OPTS_VALUES = {
  type: 'ping',
  target: '',
  location: 'World',
  limit: '10'
};
const MAP_MIN_ZOOM$1 = 2;
const MAP_MAX_ZOOM$1 = 22;
const MAP_ZOOM_REG$1 = 3.74;
const MAP_CENTER_REG$1 = {
  lat: 48,
  lng: 16
};
const MAP_ZOOM_ALT$1 = 2.14;
const MAP_CENTER_ALT$1 = {
  lat: 30,
  lng: 18
};
const DEFAULT_MARKER_COLOR = '#C0C0C0';
const PROBE_NO_TIMING_VALUE$2 = _.getProbeTimeOutValue();
const PROBE_STATUS_FAILED = _.getProbeStatusFailedValue();
const PROBE_STATUS_OFFLINE$2 = _.getProbeStatusOfflineValue();
const PROBE_OFFLINE_TEXT = 'Probe offline';
const RAW_OUTPUT_LINES_BATCH_LIMIT = 40;
const DEFAULT_TARGET_VALUE = 'cdn.jsdelivr.net';
const INFINITE_MEASUREMENT_PACKETS = 16;
const INFINITE_MEASUREMENT_LIMIT = 5;
const RATE_LIMIT_HEADERS$2 = ['x-ratelimit-limit', 'x-ratelimit-consumed', 'x-ratelimit-remaining', 'x-ratelimit-reset', 'x-credits-consumed', 'x-credits-remaining', 'x-request-cost'];
const PORT_SUPPORTED_BY_TYPE = {
  ping: ['TCP'],
  traceroute: ['TCP'],
  mtr: ['TCP', 'UDP']
};
const DEFAULT_SORT_BY = 'location';
const DEFAULT_SORT_ORDER$1 = 'asc';
const SORT_ORDER_OPTS = ['asc', 'desc'];
const FOCUS_MODE_CONTENT_SWAP_MS = 150;
const FOCUS_MODE_RESULTS_EXPAND_MS = 420;
const FOCUS_MODE_CONTENT_EXIT_MS = 180;
const FOCUS_MODE_PROMPT_ENTER_MS = 180;
const FOCUS_MODE_POSITION_MS = 420;
const FOCUS_MODE_EXIT_SCROLL_MS = FOCUS_MODE_POSITION_MS + FOCUS_MODE_CONTENT_EXIT_MS;
const FOCUS_MODE_SCROLL_OFFSET = 30;
const PENDING_RESULT_SCROLL_TIMEOUT_MS = 500;
const SMOOTH_SCROLL_SETTLE_DELAY_MS = 120;
const SMOOTH_SCROLL_MAX_DURATION_MS = 2000;
const SORT_BY_OPTS = [{
  value: 'location',
  name: 'Location'
}, {
  value: 'quality',
  name: 'Quality'
}, {
  value: 'rtt-last',
  name: 'Rtt last'
}, {
  value: 'min',
  name: 'Rtt min'
}, {
  value: 'avg',
  name: 'Rtt avg'
}, {
  value: 'max',
  name: 'Rtt max'
}];
const ALLOWED_COLLAPSE_OPTS = ['all', 'none']; // default would be "response bodies"

const getMarkerSize$1 = (probeCount, zoom) => {
  let size = {
    svgWidth: 16,
    svgHeight: 16,
    circleRadius: 4.5,
    strokeWidth: 1.5
  };
  if (probeCount > 1) {
    let scalingFactor = probeCount.toString().length;
    size.svgWidth += 4 * scalingFactor + 4;
    size.svgHeight += 4 * scalingFactor + 4;
    size.circleRadius += 2 * scalingFactor + 1.5;
    size.strokeWidth += .5;
  }
  if (zoom >= 5) {
    size.svgWidth *= 1.1;
    size.svgHeight *= 1.1;
  }
  if (zoom >= 10) {
    size.svgWidth *= 1.1;
    size.svgHeight *= 1.1;
  }
  return size;
};
const originalMapMarkersPos = new Map();
const DEFAULT_MARKER_DIMENSIONS = 24;
let map$1;
let infoWindows$1 = [];
let mapMarkers$1 = [];
let probesMarkers = [];
let probesInfoWindows = [];
let mapProbesClusters = [];
component$j.exports = {
  decorators: {
    clipboard
  },
  data() {
    return {
      _,
      map: null,
      display: null,
      view: null,
      rawProbes: '',
      PROBE_NO_TIMING_VALUE: PROBE_NO_TIMING_VALUE$2,
      PROBE_STATUS_FAILED,
      PROBE_STATUS_OFFLINE: PROBE_STATUS_OFFLINE$2,
      DEFAULT_TARGET_VALUE,
      INFINITE_MEASUREMENT_LIMIT,
      INITIAL_MAIN_OPTS_VALUES,
      testTypesList: ['ping', 'traceroute', 'DNS', 'MTR', 'HTTP'],
      mainOptions: {
        ...INITIAL_MAIN_OPTS_VALUES
      },
      showMap: true,
      originalShowMap: true,
      transitionMap: true,
      infiniteSwitchEnabled: false,
      showMeasurementOpts: false,
      dnsTypesList: ['A', 'AAAA', 'ANY', 'CNAME', 'DNSKEY', 'DS', 'MX', 'NS', 'NSEC', 'PTR', 'RRSIG', 'SOA', 'TXT', 'SRV', 'SVCB'],
      netDockerCmdText: DOCKER_CMD_CONTENT,
      netDockerCmdTextFull: DOCKER_CMD_CONTENT_FULL,
      netPodmanCmdText: PODMAN_CMD_CONTENT,
      netPodmanCmdTextFull: PODMAN_CMD_CONTENT_FULL,
      totalProbes: 0,
      totalCities: 0,
      totalCountries: 0,
      pingOpts: JSON.parse(JSON.stringify(CLIENT_DEFAULT_PING_OPTS)),
      // deep copy is needed here, as default values for other options are deep-copied elsewhere
      tracerouteOpts: CLIENT_DEFAULT_TRACEROUTE_OPTS,
      dnsOpts: CLIENT_DEFAULT_DNS_OPTS,
      mtrOpts: CLIENT_DEFAULT_MTR_OPTS,
      httpOpts: CLIENT_DEFAULT_HTTP_OPTS,
      inputErrors: {},
      testResults: null,
      testInProgress: false,
      runTestBtnDisabled: true,
      gmapsReady: false,
      runTestBtnDelayTimeout: null,
      testReqCancelFn: null,
      activeTestRunId: 0,
      gmapsIdleListener: null,
      notAppliedOpts: {},
      defaultPacketsAmount: DEFAULT_PACKETS_AMOUNT,
      defaultLimit: DEFAULT_LIMIT$2,
      probesMinTiming: 5,
      joinNetSwitchValue: 'docker',
      showCommandsBlock: false,
      scrolledToResId: null,
      modifiedMeasOptsCnt: 0,
      appliedMeasOpts: {},
      measurementDate: null,
      mobileShareResHeaderData: null,
      runTestBtnText: 'Run Test',
      testReqParams: null,
      focusModeTransition: null,
      focusModeTransitionTimeout: null,
      focusModePosition: null,
      focusModePositionTimeout: null,
      pendingResultId: null,
      showMeasurementLoadingInfo: false,
      sharedMeasurementInitialLoading: false,
      probesResponse: null,
      clusterRadius: null,
      nextClusterRadius: null,
      shareResFlow: false,
      activeTargetIdx: 0,
      rawOutputMode: true,
      measurementsMetadata: null,
      targetsArr: [],
      hiddenTestResults: {
        0: [],
        1: []
      },
      hiddenResponseBodies: {
        0: [],
        1: []
      },
      qsMeasurementIdsArr: [],
      showCreditsErrorBar: false,
      infiniteMeasIds: [],
      isInfiniteMeasStopped: false,
      isInfiniteModeRes: false,
      prevProbesMeasId: null,
      preparedTestResults: [],
      loadingProbeResults: [],
      ddHandlerSet: false,
      showCreditsData: false,
      rateCreditsData: null,
      measurementErrMsg: null,
      probesMaxTiming: 200,
      sortBy: DEFAULT_SORT_BY,
      sortOrder: DEFAULT_SORT_ORDER$1,
      sortByOpts: SORT_BY_OPTS,
      locationAutofilled: false,
      showingNetworkLogos: false,
      screenWidth: ractive.isServer ? 0 : window.innerWidth,
      collapseFromQuery: null,
      skipDefaultAutoCollapseFromQuery: false,
      integrationExamples: [{
        name: 'n8n',
        description: 'Add Globalping to your n8n workflows and get access to thousands of probes.',
        img: '/img/integrations/n8n.svg'
      }, {
        name: 'Uptime Kuma',
        description: 'Self-hosted uptime monitoring with native Globalping integration.',
        img: '/img/integrations/uptime-kuma.svg'
      }, {
        name: 'Zapier',
        description: 'Build advanced automations without writing any code using Zapier.',
        img: '/img/integrations/zapier.svg'
      }, {
        name: 'Upptime',
        description: 'GitHub Actions based uptime monitoring with Globalping.',
        img: '/img/integrations/upptime.svg'
      }]
    };
  },
  computed: {
    ogTitle() {
      return this.get('_measurementOgTitle');
    },
    ogDescription() {
      return this.get('_measurementOgDescription');
    },
    disablePort() {
      let type = this.get('mainOptions.type').toLowerCase();
      let opts = this.get(`${type}Opts`);
      let supportedProtocols = PORT_SUPPORTED_BY_TYPE[type];
      if (!supportedProtocols) {
        return false;
      }
      return !supportedProtocols.includes(opts?.protocol ?? '');
    },
    location: {
      get() {
        // This is a one-way setter.
        return this.get('_location');
      },
      set(value) {
        this.set('_location', value);
        this.set('mainOptions.location', value.replace(/%/g, '+'));
      }
    },
    allCollapsed() {
      let targetCount = this.get('targetsArr').length;
      let testProbeCount = this.get('preparedTestResults').length;
      for (let i = 0; i < targetCount; i++) {
        if (this.get(`hiddenTestResults[${i}]`).length !== testProbeCount) {
          return false;
        }
      }
      return true;
    },
    tableOutputReady() {
      let preparedTestResults = this.get('preparedTestResults') || [];
      let expectedTargetsCnt = this.get('isInfiniteModeRes') || this.get('qsMeasurementIdsArr.length') <= 1 ? this.get('targetsArr.length') : this.get('qsMeasurementIdsArr.length');
      let actualTargetsCnt = preparedTestResults[0]?.statsPerTarget?.length || 0;
      return preparedTestResults.length && (!expectedTargetsCnt || actualTargetsCnt >= expectedTargetsCnt);
    },
    focusModePromptStatus() {
      let measurementErrMsg = this.get('measurementErrMsg');
      let testResults = Object.values(this.get('testResults') || {});
      let hasTestResults = testResults.some(results => results?.length);
      let title = 'Measurement was stopped';
      let description = 'Open focus mode to review any available measurement details.';
      if (measurementErrMsg) {
        title = 'Measurement failed';
        description = measurementErrMsg;
      } else if (this.get('sharedMeasurementInitialLoading')) {
        title = 'Measurement is loading';
        description = 'The shared measurement results are still loading.';
      } else if (this.get('testInProgress')) {
        title = 'Measurement is running';
        description = 'Open focus mode to view detailed results and sharing options as they become available.';
      } else if (hasTestResults) {
        title = 'Measurement results are ready';
        description = 'Open focus mode to view detailed results and sharing options.';
      }
      return {
        title,
        description
      };
    },
    focusModeResultsPreviewAvailable() {
      let testResults = Object.values(this.get('testResults') || {});
      let hasTestResults = testResults.some(results => results?.length);
      let hasLoadingProbeResults = this.get('remainingLoadingProbeResults.length') > 0;
      let testInProgress = this.get('testInProgress');
      let localLoadingPreviewAvailable = testInProgress && !this.get('shareResFlow') && (hasLoadingProbeResults || hasTestResults);
      return this.get('focusModeSupported') && !this.get('measurementErrMsg') && !this.get('sharedMeasurementInitialLoading') && (!testInProgress || localLoadingPreviewAvailable) && (hasTestResults || hasLoadingProbeResults) && (this.get('rawOutputMode') || this.get('tableOutputReady') || hasLoadingProbeResults);
    },
    focusModeAvailable() {
      return this.get('focusModeSupported') && !!(this.get('testInProgress') || this.get('testResults') || this.get('measurementErrMsg') || this.get('testReqParams') || this.get('shareResFlow') || this.get('measurement'));
    },
    focusModeActive() {
      return this.get('focusModeSupported') && !this.get('view') && this.get('focusModeAvailable');
    },
    focusModeSupported() {
      return this.get('screenWidth') >= 768;
    },
    remainingLoadingProbeResults() {
      if (this.get('isInfiniteMeasStopped')) {
        return [];
      }
      let preparedResultIds = new Set((this.get('preparedTestResults') || []).map(result => result.clientSideId));
      return (this.get('loadingProbeResults') || []).filter(result => !preparedResultIds.has(result.clientSideId));
    },
    rawOutputExpandedListWidth() {
      let screenWidth = this.get('screenWidth') || 0;
      if (ractive.isServer || screenWidth < 768) {
        return 0;
      }
      let pageWidth = document.body?.clientWidth || document.documentElement.clientWidth;
      return Math.min(1304, pageWidth - 48);
    },
    anyResponseBodyCollapsible() {
      if (ractive.isServer) {
        return false;
      }
      let preparedTestResults = this.get('preparedTestResults') || [];
      let resultsToCheck = this.get('focusModeResultsPreviewAvailable') && !this.get('focusModeActive') ? preparedTestResults.slice(0, 1) : preparedTestResults;
      let targetsArr = this.get('targetsArr') || [];
      let charsPerLine = this.getRawOutputCharsPerLine();
      for (let targetIdx = 0; targetIdx < targetsArr.length; targetIdx++) {
        for (let i = 0; i < resultsToCheck.length; i++) {
          let body = resultsToCheck[i]?.statsPerTarget?.[targetIdx]?.responseBody || '';
          if (_.shouldCollapseResponseBody(body, charsPerLine)) {
            return true;
          }
        }
      }
      return false;
    }
  },
  onrender() {
    this.focusModeRenderId = (this.focusModeRenderId || 0) + 1;
    if (!ractive.isServer) {
      this.set('@shared.googleMapsLoaded', true);
      if (app.loaded) {
        setTimeout(this.initMap.bind(this));
      }
      listeners.screenWidthListener(this);
      listeners.addManagedListener(this, document, 'keydown', event => this.handleFocusModeKeyDown(event));
      listeners.addManagedListener(this, document, 'click', event => this.handleFocusModeDocumentClick(event));
    }
  },
  oninit() {
    this.pendingResultScrollFrame = null;
    this.pendingResultScrollCancel = null;
    if (!ractive.isServer) {
      this.on('c-header.main-logo-click', () => {
        this.set('measurement', '');
        return false;
      });

      // check if ids are present in query string
      // if so - it is a share-results-flow
      let measurement = this.get('measurement');
      let view = this.get('view');
      let qsMeasurementIdsArr = [];
      let isInfiniteMeas = false;
      let isMultiEpMeas = false;
      if (view === 'measurement' || !measurement && view === 'home') {
        app.router.replaceQueryParam('view', null, this);
      }

      // A separator for IDs for regular link is a comma, for infinite one - plus sign
      if (measurement && measurement.includes(',')) {
        qsMeasurementIdsArr = measurement.split(',');
        isMultiEpMeas = true;
      } else if (measurement && measurement.includes('.')) {
        qsMeasurementIdsArr = measurement.split('.');
        isInfiniteMeas = true;
        this.set('infiniteSwitchEnabled', true);
        this.set('isInfiniteModeRes', true);
        this.set('rawOutputMode', false);
      } else if (measurement) {
        qsMeasurementIdsArr = [measurement];
      }
      if (qsMeasurementIdsArr.length) {
        this.set('qsMeasurementIdsArr', qsMeasurementIdsArr);
        this.set('shareResFlow', true);
        this.set('sharedMeasurementInitialLoading', true);
        this.set('prevProbesMeasId', qsMeasurementIdsArr[0]);
        this.getMultipleTestMeasurementById(qsMeasurementIdsArr, isInfiniteMeas);
      }

      // read the map and display URL params and apply them
      let map = this.get('map');
      let display = this.get('display');
      if (map === 'hidden') {
        this.set({
          showMap: false,
          originalShowMap: false
        });
      }
      let nonDefaultDisplayValue = isMultiEpMeas || isInfiniteMeas ? 'raw' : 'table';
      if (display === nonDefaultDisplayValue) {
        // if valid, set the non-default value in params
        this.set('rawOutputMode', display === 'raw');
      } else {
        // otherwise set the appropriate default value
        // for multi-endpoint tests, this always sets the display to table
        // if the test is not ping, it is changed back to raw in an observer
        this.set('rawOutputMode', nonDefaultDisplayValue !== 'raw');
      }

      // read the sorting URL params and apply them
      let by = this.get('by');
      let order = this.get('order');
      let sortByVals = SORT_BY_OPTS.map(opt => opt.value);
      if (sortByVals.includes(by)) {
        this.set('sortBy', by);
      }
      if (SORT_ORDER_OPTS.includes(order)) {
        this.set('sortOrder', order);
      }

      // read the collapse URL param and apply it once results are available
      let collapse = this.get('collapse');
      if (ALLOWED_COLLAPSE_OPTS.includes(collapse)) {
        this.set('collapseFromQuery', collapse);
      }

      // get probes from sessionStorage or fetch them and handle
      this.getProbesData();
      let location = this.get('location');
      if (location && !measurement) {
        this.set('locationAutofilled', true);
      }
      this.initResponseBodyCharWidth();
      this.observe('focusModeActive', (focusModeActive, previousFocusModeActive) => {
        if (focusModeActive && this.get('focusModePosition') !== 'entering') {
          this.cancelFocusModeExitScroll();
          if (this.focusModeAvailabilityClosePending) {
            this.focusModeAvailabilityClosePending = false;
            this.focusModeClosePending = false;
            this.clearFocusModeTransition();
            if (this.get('focusModePosition') === 'preparing-close') {
              this.set('focusModePosition', null);
              this.moveFocusModeBackdrop(false);
              return;
            }
          }
          this.startFocusModePositionEntry();
        } else if (previousFocusModeActive && this.get('focusModeSupported') && this.get('focusModePosition') !== 'leaving' && !this.focusModeClosePending) {
          this.closeFocusMode(null, false, true);
        }
      }, {
        init: false
      });
      this.observe('focusModeActive testInProgress shareResFlow measurement testReqParams sharedMeasurementInitialLoading', () => {
        clearTimeout(this.measurementLoadingInfoTimeout);
        this.measurementLoadingInfoTimeout = null;
        this.set('showMeasurementLoadingInfo', false);
        let shouldShow = this.shouldShowMeasurementLoadingInfo();
        if (shouldShow && this.get('shareResFlow')) {
          this.set('showMeasurementLoadingInfo', true);
        } else if (shouldShow) {
          this.measurementLoadingInfoTimeout = setTimeout(() => {
            this.measurementLoadingInfoTimeout = null;
            if (this.shouldShowMeasurementLoadingInfo()) {
              this.set('showMeasurementLoadingInfo', true);
            }
          }, 300);
        }
      });
      this.observe('pendingResultId focusModeActive focusModeSupported tableOutputReady rawOutputMode', () => {
        this.scrollToPendingResult();
      }, {
        defer: true
      });
      this.observe('sortBy', sortBy => {
        app.router.replaceQueryParam('by', sortBy === DEFAULT_SORT_BY ? null : sortBy, this);
      });
      this.observe('sortOrder', sortOrder => {
        app.router.replaceQueryParam('order', sortOrder === DEFAULT_SORT_ORDER$1 ? null : sortOrder, this);
      });
      this.observe('sortOrder sortBy preparedTestResults activeTargetIdx rawOutputMode', () => {
        let sortOrder = this.get('sortOrder');
        let sortBy = this.get('sortBy');
        let preparedTestResults = this.get('preparedTestResults');
        let rawOutputMode = this.get('rawOutputMode');
        let activeTargetIdx = rawOutputMode ? this.get('activeTargetIdx') : 0;
        if (preparedTestResults.length) {
          let sortedResults = _.sortGpMeasurementResults(preparedTestResults, sortBy, sortOrder, activeTargetIdx);
          let orderChanged = sortedResults.length !== preparedTestResults.length || sortedResults.some((result, idx) => result.clientSideId !== preparedTestResults[idx]?.clientSideId);
          if (orderChanged) {
            this.set('preparedTestResults', sortedResults);
          }
        }
      });

      // clear table sort params and enable rawOutputMode whenever test type isn't ping
      this.observe('testReqParams.type', testType => {
        if (testType && testType !== 'ping') {
          this.set('rawOutputMode', true);
          app.router.replaceQueryParam('by', null, this);
          app.router.replaceQueryParam('order', null, this);
        }
      });

      // persist non-default display value in the URL
      this.observe('rawOutputMode testReqParams.type', () => {
        let testType = this.get('testReqParams.type');
        if (!testType) {
          return;
        }
        let rawOutputMode = this.get('rawOutputMode');
        let isInfiniteMeas = this.get('isInfiniteModeRes');
        let isMultiEpMeas = this.get('measurement')?.split(',')?.length >= 2;
        if (testType === 'ping' && (isInfiniteMeas || isMultiEpMeas)) {
          app.router.replaceQueryParam('display', rawOutputMode ? 'raw' : null, this);
        } else {
          app.router.replaceQueryParam('display', rawOutputMode ? null : 'table', this);
        }
      });

      // persist non-default map value in the URL
      this.observe('showMap', showMap => {
        app.router.replaceQueryParam('map', showMap ? null : 'hidden', this);
      });
      this.observe('preparedTestResults', (preparedTestResults, prevPreparedTestResults) => {
        if (_.isEqual(preparedTestResults, prevPreparedTestResults)) {
          return;
        }
        let collapse = this.get('collapseFromQuery');
        let testType = (this.get('testReqParams.type') || '').toLowerCase();
        let targetCount = this.get('targetsArr')?.length || 0;
        let firstResultTargetCount = preparedTestResults?.[0]?.statsPerTarget?.length || 0;
        if (!preparedTestResults.length) {
          this.set('skipDefaultAutoCollapseFromQuery', false);
          return;
        }

        // respect query-driven collapse first and prevent subsequent partial-result updates from overriding it with default auto-collapse
        if (collapse) {
          if (collapse === 'none') {
            this.expandAllRawOutput({
              withResponseBody: true
            });
          } else {
            // === 'all'
            this.collapseAllRawOutput();
          }
          this.set('collapseFromQuery', null);
          this.set('skipDefaultAutoCollapseFromQuery', true);
          return;
        }
        if (this.get('skipDefaultAutoCollapseFromQuery')) {
          return;
        }

        // skip default collapsing until all target data is present
        if (targetCount && targetCount !== firstResultTargetCount) {
          return;
        }
        if (prevPreparedTestResults.length === 0 && preparedTestResults.length > 0 && !collapse) {
          this.collapseAllRawOutput({
            responseBodyOnly: true
          });
        }

        // close response bodies by default
        if (!collapse && testType === 'http' && preparedTestResults.length) {
          this.collapseAllRawOutput({
            responseBodyOnly: true
          });
        }
      }, {
        deep: true,
        defer: true
      });
      this.observe('hiddenTestResults hiddenResponseBodies preparedTestResults targetsArr collapseFromQuery', () => {
        if (this.get('collapseFromQuery')) {
          return;
        }
        let preparedTestResults = this.get('preparedTestResults');
        let targetCount = this.get('targetsArr')?.length || 0;
        let firstResultTargetCount = preparedTestResults?.[0]?.statsPerTarget?.length || 0;
        if (!preparedTestResults.length) {
          app.router.replaceQueryParam('collapse', null, this);
          return;
        }

        // Avoid transient URL updates while multi-target results are still partially populated.
        if (targetCount && targetCount !== firstResultTargetCount) {
          return;
        }
        let hiddenTestResults = this.get('hiddenTestResults') || {};
        let hiddenResponseBodies = this.get('hiddenResponseBodies') || {};
        let testType = this.get('testReqParams.type');
        let isHttpTest = testType.toLowerCase() === 'http';
        let anyResponseBodyCollapsible = this.get('anyResponseBodyCollapsible');
        let availableTargets = targetCount;
        if (!availableTargets) {
          return;
        }
        let allCollapsed = true;
        let allExpanded = true;
        let allResponseBodiesExpanded = isHttpTest;
        for (let targetIdx = 0; targetIdx < availableTargets; targetIdx++) {
          let hidden = hiddenTestResults[targetIdx] || [];
          let hiddenContent = hiddenResponseBodies[targetIdx] || [];
          if (hidden.length !== preparedTestResults.length) {
            allCollapsed = false;
          }
          if (hiddenContent.length) {
            allResponseBodiesExpanded = false;
          }
          if (hidden.length) {
            allExpanded = false;
          }
        }
        let collapsedValue = null;
        if (allCollapsed) {
          collapsedValue = 'all';
        } else if (allExpanded && allResponseBodiesExpanded && (!isHttpTest || anyResponseBodyCollapsible)) {
          collapsedValue = 'none';
        }
        app.router.replaceQueryParam('collapse', collapsedValue, this);
      }, {
        defer: true,
        init: false
      });

      // handle test type switch
      this.observe('mainOptions.type', type => {
        // if qsMeasurementIdsArr - share-results-flow, so type would be set, we should ignore this case
        if (this.get('qsMeasurementIdsArr').length) {
          return;
        }
        this.resetMeasurementOptions(type);
      }, {
        init: false
      });

      // when infinite switch is enabled set limit to INFINITE_MEASUREMENT_LIMIT if limit is bigger than INFINITE_MEASUREMENT_LIMIT
      this.observe('infiniteSwitchEnabled', infiniteSwitchEnabled => {
        let currentLimit = this.get('mainOptions.limit');
        if (infiniteSwitchEnabled && currentLimit > INFINITE_MEASUREMENT_LIMIT) {
          this.set('mainOptions.limit', INFINITE_MEASUREMENT_LIMIT);
        } else if (infiniteSwitchEnabled === false && currentLimit > INFINITE_MEASUREMENT_LIMIT) {
          this.set('mainOptions.limit', INITIAL_MAIN_OPTS_VALUES.limit);
        }
      });

      // handle limit changing when infinite switch is enabled - disable input if it is bigger than INFINITE_MEASUREMENT_LIMIT
      this.observe('mainOptions.limit', currentLimit => {
        let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');
        if (infiniteSwitchEnabled && currentLimit >= INFINITE_MEASUREMENT_LIMIT) {
          this.set('mainOptions.limit', INFINITE_MEASUREMENT_LIMIT);
        }
      });

      // handle join-network switch and commands content
      this.observe('joinNetSwitchValue', joinNetSwitchValue => {
        let netCmdText;
        let netCmdTextFull;
        switch (joinNetSwitchValue) {
          case 'podman':
            netCmdText = this.get('netPodmanCmdText');
            netCmdTextFull = this.get('netPodmanCmdTextFull');
            break;
          case 'docker':
          default:
            netCmdText = this.get('netDockerCmdText');
            netCmdTextFull = this.get('netDockerCmdTextFull');
        }
        this.set('netCmdText', netCmdText);
        this.set('netCmdTextFull', netCmdTextFull);
        let clipboardValue = netCmdTextFull.map(part => part.cmd).join('\n');
        this.set('netCmdTextFullClipboard', clipboardValue);
        if (this.get('showCommandsBlock')) {
          this.set('showCommandsBlock', false);
        }
      });

      // handle show-hide full join-network command
      this.observe('showCommandsBlock', showCommandsBlock => {
        if (showCommandsBlock) {
          this.expandCmdBlock();
        } else {
          this.collapseCmdBlock();
        }
      }, {
        init: false,
        defer: true
      });

      // zoom to results once we get the first response
      this.observe('realTimeTestResResponse', (responses, prevResponses) => {
        if (!prevResponses && responses && responses.every(r => r.results.length) && responses[0]) {
          this.zoomToResults(responses[0].locations);
        }
      }, {
        init: false
      });

      // handle test results in real time
      this.observe('realTimeTestResResponse', realTimeTestResResponse => {
        if (!realTimeTestResResponse) {
          return;
        }

        // clear refetch timeout for the related request when it's finished, collect response statuses
        let respStatuses = realTimeTestResResponse.reduce((statusObj, r, rIdx) => {
          if (r.status === 'finished') {
            this.get(`testReqCancelFn[${rIdx}]`)?.();
            return {
              ...statusObj,
              [rIdx]: true
            };
          }
          return {
            ...statusObj,
            [rIdx]: false
          };
        }, {});

        // check respStatuses and handle the case when all requests are finished unless it is an infinite flow
        let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');
        let targetsArrLength = this.get('targetsArr').length;
        if (this.get('shareResFlow')) {
          this.set('testInProgress', realTimeTestResResponse.some(r => r.status === 'in-progress'));
        }
        if (!(targetsArrLength === 1 && infiniteSwitchEnabled) && Object.values(respStatuses).length === targetsArrLength && Object.values(respStatuses).every(s => s === true)) {
          this.set('testInProgress', false);
          if (!this.get('shareResFlow')) {
            this.disableRunTestBtnForDelay();
          }
        }
        if (realTimeTestResResponse && realTimeTestResResponse.length) {
          realTimeTestResResponse.forEach((rtTestRes, rtTestResIdx) => {
            let prevTestResults = this.get(`testResults[${rtTestResIdx}]`);
            let testResults = rtTestRes.results.map((res, resIdx) => ({
              id: rtTestRes.id,
              clientSideId: resIdx,
              target: rtTestRes.target,
              type: rtTestRes.type,
              clientSideStartedAt: prevTestResults ? prevTestResults[resIdx].clientSideStartedAt : rtTestRes.clientSideStartedAt,
              clientSideUpdatedAt: rtTestRes.clientSideUpdatedAt,
              serverTime: new Date(rtTestRes.updatedAt).getTime() - new Date(rtTestRes.createdAt).getTime(),
              status: rtTestRes.status,
              ...res
            }));
            if (JSON.stringify(testResults) !== JSON.stringify(prevTestResults)) {
              this.set(`testResults[${rtTestResIdx}]`, testResults);
            }
          });
        }
      }, {
        init: false
      });

      // prepare data for Markers of the map, timings for the map scale
      this.observe('testResults', testResults => {
        if (!testResults) {
          return;
        }
        let dnsOpts = this.get('dnsOpts');
        let testType = this.get('mainOptions.type');
        let targetsCnt = this.get('targetsArr').length;
        let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');

        // combine results
        // if it is a regular measurement then each array element is corresponds to each target, these arrays elements contain data per probe for this target
        // if Infinite measurement - each array element is a new request's response, each el inside such array is a data for probe
        let parsedMeasData = testResults.reduce((mData, tRes, tResIdx) => {
          if (!tRes || !tRes.length) {
            return mData;
          }
          let mappedRes = tRes.map((res, resIdx) => {
            let calcTiming = null;
            let data = {
              id: res.id,
              clientSideId: res.clientSideId,
              network: res.probe.network,
              city: res.probe.city,
              country: res.probe.country,
              lat: res.probe.latitude,
              lng: res.probe.longitude,
              targets: [res.target]
            };
            if (infiniteSwitchEnabled) {
              let {
                packetsRtt
              } = _.parseGpRawOutputForTimings(res.result.rawOutput);
              let prevPacketsRtt = tResIdx - 1 >= 0 ? mData[tResIdx - 1][resIdx].packetsRtt : [];
              let allCurrPacketsRtt = [...prevPacketsRtt, ...packetsRtt];
              let numericPacketsRtt = allCurrPacketsRtt.filter(v => typeof v === 'number');
              data = {
                ...data,
                packetsRtt: allCurrPacketsRtt
              };
              if (res.result.status === PROBE_STATUS_FAILED) {
                calcTiming = {
                  value: PROBE_STATUS_FAILED
                };
              } else if (res.result.status === PROBE_STATUS_OFFLINE$2) {
                calcTiming = {
                  value: PROBE_STATUS_OFFLINE$2
                };
              } else if (numericPacketsRtt.length) {
                calcTiming = {
                  value: Math.round(numericPacketsRtt.reduce((sum, rtt) => sum += rtt, 0) / numericPacketsRtt.length),
                  units: ' ms'
                };
              } else if (packetsRtt.length && packetsRtt.every(v => v === _.getProbeTimeOutValue())) {
                calcTiming = {
                  value: _.getProbeTimeOutValue()
                };
              } else {
                calcTiming = {
                  value: tResIdx - 1 >= 0 ? mData[tResIdx - 1][resIdx].timings[0] : null
                };
              }
            } else if (res.result.status !== 'in-progress') {
              calcTiming = _.calcGpTestResTiming(testType, res, dnsOpts.trace);
            }
            if (calcTiming?.extraValues?.errorStatus) {
              calcTiming.value = calcTiming.extraValues.errorStatus;
            }
            let resTiming = !calcTiming ? null : typeof calcTiming.value === 'number' ? `${Math.round(calcTiming.value)}${calcTiming.units}` : calcTiming.value;
            let extraValues = calcTiming?.extraValues;
            let httpStatus = extraValues?.httpStatus?.value;
            let dnsStatus = extraValues?.dnsStatus?.value;
            let errorCode = null;
            if (extraValues?.errorStatus === _.getProbeStatusHttpErrorValue()) {
              errorCode = `HTTP ${httpStatus}`;
            } else if (extraValues?.errorStatus === _.getProbeStatusDnsErrorValue() && dnsStatus !== null && typeof dnsStatus !== 'undefined') {
              errorCode = dnsStatus;
            }
            return {
              ...data,
              timings: [resTiming],
              errorCodes: [errorCode]
            };
          });
          return {
            ...mData,
            [tResIdx]: mappedRes
          };
        }, {});

        // markersData for the first target, regular flow
        let markersData = parsedMeasData[0];

        // in case of infinite flow, get the latest data
        if (infiniteSwitchEnabled) {
          let lastIdx = Object.keys(parsedMeasData).length - 1;
          markersData = parsedMeasData[lastIdx];
        }

        // if there are another targets then we should add its data to markersData respectively
        if (targetsCnt > 1) {
          for (let cnt = 1; cnt < targetsCnt; cnt++) {
            if (!parsedMeasData[cnt]) {
              return;
            }
            markersData = markersData.map(mD => {
              let secReqMD = parsedMeasData[cnt].find(i => i.clientSideId === mD.clientSideId);
              return {
                ...mD,
                timings: [...mD.timings, ...secReqMD.timings],
                errorCodes: [...mD.errorCodes, ...secReqMD.errorCodes],
                targets: [...mD.targets, ...secReqMD.targets]
              };
            });
          }
        }
        this.set('markersData', markersData);
      }, {
        init: false
      });

      // check the statuses of probes in the measurement and stop measurement if all of them are failed
      this.observe('testResults', testResults => {
        for (let i in testResults) {
          if (this.get('testInProgress') && !this.get('shareResFlow') && this.get('isInfiniteModeRes') && testResults[i].every(r => r.result.status === PROBE_STATUS_FAILED)) {
            this.stopCurrentTest();
            return;
          }
        }
      });

      // prepare results for gp-results-raw-output and gp-results-table-output, regular or infinite flow
      this.observe('testResults targetsArr', () => {
        let testResults = this.get('testResults');
        if (!testResults) {
          return;
        }
        let testType = this.get('testReqParams.type');
        let isInfiniteModeRes = this.get('isInfiniteModeRes');
        let sortBy = this.get('sortBy');
        let sortOrder = this.get('sortOrder');
        let rawOutputMode = this.get('rawOutputMode');
        let activeTargetIdx = rawOutputMode ? this.get('activeTargetIdx') : 0;
        let preparedTestResults;
        if (testType === 'ping' && isInfiniteModeRes) {
          preparedTestResults = this.prepareInfiniteResults(testResults);
        } else {
          preparedTestResults = this.prepareRegularResults(testResults);
        }
        preparedTestResults = _.sortGpMeasurementResults(preparedTestResults, sortBy, sortOrder, activeTargetIdx);
        this.set('preparedTestResults', preparedTestResults);
      });

      // set initial screenWidth value
      this.observe('screenWidth', screenWidth => {
        if (!screenWidth) {
          this.set('screenWidth', window.innerWidth);
        }
      });

      // handle tooltips positions depending on the screen size
      this.observe('screenWidth', screenWidth => {
        let ttPositions = {};
        if (screenWidth >= 1272) {
          ttPositions.targetTtPos = 'top';
          ttPositions.locationTtPos = 'top';
          ttPositions.limitTtPos = 'top';
        } else if (screenWidth >= 768) {
          ttPositions.targetTtPos = 'top';
          ttPositions.locationTtPos = 'right';
          ttPositions.limitTtPos = 'top';
        } else {
          ttPositions.targetTtPos = 'right';
          ttPositions.locationTtPos = 'right';
          ttPositions.limitTtPos = 'right';
        }
        this.set('ttPositions', ttPositions);
      });

      // disable Infinite switch if there is more than one target
      this.observe('mainOptions.target', target => {
        if (target.split(',').length > 1) {
          let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');
          if (infiniteSwitchEnabled) {
            this.set('notAppliedOpts.packets', '');
            this.set('infiniteSwitchEnabled', false);
            this.applyOptions();
          }
        }
      });

      // add navigation functionality once the Run Test button with dropdown appeared
      this.observe('testInProgress', testInProgress => {
        let prevProbesMeasId = this.get('prevProbesMeasId');
        if (prevProbesMeasId && !testInProgress) {
          this.handleDropDownRunTestBtnNav();
        }
      });
      this.observe('showMap', newValue => {
        if (!newValue && this.get('originalShowMap')) {
          this.set('transitionMap', false);
        } else {
          // using a deferred observer somehow isn't sufficient here
          setTimeout(() => {
            this.set('transitionMap', true);
          }, 100);
        }
      });
    }
  },
  oncomplete() {
    if (!ractive.isServer) {
      // run the test if user is pressed Enter inside of any of main options inputs
      let targetInput = this.find('#targetInput');
      let limitInput = this.find('#limitInput');
      let handleEnterBtn = event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.resetMapAndRunTest();
        }
      };
      targetInput.addEventListener('keypress', handleEnterBtn);
      limitInput.addEventListener('keypress', handleEnterBtn);
      let measurement = this.get('measurement');
      let location = this.get('location');
      if (location && !measurement) {
        // Wait for location-input's onrender to finish (setting swapInputs)
        setTimeout(() => {
          let input = document.querySelector('.location-input-hp .aa-Input');
          if (input) {
            input.select();
            let y = input.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: y - 225,
              behavior: 'smooth'
            });
          }
        }, 10);
      }
    }
  },
  onunrender() {
    this.focusModeRenderId = (this.focusModeRenderId || 0) + 1;
    this.moveFocusModeBackdrop(false);
    this.set('activeTestRunId', this.get('activeTestRunId') + 1);
    let gmapsIdleListener = this.get('gmapsIdleListener');
    if (gmapsIdleListener) {
      google.maps.event.removeListener(gmapsIdleListener);
      this.set('gmapsIdleListener', null);
    }
    clearTimeout(this.get('runTestBtnDelayTimeout'));
    clearTimeout(this.get('focusModeTransitionTimeout'));
    clearTimeout(this.get('focusModePositionTimeout'));
    clearTimeout(this.measurementLoadingInfoTimeout);
    this.measurementLoadingInfoTimeout = null;
    this.cancelPendingResultScrollFrame();
    this.cancelFocusModeExitScroll();
    this.set('pendingResultId', null);
    this.get('testReqCancelFn')?.forEach(cancel => cancel?.());
    this.set('testReqCancelFn', []);
  },
  shouldShowMeasurementLoadingInfo() {
    return (this.get('focusModeActive') || !this.get('focusModeSupported')) && (this.get('shareResFlow') ? this.get('sharedMeasurementInitialLoading') : this.get('testInProgress'));
  },
  isActiveTestRun(testRunId) {
    return testRunId === null || testRunId === undefined || testRunId === this.get('activeTestRunId');
  },
  handleRunTestBtn() {
    if (this.get('runTestBtnDisabled')) {
      return;
    }
    if (this.get('testInProgress')) {
      this.stopCurrentTest();
      return;
    }
    this.resetMapAndRunTest();
  },
  stopCurrentTest() {
    let nextTestRunId = this.get('activeTestRunId') + 1;
    let gmapsIdleListener = this.get('gmapsIdleListener');
    if (gmapsIdleListener) {
      google.maps.event.removeListener(gmapsIdleListener);
      this.set('gmapsIdleListener', null);
    }
    this.set('activeTestRunId', nextTestRunId);
    this.get('testReqCancelFn')?.forEach(cancel => cancel?.());
    this.set('testReqCancelFn', []);
    this.set('testInProgress', false);
    this.set('isInfiniteMeasStopped', true);
    this.set('runTestBtnText', 'Run Again');
    this.enableRunTestBtn();
  },
  enableRunTestBtn() {
    clearTimeout(this.get('runTestBtnDelayTimeout'));
    this.set('runTestBtnDisabled', false);
    this.set('runTestBtnDelayTimeout', null);
  },
  clearFocusModeTransition() {
    clearTimeout(this.get('focusModeTransitionTimeout'));
    this.set({
      focusModeTransition: null,
      focusModeTransitionTimeout: null
    });
  },
  moveFocusModeBackdrop(moving) {
    let focusModeRoot = this.find('.gp_map-block');
    let backdrop = this.find('.gp_focus-mode-backdrop');
    if (!focusModeRoot || !backdrop) {
      return false;
    }
    if (moving) {
      focusModeRoot.parentNode.insertBefore(backdrop, focusModeRoot);
    } else if (backdrop.parentNode !== focusModeRoot) {
      focusModeRoot.insertBefore(backdrop, focusModeRoot.firstChild);
    }
    return true;
  },
  startFocusModePositionEntry() {
    clearTimeout(this.get('focusModePositionTimeout'));
    this.set('focusModePosition', 'entering');
    if (!this.moveFocusModeBackdrop(true)) {
      this.update().then(() => {
        if (this.get('focusModePosition') === 'entering') {
          this.moveFocusModeBackdrop(true);
        }
      });
    }
    this.scheduleFocusModePositionTimeout('entering');
  },
  prepareFocusModePositionEntry() {
    this.startFocusModePositionEntry();
    this.find('.gp_map-block').getBoundingClientRect();
  },
  freezeFocusModeBackdrop() {
    let backdrop = this.find('.gp_focus-mode-backdrop');
    if (!backdrop) {
      return () => {};
    }
    let style = getComputedStyle(backdrop);
    let opacity = style.opacity;
    let backdropFilter = style.backdropFilter;
    backdrop.style.transition = 'none';
    backdrop.style.opacity = opacity;
    backdrop.style.backdropFilter = backdropFilter;
    return () => {
      if (!backdrop.isConnected) {
        return;
      }
      backdrop.style.transition = '';
      backdrop.getBoundingClientRect();
      backdrop.style.opacity = '';
      backdrop.style.backdropFilter = '';
    };
  },
  scheduleFocusModePositionTimeout(position) {
    requestAnimationFrame(() => {
      if (this.get('focusModePosition') !== position) {
        return;
      }
      this.set('focusModePositionTimeout', setTimeout(() => {
        if (this.get('focusModePosition') === position) {
          this.set('focusModePosition', null);
          this.moveFocusModeBackdrop(false);
        }
        this.set('focusModePositionTimeout', null);
      }, FOCUS_MODE_POSITION_MS + 50));
    });
  },
  handleFocusModePositionTransitionEnd(event) {
    if (event.target !== event.currentTarget || event.propertyName !== 'transform') {
      return;
    }
    this.finishFocusModePositionTransition();
  },
  handleFocusModeBackdropTransitionEnd(event) {
    if (event.target !== event.currentTarget || event.propertyName !== 'opacity') {
      return;
    }
    this.finishFocusModePositionTransition();
  },
  finishFocusModePositionTransition() {
    let position = this.get('focusModePosition');
    if (position !== 'entering' && (position !== 'leaving' || this.get('focusModeActive'))) {
      return;
    }
    let focusModeRoot = this.find('.gp_map-block');
    let style = getComputedStyle(focusModeRoot);
    let matrixMatch = style.transform.match(/^matrix(3d)?\((.+)\)$/);
    let transformValues = matrixMatch?.[2].split(',').map(value => Number.parseFloat(value));
    let currentTransformY = matrixMatch ? transformValues[matrixMatch[1] ? 13 : 5] : 0;
    let expectedTransformY = position === 'entering' ? Number.parseFloat(style.getPropertyValue('--focus-mode-offset-y')) || 0 : 0;
    let backdropOpacity = Number.parseFloat(getComputedStyle(this.find('.gp_focus-mode-backdrop')).opacity);
    let expectedBackdropOpacity = position === 'entering' ? 1 : 0;
    if (Math.abs(currentTransformY - expectedTransformY) < 1 && Math.abs(backdropOpacity - expectedBackdropOpacity) < .01) {
      clearTimeout(this.get('focusModePositionTimeout'));
      this.set({
        focusModePosition: null,
        focusModePositionTimeout: null
      });
      this.moveFocusModeBackdrop(false);
    }
  },
  openFocusMode(event) {
    event?.preventDefault?.();
    if (!this.get('focusModeSupported')) {
      return;
    }
    let isResultsPreviewOpening = !!this.find('.gp_map-block_test-output_results-preview');
    let isReversingClose = ['leaving', 'preparing-close'].includes(this.get('focusModePosition'));
    let releaseBackdrop = this.freezeFocusModeBackdrop();
    this.cancelFocusModeExitScroll();
    this.clearFocusModeTransition();
    this.focusModeClosePending = false;
    if (isReversingClose) {
      this.startFocusModePositionEntry();
    } else {
      this.prepareFocusModePositionEntry();
    }
    this.set('focusModeTransition', 'opening');
    app.router.replaceQueryParam('view', null, this);
    releaseBackdrop();
    if (this.get('pendingResultId') === null) {
      this.scrollFocusModeRootAfterRender(FOCUS_MODE_SCROLL_OFFSET, !isReversingClose);
    }
    this.set('focusModeTransitionTimeout', setTimeout(() => {
      this.set('focusModeTransition', null);
      this.set('focusModeTransitionTimeout', null);
    }, isResultsPreviewOpening ? FOCUS_MODE_RESULTS_EXPAND_MS : FOCUS_MODE_CONTENT_SWAP_MS));
    this.focusFocusModeToggleButton();
  },
  closeFocusMode(event, restoreFocus = true, availabilityLost = false) {
    event?.preventDefault?.();
    if (!this.get('focusModeActive') && !availabilityLost || this.focusModeClosePending) {
      return;
    }
    this.focusModeClosePending = true;
    this.focusModeAvailabilityClosePending = availabilityLost;
    this.cancelPendingResultScrollFrame();
    this.cancelFocusModeExitScroll();
    this.set('pendingResultId', null);
    this.startFocusModeExitScroll();
    this.clearFocusModeTransition();
    let renderId = this.focusModeRenderId;
    let finishClose = () => {
      if (this.focusModeRenderId !== renderId || availabilityLost && this.get('focusModeActive')) {
        this.focusModeClosePending = false;
        this.focusModeAvailabilityClosePending = false;
        return;
      }
      clearTimeout(this.get('focusModePositionTimeout'));
      this.set('focusModePosition', 'leaving');
      if (!availabilityLost) {
        app.router.replaceQueryParam('view', 'home', this);
      }
      this.set('focusModeTransition', 'content-leaving');
      this.focusModeClosePending = false;
      if (!availabilityLost) {
        this.focusModeAvailabilityClosePending = false;
      }
      this.scheduleFocusModePositionTimeout('leaving');
      this.set('focusModeTransitionTimeout', setTimeout(() => {
        this.set('focusModeTransition', 'prompt-entering');
        if (restoreFocus) {
          this.focusFocusModeToggleButton();
        }
        this.set('focusModeTransitionTimeout', setTimeout(() => {
          this.set('focusModeTransition', null);
          this.set('focusModeTransitionTimeout', null);
          if (availabilityLost) {
            this.focusModeAvailabilityClosePending = false;
          }
        }, FOCUS_MODE_PROMPT_ENTER_MS));
      }, FOCUS_MODE_CONTENT_EXIT_MS));
    };
    if (this.get('focusModePosition') === 'entering') {
      finishClose();
      return;
    }
    this.set('focusModePosition', 'preparing-close');
    this.moveFocusModeBackdrop(true);
    this.update().then(() => {
      if (this.focusModeRenderId !== renderId || availabilityLost && this.get('focusModeActive')) {
        this.focusModeClosePending = false;
        this.focusModeAvailabilityClosePending = false;
        return;
      }
      this.find('.gp_map-block')?.getBoundingClientRect();
      requestAnimationFrame(finishClose);
    });
  },
  closeFocusModeFromBackdrop(event) {
    if (document.body.classList.contains('modal-open')) {
      return;
    }
    this.closeFocusMode(event, false);
  },
  handleFocusModeDocumentClick(event) {
    if (!this.get('focusModeActive') || document.body.classList.contains('modal-open')) {
      return;
    }
    if (event.target.classList?.contains('gp_focus-mode-backdrop')) {
      return;
    }
    let focusModeRoot = this.find('.gp_map-block');
    let focusModeRootRect = focusModeRoot?.getBoundingClientRect();
    let clickedFocusModeSurface = event.composedPath().includes(focusModeRoot) || focusModeRootRect && event.clientX >= focusModeRootRect.left && event.clientX <= focusModeRootRect.right && event.clientY >= focusModeRootRect.top && event.clientY <= focusModeRootRect.bottom;
    if (!clickedFocusModeSurface) {
      this.closeFocusModeFromBackdrop(event);
    }
  },
  handleFocusModeKeyDown(event) {
    if (!this.get('focusModeActive')) {
      return;
    }
    if (event.key === 'Escape') {
      this.closeFocusMode(event);
      return;
    }
    if (event.key !== 'Tab') {
      return;
    }

    // force focus to stay within the map block
    let focusModeRoot = this.find('.gp_map-block');
    let focusableElements = Array.from(focusModeRoot.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')).filter(element => !element.disabled && element.getAttribute('tabindex') !== '-1' && element.getClientRects().length);
    if (!focusableElements.length) {
      event.preventDefault();
      this.focusWithoutScroll(focusModeRoot);
      return;
    }
    let firstElement = focusableElements[0];
    let lastElement = focusableElements[focusableElements.length - 1];
    let activeElement = document.activeElement;
    let shouldWrapBackward = event.shiftKey && (activeElement === firstElement || !focusModeRoot.contains(activeElement));
    let shouldWrapForward = !event.shiftKey && (activeElement === lastElement || !focusModeRoot.contains(activeElement));
    if (shouldWrapBackward || shouldWrapForward) {
      event.preventDefault();
      this.focusWithoutScroll(shouldWrapBackward ? lastElement : firstElement);
    }
  },
  focusFocusModeToggleButton() {
    let renderId = this.focusModeRenderId;
    this.update().then(() => {
      if (this.focusModeRenderId !== renderId) {
        return;
      }
      let focusToggleSelector = this.get('focusModeActive') ? '.gp_map-block_focus-bar_return' : '.gp_focus-mode-toggle';
      this.focusWithoutScroll(this.find(focusToggleSelector));
    });
  },
  focusWithoutScroll(element) {
    try {
      element?.focus({
        preventScroll: true
      });
    } catch {
      element?.focus();
    }
  },
  disableRunTestBtnForDelay() {
    clearTimeout(this.get('runTestBtnDelayTimeout'));
    this.set('runTestBtnDisabled', true);
    this.set('runTestBtnDelayTimeout', setTimeout(() => {
      this.set('runTestBtnDisabled', false);
      this.set('runTestBtnDelayTimeout', null);
    }, 500));
  },
  proceedToTest(prevProbesMeasId) {
    let {
      type,
      target,
      location,
      limit,
      ipVersion
    } = this.get('mainOptions');
    let appliedMeasOpts = this.get('appliedMeasOpts');
    let measurementOpts = _.deepExtend({}, appliedMeasOpts.initPresetOpts, appliedMeasOpts.notPresetOpts);
    let targetsArr = target.split(',').map(target => target.trim());
    let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');
    let testRunId = this.get('activeTestRunId') + 1;

    // create parameters for the measurement request
    let reqParams = {
      type,
      // to get test results in real time
      inProgressUpdates: !!infiniteSwitchEnabled
    };

    // ipVersion should only be passed if all targets are a domain name and the test type is not 'DNS'
    if (ipVersion && type.toLowerCase() !== 'dns') {
      measurementOpts = {
        ...measurementOpts,
        ipVersion
      };
    }
    reqParams.limit = limit || DEFAULT_LIMIT$2;
    if (location) {
      reqParams.locations = location.split(',').map(loc => ({
        magic: loc
      }));
    } else {
      this.set('mainOptions.location', INITIAL_MAIN_OPTS_VALUES.location);
      reqParams.locations = [{
        magic: INITIAL_MAIN_OPTS_VALUES.location
      }];
    }

    // since packets field default value is present only for Ping and MTR type
    if (type.toLowerCase() === 'ping' || type.toLowerCase() === 'mtr') {
      reqParams.measurementOptions = {
        // default values used if user does not set them manually
        packets: DEFAULT_PACKETS_AMOUNT
      };
    } else {
      delete measurementOpts.packets;
      if (type.toLowerCase() === 'http') {
        reqParams.measurementOptions = {
          request: {
            method: measurementOpts?.request?.method || CLIENT_DEFAULT_HTTP_OPTS.request.method
          }
        };
      }
    }
    if (Object.keys(measurementOpts).length) {
      reqParams.measurementOptions = {
        ...(reqParams.measurementOptions || {}),
        ...measurementOpts
      };
    }

    // clear all data from the previous test, close additional options menu, show spinner, set up Map's data etc.
    let releaseFocusModeBackdrop;
    if (this.get('focusModeSupported') && !this.get('focusModeActive')) {
      this.prepareFocusModePositionEntry();
      releaseFocusModeBackdrop = this.freezeFocusModeBackdrop();
    }
    this.set('testResults', null);
    this.set('markersData', null);
    this.set('probesResponse', null);
    this.set('showMeasurementOpts', false);
    this.set('testInProgress', true);
    releaseFocusModeBackdrop?.();
    this.set('measurementErrMsg', null);
    this.set('testReqParams', null);
    this.set('measurementDate', null);
    this.set('mobileShareResHeaderData', null);
    this.set('realTimeTestResResponse', null);
    this.set('activeTargetIdx', 0);
    this.set('measurementsMetadata', null);
    this.set('showCreditsErrorBar', false);
    this.set('targetsArr', targetsArr);
    this.set('infiniteMeasIds', []);
    this.set('isInfiniteMeasStopped', false);
    this.set('showCreditsData', true);
    this.set('prevProbesMeasId', null);
    this.set('preparedTestResults', []);
    this.set('loadingProbeResults', []);
    this.set('rateCreditsData', null);
    this.set('probesMaxTiming', type.toLowerCase() === 'http' ? 1000 : 200);
    this.set('_measurementOgTitle', null);
    this.set('_measurementOgDescription', null);
    this.set('showingNetworkLogos', false);
    this.set('activeTestRunId', testRunId);
    this.clearFocusModeTransition();
    app.router.replaceQueryParam('view', null, this);
    if (this.get('focusModeSupported')) {
      this.scrollFocusModeRootAfterRender();
    }
    this.expandAllRawOutput();

    // if it is infinite/multi-endpoint measurement then we should show TableOutput by default
    // otherwise leave prev value set by user
    if (type === 'ping' && (infiniteSwitchEnabled || targetsArr.length >= 2)) {
      this.set('rawOutputMode', false);
    }

    // is designed to prevent the way the test results are displayed from changing when the user toggles the infinite switch
    this.set('isInfiniteModeRes', infiniteSwitchEnabled);

    // re-use probes case
    if (prevProbesMeasId) {
      reqParams = {
        ...reqParams,
        locations: prevProbesMeasId
      };
    }

    // run Infinite type of the measurement
    if (type === 'ping' && targetsArr.length === 1 && infiniteSwitchEnabled) {
      this.postInfiniteGlobalpingMeasurement({
        reqParams,
        target: targetsArr[0],
        testRunId
      });
      return;
    }

    // common type of the measurement
    http.postGlobalpingMeasurement({
      ...reqParams,
      target: targetsArr[0]
    }, RATE_LIMIT_HEADERS$2).then(res => {
      if (!this.isActiveTestRun(testRunId)) {
        return;
      }

      // set measurement ID for re-use probes case
      this.set('prevProbesMeasId', res.response.id);
      this.set('loadingProbeResults', Array.from({
        length: res.response.probesCount || 0
      }, (_, clientSideId) => ({
        clientSideId
      })));

      // Update the URL.
      this.set('measurement', res.response.id);

      // set response headers for gp-credits/gp-credits-message
      this.set('rateCreditsData', {
        ...res.responseHeaders
      });
      if (targetsArr[1]) {
        let secReqParams;

        // prepare params depending whether there is prevProbesMeasId or not
        if (prevProbesMeasId) {
          secReqParams = {
            locations: res.response.id,
            ...reqParams,
            target: targetsArr[1]
          };
        } else {
          secReqParams = {
            ...reqParams,
            locations: res.response.id,
            target: targetsArr[1]
          };
        }
        http.postGlobalpingMeasurement(secReqParams, RATE_LIMIT_HEADERS$2).then(res1 => {
          if (!this.isActiveTestRun(testRunId)) {
            return;
          }
          let combinedHeaders = {
            ...res1.responseHeaders
          };
          ['x-ratelimit-consumed', 'x-credits-consumed', 'x-request-cost'].forEach(header => {
            combinedHeaders[header] = (Number(res.responseHeaders[header]) || 0) + (Number(res1.responseHeaders[header]) || 0);
          });

          // set response headers for gp-credits/gp-credits-message
          this.set('rateCreditsData', combinedHeaders);
          this.getTestMeasurementById({
            measurementId: res.response.id,
            testRunId
          });
          this.getTestMeasurementById({
            measurementId: res1.response.id,
            resNumber: 1,
            testRunId
          });
          this.set('showMap', this.get('originalShowMap'));

          // Update the URL without creating a new history entry.
          app.router.replaceQueryParam('measurement', `${this.get('measurement')},${res1.response.id}`);
        }).catch(err => {
          if (!this.isActiveTestRun(testRunId)) {
            return;
          }
          this.set('showMap', this.get('originalShowMap'));
          this.getTestMeasurementById({
            measurementId: res.response.id,
            testRunId
          }).then(() => {
            if (!this.isActiveTestRun(testRunId)) {
              return;
            }
            this.handlePostGPMeasError(err, true);
            this.set('targetsArr', [targetsArr[0]]);
          });
        });
      } else {
        this.getTestMeasurementById({
          measurementId: res.response.id,
          testRunId
        });
        this.set('showMap', this.get('originalShowMap'));
      }
    }).catch(err => {
      if (!this.isActiveTestRun(testRunId)) {
        return;
      }
      this.handlePostGPMeasError(err);
    });
  },
  applyOptions() {
    // Clear the port input when the selected protocol does not support it
    if (this.get('disablePort')) {
      this.set('notAppliedOpts.port', '');
    }

    // filter opts from empty values
    let filterOptsFromEmptyOne = opts => Object.keys(opts).reduce((res, key) => {
      if (typeof opts[key] === 'object') {
        res[key] = Object.keys(opts[key]).reduce((secRes, secKey) => {
          if (opts[key][secKey] !== '') {
            secRes[secKey] = opts[key][secKey];
          }
          return secRes;
        }, {});
      } else if (opts[key] !== '') {
        res[key] = opts[key];
      }
      return res;
    }, {});
    let {
      type
    } = this.get('mainOptions');
    let currOptsName = `${type.toLowerCase()}Opts`;
    let initPresetOpts = filterOptsFromEmptyOne(this.get(currOptsName));
    let notPresetOpts = filterOptsFromEmptyOne(this.get('notAppliedOpts'));
    let opts = {
      initPresetOpts,
      notPresetOpts
    };
    this.set('appliedMeasOpts', opts);
    this.countModifiedMeasurementOpts(type, initPresetOpts, notPresetOpts);
    this.set('showMeasurementOpts', false);
  },
  initMap() {
    let mq = window.matchMedia('(min-width: 768px)');
    map$1 = new google.maps.Map(this.find('#gp-map'), {
      zoom: MAP_ZOOM_REG$1,
      center: MAP_CENTER_REG$1,
      mapTypeId: 'roadmap',
      draggableCursor: 'default',
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      minZoom: MAP_MIN_ZOOM$1,
      maxZoom: MAP_MAX_ZOOM$1,
      mapId: 'ce04bbf9d49b6f34'
    });
    if (mq.matches) {
      map$1.setCenter(MAP_CENTER_ALT$1);
      map$1.setZoom(MAP_ZOOM_ALT$1);
    }
    this.set('clusterRadius', this.getClusterRadius());

    // handle map changes on zoom
    map$1.addListener('zoom_changed', () => {
      // close all IWs on zoom
      infoWindows$1.forEach(iw => iw.close());
      probesInfoWindows.forEach(piw => piw.close());
      this.despiderifyMapMarkers(mapMarkers$1);

      // scale cluster's markers size on zoom
      probesMarkers.forEach(m => {
        let {
          svgWidth,
          svgHeight
        } = getMarkerSize$1(Number(m.content.getAttribute('data-probe-count')), map$1.zoom);
        m.content.style.width = `${svgWidth}px`;
        m.content.style.height = `${svgHeight}px`;
      });
      let nextClusterRadius = this.getClusterRadius();
      if (this.get('probesResponse') && !this.get('shareResFlow')) {
        this.set('nextClusterRadius', nextClusterRadius === this.get('clusterRadius') ? null : nextClusterRadius);
      }
    });
    map$1.addListener('idle', () => {
      this.refreshProbeClusters();
    });

    // draw probes Clusters or clear the map from them
    this.observe('probesResponse', probesResponse => {
      // when we run a new test probesResponse will be cleared ergo we should clear the map from the probesClusters
      if (probesResponse === null) {
        this.clearProbesClusters();
        // display probesCLusters on the map only when we have probesData and not in share-results-flow
      } else if (probesResponse && !this.get('shareResFlow')) {
        this.updateClusters(probesResponse);
      }
    });

    // check whether we should clear the Map from the markers or update them
    this.observe('markersData', (markersData, prevMarkersData) => {
      if (markersData === null) {
        this.clearTestResponseMarkers();
      } else if (JSON.stringify(markersData) !== JSON.stringify(prevMarkersData)) {
        // clear stale markers (happens on client-side navigation)
        if (!prevMarkersData && (infoWindows$1.length || mapMarkers$1.length)) {
          this.clearTestResponseMarkers();
        }

        // update Markers on the map (replace or add new) if Markers data is different
        this.updateMarkers(markersData, prevMarkersData);
      }
    });
    this.enableRunTestBtn();
    this.set('gmapsReady', true);
  },
  updateMarkers(markersData, prevMarkersData) {
    markersData.forEach(markerData => {
      let markerIdToReplace = null;
      let currentMarkerIdx = markerData.clientSideId;

      // check if the new Marker is the old one but with a timing value
      // and get Marker index to replace it later on the Map
      // get index for every Marker we draw or redraw on the map to provide proper work of InfoWindows, Results and Actions etc.
      if (prevMarkersData) {
        // stop once we found the match to get proper currentMarkerIdx
        prevMarkersData.every(pmd => {
          if (pmd.clientSideId === markerData.clientSideId && markerData.timings !== null && markerData.timings.every(t => t)) {
            markerIdToReplace = pmd.clientSideId;
            currentMarkerIdx = pmd.clientSideId;
            return false;
          }
          return true;
        });
      }

      // create a new marker and add it to the map or update existing with new data
      if (markerIdToReplace !== null) {
        mapMarkers$1.forEach((mm, mmIdx) => {
          if (markerIdToReplace === mmIdx && JSON.stringify(markerData.timings) !== JSON.stringify(prevMarkersData[markerIdToReplace].timings)) {
            this.updateMapMarkerWithIW(mm, markerData, currentMarkerIdx);
          }
        });
      } else if (!mapMarkers$1[markerData.clientSideId]) {
        // collect markers added to the map
        this.createMapMarkerWithIW(markerData, currentMarkerIdx);
      }
    });

    // close IWs on click on Map
    google.maps.event.addListener(map$1, 'click', () => {
      infoWindows$1.forEach(iw => iw.close());
      this.despiderifyMapMarkers(mapMarkers$1);
    });
  },
  updateClusters(probes) {
    let clusterRadius = this.getClusterRadius();
    this.set({
      clusterRadius,
      nextClusterRadius: null
    });
    let preparedMarkers = Object.keys(probes).map(key => {
      let [lat, lng] = key.split(', ');
      let marker = probesMarkers.find(pm => pm.position.lat === lat && pm.position.lng === lng);
      if (!marker) {
        marker = this.createMapClusterMarkerWithIW(key, probes[key]);
        probesMarkers.push(marker);
      }
      return marker;
    });

    // eslint-disable-next-line no-undef
    let probeCluster = new markerClusterer.MarkerClusterer({
      markers: preparedMarkers,
      map: map$1,
      renderer: {
        render({
          markers,
          position
        }) {
          let totalCustomNumber = markers.reduce((sum, marker) => sum + (marker.markersCount || 0), 0);
          let clusterSvg = window.btoa(`<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 68 68" fill="none">
							<g clip-path="url(#a)">
							<path fill="url(#b)" d="M30 2.31a8 8 0 0 1 8 0l21.445 12.38a8 8 0 0 1 4 6.929V46.38a8 8 0 0 1-4 6.928L38 65.691a8 8 0 0 1-8 0L8.555 53.309a8 8 0 0 1-4-6.928V21.62a8 8 0 0 1 4-6.928z"/>
							<path stroke="#69E7C8" stroke-width="1.5" d="M30.375 4.959a7.25 7.25 0 0 1 7.25 0L57.338 16.34a7.25 7.25 0 0 1 3.625 6.279V45.38a7.25 7.25 0 0 1-3.625 6.279L37.625 63.04a7.25 7.25 0 0 1-7.25 0L10.662 51.66a7.25 7.25 0 0 1-3.625-6.279V22.62a7.25 7.25 0 0 1 3.625-6.279L30.375 4.96Z"/>
							</g>
							<text x="34" y="40" fill="#fff" font-family="Lexend, sans-serif" font-size="16px" font-weight="600" text-anchor="middle">
							${totalCustomNumber}
							</text>
							<defs>
							<linearGradient id="b" x1="34" x2="34" y1="0" y2="68" gradientUnits="userSpaceOnUse">
							<stop stop-color="#17D4A7"/>
							<stop offset="1" stop-color="#17D4A7"/>
							</linearGradient>
							<clipPath id="a">
							<path fill="#fff" d="M0 0h68v68H0z"/>
							</clipPath>
							</defs>
						</svg>`);
          let clusterDiv = document.createElement('div');
          let clusterImg = document.createElement('img');
          clusterDiv.style.position = 'relative';
          clusterDiv.style.width = '54px';
          clusterDiv.style.height = '54px';
          clusterDiv.style.background = 'transparent';
          clusterImg.src = `data:image/svg+xml;base64,${clusterSvg}`;
          clusterImg.width = '54';
          clusterImg.height = '54';
          clusterDiv.appendChild(clusterImg);
          return new google.maps.marker.AdvancedMarkerElement({
            position,
            content: clusterDiv
          });
        }
      },
      // eslint-disable-next-line no-undef
      algorithm: new markerClusterer.SuperClusterAlgorithm({
        radius: clusterRadius
      })
    });
    mapProbesClusters.push(probeCluster);
    google.maps.event.addListener(map$1, 'click', () => {
      probesInfoWindows.forEach(piw => piw.close());
    });
  },
  refreshProbeClusters() {
    let probesResponse = this.get('probesResponse');
    let nextClusterRadius = this.get('nextClusterRadius');
    if (!probesResponse || this.get('shareResFlow') || !nextClusterRadius || nextClusterRadius === this.get('clusterRadius')) {
      return;
    }
    this.set('clusterRadius', nextClusterRadius);
    this.clearProbesClusters();
    this.updateClusters(probesResponse);
  },
  getClusterRadius() {
    if (map$1.zoom <= MAP_ZOOM_REG$1) {
      return 120;
    }
    return 200;
  },
  clearTestResponseMarkers() {
    infoWindows$1.forEach(iw => iw.close());
    mapMarkers$1.forEach(mm => mm.setMap(null));
    infoWindows$1 = [];
    mapMarkers$1 = [];
  },
  clearProbesClusters() {
    probesInfoWindows.forEach(piw => piw.close());
    mapProbesClusters.forEach(pc => pc.setMap(null));
    probesMarkers.forEach(pm => pm.map = null);
    probesMarkers = [];
    probesInfoWindows = [];
    mapProbesClusters = [];
  },
  collapseCmdBlock() {
    let element = document.querySelector('.gp_join-network_cmd-block_command');
    requestAnimationFrame(() => {
      element.style.height = `${element.scrollHeight}px`;
      requestAnimationFrame(() => {
        element.style.height = '56px';
      });
    });
  },
  expandCmdBlock() {
    let element = document.querySelector('.gp_join-network_cmd-block_command');
    requestAnimationFrame(() => {
      element.style.height = '56px';
      requestAnimationFrame(() => {
        element.style.height = `${element.scrollHeight}px`;
      });
    });
  },
  handleSeeResults(clientSideId) {
    this.set('pendingResultId', clientSideId);
    if (this.get('focusModeSupported') && !this.get('focusModeActive')) {
      this.openFocusMode();
    }
  },
  scrollToPendingResult() {
    let clientSideId = this.get('pendingResultId');
    let focusModeSupported = this.get('focusModeSupported');
    if (clientSideId === null || focusModeSupported && !this.get('focusModeActive') || !this.get('rawOutputMode') && !this.get('tableOutputReady')) {
      return;
    }
    this.cancelPendingResultScrollFrame();
    let isCurrentNavigation = () => (!this.get('focusModeSupported') || this.get('focusModeActive')) && this.get('pendingResultId') === clientSideId;
    this.update().then(() => {
      if (!isCurrentNavigation()) {
        return false;
      }
      if (this.get('rawOutputMode')) {
        // Set this after raw output mounts so it can expand the selected item.
        this.set('scrolledToResId', clientSideId);
      }
      return this.update().then(() => true);
    }).then(shouldContinue => {
      if (!shouldContinue || !isCurrentNavigation()) {
        return;
      }
      let retryUntil = performance.now() + PENDING_RESULT_SCROLL_TIMEOUT_MS;
      let findAndScrollToResult = () => {
        let frame = requestAnimationFrame(() => {
          if (this.pendingResultScrollFrame !== frame) {
            return;
          }
          this.pendingResultScrollFrame = null;
          if (!isCurrentNavigation()) {
            return;
          }
          let el;
          if (this.get('rawOutputMode')) {
            el = this.find(`.c-gp-results-raw-output_list_item.item-id-${clientSideId}`);
          } else {
            el = this.find(`.c-gp-results-table-output .results-table_row.row-num-${clientSideId}`);
          }
          let mapWrapper = this.find('.gp_map-block_map-wrapper');
          let mapIsCollapsing = this.get('focusModeActive') && !this.get('showMap') && mapWrapper.getBoundingClientRect().height > 0;
          if (el && !mapIsCollapsing) {
            let focusModeRoot = this.find('.gp_map-block');
            let scrollOffset = this.get('focusModeSupported') ? FOCUS_MODE_SCROLL_OFFSET : 0;
            let shouldMeasureRawOutput = this.get('rawOutputMode');
            if (shouldMeasureRawOutput) {
              focusModeRoot.classList.add('gp_map-block_measure-content');
              focusModeRoot.getBoundingClientRect();
            }
            let getScrollTop = () => {
              let resultOffset = el.getBoundingClientRect().top - focusModeRoot.getBoundingClientRect().top;
              return this.getFocusModeRootScrollTop(focusModeRoot, scrollOffset) + resultOffset;
            };
            let cancelSmoothScroll;
            let cancelPendingResultScroll = () => cancelSmoothScroll();
            cancelSmoothScroll = this.smoothScrollToLatestPosition(getScrollTop, () => this.finishRawOutputMeasurement(focusModeRoot), () => {
              if (this.pendingResultScrollCancel === cancelPendingResultScroll) {
                this.pendingResultScrollCancel = null;
              }
              if (isCurrentNavigation()) {
                this.set('pendingResultId', null);
              }
            });
            this.pendingResultScrollCancel = cancelPendingResultScroll;
            return;
          }
          if (performance.now() < retryUntil) {
            findAndScrollToResult();
          } else {
            this.set('pendingResultId', null);
          }
        });
        this.pendingResultScrollFrame = frame;
      };
      findAndScrollToResult();
    });
  },
  cancelPendingResultScrollFrame() {
    if (this.pendingResultScrollFrame !== null) {
      cancelAnimationFrame(this.pendingResultScrollFrame);
      this.pendingResultScrollFrame = null;
    }
    this.pendingResultScrollCancel?.();
    this.pendingResultScrollCancel = null;
  },
  finishRawOutputMeasurement(focusModeRoot) {
    if (!focusModeRoot.classList.contains('gp_map-block_measure-content')) {
      return;
    }
    focusModeRoot.querySelectorAll('.c-gp-results-raw-output_list_item').forEach(item => {
      let itemStyle = getComputedStyle(item);
      let verticalInsets = [itemStyle.paddingTop, itemStyle.paddingBottom, itemStyle.borderTopWidth, itemStyle.borderBottomWidth].reduce((total, value) => total + (Number.parseFloat(value) || 0), 0);
      let height = Number.parseFloat(itemStyle.height);
      if (itemStyle.boxSizing === 'border-box') {
        height -= verticalInsets;
      }
      if (!Number.isFinite(height)) {
        height = item.getBoundingClientRect().height - verticalInsets;
      }
      if (Number.isFinite(height) && height > 0) {
        item.style.containIntrinsicSize = `auto ${height}px`;
      }
    });
    focusModeRoot.classList.remove('gp_map-block_measure-content');
  },
  smoothScrollToLatestPosition(getTargetScrollTop, beforeComplete, onComplete) {
    let settleTimeout;
    let maxDurationTimeout;
    let finished = false;
    let clearListeners = () => {
      clearTimeout(settleTimeout);
      clearTimeout(maxDurationTimeout);
      window.removeEventListener('scroll', scheduleCompletion);
    };
    let finish = () => {
      if (finished) {
        return;
      }
      finished = true;
      clearListeners();
      beforeComplete?.();
      onComplete?.();
    };
    let scheduleCompletion = () => {
      clearTimeout(settleTimeout);
      settleTimeout = setTimeout(finish, SMOOTH_SCROLL_SETTLE_DELAY_MS);
    };
    window.addEventListener('scroll', scheduleCompletion, {
      passive: true
    });
    window.scrollTo({
      top: getTargetScrollTop(),
      behavior: 'smooth'
    });
    scheduleCompletion();
    maxDurationTimeout = setTimeout(finish, SMOOTH_SCROLL_MAX_DURATION_MS);
    return () => {
      if (finished) {
        return;
      }
      window.scrollTo({
        top: window.scrollY,
        behavior: 'auto'
      });
      finish();
    };
  },
  initResponseBodyCharWidth() {
    let measureNode = document.createElement('span');
    measureNode.style.position = 'absolute';
    measureNode.style.visibility = 'hidden';
    measureNode.style.whiteSpace = 'pre';
    measureNode.style.pointerEvents = 'none';
    measureNode.style.fontFamily = '"Source Code Pro", monospace';
    measureNode.style.fontSize = '13px';
    measureNode.style.lineHeight = '21px';
    measureNode.textContent = 'M';
    document.body.appendChild(measureNode);
    let width = measureNode.getBoundingClientRect().width;
    measureNode.remove();
    this.set('responseBodyCharWidth', width > 0 ? width : 7);
  },
  getRawOutputCharsPerLine() {
    let listEl;
    let outputHorizontalPadding = 32 * 2;
    let outputListMargin = 24 * 2;
    let windowWidth = window.innerWidth;
    let FALLBACK_CHAR_WIDTH = 7;
    let listWidth = this.get('rawOutputExpandedListWidth');
    if (!listWidth) {
      try {
        listEl = this.find('.c-gp-results-raw-output_list');
      } catch {
        let contentWidth = Math.min(1240, windowWidth - outputListMargin - outputHorizontalPadding);
        return Math.floor(contentWidth / FALLBACK_CHAR_WIDTH);
      }
      listWidth = listEl?.getBoundingClientRect?.().width || 0;
    }
    let contentWidth = Math.max(1, listWidth - outputHorizontalPadding);
    if (!listWidth) {
      contentWidth = Math.min(1240, windowWidth - outputListMargin - outputHorizontalPadding);
    }
    let charWidth = this.get('responseBodyCharWidth') || FALLBACK_CHAR_WIDTH;
    return Math.max(1, Math.floor(contentWidth / charWidth));
  },
  collapseAllRawOutput({
    responseBodyOnly = false
  } = {}) {
    let ids = this.get('preparedTestResults').map(result => result.clientSideId);
    this.set('hiddenResponseBodies', {
      0: [...ids],
      1: [...ids]
    });
    if (!responseBodyOnly) {
      this.set(`hiddenTestResults`, {
        0: [...ids],
        1: [...ids]
      });
    }
  },
  expandAllRawOutput({
    withResponseBody = false,
    responseBodyOnly = false
  } = {}) {
    if (withResponseBody || responseBodyOnly) {
      this.set(`hiddenResponseBodies`, {
        0: [],
        1: []
      });
    } else {
      this.collapseAllRawOutput({
        responseBodyOnly: true
      });
    }
    if (!responseBodyOnly) {
      this.set('hiddenTestResults', {
        0: [],
        1: []
      });
    }
  },
  getTestMeasurementById({
    measurementId,
    resNumber = '0',
    isShareResCase = false,
    isFirstShareReq = false,
    isLastShareReq = false,
    isInfiniteMeas = false,
    reqParams = {},
    testRunId = null
  }) {
    return new Promise((resolve, reject) => {
      let cancelled = false;
      let timeout = null;
      let cancel = () => {
        cancelled = true;
        clearTimeout(timeout);
        timeout = null;
      };
      let fetch = () => {
        if (cancelled || !this.isActiveTestRun(testRunId)) {
          resolve();
          return;
        }
        http.getGlobalpingMeasurement(measurementId).then(testRes => {
          if (cancelled || !this.isActiveTestRun(testRunId)) {
            cancel();
            resolve();
            return;
          }
          if (Number(resNumber) === 0) {
            this.set('measurementDate', _.formatDateTime(new Date(testRes.createdAt)));
          }
          if (isShareResCase) {
            let currentTargets = this.get('mainOptions.target');
            let currTargetsArr = _.removeDuplicatedTargets(currentTargets ? currentTargets.split(',') : []);
            let updTargetsArr = currTargetsArr.indexOf(testRes.target) < 0 ? [...currTargetsArr, testRes.target] : currTargetsArr;
            this.set('mainOptions.target', updTargetsArr.join(','));

            // if infinite measurement we need to set targetsArr ASAP since we know there is only one target
            if (isInfiniteMeas) {
              this.set('targetsArr', updTargetsArr);
            }

            // only the first target's response returns locations
            if (isFirstShareReq) {
              let magicValue = testRes.locations?.reduce((res, loc) => {
                if (loc.magic) {
                  res += res.length ? `, ${loc.magic}` : loc.magic;
                  return res;
                }
                return res;
              }, '');
              this.set('mainOptions.location', magicValue);
            }
            if (isLastShareReq) {
              this.set('targetsArr', updTargetsArr);
              this.set('mainOptions.type', this.translateTestTypeName(testRes.type));
              this.set('mainOptions.limit', testRes.limit || DEFAULT_LIMIT$2);
              this.set('mobileShareResHeaderData', {
                date: _.formatDateTime(new Date(testRes.createdAt)),
                target: updTargetsArr.join(', '),
                type: this.translateTestTypeName(testRes.type)
              });

              // handle map max timing for HTTP measurement
              if (testRes.type.toLowerCase() === 'http') {
                this.set('probesMaxTiming', 1000);
              }

              // ipVersion (target ip-type-switch) came with the measurementOptions but should be treated as the mainOptions
              if (testRes.measurementOptions?.ipVersion) {
                // if there is one target and it has IPv6 format (not a domain name) we shouldn't set ipVersion
                if (updTargetsArr.length !== 1 || !ipRegex_1.v6({
                  exact: true,
                  allowBrackets: true
                }).test(updTargetsArr[0])) {
                  this.set('mainOptions.ipVersion', testRes.measurementOptions.ipVersion);
                }
                delete testRes.measurementOptions.ipVersion;
              }
              let defaultAPIOpts = this.getDefaultAPIMeasOptsByTestName(testRes.type);
              let combinedOptions = _.deepExtend({}, defaultAPIOpts, testRes.measurementOptions);
              let receivedInitPresetOpts = this.filterForInitPresetOpts(defaultAPIOpts, combinedOptions);
              let receivedNotPresetOpts = this.filterForNotPresetOpts(defaultAPIOpts, combinedOptions);
              this.set('notAppliedOpts', receivedNotPresetOpts);
              this.set(`${testRes.type.toLowerCase()}Opts`, receivedInitPresetOpts);
              this.applyOptions();
              if (!isInfiniteMeas) {
                this.set('runTestBtnText', 'Run Again');
              }

              // clear qsMeasurementIdsArr so the mainOptions.type observer could work now
              this.set('qsMeasurementIdsArr', []);
            }
          }
          let isInfiniteMeasStopped = this.get('isInfiniteMeasStopped');

          // check if infinite measurement was stopped
          if (isInfiniteMeas && isInfiniteMeasStopped) {
            cancel();
            resolve();
          }

          // prepare and set request params to pass them to gp-test-results
          let testReqParams = JSON.parse(JSON.stringify(testRes));
          delete testReqParams.results;
          delete testReqParams.status;
          delete testReqParams.updatedAt;
          delete testReqParams.createdAt;
          testReqParams = {
            inProgressUpdates: isInfiniteMeas,
            limit: DEFAULT_LIMIT$2,
            ...testReqParams,
            measurementOptions: {
              trace: false,
              ...testReqParams.measurementOptions
            }
          };

          // set testReqParams to pass them to c-gp-results-raw-output
          this.set('testReqParams', testReqParams);

          // collect IDs of each target's measurement response
          let updMeasMetadata = {
            ...this.get('measurementsMetadata'),
            [resNumber]: {
              target: testReqParams.target,
              measurementId: testReqParams.id
            }
          };
          this.set('measurementsMetadata', updMeasMetadata);

          // set the local/client time of the response received
          let currentTimestamp = Date.now();
          let testResUpd = {
            ...testRes,
            clientSideStartedAt: currentTimestamp,
            clientSideUpdatedAt: currentTimestamp
          };

          // should be after the mainOptions.type was set
          this.set(`realTimeTestResResponse[${resNumber}]`, testResUpd);

          // handle infinite test flow, once at least one probe is finished we should run measurement again
          if (this.get('shareResFlow') === false && isInfiniteMeas && testRes.results.some(r => r.result.status === 'finished')) {
            let infiniteMeasIds = this.get('infiniteMeasIds');
            if (!infiniteMeasIds.includes(testRes.id)) {
              this.set('infiniteMeasIds', [...infiniteMeasIds, testRes.id]);
              if (!isInfiniteMeasStopped) {
                this.postInfiniteGlobalpingMeasurement({
                  reqParams,
                  target: testRes.target,
                  isInfiniteMeas: true,
                  resNumber: infiniteMeasIds.length + 1,
                  testRunId
                });
              }
            }
          }
          resolve(testRes);
          if (!cancelled) {
            timeout = setTimeout(fetch, 500);
          }
        }).catch(e => {
          if (cancelled || !this.isActiveTestRun(testRunId)) {
            cancel();
            resolve();
            return;
          }
          cancel();
          if (isShareResCase) {
            this.handleSharedMeasurementLoadError(e);
          } else if (e.responseStatusCode === 404) {
            this.set('runTestBtnText', 'Run Test');
            this.scrollMapIntoView();
          }
          reject(e);
        });
      };
      this.set(`testReqCancelFn[${resNumber}]`, cancel);
      fetch();
    });
  },
  handleProbesResponse(response) {
    this.set('rawProbes', response);
    let {
      totalCities,
      totalCountries
    } = response.reduce((res, item) => {
      if (!res.citiesList.includes(item.location.city)) {
        res.citiesList.push(item.location.city);
      }
      if (!res.countriesList.includes(item.location.country)) {
        res.countriesList.push(item.location.country);
      }
      res.totalCities = res.citiesList.length;
      res.totalCountries = res.countriesList.length;
      return res;
    }, {
      citiesList: [],
      countriesList: [],
      totalCities: 0,
      totalCountries: 0
    });
    this.animate('totalProbes', response.length, {
      duration: 1500
    });
    this.animate('totalCities', totalCities, {
      duration: 1500
    });
    this.animate('totalCountries', totalCountries, {
      duration: 1500
    });
    if (this.get('activeTestRunId') === 0) {
      this.set('probesResponse', this.groupProbes(response));
    }
  },
  translateTestTypeName(name) {
    switch (name.toLowerCase()) {
      case 'ping':
      case 'traceroute':
        return name.toLowerCase();
      case 'dns':
      case 'mtr':
      case 'http':
        return name.toUpperCase();
    }
  },
  getDefaultClientMeasOptsByTestName(name) {
    let res;
    switch (name.toLowerCase()) {
      case 'ping':
        res = this.get('infiniteSwitchEnabled') ? {
          ...CLIENT_DEFAULT_PING_OPTS,
          packets: INFINITE_MEASUREMENT_PACKETS
        } : CLIENT_DEFAULT_PING_OPTS;
        break;
      case 'traceroute':
        res = CLIENT_DEFAULT_TRACEROUTE_OPTS;
        break;
      case 'dns':
        res = CLIENT_DEFAULT_DNS_OPTS;
        break;
      case 'mtr':
        res = CLIENT_DEFAULT_MTR_OPTS;
        break;
      case 'http':
        res = CLIENT_DEFAULT_HTTP_OPTS;
        break;
    }

    // create deep copy to avoid mutations
    return JSON.parse(JSON.stringify(res));
  },
  getDefaultAPIMeasOptsByTestName(name) {
    let res;
    switch (name.toLowerCase()) {
      case 'ping':
        res = API_DEFAULT_PING_OPTS;
        break;
      case 'traceroute':
        res = API_DEFAULT_TRACEROUTE_OPTS;
        break;
      case 'dns':
        res = API_DEFAULT_DNS_OPTS;
        break;
      case 'mtr':
        res = API_DEFAULT_MTR_OPTS;
        break;
      case 'http':
        res = API_DEFAULT_HTTP_OPTS;
        break;
    }

    // create deep copy to avoid mutations
    return JSON.parse(JSON.stringify(res));
  },
  handleToggleMeasOpts() {
    if (this.get('testInProgress')) {
      return;
    }
    let prevValue = this.get('showMeasurementOpts');
    this.set('showMeasurementOpts', !prevValue);

    // if opts were not applied we should em reset to default or to prev applied state on closing of MeasOpts dropdown
    if (prevValue === true) {
      let testType = this.get('mainOptions.type');
      let appliedMeasOpts = this.get('appliedMeasOpts');
      let defaultOpts = this.getDefaultClientMeasOptsByTestName(testType);
      if (Object.keys(appliedMeasOpts).length) {
        this.set(`${testType.toLowerCase()}Opts`, {
          ...JSON.parse(JSON.stringify(appliedMeasOpts.initPresetOpts))
        });
        this.set('notAppliedOpts', {
          ...JSON.parse(JSON.stringify(appliedMeasOpts.notPresetOpts))
        });
      } else {
        this.set(`${testType.toLowerCase()}Opts`, defaultOpts);
        this.set('notAppliedOpts', {});
      }
    }
  },
  countModifiedMeasurementOpts(type, initPresetOpts, notPresetOpts) {
    let defaultOpts = this.getDefaultClientMeasOptsByTestName(type);
    let modifiedMeasOptsCnt = Object.keys(notPresetOpts).reduce((cnt, key) => {
      if (typeof notPresetOpts[key] === 'object') {
        if (key === 'request' && notPresetOpts[key].headers) {
          // each header should be treated as 1 modified option
          let headersCnt = Object.keys(notPresetOpts[key].headers).length;
          let otherPropsCnt = Object.keys(notPresetOpts[key]).length - 1; // -1 for headers

          return cnt + headersCnt + otherPropsCnt;
        }
        return cnt + Object.keys(notPresetOpts[key]).length;
      } else if (defaultOpts[key] !== notPresetOpts[key]) {
        return ++cnt;
      }
      return cnt;
    }, 0);
    Object.keys(defaultOpts).forEach(key => {
      if (typeof defaultOpts[key] === 'object') {
        Object.keys(defaultOpts[key]).forEach(secKey => {
          if (defaultOpts[key][secKey] !== initPresetOpts[key][secKey]) {
            modifiedMeasOptsCnt++;
          }
        });
      } else if (defaultOpts[key] !== initPresetOpts[key] && defaultOpts[key] !== notPresetOpts[key]) {
        modifiedMeasOptsCnt++;
      }
    });
    this.set('modifiedMeasOptsCnt', modifiedMeasOptsCnt);
  },
  resetMapAndRunTest(prevProbesMeasId = null) {
    this.set({
      shareResFlow: false,
      sharedMeasurementInitialLoading: false,
      mobileShareResHeaderData: null
    });
    this.get('testReqCancelFn')?.forEach(cancel => cancel?.());
    this.set('testReqCancelFn', []);
    this.disableRunTestBtnForDelay();
    this.set('testInProgress', true);
    let mq = window.matchMedia('(min-width: 768px)');
    if (mq.matches) {
      map$1.setCenter(MAP_CENTER_ALT$1);
      map$1.setZoom(MAP_ZOOM_ALT$1);
    } else {
      map$1.setCenter(MAP_CENTER_REG$1);
      map$1.setZoom(MAP_ZOOM_REG$1);
    }

    // once zoom is ended the idle event will be fired
    let listener = map$1.addListener('idle', () => {
      this.proceedToTest(prevProbesMeasId);
      // remove listener to avoid unintended test runs while zoom
      google.maps.event.removeListener(listener);
      this.set('gmapsIdleListener', null);
    });
    this.set('gmapsIdleListener', listener);
  },
  filterForInitPresetOpts(defaultOpts, optionsToFilter) {
    return Object.keys(optionsToFilter).reduce((res, key) => {
      if (Object.hasOwn(defaultOpts, key)) {
        if (typeof defaultOpts[key] === 'object') {
          res = {
            ...res,
            [key]: this.filterForInitPresetOpts(defaultOpts[key], optionsToFilter[key])
          };
        } else {
          res = {
            ...res,
            [key]: optionsToFilter[key]
          };
        }
      }
      return res;
    }, {});
  },
  filterForNotPresetOpts(defaultOpts, optionsToFilter) {
    return Object.keys(optionsToFilter).reduce((res, key) => {
      if (Object.hasOwn(defaultOpts, key)) {
        if (typeof optionsToFilter[key] === 'object') {
          res = {
            ...res,
            [key]: this.filterForNotPresetOpts(defaultOpts[key], optionsToFilter[key])
          };
        }
      } else {
        res = {
          ...res,
          [key]: optionsToFilter[key]
        };
      }
      return res;
    }, {});
  },
  zoomToResults(locations) {
    setTimeout(() => {
      // do not zoom if test was done for the World.
      if (!locations || locations.length === 1 && (locations[0].magic.toLowerCase() === 'world' || locations[0].magic === '')) {
        return;
      }

      // limit max zoom temp to avoid unnecessary zooming
      map$1.setOptions({
        maxZoom: 6
      });
      let bounds = new google.maps.LatLngBounds();
      mapMarkers$1.forEach(mm => {
        bounds.extend(mm.position);
      });
      google.maps.event.addListenerOnce(map$1, 'bounds_changed', () => {
        map$1.panTo(bounds.getCenter());
        // restore default zoom
        map$1.setOptions({
          maxZoom: MAP_MAX_ZOOM$1
        });
      });
      map$1.fitBounds(bounds);
    }, 400);
  },
  getProbesData() {
    dataCache.getCache('probesResponse', 60 * 1000, http.fetchGlobalpingProbes).then(value => this.handleProbesResponse(value)).catch(error => {
      console.error('Failed to fetch probes', error);
    });
  },
  scrollMapIntoView() {
    let mapBlockEl = this.find('.gp_map-block');
    let mobileTestDetails = this.find('.gp_map-block_test-details');
    if (mobileTestDetails?.checkVisibility?.()) {
      mobileTestDetails.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      mapBlockEl.scrollIntoView({
        behavior: 'smooth'
      });
    }
  },
  scrollFocusModeRootIntoView(scrollOffset = FOCUS_MODE_SCROLL_OFFSET) {
    let mapBlockEl = this.find('.gp_map-block');
    if (!mapBlockEl) {
      return;
    }
    let targetScrollTop = this.getFocusModeRootScrollTop(mapBlockEl, scrollOffset);
    if (targetScrollTop >= window.scrollY) {
      return;
    }
    window.scrollTo({
      behavior: 'smooth',
      top: targetScrollTop
    });
  },
  cancelFocusModeExitScroll() {
    let cancelScroll = this.focusModeExitScrollCancel;
    this.focusModeExitScrollCancel = null;
    cancelScroll?.();
  },
  startFocusModeExitScroll() {
    this.cancelFocusModeExitScroll();
    let focusModeRoot = this.find('.gp_map-block');
    let pageRoot = this.find('.p-globalping');
    let mainInfo = this.find('.gp_main-info');
    let focusModeOffsetY = Number.parseFloat(getComputedStyle(focusModeRoot).getPropertyValue('--focus-mode-offset-y')) || 0;
    let mainInfoTransition = mainInfo.style.transition;
    let isFocusModeOpen = pageRoot.classList.contains('focus-mode-open');
    if (isFocusModeOpen) {
      mainInfo.style.transition = 'none';
      pageRoot.classList.remove('focus-mode-open');
    }
    let targetScrollTop = this.getFocusModeRootScrollTop(focusModeRoot, FOCUS_MODE_SCROLL_OFFSET + focusModeOffsetY);
    if (isFocusModeOpen) {
      pageRoot.classList.add('focus-mode-open');
      focusModeRoot.getBoundingClientRect();
      mainInfo.style.transition = mainInfoTransition;
    }
    let startScrollTop = window.scrollY;
    if (targetScrollTop >= startScrollTop) {
      return;
    }
    let renderId = this.focusModeRenderId;
    let startTime = performance.now();
    let frame;
    let cancelScroll = () => {
      cancelAnimationFrame(frame);
      window.scrollTo({
        top: window.scrollY,
        behavior: 'auto'
      });
      if (this.focusModeExitScrollCancel === cancelScroll) {
        this.focusModeExitScrollCancel = null;
      }
    };
    let scroll = timestamp => {
      if (this.focusModeRenderId !== renderId) {
        cancelScroll();
        return;
      }
      let progress = Math.min(1, (timestamp - startTime) / FOCUS_MODE_EXIT_SCROLL_MS);
      let easedProgress = 1 - Math.pow(1 - progress, 3);
      let scrollTop = startScrollTop + (targetScrollTop - startScrollTop) * easedProgress;
      window.scrollTo({
        top: scrollTop,
        behavior: 'auto'
      });
      if (progress < 1) {
        frame = requestAnimationFrame(scroll);
      } else if (this.focusModeExitScrollCancel === cancelScroll) {
        this.focusModeExitScrollCancel = null;
      }
    };
    this.focusModeExitScrollCancel = cancelScroll;
    window.scrollTo({
      top: targetScrollTop,
      behavior: 'smooth'
    });
    frame = requestAnimationFrame(scroll);
  },
  getFocusModeRootScrollTop(mapBlockEl, scrollOffset = FOCUS_MODE_SCROLL_OFFSET) {
    let style = getComputedStyle(mapBlockEl);
    let focusModeOffsetY = Number.parseFloat(style.getPropertyValue('--focus-mode-offset-y')) || 0;
    let currentMarginTop = Number.parseFloat(style.marginTop) || 0;
    let currentTransformY = 0;
    let matrixMatch = style.transform.match(/^matrix(3d)?\((.+)\)$/);
    if (matrixMatch) {
      let transformValues = matrixMatch[2].split(',').map(value => Number.parseFloat(value));
      currentTransformY = matrixMatch[1] ? transformValues[13] : transformValues[5];
      currentTransformY = Number.isFinite(currentTransformY) ? currentTransformY : 0;
    }
    return Math.max(0, window.scrollY + mapBlockEl.getBoundingClientRect().top - currentTransformY - currentMarginTop + focusModeOffsetY - scrollOffset);
  },
  scrollFocusModeRootAfterRender(scrollOffset = FOCUS_MODE_SCROLL_OFFSET, cancelIfScrolled = true) {
    let scheduledScrollY = window.scrollY;
    let renderId = this.focusModeRenderId;
    this.update().then(() => {
      if (this.focusModeRenderId !== renderId) {
        return;
      }
      requestAnimationFrame(() => {
        if (this.focusModeRenderId === renderId && (!cancelIfScrolled || window.scrollY === scheduledScrollY)) {
          let focusBar = this.get('focusModeActive') && this.find('.gp_map-block_focus-bar');
          this.scrollFocusModeRootIntoView(scrollOffset - (focusBar?.offsetTop || 0));
        }
      });
    });
  },
  updateMapMarkerWithIW(marker, markerData, currentMarkerIdx) {
    let updSvg = this.createMapMarkerSvg(markerData);
    let currIw = infoWindows$1[currentMarkerIdx];
    marker.content.style.backgroundImage = `url('data:image/svg+xml;base64,${updSvg}')`;
    currIw.setContent(this.createInfoWindowContent(markerData, currentMarkerIdx));
  },
  createMapMarkerWithIW(markerData, currentMarkerIdx) {
    // create Popup element which will be shown on click on the marker
    let infoWindow = new google.maps.InfoWindow();

    // create svg to use as a Marker icon
    let svg = this.createMapMarkerSvg(markerData);
    let locationId = markerData.clientSideId;

    // add listener to IW for Results and Actions button
    google.maps.event.addListener(infoWindow, 'domready', () => {
      let clickableEl = document.getElementById(`iw-${currentMarkerIdx}`);
      let hasListener = clickableEl.dataset.hasListener;
      if (!hasListener) {
        clickableEl.addEventListener('click', () => {
          this.handleSeeResults(locationId);
          clickableEl.dataset.hasListener = true;
        });
      }
    });

    // collect IWs
    infoWindows$1.push(infoWindow);
    infoWindow.setContent(this.createInfoWindowContent(markerData, currentMarkerIdx));
    let markerContent = document.createElement('div');
    markerContent.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
    markerContent.style.width = `${DEFAULT_MARKER_DIMENSIONS}px`;
    markerContent.style.height = `${DEFAULT_MARKER_DIMENSIONS}px`;
    markerContent.style.backgroundRepeat = 'no-repeat';
    markerContent.style.backgroundPosition = 'center';
    markerContent.style.backgroundSize = 'contain';

    // create a new Marker
    let marker = new google.maps.marker.AdvancedMarkerElement({
      map: map$1,
      content: markerContent,
      position: {
        lat: markerData.lat,
        lng: markerData.lng
      },
      zIndex: 1
    });

    // keep original markers positions
    originalMapMarkersPos.set(marker, marker.position);
    mapMarkers$1.push(marker);

    // open IW on click, close all other IWs, handle markers spiderifying
    marker.addListener('click', () => {
      infoWindows$1.forEach(iw => iw.close());

      // check if marker is overlapping with other and should be spiderified
      if (this.shouldMapMarkersSpiderify(marker, mapMarkers$1, map$1) && marker.isSpiderPart !== true) {
        // despiderify markers
        this.despiderifyMapMarkers(mapMarkers$1);
        // spiderify overlapping markers
        this.spiderifyMapMarkers(marker, mapMarkers$1, map$1);
      } else {
        // open InfoWindow if marker is already spiderified or do not needed to be
        infoWindow.open({
          map: map$1,
          anchor: marker
        });
      }
    });
  },
  async getMultipleTestMeasurementById(idsArr, isInfiniteMeas = false) {
    try {
      for (let i = 0; i < idsArr.length; i++) {
        if (!this.get('shareResFlow')) {
          return;
        }
        await this.getTestMeasurementById({
          measurementId: idsArr[i],
          resNumber: i,
          isShareResCase: true,
          isFirstShareReq: i === 0,
          isLastShareReq: idsArr.length - 1 === i,
          isInfiniteMeas
        });
        if (!this.get('shareResFlow')) {
          return;
        }
      }
      this.set('sharedMeasurementInitialLoading', false);
    } catch {
      // getTestMeasurementById handles shared measurement errors before rejecting.
    }
  },
  handleSharedMeasurementLoadError(error) {
    if (!this.get('shareResFlow') || this.get('measurementErrMsg')) {
      return;
    }
    this.get('testReqCancelFn')?.forEach(cancel => cancel?.());
    this.set({
      testReqCancelFn: [],
      testInProgress: false,
      sharedMeasurementInitialLoading: false,
      measurementErrMsg: error.responseStatusCode === 404 ? 'This measurement has expired or is no longer available.' : 'Unable to load this measurement. Please try again later.',
      measurementDate: null,
      mobileShareResHeaderData: null,
      runTestBtnText: 'Run Test'
    });
  },
  postInfiniteGlobalpingMeasurement({
    reqParams,
    target,
    isInfiniteMeas = true,
    resNumber = 0,
    testRunId = null
  }) {
    this.set('runTestBtnText', 'Stop');
    http.postGlobalpingMeasurement({
      ...reqParams,
      target
    }, RATE_LIMIT_HEADERS$2).then(res => {
      if (!this.isActiveTestRun(testRunId)) {
        return;
      }

      // set response headers for gp-credits/gp-credits-message
      this.set('rateCreditsData', {
        ...res.responseHeaders,
        probesCount: res.response.probesCount
      });
      if (resNumber === 0) {
        this.set('loadingProbeResults', Array.from({
          length: res.response.probesCount || 0
        }, (_, clientSideId) => ({
          clientSideId
        })));
      }

      // set measurement ID for re-use probes case
      this.set('prevProbesMeasId', res.response.id);

      // Update the URL.
      if (resNumber === 0) {
        this.set('measurement', res.response.id);
      } else {
        app.router.replaceQueryParam('measurement', `${this.get('measurement').split('.').slice(-9).join('.')}.${res.response.id}`);
      }
      let updReqParams = {
        ...reqParams,
        locations: res.response.id
      };
      this.getTestMeasurementById({
        measurementId: res.response.id,
        resNumber,
        isInfiniteMeas,
        reqParams: updReqParams,
        testRunId
      });
      this.set('showMap', this.get('originalShowMap'));
    }).catch(err => {
      if (!this.isActiveTestRun(testRunId)) {
        return;
      }
      this.handlePostGPMeasError(err);
    });
  },
  isInfiniteOptsCorrect() {
    let {
      type,
      target
    } = this.get('mainOptions');
    return type === 'ping' && target.split(',').length <= 1;
  },
  handleInfiniteSwitch() {
    if (this.get('testInProgress') || !this.isInfiniteOptsCorrect()) {
      return;
    }
    let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');
    if (infiniteSwitchEnabled) {
      this.set('notAppliedOpts.packets', '');
    } else {
      this.set('notAppliedOpts.packets', INFINITE_MEASUREMENT_PACKETS);
    }
    this.set('infiniteSwitchEnabled', !infiniteSwitchEnabled);
    this.applyOptions();
  },
  handleInfiniteSwitchKeyDown(e) {
    if (e.key === 'Enter') {
      this.handleInfiniteSwitch();
    }
  },
  handlePostGPMeasError(err, isSecondTarget = false) {
    let isInfiniteModeRes = this.get('isInfiniteModeRes');
    let testResults = this.get('testResults');
    let targetsArr = this.get('targetsArr');
    this.set('testInProgress', false);
    this.enableRunTestBtn();
    // we show the error block under the map block only if it is not an infinite measurement or the one with no results
    this.set('runTestBtnText', 'Run Test');
    // set response headers (from error) for gp-credits/gp-credits-message
    this.set('rateCreditsData', err.responseHeaders);
    if (err.responseStatusCode === 429) {
      let measurementErrMsg = _.createMeasCreditsErrMsg(err.responseHeaders, this.get('@shared.user'), isInfiniteModeRes, !!testResults, isSecondTarget, targetsArr[0]);
      this.set('measurementErrMsg', measurementErrMsg);
      if (testResults && (isSecondTarget || isInfiniteModeRes)) {
        this.set('showCreditsErrorBar', true);
      } else {
        this.set('showCreditsData', false);
      }
    } else if (err.error.type === 'validation_error') {
      let measurementOptsErr = Object.keys(err.error.params || {}).some(key => key.split('.')[0] === 'measurementOptions');
      let inputErrors = _.parseValidationErrors(err.error, isSecondTarget && targetsArr[1]);
      this.set('inputErrors', inputErrors);
      this.set('measurementErrMsg', 'Please correct the highlighted fields and run the measurement again.');

      // open measurement options menu if it contains errors
      if (measurementOptsErr) {
        this.set('showMeasurementOpts', true);
      }
    } else {
      this.set('measurementErrMsg', err.error.message);
    }
  },
  reUseProbesRunTest() {
    let prevProbesMeasId = this.get('prevProbesMeasId');
    this.resetMapAndRunTest(prevProbesMeasId);
  },
  handleDropDownRunTestBtnNav() {
    // set this handler only once
    if (this.get('ddHandlerSet')) {
      return;
    }
    setTimeout(() => {
      let dropdownComponent = document.getElementById('dd-run-test-btn');
      dropdownComponent.addEventListener('focusout', event => {
        let dropdownMenu = dropdownComponent.querySelector('.dropdown-menu');
        let button = dropdownComponent.querySelector('.dropdown-toggle');
        let buttonWrapper = dropdownComponent.querySelector('.gp_map-block_settings-wrapper_split-btn');
        if (dropdownMenu && event.relatedTarget && !dropdownMenu.contains(event.relatedTarget)) {
          dropdownMenu.querySelectorAll('.dropdown-item').forEach(item => item.classList.remove('active'));
          button.setAttribute('aria-expanded', false);
          buttonWrapper.classList.remove('open');
        }
      });
      dropdownComponent.addEventListener('keydown', event => {
        let dropdownMenu = dropdownComponent.querySelector('.dropdown-menu');
        let activeItem = dropdownComponent.querySelector('.dropdown-item.active');
        let button = dropdownComponent.querySelector('.dropdown-toggle');
        if (dropdownMenu) {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            if (!activeItem) {
              let firstItem = dropdownMenu.firstElementChild;
              if (firstItem) {
                firstItem.classList.add('active');
              }
            } else {
              let nextItem;
              if (event.key === 'ArrowDown') {
                nextItem = activeItem.nextElementSibling;
              } else if (event.key === 'ArrowUp') {
                nextItem = activeItem.previousElementSibling;
              }
              if (nextItem) {
                activeItem.classList.remove('active');
                nextItem.classList.add('active');
              } else if (event.key === 'ArrowUp') {
                activeItem.classList.remove('active');
                button.focus();
              }
            }
          } else if (event.key === 'Enter' && activeItem) {
            activeItem.click();
          }
        }
      });
      this.set('ddHandlerSet', true);
    }, 4);
  },
  createMapMarkerSvg(markerData) {
    let svg;
    let svgFillColors = [];
    let targetsCnt = this.get('targetsArr').length;
    let probesMaxTiming = this.get('probesMaxTiming');
    let probesMinTiming = this.get('probesMinTiming');
    for (let i = 0; i < targetsCnt; i++) {
      svgFillColors.push(markerData.timings[i] ? _.getGpProbeStatusColor(markerData.timings[i], probesMaxTiming, probesMinTiming) : DEFAULT_MARKER_COLOR);
    }
    if (markerData.timings.length > 1) {
      svg = window.btoa(`<svg width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" viewBox="0 0 ${DEFAULT_MARKER_DIMENSIONS} ${DEFAULT_MARKER_DIMENSIONS}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
					<circle cx="12" cy="10" r="6" fill="${svgFillColors[1]}"/>
					<clipPath id="cut-off">
					<rect x="6" y="4" width="6" height="1112"/>
					</clipPath>
					<circle cx="12" cy="10" r="6" fill="${svgFillColors[0]}" clip-path="url(#cut-off)"/>
					<circle cx="12" cy="10" r="7" stroke="white" stroke-width="2"/>
					</g>
					<defs>
					<filter id="filter0_d_6106_3045" x="0" y="0" width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
					<feOffset dy="2"/>
					<feGaussianBlur stdDeviation="2"/>
					<feComposite in2="hardAlpha" operator="out"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
					</filter>
					</defs>
					</svg>`);
    } else {
      svg = window.btoa(`<svg width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" viewBox="0 0 ${DEFAULT_MARKER_DIMENSIONS} ${DEFAULT_MARKER_DIMENSIONS}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
					<circle cx="12" cy="10" r="6" fill="${svgFillColors[0]}"/>
					<circle cx="12" cy="10" r="7" stroke="white" stroke-width="2"/>
					</g>
					<defs>
					<filter id="filter0_d_6106_3045" x="0" y="0" width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
					<feOffset dy="2"/>
					<feGaussianBlur stdDeviation="2"/>
					<feComposite in2="hardAlpha" operator="out"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
					</filter>
					</defs>
					</svg>`);
    }
    return svg;
  },
  createInfoWindowContent(markerData, currentMarkerIdx) {
    let targetsCnt = this.get('targetsArr').length;
    let probesMaxTiming = this.get('probesMaxTiming');
    let probesMinTiming = this.get('probesMinTiming');
    let infoWindowContent = '<div class="gp-map_popup">';
    infoWindowContent += `<div class="gp-map_popup${targetsCnt > 1 ? '_multi' : '_single'}">`;
    if (targetsCnt === 1) {
      infoWindowContent += `<div class="gp-map_popup_single_timing">${markerData.errorCodes?.[0] || markerData.timings[0] || ''}</div>`;
      infoWindowContent += `<div class="gp-map_popup_single_network">${markerData.network}</div>`;
      infoWindowContent += `<div class="gp-map_popup_single_location">(${markerData.city}, ${markerData.country})</div>`;
    } else {
      infoWindowContent += `<div class="gp-map_popup_multi_network">${markerData.network}</div>`;
      infoWindowContent += `<div class="gp-map_popup_multi_location">(${markerData.city}, ${markerData.country})</div>`;
      markerData.targets.forEach((target, targetIdx) => {
        infoWindowContent += '<div class="gp-map_popup_multi_data">';
        infoWindowContent += `<span class="gp-map_popup_multi_data_target">${target}</span>`;
        infoWindowContent += `<span class="gp-map_popup_multi_data_timing"
						style='color: ${_.getGpProbeStatusColor(markerData.timings[targetIdx], probesMaxTiming, probesMinTiming)}'>${markerData.errorCodes?.[targetIdx] || markerData.timings[targetIdx] || ''}</span>`;
        infoWindowContent += '</div>';
      });
    }
    infoWindowContent += '</div>';
    infoWindowContent += `<div class="gp-map_popup_see-results ${targetsCnt > 1 ? 'centered' : ''}" id="iw-${currentMarkerIdx}">`;
    infoWindowContent += `<img width="20" height="20" src="${this.get('@shared.assetsHost')}/img/see-results-icon.svg">`;
    infoWindowContent += '<span>Results and Actions</span>';
    infoWindowContent += '</div>';
    infoWindowContent += '</div>';
    return infoWindowContent;
  },
  prepareRegularResults(testResults) {
    if (!testResults?.[0]?.length) {
      return [];
    }
    let dnsTraceEnabled = this.get('testReqParams.measurementOptions.trace');
    let parseTargetStats = res => {
      let baseStat = {
        target: res.target
      };
      if (res.result.status === 'in-progress') {
        return baseStat;
      }
      let {
        isFailed = false,
        lastTiming,
        value: avgTiming,
        extraValues
      } = _.calcGpTestResTiming(res.type, res, dnsTraceEnabled);
      let {
        packetsRtt,
        packetsTotal
      } = _.parseGpRawOutputForTimings(res.result.rawOutput);
      let stats = res.result?.stats || {};
      let isOffline = res.result.status === PROBE_STATUS_OFFLINE$2;
      let minTiming = stats.min || PROBE_NO_TIMING_VALUE$2;
      let maxTiming = stats.max || PROBE_NO_TIMING_VALUE$2;
      let responseBodyDelimiter = /(?:\r?\n){2}/;
      return {
        ...baseStat,
        ipAddr: res.result.resolvedAddress,
        lastTiming,
        minTiming,
        avgTiming,
        maxTiming,
        statsTotal: stats.total,
        statsDrop: stats.drop,
        isFailed,
        isOffline,
        packetsRtt,
        extraValues,
        failureRawOutput: this.getFailureProbeRawOutput(res),
        rawOutput: res.type === 'http' ? res.result.rawOutput.split(responseBodyDelimiter)[0] : res.result.rawOutput,
        responseBody: res.type === 'http' ? res.result.rawOutput.split(responseBodyDelimiter).slice(1).join('\n\n') : null,
        qualityStr: this.createQualityString(isOffline, stats.total, stats.drop),
        areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal),
        tls: res.result.tls
      };
    };
    let targets = this.get('targetsArr');
    let prepResults = testResults[0].map(res => ({
      clientSideId: res.clientSideId,
      ...res.probe,
      statsPerTarget: [parseTargetStats(res)]
    }));
    for (let i = 1; i < targets.length; i++) {
      prepResults.forEach(pR => {
        let nextRes = testResults[i]?.find(r => r.clientSideId === pR.clientSideId);
        if (nextRes) {
          pR.statsPerTarget.push(parseTargetStats(nextRes));
        } else {
          pR.statsPerTarget.push({
            target: targets[i]
          });
        }
      });
    }
    return prepResults;
  },
  prepareInfiniteResults(rawResults) {
    let probesAmount = rawResults[0].length;
    let probesMeasurements = [];

    // gather probe's data from different measurements, with each sub array representing a single probe's data
    for (let i = 0; i < probesAmount; i++) {
      probesMeasurements.push(rawResults.map(rr => rr[i]));
    }

    // prepare data for gp-raw-output, gp-table-output components
    return probesMeasurements.map(pbm => {
      return pbm.reduce((combinedProbeData, probeData) => {
        let {
          packetsRtt,
          packetsDrop,
          packetsTotal
        } = _.parseGpRawOutputForTimings(probeData.result.rawOutput);
        let isOffline = probeData.result.status === PROBE_STATUS_OFFLINE$2;
        let packetsRttCombined = [...(combinedProbeData.packetsRtt || []), ...packetsRtt];
        let packetsDropCombined = (combinedProbeData.packetsDrop || 0) + packetsDrop;
        let packetsTotalCombined = (combinedProbeData.packetsTotal || 0) + packetsTotal;
        let numericPacketsRttCombined = packetsRttCombined.filter(v => typeof v === 'number');
        let maxTiming = numericPacketsRttCombined.length ? Math.max(...numericPacketsRttCombined) : PROBE_NO_TIMING_VALUE$2;
        let minTiming = numericPacketsRttCombined.length ? Math.min(...numericPacketsRttCombined) : PROBE_NO_TIMING_VALUE$2;
        let avgTiming = numericPacketsRttCombined.length ? Number((numericPacketsRttCombined.reduce((res, rtt) => res += rtt, 0) / numericPacketsRttCombined.length).toFixed(2)) : PROBE_NO_TIMING_VALUE$2;
        let lastTiming = packetsRttCombined[packetsRttCombined.length - 1] || PROBE_NO_TIMING_VALUE$2;
        let lossValue = this.calcLoss(packetsRttCombined.length + packetsDropCombined, packetsDropCombined);
        let {
          packetLines,
          linesHeader,
          lastLineIdx
        } = this.parseLinesFromRawOutput(probeData.result.rawOutput, combinedProbeData.lastLineIdx || 0);
        let outputLinesCombined = [...(combinedProbeData.rawOutputLines || []), ...packetLines];
        let ipAddr = combinedProbeData.ipAddr || this.parseIPFromRawOutput(probeData.result.rawOutput);
        let rawOutputCombined = this.handleRawOutput([linesHeader, ...outputLinesCombined]);
        let clientSideMeasTime = probeData.clientSideUpdatedAt - probeData.clientSideStartedAt;
        let measurementTimeCombined = combinedProbeData.measurementTime || 0;

        // if measurement is finished we should take a server time (updatedAt - createdAt)
        if (probeData.status === 'finished') {
          measurementTimeCombined += probeData.serverTime;
        } else {
          // otherwise we should take a local time
          measurementTimeCombined += clientSideMeasTime;
        }
        return {
          ...combinedProbeData,
          lastLineIdx,
          packetsRtt: packetsRttCombined,
          packetsDrop: packetsDropCombined,
          packetsTotal: packetsTotalCombined,
          rawOutputLines: outputLinesCombined,
          measurementTime: measurementTimeCombined,
          ipAddr,
          clientSideId: probeData.clientSideId,
          ...probeData.probe,
          statsPerTarget: [{
            target: probeData.target,
            ipAddr,
            lastTiming,
            minTiming,
            avgTiming,
            maxTiming,
            statsTotal: packetsRttCombined.length,
            statsDrop: packetsDropCombined,
            isFailed: probeData.result.status === PROBE_STATUS_FAILED,
            isOffline,
            failureRawOutput: this.getFailureProbeRawOutput(probeData),
            packetsRtt: packetsRttCombined,
            qualityStr: this.createQualityString(isOffline, numericPacketsRttCombined.length + packetsDropCombined, packetsDropCombined),
            areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotalCombined),
            rawOutput: rawOutputCombined,
            extraValues: lossValue !== null ? {
              loss: {
                text: 'Loss',
                value: lossValue,
                units: '%'
              }
            } : {},
            rawFooter: this.createRawFooter(probeData.target, numericPacketsRttCombined, packetsTotalCombined, numericPacketsRttCombined.length, lossValue, minTiming, avgTiming, maxTiming, measurementTimeCombined, rawOutputCombined)
          }]
        };
      }, {});
    });
  },
  getFailureProbeRawOutput(probeData) {
    let rawOutput;
    let {
      status = null
    } = probeData.result;
    if (status === PROBE_STATUS_OFFLINE$2 || status === PROBE_STATUS_FAILED) {
      rawOutput = probeData.result.rawOutput;
    }
    return rawOutput;
  },
  createQualityString(isOffline, statsTotal, statsDrop) {
    if (isOffline) {
      return PROBE_OFFLINE_TEXT;
    }
    let {
      actualAmount,
      qualityPercentage
    } = this.calcQuality(statsTotal, statsDrop);
    return qualityPercentage !== null ? `${actualAmount}/${statsTotal} - ${qualityPercentage}%` : '';
  },
  checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal) {
    if (!packetsTotal || typeof lastTiming === 'undefined' || typeof maxTiming === 'undefined' || typeof minTiming === 'undefined' || typeof avgTiming === 'undefined') {
      return false;
    }
    return true;
  },
  calcQuality(statsTotal, statsDrop) {
    if (typeof statsTotal === 'undefined' || typeof statsDrop === 'undefined' || statsTotal === 0) {
      return {
        qualityPercentage: null,
        actualAmount: null
      };
    }
    let actualAmount = Math.max(statsTotal - statsDrop, 0);
    let qualityPercentage = Math.round(actualAmount / statsTotal * 100);
    return {
      qualityPercentage,
      actualAmount
    };
  },
  parseIPFromRawOutput(raw) {
    let regex = ipRegex_1();
    let match = raw.match(regex);
    if (match) {
      return match[0];
    }
    return '';
  },
  parseLinesFromRawOutput(raw, idxShift = 0) {
    let lines = raw.split('\n').filter(l => l);
    let linesHeader;
    let packetLines = [];
    let lastLineIdx = idxShift;
    for (let i = 0; i < lines.length; i++) {
      if (i === 0) {
        linesHeader = lines[i];
        continue;
      }
      if (lines[i].includes('---')) {
        break;
      }
      let subRegex = /(icmp_seq|tcp_conn)=(\d+)/;
      let match = lines[i].match(subRegex);
      let proto = match[1];
      let originalIdx = Number(match[2]);
      lastLineIdx = idxShift + originalIdx;
      let substitute = `${proto}=${lastLineIdx}`;
      let numberedLine = lines[i].replace(subRegex, substitute);
      packetLines.push(numberedLine);
    }
    return {
      packetLines,
      linesHeader,
      lastLineIdx
    };
  },
  calcLoss(statsTotal, statsDrop) {
    if (typeof statsTotal === 'undefined' || typeof statsDrop === 'undefined' || statsTotal === 0) {
      return null;
    }
    let actualAmount = Math.max(statsTotal - statsDrop, 0);
    return Math.round(statsDrop / actualAmount * 100);
  },
  handleRawOutput(lines) {
    let limitedLines = lines.length > RAW_OUTPUT_LINES_BATCH_LIMIT ? ['...', ...lines.slice(-RAW_OUTPUT_LINES_BATCH_LIMIT)] : lines;
    return limitedLines.join('\n');
  },
  setMainOptsTestType(newTestType) {
    if (this.get('testInProgress')) {
      return;
    }
    this.set('mainOptions.type', newTestType);
  },
  createRawFooter(target, rtts, packetsTotal, packetsReceived, lossValue, minTiming, avgTiming, maxTiming, time, rawOutput = '') {
    let mdev = this.calculateMeanDeviation(rtts);
    let showRttUnits = [minTiming, avgTiming, maxTiming, mdev].some(i => i !== PROBE_NO_TIMING_VALUE$2);
    let str = `${rawOutput ? '\n' : ''}--- ${target} ping statistics ---
${packetsTotal} packets transmitted, ${packetsReceived} received, ${lossValue || 0}% packet loss, time ${time}ms
rtt min/avg/max/mdev = ${minTiming}/${avgTiming}/${maxTiming}/${mdev}${showRttUnits ? ' ms' : ''}`;
    return str;
  },
  calculateMeanDeviation(rtts) {
    if (rtts.length === 0) {
      return PROBE_NO_TIMING_VALUE$2;
    }
    let rttsNumber = rtts.length;
    let rttsSquaredSum = rtts.reduce((sum, rtt) => sum + rtt * rtt, 0);
    let rttsSum = rtts.reduce((sum, rtt) => sum + rtt, 0);
    let mdev = Math.sqrt(rttsSquaredSum / rttsNumber - Math.pow(rttsSum / rttsNumber, 2));
    return Math.round(mdev * 1000) / 1000;
  },
  groupProbes(probes) {
    // group probes by Continents and Coordinates
    let groups = probes.reduce((res, probe) => {
      let coords = `${probe.location.latitude}, ${probe.location.longitude}`;

      // group by Coordinates
      if (!Object.hasOwn(res, coords)) {
        res[coords] = [];
      }
      res[coords].push(probe);
      return res;
    }, {});
    return groups;
  },
  createMapClusterMarkerWithIW(key, markersByCoords) {
    let [lat, lng] = key.split(', ');
    let svg = this.createClusterMarkerSVG(markersByCoords.length);
    let probeInfoWindow = new google.maps.InfoWindow();

    // Collect InfoWindows
    probesInfoWindows.push(probeInfoWindow);
    probeInfoWindow.setContent(this.createClusterMarkerInfoWindowContent(markersByCoords));
    let markerContent = document.createElement('div');
    markerContent.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
    markerContent.style.backgroundRepeat = 'no-repeat';
    markerContent.style.backgroundPosition = 'center';
    markerContent.style.backgroundSize = 'contain';
    markerContent.setAttribute('data-probe-count', markersByCoords.length);
    let {
      svgWidth,
      svgHeight
    } = getMarkerSize$1(markersByCoords.length, map$1.zoom);
    markerContent.style.width = `${svgWidth}px`;
    markerContent.style.height = `${svgHeight}px`;
    let probeMarker = new google.maps.marker.AdvancedMarkerElement({
      content: markerContent,
      position: {
        lat: Number(lat),
        lng: Number(lng)
      },
      zIndex: 1
    });
    probeMarker.addListener('click', () => {
      probesInfoWindows.forEach(iw => iw.close());
      probeInfoWindow.open({
        map: map$1,
        anchor: probeMarker
      });
    });
    probeMarker.markersCount = markersByCoords.length || 0;
    return probeMarker;
  },
  createClusterMarkerInfoWindowContent(markersByCoords) {
    let markersCnt = markersByCoords.length;
    let groupedNetworks = markersByCoords.reduce((res, m) => {
      let marker = res.find(i => i.location.network === m.location.network);
      if (marker) {
        marker.cnt += 1;
      } else {
        res.push({
          ...m,
          cnt: 1,
          sortKey: m.location.network.toLowerCase()
        });
      }
      return res;
    }, []).sort((a, b) => a.sortKey < b.sortKey ? -1 : a.sortKey > b.sortKey);
    let infoWindowContent = `<div class="gp_map-cluster-iw">`;
    if (markersCnt === 1) {
      let {
        network,
        city,
        country
      } = markersByCoords[0].location;
      infoWindowContent += `<span>${network} (${city}, ${country})</span>`;
    } else {
      // in this case we should render a list of probes
      groupedNetworks.forEach((m, mIdx) => {
        if (mIdx === 0) {
          // add header content
          infoWindowContent += '<span class="gp_map-cluster-iw_header">';
          infoWindowContent += `<img width="16" height="16" src="${this.get('@shared.assetsHost')}/img/location-icon.svg">`;
          infoWindowContent += `<span class="gp_map-cluster-iw_header_location">${m.location.city}, ${m.location.country}</span>`;
          infoWindowContent += `<span class="gp_map-cluster-iw_header_cnt">${markersByCoords.length}</span>`;
          infoWindowContent += '</span>';
        }

        // render the list of the probes, grouped by the same network
        infoWindowContent += `<span class="gp_map-cluster-iw_row">${m.location.network} ${m.cnt > 1 ? `<span class="gp_map-cluster-iw_row_network-cnt">${m.cnt}</span>` : ''}</span>`;
      });
    }
    infoWindowContent += '</div>';
    return infoWindowContent;
  },
  createClusterMarkerSVG(elementsCnt) {
    let {
      svgWidth,
      svgHeight,
      circleRadius,
      strokeWidth
    } = getMarkerSize$1(elementsCnt, 1); // here zoom must always be 1

    return window.btoa(`
				<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius}" fill="#17D4A7"/>
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius + 1}" stroke="white" stroke-width="${strokeWidth}"/>
					</g>
					${elementsCnt !== 1 ? `<text x="${svgWidth / 2}" y="${svgHeight / 2}" text-anchor="middle" dy=".35em" font-family="Arial" font-size="10" font-weight="bold" fill="#fff">${elementsCnt}</text>` : ''}
					<defs>
						<filter id="filter0_d_6106_3045" x="0" y="0" width="${svgWidth}" height="${svgHeight}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix"/>
							<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
							<feOffset dy="1"/>
							<feGaussianBlur stdDeviation="1"/>
							<feComposite in2="hardAlpha" operator="out"/>
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
						</filter>
					</defs>
				</svg>
			`);
  },
  spiderifyMapMarkers(clickedMarker, markers, map) {
    let projection = map.getProjection();
    let clickedPos = projection.fromLatLngToPoint(clickedMarker.position);
    let markerWidth = DEFAULT_MARKER_DIMENSIONS;
    let a = markerWidth;
    let b = 0.2 * markerWidth;
    let theta = 0;
    let overlappedMarkers = markers.filter(marker => {
      if (marker === clickedMarker) {
        return false;
      }
      let markerPos = projection.fromLatLngToPoint(marker.position);
      let pixelDistance = Math.sqrt(Math.pow(clickedPos.x - markerPos.x, 2) + Math.pow(clickedPos.y - markerPos.y, 2)) * Math.pow(2, map.zoom);
      return pixelDistance <= markerWidth;
    });
    let spiderMarkers = [clickedMarker, ...overlappedMarkers];
    spiderMarkers.forEach((marker, index) => {
      marker.isSpiderPart = true;
      if (index === 0) {
        // keep the clicked marker in place
        marker.position = clickedMarker.position;
      } else {
        // spiral calculation
        let r = a + b * theta;
        let offsetX = r * Math.cos(theta);
        let offsetY = r * Math.sin(theta);
        let x = clickedPos.x + offsetX / Math.pow(2, map.zoom);
        let y = clickedPos.y + offsetY / Math.pow(2, map.zoom);
        let point = new google.maps.Point(x, y);
        let latLng = projection.fromPointToLatLng(point);
        marker.position = new google.maps.LatLng(latLng.lat(), latLng.lng());
        marker.zIndex = 99999;

        // increment angle
        theta += markerWidth / r;
      }
    });
  },
  despiderifyMapMarkers(markers) {
    markers.forEach(m => {
      let originalPos = originalMapMarkersPos.get(m);
      if (originalPos) {
        m.position = originalPos;
        m.zIndex = 1;
        m.isSpiderPart = false;
      }
    });
  },
  shouldMapMarkersSpiderify(clickedMarker, markers, map) {
    let projection = map.getProjection();
    let clickedPos = projection.fromLatLngToPoint(clickedMarker.position);
    let overlapThreshold = DEFAULT_MARKER_DIMENSIONS / 2;
    return markers.some(marker => {
      if (marker !== clickedMarker) {
        let markerPos = projection.fromLatLngToPoint(marker.position);
        let pixelDistance = Math.sqrt(Math.pow(clickedPos.x - markerPos.x, 2) + Math.pow(clickedPos.y - markerPos.y, 2)) * Math.pow(2, map.zoom);
        return pixelDistance <= overlapThreshold;
      }
      return false;
    });
  },
  resetMeasurementOptions(type) {
    type ||= this.get('mainOptions.type');
    this.set('showMeasurementOpts', false);
    this.set('inputErrors', {});
    this.set(`${type.toLowerCase()}Opts`, this.getDefaultClientMeasOptsByTestName(type));
    this.set('appliedMeasOpts', {});
    this.set('notAppliedOpts', {});
    this.set('measurementErrMsg', null);
    this.set('modifiedMeasOptsCnt', 0);
    this.set('infiniteSwitchEnabled', false);
  },
  onExampleClick(options) {
    let {
      extended,
      infinite,
      ...mainOptions
    } = options;
    this.resetMeasurementOptions(mainOptions.type);
    if (infinite) {
      this.set('infiniteSwitchEnabled', true);
      this.set('notAppliedOpts.packets', INFINITE_MEASUREMENT_PACKETS);
    }
    this.set('mainOptions', mainOptions);
    if (extended) {
      this.set(`${mainOptions.type}Opts`, extended);
    }
    this.applyOptions();
    this.resetMapAndRunTest();
    this.scrollMapIntoView();
  }
};
component$j.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "r-page",
    m: [{
      n: "noYield",
      f: [{
        t: 2,
        r: "noYield"
      }],
      t: 13
    }, {
      n: "title",
      f: [{
        t: 2,
        r: "title"
      }],
      t: 13
    }, {
      n: "description",
      f: [{
        t: 2,
        r: "description"
      }],
      t: 13
    }, {
      n: "ogTitle",
      f: [{
        t: 2,
        r: "ogTitle"
      }],
      t: 13
    }, {
      n: "ogDescription",
      f: [{
        t: 2,
        r: "ogDescription"
      }],
      t: 13
    }, {
      n: "openGraphImage",
      f: [{
        t: 4,
        f: [{
          t: 2,
          r: "@shared.serverHost"
        }, "/open-graph/image/measurement/", {
          t: 2,
          r: "measurement"
        }],
        n: 50,
        r: "measurement"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "script",
      m: [{
        n: "src",
        f: "https://cdn.jsdelivr.net/npm/@googlemaps/markerclusterer@2.5.3/dist/index.umd.min.js",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "script",
        f: ["\t\t\tfunction onDocumentReady (fn) {\n\t\t\t\tif (document.readyState !== 'loading') {\n\t\t\t\t\tfn();\n\t\t\t\t} else {\n\t\t\t\t\tdocument.addEventListener('DOMContentLoaded', fn);\n\t\t\t\t}\n\t\t\t}\n\t\t\t/* eslint-disable */\n\t\t\tfunction initMap () {\n\t\t\t\tonDocumentReady(function () {\n\t\t\t\t\tapp.loaded = true;\n\n\t\t\t\t\tif (app.router.route && app.router.route.view && app.router.route.view.initMap) {\n\t\t\t\t\t\tapp.router.route.view.initMap();\n\t\t\t\t\t}\n\t\t\t\t});\n\t\t\t}\n\t\t"]
      }, " ", {
        t: 7,
        e: "script",
        m: [{
          n: "src",
          f: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBTICLY5LgWNJ0Uly61Q1sNXz_1KZIECwg&language=en&callback=initMap&libraries=marker&loading=async",
          t: 13,
          g: 1
        }, {
          n: "async",
          f: 0,
          t: 13
        }]
      }],
      n: 50,
      x: {
        r: ["@shared.isServer", "@shared.googleMapsLoaded"],
        s: "!_0&&!_1"
      }
    }, " ", {
      t: 7,
      e: "c-notification"
    }, " ", {
      t: 7,
      e: "c-gp-header",
      m: [{
        n: "additionalClasses",
        f: ["header-with-globalping-bg no-border ", {
          t: 4,
          f: ["focus-mode-background"],
          n: 50,
          x: {
            r: ["focusModeActive", "focusModeTransition", "focusModePosition"],
            s: "_0||_1||_2===\"preparing-close\""
          }
        }],
        t: 13
      }, {
        n: "isInert",
        f: [{
          t: 2,
          x: {
            r: ["focusModeActive", "focusModeTransition", "focusModePosition"],
            s: "_0||_1||_2===\"preparing-close\""
          }
        }],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        n: "class",
        f: ["p-globalping ", {
          t: 4,
          f: ["focus-mode-open"],
          n: 50,
          x: {
            r: ["focusModeActive", "focusModePosition"],
            s: "_0||_1===\"preparing-close\""
          }
        }],
        t: 13
      }],
      f: [{
        t: 7,
        e: "c-gp-jumbotron",
        m: [{
          n: "className",
          f: "main",
          t: 13,
          g: 1
        }, {
          n: "gridType",
          f: "globe",
          t: 13,
          g: 1
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp_main-info",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_main-info_descr",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_main-info_descr_green",
              g: 1
            }],
            f: ["Monitor, debug and benchmark"]
          }, " ", {
            t: 7,
            e: "span",
            f: ["your internet infrastructure from a globally distributed network of probes."]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_main-info_row",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_main-info_stats",
              g: 1
            }],
            f: [{
              t: 7,
              e: "a",
              m: [{
                t: 13,
                n: "class",
                f: "gp_main-info_stats_item",
                g: 1
              }, {
                n: "href",
                f: "/network?group=disabled",
                t: 13,
                g: 1
              }, {
                n: "aria-label",
                f: "Explore the network",
                t: 13,
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_main-info_stats_item_number",
                  g: 1
                }],
                f: [{
                  t: 2,
                  x: {
                    r: ["totalProbes"],
                    s: "Math.floor(_0)"
                  }
                }, " ", {
                  t: 7,
                  e: "span"
                }]
              }, " ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_main-info_stats_item_text",
                  g: 1
                }],
                f: ["connected probes"]
              }]
            }, " ", {
              t: 7,
              e: "a",
              m: [{
                t: 13,
                n: "class",
                f: "gp_main-info_stats_item",
                g: 1
              }, {
                n: "href",
                f: "/network",
                t: 13,
                g: 1
              }, {
                n: "aria-label",
                f: "Explore the network",
                t: 13,
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_main-info_stats_item_number",
                  g: 1
                }],
                f: [{
                  t: 2,
                  x: {
                    r: ["totalCities"],
                    s: "Math.floor(_0)"
                  }
                }, " ", {
                  t: 7,
                  e: "span"
                }]
              }, " ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_main-info_stats_item_text",
                  g: 1
                }],
                f: ["different cities"]
              }]
            }, " ", {
              t: 7,
              e: "a",
              m: [{
                t: 13,
                n: "class",
                f: "gp_main-info_stats_item",
                g: 1
              }, {
                n: "href",
                f: "/network?group=country",
                t: 13,
                g: 1
              }, {
                n: "aria-label",
                f: "Explore the network",
                t: 13,
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_main-info_stats_item_number",
                  g: 1
                }],
                f: [{
                  t: 2,
                  x: {
                    r: ["totalCountries"],
                    s: "Math.floor(_0)"
                  }
                }, " ", {
                  t: 7,
                  e: "span"
                }]
              }, " ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_main-info_stats_item_text",
                  g: 1
                }],
                f: ["different countries"]
              }]
            }]
          }, " ", {
            t: 7,
            e: "c-gp-video-modal",
            m: [{
              n: "view",
              f: [{
                t: 2,
                r: "view"
              }],
              t: 13
            }, {
              n: "measurement",
              f: [{
                t: 2,
                r: "measurement"
              }],
              t: 13
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          n: "class",
          f: ["gp_map-block ", {
            t: 4,
            f: ["gp_map-block_focus-mode ", {
              t: 4,
              f: ["gp_map-block_focus-mode_entering"],
              n: 50,
              x: {
                r: ["focusModePosition"],
                s: "_0===\"entering\""
              }
            }, {
              t: 4,
              f: ["gp_map-block_focus-mode_preparing-close"],
              n: 50,
              x: {
                r: ["focusModePosition"],
                s: "_0===\"preparing-close\""
              },
              l: 1
            }],
            n: 50,
            x: {
              r: ["focusModeActive", "focusModePosition"],
              s: "_0||_1===\"preparing-close\""
            }
          }, {
            t: 4,
            f: ["gp_map-block_results-leaving"],
            n: 50,
            x: {
              r: ["focusModeTransition", "focusModePosition"],
              s: "_0===\"content-leaving\"||_1===\"leaving\""
            },
            l: 1
          }],
          t: 13
        }, {
          n: ["transitionend"],
          t: 70,
          f: {
            r: ["@this", "@event"],
            s: "[_0.handleFocusModePositionTransitionEnd(_1)]"
          }
        }, {
          t: 4,
          f: [{
            n: "role",
            f: "dialog",
            t: 13
          }, {
            n: "aria-modal",
            f: "true",
            t: 13
          }, {
            n: "aria-label",
            f: "Globalping measurement tool",
            t: 13
          }, {
            n: "tabindex",
            f: "-1",
            t: 13
          }],
          n: 50,
          r: "focusModeActive"
        }],
        f: [{
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              n: "class",
              f: ["gp_focus-mode-backdrop ", {
                t: 4,
                f: ["gp_focus-mode-backdrop_moving"],
                n: 50,
                r: "focusModePosition"
              }, {
                t: 4,
                f: ["gp_focus-mode-backdrop_settled"],
                n: 51,
                l: 1
              }, " ", {
                t: 4,
                f: ["active"],
                n: 50,
                x: {
                  r: ["focusModeActive", "focusModePosition"],
                  s: "_0||_1===\"preparing-close\""
                }
              }, {
                t: 4,
                f: ["gp_focus-mode-backdrop_closing"],
                n: 50,
                r: "focusModeTransition",
                l: 1
              }],
              t: 13
            }, {
              n: "aria-hidden",
              f: "true",
              t: 13,
              g: 1
            }, {
              n: ["transitionend"],
              t: 70,
              f: {
                r: ["@this", "@event"],
                s: "[_0.handleFocusModeBackdropTransitionEnd(_1)]"
              }
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this", "@event"],
                s: "[_0.closeFocusModeFromBackdrop(_1)]"
              }
            }]
          }],
          n: 50,
          x: {
            r: ["focusModeAvailable", "focusModeActive", "focusModeTransition", "focusModePosition"],
            s: "_0||_1||_2||_3"
          }
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_map-block_focus-backing",
              g: 1
            }, {
              n: "aria-hidden",
              f: "true",
              t: 13,
              g: 1
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              n: "class",
              f: ["gp_map-block_focus-bar ", {
                t: 4,
                f: ["gp_map-block_focus-bar_entering"],
                n: 50,
                x: {
                  r: ["focusModeTransition"],
                  s: "_0===\"opening\""
                }
              }, {
                t: 4,
                f: ["gp_map-block_focus-bar_leaving"],
                n: 50,
                x: {
                  r: ["focusModeTransition", "focusModePosition"],
                  s: "_0===\"content-leaving\"||_1===\"leaving\""
                },
                l: 1
              }],
              t: 13
            }, {
              t: 4,
              f: [{
                n: "inert",
                f: 0,
                t: 13
              }, {
                n: "aria-hidden",
                f: "true",
                t: 13
              }],
              n: 51,
              r: "focusModeActive"
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                t: 13,
                n: "class",
                f: "gp_map-block_focus-bar_logo",
                g: 1
              }, {
                n: "width",
                f: "119",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "24",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/globalping-full-dark.svg"],
                t: 13
              }, {
                n: "alt",
                f: "Globalping",
                t: 13,
                g: 1
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp_map-block_focus-bar_heading",
                g: 1
              }],
              f: [{
                t: 7,
                e: "h2",
                f: ["Measurement results"]
              }, " ", {
                t: 4,
                f: [{
                  t: 7,
                  e: "span",
                  f: [{
                    t: 7,
                    e: "i",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "fa fa-calendar",
                      g: 1
                    }, {
                      n: "aria-hidden",
                      f: "true",
                      t: 13,
                      g: 1
                    }]
                  }, " ", {
                    t: 2,
                    r: "measurementDate"
                  }]
                }],
                n: 50,
                r: "measurementDate"
              }]
            }, " ", {
              t: 7,
              e: "button",
              m: [{
                t: 13,
                n: "class",
                f: "gp_map-block_header_focus-toggle gp_map-block_focus-bar_return",
                g: 1
              }, {
                n: "type",
                f: "button",
                t: 13,
                g: 1
              }, {
                n: "aria-label",
                f: "Return to homepage from measurement focus mode",
                t: 13,
                g: 1
              }, {
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this", "@event"],
                  s: "[_0.closeFocusMode(_1)]"
                }
              }],
              f: [{
                t: 7,
                e: "i",
                m: [{
                  t: 13,
                  n: "class",
                  f: "fa fa-reply",
                  g: 1
                }, {
                  n: "aria-hidden",
                  f: "true",
                  t: 13,
                  g: 1
                }]
              }, " ", {
                t: 7,
                e: "span",
                f: ["Return to homepage"]
              }]
            }]
          }],
          n: 50,
          x: {
            r: ["focusModeActive", "focusModeTransition", "focusModePosition"],
            s: "_0||_1===\"content-leaving\"||_2"
          }
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_map-block_header",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_map-block_header_dots",
              g: 1
            }, {
              n: "aria-hidden",
              f: "true",
              t: 13,
              g: 1
            }],
            f: [{
              t: 7,
              e: "span"
            }, " ", {
              t: 7,
              e: "span"
            }, " ", {
              t: 7,
              e: "span"
            }]
          }, " ", {
            t: 4,
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp_map-block_header_measurement-date",
                g: 1
              }],
              f: [{
                t: 7,
                e: "i",
                m: [{
                  t: 13,
                  n: "class",
                  f: "fa fa-calendar",
                  g: 1
                }, {
                  n: "aria-hidden",
                  f: "true",
                  t: 13,
                  g: 1
                }]
              }, " ", {
                t: 7,
                e: "span",
                f: [{
                  t: 2,
                  r: "measurementDate"
                }]
              }]
            }],
            n: 50,
            x: {
              r: ["measurementDate", "focusModeActive"],
              s: "_0&&!_1"
            }
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_map-block_settings-wrapper",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_map-block_settings-wrapper_settings",
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp_map-block_settings-wrapper_settings_grouped",
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_dropdown_reg",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  f: ["Test type"]
                }, " ", {
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "btn-group",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "button",
                    m: [{
                      n: "type",
                      f: "button",
                      t: 13,
                      g: 1
                    }, {
                      n: "class",
                      f: ["dropdown-toggle ", {
                        t: 4,
                        f: ["disabled"],
                        n: 50,
                        r: "testInProgress"
                      }],
                      t: 13
                    }, {
                      n: "data-toggle",
                      f: "dropdown",
                      t: 13,
                      g: 1
                    }, {
                      n: "aria-haspopup",
                      f: "true",
                      t: 13,
                      g: 1
                    }, {
                      n: "aria-expanded",
                      f: "false",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "span",
                      f: [{
                        t: 2,
                        r: "~/mainOptions.type"
                      }]
                    }, " ", {
                      t: 7,
                      e: "i",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-angle-down",
                        g: 1
                      }, {
                        n: "aria-hidden",
                        f: "true",
                        t: 13,
                        g: 1
                      }]
                    }]
                  }, " ", {
                    t: 7,
                    e: "ul",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "dropdown-menu",
                      g: 1
                    }, {
                      n: "role",
                      f: "listbox",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 4,
                      f: [{
                        t: 7,
                        e: "li",
                        m: [{
                          n: "aria-selected",
                          f: [{
                            t: 2,
                            x: {
                              r: [".", "mainOptions.type"],
                              s: "_0===_1"
                            }
                          }],
                          t: 13
                        }, {
                          n: "role",
                          f: "option",
                          t: 13,
                          g: 1
                        }, {
                          n: ["click"],
                          t: 70,
                          f: {
                            r: ["@this", "."],
                            s: "[_0.setMainOptsTestType(_1)]"
                          }
                        }],
                        f: [{
                          t: 2,
                          r: "."
                        }]
                      }],
                      n: 52,
                      r: "~/testTypesList"
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "c-tags-input",
                m: [{
                  n: "inputId",
                  f: "targetInput",
                  t: 13,
                  g: 1
                }, {
                  n: "value",
                  f: [{
                    t: 2,
                    r: "mainOptions.target"
                  }],
                  t: 13
                }, {
                  n: "defaultValue",
                  f: [{
                    t: 2,
                    r: "DEFAULT_TARGET_VALUE"
                  }],
                  t: 13
                }, {
                  n: "error",
                  f: [{
                    t: 2,
                    r: "inputErrors.target"
                  }],
                  t: 13
                }, {
                  n: "placeholder",
                  f: "IP or domain",
                  t: 13,
                  g: 1
                }, {
                  n: "labelText",
                  f: "Target(s)",
                  t: 13,
                  g: 1
                }, {
                  n: "isDisabled",
                  f: [{
                    t: 2,
                    r: "testInProgress"
                  }],
                  t: 13
                }, {
                  n: "setDefaultValueInitially",
                  f: [{
                    t: 2,
                    x: {
                      r: ["shareResFlow"],
                      s: "!_0"
                    }
                  }],
                  t: 13
                }, {
                  n: "useGpTargetHandler",
                  f: [{
                    t: 2,
                    x: {
                      r: [],
                      s: "true"
                    }
                  }],
                  t: 13
                }, {
                  n: "gpMainOpts",
                  f: [{
                    t: 2,
                    r: "mainOptions"
                  }],
                  t: 13
                }, {
                  n: "gpHttpOpts",
                  f: [{
                    t: 2,
                    r: "httpOpts"
                  }],
                  t: 13
                }, {
                  n: "gpNotAppliedOpts",
                  f: [{
                    t: 2,
                    r: "notAppliedOpts"
                  }],
                  t: 13
                }, {
                  n: "gpUrlHandlerCb",
                  f: [{
                    t: 2,
                    r: "@this.applyOptions"
                  }],
                  t: 13
                }, {
                  n: "showIPSwitch",
                  f: [{
                    t: 2,
                    x: {
                      r: ["mainOptions.type"],
                      s: "_0!==\"DNS\""
                    }
                  }],
                  t: 13
                }, {
                  n: "ipVersion",
                  f: [{
                    t: 2,
                    r: "mainOptions.ipVersion"
                  }],
                  t: 13
                }, {
                  n: "ttPos",
                  f: [{
                    t: 2,
                    r: "ttPositions.targetTtPos"
                  }],
                  t: 13
                }],
                f: [],
                p: {
                  labelIcon: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "tooltip",
                      t: 71,
                      f: {
                        r: ["ttPos"],
                        s: "[\"Up to 2 IP addresses or domains\",_0]"
                      }
                    }, {
                      n: "width",
                      f: "14",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "14",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/help-icon.svg"],
                      t: 13
                    }]
                  }]
                }
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp_map-block_settings-wrapper_settings_grouped",
                g: 1
              }],
              f: [{
                t: 7,
                e: "c-location-input",
                m: [{
                  n: ["enter"],
                  t: 70,
                  f: {
                    r: ["@this"],
                    s: "[_0.resetMapAndRunTest()]"
                  }
                }, {
                  n: "rawProbes",
                  f: [{
                    t: 2,
                    r: "rawProbes"
                  }],
                  t: 13
                }, {
                  n: "value",
                  f: [{
                    t: 2,
                    r: "mainOptions.location"
                  }],
                  t: 13
                }, {
                  n: "error",
                  f: [{
                    t: 2,
                    r: "inputErrors.location"
                  }],
                  t: 13
                }, {
                  n: "placeholder",
                  f: "Enter location",
                  t: 13,
                  g: 1
                }, {
                  n: "labelText",
                  f: "Location",
                  t: 13,
                  g: 1
                }, {
                  n: "classList",
                  f: "gp_map-block_settings-wrapper_settings_location gp_input location-input-hp",
                  t: 13,
                  g: 1
                }, {
                  n: "disabled",
                  f: [{
                    t: 2,
                    r: "testInProgress"
                  }],
                  t: 13
                }, {
                  n: "ttPos",
                  f: [{
                    t: 2,
                    r: "ttPositions.locationTtPos"
                  }],
                  t: 13
                }, {
                  n: "locationAutofilled",
                  f: [{
                    t: 2,
                    r: "locationAutofilled"
                  }],
                  t: 13
                }],
                f: [],
                p: {
                  labelIcon: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "tooltip",
                      t: 71,
                      f: {
                        r: ["ttPos"],
                        s: "[[\"This magic field supports names of continents, regions, countries, US states, cities, networks, and our custom tags.\",\"\",\"Use + to combine multiple filters.\",\"Use , to select multiple locations.\"],_0,undefined,undefined,\"multiline\"]"
                      }
                    }, {
                      n: "width",
                      f: "14",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "14",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/help-icon.svg"],
                      t: 13
                    }]
                  }]
                }
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_map-block_settings-wrapper_settings_subgroup",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "c-controlled-input",
                  m: [{
                    n: "id",
                    f: "limitInput",
                    t: 13,
                    g: 1
                  }, {
                    n: "value",
                    f: [{
                      t: 2,
                      r: "mainOptions.limit"
                    }],
                    t: 13
                  }, {
                    n: "error",
                    f: [{
                      t: 2,
                      r: "inputErrors.limit"
                    }],
                    t: 13
                  }, {
                    n: "placeholder",
                    f: [{
                      t: 2,
                      r: "defaultLimit"
                    }],
                    t: 13
                  }, {
                    n: "labelText",
                    f: "Limit",
                    t: 13,
                    g: 1
                  }, {
                    n: "classList",
                    f: "gp_map-block_settings-wrapper_settings_limit gp_input",
                    t: 13,
                    g: 1
                  }, {
                    n: "hideLabelIcon",
                    f: [{
                      t: 2,
                      x: {
                        r: ["infiniteSwitchEnabled"],
                        s: "_0===false"
                      }
                    }],
                    t: 13
                  }, {
                    n: "disabled",
                    f: [{
                      t: 2,
                      r: "testInProgress"
                    }],
                    t: 13
                  }, {
                    n: "ttPos",
                    f: [{
                      t: 2,
                      r: "ttPositions.limitTtPos"
                    }],
                    t: 13
                  }],
                  f: [],
                  p: {
                    labelIcon: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "tooltip",
                        t: 71,
                        f: {
                          r: ["ttPos"],
                          s: "[\"Values up to 5 are supported for infinite measurements\",_0,undefined,undefined,\"gp_tt-limit\"]"
                        }
                      }, {
                        n: "width",
                        f: "14",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "14",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/help-icon.svg"],
                        t: 13
                      }]
                    }]
                  }
                }, " ", {
                  t: 7,
                  e: "div",
                  m: [{
                    n: "class",
                    f: ["gp_map-block_settings-wrapper_settings_subgroup_options-block ", {
                      t: 4,
                      f: ["disabled"],
                      n: 50,
                      r: "testInProgress"
                    }],
                    t: 13
                  }],
                  f: [{
                    t: 7,
                    e: "button",
                    m: [{
                      n: "class",
                      f: [{
                        t: 4,
                        f: ["active"],
                        n: 50,
                        r: "showMeasurementOpts"
                      }],
                      t: 13
                    }, {
                      n: ["click"],
                      t: 70,
                      f: {
                        r: ["@this"],
                        s: "[_0.handleToggleMeasOpts()]"
                      }
                    }],
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "width",
                        f: "20",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "20",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/settings-icon.svg"],
                        t: 13
                      }]
                    }, " ", {
                      t: 4,
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "additional-opts-total",
                          g: 1
                        }],
                        f: [{
                          t: 2,
                          r: "modifiedMeasOptsCnt"
                        }]
                      }],
                      n: 50,
                      x: {
                        r: ["modifiedMeasOptsCnt", "showMeasurementOpts"],
                        s: "_0&&_1===false"
                      }
                    }]
                  }, " ", {
                    t: 7,
                    e: "div",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp_map-block_settings-wrapper_settings_subgroup_options-block_specific-set",
                      g: 1
                    }],
                    f: [{
                      t: 4,
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "typePing",
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "div",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "pair",
                            g: 1
                          }],
                          f: [{
                            t: 7,
                            e: "c-controlled-input",
                            m: [{
                              n: "value",
                              f: [{
                                t: 2,
                                r: "notAppliedOpts.port"
                              }],
                              t: 13
                            }, {
                              n: "error",
                              f: [{
                                t: 2,
                                r: "inputErrors.port"
                              }],
                              t: 13
                            }, {
                              n: "placeholder",
                              f: "80",
                              t: 13,
                              g: 1
                            }, {
                              n: "labelText",
                              f: "Port",
                              t: 13,
                              g: 1
                            }, {
                              n: "classList",
                              f: "port-input gp_input",
                              t: 13,
                              g: 1
                            }, {
                              n: "disabled",
                              f: [{
                                t: 2,
                                r: "disablePort"
                              }],
                              t: 13
                            }],
                            f: []
                          }, " ", {
                            t: 7,
                            e: "div",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "gp_dropdown_reg",
                              g: 1
                            }],
                            f: [{
                              t: 7,
                              e: "span",
                              f: ["Protocol"]
                            }, " ", {
                              t: 7,
                              e: "div",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "btn-group",
                                g: 1
                              }],
                              f: [{
                                t: 7,
                                e: "button",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "dropdown-toggle",
                                  g: 1
                                }, {
                                  n: "type",
                                  f: "button",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "data-toggle",
                                  f: "dropdown",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "aria-haspopup",
                                  f: "true",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "aria-expanded",
                                  f: "false",
                                  t: 13,
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "span",
                                  f: [{
                                    t: 2,
                                    r: "~/pingOpts.protocol"
                                  }]
                                }, " ", {
                                  t: 7,
                                  e: "i",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "fa fa-angle-down",
                                    g: 1
                                  }, {
                                    n: "aria-hidden",
                                    f: "true",
                                    t: 13,
                                    g: 1
                                  }]
                                }]
                              }, " ", {
                                t: 7,
                                e: "ul",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "dropdown-menu",
                                  g: 1
                                }, {
                                  n: "role",
                                  f: "listbox",
                                  t: 13,
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["pingOpts.protocol"],
                                        s: "_0===\"TCP\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"pingOpts.protocol\",\"TCP\")]"
                                    }
                                  }],
                                  f: ["TCP"]
                                }, " ", {
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["pingOpts.protocol"],
                                        s: "_0===\"ICMP\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"pingOpts.protocol\",\"ICMP\")]"
                                    }
                                  }],
                                  f: ["ICMP"]
                                }]
                              }]
                            }]
                          }]
                        }, " ", {
                          t: 7,
                          e: "c-controlled-input",
                          m: [{
                            n: "value",
                            f: [{
                              t: 2,
                              r: "notAppliedOpts.packets"
                            }],
                            t: 13
                          }, {
                            n: "error",
                            f: [{
                              t: 2,
                              r: "inputErrors.packets"
                            }],
                            t: 13
                          }, {
                            n: "placeholder",
                            f: [{
                              t: 2,
                              r: "defaultPacketsAmount"
                            }],
                            t: 13
                          }, {
                            n: "labelText",
                            f: "Packets",
                            t: 13,
                            g: 1
                          }, {
                            n: "classList",
                            f: "gp_input",
                            t: 13,
                            g: 1
                          }, {
                            n: "disabled",
                            f: [{
                              t: 2,
                              r: "infiniteSwitchEnabled"
                            }],
                            t: 13
                          }],
                          f: []
                        }]
                      }],
                      n: 50,
                      x: {
                        r: ["mainOptions.type"],
                        s: "_0===\"ping\""
                      }
                    }, " ", {
                      t: 4,
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "typeTraceroute",
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "div",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "pair",
                            g: 1
                          }],
                          f: [{
                            t: 7,
                            e: "c-controlled-input",
                            m: [{
                              n: "value",
                              f: [{
                                t: 2,
                                r: "notAppliedOpts.port"
                              }],
                              t: 13
                            }, {
                              n: "error",
                              f: [{
                                t: 2,
                                r: "inputErrors.port"
                              }],
                              t: 13
                            }, {
                              n: "placeholder",
                              f: "53",
                              t: 13,
                              g: 1
                            }, {
                              n: "labelText",
                              f: "Port",
                              t: 13,
                              g: 1
                            }, {
                              n: "classList",
                              f: "port-input gp_input",
                              t: 13,
                              g: 1
                            }, {
                              n: "disabled",
                              f: [{
                                t: 2,
                                r: "disablePort"
                              }],
                              t: 13
                            }],
                            f: []
                          }, " ", {
                            t: 7,
                            e: "div",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "gp_dropdown_reg",
                              g: 1
                            }],
                            f: [{
                              t: 7,
                              e: "span",
                              f: ["Protocol"]
                            }, " ", {
                              t: 7,
                              e: "div",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "btn-group",
                                g: 1
                              }],
                              f: [{
                                t: 7,
                                e: "button",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "dropdown-toggle",
                                  g: 1
                                }, {
                                  n: "type",
                                  f: "button",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "data-toggle",
                                  f: "dropdown",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "aria-haspopup",
                                  f: "true",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "aria-expanded",
                                  f: "false",
                                  t: 13,
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "span",
                                  f: [{
                                    t: 2,
                                    r: "~/tracerouteOpts.protocol"
                                  }]
                                }, " ", {
                                  t: 7,
                                  e: "i",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "fa fa-angle-down",
                                    g: 1
                                  }, {
                                    n: "aria-hidden",
                                    f: "true",
                                    t: 13,
                                    g: 1
                                  }]
                                }]
                              }, " ", {
                                t: 7,
                                e: "ul",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "dropdown-menu",
                                  g: 1
                                }, {
                                  n: "role",
                                  f: "listbox",
                                  t: 13,
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["tracerouteOpts.protocol"],
                                        s: "_0===\"TCP\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"tracerouteOpts.protocol\",\"TCP\")]"
                                    }
                                  }],
                                  f: ["TCP"]
                                }, " ", {
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["tracerouteOpts.protocol"],
                                        s: "_0===\"UDP\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"tracerouteOpts.protocol\",\"UDP\")]"
                                    }
                                  }],
                                  f: ["UDP"]
                                }, " ", {
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["tracerouteOpts.protocol"],
                                        s: "_0===\"ICMP\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"tracerouteOpts.protocol\",\"ICMP\")]"
                                    }
                                  }],
                                  f: ["ICMP"]
                                }]
                              }]
                            }]
                          }]
                        }]
                      }],
                      n: 50,
                      x: {
                        r: ["mainOptions.type"],
                        s: "_0===\"traceroute\""
                      }
                    }, " ", {
                      t: 4,
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "typeDNS",
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "div",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "rows",
                            g: 1
                          }],
                          f: [{
                            t: 7,
                            e: "div",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "rows_row-one",
                              g: 1
                            }],
                            f: [{
                              t: 7,
                              e: "c-controlled-input",
                              m: [{
                                n: "value",
                                f: [{
                                  t: 2,
                                  r: "notAppliedOpts.port"
                                }],
                                t: 13
                              }, {
                                n: "error",
                                f: [{
                                  t: 2,
                                  r: "inputErrors.port"
                                }],
                                t: 13
                              }, {
                                n: "placeholder",
                                f: "53",
                                t: 13,
                                g: 1
                              }, {
                                n: "labelText",
                                f: "Port",
                                t: 13,
                                g: 1
                              }, {
                                n: "classList",
                                f: "port-input gp_input",
                                t: 13,
                                g: 1
                              }],
                              f: []
                            }, " ", {
                              t: 7,
                              e: "div",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "gp_dropdown_reg",
                                g: 1
                              }],
                              f: [{
                                t: 7,
                                e: "span",
                                f: ["Protocol"]
                              }, " ", {
                                t: 7,
                                e: "div",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "btn-group",
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "button",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "dropdown-toggle",
                                    g: 1
                                  }, {
                                    n: "type",
                                    f: "button",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: "data-toggle",
                                    f: "dropdown",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: "aria-haspopup",
                                    f: "true",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: "aria-expanded",
                                    f: "false",
                                    t: 13,
                                    g: 1
                                  }],
                                  f: [{
                                    t: 7,
                                    e: "span",
                                    f: [{
                                      t: 2,
                                      r: "~/dnsOpts.protocol"
                                    }]
                                  }, " ", {
                                    t: 7,
                                    e: "i",
                                    m: [{
                                      t: 13,
                                      n: "class",
                                      f: "fa fa-angle-down",
                                      g: 1
                                    }, {
                                      n: "aria-hidden",
                                      f: "true",
                                      t: 13,
                                      g: 1
                                    }]
                                  }]
                                }, " ", {
                                  t: 7,
                                  e: "ul",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "dropdown-menu",
                                    g: 1
                                  }, {
                                    n: "role",
                                    f: "listbox",
                                    t: 13,
                                    g: 1
                                  }],
                                  f: [{
                                    t: 7,
                                    e: "li",
                                    m: [{
                                      n: "aria-selected",
                                      f: [{
                                        t: 2,
                                        x: {
                                          r: ["dnsOpts.protocol"],
                                          s: "_0===\"UDP\""
                                        }
                                      }],
                                      t: 13
                                    }, {
                                      n: "role",
                                      f: "option",
                                      t: 13,
                                      g: 1
                                    }, {
                                      n: ["click"],
                                      t: 70,
                                      f: {
                                        r: ["@this"],
                                        s: "[_0.set(\"dnsOpts.protocol\",\"UDP\")]"
                                      }
                                    }],
                                    f: ["UDP"]
                                  }, " ", {
                                    t: 7,
                                    e: "li",
                                    m: [{
                                      n: "aria-selected",
                                      f: [{
                                        t: 2,
                                        x: {
                                          r: ["dnsOpts.protocol"],
                                          s: "_0===\"TCP\""
                                        }
                                      }],
                                      t: 13
                                    }, {
                                      n: "role",
                                      f: "option",
                                      t: 13,
                                      g: 1
                                    }, {
                                      n: ["click"],
                                      t: 70,
                                      f: {
                                        r: ["@this"],
                                        s: "[_0.set(\"dnsOpts.protocol\",\"TCP\")]"
                                      }
                                    }],
                                    f: ["TCP"]
                                  }]
                                }]
                              }]
                            }]
                          }, " ", {
                            t: 7,
                            e: "div",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "rows_row-two",
                              g: 1
                            }],
                            f: [{
                              t: 7,
                              e: "div",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "gp_dropdown_reg",
                                g: 1
                              }],
                              f: [{
                                t: 7,
                                e: "span",
                                f: ["Type"]
                              }, " ", {
                                t: 7,
                                e: "div",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "btn-group",
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "button",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "dropdown-toggle",
                                    g: 1
                                  }, {
                                    n: "type",
                                    f: "button",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: "data-toggle",
                                    f: "dropdown",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: "aria-haspopup",
                                    f: "true",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: "aria-expanded",
                                    f: "false",
                                    t: 13,
                                    g: 1
                                  }],
                                  f: [{
                                    t: 7,
                                    e: "span",
                                    f: [{
                                      t: 2,
                                      r: "~/dnsOpts.query.type"
                                    }]
                                  }, " ", {
                                    t: 7,
                                    e: "i",
                                    m: [{
                                      t: 13,
                                      n: "class",
                                      f: "fa fa-angle-down",
                                      g: 1
                                    }, {
                                      n: "aria-hidden",
                                      f: "true",
                                      t: 13,
                                      g: 1
                                    }]
                                  }]
                                }, " ", {
                                  t: 7,
                                  e: "ul",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "dropdown-menu",
                                    g: 1
                                  }, {
                                    n: "role",
                                    f: "listbox",
                                    t: 13,
                                    g: 1
                                  }],
                                  f: [{
                                    t: 4,
                                    f: [{
                                      t: 7,
                                      e: "li",
                                      m: [{
                                        n: "aria-selected",
                                        f: [{
                                          t: 2,
                                          x: {
                                            r: [".", "dnsOpts.query.type"],
                                            s: "_0===_1"
                                          }
                                        }],
                                        t: 13
                                      }, {
                                        n: "role",
                                        f: "option",
                                        t: 13,
                                        g: 1
                                      }, {
                                        n: ["click"],
                                        t: 70,
                                        f: {
                                          r: ["@this", "."],
                                          s: "[_0.set(\"dnsOpts.query.type\",_1)]"
                                        }
                                      }],
                                      f: [{
                                        t: 2,
                                        r: "."
                                      }]
                                    }],
                                    n: 52,
                                    r: "~/dnsTypesList"
                                  }]
                                }]
                              }]
                            }, " ", {
                              t: 7,
                              e: "div",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "rows_row-two_switch-block",
                                g: 1
                              }],
                              f: [{
                                t: 7,
                                e: "label",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "gp_switch",
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "input",
                                  m: [{
                                    n: "type",
                                    f: "checkbox",
                                    t: 13
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this", "dnsOpts.trace"],
                                      s: "[_0.set(\"dnsOpts.trace\",!_1)]"
                                    }
                                  }, {
                                    n: "checked",
                                    f: [{
                                      t: 2,
                                      r: "dnsOpts.trace"
                                    }],
                                    t: 13
                                  }]
                                }, " ", {
                                  t: 7,
                                  e: "span",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "slider round",
                                    g: 1
                                  }]
                                }]
                              }, " ", {
                                t: 7,
                                e: "span",
                                f: ["Trace"]
                              }]
                            }]
                          }]
                        }, " ", {
                          t: 7,
                          e: "c-controlled-input",
                          m: [{
                            n: "value",
                            f: [{
                              t: 2,
                              r: "notAppliedOpts.resolver"
                            }],
                            t: 13
                          }, {
                            n: "error",
                            f: [{
                              t: 2,
                              r: "inputErrors.resolver"
                            }],
                            t: 13
                          }, {
                            n: "placeholder",
                            f: "IP address",
                            t: 13,
                            g: 1
                          }, {
                            n: "labelText",
                            f: "Resolver",
                            t: 13,
                            g: 1
                          }, {
                            n: "classList",
                            f: "resolver-input gp_input",
                            t: 13,
                            g: 1
                          }],
                          f: []
                        }]
                      }],
                      n: 50,
                      x: {
                        r: ["mainOptions.type"],
                        s: "_0===\"DNS\""
                      }
                    }, " ", {
                      t: 4,
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "typeMTR",
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "div",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "pair",
                            g: 1
                          }],
                          f: [{
                            t: 7,
                            e: "c-controlled-input",
                            m: [{
                              n: "value",
                              f: [{
                                t: 2,
                                r: "notAppliedOpts.port"
                              }],
                              t: 13
                            }, {
                              n: "error",
                              f: [{
                                t: 2,
                                r: "inputErrors.port"
                              }],
                              t: 13
                            }, {
                              n: "placeholder",
                              f: "53",
                              t: 13,
                              g: 1
                            }, {
                              n: "labelText",
                              f: "Port",
                              t: 13,
                              g: 1
                            }, {
                              n: "classList",
                              f: "port-input gp_input",
                              t: 13,
                              g: 1
                            }, {
                              n: "disabled",
                              f: [{
                                t: 2,
                                r: "disablePort"
                              }],
                              t: 13
                            }],
                            f: []
                          }, " ", {
                            t: 7,
                            e: "div",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "gp_dropdown_reg",
                              g: 1
                            }],
                            f: [{
                              t: 7,
                              e: "span",
                              f: ["Protocol"]
                            }, " ", {
                              t: 7,
                              e: "div",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "btn-group",
                                g: 1
                              }],
                              f: [{
                                t: 7,
                                e: "button",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "dropdown-toggle",
                                  g: 1
                                }, {
                                  n: "type",
                                  f: "button",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "data-toggle",
                                  f: "dropdown",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "aria-haspopup",
                                  f: "true",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "aria-expanded",
                                  f: "false",
                                  t: 13,
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "span",
                                  f: [{
                                    t: 2,
                                    r: "~/mtrOpts.protocol"
                                  }]
                                }, " ", {
                                  t: 7,
                                  e: "i",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "fa fa-angle-down",
                                    g: 1
                                  }, {
                                    n: "aria-hidden",
                                    f: "true",
                                    t: 13,
                                    g: 1
                                  }]
                                }]
                              }, " ", {
                                t: 7,
                                e: "ul",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "dropdown-menu",
                                  g: 1
                                }, {
                                  n: "role",
                                  f: "listbox",
                                  t: 13,
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["mtrOpts.protocol"],
                                        s: "_0===\"UDP\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"mtrOpts.protocol\",\"UDP\")]"
                                    }
                                  }],
                                  f: ["UDP"]
                                }, " ", {
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["mtrOpts.protocol"],
                                        s: "_0===\"TCP\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"mtrOpts.protocol\",\"TCP\")]"
                                    }
                                  }],
                                  f: ["TCP"]
                                }, " ", {
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["mtrOpts.protocol"],
                                        s: "_0===\"ICMP\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"mtrOpts.protocol\",\"ICMP\")]"
                                    }
                                  }],
                                  f: ["ICMP"]
                                }]
                              }]
                            }]
                          }]
                        }, " ", {
                          t: 7,
                          e: "c-controlled-input",
                          m: [{
                            n: "value",
                            f: [{
                              t: 2,
                              r: "notAppliedOpts.packets"
                            }],
                            t: 13
                          }, {
                            n: "error",
                            f: [{
                              t: 2,
                              r: "inputErrors.packets"
                            }],
                            t: 13
                          }, {
                            n: "placeholder",
                            f: [{
                              t: 2,
                              r: "defaultPacketsAmount"
                            }],
                            t: 13
                          }, {
                            n: "labelText",
                            f: "Packets",
                            t: 13,
                            g: 1
                          }, {
                            n: "classList",
                            f: "gp_input",
                            t: 13,
                            g: 1
                          }],
                          f: []
                        }]
                      }],
                      n: 50,
                      x: {
                        r: ["mainOptions.type"],
                        s: "_0===\"MTR\""
                      }
                    }, " ", {
                      t: 4,
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "typeHTTP",
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "c-controlled-input",
                          m: [{
                            n: "value",
                            f: [{
                              t: 2,
                              r: "notAppliedOpts.request.host"
                            }],
                            t: 13
                          }, {
                            n: "error",
                            f: [{
                              t: 2,
                              r: "inputErrors.host"
                            }],
                            t: 13
                          }, {
                            n: "placeholder",
                            f: "Host",
                            t: 13,
                            g: 1
                          }, {
                            n: "labelText",
                            f: "Host",
                            t: 13,
                            g: 1
                          }, {
                            n: "classList",
                            f: "gp_input",
                            t: 13,
                            g: 1
                          }],
                          f: []
                        }, " ", {
                          t: 7,
                          e: "c-controlled-input",
                          m: [{
                            n: "value",
                            f: [{
                              t: 2,
                              r: "notAppliedOpts.request.path"
                            }],
                            t: 13
                          }, {
                            n: "error",
                            f: [{
                              t: 2,
                              r: "inputErrors.path"
                            }],
                            t: 13
                          }, {
                            n: "placeholder",
                            f: "Path",
                            t: 13,
                            g: 1
                          }, {
                            n: "labelText",
                            f: "Path",
                            t: 13,
                            g: 1
                          }, {
                            n: "classList",
                            f: "gp_input",
                            t: 13,
                            g: 1
                          }],
                          f: []
                        }, " ", {
                          t: 7,
                          e: "c-controlled-input",
                          m: [{
                            n: "value",
                            f: [{
                              t: 2,
                              r: "notAppliedOpts.request.query"
                            }],
                            t: 13
                          }, {
                            n: "error",
                            f: [{
                              t: 2,
                              r: "inputErrors.query"
                            }],
                            t: 13
                          }, {
                            n: "placeholder",
                            f: "Query",
                            t: 13,
                            g: 1
                          }, {
                            n: "labelText",
                            f: "Query",
                            t: 13,
                            g: 1
                          }, {
                            n: "classList",
                            f: "gp_input",
                            t: 13,
                            g: 1
                          }],
                          f: []
                        }, " ", {
                          t: 7,
                          e: "div",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "pair",
                            g: 1
                          }],
                          f: [{
                            t: 7,
                            e: "div",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "gp_dropdown_reg",
                              g: 1
                            }],
                            f: [{
                              t: 7,
                              e: "span",
                              f: ["Protocol"]
                            }, " ", {
                              t: 7,
                              e: "div",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "btn-group",
                                g: 1
                              }],
                              f: [{
                                t: 7,
                                e: "button",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "dropdown-toggle",
                                  g: 1
                                }, {
                                  n: "type",
                                  f: "button",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "data-toggle",
                                  f: "dropdown",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "aria-haspopup",
                                  f: "true",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "aria-expanded",
                                  f: "false",
                                  t: 13,
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "span",
                                  f: [{
                                    t: 2,
                                    r: "~/httpOpts.protocol"
                                  }]
                                }, " ", {
                                  t: 7,
                                  e: "i",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "fa fa-angle-down",
                                    g: 1
                                  }, {
                                    n: "aria-hidden",
                                    f: "true",
                                    t: 13,
                                    g: 1
                                  }]
                                }]
                              }, " ", {
                                t: 7,
                                e: "ul",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "dropdown-menu",
                                  g: 1
                                }, {
                                  n: "role",
                                  f: "listbox",
                                  t: 13,
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["httpOpts.protocol"],
                                        s: "_0===\"HTTP\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"httpOpts.protocol\",\"HTTP\")]"
                                    }
                                  }],
                                  f: ["HTTP"]
                                }, " ", {
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["httpOpts.protocol"],
                                        s: "_0===\"HTTPS\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"httpOpts.protocol\",\"HTTPS\")]"
                                    }
                                  }],
                                  f: ["HTTPS"]
                                }, " ", {
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["httpOpts.protocol"],
                                        s: "_0===\"HTTP2\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"httpOpts.protocol\",\"HTTP2\")]"
                                    }
                                  }],
                                  f: ["HTTP2"]
                                }]
                              }]
                            }]
                          }, " ", {
                            t: 7,
                            e: "c-controlled-input",
                            m: [{
                              n: "value",
                              f: [{
                                t: 2,
                                r: "notAppliedOpts.port"
                              }],
                              t: 13
                            }, {
                              n: "error",
                              f: [{
                                t: 2,
                                r: "inputErrors.port"
                              }],
                              t: 13
                            }, {
                              n: "placeholder",
                              f: "53",
                              t: 13,
                              g: 1
                            }, {
                              n: "labelText",
                              f: "Port",
                              t: 13,
                              g: 1
                            }, {
                              n: "classList",
                              f: "port-input gp_input",
                              t: 13,
                              g: 1
                            }],
                            f: []
                          }]
                        }, " ", {
                          t: 7,
                          e: "div",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "pair",
                            g: 1
                          }],
                          f: [{
                            t: 7,
                            e: "div",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "gp_dropdown_reg",
                              g: 1
                            }],
                            f: [{
                              t: 7,
                              e: "span",
                              f: ["Method"]
                            }, " ", {
                              t: 7,
                              e: "div",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "btn-group",
                                g: 1
                              }],
                              f: [{
                                t: 7,
                                e: "button",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "dropdown-toggle",
                                  g: 1
                                }, {
                                  n: "type",
                                  f: "button",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "data-toggle",
                                  f: "dropdown",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "aria-haspopup",
                                  f: "true",
                                  t: 13,
                                  g: 1
                                }, {
                                  n: "aria-expanded",
                                  f: "false",
                                  t: 13,
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "span",
                                  f: [{
                                    t: 2,
                                    r: "~/httpOpts.request.method"
                                  }]
                                }, " ", {
                                  t: 7,
                                  e: "i",
                                  m: [{
                                    t: 13,
                                    n: "class",
                                    f: "fa fa-angle-down",
                                    g: 1
                                  }, {
                                    n: "aria-hidden",
                                    f: "true",
                                    t: 13,
                                    g: 1
                                  }]
                                }]
                              }, " ", {
                                t: 7,
                                e: "ul",
                                m: [{
                                  t: 13,
                                  n: "class",
                                  f: "dropdown-menu",
                                  g: 1
                                }, {
                                  n: "role",
                                  f: "listbox",
                                  t: 13,
                                  g: 1
                                }],
                                f: [{
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["httpOpts.request.method"],
                                        s: "_0===\"GET\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"httpOpts.request.method\",\"GET\")]"
                                    }
                                  }],
                                  f: ["GET"]
                                }, " ", {
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["httpOpts.request.method"],
                                        s: "_0===\"HEAD\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"httpOpts.request.method\",\"HEAD\")]"
                                    }
                                  }],
                                  f: ["HEAD"]
                                }, " ", {
                                  t: 7,
                                  e: "li",
                                  m: [{
                                    n: "aria-selected",
                                    f: [{
                                      t: 2,
                                      x: {
                                        r: ["httpOpts.request.method"],
                                        s: "_0===\"OPTIONS\""
                                      }
                                    }],
                                    t: 13
                                  }, {
                                    n: "role",
                                    f: "option",
                                    t: 13,
                                    g: 1
                                  }, {
                                    n: ["click"],
                                    t: 70,
                                    f: {
                                      r: ["@this"],
                                      s: "[_0.set(\"httpOpts.request.method\",\"OPTIONS\")]"
                                    }
                                  }],
                                  f: ["OPTIONS"]
                                }]
                              }]
                            }]
                          }, " ", {
                            t: 7,
                            e: "c-controlled-input",
                            m: [{
                              n: "value",
                              f: [{
                                t: 2,
                                r: "notAppliedOpts.resolver"
                              }],
                              t: 13
                            }, {
                              n: "error",
                              f: [{
                                t: 2,
                                r: "inputErrors.resolver"
                              }],
                              t: 13
                            }, {
                              n: "placeholder",
                              f: "Resolver",
                              t: 13,
                              g: 1
                            }, {
                              n: "labelText",
                              f: "Resolver",
                              t: 13,
                              g: 1
                            }, {
                              n: "classList",
                              f: "gp_input",
                              t: 13,
                              g: 1
                            }],
                            f: []
                          }]
                        }, " ", {
                          t: 7,
                          e: "c-controlled-textarea",
                          m: [{
                            n: "value",
                            f: [{
                              t: 2,
                              r: "notAppliedOpts.request.headers"
                            }],
                            t: 13
                          }, {
                            n: "error",
                            f: [{
                              t: 2,
                              r: "inputErrors.headers"
                            }],
                            t: 13
                          }, {
                            n: "placeholder",
                            f: "Header: Value",
                            t: 13,
                            g: 1
                          }, {
                            n: "labelText",
                            f: "Headers",
                            t: 13,
                            g: 1
                          }, {
                            n: "classList",
                            f: "gp_input",
                            t: 13,
                            g: 1
                          }],
                          f: []
                        }]
                      }],
                      n: 50,
                      x: {
                        r: ["mainOptions.type"],
                        s: "_0===\"HTTP\""
                      }
                    }, " ", {
                      t: 7,
                      e: "button",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "gp_btn_green",
                        g: 1
                      }, {
                        n: ["click"],
                        t: 70,
                        f: {
                          r: ["@this"],
                          s: "[_0.applyOptions()]"
                        }
                      }],
                      f: ["Apply"]
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "div",
                  m: [{
                    n: "class",
                    f: ["gp_map-block_settings-wrapper_settings_subgroup_switch-block ", {
                      t: 4,
                      f: ["turned-off"],
                      n: 51,
                      x: {
                        r: ["@this"],
                        s: "_0.isInfiniteOptsCorrect()"
                      }
                    }, " ", {
                      t: 4,
                      f: ["disabled"],
                      n: 50,
                      r: "testInProgress"
                    }],
                    t: 13
                  }],
                  f: [{
                    t: 7,
                    e: "label",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp_switch",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "input",
                      m: [{
                        n: "type",
                        f: "checkbox",
                        t: 13
                      }, {
                        n: "checked",
                        f: [{
                          t: 2,
                          r: "infiniteSwitchEnabled"
                        }],
                        t: 13
                      }, {
                        n: ["click"],
                        t: 70,
                        f: {
                          r: ["@this"],
                          s: "[_0.handleInfiniteSwitch()]"
                        }
                      }, {
                        n: ["keydown"],
                        t: 70,
                        f: {
                          r: ["@this", "@event"],
                          s: "[_0.handleInfiniteSwitchKeyDown(_1)]"
                        }
                      }, {
                        t: 4,
                        f: [{
                          n: "disabled",
                          f: "true",
                          t: 13
                        }],
                        n: 51,
                        x: {
                          r: ["@this", "testInProgress"],
                          s: "_0.isInfiniteOptsCorrect()&&!_1"
                        }
                      }]
                    }, " ", {
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "slider round",
                        g: 1
                      }]
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    f: ["Infinite"]
                  }]
                }]
              }]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "btn-group run-test-btn",
              g: 1
            }, {
              n: "id",
              f: "dd-run-test-btn",
              t: 13,
              g: 1
            }],
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_map-block_settings-wrapper_split-btn",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "button",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp_map-block_settings-wrapper_split-btn_run gp_btn_green",
                    g: 1
                  }, {
                    n: "disabled",
                    f: [{
                      t: 2,
                      r: "runTestBtnDisabled"
                    }],
                    t: 13
                  }, {
                    n: ["click"],
                    t: 70,
                    f: {
                      r: ["@this"],
                      s: "[_0.handleRunTestBtn()]"
                    }
                  }],
                  f: ["Run"]
                }, " ", {
                  t: 7,
                  e: "button",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "dropdown-toggle gp_btn_green",
                    g: 1
                  }, {
                    n: "type",
                    f: "button",
                    t: 13,
                    g: 1
                  }, {
                    n: "data-toggle",
                    f: "dropdown",
                    t: 13,
                    g: 1
                  }, {
                    n: "aria-haspopup",
                    f: "true",
                    t: 13,
                    g: 1
                  }, {
                    n: "aria-expanded",
                    f: "false",
                    t: 13,
                    g: 1
                  }, {
                    n: "disabled",
                    f: [{
                      t: 2,
                      r: "runTestBtnDisabled"
                    }],
                    t: 13
                  }],
                  f: [{
                    t: 7,
                    e: "div",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp_map-block_settings-wrapper_split-btn_icon",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "width",
                        f: "20",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "20",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/chevron-down.white.svg"],
                        t: 13
                      }]
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "dropdown-menu gp_map-block_settings-wrapper_split-btn_dropdown",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "button",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "dropdown-item",
                      g: 1
                    }, {
                      n: "type",
                      f: "button",
                      t: 13,
                      g: 1
                    }, {
                      n: ["click"],
                      t: 70,
                      f: {
                        r: ["@this"],
                        s: "[_0.reUseProbesRunTest()]"
                      }
                    }],
                    f: ["Re-use probes"]
                  }]
                }]
              }],
              n: 50,
              x: {
                r: ["prevProbesMeasId", "testInProgress"],
                s: "_0&&!_1"
              }
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "button",
                m: [{
                  n: ["click"],
                  t: 70,
                  f: {
                    r: ["@this"],
                    s: "[_0.handleRunTestBtn()]"
                  }
                }, {
                  n: "class",
                  f: ["gp_map-block_settings-wrapper_btn ", {
                    t: 4,
                    f: ["gp_btn_green"],
                    n: 50,
                    x: {
                      r: ["testInProgress"],
                      s: "!_0"
                    }
                  }, {
                    t: 4,
                    f: ["gp_btn_black gp_btn_black_loading"],
                    n: 51,
                    l: 1
                  }, " ", {
                    t: 4,
                    f: ["gp_btn_green_disabled"],
                    n: 50,
                    x: {
                      r: ["testInProgress", "gmapsReady"],
                      s: "!_0&&!_1"
                    }
                  }],
                  t: 13
                }, {
                  n: "data-testid",
                  f: "run-test-btn",
                  t: 13,
                  g: 1
                }, {
                  n: "disabled",
                  f: [{
                    t: 2,
                    r: "runTestBtnDisabled"
                  }],
                  t: 13
                }],
                f: [{
                  t: 4,
                  f: [{
                    t: 7,
                    e: "span",
                    f: ["Stop"]
                  }, " ", {
                    t: 7,
                    e: "div",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "spinner",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "div"
                    }, " ", {
                      t: 7,
                      e: "div"
                    }, " ", {
                      t: 7,
                      e: "div"
                    }, " ", {
                      t: 7,
                      e: "div"
                    }]
                  }],
                  n: 50,
                  r: "testInProgress"
                }, {
                  t: 4,
                  f: [{
                    t: 2,
                    r: "runTestBtnText"
                  }],
                  n: 51,
                  l: 1
                }]
              }],
              n: 51,
              l: 1
            }]
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "c-gp-credits-message",
            m: [{
              n: "measurementErrMsg",
              f: [{
                t: 2,
                r: "measurementErrMsg"
              }],
              t: 13
            }, {
              n: "rateCreditsData",
              f: [{
                t: 2,
                r: "rateCreditsData"
              }],
              t: 13
            }],
            f: []
          }],
          n: 50,
          x: {
            r: ["showCreditsErrorBar", "focusModeActive", "focusModeAvailable"],
            s: "_0&&(_1||!_2)"
          }
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "p",
            m: [{
              t: 13,
              n: "class",
              f: "gp_map-block_test-details",
              g: 1
            }],
            f: [{
              t: 7,
              e: "i",
              m: [{
                t: 13,
                n: "class",
                f: "fa fa-info-circle",
                g: 1
              }, {
                n: "aria-hidden",
                f: "true",
                t: 13,
                g: 1
              }]
            }, " Showing ", {
              t: 7,
              e: "strong",
              f: [{
                t: 2,
                r: "mobileShareResHeaderData.type"
              }]
            }, " test results for ", {
              t: 7,
              e: "strong",
              f: [{
                t: 2,
                r: "mobileShareResHeaderData.target"
              }]
            }, " from ", {
              t: 2,
              r: "mobileShareResHeaderData.date"
            }, "."]
          }],
          n: 50,
          r: "mobileShareResHeaderData"
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            n: "class",
            f: ["gp_map-block_map-wrapper ", {
              t: 4,
              f: ["transition-none"],
              n: 51,
              r: "transitionMap"
            }, " ", {
              t: 4,
              f: ["gp_map-block_map-wrapper_hidden"],
              n: 51,
              x: {
                r: ["showMap", "focusModeActive"],
                s: "_0||!_1"
              }
            }],
            t: 13
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_map-block_map-wrapper_map",
              g: 1
            }, {
              n: "id",
              f: "gp-map",
              t: 13,
              g: 1
            }]
          }, " ", {
            t: 4,
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp_map-block_map-wrapper_timings-scale",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "value",
                  g: 1
                }],
                f: [{
                  t: 2,
                  r: "probesMaxTiming"
                }, " ms"]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gradient",
                  g: 1
                }]
              }, " ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "value",
                  g: 1
                }],
                f: [{
                  t: 2,
                  r: "probesMinTiming"
                }, " ms"]
              }]
            }],
            n: 50,
            r: "testResults"
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "c-gp-credits",
            m: [{
              n: "mapOpened",
              f: [{
                t: 2,
                r: "showMap"
              }],
              t: 13
            }, {
              n: "testInProgress",
              f: [{
                t: 2,
                r: "testInProgress"
              }],
              t: 13
            }, {
              n: "isInfiniteModeRes",
              f: [{
                t: 2,
                r: "isInfiniteModeRes"
              }],
              t: 13
            }, {
              n: "rateCreditsData",
              f: [{
                t: 2,
                r: "rateCreditsData"
              }],
              t: 13
            }, {
              n: "testResults",
              f: [{
                t: 2,
                r: "testResults"
              }],
              t: 13
            }],
            f: []
          }],
          n: 50,
          x: {
            r: ["showCreditsData", "focusModeActive", "focusModeAvailable"],
            s: "_0&&(_1||!_2)"
          }
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_map-block_test-output gp_map-block_test-output_stack",
            g: 1
          }],
          f: [{
            t: 4,
            f: [{
              t: 7,
              e: "div",
              m: [{
                n: "class",
                f: ["gp_map-block_test-output with-padding ", {
                  t: 4,
                  f: ["gp_map-block_test-output_prompt-overlay"],
                  n: 50,
                  x: {
                    r: ["focusModeTransition"],
                    s: "_0===\"opening\""
                  }
                }],
                t: 13
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  n: "class",
                  f: ["gp_map-block_test-output_info gp_map-block_test-output_focus-prompt ", {
                    t: 4,
                    f: ["gp_map-block_test-output_focus-prompt_exiting"],
                    n: 50,
                    x: {
                      r: ["focusModeTransition"],
                      s: "_0===\"opening\""
                    }
                  }, {
                    t: 4,
                    f: ["gp_map-block_test-output_focus-prompt_entering"],
                    n: 50,
                    x: {
                      r: ["focusModeTransition"],
                      s: "_0===\"prompt-entering\""
                    },
                    l: 1
                  }],
                  t: 13
                }],
                f: [{
                  t: 7,
                  e: "i",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "fa fa-line-chart",
                    g: 1
                  }, {
                    n: "aria-hidden",
                    f: "true",
                    t: 13,
                    g: 1
                  }]
                }, " ", {
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp_map-block_test-output_focus-prompt_text",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "strong",
                    f: [{
                      t: 2,
                      r: "focusModePromptStatus.title"
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    f: [{
                      t: 3,
                      r: "focusModePromptStatus.description"
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "button",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp_btn_green gp_focus-mode-toggle",
                    g: 1
                  }, {
                    n: "type",
                    f: "button",
                    t: 13,
                    g: 1
                  }, {
                    n: "aria-label",
                    f: "Open measurement focus mode",
                    t: 13,
                    g: 1
                  }, {
                    n: ["click"],
                    t: 70,
                    f: {
                      r: ["@this", "@event"],
                      s: "[_0.openFocusMode(_1)]"
                    }
                  }],
                  f: [{
                    t: 7,
                    e: "i",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "fa fa-expand",
                      g: 1
                    }, {
                      n: "aria-hidden",
                      f: "true",
                      t: 13,
                      g: 1
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    f: ["Open focus mode"]
                  }]
                }]
              }]
            }],
            n: 50,
            x: {
              r: ["focusModeAvailable", "focusModeActive", "focusModeTransition", "focusModeResultsPreviewAvailable"],
              s: "_0&&(!_1||_2===\"opening\")&&!_3"
            }
          }, " ", {
            t: 4,
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  n: "class",
                  f: ["gp_map-block_test-output gp_map-block_test-output_focused-content ", {
                    t: 4,
                    f: ["gp_map-block_test-output_focused-content_leaving"],
                    n: 50,
                    x: {
                      r: ["focusModeTransition"],
                      s: "_0===\"content-leaving\""
                    }
                  }, " with-padding"],
                  t: 13
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp_map-block_test-output_fail-msg",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "width",
                      f: "56",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "56",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/fail-icon-big.svg"],
                      t: 13
                    }]
                  }, " ", {
                    t: 7,
                    e: "p",
                    f: [{
                      t: 3,
                      r: "measurementErrMsg"
                    }]
                  }]
                }]
              }],
              n: 50,
              x: {
                r: ["measurementErrMsg", "showCreditsErrorBar"],
                s: "_0&&!_1"
              }
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  n: "class",
                  f: ["gp_map-block_test-output gp_map-block_test-output_focused-content ", {
                    t: 4,
                    f: ["gp_map-block_test-output_results-preview ", {
                      t: 4,
                      f: ["gp_map-block_test-output_results-preview_entering"],
                      n: 50,
                      x: {
                        r: ["focusModeTransition"],
                        s: "_0===\"prompt-entering\""
                      }
                    }],
                    n: 50,
                    x: {
                      r: ["focusModeResultsPreviewAvailable", "focusModeActive", "focusModeTransition"],
                      s: "_0&&!_1&&_2!==\"content-leaving\""
                    }
                  }, {
                    t: 4,
                    f: ["gp_map-block_test-output_results-preview_expanding"],
                    n: 50,
                    x: {
                      r: ["focusModeResultsPreviewAvailable", "focusModeTransition"],
                      s: "_0&&_1===\"opening\""
                    },
                    l: 1
                  }, {
                    t: 4,
                    f: ["gp_map-block_test-output_results-preview_expanded"],
                    n: 50,
                    x: {
                      r: ["focusModeResultsPreviewAvailable", "focusModeActive"],
                      s: "_0&&_1"
                    },
                    l: 1
                  }, {
                    t: 4,
                    f: ["gp_map-block_test-output_focused-content_leaving"],
                    n: 50,
                    x: {
                      r: ["focusModeTransition"],
                      s: "_0===\"content-leaving\""
                    },
                    l: 1
                  }],
                  t: 13
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp_map-block_test-output_results-preview-content",
                    g: 1
                  }, {
                    t: 4,
                    f: [{
                      n: "inert",
                      f: 0,
                      t: 13
                    }, {
                      n: "aria-hidden",
                      f: "true",
                      t: 13
                    }],
                    n: 50,
                    x: {
                      r: ["focusModeResultsPreviewAvailable", "focusModeActive", "focusModeTransition"],
                      s: "_0&&!_1&&_2!==\"content-leaving\""
                    }
                  }],
                  f: [{
                    t: 7,
                    e: "c-gp-results-controls",
                    m: [{
                      n: "showMap",
                      f: [{
                        t: 2,
                        r: "showMap"
                      }],
                      t: 13
                    }, {
                      n: "originalShowMap",
                      f: [{
                        t: 2,
                        r: "originalShowMap"
                      }],
                      t: 13
                    }, {
                      n: "targets",
                      f: [{
                        t: 2,
                        r: "targetsArr"
                      }],
                      t: 13
                    }, {
                      n: "activeTargetIdx",
                      f: [{
                        t: 2,
                        r: "activeTargetIdx"
                      }],
                      t: 13
                    }, {
                      n: "rawOutputMode",
                      f: [{
                        t: 2,
                        r: "rawOutputMode"
                      }],
                      t: 13
                    }, {
                      n: "collapseOutput",
                      f: [{
                        t: 2,
                        r: "@this.collapseAllRawOutput"
                      }],
                      t: 13
                    }, {
                      n: "expandOutput",
                      f: [{
                        t: 2,
                        r: "@this.expandAllRawOutput"
                      }],
                      t: 13
                    }, {
                      n: "allCollapsed",
                      f: [{
                        t: 2,
                        r: "allCollapsed"
                      }],
                      t: 13
                    }, {
                      n: "testType",
                      f: [{
                        t: 2,
                        r: "testReqParams.type"
                      }],
                      t: 13
                    }, {
                      n: "sortOrder",
                      f: [{
                        t: 2,
                        r: "sortOrder"
                      }],
                      t: 13
                    }, {
                      n: "sortBy",
                      f: [{
                        t: 2,
                        r: "sortBy"
                      }],
                      t: 13
                    }, {
                      n: "sortByOpts",
                      f: [{
                        t: 2,
                        r: "sortByOpts"
                      }],
                      t: 13
                    }],
                    f: []
                  }, " ", {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "gp_map-block_test-output_raw-output",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "c-gp-results-raw-output",
                        m: [{
                          n: "testReqParams",
                          f: [{
                            t: 2,
                            r: "testReqParams"
                          }],
                          t: 13
                        }, {
                          n: "preparedTestResults",
                          f: [{
                            t: 2,
                            r: "preparedTestResults"
                          }],
                          t: 13
                        }, {
                          n: "hiddenTestResults",
                          f: [{
                            t: 2,
                            r: "hiddenTestResults"
                          }],
                          t: 13
                        }, {
                          n: "hiddenResponseBodies",
                          f: [{
                            t: 2,
                            r: "hiddenResponseBodies"
                          }],
                          t: 13
                        }, {
                          n: "testInProgress",
                          f: [{
                            t: 2,
                            r: "testInProgress"
                          }],
                          t: 13
                        }, {
                          n: "scrolledToResId",
                          f: [{
                            t: 2,
                            r: "scrolledToResId"
                          }],
                          t: 13
                        }, {
                          n: "currSearchLocation",
                          f: [{
                            t: 2,
                            r: "mainOptions.location"
                          }],
                          t: 13
                        }, {
                          n: "activeTargetIdx",
                          f: [{
                            t: 2,
                            r: "activeTargetIdx"
                          }],
                          t: 13
                        }, {
                          n: "isInfiniteModeRes",
                          f: [{
                            t: 2,
                            r: "isInfiniteModeRes"
                          }],
                          t: 13
                        }, {
                          n: "screenWidth",
                          f: [{
                            t: 2,
                            r: "screenWidth"
                          }],
                          t: 13
                        }, {
                          n: "sortOrder",
                          f: [{
                            t: 2,
                            r: "sortOrder"
                          }],
                          t: 13
                        }, {
                          n: "sortBy",
                          f: [{
                            t: 2,
                            r: "sortBy"
                          }],
                          t: 13
                        }, {
                          n: "showingNetworkLogos",
                          f: [{
                            t: 2,
                            r: "showingNetworkLogos"
                          }],
                          t: 13
                        }, {
                          n: "responseBodyCharWidth",
                          f: [{
                            t: 2,
                            r: "responseBodyCharWidth"
                          }],
                          t: 13
                        }, {
                          n: "expandedListWidth",
                          f: [{
                            t: 2,
                            r: "rawOutputExpandedListWidth"
                          }],
                          t: 13
                        }, {
                          n: "limitLayoutToFirstResult",
                          f: [{
                            t: 2,
                            x: {
                              r: ["focusModeResultsPreviewAvailable", "focusModeActive"],
                              s: "_0&&!_1"
                            }
                          }],
                          t: 13
                        }, {
                          n: "loadingProbeResults",
                          f: [{
                            t: 2,
                            x: {
                              r: ["focusModeSupported", "remainingLoadingProbeResults"],
                              s: "_0?_1:[]"
                            }
                          }],
                          t: 13
                        }, {
                          n: "expandAllRawOutput",
                          f: [{
                            t: 2,
                            r: "@this.expandAllRawOutput"
                          }],
                          t: 13
                        }],
                        f: []
                      }]
                    }],
                    n: 50,
                    r: "rawOutputMode"
                  }, {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "gp_map-block_test-output_table-output",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "c-gp-results-table-output",
                        m: [{
                          n: "testInProgress",
                          f: [{
                            t: 2,
                            r: "testInProgress"
                          }],
                          t: 13
                        }, {
                          n: "preparedTestResults",
                          f: [{
                            t: 2,
                            r: "preparedTestResults"
                          }],
                          t: 13
                        }, {
                          n: "loadingProbeResults",
                          f: [{
                            t: 2,
                            x: {
                              r: ["focusModeSupported", "remainingLoadingProbeResults"],
                              s: "_0?_1:[]"
                            }
                          }],
                          t: 13
                        }, {
                          n: "targets",
                          f: [{
                            t: 2,
                            r: "targetsArr"
                          }],
                          t: 13
                        }, {
                          n: "targetsCnt",
                          f: [{
                            t: 2,
                            r: "targetsArr.length"
                          }],
                          t: 13
                        }, {
                          n: "currSearchLocation",
                          f: [{
                            t: 2,
                            r: "mainOptions.location"
                          }],
                          t: 13
                        }, {
                          n: "isInfiniteModeRes",
                          f: [{
                            t: 2,
                            r: "isInfiniteModeRes"
                          }],
                          t: 13
                        }, {
                          n: "sortOrder",
                          f: [{
                            t: 2,
                            r: "sortOrder"
                          }],
                          t: 13
                        }, {
                          n: "sortBy",
                          f: [{
                            t: 2,
                            r: "sortBy"
                          }],
                          t: 13
                        }],
                        f: []
                      }]
                    }],
                    n: 51,
                    l: 1
                  }, " ", {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "c-gp-results-share",
                      m: [{
                        n: "testReqParams",
                        f: [{
                          t: 2,
                          r: "testReqParams"
                        }],
                        t: 13
                      }, {
                        n: "measurementsMetadata",
                        f: [{
                          t: 2,
                          r: "measurementsMetadata"
                        }],
                        t: 13
                      }, {
                        n: "isInfiniteModeRes",
                        f: [{
                          t: 2,
                          r: "isInfiniteModeRes"
                        }],
                        t: 13
                      }, {
                        n: "testInProgress",
                        f: [{
                          t: 2,
                          r: "testInProgress"
                        }],
                        t: 13
                      }, {
                        n: "preparedTestResults",
                        f: [{
                          t: 2,
                          r: "preparedTestResults"
                        }],
                        t: 13
                      }, {
                        n: "activeTargetIdx",
                        f: [{
                          t: 2,
                          r: "activeTargetIdx"
                        }],
                        t: 13
                      }, {
                        n: "showLogoDevAttribution",
                        f: [{
                          t: 2,
                          x: {
                            r: ["rawOutputMode", "showingNetworkLogos"],
                            s: "_0&&_1"
                          }
                        }],
                        t: 13
                      }],
                      f: []
                    }],
                    n: 50,
                    x: {
                      r: ["testReqParams.id", "testInProgress", "focusModeActive", "focusModeAvailable"],
                      s: "_0&&!_1&&(_2||!_3)"
                    }
                  }]
                }, " ", {
                  t: 4,
                  f: [{
                    t: 7,
                    e: "div",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp_map-block_test-output_results-preview-action",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "button",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "gp_map-block_test-output_results-preview-action_button gp_focus-mode-toggle",
                        g: 1
                      }, {
                        n: "type",
                        f: "button",
                        t: 13,
                        g: 1
                      }, {
                        n: ["click"],
                        t: 70,
                        f: {
                          r: ["@this", "@event"],
                          s: "[_0.openFocusMode(_1)]"
                        }
                      }],
                      f: [{
                        t: 7,
                        e: "i",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "fa fa-expand",
                          g: 1
                        }, {
                          n: "aria-hidden",
                          f: "true",
                          t: 13,
                          g: 1
                        }]
                      }, " View results"]
                    }]
                  }],
                  n: 50,
                  x: {
                    r: ["focusModeResultsPreviewAvailable", "focusModeActive", "focusModeTransition"],
                    s: "_0&&!_1&&_2!==\"content-leaving\""
                  }
                }]
              }, " "],
              n: 50,
              x: {
                r: ["testResults", "rawOutputMode", "tableOutputReady", "focusModeSupported", "testInProgress", "remainingLoadingProbeResults.length"],
                s: "(_0&&(_1||_2))||(_3&&_4&&_5)"
              },
              l: 1
            }, {
              t: 4,
              f: [" ", {
                t: 7,
                e: "div",
                m: [{
                  n: "class",
                  f: ["gp_map-block_test-output gp_map-block_test-output_focused-content ", {
                    t: 4,
                    f: ["gp_map-block_test-output_focused-content_leaving"],
                    n: 50,
                    x: {
                      r: ["focusModeTransition"],
                      s: "_0===\"content-leaving\""
                    }
                  }, " with-padding"],
                  t: 13
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp_map-block_test-output_info",
                    g: 1
                  }],
                  f: [{
                    t: 4,
                    f: [{
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "gp_map-block_test-output_info_text gp_map-block_test-output_info_text_entering",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "img",
                        m: [{
                          n: "width",
                          f: "56",
                          t: 13,
                          g: 1
                        }, {
                          n: "height",
                          f: "56",
                          t: 13,
                          g: 1
                        }, {
                          n: "src",
                          f: [{
                            t: 2,
                            r: "@shared.assetsHost"
                          }, "/img/bulb-icon.svg"],
                          t: 13
                        }]
                      }, " ", {
                        t: 7,
                        e: "p",
                        f: [{
                          t: 4,
                          f: ["Measurement loading..."],
                          n: 50,
                          r: "shareResFlow"
                        }, {
                          t: 4,
                          f: ["Measurement started"],
                          n: 51,
                          l: 1
                        }]
                      }]
                    }],
                    n: 50,
                    r: "showMeasurementLoadingInfo"
                  }]
                }]
              }, " "],
              n: 50,
              x: {
                r: ["@this"],
                s: "_0.shouldShowMeasurementLoadingInfo()"
              },
              l: 1
            }, {
              t: 4,
              f: [" ", {
                t: 7,
                e: "div",
                m: [{
                  n: "class",
                  f: ["gp_map-block_test-output gp_map-block_test-output_focused-content ", {
                    t: 4,
                    f: ["gp_map-block_test-output_focused-content_leaving"],
                    n: 50,
                    x: {
                      r: ["focusModeTransition"],
                      s: "_0===\"content-leaving\""
                    }
                  }, " with-padding"],
                  t: 13
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp_map-block_test-output_info",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "div",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp_map-block_test-output_info_text",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "width",
                        f: "56",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "56",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/bulb-icon.svg"],
                        t: 13
                      }]
                    }, " ", {
                      t: 7,
                      e: "p",
                      f: ["Run a global latency test! Benchmark your CDN provider and understand how the network performs! Compare DNS providers to find the fastest one globally or in your region. Run network tests globally or from specific locations and regions. Debug and troubleshoot your networking problems and share the test results with others!"]
                    }]
                  }, " ", {
                    t: 7,
                    e: "c-test-examples",
                    m: [{
                      n: "onExampleClick",
                      f: [{
                        t: 2,
                        r: "@this.onExampleClick"
                      }],
                      t: 13
                    }]
                  }]
                }]
              }],
              n: 51,
              l: 1
            }],
            n: 50,
            x: {
              r: ["focusModeAvailable", "focusModeActive", "focusModeTransition", "focusModeResultsPreviewAvailable"],
              s: "!_0||_1||_2===\"content-leaving\"||_3"
            }
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp_details",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_details_platform",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_details_platform_title",
              g: 1
            }],
            f: ["The Globalping platform"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_details_platform_descr",
              g: 1
            }],
            f: ["Globalping is a platform that allows anyone to run networking commands such as ping, traceroute, dig, curl and mtr on probes distributed all around the world. Our goal is to provide a free and simple service for everyone out there to make the internet faster. You can use it to optimize your anycast network, monitor your latency, debug routing issues and even check for censorship in different countries."]
          }, " ", {
            t: 7,
            e: "img",
            m: [{
              t: 13,
              n: "class",
              f: "gp_details_platform_img",
              g: 1
            }, {
              n: "width",
              f: "363",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "288",
              t: 13,
              g: 1
            }, {
              n: "alt",
              f: "",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/polygons_1.svg"],
              t: 13
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_details_magic",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_details_magic_title",
              g: 1
            }],
            f: ["Test from anywhere with ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "text-magic-color",
                g: 1
              }],
              f: ["magic"]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_details_magic_descr",
              g: 1
            }],
            f: ["All Globalping integrations and tools including the CLI ", {
              t: 7,
              e: "a",
              m: [{
                n: "target",
                f: "_blank",
                t: 13,
                g: 1
              }, {
                n: "rel",
                f: "noreferrer",
                t: 13,
                g: 1
              }, {
                n: "href",
                f: "https://github.com/jsdelivr/globalping#best-practices-and-tips",
                t: 13,
                g: 1
              }],
              f: ["use the magic API field"]
            }, " to set the location of a test. This means that you can write anything that makes sense to you as the input and we will do our best to select the most appropriate probes. Valid inputs include countries, continents, cities, US states, regions (Western Europe), ASNs, ISP names, eyeball or datacenter tags and cloud region names (us-east-2)."]
          }, " ", {
            t: 7,
            e: "img",
            m: [{
              t: 13,
              n: "class",
              f: "gp_details_magic_img",
              g: 1
            }, {
              n: "width",
              f: "510",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "289",
              t: 13,
              g: 1
            }, {
              n: "alt",
              f: "",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/polygons_2.svg"],
              t: 13
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "section",
        m: [{
          t: 13,
          n: "class",
          f: "gp_integrations",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_integrations_content",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_integrations_background-container",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                t: 13,
                n: "class",
                f: "gp_integrations_background",
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/polygons_5.svg"],
                t: 13
              }, {
                n: "alt",
                f: "",
                t: 13,
                g: 1
              }]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_integrations_main",
              g: 1
            }],
            f: [{
              t: 7,
              e: "h4",
              m: [{
                t: 13,
                n: "class",
                f: "gp_integrations_header",
                g: 1
              }],
              f: ["Integrations"]
            }, " ", {
              t: 7,
              e: "p",
              m: [{
                t: 13,
                n: "class",
                f: "gp_integrations_description",
                g: 1
              }],
              f: ["A fully-featured REST API for your own app, easy-to-use CLI for scripting, or a no-code chatbot – we have it all. Integrate Globalping into anything!"]
            }, " ", {
              t: 7,
              e: "a",
              m: [{
                t: 13,
                n: "class",
                f: "gp_integrations_link",
                g: 1
              }, {
                n: "href",
                f: "/integrations",
                t: 13,
                g: 1
              }],
              f: ["Check our integrations"]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_integrations_examples",
              g: 1
            }],
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_integrations_example",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "img",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp_integrations_example_logo",
                    g: 1
                  }, {
                    n: "src",
                    f: [{
                      t: 2,
                      r: "@shared.assetsHost"
                    }, {
                      t: 2,
                      r: "./img"
                    }],
                    t: 13
                  }, {
                    n: "height",
                    f: "48",
                    t: 13,
                    g: 1
                  }, {
                    n: "width",
                    f: "48",
                    t: 13,
                    g: 1
                  }, {
                    n: "alt",
                    f: "",
                    t: 13,
                    g: 1
                  }]
                }, " ", {
                  t: 7,
                  e: "div",
                  f: [{
                    t: 7,
                    e: "h5",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp_integrations_example_header",
                      g: 1
                    }],
                    f: [{
                      t: 2,
                      r: "./name"
                    }]
                  }, " ", {
                    t: 7,
                    e: "p",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp_integrations_example_description",
                      g: 1
                    }],
                    f: [{
                      t: 2,
                      r: "./description"
                    }]
                  }]
                }]
              }],
              n: 52,
              r: "integrationExamples"
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp_features",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_features_item",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_icon",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "48",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "48",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/globalping-opensource-icon.svg"],
                t: 13
              }]
            }]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_name",
              g: 1
            }],
            f: ["Open source and free"]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_descr",
              g: 1
            }],
            f: ["Every component of Globalping is open source and is being actively developed on GitHub with the help of our community and users. We offer generous free limits with higher limits for GitHub Sponsors."]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_features_item",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_icon",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "48",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "48",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/globalping-nonprofit-icon.svg"],
                t: 13
              }]
            }]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_name",
              g: 1
            }],
            f: ["Developed by jsDelivr"]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_descr",
              g: 1
            }],
            f: ["The Globalping platform is developed by the jsDelivr team who has more than 10 years of experience maintaining the jsDelivr CDN which is being used by millions of websites around the globe."]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_features_item",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_icon",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "48",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "48",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/globalping-community-icon.svg"],
                t: 13
              }]
            }]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_name",
              g: 1
            }],
            f: ["Powered by community and sponsors"]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_descr",
              g: 1
            }],
            f: ["The jsDelivr organization and all projects including Globalping rely on our corporate and individual sponsors. Consider joining them to help us release new features even faster!"]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_features_item",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_icon",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "48",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "48",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/globalping-security-icon.svg"],
                t: 13
              }]
            }]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_name",
              g: 1
            }],
            f: ["Secure and private"]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_features_item_descr",
              g: 1
            }],
            f: ["The security of our systems and privacy of our users are of the utmost importance for us. We minimize the public information that our probes expose and block harmful and abusive domains and IPs."]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp_installation",
          g: 1
        }],
        f: [{
          t: 7,
          e: "a",
          m: [{
            t: 13,
            n: "class",
            f: "gp_installation_item",
            g: 1
          }, {
            n: "href",
            f: "/cli",
            t: 13,
            g: 1
          }],
          f: [{
            t: 7,
            e: "img",
            m: [{
              n: "width",
              f: "61",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "53",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/cli-icon.svg"],
              t: 13
            }]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_installation_item_title",
              g: 1
            }],
            f: ["Install the Globalping CLI"]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_installation_item_descr",
              g: 1
            }],
            f: ["Run and script network tests from all over the world without ever leaving your terminal"]
          }]
        }, " ", {
          t: 7,
          e: "a",
          m: [{
            t: 13,
            n: "class",
            f: "gp_installation_item router-ignore",
            g: 1
          }, {
            n: "href",
            f: "/docs/api.globalping.io",
            t: 13,
            g: 1
          }],
          f: [{
            t: 7,
            e: "img",
            m: [{
              n: "width",
              f: "61",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "53",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/rest-api-icon.svg"],
              t: 13
            }]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_installation_item_title",
              g: 1
            }],
            f: ["Integrate the Globalping REST API"]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_installation_item_descr",
              g: 1
            }],
            f: ["Use our free API to build your own tools, automated your tests and integrate Globalping into your existing flow"]
          }]
        }, " ", {
          t: 7,
          e: "a",
          m: [{
            t: 13,
            n: "class",
            f: "gp_installation_item",
            g: 1
          }, {
            n: "href",
            f: "/slack",
            t: 13,
            g: 1
          }],
          f: [{
            t: 7,
            e: "img",
            m: [{
              n: "width",
              f: "61",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "53",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/slack-icon.svg"],
              t: 13
            }]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_installation_item_title",
              g: 1
            }],
            f: ["Install the Globalping Slack App"]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_installation_item_descr",
              g: 1
            }],
            f: ["Install the app into your Slack organization to allow all of your members to run global tests in any channel"]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp_our-users",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_our-users_title",
            g: 1
          }],
          f: ["Our users:"]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_our-users_list",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_our-users_list_user",
              g: 1
            }],
            f: [{
              t: 7,
              e: "a",
              m: [{
                n: "target",
                f: "_blank",
                t: 13,
                g: 1
              }, {
                n: "rel",
                f: "noopener noreferrer",
                t: 13,
                g: 1
              }, {
                n: "href",
                f: "https://www.fastly.com",
                t: 13,
                g: 1
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "title",
                  f: "Used by Fastly",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "48",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/sponsors/fastly.png"],
                  t: 13
                }, {
                  n: "srcset",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/sponsors/fastly@2x.png 2x"],
                  t: 13
                }, {
                  n: "loading",
                  f: "lazy",
                  t: 13,
                  g: 1
                }]
              }]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_our-users_list_user",
              g: 1
            }],
            f: [{
              t: 7,
              e: "a",
              m: [{
                n: "target",
                f: "_blank",
                t: 13,
                g: 1
              }, {
                n: "rel",
                f: "noopener noreferrer",
                t: 13,
                g: 1
              }, {
                n: "href",
                f: "https://he.net",
                t: 13,
                g: 1
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "title",
                  f: "Used by Hurricane Electric",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "48",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/sponsors/hurricane_electric.png"],
                  t: 13
                }, {
                  n: "loading",
                  f: "lazy",
                  t: 13,
                  g: 1
                }]
              }]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_our-users_list_user",
              g: 1
            }],
            f: [{
              t: 7,
              e: "a",
              m: [{
                n: "target",
                f: "_blank",
                t: 13,
                g: 1
              }, {
                n: "rel",
                f: "noopener noreferrer",
                t: 13,
                g: 1
              }, {
                n: "href",
                f: "https://www.dnsfilter.com/",
                t: 13,
                g: 1
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "title",
                  f: "Used by DNSFilter",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "48",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/sponsors/dnsfilter.png"],
                  t: 13
                }, {
                  n: "loading",
                  f: "lazy",
                  t: 13,
                  g: 1
                }]
              }]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_our-users_list_user",
              g: 1
            }],
            f: [{
              t: 7,
              e: "a",
              m: [{
                n: "target",
                f: "_blank",
                t: 13,
                g: 1
              }, {
                n: "rel",
                f: "noopener noreferrer",
                t: 13,
                g: 1
              }, {
                n: "href",
                f: "https://gcore.com/",
                t: 13,
                g: 1
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "title",
                  f: "Used by Gcore",
                  t: 13,
                  g: 1
                }, {
                  n: "width",
                  f: "162",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "48",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/sponsors/gcore.svg"],
                  t: 13
                }, {
                  n: "loading",
                  f: "lazy",
                  t: 13,
                  g: 1
                }]
              }]
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp_join-network",
          g: 1
        }, {
          n: "id",
          f: "join-the-network",
          t: 13,
          g: 1
        }],
        f: [{
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "gp_join-network_title",
            g: 1
          }],
          f: ["Join the network"]
        }, " ", {
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "gp_join-network_subtitle",
            g: 1
          }],
          f: ["To join the Globalping probe network all you have to do is run our container."]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_join-network_switch-wrapper",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_join-network_switch",
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                n: "class",
                f: [{
                  t: 4,
                  f: ["active"],
                  n: 50,
                  x: {
                    r: ["joinNetSwitchValue"],
                    s: "_0===\"docker\""
                  }
                }],
                t: 13
              }, {
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this"],
                  s: "[_0.set(\"joinNetSwitchValue\",\"docker\")]"
                }
              }],
              f: ["Docker"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                n: "class",
                f: [{
                  t: 4,
                  f: ["active"],
                  n: 50,
                  x: {
                    r: ["joinNetSwitchValue"],
                    s: "_0===\"podman\""
                  }
                }],
                t: 13
              }, {
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this"],
                  s: "[_0.set(\"joinNetSwitchValue\",\"podman\")]"
                }
              }],
              f: ["Podman"]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_join-network_cmd-block",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              n: "class",
              f: ["gp_join-network_cmd-block_command ", {
                t: 4,
                f: ["opened"],
                n: 50,
                r: "showCommandsBlock"
              }],
              t: 13
            }],
            f: [{
              t: 4,
              f: [{
                t: 4,
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp_join-network_cmd-block_command_row",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "span",
                    f: [{
                      t: 2,
                      x: {
                        r: ["idx"],
                        s: "_0+1"
                      }
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    f: [{
                      t: 2,
                      r: "./cmd"
                    }]
                  }, " ", {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "span",
                      f: [{
                        t: 2,
                        r: "./comment"
                      }]
                    }],
                    n: 50,
                    r: "./comment"
                  }]
                }],
                n: 52,
                i: "idx",
                r: "netCmdTextFull"
              }],
              n: 50,
              r: "showCommandsBlock"
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_join-network_cmd-block_command_oneliner",
                  g: 1
                }],
                f: [{
                  t: 2,
                  r: "netCmdText"
                }]
              }],
              n: 51,
              l: 1
            }]
          }, " ", {
            t: 7,
            e: "button",
            m: [{
              t: 13,
              n: "class",
              f: "gp_join-network_cmd-block_btn gp_btn_green",
              g: 1
            }, {
              n: "clipboard",
              t: 71
            }, {
              n: "data-clipboard-text",
              f: [{
                t: 2,
                x: {
                  r: ["showCommandsBlock", "netCmdTextFullClipboard", "netCmdText"],
                  s: "_0?_1:_2"
                }
              }],
              t: 13
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "20",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "20",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/copy-icon.svg"],
                t: 13
              }]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              n: "class",
              f: ["gp_join-network_cmd-block_open-btn ", {
                t: 4,
                f: ["active"],
                n: 50,
                r: "showCommandsBlock"
              }],
              t: 13
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this"],
                s: "[_0.toggle(\"showCommandsBlock\")]"
              }
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "9",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "6",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/chevron.svg"],
                t: 13
              }]
            }]
          }]
        }, " ", {
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "gp_join-network_descr",
            g: 1
          }],
          f: ["Once you connect you will become part of the global community that powers the Globalping Platform. The container will work on both x86 and ARM architectures."]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp_join-community",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_join-community_content",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_join-community_content_title",
              g: 1
            }],
            f: ["We invite everyone to join our community and help us develop our projects."]
          }, " ", {
            t: 7,
            e: "ul",
            m: [{
              t: 13,
              n: "class",
              f: "gp_join-community_content_list",
              g: 1
            }],
            f: [{
              t: 7,
              e: "li",
              f: ["We promise a friendly discussion in our issues and code reviews"]
            }, " ", {
              t: 7,
              e: "li",
              f: ["We appreciate your work and will review your PRs in a timely manner"]
            }, " ", {
              t: 7,
              e: "li",
              f: ["We are open to new ideas and technologies"]
            }, " ", {
              t: 7,
              e: "li",
              f: ["You don't have to be a developer to help"]
            }, " ", {
              t: 7,
              e: "li",
              f: ["Copywriters, community moderators, dev relations, media relations... are all equally important"]
            }]
          }, " ", {
            t: 7,
            e: "img",
            m: [{
              t: 13,
              n: "class",
              f: "gp_join-community_img",
              g: 1
            }, {
              n: "width",
              f: "363",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "416",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/polygons_3.svg"],
              t: 13
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp_gh-links",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_gh-links_header",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp_gh-links_header_title",
              g: 1
            }],
            f: ["Become an open source contributor!"]
          }, " ", {
            t: 7,
            e: "img",
            m: [{
              n: "width",
              f: "64",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "64",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/github.svg"],
              t: 13
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_gh-links_content",
            g: 1
          }],
          f: [{
            t: 7,
            e: "a",
            m: [{
              t: 13,
              n: "class",
              f: "gp_gh-links_content_item",
              g: 1
            }, {
              n: "target",
              f: "_blank",
              t: 13,
              g: 1
            }, {
              n: "rel",
              f: "noopener noreferrer",
              t: 13,
              g: 1
            }, {
              n: "href",
              f: "https://github.com/jsdelivr/globalping",
              t: 13,
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp_gh-links_content_item_title",
                g: 1
              }],
              f: ["Globalping API"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp_gh-links_content_item_descr",
                g: 1
              }],
              f: ["Learn more about the project, the API, tools and become a contributor"]
            }]
          }, " ", {
            t: 7,
            e: "a",
            m: [{
              t: 13,
              n: "class",
              f: "gp_gh-links_content_item",
              g: 1
            }, {
              n: "target",
              f: "_blank",
              t: 13,
              g: 1
            }, {
              n: "rel",
              f: "noopener noreferrer",
              t: 13,
              g: 1
            }, {
              n: "href",
              f: "https://github.com/jsdelivr/globalping-cli",
              t: 13,
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp_gh-links_content_item_title",
                g: 1
              }],
              f: ["Globalping CLI"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp_gh-links_content_item_descr",
                g: 1
              }],
              f: ["Our simple to use CLI is also open source and awaits for your feedback."]
            }]
          }, " ", {
            t: 7,
            e: "a",
            m: [{
              t: 13,
              n: "class",
              f: "gp_gh-links_content_item",
              g: 1
            }, {
              n: "target",
              f: "_blank",
              t: 13,
              g: 1
            }, {
              n: "rel",
              f: "noopener noreferrer",
              t: 13,
              g: 1
            }, {
              n: "href",
              f: "https://github.com/jsdelivr/globalping-probe",
              t: 13,
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp_gh-links_content_item_title",
                g: 1
              }],
              f: ["Globalping Probe"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp_gh-links_content_item_descr",
                g: 1
              }],
              f: ["Explore the codebase of our software probes and firmware for hardware probes as well"]
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp_probe",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_probe_promo",
            g: 1
          }],
          f: [{
            t: 7,
            e: "img",
            m: [{
              n: "width",
              f: "198",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "198",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/probe.png"],
              t: 13
            }, {
              n: "srcset",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/probe@2x.png 2x"],
              t: 13
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_probe_promo_content",
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp_probe_promo_content_title",
                g: 1
              }],
              f: ["Get a hardware probe"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp_probe_promo_content_descr",
                g: 1
              }],
              f: ["Become a GitHub sponsor for $10/month or more and get your own hardware probe to install in your home or office network."]
            }, " ", {
              t: 7,
              e: "a",
              m: [{
                t: 13,
                n: "class",
                f: "gp_probe_promo_content_btn gp_btn_green",
                g: 1
              }, {
                n: "target",
                f: "_blank",
                t: 13,
                g: 1
              }, {
                n: "rel",
                f: "noopener noreferrer",
                t: 13,
                g: 1
              }, {
                n: "href",
                f: "https://github.com/sponsors/jsdelivr",
                t: 13,
                g: 1
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "20",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "20",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/github.small.svg"],
                  t: 13
                }]
              }, " Become a GitHub Sponsor"]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_probe_get-probe",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_probe_get-probe_header",
              g: 1
            }],
            f: ["How to get a probe?"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_probe_get-probe_list",
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp_probe_get-probe_list_item",
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_probe_get-probe_list_item_progress",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "img",
                  m: [{
                    n: "width",
                    f: "24",
                    t: 13,
                    g: 1
                  }, {
                    n: "height",
                    f: "24",
                    t: 13,
                    g: 1
                  }, {
                    n: "src",
                    f: [{
                      t: 2,
                      r: "@shared.assetsHost"
                    }, "/img/circle-icon.svg"],
                    t: 13
                  }]
                }, " ", {
                  t: 7,
                  e: "span"
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_probe_get-probe_list_item_content",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  f: ["Become a sponsor"]
                }, " ", {
                  t: 7,
                  e: "span",
                  f: ["Become a GitHub Sponsor for $10+/month."]
                }]
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp_probe_get-probe_list_item",
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_probe_get-probe_list_item_progress",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "img",
                  m: [{
                    n: "width",
                    f: "24",
                    t: 13,
                    g: 1
                  }, {
                    n: "height",
                    f: "24",
                    t: 13,
                    g: 1
                  }, {
                    n: "src",
                    f: [{
                      t: 2,
                      r: "@shared.assetsHost"
                    }, "/img/circle-icon.svg"],
                    t: 13
                  }]
                }, " ", {
                  t: 7,
                  e: "span"
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_probe_get-probe_list_item_content",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "rel",
                      f: "noopener noreferrer",
                      t: 13,
                      g: 1
                    }, {
                      n: "href",
                      f: "https://forms.gle/9jSzytJpTDYJmS2W8",
                      t: 13,
                      g: 1
                    }],
                    f: ["Fill the form"]
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  f: ["Fill out this form with your details."]
                }]
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp_probe_get-probe_list_item",
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_probe_get-probe_list_item_progress",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "img",
                  m: [{
                    n: "width",
                    f: "24",
                    t: 13,
                    g: 1
                  }, {
                    n: "height",
                    f: "24",
                    t: 13,
                    g: 1
                  }, {
                    n: "src",
                    f: [{
                      t: 2,
                      r: "@shared.assetsHost"
                    }, "/img/circle-icon.svg"],
                    t: 13
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_probe_get-probe_list_item_content",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  f: ["Probe arrives"]
                }, " ", {
                  t: 7,
                  e: "span",
                  f: ["Wait for the probe to arrive."]
                }]
              }]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_probe_how-it-works",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_probe_how-it-works_header",
              g: 1
            }],
            f: ["How it works?"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_probe_how-it-works_text",
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              f: ["Installing our hardware probe simplifies the whole process and ", {
                t: 7,
                e: "b",
                f: ["removes the need of having a computer running 24/7."]
              }, " Just connect the probe to your switch or router via an ethernet cable and you are done!"]
            }, " ", {
              t: 7,
              e: "span",
              f: ["Our hardware probes are fully secure. ", {
                t: 7,
                e: "b",
                f: ["They don't allow any kind of access to your LAN"]
              }, ", they block all malicious and abusive endpoints, don't open any ports whatsoever and the firmware itself is fully open source."]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_probe_how-it-works_btns",
              g: 1
            }],
            f: [{
              t: 7,
              e: "a",
              m: [{
                t: 13,
                n: "class",
                f: "gp_probe_how-it-works_btns_learn-more gp_btn_black",
                g: 1
              }, {
                n: "target",
                f: "_blank",
                t: 13,
                g: 1
              }, {
                n: "rel",
                f: "noopener noreferrer",
                t: 13,
                g: 1
              }, {
                n: "href",
                f: "https://github.com/jsdelivr/globalping-hwprobe",
                t: 13,
                g: 1
              }],
              f: ["Learn more"]
            }, " ", {
              t: 7,
              e: "a",
              m: [{
                t: 13,
                n: "class",
                f: "gp_probe_how-it-works_btns_sponsor gp_btn_green",
                g: 1
              }, {
                n: "target",
                f: "_blank",
                t: 13,
                g: 1
              }, {
                n: "rel",
                f: "noopener noreferrer",
                t: 13,
                g: 1
              }, {
                n: "href",
                f: "https://github.com/sponsors/jsdelivr",
                t: 13,
                g: 1
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "20",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "20",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/github.small.svg"],
                  t: 13
                }]
              }, " Become a GitHub Sponsor"]
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp_sponsors",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp_sponsors_content",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_sponsors_content_info",
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp_sponsors_content_info_title",
                g: 1
              }],
              f: ["Globalping sponsors"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp_sponsors_content_info_descr",
                g: 1
              }],
              f: ["We thank everyone who decided to help our project by either running multiple globally distributed probes or donating to our cause."]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_sponsors_content_list",
              g: 1
            }, {
              n: "data-testid",
              f: "gp-sponsors",
              t: 13,
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp_sponsors_content_list_tier-one",
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://xtom.com",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by xTom",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "101",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "28",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/xtom.svg"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://looking.house",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Looking.house",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "151",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "34",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/looking-house.svg"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.starrydns.com",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by StarryDNS",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "160",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "28",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/starry.png"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.ip2location.io/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by IP2Location",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "169",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "28",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/ip2location.svg"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.exoscale.com",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Exoscale",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "210",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "28",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/exoscale.svg"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.fdcservers.net",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by FDCServers",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "95",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "28",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/fdc.svg"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://ipinfo.io/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by IPInfo",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "93",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "28",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/ipinfo.svg"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.edisglobal.com/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by EDIS Global",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "91",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "28",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/edis-global.svg"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.misaka.io",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Misaka Network, Inc.",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "95",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "28",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/misaka.svg"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://zappiehost.com",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Zappie Host",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "97",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "28",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/zappiehost.png"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://gcore.com/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Gcore",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "141",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "42",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/gcore.svg"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 9,
                  c: " swap images for better look depending on screenWidth "
                }, " ", {
                  t: 4,
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "rel",
                      f: "noopener noreferrer",
                      t: 13,
                      g: 1
                    }, {
                      n: "href",
                      f: "https://www.dnsfilter.com/",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "title",
                        f: "Sponsored by DNSFilter",
                        t: 13,
                        g: 1
                      }, {
                        n: "width",
                        f: "120",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "28",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/sponsors/dnsfilter.png"],
                        t: 13
                      }]
                    }]
                  }],
                  n: 50,
                  x: {
                    r: ["screenWidth"],
                    s: "_0<768"
                  }
                }, {
                  t: 4,
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "rel",
                      f: "noopener noreferrer",
                      t: 13,
                      g: 1
                    }, {
                      n: "href",
                      f: "https://ipgeolocation.io/",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "title",
                        f: "Sponsored by IP Geolocation",
                        t: 13,
                        g: 1
                      }, {
                        n: "width",
                        f: "97",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "56",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/sponsors/ipgeolocation.svg"],
                        t: 13
                      }]
                    }]
                  }],
                  n: 51,
                  l: 1
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://shockhosting.com/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Shock Hosting",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "220",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "30",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/shockhosting.svg"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 9,
                  c: " swap images for better look depending on screenWidth "
                }, " ", {
                  t: 4,
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "rel",
                      f: "noopener noreferrer",
                      t: 13,
                      g: 1
                    }, {
                      n: "href",
                      f: "https://ipgeolocation.io/",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "title",
                        f: "Sponsored by IP Geolocation",
                        t: 13,
                        g: 1
                      }, {
                        n: "width",
                        f: "97",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "56",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/sponsors/ipgeolocation.svg"],
                        t: 13
                      }]
                    }]
                  }],
                  n: 50,
                  x: {
                    r: ["screenWidth"],
                    s: "_0<768"
                  }
                }, {
                  t: 4,
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "rel",
                      f: "noopener noreferrer",
                      t: 13,
                      g: 1
                    }, {
                      n: "href",
                      f: "https://www.dnsfilter.com/",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "title",
                        f: "Sponsored by DNSFilter",
                        t: 13,
                        g: 1
                      }, {
                        n: "width",
                        f: "120",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "28",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/sponsors/dnsfilter.png"],
                        t: 13
                      }]
                    }]
                  }],
                  n: 51,
                  l: 1
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://onidel.com/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Onidel",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "130",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "32",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/onidel.svg"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.kuroit.com/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Kuroit",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "128",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "34",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/kuroit.png"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://exservers.net//",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by ExServers",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "156",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "28",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/exservers.png"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://netshop-isp.com.cy/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by NetShop ISP",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "145",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "40",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/netshop-logo-dark.svg"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://oneprovider.com/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by OneProvider",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "171",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "45",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/oneprovider.svg"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.mvps.net/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by MVPS",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "158",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "50",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/mvps.svg"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.fastly.com/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Fastly",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "130",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "42",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/fastly.svg"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.host-stage.net/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by HostStage",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "189",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "40",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/host-stage.svg"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.iplocate.io/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by IPLocate",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "164",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "27",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/iplocate.svg"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://breezehost.io/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by BreezeHost",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "121",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "46",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/breezehost.svg"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://cloudlooking.glass/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Cloud Looking Glass",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "147",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "40",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/cloud-looking-glass.png"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.datapacket.com/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Datapacket",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "180",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "26",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/datapacket.svg"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_sponsors_content_list_tier-one_row",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://www.digiturunc.com/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Digiturunc",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "122",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "56",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/digiturunc.png"],
                      t: 13
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: "https://perlod.com/",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: "Sponsored by Perlod",
                      t: 13,
                      g: 1
                    }, {
                      n: "width",
                      f: "112",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "32",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/sponsors/perlod.svg"],
                      t: 13
                    }]
                  }]
                }]
              }, " ", {
                t: 9,
                c: " <div class=\"gp_sponsors_content_list_tier-two\">\n\t\t\t\t\t\t\t<div class=\"gp_sponsors_content_list_tier-two_row\">\n\t\t\t\t\t\t\t\t<div class=\"gp_person-sponsor\">Robert  Kowalski</div>\n\n\t\t\t\t\t\t\t\t<img width=\"57\"\n\t\t\t\t\t\t\t\t\theight=\"19\"\n\t\t\t\t\t\t\t\t\tsrc=\"{{@shared.assetsHost}}/img/sponsors/dell.svg\">\n\n\t\t\t\t\t\t\t\t<div class=\"gp_person-sponsor\">Magdalene Tabhita</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div> "
              }]
            }]
          }, " ", {
            t: 7,
            e: "a",
            m: [{
              t: 13,
              n: "class",
              f: "gp_sponsors_content_btn gp_btn_green",
              g: 1
            }, {
              n: "href",
              f: "mailto:d@jsdelivr.com",
              t: 13,
              g: 1
            }],
            f: ["Get in Contact"]
          }, " ", {
            t: 7,
            e: "img",
            m: [{
              t: 13,
              n: "class",
              f: "gp_sponsors_content_img",
              g: 1
            }, {
              n: "width",
              f: "289",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "288",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/polygons_4.svg"],
              t: 13
            }]
          }]
        }]
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "c-gp-footer"
      }],
      n: 51,
      r: "focusModeActive"
    }]
  }],
  e: {
    "!_0&&!_1": function (_0, _1) {
      return !_0 && !_1;
    },
    "_0||_1||_2===\"preparing-close\"": function (_0, _1, _2) {
      return _0 || _1 || _2 === "preparing-close";
    },
    "_0||_1===\"preparing-close\"": function (_0, _1) {
      return _0 || _1 === "preparing-close";
    },
    "Math.floor(_0)": function (_0) {
      return Math.floor(_0);
    },
    "_0===\"entering\"": function (_0) {
      return _0 === "entering";
    },
    "_0===\"preparing-close\"": function (_0) {
      return _0 === "preparing-close";
    },
    "_0===\"content-leaving\"||_1===\"leaving\"": function (_0, _1) {
      return _0 === "content-leaving" || _1 === "leaving";
    },
    "[_0.handleFocusModePositionTransitionEnd(_1)]": function (_0, _1) {
      return [_0.handleFocusModePositionTransitionEnd(_1)];
    },
    "[_0.handleFocusModeBackdropTransitionEnd(_1)]": function (_0, _1) {
      return [_0.handleFocusModeBackdropTransitionEnd(_1)];
    },
    "[_0.closeFocusModeFromBackdrop(_1)]": function (_0, _1) {
      return [_0.closeFocusModeFromBackdrop(_1)];
    },
    "_0||_1||_2||_3": function (_0, _1, _2, _3) {
      return _0 || _1 || _2 || _3;
    },
    "_0===\"opening\"": function (_0) {
      return _0 === "opening";
    },
    "[_0.closeFocusMode(_1)]": function (_0, _1) {
      return [_0.closeFocusMode(_1)];
    },
    "_0||_1===\"content-leaving\"||_2": function (_0, _1, _2) {
      return _0 || _1 === "content-leaving" || _2;
    },
    "_0&&!_1": function (_0, _1) {
      return _0 && !_1;
    },
    "_0===_1": function (_0, _1) {
      return _0 === _1;
    },
    "[_0.setMainOptsTestType(_1)]": function (_0, _1) {
      return [_0.setMainOptsTestType(_1)];
    },
    "!_0": function (_0) {
      return !_0;
    },
    "true": function () {
      return true;
    },
    "_0!==\"DNS\"": function (_0) {
      return _0 !== "DNS";
    },
    "[\"Up to 2 IP addresses or domains\",_0]": function (_0) {
      return ["Up to 2 IP addresses or domains", _0];
    },
    "[_0.resetMapAndRunTest()]": function (_0) {
      return [_0.resetMapAndRunTest()];
    },
    "[[\"This magic field supports names of continents, regions, countries, US states, cities, networks, and our custom tags.\",\"\",\"Use + to combine multiple filters.\",\"Use , to select multiple locations.\"],_0,undefined,undefined,\"multiline\"]": function (_0) {
      return [["This magic field supports names of continents, regions, countries, US states, cities, networks, and our custom tags.", "", "Use + to combine multiple filters.", "Use , to select multiple locations."], _0, undefined, undefined, "multiline"];
    },
    "_0===false": function (_0) {
      return _0 === false;
    },
    "[\"Values up to 5 are supported for infinite measurements\",_0,undefined,undefined,\"gp_tt-limit\"]": function (_0) {
      return ["Values up to 5 are supported for infinite measurements", _0, undefined, undefined, "gp_tt-limit"];
    },
    "[_0.handleToggleMeasOpts()]": function (_0) {
      return [_0.handleToggleMeasOpts()];
    },
    "_0&&_1===false": function (_0, _1) {
      return _0 && _1 === false;
    },
    "_0===\"TCP\"": function (_0) {
      return _0 === "TCP";
    },
    "[_0.set(\"pingOpts.protocol\",\"TCP\")]": function (_0) {
      return [_0.set("pingOpts.protocol", "TCP")];
    },
    "_0===\"ICMP\"": function (_0) {
      return _0 === "ICMP";
    },
    "[_0.set(\"pingOpts.protocol\",\"ICMP\")]": function (_0) {
      return [_0.set("pingOpts.protocol", "ICMP")];
    },
    "_0===\"ping\"": function (_0) {
      return _0 === "ping";
    },
    "[_0.set(\"tracerouteOpts.protocol\",\"TCP\")]": function (_0) {
      return [_0.set("tracerouteOpts.protocol", "TCP")];
    },
    "_0===\"UDP\"": function (_0) {
      return _0 === "UDP";
    },
    "[_0.set(\"tracerouteOpts.protocol\",\"UDP\")]": function (_0) {
      return [_0.set("tracerouteOpts.protocol", "UDP")];
    },
    "[_0.set(\"tracerouteOpts.protocol\",\"ICMP\")]": function (_0) {
      return [_0.set("tracerouteOpts.protocol", "ICMP")];
    },
    "_0===\"traceroute\"": function (_0) {
      return _0 === "traceroute";
    },
    "[_0.set(\"dnsOpts.protocol\",\"UDP\")]": function (_0) {
      return [_0.set("dnsOpts.protocol", "UDP")];
    },
    "[_0.set(\"dnsOpts.protocol\",\"TCP\")]": function (_0) {
      return [_0.set("dnsOpts.protocol", "TCP")];
    },
    "[_0.set(\"dnsOpts.query.type\",_1)]": function (_0, _1) {
      return [_0.set("dnsOpts.query.type", _1)];
    },
    "[_0.set(\"dnsOpts.trace\",!_1)]": function (_0, _1) {
      return [_0.set("dnsOpts.trace", !_1)];
    },
    "_0===\"DNS\"": function (_0) {
      return _0 === "DNS";
    },
    "[_0.set(\"mtrOpts.protocol\",\"UDP\")]": function (_0) {
      return [_0.set("mtrOpts.protocol", "UDP")];
    },
    "[_0.set(\"mtrOpts.protocol\",\"TCP\")]": function (_0) {
      return [_0.set("mtrOpts.protocol", "TCP")];
    },
    "[_0.set(\"mtrOpts.protocol\",\"ICMP\")]": function (_0) {
      return [_0.set("mtrOpts.protocol", "ICMP")];
    },
    "_0===\"MTR\"": function (_0) {
      return _0 === "MTR";
    },
    "_0===\"HTTP\"": function (_0) {
      return _0 === "HTTP";
    },
    "[_0.set(\"httpOpts.protocol\",\"HTTP\")]": function (_0) {
      return [_0.set("httpOpts.protocol", "HTTP")];
    },
    "_0===\"HTTPS\"": function (_0) {
      return _0 === "HTTPS";
    },
    "[_0.set(\"httpOpts.protocol\",\"HTTPS\")]": function (_0) {
      return [_0.set("httpOpts.protocol", "HTTPS")];
    },
    "_0===\"HTTP2\"": function (_0) {
      return _0 === "HTTP2";
    },
    "[_0.set(\"httpOpts.protocol\",\"HTTP2\")]": function (_0) {
      return [_0.set("httpOpts.protocol", "HTTP2")];
    },
    "_0===\"GET\"": function (_0) {
      return _0 === "GET";
    },
    "[_0.set(\"httpOpts.request.method\",\"GET\")]": function (_0) {
      return [_0.set("httpOpts.request.method", "GET")];
    },
    "_0===\"HEAD\"": function (_0) {
      return _0 === "HEAD";
    },
    "[_0.set(\"httpOpts.request.method\",\"HEAD\")]": function (_0) {
      return [_0.set("httpOpts.request.method", "HEAD")];
    },
    "_0===\"OPTIONS\"": function (_0) {
      return _0 === "OPTIONS";
    },
    "[_0.set(\"httpOpts.request.method\",\"OPTIONS\")]": function (_0) {
      return [_0.set("httpOpts.request.method", "OPTIONS")];
    },
    "[_0.applyOptions()]": function (_0) {
      return [_0.applyOptions()];
    },
    "_0.isInfiniteOptsCorrect()": function (_0) {
      return _0.isInfiniteOptsCorrect();
    },
    "[_0.handleInfiniteSwitch()]": function (_0) {
      return [_0.handleInfiniteSwitch()];
    },
    "[_0.handleInfiniteSwitchKeyDown(_1)]": function (_0, _1) {
      return [_0.handleInfiniteSwitchKeyDown(_1)];
    },
    "_0.isInfiniteOptsCorrect()&&!_1": function (_0, _1) {
      return _0.isInfiniteOptsCorrect() && !_1;
    },
    "[_0.handleRunTestBtn()]": function (_0) {
      return [_0.handleRunTestBtn()];
    },
    "[_0.reUseProbesRunTest()]": function (_0) {
      return [_0.reUseProbesRunTest()];
    },
    "_0&&(_1||!_2)": function (_0, _1, _2) {
      return _0 && (_1 || !_2);
    },
    "_0||!_1": function (_0, _1) {
      return _0 || !_1;
    },
    "_0===\"prompt-entering\"": function (_0) {
      return _0 === "prompt-entering";
    },
    "[_0.openFocusMode(_1)]": function (_0, _1) {
      return [_0.openFocusMode(_1)];
    },
    "_0&&(!_1||_2===\"opening\")&&!_3": function (_0, _1, _2, _3) {
      return _0 && (!_1 || _2 === "opening") && !_3;
    },
    "_0===\"content-leaving\"": function (_0) {
      return _0 === "content-leaving";
    },
    "_0&&!_1&&_2!==\"content-leaving\"": function (_0, _1, _2) {
      return _0 && !_1 && _2 !== "content-leaving";
    },
    "_0&&_1===\"opening\"": function (_0, _1) {
      return _0 && _1 === "opening";
    },
    "_0&&_1": function (_0, _1) {
      return _0 && _1;
    },
    "_0?_1:[]": function (_0, _1) {
      return _0 ? _1 : [];
    },
    "_0&&!_1&&(_2||!_3)": function (_0, _1, _2, _3) {
      return _0 && !_1 && (_2 || !_3);
    },
    "(_0&&(_1||_2))||(_3&&_4&&_5)": function (_0, _1, _2, _3, _4, _5) {
      return _0 && (_1 || _2) || _3 && _4 && _5;
    },
    "_0.shouldShowMeasurementLoadingInfo()": function (_0) {
      return _0.shouldShowMeasurementLoadingInfo();
    },
    "!_0||_1||_2===\"content-leaving\"||_3": function (_0, _1, _2, _3) {
      return !_0 || _1 || _2 === "content-leaving" || _3;
    },
    "_0===\"docker\"": function (_0) {
      return _0 === "docker";
    },
    "[_0.set(\"joinNetSwitchValue\",\"docker\")]": function (_0) {
      return [_0.set("joinNetSwitchValue", "docker")];
    },
    "_0===\"podman\"": function (_0) {
      return _0 === "podman";
    },
    "[_0.set(\"joinNetSwitchValue\",\"podman\")]": function (_0) {
      return [_0.set("joinNetSwitchValue", "podman")];
    },
    "_0+1": function (_0) {
      return _0 + 1;
    },
    "_0?_1:_2": function (_0, _1, _2) {
      return _0 ? _1 : _2;
    },
    "[_0.toggle(\"showCommandsBlock\")]": function (_0) {
      return [_0.toggle("showCommandsBlock")];
    },
    "_0<768": function (_0) {
      return _0 < 768;
    }
  }
};
component$j.exports.components = {
  "c-gp-video-modal": videoModal,
  "c-test-examples": testExamples,
  "c-gp-jumbotron": jumbotron,
  "c-gp-credits": credits$1,
  "c-gp-credits-message": creditsMessage,
  "c-gp-results-share": resultsShare,
  "c-gp-results-table-output": resultsTableOutput,
  "c-gp-results-raw-output": resultsRawOutput,
  "c-gp-results-controls": resultsControls,
  "c-tags-input": tagsInput,
  "c-controlled-textarea": controlledTextarea,
  "c-location-input": locationInput,
  "c-controlled-input": controlledInput,
  "c-notification": notification,
  "c-gp-footer": footer,
  "c-gp-header": header,
  "r-page": rPage
};
var _index = ractive.extend(component$j.exports);

var component$i = {
  exports: {}
};
const CONTENT_TYPE_HEADER = 'header';
const CONTENT_TYPE_SUBHEADER = 'subheader';
const CONTENT_TYPE_DESCR = 'descr';
const CONTENT_TYPE_LIST = 'list';
component$i.exports = {
  computed: {
    contentPerTestType() {
      let locationData = this.get('locationData');
      let locationName = locationData ? locationData.name || locationData.from : 'World';
      return {
        ping: [{
          type: CONTENT_TYPE_HEADER,
          content: 'What is ping?'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Ping is a network testing and troubleshooting utility that helps identify problems when
you can't reach a server or experience slow loading times. It's also often used for simple
network performance monitoring, determining if a website is reachable from the local network, or resolving a hostname's IP address.`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Ping sends Internet Control Message Protocol (ICMP) packets from your location to a target
host (a hostname or IP address) to test connectivity. If everything goes well, the target
receives the request and sends back a response to confirm that it's reachable and working.
The response includes the round-trip time (RTT), which tells you how long it took for the
data to travel to the destination and back. This RTT can also indicate the latency, or delay, to the target.`
        }, {
          type: CONTENT_TYPE_HEADER,
          content: 'What are everyday use cases for ping?'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: 'Not sure how ping can help you? Here are some popular use cases:'
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Test network connectivity'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Ping is the go-to tool when you experience network issues. By sending data packets to a target
host and receiving a response, ping lets you quickly verify if the target is reachable and evaluate
the overall network connectivity.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Measure latency'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `You may have a network bottleneck or other performance issues if you spot unusually high RTTs in
your ping results. If you notice high latency but don't know where in the network the problem is,
pinging different hosts and comparing the RTTs helps find the problematic devices.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Test website reachability'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `When you can't load a website via your browser, ping the website's hostname to check if it's reachable
from your network. This lets you determine whether you're facing network-related issues or a problem with your browser.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Diagnose Internet connection problems'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Can't connect to the Internet? Ping your router's IP address to verify if your device can reach the
router, helping you find out if the issue lies within your local network or the Internet connection.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Monitor networks'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Create automated scripts that regularly ping one or more hosts and store the result data. Use this
data to identify hosts that frequently cause high response times, packet loss, or other problems so you can take action.`
        }, {
          type: CONTENT_TYPE_HEADER,
          content: `What are common use cases to run ping from ${locationName}?`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Sometimes you need to run network tests from locations that aren't accessible to you. That's where Globalping comes
to the rescue. It's a platform that relies on a globally distributed network of probes, allowing you to
perform measurements from any corner of the world.`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Running ping from ${locationName} and other places provides many insights and extends the
use cases we explored in the previous section:`
        }, {
          type: CONTENT_TYPE_LIST,
          content: ['Set up global network monitoring', 'Test website availability from various regions', 'Measure latency as experienced by users across the globe']
        }, {
          type: CONTENT_TYPE_DESCR,
          content: 'Here are some additional use cases for geographically distributed ping:'
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Optimize content delivery'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Run ping from ${locationName} and other locations to test the latency to your website or API. Examine the ping's
RTTs - if they're unusually high, users likely experience delays and long loading times. To reduce latency,
consider using a CDN (Content Delivery Network) for efficient content distribution.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: `Troubleshoot from your users' perspective`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Imagine your website users in ${locationName} are reporting issues, but everything
seems fine from your end. With Globalping, you can run ping from ${locationName} as if you were doing it from your
location to troubleshoot the problem.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Monitor remote servers'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `If you manage servers around the globe, running ping from different locations can be of invaluable help for
monitoring performance and connectivity. This allows you to respond faster and more informed when issues in specific regions arise.`
        }],
        traceroute: [{
          type: CONTENT_TYPE_HEADER,
          content: 'What is traceroute?'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Traceroute is a valuable network testing and troubleshooting utility that helps pinpoint potential issues along
the route between your device and the target host, such as when you're unable to reach a website or experience slow load times.`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Traceroute sends small data packets to a target hostname or IP address and lists each hop (usually a router) used to get there.
Each packet has a Time to Live (TTL) value, starting at 1, to limit its lifespan. As the data passes through each hop, the TTL value decreases by 1. Once it
reaches 0, the current router stops forwarding the packet and responds with a "TTL exceeded" message. Traceroute then takes note of the router's IP address,
increases the packet's initial TTL by 1, and resends the request.
Thanks to this back and forth, traceroute can compile a list of all the hops the data passes to the target, including the round-trip time (RTT) for each hop.`
        }, {
          type: CONTENT_TYPE_HEADER,
          content: 'What are common use cases for traceroute?'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Are you wondering what you can actually achieve by running traceroute? Here are some typical use cases:`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Measure performance'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `If you notice high latency to a target, run traceroute and look at each hop's round-trip time (RTT) to learn about the time it took for
the data packets to reach the destination and back. If you come across a hop with an unusually high RTT, it could indicate congestion or some other performance
issue at that point.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Analyze network paths'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Traceroute comes in handy when you need to know the path packets take through the network to reach a target host. Listing the IP addresses,
host names, and RTTs for each hop gives you a clearer picture of the network infrastructure. As a result, you may find potential bottlenecks or other problematic
segments, allowing you to take action quickly.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Troubleshoot network connectivity'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `When you're experiencing network connectivity issues, traceroute can help pinpoint the problem by collecting data about each hop between
your device and the target. Typically, the issue is with the last hop that sent a response or the one after that hop. Once you know where the problem is, you're a
big step closer to solving it.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Verify routing changes'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Running traceroute before and after making changes to your network infrastructure allows you to verify that the new routing's working as
expected. Compare traceroute results to ensure that data takes the correct path and identify any unexpected behavior you should fix.`
        }, {
          type: CONTENT_TYPE_HEADER,
          content: `What are everyday use cases to run traceroute from ${locationName}?`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `But how can you use traceroute when users report issues with your infrastructure in places that aren't accessible to you? This is where
Globalping can help you: The platform leverages a globally distributed network of probes, enabling you to send measurement requests from anywhere in the world.`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Running traceroute from ${locationName} and any other location provides insights on a global scale, adding to the use cases explored above:`
        }, {
          type: CONTENT_TYPE_LIST,
          content: ['Find network bottlenecks and measure latency globally', 'Analyze and verify the paths data takes from different locations to a website or server', 'Resolve network connectivity issues reported by users all over the world']
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Let's explore some more use cases for running traceroute globally:`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Global network monitoring'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Running traceroute with Globalping regularly from different locations around the world gives you a comprehensive view of your network's
performance and connectivity. This allows you to resolve many network-related issues faster and ensure a consistently high user experience.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Compare service providers'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `When choosing the ideal CDN provider, DNS provider, or Cloud hosting company, running traceroute from ${locationName} and other locations
to the provider can help. Examine the number of hops, the round-trip times, and any potential performance spikes encountered along the path. That way, you can
determine which providers offer the best network connectivity and reliability for your desired locations.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: `Investigate user reports`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Are users in remote locations like ${locationName} reporting issues you can't reproduce? Use Globalping to run traceroute from an area near
these users to identify regional problems and determine the proper troubleshooting steps.`
        }],
        dns: [{
          type: CONTENT_TYPE_HEADER,
          content: 'What is dig, and how to resolve DNS?'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Dig is a network testing and troubleshooting tool that allows you to retrieve DNS (Domain Name System) information, such as a
domain's IP address, DNS records, and name server information.`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `The dig command is quite flexible and lets you add options as needed. For example, you can query specific record types or define
the name server to query instead of your default resolver. When you run the dig command, you get a response divided into sections. The "authority section,"
for instance, lists the authoritative name servers that responded, and the "answer section" contains the response to your DNS query, such as the A record.`
        }, {
          type: CONTENT_TYPE_HEADER,
          content: 'What are typical scenarios for using dig?'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: 'Not sure what you can do with the dig command? Here are some ideas:'
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Perform DNS lookups'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Probably the most common use case for dig is to perform DNS lookups to provide you with information about the DNS configuration of a domain.
The data retrieved can include A records (IPv4 addresses), AAAA records (IPv6 addresses), MX records (mail server), NS records (name servers), and more.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Troubleshoot DNS issues'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Dig is also the go-to tool for troubleshooting DNS resolution problems. Using the command, you can verify if DNS records are configured
correctly and that DNS servers are responding as they should. Query DNS records and analyze the results to find misconfigurations, DNS propagation problems,
and other DNS issues.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Measure DNS performance'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `If you want to measure the performance and reliability of different DNS servers, dig can help you with that too. Examine DNS response times
and query statistics to identify potential bottlenecks or test the efficiency of DNS caching.`
        }, {
          type: CONTENT_TYPE_HEADER,
          content: `What are common use cases to run dig from ${locationName}?`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Sometimes you may experience DNS resolution issues or need to check DNS information from locations that aren't accessible to you.
That's where the Globalping platform comes into play. It consists of a network of globally distributed probes that allows you to perform DNS queries similar to dig
from any location.`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `If you run dig from different places around the world, you can perform DNS-related tasks on a global scale, extending the use cases listed
in the previous section:`
        }, {
          type: CONTENT_TYPE_LIST,
          content: ['Measure regional DNS performance', 'Perform global DNS resolution', 'Monitor and troubleshoot DNS issues globally']
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `But there's more:`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: `Resolve DNS from ${locationName}`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Suppose your users in ${locationName} can't reach your website or email services. By running dig from ${locationName} with Globalping, you can
retrieve DNS information specific to that location. Examine the query results and look for misconfigurations that could affect your users' experience.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Test load balancers'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Load balancers help you distribute incoming network traffic, for example, if you run a busy website. You can run dig from ${locationName} and
other locations to test whether your load balancers work as intended. Use Globalping to query your domain's DNS record, which should return IP addresses representing
the used load balancers. Then, run the same dig command repeatedly and see if it returns different IP, showing the load balancer in action. `
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Debug CDN and multi-CDN setups'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Dig can also help you optimize global content delivery and troubleshoot CDN and multi-CDN setups. For example, use Globalping to perform
DNS queries by running dig from ${locationName} to identify the region's CDN nodes responsible for content delivery. This way, you can verify whether the content
is served to users from the closest nodes and compare DNS response times to find potential performance issues.`
        }],
        mtr: [{
          type: CONTENT_TYPE_HEADER,
          content: 'What is mtr?'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `MTR (My Traceroute) is a network testing and troubleshooting utility that combines the functionality of the ping and traceroute commands.
It's designed to help identify issues along the path between your device and a specific destination, including connectivity problems, packet loss, and high latency.`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `When you run mtr, it sends small data packets to the target host. As the data travels through the network, mtr records information about
each hop (typically a router) passed on the way. For each hop, it notes the IP address and continuously updates the packet loss percentage and the average and
current round-trip time (RTT). While traceroute provides a snapshot of the network path at a specific time, mtr lets you observe what happens as the test progresses.`
        }, {
          type: CONTENT_TYPE_HEADER,
          content: 'What are typical scenarios for using mtr?'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: 'Here are three examples of what you can accomplish with mtr:'
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Analyze & troubleshoot network paths'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Running mtr gives you real-time data showing the network path between your device and a target host. By providing the IP address, hostname,
RTTs, and packet loss percentage for each hop, you can find bottlenecks and other problematic points and start targeted troubleshooting.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Plan & optimize network infrastructure'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Want to update the routing to improve your network infrastructure? Then run mtr to get data about your network paths before and after the
changes. This helps you determine if you're on the right track and take quick action if the results are not meeting your expectations.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Measure performance'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `MTR is also helpful in troubleshooting network issues that impact latency by helping you locate the root cause within the network.
Observe each hop's round-trip time (RTT) as the test progresses, and you can hopefully find the hops contributing to high latency and take measures, such as
moving servers or using a CDN.`
        }, {
          type: CONTENT_TYPE_HEADER,
          content: `What are typical use cases to run mtr from ${locationName}?`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `When troubleshooting network issues, running mtr from your location or a server you can access is often not enough. Instead, you may
want to perform measurements from various locations worldwide - fortunately, Globalping's global probe network allows you to do just that.`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: 'Running mtr globally expands the previously described usage scenarios:'
        }, {
          type: CONTENT_TYPE_LIST,
          content: ['Analyze, plan, and optimize network paths from various regions', 'Troubleshoot network problems wherever they occur', 'Optimize content delivery for your international users']
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `But there's more you can achieve when you run mtr from different places:`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Investigate regional user issues'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `If you receive reports from your users about connection problems, use Globalping to run mtr from ${locationName} or just about any
other location. This allows you to find the network segments that aren't working properly and then determine the needed steps to get to the bottom of the problem.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'SLA monitoring'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `If you have service level agreements with customers worldwide, monitoring your network infrastructure with mtr can help ensure that
performance and reliability meet agreed metrics. Of course, you can also use this in reverse to ensure that your SLAs with service providers are met in
various locations.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Compare CDN performance and quality'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Want to find the best content delivery networks (CDN) in ${locationName} or other locations? Use Globalping to run mtr from different sites
within ${locationName} to compare the performance and reliability of the providers' network infrastructures. Then, compare the results with those from other regions
to find the CDN provider that best meets your needs in your most important locations.`
        }],
        http: [{
          type: CONTENT_TYPE_HEADER,
          content: 'What is curl?'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: 'Curl is a tool that lets you make HTTP requests and retrieve content or get information from URLs directly from the command line.'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `You often use curl to make HEAD or GET requests to URLs. For instance, when you make a HEAD request, you get information about the host
and web server associated with the URL. For a GET request, the server responds with the contents of the URL, such as a web page or data from an API GET endpoint.
Each response from the server contains a status code like 404 for "not found" or 200 for successful requests. You can use these codes to determine if the requested
resource is accessible and if there are any server problems.`
        }, {
          type: CONTENT_TYPE_HEADER,
          content: 'What are some everyday use cases for curl to send HTTP requests?'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Not sure what you can achieve by sending HTTP GET or HEAD requests?
Here are some ideas:`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Verify service availability'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Adding HTTP GET and HEAD requests to your monitoring setup is an effective and simple way to keep an eye on the availability and
response times of your website or servers. Set up alerts to be able to quickly address issues and ensure that everything is back up and running in no time.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Check HTTP headers'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `When making an HTTP HEAD request to a website or API using curl, you can fetch the header information without the URL's content.
This allows you to explore and verify cache directives (e.g., ETag or Cache-Control), server information (e.g., software and version), content type, encoding,
and security measures (e.g., Content-Security-Policy or Strict-Transport-Security).`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Debugging and troubleshooting'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Curl can also be super helpful in numerous troubleshooting scenarios. For example, you can send requests to your API endpoints using
different parameter values and request headers to test and verify the responses. Or you can use it to evaluate the performance of your service by measuring
the time it takes a GET or HEAD request to your service to send you a response.`
        }, {
          type: CONTENT_TYPE_HEADER,
          content: `What can I achieve by making HTTP requests from ${locationName}?`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `If you run a website or an API, your users often report problems with your service from different locations that you'd like to investigate
but can't because the location is out of your reach. That's where our Globalping network testing platform comes to the rescue. It consists of a global probe network
that allows you to perform various network commands from anywhere.`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: 'The ability to make HTTP requests using curl from anywhere in the world makes the above scenarios even more interesting:'
        }, {
          type: CONTENT_TYPE_LIST,
          content: ['Debug and troubleshoot regional issues with your website or server', 'Verify the availability and performance of your website or API from all over the world']
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Let's explore some more use cases:`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: `Test services from your user's perspective`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Imagine your users in ${locationName} are reporting unusual behavior from one of your API GET endpoints that you can't reproduce from your
location. To get to the bottom of the problem, you can start troubleshooting by running curl from ${locationName} using Globalping. By making a GET request,
you can retrieve the API response as seen by your users, helping you learn more about the problem and determine your next troubleshooting steps.`
        }, {
          type: CONTENT_TYPE_SUBHEADER,
          content: 'Investigate censorship & content modification'
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Another interesting way to use Globalping is to run curl from ${locationName} or any other location to learn about censorship or content
modification in that area. For example, you can make a HEAD request to check if a URL is accessible or perform a GET request to compare the content of a URL
with your local version, ensuring that it hasn't been changed.`
        }, {
          type: CONTENT_TYPE_DESCR,
          content: `Globalping also provides performance metrics for each HTTP request, including the response time, content download time, time to first
byte, DNS resolution time, and the time taken to establish the TLS and TCP connection with the server. This allows you to run performance benchmarks and
comparisons from ${locationName}. Measure and understand the local and global latency of your service or the service providers you use, such as CDN, DNS, and
Edge computing companies.`
        }]
      };
    },
    testType() {
      let selectedTestType = this.get('selectedTestType');
      return selectedTestType ? selectedTestType.toLowerCase() : 'ping';
    },
    isLocationPresented() {
      let locationData = this.get('locationData');
      return locationData !== null && typeof locationData === 'object';
    }
  }
};
component$i.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-gp-test-depiction",
      g: 1
    }],
    f: [{
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "c-gp-test-depiction_test",
          g: 1
        }],
        f: [{
          t: 4,
          f: [{
            t: 4,
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "c-gp-test-depiction_test_header",
                  g: 1
                }],
                f: [{
                  t: 2,
                  r: "./content"
                }]
              }],
              n: 50,
              r: "isLocationPresented"
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "c-placeholder-skeleton",
                m: [{
                  n: "type",
                  f: "header",
                  t: 13,
                  g: 1
                }]
              }],
              n: 51,
              l: 1
            }],
            n: 50,
            x: {
              r: ["./type"],
              s: "_0===\"header\""
            }
          }, {
            t: 4,
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "c-gp-test-depiction_test_subheader",
                  g: 1
                }],
                f: [{
                  t: 2,
                  r: "./content"
                }]
              }],
              n: 50,
              r: "isLocationPresented"
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "c-placeholder-skeleton",
                m: [{
                  n: "type",
                  f: "subheader",
                  t: 13,
                  g: 1
                }]
              }],
              n: 51,
              l: 1
            }, " "],
            n: 50,
            x: {
              r: ["./type"],
              s: "_0===\"subheader\""
            },
            l: 1
          }, {
            t: 4,
            f: [" ", {
              t: 4,
              f: [{
                t: 7,
                e: "p",
                m: [{
                  t: 13,
                  n: "class",
                  f: "c-gp-test-depiction_test_descr",
                  g: 1
                }],
                f: [{
                  t: 2,
                  r: "./content"
                }]
              }],
              n: 50,
              r: "isLocationPresented"
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "c-placeholder-skeleton",
                m: [{
                  n: "type",
                  f: "descr",
                  t: 13,
                  g: 1
                }]
              }],
              n: 51,
              l: 1
            }, " "],
            n: 50,
            x: {
              r: ["./type"],
              s: "_0===\"descr\""
            },
            l: 1
          }, {
            t: 4,
            f: [" ", {
              t: 4,
              f: [{
                t: 7,
                e: "ul",
                m: [{
                  t: 13,
                  n: "class",
                  f: "c-gp-test-depiction_test_list",
                  g: 1
                }],
                f: [{
                  t: 4,
                  f: [{
                    t: 7,
                    e: "li",
                    f: [{
                      t: 2,
                      r: "."
                    }]
                  }],
                  n: 52,
                  r: "./content"
                }]
              }],
              n: 50,
              r: "isLocationPresented"
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "c-placeholder-skeleton",
                m: [{
                  n: "type",
                  f: "list",
                  t: 13,
                  g: 1
                }, {
                  n: "content",
                  f: [{
                    t: 2,
                    r: "./content"
                  }],
                  t: 13
                }]
              }],
              n: 51,
              l: 1
            }],
            n: 50,
            x: {
              r: ["./type"],
              s: "_0===\"list\""
            },
            l: 1
          }],
          n: 52,
          rx: {
            r: "contentPerTestType",
            m: [{
              t: 30,
              n: "testType"
            }]
          }
        }]
      }],
      n: 50,
      r: "testType"
    }]
  }],
  e: {
    "_0===\"header\"": function (_0) {
      return _0 === "header";
    },
    "_0===\"subheader\"": function (_0) {
      return _0 === "subheader";
    },
    "_0===\"descr\"": function (_0) {
      return _0 === "descr";
    },
    "_0===\"list\"": function (_0) {
      return _0 === "list";
    }
  }
};
component$i.exports.components = {
  "c-placeholder-skeleton": placeholderSkeleton
};
var testDepiction = ractive.extend(component$i.exports);

var component$h = {
  exports: {}
};
const DEFAULT_LIMIT$1 = 3;
const INITIAL_OPTS_VALUES$1 = {
  type: 'Ping',
  target: 'cdn.jsdelivr.net'
};
const CAPITALIZE_EXCLUDE_LIST = ['and', 'or', 'from', 'ltd', 'of'];
const RATE_LIMIT_HEADERS$1 = ['x-ratelimit-remaining', 'x-ratelimit-reset', 'x-credits-remaining', 'x-request-cost'];
const PROBE_NO_TIMING_VALUE$1 = _.getProbeTimeOutValue();
const PROBE_STATUS_OFFLINE$1 = _.getProbeStatusOfflineValue();
component$h.exports = {
  data() {
    return {
      _,
      title: '',
      description: '',
      selectedTestType: null,
      displayingTestType: INITIAL_OPTS_VALUES$1.type,
      btnTestType: INITIAL_OPTS_VALUES$1.type,
      testTypesList: [{
        name: 'Ping',
        toDisplay: 'Ping'
      }, {
        name: 'Traceroute',
        toDisplay: 'Traceroute'
      }, {
        name: 'DNS',
        toDisplay: 'DNS resolve'
      }, {
        name: 'MTR',
        toDisplay: 'MTR'
      }, {
        name: 'HTTP',
        toDisplay: 'HTTP'
      }],
      testOpts: {
        target: INITIAL_OPTS_VALUES$1.target,
        limit: ''
      },
      inputErrors: {},
      errorMessage: null,
      testResults: null,
      testInProgress: false,
      testReqCancelFn: null,
      defaultTestLimit: DEFAULT_LIMIT$1,
      probesResponse: null,
      locationData: null,
      totalProbesCnt: 0,
      parsedLocations: {
        cities: {},
        asns: {},
        networks: {},
        countries: {},
        continents: {},
        regions: {},
        states: {},
        cloudRegions: {}
      },
      highLevelLocationHref: null,
      probesParsed: false,
      testReqParams: null,
      preparedTestResults: [],
      hiddenTestResults: {
        0: []
      },
      rawLocation: null,
      rawLocationToDisplay: null,
      allRequiredDataReady: false
    };
  },
  onconfig() {
    if (!ractive.isServer) {
      let title, description;
      let {
        rawTestType,
        rawLocation,
        rawLocationToDisplay
      } = this.getInitialRawDataFromUrl();

      // create temp title, descr before any checks, required by GA
      title = this.createMetaTitle(rawTestType, rawLocationToDisplay);
      description = this.createMetaDescr(rawTestType, rawLocationToDisplay);
      this.set('title', title);
      this.set('description', description);
      this.set('selectedTestType', rawTestType);
      this.set('rawLocation', rawLocation);
      this.set('rawLocationToDisplay', rawLocationToDisplay);
    }
  },
  oninit() {
    if (!ractive.isServer) {
      this.getGlobalpingProbesData();
      this.observe('selectedTestType', selectedTestType => {
        if (selectedTestType) {
          switch (selectedTestType.toLowerCase()) {
            case 'mtr':
            case 'http':
              this.set('displayingTestType', selectedTestType.toUpperCase());
              this.set('btnTestType', selectedTestType.toUpperCase());
              break;
            case 'dns':
              this.set('displayingTestType', `${selectedTestType.toUpperCase()} resolve`);
              this.set('btnTestType', selectedTestType.toUpperCase());
              break;
            default:
              this.set('displayingTestType', _.capitalizeStrEveryFirstLetter(selectedTestType));
              this.set('btnTestType', _.capitalizeStrEveryFirstLetter(selectedTestType));
          }
        }
        this.set('inputErrors', {});
        this.set('testResults', null);
        this.expandAllRawOutput();
      });
      this.observe('realTimeTestResResponse', realTimeTestResResponse => {
        if (realTimeTestResResponse.status === 'finished') {
          this.get('testReqCancelFn')?.();
          this.set('testInProgress', false);
        }
        let prevTestResults = this.get('testResults') || [];
        let updTestResults = realTimeTestResResponse.results.map((res, resIdx) => ({
          ...res,
          clientSideId: res.clientSideId ?? resIdx
        }));

        // filter out results that have already been drawn
        prevTestResults = prevTestResults.filter(prevRes => {
          return !updTestResults.some(updRes => updRes.clientSideId === prevRes.clientSideId);
        });
        this.set('testResults', [...prevTestResults, ...updTestResults]);
      }, {
        init: false
      });

      // check if everything is already set and we can get LocationData etc.
      this.observe('probesParsed selectedTestType rawLocation', () => {
        let probesParsed = this.get('probesParsed');
        let selectedTestType = this.get('selectedTestType');
        let rawLocation = this.get('rawLocation');
        if (probesParsed && selectedTestType && rawLocation) {
          this.set('allRequiredDataReady', true);
        } else {
          this.set('allRequiredDataReady', false);
        }
      });

      // create and set meta title, description; locationData, highLevelLocationHref
      // check if location is correct or presented in the available probes locations
      this.observe('allRequiredDataReady', allRequiredDataReady => {
        if (allRequiredDataReady === false) {
          return;
        }
        let selectedTestType = this.get('selectedTestType');
        let rawLocation = this.get('rawLocation');

        // handle locationData, highLevelLocationHref
        if (rawLocation && rawLocation.toLowerCase() !== 'world') {
          let locationData = this.getLocDataByLocValue(rawLocation);
          if (locationData) {
            // if both location and testType are correct and present
            this.set('locationData', locationData);
            this.set('highLevelLocationHref', `${commonjsGlobal.location.origin}${this.modifyQueryPart(selectedTestType, locationData.fromAsUrlPart)}`);
          } else {
            // when testType correct but location absent at the moment among the probes or incorrect
            this.moveToNewPageURL(selectedTestType);
            return;
          }
        } else {
          this.set('locationData', {
            from: 'World',
            probesCnt: this.get('totalProbesCnt')
          });
          this.set('highLevelLocationHref', `${commonjsGlobal.location.origin}${this.modifyQueryPart(selectedTestType)}`);
        }

        // handle meta tag title and description once location is confirmed as presented
        let locationData = this.getLocDataByLocValue(rawLocation);
        let title = this.createMetaTitle(selectedTestType, locationData ? locationData.name : 'World');
        let description = this.createMetaDescr(selectedTestType, locationData ? locationData.name : 'world');
        this.set('title', title);
        this.set('description', description);
      });

      // set measurementsMetadata for the c-gp-results-share component
      this.observe('testReqParams', testReqParams => {
        if (!testReqParams) {
          return;
        }
        let measurementsMetadata = {
          0: {
            target: testReqParams.target,
            measurementId: testReqParams.id
          }
        };
        this.set('measurementsMetadata', measurementsMetadata);
      });

      // prepare results for gp-results-raw-output
      this.observe('testResults', testResults => {
        if (!testResults) {
          return;
        }
        this.set('preparedTestResults', this.prepareRegularResults(testResults));
      });
    }
  },
  oncomplete() {
    if (!ractive.isServer) {
      // run the test if user is pressed Enter inside of any of options inputs
      let targetInput = this.find('#targetInput');
      let limitInput = this.find('#limitInput');
      let handleEnterBtn = event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.proceedToTest();
        }
      };
      targetInput.addEventListener('keypress', handleEnterBtn);
      limitInput.addEventListener('keypress', handleEnterBtn);
    }
  },
  onunrender() {
    this.get('testReqCancelFn')?.();
  },
  expandAllRawOutput() {
    this.set('hiddenTestResults', {
      0: []
    });
  },
  proceedToTest() {
    let type = this.get('selectedTestType');
    let testOpts = this.get('testOpts');
    let {
      name: magic = 'World'
    } = this.get('locationData');
    let reqParams = {
      type,
      ...testOpts,
      locations: [{
        magic
      }]
    };
    if (!reqParams.limit) {
      reqParams.limit = DEFAULT_LIMIT$1;
    }

    // clear all data from the previous test, show spinner
    this.set('testResults', null);
    this.set('testInProgress', true);
    this.set('testReqParams', null);
    this.set('errorMessage', null);
    this.set('preparedTestResults', []);
    this.expandAllRawOutput();
    http.postGlobalpingMeasurement(reqParams, RATE_LIMIT_HEADERS$1).then(res => {
      this.getTestMeasurementById(res.response.id);
    }).catch(err => {
      let errBody = err?.error;
      this.set('testInProgress', false);
      if (errBody?.type === 'validation_error') {
        let inputErrors = _.parseValidationErrors(errBody);
        this.set('inputErrors', inputErrors);
      } else if (err.responseStatusCode === 429) {
        let measurementErrMsg = _.createMeasCreditsErrMsg(err.responseHeaders, this.get('@shared.user'));
        this.set('errorMessage', measurementErrMsg);
      } else {
        this.set('errorMessage', err.error?.message ?? 'An unexpected error occurred.');
      }
    });
  },
  parseProbesResponse(data) {
    return data.reduce((res, {
      tags,
      location
    }) => {
      let cityNameLC = location.city.toLowerCase();
      let cityNameAsUrlPart = cityNameLC.split(' ').join('-');
      let countryCodeLC = location.country.toLowerCase();
      let countryNameLC = countries.find(i => i.code.toLowerCase() === countryCodeLC).name.toLowerCase();
      let countryNameAsUrlPart = countryNameLC.split(' ').join('-');
      let asnName = `as${location.asn}`;
      let networkNameAsKey = _.networkNameToKey(location.network);
      let continentCodeLC = location.continent.toLowerCase();
      let continentNameLC = CONTINENTS.find(i => i.code.toLowerCase() === continentCodeLC).name.toLowerCase();
      let continentNameAsUrlPart = continentNameLC.split(' ').join('-');
      let regionNameLC = location.region.toLowerCase();
      let regionNameAsUrlPart = regionNameLC.split(' ').join('-');
      let stateCodeLC = location.state ? location.state.toLowerCase() : null;
      let stateNameLC = stateCodeLC ? usaStates.find(i => i.code.toLowerCase() === stateCodeLC).name.toLowerCase() : null;
      let stateNameAsUrlPart = stateNameLC ? stateNameLC.split(' ').join('-') : null;
      tags.forEach(tag => {
        let tagLC = tag.toLowerCase();
        if (!_.isTagCloudRegion(tagLC)) {
          return;
        }
        if (!Object.keys(res.cloudRegions).includes(tagLC)) {
          res.cloudRegions[tagLC] = {
            name: tagLC,
            from: 'world',
            probesCnt: 1,
            fromAsUrlPart: tagLC
          };
        } else {
          res.cloudRegions[tagLC].probesCnt += 1;
        }
      });

      // collect uniques cities and count amount of probes per city
      if (!Object.keys(res.cities).includes(cityNameAsUrlPart)) {
        res.cities[cityNameAsUrlPart] = {
          name: cityNameLC,
          from: countries.find(i => i.code.toLowerCase() === countryCodeLC).name.toLowerCase(),
          probesCnt: 1,
          fromAsUrlPart: countryNameAsUrlPart
        };
      } else {
        res.cities[cityNameAsUrlPart].probesCnt += 1;
      }

      // collect uniques ASNs and count amount of probes per ASN
      if (!Object.keys(res.asns).includes(asnName)) {
        res.asns[asnName] = {
          name: asnName,
          from: location.network,
          probesCnt: 1,
          fromAsUrlPart: networkNameAsKey
        };
      } else {
        res.asns[asnName].probesCnt += 1;
      }

      // collect uniques Networks and count amount of probes per Network
      if (!Object.keys(res.networks).includes(networkNameAsKey)) {
        res.networks[networkNameAsKey] = {
          name: location.network,
          from: 'world',
          probesCnt: 1,
          fromAsUrlPart: 'world'
        };
      } else {
        res.networks[networkNameAsKey].probesCnt += 1;
      }

      // collect uniques Countries and count amount of probes per Country
      if (!Object.keys(res.countries).includes(countryNameAsUrlPart)) {
        res.countries[countryNameAsUrlPart] = {
          name: countryNameLC,
          from: continentNameLC,
          probesCnt: 1,
          fromAsUrlPart: continentNameAsUrlPart
        };
      } else {
        res.countries[countryNameAsUrlPart].probesCnt += 1;
      }

      // collect uniques Continents and count amount of probes per Continent
      if (!Object.keys(res.continents).includes(continentNameAsUrlPart)) {
        res.continents[continentNameAsUrlPart] = {
          name: continentNameLC,
          from: 'world',
          probesCnt: 1,
          fromAsUrlPart: 'world'
        };
      } else {
        res.continents[continentNameAsUrlPart].probesCnt += 1;
      }

      // collect uniques Regions and count amount of probes per Region
      if (!Object.keys(res.regions).includes(regionNameAsUrlPart)) {
        res.regions[regionNameAsUrlPart] = {
          name: regionNameLC,
          from: 'world',
          probesCnt: 1,
          fromAsUrlPart: 'world'
        };
      } else {
        res.regions[regionNameAsUrlPart].probesCnt += 1;
      }

      // collect uniques states (if they are present) and count amount of probes per state
      if (stateNameAsUrlPart) {
        if (!Object.keys(res.states).includes(stateNameAsUrlPart)) {
          res.states[stateNameAsUrlPart] = {
            name: stateNameLC,
            from: countries.find(i => i.code.toLowerCase() === countryCodeLC).name.toLowerCase(),
            probesCnt: 1,
            fromAsUrlPart: countryNameAsUrlPart
          };
        } else {
          res.states[stateNameAsUrlPart].probesCnt += 1;
        }
      }
      return res;
    }, {
      cities: {},
      asns: {},
      networks: {},
      countries: {},
      continents: {},
      regions: {},
      states: {},
      cloudRegions: {}
    });
  },
  getLocDataByLocValue(location = '') {
    let locationLC = location.toLowerCase();
    let parsedLocations = this.get('parsedLocations');

    // check if the location is a city
    if (parsedLocations.cities[locationLC]) {
      let {
        name,
        from,
        probesCnt,
        fromAsUrlPart
      } = parsedLocations.cities[locationLC];
      return {
        name: _.capitalizeStrEveryFirstLetter(name),
        from: _.capitalizeStrEveryFirstLetter(from),
        probesCnt,
        fromAsUrlPart,
        type: 'city'
      };
    }

    // check if the location is an ASN
    if (parsedLocations.asns[locationLC]) {
      let {
        name,
        from,
        probesCnt,
        fromAsUrlPart
      } = parsedLocations.asns[locationLC];
      return {
        name: name.toUpperCase(),
        from,
        probesCnt,
        fromAsUrlPart,
        type: 'asn'
      };
    }

    // check if the location is a Network
    if (parsedLocations.networks[locationLC]) {
      let {
        name,
        from,
        probesCnt,
        fromAsUrlPart
      } = parsedLocations.networks[locationLC];
      return {
        name,
        from: _.capitalizeStrEveryFirstLetter(from),
        probesCnt,
        fromAsUrlPart,
        type: 'isp'
      };
    }

    // check if the location is a Country
    if (parsedLocations.countries[locationLC]) {
      let {
        name,
        from,
        probesCnt,
        fromAsUrlPart
      } = parsedLocations.countries[locationLC];
      return {
        name: _.capitalizeStrEveryFirstLetter(name),
        from: _.capitalizeStrEveryFirstLetter(from, CAPITALIZE_EXCLUDE_LIST),
        probesCnt,
        fromAsUrlPart,
        type: 'country'
      };
    }

    // check if the location is a Continent
    if (parsedLocations.continents[locationLC]) {
      let {
        name,
        from,
        probesCnt,
        fromAsUrlPart
      } = parsedLocations.continents[locationLC];
      return {
        name: _.capitalizeStrEveryFirstLetter(name),
        from: _.capitalizeStrEveryFirstLetter(from),
        probesCnt,
        fromAsUrlPart,
        type: 'continent'
      };
    }

    // check if the location is a Region
    if (parsedLocations.regions[locationLC]) {
      let {
        name,
        from,
        probesCnt,
        fromAsUrlPart
      } = parsedLocations.regions[locationLC];
      return {
        name: _.capitalizeStrEveryFirstLetter(name),
        from: _.capitalizeStrEveryFirstLetter(from),
        probesCnt,
        fromAsUrlPart,
        type: 'region'
      };
    }

    // check if the location is a State
    if (parsedLocations.states[locationLC]) {
      let {
        name,
        from,
        probesCnt,
        fromAsUrlPart
      } = parsedLocations.states[locationLC];
      return {
        name: _.capitalizeStrEveryFirstLetter(name),
        from: _.capitalizeStrEveryFirstLetter(from),
        probesCnt,
        fromAsUrlPart,
        type: 'state'
      };
    }
    if (parsedLocations.cloudRegions[locationLC]) {
      return {
        ...parsedLocations.cloudRegions[locationLC],
        type: 'cloudRegion'
      };
    }
  },
  getTestMeasurementById(measurementId) {
    let cancelled = false;
    let timeout = null;
    let cancel = () => {
      cancelled = true;
      clearTimeout(timeout);
      timeout = null;
    };
    let fetch = () => {
      if (cancelled) {
        return;
      }
      http.getGlobalpingMeasurement(measurementId).then(testRes => {
        // prepare and set request params to pass them to gp-test-results
        let testReqParams = JSON.parse(JSON.stringify(testRes));
        delete testReqParams.results;
        delete testReqParams.status;
        delete testReqParams.updatedAt;
        delete testReqParams.createdAt;
        testReqParams = {
          inProgressUpdates: true,
          limit: DEFAULT_LIMIT$1,
          ...testReqParams,
          measurementOptions: {
            trace: false,
            ...testReqParams.measurementOptions
          }
        };

        // set testReqParams to pass them to c-gp-results-raw-output
        this.set('testReqParams', testReqParams);

        // should be after the mainOptions.type was set
        this.set('realTimeTestResResponse', testRes);
        if (!cancelled) {
          timeout = setTimeout(fetch, 500);
        }
      }).catch(() => {
        cancel();
      });
    };
    fetch();
    this.set('testReqCancelFn', cancel);
  },
  handleTestTypeSelect(testTypeName) {
    this.set('selectedTestType', testTypeName);
    let newPath = this.modifyQueryPart(testTypeName);
    app.router.dispatch(newPath, {
      noScroll: true
    });
  },
  moveToNewPageURL(testType, newLocation = 'world') {
    let newPath = this.modifyQueryPart(testType, newLocation);
    window.location.replace(newPath);
  },
  modifyQueryPart(testType = 'ping', newLocation = null) {
    let newQueryTestFromValue = '';
    if (newLocation) {
      newQueryTestFromValue = `${testType}-from-${newLocation}`;
    } else {
      let splittedQueryTestFrom = app.router.uri.path.split('/');
      let currQueryTestFromValue = splittedQueryTestFrom[splittedQueryTestFrom.length - 1];
      newQueryTestFromValue = currQueryTestFromValue.replace(/[A-Za-z]+/, `${testType}`);
    }
    return `/network-tools/${newQueryTestFromValue.toLowerCase()}`;
  },
  getGlobalpingProbesData() {
    dataCache.getCache('probesResponse', 60 * 1000, http.fetchGlobalpingProbes).then(response => {
      this.set('parsedLocations', this.parseProbesResponse(response));
      this.set('totalProbesCnt', response.length);
      this.set('probesParsed', true);
    }).catch(error => {
      console.error('Failed to fetch probes', error);
    });
  },
  checkIfTestTypeCorrect(testType) {
    if (!testType) {
      return false;
    }
    let testTypesList = this.get('testTypesList');
    return testTypesList.some(i => i.name.toLowerCase() === testType.toLowerCase());
  },
  createMetaTitle(testType, location) {
    switch (testType.toLowerCase()) {
      case 'dns':
      case 'mtr':
      case 'http':
        testType = testType.toUpperCase();
        break;
      default:
        testType = _.capitalizeFirstLetter(testType);
    }
    return `${testType} for free from ${location} - Global ${testType} tests by Globalping`;
  },
  createMetaDescr(testType, location) {
    let description = `Run ${testType} network tests for free from multiple global regions`;
    if (location.toLowerCase() !== 'world') {
      description += ` like ${location}`;
    }
    description += ' to any endpoint including IP addresses, websites, CDN or cloud providers. Test the network latency and uptime regionally';
    if (location.toLowerCase() !== 'world') {
      description += ` in ${location}`;
    }
    description += ' or globally.';
    return description;
  },
  prepareRegularResults(testResults) {
    let dnsTraceEnabled = this.get('testReqParams.measurementOptions.trace');
    let selectedTestType = this.get('selectedTestType');
    return testResults.map((res, resIdx) => {
      let preparedRes = {
        ...res.probe,
        clientSideId: res.clientSideId ?? resIdx,
        statsPerTarget: [{
          target: res.target
        }]
      };
      if (res.result.status !== 'in-progress') {
        let {
          isFailed = false,
          lastTiming,
          value: avgTiming,
          extraValues
        } = _.calcGpTestResTiming(selectedTestType, res, dnsTraceEnabled);
        let {
          packetsTotal
        } = _.parseGpRawOutputForTimings(res.result.rawOutput);
        let minTiming = res.result?.stats?.min || PROBE_NO_TIMING_VALUE$1;
        let maxTiming = res.result?.stats?.max || PROBE_NO_TIMING_VALUE$1;
        let isOffline = res.result.status === PROBE_STATUS_OFFLINE$1;
        preparedRes.statsPerTarget = [{
          ...preparedRes.statsPerTarget[0],
          ipAddr: res.result.resolvedAddress,
          avgTiming,
          isFailed,
          isOffline,
          extraValues,
          rawOutput: res.result.rawOutput,
          areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal)
        }];
      }
      return preparedRes;
    });
  },
  checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal) {
    if (!packetsTotal || typeof lastTiming === 'undefined' || typeof maxTiming === 'undefined' || typeof minTiming === 'undefined' || typeof avgTiming === 'undefined') {
      return false;
    }
    return true;
  },
  getInitialRawDataFromUrl() {
    let rawParamsValue = this.get('params');
    let clearParamsValue = rawParamsValue.replace(/\/network-tools\/?/, '').toLowerCase();
    let splitPoint = '-from-';
    let splitPointIdx = clearParamsValue.indexOf(splitPoint);
    let [rawTestType, rawLocation = 'world'] = splitPointIdx === -1 ? clearParamsValue.split(splitPoint) : [clearParamsValue.slice(0, splitPointIdx), clearParamsValue.slice(splitPointIdx + splitPoint.length)];
    let rawLocationToDisplay = _.capitalizeStrEveryFirstLetter((rawLocation || 'world').split('-').join(' '), CAPITALIZE_EXCLUDE_LIST);
    return {
      rawTestType,
      rawLocation,
      rawLocationToDisplay
    };
  }
};
component$h.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "r-page",
    m: [{
      n: "noYield",
      f: [{
        t: 2,
        r: "noYield"
      }],
      t: 13
    }, {
      n: "title",
      f: [{
        t: 2,
        r: "title"
      }],
      t: 13
    }, {
      n: "description",
      f: [{
        t: 2,
        r: "description"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "c-notification"
    }, " ", {
      t: 7,
      e: "c-gp-header",
      m: [{
        n: "additionalClasses",
        f: "header-with-globalping-bg",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "p-globalping-network-tools",
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-nettools_main-info",
          g: 1
        }],
        f: [{
          t: 7,
          e: "c-gp-jumbotron",
          m: [{
            n: "className",
            f: "network-tools",
            t: 13,
            g: 1
          }, {
            n: "gridType",
            f: "type2",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-nettools_main-info_content",
            g: 1
          }],
          f: [{
            t: 4,
            f: [{
              t: 7,
              e: "h1",
              f: [{
                t: 2,
                r: "displayingTestType"
              }, " from ", {
                t: 4,
                f: ["multiple locations in"],
                n: 50,
                r: "locationData.probesCnt"
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp-nettools_main-info_content_location",
                g: 1
              }],
              f: [{
                t: 4,
                f: [{
                  t: 7,
                  e: "span",
                  f: [{
                    t: 2,
                    r: "locationData.name"
                  }]
                }],
                n: 50,
                r: "locationData.name"
              }, " ", {
                t: 4,
                f: [{
                  t: 4,
                  f: [{
                    t: 7,
                    e: "span",
                    f: [", "]
                  }],
                  n: 50,
                  r: "locationData.name"
                }, " ", {
                  t: 7,
                  e: "a",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-nettools_green-text",
                    g: 1
                  }, {
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: [{
                      t: 2,
                      r: "highLevelLocationHref"
                    }],
                    t: 13
                  }],
                  f: [{
                    t: 2,
                    r: "locationData.from"
                  }]
                }],
                n: 51,
                x: {
                  r: ["locationData.type"],
                  s: "_0===\"asn\"||_0===\"isp\"||_0===\"cloudRegion\""
                }
              }]
            }, " ", {
              t: 4,
              f: [{
                t: 7,
                e: "a",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-nettools_network-link",
                  g: 1
                }, {
                  n: "href",
                  f: ["/networks/", {
                    t: 2,
                    r: "locationData.fromAsUrlPart"
                  }],
                  t: 13
                }],
                f: [{
                  t: 2,
                  r: "locationData.from"
                }]
              }],
              n: 50,
              x: {
                r: ["locationData.type"],
                s: "_0===\"asn\""
              }
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp-nettools_main-info_content_input-block",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                f: ["Run a Free"]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_dropdown_alt",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "btn-group",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "button",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "dropdown-toggle",
                      g: 1
                    }, {
                      n: "type",
                      f: "button",
                      t: 13,
                      g: 1
                    }, {
                      n: "data-toggle",
                      f: "dropdown",
                      t: 13,
                      g: 1
                    }, {
                      n: "aria-haspopup",
                      f: "true",
                      t: 13,
                      g: 1
                    }, {
                      n: "aria-expanded",
                      f: "false",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "span",
                      f: [{
                        t: 2,
                        r: "~/displayingTestType"
                      }]
                    }, " ", {
                      t: 7,
                      e: "i",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-angle-down",
                        g: 1
                      }, {
                        n: "aria-hidden",
                        f: "true",
                        t: 13,
                        g: 1
                      }]
                    }]
                  }, " ", {
                    t: 7,
                    e: "ul",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "dropdown-menu",
                      g: 1
                    }, {
                      n: "role",
                      f: "listbox",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 4,
                      f: [{
                        t: 4,
                        f: [{
                          t: 7,
                          e: "li",
                          m: [{
                            n: "aria-selected",
                            f: "false",
                            t: 13,
                            g: 1
                          }, {
                            n: "role",
                            f: "option",
                            t: 13,
                            g: 1
                          }, {
                            n: ["click"],
                            t: 70,
                            f: {
                              r: ["@this", "./name"],
                              s: "[_0.handleTestTypeSelect(_1)]"
                            }
                          }],
                          f: [{
                            t: 2,
                            r: "./toDisplay"
                          }]
                        }],
                        n: 50,
                        x: {
                          r: ["./toDisplay", "displayingTestType"],
                          s: "_0!==_1"
                        }
                      }],
                      n: 52,
                      r: "~/testTypesList"
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "span",
                f: ["test"]
              }]
            }],
            n: 50,
            r: "locationData"
          }, {
            t: 4,
            f: [{
              t: 7,
              e: "h1",
              f: [{
                t: 2,
                r: "displayingTestType"
              }, " from multiple locations in"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp-nettools_main-info_content_temp-location",
                g: 1
              }],
              f: [{
                t: 4,
                f: [{
                  t: 2,
                  r: "rawLocationToDisplay"
                }, ","],
                n: 50,
                x: {
                  r: ["rawLocationToDisplay"],
                  s: "_0.toLowerCase()!==\"world\""
                }
              }, " ", {
                t: 7,
                e: "a",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-nettools_green-text",
                  g: 1
                }, {
                  n: "target",
                  f: "_blank",
                  t: 13,
                  g: 1
                }, {
                  n: "rel",
                  f: "noopener noreferrer",
                  t: 13,
                  g: 1
                }, {
                  n: "href",
                  f: [{
                    t: 2,
                    r: "global.location.origin"
                  }, "/network-tools/", {
                    t: 2,
                    r: "selectedTestType"
                  }, "-from-world"],
                  t: 13
                }],
                f: ["World"]
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp-nettools_main-info_content_input-block",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                f: ["Run a Free"]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp_dropdown_alt",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "btn-group",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "button",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "dropdown-toggle",
                      g: 1
                    }, {
                      n: "type",
                      f: "button",
                      t: 13,
                      g: 1
                    }, {
                      n: "data-toggle",
                      f: "dropdown",
                      t: 13,
                      g: 1
                    }, {
                      n: "aria-haspopup",
                      f: "true",
                      t: 13,
                      g: 1
                    }, {
                      n: "aria-expanded",
                      f: "false",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "span",
                      f: [{
                        t: 2,
                        r: "~/displayingTestType"
                      }]
                    }, " ", {
                      t: 7,
                      e: "i",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-angle-down",
                        g: 1
                      }, {
                        n: "aria-hidden",
                        f: "true",
                        t: 13,
                        g: 1
                      }]
                    }]
                  }, " ", {
                    t: 7,
                    e: "ul",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "dropdown-menu",
                      g: 1
                    }, {
                      n: "role",
                      f: "listbox",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 4,
                      f: [{
                        t: 4,
                        f: [{
                          t: 7,
                          e: "li",
                          m: [{
                            n: "aria-selected",
                            f: "false",
                            t: 13,
                            g: 1
                          }, {
                            n: "role",
                            f: "option",
                            t: 13,
                            g: 1
                          }, {
                            n: ["click"],
                            t: 70,
                            f: {
                              r: ["@this", "./name"],
                              s: "[_0.handleTestTypeSelect(_1)]"
                            }
                          }],
                          f: [{
                            t: 2,
                            r: "./toDisplay"
                          }]
                        }],
                        n: 50,
                        x: {
                          r: ["./toDisplay", "displayingTestType"],
                          s: "_0!==_1"
                        }
                      }],
                      n: 52,
                      r: "~/testTypesList"
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "span",
                f: ["test"]
              }]
            }],
            n: 50,
            r: "rawLocationToDisplay",
            l: 1
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-nettools_demo-tools",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-nettools_demo-tools_head",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span"
          }, " ", {
            t: 7,
            e: "span"
          }, " ", {
            t: 7,
            e: "span"
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-nettools_demo-tools_ctrls",
            g: 1
          }],
          f: [{
            t: 7,
            e: "c-controlled-input",
            m: [{
              n: "id",
              f: "targetInput",
              t: 13,
              g: 1
            }, {
              n: "value",
              f: [{
                t: 2,
                r: "testOpts.target"
              }],
              t: 13
            }, {
              n: "error",
              f: [{
                t: 2,
                r: "inputErrors.target"
              }],
              t: 13
            }, {
              n: "placeholder",
              f: "IP or host",
              t: 13,
              g: 1
            }, {
              n: "labelText",
              f: "Target",
              t: 13,
              g: 1
            }, {
              n: "classList",
              f: "gp-nettools_demo-tools_ctrls_target gp_input",
              t: 13,
              g: 1
            }],
            f: []
          }, " ", {
            t: 7,
            e: "c-controlled-input",
            m: [{
              n: "id",
              f: "limitInput",
              t: 13,
              g: 1
            }, {
              n: "value",
              f: [{
                t: 2,
                r: "testOpts.limit"
              }],
              t: 13
            }, {
              n: "error",
              f: [{
                t: 2,
                r: "inputErrors.limit"
              }],
              t: 13
            }, {
              n: "placeholder",
              f: [{
                t: 2,
                r: "defaultTestLimit"
              }],
              t: 13
            }, {
              n: "labelText",
              f: "Probes",
              t: 13,
              g: 1
            }, {
              n: "classList",
              f: "gp-nettools_demo-tools_ctrls_probes gp_input",
              t: 13,
              g: 1
            }],
            f: []
          }, " ", {
            t: 7,
            e: "button",
            m: [{
              n: ["click"],
              t: 70,
              f: {
                r: ["@this"],
                s: "[_0.proceedToTest()]"
              }
            }, {
              n: "class",
              f: ["gp-nettools_demo-tools_ctrls_btn gp_btn_green ", {
                t: 4,
                f: ["gp_btn_green_disabled gp_btn_green_loading"],
                n: 50,
                r: "testInProgress"
              }],
              t: 13
            }, {
              n: "data-testid",
              f: "network-tools-run-test-btn",
              t: 13,
              g: 1
            }, {
              n: "disabled",
              f: [{
                t: 2,
                r: "testInProgress"
              }],
              t: 13
            }],
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "div"
              }, " ", {
                t: 7,
                e: "div"
              }, " ", {
                t: 7,
                e: "div"
              }, " ", {
                t: 7,
                e: "div"
              }],
              n: 50,
              r: "testInProgress"
            }, {
              t: 4,
              f: ["Run ", {
                t: 2,
                r: "btnTestType"
              }, " Test"],
              n: 51,
              l: 1
            }]
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-nettools_demo-tools_fail-msg",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "56",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "56",
                t: 13,
                g: 1
              }, {
                n: "alt",
                f: "Fail icon",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/fail-icon-big.svg"],
                t: 13
              }]
            }, " ", {
              t: 7,
              e: "p",
              f: [{
                t: 3,
                r: "errorMessage"
              }]
            }]
          }],
          n: 50,
          r: "errorMessage"
        }, {
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-nettools_demo-tools_raw-output",
              g: 1
            }],
            f: [{
              t: 7,
              e: "c-gp-results-raw-output",
              m: [{
                n: "testReqParams",
                f: [{
                  t: 2,
                  r: "testReqParams"
                }],
                t: 13
              }, {
                n: "testInProgress",
                f: [{
                  t: 2,
                  r: "testInProgress"
                }],
                t: 13
              }, {
                n: "measurementsMetadata",
                f: [{
                  t: 2,
                  r: "measurementsMetadata"
                }],
                t: 13
              }, {
                n: "preparedTestResults",
                f: [{
                  t: 2,
                  r: "preparedTestResults"
                }],
                t: 13
              }, {
                n: "hiddenTestResults",
                f: [{
                  t: 2,
                  r: "hiddenTestResults"
                }],
                t: 13
              }, {
                n: "targetsCnt",
                f: [{
                  t: 2,
                  x: {
                    r: [],
                    s: "1"
                  }
                }],
                t: 13
              }, {
                n: "showSetLocationButton",
                f: [{
                  t: 2,
                  x: {
                    r: [],
                    s: "false"
                  }
                }],
                t: 13
              }, {
                n: "allowResultsBlockShrink",
                f: [{
                  t: 2,
                  x: {
                    r: [],
                    s: "true"
                  }
                }],
                t: 13
              }, {
                n: "activeTargetIdx",
                f: [{
                  t: 2,
                  x: {
                    r: [],
                    s: "0"
                  }
                }],
                t: 13
              }],
              f: []
            }]
          }, " "],
          n: 50,
          r: "testResults",
          l: 1
        }, {
          t: 4,
          f: [" ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-nettools_demo-tools_descr",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "56",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "56",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/bulb-icon.svg"],
                t: 13
              }]
            }, " ", {
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-nettools_demo-tools_descr_text",
                  g: 1
                }, {
                  n: "data-testid",
                  f: "network-tools-description",
                  t: 13,
                  g: 1
                }],
                f: ["Run a free global ", {
                  t: 2,
                  r: "displayingTestType"
                }, " test! Benchmark and compare CDN and DNS providers to understand how their networks performs. Compare hosting and cloud providers to find the fastest one globally or in your region. Run ", {
                  t: 2,
                  r: "displayingTestType"
                }, " tests from ", {
                  t: 2,
                  x: {
                    r: ["locationData.name", "locationData.from"],
                    s: "_0||_1"
                  }
                }, ", globally or from other locations or even cloud regions. Test, measure and troubleshoot your network for free using Globalping!"]
              }],
              n: 50,
              r: "locationData"
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "c-placeholder-skeleton",
                m: [{
                  n: "type",
                  f: "descr",
                  t: 13,
                  g: 1
                }]
              }],
              n: 51,
              l: 1
            }]
          }],
          n: 51,
          l: 1
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-nettools_learn-how",
          g: 1
        }],
        f: [{
          t: 4,
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp-nettools_learn-how_title",
              g: 1
            }],
            f: ["Explore how Globalping makes global network tests and benchmarking possible and free for all."]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp-nettools_learn-how_descr",
              g: 1
            }],
            f: ["Debug your web services and servers and understand and fix your routing by running network commands like ping from ", {
              t: 2,
              x: {
                r: ["locationData.name", "locationData.from"],
                s: "_0||_1"
              }
            }, " or any other location like a country or city."]
          }],
          n: 50,
          r: "locationData"
        }, {
          t: 4,
          f: [{
            t: 7,
            e: "c-placeholder-skeleton",
            m: [{
              n: "type",
              f: "header",
              t: 13,
              g: 1
            }]
          }, " ", {
            t: 7,
            e: "c-placeholder-skeleton",
            m: [{
              n: "type",
              f: "descr",
              t: 13,
              g: 1
            }]
          }],
          n: 51,
          l: 1
        }, " ", {
          t: 7,
          e: "a",
          m: [{
            t: 13,
            n: "class",
            f: "gp-nettools_learn-how_btn gp_btn_green",
            g: 1
          }, {
            n: "href",
            f: "/",
            t: 13,
            g: 1
          }],
          f: ["Learn more"]
        }]
      }, " ", {
        t: 7,
        e: "c-gp-test-depiction",
        m: [{
          n: "locationData",
          f: [{
            t: 2,
            r: "locationData"
          }],
          t: 13
        }, {
          n: "selectedTestType",
          f: [{
            t: 2,
            r: "selectedTestType"
          }],
          t: 13
        }]
      }]
    }, " ", {
      t: 7,
      e: "c-gp-footer"
    }]
  }],
  e: {
    "0": function () {
      return 0;
    },
    "1": function () {
      return 1;
    },
    "_0===\"asn\"||_0===\"isp\"||_0===\"cloudRegion\"": function (_0) {
      return _0 === "asn" || _0 === "isp" || _0 === "cloudRegion";
    },
    "_0===\"asn\"": function (_0) {
      return _0 === "asn";
    },
    "[_0.handleTestTypeSelect(_1)]": function (_0, _1) {
      return [_0.handleTestTypeSelect(_1)];
    },
    "_0!==_1": function (_0, _1) {
      return _0 !== _1;
    },
    "_0.toLowerCase()!==\"world\"": function (_0) {
      return _0.toLowerCase() !== "world";
    },
    "[_0.proceedToTest()]": function (_0) {
      return [_0.proceedToTest()];
    },
    "false": function () {
      return false;
    },
    "true": function () {
      return true;
    },
    "_0||_1": function (_0, _1) {
      return _0 || _1;
    }
  }
};
component$h.exports.components = {
  "c-placeholder-skeleton": placeholderSkeleton,
  "c-gp-test-depiction": testDepiction,
  "c-gp-jumbotron": jumbotron,
  "c-gp-results-raw-output": resultsRawOutput,
  "c-controlled-input": controlledInput,
  "c-notification": notification,
  "c-gp-footer": footer,
  "c-gp-header": header,
  "r-page": rPage
};
var networkTools = ractive.extend(component$h.exports);

var component$g = {
  exports: {}
};
component$g.exports = {
  data() {
    return {
      title: 'Our Sponsors - Globalping',
      description: 'Globalping is sponsored by Datapacket, Gcore, and other awesome companies.',
      platinumSponsors: [{
        href: 'https://www.datapacket.com/',
        linkDisplayed: 'datapacket.com',
        imgTitle: 'Sponsored by Datapacket',
        imgWidth: 263,
        imgHeight: 38,
        imgSrc: ['/img/sponsors/datapacket.svg'],
        spDescr: 'DataPacket - one partner for global infrastructure. Dedicated servers with local routing in 67 global locations. Expert account teams and always-on support.'
      }, {
        href: 'https://oneprovider.com/',
        linkDisplayed: 'oneprovider.com',
        imgTitle: 'Sponsored by OneProvider',
        imgWidth: 243,
        imgHeight: 64,
        imgSrc: ['/img/sponsors/oneprovider.svg'],
        spDescr: 'OneProvider provides worldwide hosting services with dedicated servers available in over 140 locations and its OneCloud VPS service in more than 60 locations.'
      }, {
        href: 'https://www.fastly.com/',
        linkDisplayed: 'fastly.com',
        imgTitle: 'Sponsored by Fastly',
        imgWidth: 150,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/fastly.svg'],
        spDescr: 'Fastly\'s edge cloud platform powers fast, secure, and scalable digital experiences.'
      }],
      goldSponsors: [{
        href: 'https://gcore.com/',
        linkDisplayed: 'gcore.com',
        imgTitle: 'Sponsored by Gcore',
        imgWidth: 182,
        imgHeight: 54,
        imgSrc: ['/img/sponsors/gcore.svg'],
        spDescr: 'Gcore accelerates AI training, provides comprehensive cloud services, improves content delivery, and protects servers and applications.'
      }],
      bronzeSponsors: [{
        href: 'https://xtom.com',
        imgTitle: 'Sponsored by xTom',
        imgWidth: 216,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/xtom.svg']
      }, {
        href: 'https://looking.house',
        imgTitle: 'Sponsored by Looking.house',
        imgWidth: 222,
        imgHeight: 50,
        imgSrc: ['/img/sponsors/looking-house.svg']
      }, {
        href: 'https://www.starrydns.com',
        imgTitle: 'Sponsored by StarryDNS',
        imgWidth: 229,
        imgHeight: 40,
        imgSrc: ['/img/sponsors/starry.png']
      }, {
        href: 'https://www.ip2location.io/',
        imgTitle: 'Sponsored by IP2Location',
        imgWidth: 241,
        imgHeight: 40,
        imgSrc: ['/img/sponsors/ip2location.svg']
      }, {
        href: 'https://www.exoscale.com',
        imgTitle: 'Sponsored by Exoscale',
        imgWidth: 262,
        imgHeight: 35,
        imgSrc: ['/img/sponsors/exoscale.svg']
      }, {
        href: 'https://www.fdcservers.net',
        imgTitle: 'Sponsored by FDCServers',
        imgWidth: 205,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/fdc.svg']
      }, {
        href: 'https://ipinfo.io/',
        imgTitle: 'Sponsored by IPInfo',
        imgWidth: 200,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/ipinfo.svg']
      }, {
        href: 'https://www.edisglobal.com/',
        imgTitle: 'Sponsored by EDIS Global',
        imgWidth: 196,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/edis-global.svg']
      }, {
        href: 'https://www.misaka.io',
        imgTitle: 'Sponsored by Misaka Network, Inc.',
        imgWidth: 203,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/misaka.svg']
      }, {
        href: 'https://zappiehost.com',
        imgTitle: 'Sponsored by Zappie Host',
        imgWidth: 208,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/zappiehost.png']
      }, {
        href: 'https://shockhosting.com/',
        imgTitle: 'Sponsored by Shock Hosting',
        imgWidth: 268,
        imgHeight: 40,
        imgSrc: ['/img/sponsors/shockhosting.svg']
      }, {
        href: 'https://www.dnsfilter.com/',
        imgTitle: 'Sponsored by DNSFilter',
        imgWidth: 214,
        imgHeight: 50,
        imgSrc: ['/img/sponsors/dnsfilter.png']
      }, {
        href: 'https://ipgeolocation.io/',
        imgTitle: 'Sponsored by IP Geolocation',
        imgWidth: 121,
        imgHeight: 70,
        imgSrc: ['/img/sponsors/ipgeolocation.svg']
      }, {
        href: 'https://cloudlooking.glass/',
        imgTitle: 'Sponsored by Cloud Looking Glass',
        imgWidth: 221,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/cloud-looking-glass.png']
      }, {
        href: 'https://onidel.com/',
        imgTitle: 'Sponsored by Onidel',
        imgWidth: 244,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/onidel.svg']
      }, {
        href: 'https://www.kuroit.com/',
        imgTitle: 'Sponsored by Kuroit',
        imgWidth: 226,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/kuroit.png']
      }, {
        href: 'https://exservers.net/',
        imgTitle: 'Sponsored by ExServers',
        imgWidth: 250,
        imgHeight: 45,
        imgSrc: ['/img/sponsors/exservers.png']
      }, {
        href: 'https://netshop-isp.com.cy/',
        imgTitle: 'Sponsored by NetShop ISP',
        imgWidth: 217,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/netshop-logo-dark.svg']
      }, {
        href: 'https://www.host-stage.net/',
        imgTitle: 'Sponsored by HostStage',
        imgWidth: 259,
        imgHeight: 55,
        imgSrc: ['/img/sponsors/host-stage.svg']
      }, {
        href: 'https://www.mvps.net/',
        imgTitle: 'Sponsored by MVPS',
        imgWidth: 253,
        imgHeight: 80,
        imgSrc: ['/img/sponsors/mvps.svg']
      }, {
        href: 'https://www.iplocate.io/',
        imgTitle: 'Sponsored by IPLocate',
        imgWidth: 252,
        imgHeight: 42,
        imgSrc: ['/img/sponsors/iplocate.svg']
      }, {
        href: 'https://breezehost.io/',
        imgTitle: 'Sponsored by BreezeHost',
        imgWidth: 204,
        imgHeight: 77,
        imgSrc: ['/img/sponsors/breezehost.svg']
      }, {
        href: 'https://www.digiturunc.com/',
        imgTitle: 'Sponsored by Digiturunc',
        imgWidth: 200,
        imgHeight: 92,
        imgSrc: ['/img/sponsors/digiturunc.png']
      }, {
        href: 'https://perlod.com/',
        imgTitle: 'Sponsored by Perlod',
        imgWidth: 210,
        imgHeight: 60,
        imgSrc: ['/img/sponsors/perlod.svg']
      }]
    };
  }
};
component$g.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "r-page",
    m: [{
      n: "noYield",
      f: [{
        t: 2,
        r: "noYield"
      }],
      t: 13
    }, {
      n: "title",
      f: [{
        t: 2,
        r: "title"
      }],
      t: 13
    }, {
      n: "description",
      f: [{
        t: 2,
        r: "description"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "c-notification"
    }, " ", {
      t: 7,
      e: "c-gp-header",
      m: [{
        n: "additionalClasses",
        f: "header-with-globalping-bg",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "p-globalping-sponsors",
        g: 1
      }],
      f: [{
        t: 7,
        e: "c-gp-jumbotron",
        m: [{
          n: "className",
          f: "sponsors",
          t: 13,
          g: 1
        }, {
          n: "gridType",
          f: "type4",
          t: 13,
          g: 1
        }]
      }, " ", {
        t: 7,
        e: "h1",
        m: [{
          t: 13,
          n: "class",
          f: "gp-sponsors_header",
          g: 1
        }],
        f: ["Our Sponsors"]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-sponsors_main-info",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-sponsors_main-info_descr",
            g: 1
          }],
          f: ["As an open-source project that relies on the community to operate, we are also highly appreciative of larger organizations that support our work."]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-sponsors_main-info_list-wrapper",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp-sponsors_main-info_list-wrapper_title",
              g: 1
            }],
            f: ["Globalping sponsors can be listed here for considerable and ongoing contributions to the project in the form of:"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-sponsors_main-info_list-wrapper_list",
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp-sponsors_main-info_list-wrapper_list_item",
                g: 1
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/check.svg"],
                  t: 13
                }, {
                  n: "width",
                  f: "20",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "20",
                  t: 13,
                  g: 1
                }]
              }, " ", {
                t: 7,
                e: "span",
                f: ["Infrastructure, like servers and services"]
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp-sponsors_main-info_list-wrapper_list_item",
                g: 1
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/check.svg"],
                  t: 13
                }, {
                  n: "width",
                  f: "20",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "20",
                  t: 13,
                  g: 1
                }]
              }, " ", {
                t: 7,
                e: "span",
                f: ["Mass hosting of probes managed by us"]
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp-sponsors_main-info_list-wrapper_list_item",
                g: 1
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/check.svg"],
                  t: 13
                }, {
                  n: "width",
                  f: "20",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "20",
                  t: 13,
                  g: 1
                }]
              }, " ", {
                t: 7,
                e: "span",
                f: ["Grants and ongoing sponsorships"]
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "gp-sponsors_main-info_list-wrapper_list_item",
                g: 1
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/check.svg"],
                  t: 13
                }, {
                  n: "width",
                  f: "20",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "20",
                  t: 13,
                  g: 1
                }]
              }, " ", {
                t: 7,
                e: "span",
                f: ["Developer hours and code contributions"]
              }]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-sponsors_main-info_contact-us",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            f: ["Contact us at"]
          }, " ", {
            t: 7,
            e: "a",
            m: [{
              t: 13,
              n: "class",
              f: "gp-sponsors_main-info_contact-us_mail",
              g: 1
            }, {
              n: "href",
              f: "mailto:d@globalping.io",
              t: 13,
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/mail-icon.svg"],
                t: 13
              }, {
                n: "width",
                f: "20",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "20",
                t: 13,
                g: 1
              }]
            }, " ", {
              t: 7,
              e: "span",
              f: ["d@globalping.io"]
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-sponsors_sponsors-list",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-sponsors_sponsors-list_platinum",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-sponsors_sponsors-list_platinum_title",
              g: 1
            }],
            f: ["PLATINUM"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-sponsors_sponsors-list_platinum_list",
              g: 1
            }],
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-sponsors_sponsors-list_platinum_list_item",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-sponsors_sponsors-list_platinum_list_item_logo",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: [{
                        t: 2,
                        r: "./imgTitle"
                      }],
                      t: 13
                    }, {
                      n: "width",
                      f: [{
                        t: 2,
                        r: "./imgWidth"
                      }],
                      t: 13
                    }, {
                      n: "height",
                      f: [{
                        t: 2,
                        r: "./imgHeight"
                      }],
                      t: 13
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, {
                        t: 2,
                        r: "./imgSrc.0"
                      }],
                      t: 13
                    }, {
                      t: 4,
                      f: [{
                        n: "srcset",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, {
                          t: 2,
                          r: "./imgSrc.1"
                        }],
                        t: 13
                      }],
                      n: 50,
                      r: "./imgSrc.1"
                    }, {
                      n: "loading",
                      f: "lazy",
                      t: 13,
                      g: 1
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "p",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-sponsors_sponsors-list_platinum_list_item_descr",
                    g: 1
                  }],
                  f: [{
                    t: 2,
                    r: "./spDescr"
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-sponsors_sponsors-list_platinum_list_item_link",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/link-icon.svg"],
                      t: 13
                    }, {
                      n: "width",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "20",
                      t: 13,
                      g: 1
                    }]
                  }, " ", {
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: [{
                        t: 2,
                        r: "./href"
                      }],
                      t: 13
                    }, {
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "rel",
                      f: "noreferrer",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 2,
                      r: "./linkDisplayed"
                    }]
                  }]
                }]
              }],
              n: 52,
              r: "platinumSponsors"
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp-sponsors_sponsors-list_platinum_list_item become-a-sponsor",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-sponsors_sponsors-list_platinum_list_item_title",
                  g: 1
                }],
                f: ["Become a sponsor"]
              }, " ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-sponsors_sponsors-list_platinum_list_item_descr",
                  g: 1
                }],
                f: ["Developer hours, donations, servers, and partnerships."]
              }]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-sponsors_sponsors-list_gold",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-sponsors_sponsors-list_gold_title",
              g: 1
            }],
            f: ["GOLD"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-sponsors_sponsors-list_gold_list",
              g: 1
            }],
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-sponsors_sponsors-list_gold_list_item",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-sponsors_sponsors-list_gold_list_item_logo",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: [{
                        t: 2,
                        r: "./imgTitle"
                      }],
                      t: 13
                    }, {
                      n: "width",
                      f: [{
                        t: 2,
                        r: "./imgWidth"
                      }],
                      t: 13
                    }, {
                      n: "height",
                      f: [{
                        t: 2,
                        r: "./imgHeight"
                      }],
                      t: 13
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, {
                        t: 2,
                        r: "./imgSrc.0"
                      }],
                      t: 13
                    }, {
                      t: 4,
                      f: [{
                        n: "srcset",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, {
                          t: 2,
                          r: "./imgSrc.1"
                        }],
                        t: 13
                      }],
                      n: 50,
                      r: "./imgSrc.1"
                    }, {
                      n: "loading",
                      f: "lazy",
                      t: 13,
                      g: 1
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "p",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-sponsors_sponsors-list_gold_list_item_descr",
                    g: 1
                  }],
                  f: [{
                    t: 2,
                    r: "./spDescr"
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-sponsors_sponsors-list_gold_list_item_link",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/link-icon.svg"],
                      t: 13
                    }, {
                      n: "width",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "20",
                      t: 13,
                      g: 1
                    }]
                  }, " ", {
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: [{
                        t: 2,
                        r: "./href"
                      }],
                      t: 13
                    }, {
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "rel",
                      f: "noreferrer",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 2,
                      r: "./linkDisplayed"
                    }]
                  }]
                }]
              }],
              n: 52,
              r: "goldSponsors"
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp-sponsors_sponsors-list_gold_list_item become-a-sponsor",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-sponsors_sponsors-list_gold_list_item_title",
                  g: 1
                }],
                f: ["Become a sponsor"]
              }, " ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-sponsors_sponsors-list_gold_list_item_descr",
                  g: 1
                }],
                f: ["Developer hours, donations, servers, and partnerships."]
              }]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-sponsors_sponsors-list_bronze",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-sponsors_sponsors-list_bronze_title",
              g: 1
            }],
            f: ["BRONZE"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-sponsors_sponsors-list_bronze_list",
              g: 1
            }],
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-sponsors_sponsors-list_bronze_list_item",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-sponsors_sponsors-list_bronze_list_item_logo",
                    g: 1
                  }, {
                    n: "target",
                    f: "_blank",
                    t: 13,
                    g: 1
                  }, {
                    n: "rel",
                    f: "noopener noreferrer",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: [{
                      t: 2,
                      r: "./href"
                    }],
                    t: 13
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "title",
                      f: [{
                        t: 2,
                        r: "./imgTitle"
                      }],
                      t: 13
                    }, {
                      n: "width",
                      f: [{
                        t: 2,
                        r: "./imgWidth"
                      }],
                      t: 13
                    }, {
                      n: "height",
                      f: [{
                        t: 2,
                        r: "./imgHeight"
                      }],
                      t: 13
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, {
                        t: 2,
                        r: "./imgSrc.0"
                      }],
                      t: 13
                    }, {
                      t: 4,
                      f: [{
                        n: "srcset",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, {
                          t: 2,
                          r: "./imgSrc.1"
                        }],
                        t: 13
                      }],
                      n: 50,
                      r: "./imgSrc.1"
                    }, {
                      n: "loading",
                      f: "lazy",
                      t: 13,
                      g: 1
                    }]
                  }]
                }]
              }],
              n: 52,
              r: "bronzeSponsors"
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp-sponsors_sponsors-list_bronze_list_item become-a-sponsor",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-sponsors_sponsors-list_bronze_list_item_title",
                  g: 1
                }],
                f: ["Become a sponsor"]
              }, " ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-sponsors_sponsors-list_bronze_list_item_descr",
                  g: 1
                }],
                f: ["Developer hours, donations, servers, and partnerships."]
              }]
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-sponsors_help-us",
          g: 1
        }],
        f: [{
          t: 7,
          e: "img",
          m: [{
            n: "width",
            f: "40",
            t: 13,
            g: 1
          }, {
            n: "height",
            f: "40",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/img/heart.svg"],
            t: 13
          }, {
            n: "loading",
            f: "lazy",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "gp-sponsors_help-us_text",
            g: 1
          }],
          f: ["Help us make Globalping even better"]
        }, " ", {
          t: 7,
          e: "a",
          m: [{
            t: 13,
            n: "class",
            f: "gp_btn_green",
            g: 1
          }, {
            n: "href",
            f: "https://github.com/sponsors/jsdelivr",
            t: 13,
            g: 1
          }, {
            n: "target",
            f: "_blank",
            t: 13,
            g: 1
          }],
          f: ["Become our sponsor"]
        }]
      }]
    }, " ", {
      t: 7,
      e: "c-gp-footer"
    }]
  }]
};
component$g.exports.components = {
  "c-gp-jumbotron": jumbotron,
  "c-notification": notification,
  "c-gp-footer": footer,
  "c-gp-header": header,
  "r-page": rPage
};
var sponsors = ractive.extend(component$g.exports);

var component$f = {
  exports: {}
};
const MAXIMUM_BONUS = 1500; // in %
const DOLLARS_FOR_BONUS = 100; // dollars needed for bonus increase
const CREDITS_PER_DOLLAR = 4000;
const BONUS_PER_HUNDRED_DOLLARS = 5;
const MAXIMUM_ONE_TIME_DONATION = 12000;
component$f.exports = {
  data() {
    return {
      isMobileScreen: false,
      oneTimeChecked: false,
      sliderValue: 10,
      donatedLastYear: 0,
      donatedByMonth: Array(12).fill(0)
    };
  },
  computed: {
    minimumDonation() {
      if (this.get('oneTimeChecked')) {
        return 5;
      }
      return 10;
    },
    maximumDonation() {
      if (this.get('oneTimeChecked')) {
        return 60000;
      }
      return 6000;
    },
    sliderMinimum() {
      return Math.sqrt(this.get('minimumDonation'));
    },
    sliderMaximum() {
      return Math.sqrt(this.get('maximumDonation'));
    },
    sliderPosition() {
      let sliderValue = this.get('sliderValue');
      let sliderMinimum = this.get('sliderMinimum');
      let sliderMaximum = this.get('sliderMaximum');
      return (sliderValue - sliderMinimum) / (sliderMaximum - sliderMinimum);
    },
    toDonate() {
      return Math.round(Math.pow(this.get('sliderValue'), 2) / 5) * 5;
    },
    estimatedBonus() {
      let totalDonated = this.get('donatedLastYear') + this.get('toDonate');
      let bonusSize = Math.floor(totalDonated / DOLLARS_FOR_BONUS) * BONUS_PER_HUNDRED_DOLLARS;
      return Math.min(bonusSize, MAXIMUM_BONUS);
    },
    creditsTotal() {
      let rawCredits = CREDITS_PER_DOLLAR * this.get('toDonate');
      return Math.round((this.get('estimatedBonus') / 100 + 1) * rawCredits);
    },
    bonusIncreasePeriod() {
      return Math.max(Math.round(DOLLARS_FOR_BONUS / this.get('toDonate')), 1);
    },
    isBonusPeriodExact() {
      return this.get('toDonate') >= 100 || DOLLARS_FOR_BONUS % this.get('toDonate') === 0;
    },
    subscriptionBonuses() {
      return Array.from({
        length: 13
      }, (_, index) => {
        let month = Math.min(index + 1, 12);
        let previousDonations = this.get('donatedByMonth').slice(month, 12).reduce((a, b) => a + b, 0);
        let bonusLevel = Math.floor((Math.min(month, 12) * this.get('toDonate') + previousDonations) / DOLLARS_FOR_BONUS);
        return Math.min(bonusLevel * BONUS_PER_HUNDRED_DOLLARS, MAXIMUM_BONUS);
      });
    },
    maxTwelveMonthBonus() {
      return Math.min(Math.floor(this.get('toDonate') * 12 / DOLLARS_FOR_BONUS) * BONUS_PER_HUNDRED_DOLLARS, MAXIMUM_BONUS);
    },
    monthMaximumReached() {
      let dollarsForMaxBonus = MAXIMUM_BONUS * DOLLARS_FOR_BONUS / BONUS_PER_HUNDRED_DOLLARS;
      return Math.min(Math.floor(dollarsForMaxBonus / this.get('toDonate')), 12);
    },
    twelveMonthCredits() {
      let rawCredits = this.get('toDonate') * 12 * CREDITS_PER_DOLLAR;
      return Math.round((1 + this.get('maxTwelveMonthBonus') / 100) * rawCredits / 1000) * 1000;
    },
    lastMonthlyDonationCredits() {
      let rawCredits = this.get('toDonate') * CREDITS_PER_DOLLAR;
      return Math.round((1 + this.get('maxTwelveMonthBonus') / 100) * rawCredits / 1000) * 1000;
    },
    showHighVolumeDiscount() {
      return this.get('toDonate') >= 3000;
    },
    isLoggedIn() {
      return !!this.get('@shared.user');
    },
    skipMiddleMonths() {
      return !this.get('isMobileScreen') && this.get('subscriptionBonuses')[8] >= 100;
    }
  },
  observe: {
    '@shared.user'(user) {
      if (!user?.id) {
        this.set('donatedLastYear', 0);
        this.set('donatedByMonth', Array(12).fill(0));
        return;
      }
      http.getSponsorshipDetails(user.id).then(response => {
        if (response?.donatedInLastYear) {
          this.set('donatedLastYear', response.donatedInLastYear);
        }
        if (response?.donatedByMonth?.length === 12) {
          this.set('donatedByMonth', response.donatedByMonth);
        }
      }).catch(e => {
        console.error(e);
      });
    },
    'oneTimeChecked'() {
      if (this.get('oneTimeChecked')) {
        this.set('sliderValue', 10);
        return;
      }
      this.set('sliderValue', 5);
    },
    'screenWidth'() {
      this.set('isMobileScreen', _.isMobileScreen() || _.isTabletScreen());
    }
  },
  oncomplete() {
    if (!ractive.isServer) {
      // reset slider when navigating back to the page
      setTimeout(() => {
        document.getElementById('slider').value = this.get('sliderValue');
      }, 1);
      listeners.screenWidthListener(this);
    }
  },
  isMonthIncrease(month) {
    let subscriptionBonuses = this.get('subscriptionBonuses');
    let currentMonthBonus = subscriptionBonuses[month - 1];
    if (month === 1) {
      return currentMonthBonus > this.get('donatedByMonth').reduce((a, b) => a + b, 0) / DOLLARS_FOR_BONUS * BONUS_PER_HUNDRED_DOLLARS;
    }
    return subscriptionBonuses.every((bonus, index) => {
      if (index === month - 1) {
        return true;
      }
      if (index < month - 1) {
        return bonus < currentMonthBonus;
      }
      return bonus >= currentMonthBonus;
    });
  },
  getOneTimeDonationLink(amount) {
    if (amount > MAXIMUM_ONE_TIME_DONATION) {
      return `mailto:d@globalping.io?subject=${encodeURIComponent(`Globalping sponsorship: $${amount}`)}&body=${encodeURIComponent(`Hi, I'd like to sponsor Globalping for ${amount} dollars in a single payment.`)}`;
    }
    return `https://github.com/sponsors/jsdelivr?frequency=one-time&amount=${amount}`;
  },
  formatNumber(number) {
    return number.toLocaleString('en-US');
  },
  handleSliderKeypress(e) {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.code)) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    let toDonate = this.get('toDonate');
    let changeMultiplier = toDonate > 100 ? Math.floor(Math.sqrt(toDonate)) / 5 : 1;
    if (e.code === 'ArrowLeft' || e.code === 'ArrowDown') {
      this.set('sliderValue', Math.max(Math.sqrt(toDonate - 5 * changeMultiplier), this.get('sliderMinimum')));
    } else if (e.code === 'ArrowRight' || e.code === 'ArrowUp') {
      this.set('sliderValue', Math.min(Math.sqrt(toDonate + 5 * changeMultiplier), this.get('sliderMaximum')));
    }
  },
  roundSliderValue() {
    let roundedDonation = Math.round(Math.pow(this.get('sliderValue'), 2) / 5) * 5;
    this.set('sliderValue', Math.sqrt(roundedDonation));
  },
  handlePaymentTypeInputClick(event) {
    event.preventDefault();
    this.handlePaymentTypeSwitch(!this.get('oneTimeChecked'));
  },
  handlePaymentTypeInputKeyDown(event) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      this.handlePaymentTypeSwitch(!this.get('oneTimeChecked'));
    }
  },
  handlePaymentTypeLabelClick(event) {
    event.preventDefault();
  },
  handlePaymentTypeSwitch(oneTimeChecked) {
    this.set('oneTimeChecked', oneTimeChecked);
    this.find('#switch-payment-type')?.focus();
  }
};
component$f.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-gp-sponsorship",
      g: 1
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "payment-type-select",
        g: 1
      }],
      f: [{
        t: 7,
        e: "input",
        m: [{
          n: "id",
          f: "switch-payment-type",
          t: 13
        }, {
          n: "type",
          f: "checkbox",
          t: 13
        }, {
          n: "aria-checked",
          f: [{
            t: 2,
            r: "oneTimeChecked"
          }],
          t: 13
        }, {
          n: "checked",
          f: [{
            t: 2,
            r: "oneTimeChecked"
          }],
          t: 13
        }, {
          t: 73,
          v: "t",
          f: "false"
        }, {
          n: "class",
          f: ["switch-input ", {
            t: 4,
            f: ["checked"],
            n: 50,
            r: "oneTimeChecked"
          }],
          t: 13
        }, {
          n: ["click"],
          t: 70,
          f: {
            r: ["@this", "@event"],
            s: "[_0.handlePaymentTypeInputClick(_1)]"
          }
        }, {
          n: ["keydown"],
          t: 70,
          f: {
            r: ["@this", "@event"],
            s: "[_0.handlePaymentTypeInputKeyDown(_1)]"
          }
        }]
      }, " ", {
        t: 7,
        e: "label",
        m: [{
          n: "for",
          f: "switch-payment-type",
          t: 13,
          g: 1
        }, {
          n: ["click"],
          t: 70,
          f: {
            r: ["@this", "@event"],
            s: "[_0.handlePaymentTypeLabelClick(_1)]"
          }
        }],
        f: [{
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "prevent-select",
            g: 1
          }, {
            n: ["click"],
            t: 70,
            f: {
              r: ["@this"],
              s: "[_0.handlePaymentTypeSwitch(false)]"
            }
          }],
          f: ["Monthly"]
        }, " ", {
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "prevent-select",
            g: 1
          }, {
            n: ["click"],
            t: 70,
            f: {
              r: ["@this"],
              s: "[_0.handlePaymentTypeSwitch(true)]"
            }
          }],
          f: ["One-time"]
        }]
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "donation",
        g: 1
      }],
      f: [{
        t: 7,
        e: "label",
        m: [{
          t: 13,
          n: "class",
          f: "sponsorship-subtitle",
          g: 1
        }, {
          n: "for",
          f: "slider",
          t: 13,
          g: 1
        }],
        f: ["Donation amount:"]
      }, " ", {
        t: 7,
        e: "input",
        m: [{
          n: "id",
          f: "slider",
          t: 13
        }, {
          n: "type",
          f: "range",
          t: 13
        }, {
          n: "min",
          f: [{
            t: 2,
            r: "sliderMinimum"
          }],
          t: 13
        }, {
          n: "max",
          f: [{
            t: 2,
            r: "sliderMaximum"
          }],
          t: 13
        }, {
          n: "step",
          f: "0.001",
          t: 13
        }, {
          n: "value",
          f: [{
            t: 2,
            r: "sliderValue"
          }],
          t: 13
        }, {
          n: "class",
          f: "slider",
          t: 13
        }, {
          n: ["input"],
          t: 70,
          f: {
            r: ["@this"],
            s: "[_0.roundSliderValue()]"
          }
        }, {
          n: ["keydown"],
          t: 70,
          f: {
            r: ["@this", "@event"],
            s: "[_0.handleSliderKeypress(_1)]"
          }
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "slider-overlay",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "slider-overlay_track",
            g: 1
          }, {
            n: "style-width",
            f: ["calc(", {
              t: 2,
              x: {
                r: ["sliderPosition"],
                s: "_0*100"
              }
            }, "% + ", {
              t: 2,
              x: {
                r: ["sliderPosition"],
                s: "(1/2-_0)*15"
              }
            }, "px)"],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "slider-overlay_label",
            g: 1
          }, {
            n: "style-margin-left",
            f: ["calc(", {
              t: 2,
              x: {
                r: ["sliderPosition"],
                s: "_0*100"
              }
            }, "% + ", {
              t: 2,
              x: {
                r: ["sliderPosition"],
                s: "(1/2-_0)*15"
              }
            }, "px)"],
            t: 13
          }],
          f: ["$", {
            t: 2,
            r: "toDonate"
          }]
        }]
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "volume-discount",
          g: 1
        }],
        f: [{
          t: 7,
          e: "img",
          m: [{
            n: "width",
            f: "22",
            t: 13,
            g: 1
          }, {
            n: "height",
            f: "22",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/img/mail-icon.svg"],
            t: 13
          }, {
            n: "alt",
            f: "",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "p",
          f: ["Higher volume discounts available! If you expect to spend more than $3000 per month, please ", {
            t: 7,
            e: "a",
            m: [{
              n: "href",
              f: "mailto:d@globalping.io",
              t: 13,
              g: 1
            }],
            f: ["get in touch"]
          }, " to discuss individual pricing."]
        }]
      }],
      n: 50,
      r: "showHighVolumeDiscount"
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "one-time-donation",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "donation-information",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "donation-information_block",
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              f: [{
                t: 4,
                f: ["Estimated"],
                n: 50,
                x: {
                  r: ["isLoggedIn"],
                  s: "!_0"
                }
              }, " Bonus:"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "donation-information_value",
                g: 1
              }],
              f: ["+", {
                t: 2,
                x: {
                  r: ["@this", "estimatedBonus"],
                  s: "_0.formatNumber(_1)"
                }
              }, "%"]
            }, " ", {
              t: 7,
              e: "span",
              f: ["Credits Total:"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "donation-information_value",
                g: 1
              }],
              f: [{
                t: 2,
                x: {
                  r: ["@this", "creditsTotal"],
                  s: "_0.formatNumber(_1)"
                }
              }]
            }]
          }, " ", {
            t: 7,
            e: "p",
            m: [{
              t: 13,
              n: "class",
              f: "donation-information_footer",
              g: 1
            }],
            f: [{
              t: 4,
              f: [{
                t: 4,
                f: ["(Total bonus based on your personal donation history)"],
                n: 50,
                x: {
                  r: ["donatedLastYear", "estimatedBonus"],
                  s: "_0&&_1>0"
                }
              }],
              n: 50,
              r: "isLoggedIn"
            }, {
              t: 4,
              f: ["(Assuming this is your first donation)"],
              n: 51,
              l: 1
            }]
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "p",
            f: [{
              t: 7,
              e: "a",
              m: [{
                t: 13,
                n: "class",
                f: "sign-in-link",
                g: 1
              }, {
                n: "href",
                f: [{
                  t: 2,
                  x: {
                    r: ["@global.app"],
                    s: "_0.getSignInLink()"
                  }
                }],
                t: 13
              }],
              f: ["Sign in"]
            }, " to calculate your personal bonus based on past donations."]
          }],
          n: 50,
          x: {
            r: ["isLoggedIn"],
            s: "!_0"
          }
        }, " ", {
          t: 7,
          e: "a",
          m: [{
            t: 13,
            n: "class",
            f: "gp_btn_green button-link",
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              x: {
                r: ["@this", "toDonate"],
                s: "_0.getOneTimeDonationLink(_1)"
              }
            }],
            t: 13
          }, {
            n: "target",
            f: "_blank",
            t: 13,
            g: 1
          }],
          f: ["Donate"]
        }]
      }],
      n: 50,
      r: "oneTimeChecked"
    }, {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "monthly-donation",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "monthly-donation_information",
            g: 1
          }],
          f: [{
            t: 7,
            e: "p",
            f: ["Your bonus grows as your total donations increase."]
          }, " ", {
            t: 4,
            f: [{
              t: 7,
              e: "p",
              f: ["At $", {
                t: 2,
                r: "toDonate"
              }, "/month, your bonus increases ", {
                t: 4,
                f: [{
                  t: 4,
                  f: ["almost"],
                  n: 50,
                  x: {
                    r: ["isBonusPeriodExact"],
                    s: "!_0"
                  }
                }, " every month"],
                n: 50,
                x: {
                  r: ["bonusIncreasePeriod"],
                  s: "_0===1"
                }
              }, {
                t: 4,
                f: ["every ", {
                  t: 4,
                  f: ["~"],
                  n: 50,
                  x: {
                    r: ["isBonusPeriodExact"],
                    s: "!_0"
                  }
                }, {
                  t: 2,
                  r: "bonusIncreasePeriod"
                }, " months"],
                n: 51,
                l: 1
              }, ", up to ", {
                t: 2,
                r: "maxTwelveMonthBonus"
              }, "% in month ", {
                t: 2,
                r: "monthMaximumReached"
              }, "."]
            }],
            n: 50,
            x: {
              r: ["isLoggedIn", "donatedLastYear"],
              s: "!_0||!_1"
            }
          }, {
            t: 4,
            f: [{
              t: 7,
              e: "p",
              f: ["At $", {
                t: 2,
                r: "toDonate"
              }, "/month, your bonus stabilizes at ", {
                t: 2,
                r: "maxTwelveMonthBonus"
              }, "% in month ", {
                t: 2,
                r: "monthMaximumReached"
              }, "."]
            }],
            n: 51,
            l: 1
          }, " ", {
            t: 7,
            e: "p",
            f: ["From month ", {
              t: 2,
              r: "monthMaximumReached"
            }, " onward, each monthly donation earns ", {
              t: 2,
              x: {
                r: ["@this", "lastMonthlyDonationCredits"],
                s: "_0.formatNumber(_1)"
              }
            }, " credits."]
          }, " ", {
            t: 4,
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "p",
                m: [{
                  t: 13,
                  n: "class",
                  f: "monthly-donation_information_footer",
                  g: 1
                }],
                f: ["(Bonus based on your personal donation history)"]
              }],
              n: 50,
              x: {
                r: ["donatedLastYear", "estimatedBonus"],
                s: "_0&&_1>0"
              }
            }],
            n: 50,
            r: "isLoggedIn"
          }, {
            t: 4,
            f: [{
              t: 7,
              e: "p",
              m: [{
                t: 13,
                n: "class",
                f: "monthly-donation_information_footer",
                g: 1
              }],
              f: ["(Assuming this is your first donation)"]
            }],
            n: 51,
            l: 1
          }]
        }, " ", {
          t: 7,
          e: "h3",
          m: [{
            t: 13,
            n: "class",
            f: "sponsorship-subtitle",
            g: 1
          }],
          f: ["Monthly bonus progress"]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "monthly-donation_infographic",
            g: 1
          }],
          f: [{
            t: 4,
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "skipped-month",
                  g: 1
                }]
              }],
              n: 50,
              x: {
                r: ["skipMiddleMonths", "index"],
                s: "_0&&_1+1>=5&&_1+1<=9"
              }
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "infographic-cell",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    n: "class",
                    f: ["bonus-percentage ", {
                      t: 4,
                      f: ["bonus-highlight"],
                      n: 50,
                      x: {
                        r: ["@this", "index"],
                        s: "_0.isMonthIncrease(_1+1)"
                      }
                    }, " ", {
                      t: 4,
                      f: ["final-cell"],
                      n: 50,
                      x: {
                        r: ["index"],
                        s: "_0===12"
                      }
                    }],
                    t: 13
                  }],
                  f: [{
                    t: 2,
                    x: {
                      r: ["@this", "index", "subscriptionBonuses"],
                      s: "_0.formatNumber(_2[_1])"
                    }
                  }, "%"]
                }, " ", {
                  t: 7,
                  e: "div",
                  f: [{
                    t: 4,
                    f: [{
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "mobile-only",
                        g: 1
                      }],
                      f: ["Ongoing"]
                    }, "..."],
                    n: 50,
                    x: {
                      r: ["index"],
                      s: "_0===12"
                    }
                  }, {
                    t: 4,
                    f: ["M", {
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "mobile-only",
                        g: 1
                      }],
                      f: ["onth "]
                    }, {
                      t: 2,
                      x: {
                        r: ["index"],
                        s: "_0+1"
                      }
                    }],
                    n: 51,
                    l: 1
                  }]
                }]
              }],
              n: 51,
              l: 1
            }],
            n: 52,
            i: "index",
            x: {
              r: [],
              s: "Array(13)"
            }
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "prepay-subscription",
            g: 1
          }],
          f: [{
            t: 7,
            e: "img",
            m: [{
              n: "width",
              f: "48",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "48",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/bulb-icon-big.svg"],
              t: 13
            }]
          }, " ", {
            t: 7,
            e: "div",
            f: [{
              t: 7,
              e: "h4",
              f: ["Prepay 12 months & get full bonus instantly!"]
            }, " ", {
              t: 7,
              e: "p",
              f: ["Credits: ", {
                t: 2,
                x: {
                  r: ["@this", "twelveMonthCredits"],
                  s: "_0.formatNumber(_1)"
                }
              }]
            }]
          }, " ", {
            t: 7,
            e: "a",
            m: [{
              t: 13,
              n: "class",
              f: "gp_btn_green get-now-button button-link",
              g: 1
            }, {
              n: "href",
              f: [{
                t: 2,
                x: {
                  r: ["@this", "toDonate"],
                  s: "_0.getOneTimeDonationLink(12*_1)"
                }
              }],
              t: 13
            }, {
              n: "target",
              f: "_blank",
              t: 13,
              g: 1
            }],
            f: ["Get now"]
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "p",
            f: [{
              t: 7,
              e: "a",
              m: [{
                t: 13,
                n: "class",
                f: "sign-in-link",
                g: 1
              }, {
                n: "href",
                f: [{
                  t: 2,
                  x: {
                    r: ["@global.app"],
                    s: "_0.getSignInLink()"
                  }
                }],
                t: 13
              }],
              f: ["Sign in"]
            }, " to calculate your personal bonus based on past donations."]
          }],
          n: 50,
          x: {
            r: ["isLoggedIn"],
            s: "!_0"
          }
        }, " ", {
          t: 7,
          e: "a",
          m: [{
            t: 13,
            n: "class",
            f: "gp_btn_black button-link",
            g: 1
          }, {
            n: "href",
            f: ["https://github.com/sponsors/jsdelivr?frequency=recurring&amount=", {
              t: 2,
              r: "toDonate"
            }],
            t: 13
          }, {
            n: "target",
            f: "_blank",
            t: 13,
            g: 1
          }],
          f: ["Start Monthly Support"]
        }]
      }],
      n: 51,
      l: 1
    }]
  }],
  e: {
    "[_0.handlePaymentTypeInputClick(_1)]": function (_0, _1) {
      return [_0.handlePaymentTypeInputClick(_1)];
    },
    "[_0.handlePaymentTypeInputKeyDown(_1)]": function (_0, _1) {
      return [_0.handlePaymentTypeInputKeyDown(_1)];
    },
    "[_0.handlePaymentTypeLabelClick(_1)]": function (_0, _1) {
      return [_0.handlePaymentTypeLabelClick(_1)];
    },
    "[_0.handlePaymentTypeSwitch(false)]": function (_0) {
      return [_0.handlePaymentTypeSwitch(false)];
    },
    "[_0.handlePaymentTypeSwitch(true)]": function (_0) {
      return [_0.handlePaymentTypeSwitch(true)];
    },
    "[_0.roundSliderValue()]": function (_0) {
      return [_0.roundSliderValue()];
    },
    "[_0.handleSliderKeypress(_1)]": function (_0, _1) {
      return [_0.handleSliderKeypress(_1)];
    },
    "_0*100": function (_0) {
      return _0 * 100;
    },
    "(1/2-_0)*15": function (_0) {
      return (1 / 2 - _0) * 15;
    },
    "!_0": function (_0) {
      return !_0;
    },
    "_0.formatNumber(_1)": function (_0, _1) {
      return _0.formatNumber(_1);
    },
    "_0&&_1>0": function (_0, _1) {
      return _0 && _1 > 0;
    },
    "_0.getSignInLink()": function (_0) {
      return _0.getSignInLink();
    },
    "_0.getOneTimeDonationLink(_1)": function (_0, _1) {
      return _0.getOneTimeDonationLink(_1);
    },
    "_0===1": function (_0) {
      return _0 === 1;
    },
    "!_0||!_1": function (_0, _1) {
      return !_0 || !_1;
    },
    "_0&&_1+1>=5&&_1+1<=9": function (_0, _1) {
      return _0 && _1 + 1 >= 5 && _1 + 1 <= 9;
    },
    "_0.isMonthIncrease(_1+1)": function (_0, _1) {
      return _0.isMonthIncrease(_1 + 1);
    },
    "_0===12": function (_0) {
      return _0 === 12;
    },
    "_0.formatNumber(_2[_1])": function (_0, _1, _2) {
      return _0.formatNumber(_2[_1]);
    },
    "_0+1": function (_0) {
      return _0 + 1;
    },
    "Array(13)": function () {
      return Array(13);
    },
    "_0.getOneTimeDonationLink(12*_1)": function (_0, _1) {
      return _0.getOneTimeDonationLink(12 * _1);
    }
  }
};
var sponsorship = ractive.extend(component$f.exports);

var component$e = {
  exports: {}
};
component$e.exports = {
  decorators: {
    tooltip
  },
  data() {
    return {
      title: 'Credits - Globalping',
      description: 'Start using Globalping for free - no registration needed! Get higher limits by creating an account, hosting probes, or sponsoring the project.',
      userBenefits: {
        unregistered: {
          probesPerMeas: 50,
          freeTestsPerHour: 250
        },
        registered: {
          probesPerMeas: 500,
          freeTestsPerHour: 500
        }
      },
      faq: [{
        question: 'How to generate free credits?',
        answer: 'Simply log in to the <a href="https://dash.globalping.io" target="_blank">Globalping Dashboard</a> and follow the instructions. You will need to host a probe using a Docker container or by ordering our hardware probe.'
      }, {
        question: 'What is a credit and what does it do?',
        answer: 'A single credit equals one test. For example if you request a ping measurement from 5 locations, it will use 5 credits. A single measurement can request up to 500 probes, which effectively means a maximum of 500 credits being used per measurement.'
      }, {
        question: 'How to buy more credits?',
        answer: 'You will need to register an account first and then donate your chosen amount using GitHub Sponsors. Our system will pick up the donation and credit your account automatically.'
      }, {
        question: 'Can I use credits to power a commercial tool or product?',
        answer: 'Yes, we support commercial use of Globalping within the limits of our terms of service.'
      }, {
        question: 'Do you support non-profits with free credits?',
        answer: 'Yes, we can provide large amounts of free credits to all kinds of organizations and projects after a manual review. Please contact us via email.'
      }, {
        question: 'How to get in contact?',
        answer: 'To report issues with the API or our tools it is best to open a GitHub issue. But if for any reason you prefer to contact us privately via email you can do so at <a href="mailto:d@globalping.io">d@globalping.io</a>'
      }]
    };
  },
  openLink(url) {
    event.preventDefault();
    window.open(url, '_blank');
  }
};
component$e.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "r-page",
    m: [{
      n: "noYield",
      f: [{
        t: 2,
        r: "noYield"
      }],
      t: 13
    }, {
      n: "title",
      f: [{
        t: 2,
        r: "title"
      }],
      t: 13
    }, {
      n: "description",
      f: [{
        t: 2,
        r: "description"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "c-notification"
    }, " ", {
      t: 7,
      e: "c-gp-header",
      m: [{
        n: "additionalClasses",
        f: "header-with-globalping-bg",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "p-globalping-credits",
        g: 1
      }],
      f: [{
        t: 7,
        e: "c-gp-jumbotron",
        m: [{
          n: "className",
          f: "credits",
          t: 13,
          g: 1
        }, {
          n: "gridType",
          f: "type4",
          t: 13,
          g: 1
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-credits",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-credits_info",
            g: 1
          }],
          f: [{
            t: 7,
            e: "h1",
            m: [{
              t: 13,
              n: "class",
              f: "gp-credits_info_title",
              g: 1
            }],
            f: ["Globalping limits and credits"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-credits_info_descr",
              g: 1
            }],
            f: ["Start using Globalping for free - no registration needed!"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-credits_info_user-benefits",
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp-credits_info_user-benefits_block",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-credits_info_user-benefits_block_title",
                  g: 1
                }],
                f: ["Unregistered User"]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-credits_info_user-benefits_block_list",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-credits_info_user-benefits_block_list_item",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "width",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/check.svg"],
                      t: 13
                    }, {
                      n: "loading",
                      f: "lazy",
                      t: 13,
                      g: 1
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp-credits_info_user-benefits_block_list_item_numbers",
                      g: 1
                    }],
                    f: [{
                      t: 2,
                      r: "./userBenefits.unregistered.probesPerMeas"
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp-credits_info_user-benefits_block_list_item_text",
                      g: 1
                    }],
                    f: ["Probes per measurement"]
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-credits_info_user-benefits_block_list_item",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "width",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/check.svg"],
                      t: 13
                    }, {
                      n: "loading",
                      f: "lazy",
                      t: 13,
                      g: 1
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp-credits_info_user-benefits_block_list_item_numbers",
                      g: 1
                    }],
                    f: [{
                      t: 2,
                      r: "./userBenefits.unregistered.freeTestsPerHour"
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp-credits_info_user-benefits_block_list_item_text",
                      g: 1
                    }],
                    f: ["Free tests per hour"]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-credits_info_user-benefits_block_hint",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  f: ["Higher limits for members!"]
                }, " ", {
                  t: 7,
                  e: "img",
                  m: [{
                    n: "tooltip",
                    t: 71,
                    f: {
                      r: [],
                      s: "[[\"By creating a free account you help us fight abuse while getting access to higher limits and additional features.\"],\"top\",undefined,undefined,\"multiline gp-credits_tooltip\"]"
                    }
                  }, {
                    n: "width",
                    f: "14",
                    t: 13,
                    g: 1
                  }, {
                    n: "height",
                    f: "14",
                    t: 13,
                    g: 1
                  }, {
                    n: "src",
                    f: [{
                      t: 2,
                      r: "@shared.assetsHost"
                    }, "/img/help-icon.svg"],
                    t: 13
                  }]
                }]
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp-credits_info_user-benefits_block registered",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-credits_info_user-benefits_block_title",
                  g: 1
                }],
                f: ["Registered User"]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-credits_info_user-benefits_block_list",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-credits_info_user-benefits_block_list_item",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "width",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/check.svg"],
                      t: 13
                    }, {
                      n: "loading",
                      f: "lazy",
                      t: 13,
                      g: 1
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp-credits_info_user-benefits_block_list_item_numbers",
                      g: 1
                    }],
                    f: [{
                      t: 2,
                      r: "./userBenefits.registered.probesPerMeas"
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp-credits_info_user-benefits_block_list_item_text",
                      g: 1
                    }],
                    f: ["Probes per measurement"]
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-credits_info_user-benefits_block_list_item",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "width",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/check.svg"],
                      t: 13
                    }, {
                      n: "loading",
                      f: "lazy",
                      t: 13,
                      g: 1
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp-credits_info_user-benefits_block_list_item_numbers",
                      g: 1
                    }],
                    f: [{
                      t: 2,
                      r: "./userBenefits.registered.freeTestsPerHour"
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp-credits_info_user-benefits_block_list_item_text",
                      g: 1
                    }],
                    f: ["Free tests per hour"]
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-credits_info_user-benefits_block_list_item",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "width",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "20",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/check.svg"],
                      t: 13
                    }, {
                      n: "loading",
                      f: "lazy",
                      t: 13,
                      g: 1
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp-credits_info_user-benefits_block_list_item_text",
                      g: 1
                    }],
                    f: ["Spend credits for extra tests"]
                  }]
                }]
              }]
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-credits_info_extra-tests",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "56",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "56",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/bulb-icon.svg"],
                t: 13
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "gp-credits_info_extra-tests_text",
                g: 1
              }],
              f: ["Registered users may run additional tests by spending credits. Each test above the free limit costs one credit."]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-credits_become-a-sponsor",
            g: 1
          }],
          f: [{
            t: 7,
            e: "h2",
            m: [{
              t: 13,
              n: "class",
              f: "gp-credits_become-a-sponsor_title",
              g: 1
            }],
            f: ["Become a sponsor"]
          }, " ", {
            t: 7,
            e: "p",
            m: [{
              t: 13,
              n: "class",
              f: "gp-credits_become-a-sponsor_descr",
              g: 1
            }],
            f: ["Get extra credits for your support! Sponsors get a base reward of 4000 credits per $1 donated, with a cumulative 5% bonus for each $100 donated in the past 12 months - up to 1500%."]
          }, " ", {
            t: 7,
            e: "c-gp-sponsorship"
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-credits_host-a-probe",
            g: 1
          }],
          f: [{
            t: 7,
            e: "img",
            m: [{
              t: 13,
              n: "class",
              f: "gp-credits_host-a-probe_polygons",
              g: 1
            }, {
              n: "width",
              f: "362",
              t: 13,
              g: 1
            }, {
              n: "height",
              f: "288",
              t: 13,
              g: 1
            }, {
              n: "src",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/credits/polygons_2.svg"],
              t: 13
            }, {
              n: "loading",
              f: "lazy",
              t: 13,
              g: 1
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-credits_host-a-probe_block",
              g: 1
            }],
            f: [{
              t: 7,
              e: "h2",
              m: [{
                t: 13,
                n: "class",
                f: "gp-credits_host-a-probe_block_title",
                g: 1
              }],
              f: ["Host a probe"]
            }, " ", {
              t: 7,
              e: "h3",
              m: [{
                t: 13,
                n: "class",
                f: "gp-credits_host-a-probe_block_subtitle",
                g: 1
              }],
              f: ["+150 tests/probe/day"]
            }, " ", {
              t: 7,
              e: "p",
              m: [{
                t: 13,
                n: "class",
                f: "gp-credits_host-a-probe_block_content",
                g: 1
              }],
              f: ["Generate free credits passively! Become a member of the community by hosting a probe and adopting it under your account. For each day your probe stays online, you will get additional free credits."]
            }, " ", {
              t: 7,
              e: "a",
              m: [{
                t: 13,
                n: "class",
                f: "gp_btn_green gp-credits_host-a-probe_block_btn",
                g: 1
              }, {
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this", "@shared.serverHost"],
                  s: "[_0.openLink(_1+\"/#join-the-network\")]"
                }
              }],
              f: ["Host a probe"]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-credits_faq",
            g: 1
          }],
          f: [{
            t: 7,
            e: "h2",
            m: [{
              t: 13,
              n: "class",
              f: "gp-credits_faq_title",
              g: 1
            }],
            f: ["Frequently Asked Questions"]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp-credits_faq_descr",
              g: 1
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-credits_faq_list",
              g: 1
            }],
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "gp-credits_faq_list_item",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-credits_faq_list_item_question",
                    g: 1
                  }],
                  f: [{
                    t: 2,
                    r: "./question"
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "gp-credits_faq_list_item_answer",
                    g: 1
                  }],
                  f: [{
                    t: 3,
                    r: "./answer"
                  }]
                }]
              }],
              n: 52,
              r: "faq"
            }]
          }]
        }]
      }]
    }, " ", {
      t: 7,
      e: "c-gp-footer"
    }]
  }],
  e: {
    "[[\"By creating a free account you help us fight abuse while getting access to higher limits and additional features.\"],\"top\",undefined,undefined,\"multiline gp-credits_tooltip\"]": function () {
      return [["By creating a free account you help us fight abuse while getting access to higher limits and additional features."], "top", undefined, undefined, "multiline gp-credits_tooltip"];
    },
    "[_0.openLink(_1+\"/#join-the-network\")]": function (_0, _1) {
      return [_0.openLink(_1 + "/#join-the-network")];
    }
  }
};
component$e.exports.components = {
  "c-gp-sponsorship": sponsorship,
  "c-gp-jumbotron": jumbotron,
  "c-notification": notification,
  "c-gp-footer": footer,
  "c-gp-header": header,
  "r-page": rPage
};
var credits = ractive.extend(component$e.exports);

var component$d = {
  exports: {}
};
component$d.exports = {
  data() {
    return {
      loading: false,
      error: false,
      hasData: true,
      filter: null,
      errorText: 'An unexpected error occurred. Please try again later.',
      loadingText: 'Loading data...',
      noDataFilterText: 'No results found. Please try adjusting the filter.',
      noDataText: 'No results found. Please try again later.'
    };
  }
};
component$d.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-probe-loading-state",
      g: 1
    }],
    f: [{
      t: 4,
      f: [{
        t: 7,
        e: "div",
        f: [{
          t: 7,
          e: "i",
          m: [{
            t: 13,
            n: "class",
            f: "fa fa-circle-o-notch fa-spin fa-fw",
            g: 1
          }, {
            n: "aria-hidden",
            f: "true",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "p",
          f: [{
            t: 2,
            r: "loadingText"
          }]
        }]
      }],
      n: 50,
      r: "loading"
    }, {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "has-error",
          g: 1
        }],
        f: [{
          t: 7,
          e: "i",
          m: [{
            t: 13,
            n: "class",
            f: "fa fa-exclamation-triangle",
            g: 1
          }, {
            n: "aria-hidden",
            f: "true",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "p",
          f: [{
            t: 2,
            r: "errorText"
          }]
        }]
      }, " "],
      n: 50,
      r: "error",
      l: 1
    }, {
      t: 4,
      f: [" ", {
        t: 7,
        e: "div",
        f: [{
          t: 7,
          e: "i",
          m: [{
            t: 13,
            n: "class",
            f: "fa fa-search",
            g: 1
          }, {
            n: "aria-hidden",
            f: "true",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "p",
          f: [{
            t: 4,
            f: [{
              t: 2,
              r: "noDataFilterText"
            }],
            n: 50,
            r: "filter"
          }, {
            t: 4,
            f: [{
              t: 2,
              r: "noDataText"
            }],
            n: 51,
            l: 1
          }]
        }]
      }],
      n: 50,
      x: {
        r: ["hasData"],
        s: "!_0"
      },
      l: 1
    }]
  }],
  e: {
    "!_0": function (_0) {
      return !_0;
    }
  }
};
var probeLoadingState = ractive.extend(component$d.exports);

var component$c = {
  exports: {}
};
component$c.exports = {
  data() {
    return {
      dropdownOpened: false,
      className: '',
      currSelectedItemIdx: null,
      placeholder: '',
      onSelect: null,
      disabled: false,
      name: ''
    };
  },
  computed: {
    selectedName() {
      let placeholder = this.get('placeholder');
      let selected = this.get('selected');
      let options = this.get('options');
      let option = options.find(opt => opt.value === selected);
      return option ? option.name : selected ? selected : placeholder;
    }
  },
  oncomplete() {
    if (!ractive.isServer) {
      // close dropdown on click outside the select el
      let el = this.find('.select');
      let handleOnClickOutside = event => {
        let currDropdownOpened = this.get('dropdownOpened');
        if (currDropdownOpened && !el.contains(event.target)) {
          this.set('dropdownOpened', false);
        }
      };
      listeners.addManagedListener(this, document, 'click', handleOnClickOutside);
      this.observe('dropdownOpened', newValue => {
        if (newValue) {
          this.find('.select_wrapper_list_item.selected')?.scrollIntoView?.({
            block: 'nearest'
          });
        }
      }, {
        defer: true
      });
      this.observe('currSelectedItemIdx', () => {
        this.find('.select_wrapper_list_item.focused')?.scrollIntoView?.({
          block: 'nearest'
        });
      }, {
        defer: true
      });
    }
  },
  onKeyDown(e) {
    let listEl = this.find('.select_wrapper_list');
    if (!listEl) {
      return;
    }
    let options = this.get('options');
    let currSelectedItemIdx = this.get('currSelectedItemIdx');
    let selected = this.get('selected');

    // Start nav from the selected value position if not already navigating
    if (currSelectedItemIdx === null) {
      options.some((opt, idx) => {
        if (opt.value === selected) {
          currSelectedItemIdx = idx;
          return true;
        }
        return false;
      });
    }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (!this.get('dropdownOpened')) {
        this.toggleDropdown();
      }
      currSelectedItemIdx = currSelectedItemIdx === null ? 0 : currSelectedItemIdx + 1 > options.length - 1 ? options.length - 1 : currSelectedItemIdx + 1;
      this.set('currSelectedItemIdx', currSelectedItemIdx);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (!this.get('dropdownOpened')) {
        this.toggleDropdown();
      }
      currSelectedItemIdx = currSelectedItemIdx === null ? 0 : currSelectedItemIdx - 1 < 0 ? 0 : currSelectedItemIdx - 1;
      this.set('currSelectedItemIdx', currSelectedItemIdx);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (this.get('dropdownOpened')) {
        let selectedItem = options[currSelectedItemIdx];
        if (selectedItem) {
          this.selectItem(selectedItem.value);
        }
      } else {
        this.toggleDropdown();
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      if (this.get('dropdownOpened')) {
        this.toggleDropdown();
      }
    } else if (e.key === 'Tab') {
      if (this.get('dropdownOpened')) {
        this.toggleDropdown();
      }
    }
  },
  toggleDropdown() {
    this.set('dropdownOpened', !this.get('dropdownOpened'));
    this.set('currSelectedItemIdx', null);
  },
  selectItem(value) {
    this.toggleDropdown();
    this.set('selected', value);
    if (this.get('onSelect')) {
      this.get('onSelect')(value);
    }
  }
};
component$c.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      n: "class",
      f: ["select ", {
        t: 2,
        r: "className"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "button",
      m: [{
        t: 13,
        n: "class",
        f: "select_selected",
        g: 1
      }, {
        n: "type",
        f: "button",
        t: 13,
        g: 1
      }, {
        n: "disabled",
        f: [{
          t: 2,
          r: "disabled"
        }],
        t: 13
      }, {
        n: ["click"],
        t: 70,
        f: {
          r: ["@this"],
          s: "[_0.toggleDropdown()]"
        }
      }, {
        n: ["keydown"],
        t: 70,
        f: {
          r: ["@this", "@event"],
          s: "[_0.onKeyDown(_1)]"
        }
      }, {
        n: "aria-expanded",
        f: [{
          t: 2,
          r: "dropdownOpened"
        }],
        t: 13
      }, {
        n: "aria-haspopup",
        f: "listbox",
        t: 13,
        g: 1
      }, {
        n: "aria-controls",
        f: [{
          t: 2,
          r: "name"
        }],
        t: 13
      }, {
        n: "data-testid",
        f: [{
          t: 2,
          r: "name"
        }],
        t: 13
      }],
      f: [{
        t: 7,
        e: "span",
        m: [{
          t: 13,
          n: "class",
          f: "select_selected_label",
          g: 1
        }],
        f: [{
          t: 2,
          r: "selectedName"
        }]
      }, " ", {
        t: 7,
        e: "img",
        m: [{
          n: "width",
          f: "20",
          t: 13,
          g: 1
        }, {
          n: "height",
          f: "20",
          t: 13,
          g: 1
        }, {
          n: "src",
          f: [{
            t: 2,
            r: "@shared.assetsHost"
          }, "/img/chevron-down.svg"],
          t: 13
        }, {
          n: "loading",
          f: "lazy",
          t: 13,
          g: 1
        }, {
          n: "alt",
          f: "",
          t: 13,
          g: 1
        }]
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        n: "id",
        f: [{
          t: 2,
          r: "name"
        }],
        t: 13
      }, {
        n: "class",
        f: ["select_wrapper ", {
          t: 4,
          f: ["opened"],
          n: 50,
          r: "dropdownOpened"
        }],
        t: 13
      }, {
        n: "role",
        f: "listbox",
        t: 13,
        g: 1
      }],
      f: [{
        t: 7,
        e: "ul",
        m: [{
          t: 13,
          n: "class",
          f: "select_wrapper_list",
          g: 1
        }, {
          n: "data-testid",
          f: [{
            t: 2,
            r: "name"
          }, "-options"],
          t: 13
        }],
        f: [{
          t: 4,
          f: [{
            t: 7,
            e: "li",
            m: [{
              n: "class",
              f: ["select_wrapper_list_item ", {
                t: 4,
                f: ["selected"],
                n: 50,
                x: {
                  r: ["./value", "selected"],
                  s: "_0===_1"
                }
              }, " ", {
                t: 4,
                f: ["focused"],
                n: 50,
                x: {
                  r: ["currSelectedItemIdx", "@index"],
                  s: "_0===_1"
                }
              }],
              t: 13
            }, {
              n: "role",
              f: "option",
              t: 13,
              g: 1
            }, {
              n: "aria-selected",
              f: [{
                t: 2,
                x: {
                  r: ["./value", "selected"],
                  s: "_0===_1"
                }
              }],
              t: 13
            }, {
              n: "data-testid",
              f: ["select-option-", {
                t: 2,
                r: "./value"
              }],
              t: 13
            }, {
              n: "tabindex",
              f: "-1",
              t: 13,
              g: 1
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this", "./value"],
                s: "[_0.selectItem(_1)]"
              }
            }],
            f: [{
              t: 7,
              e: "span",
              f: [{
                t: 2,
                r: "./name"
              }]
            }]
          }],
          n: 52,
          r: "options"
        }]
      }]
    }]
  }],
  e: {
    "[_0.toggleDropdown()]": function (_0) {
      return [_0.toggleDropdown()];
    },
    "[_0.onKeyDown(_1)]": function (_0, _1) {
      return [_0.onKeyDown(_1)];
    },
    "_0===_1": function (_0, _1) {
      return _0 === _1;
    },
    "[_0.selectItem(_1)]": function (_0, _1) {
      return [_0.selectItem(_1)];
    }
  }
};
var select = ractive.extend(component$c.exports);

var component$b = {
  exports: {}
};
const FILTER_TYPE_BY_CONTINENT = 'byContinent';
const FILTER_TYPE_BY_NETWORK = 'byNetwork';
component$b.exports = {
  data() {
    return {
      addNetworks: true,
      showGroupBy: true,
      showSortOrder: true,
      availableFilters: [{
        name: 'Europe',
        value: 'Europe',
        type: FILTER_TYPE_BY_CONTINENT
      }, {
        name: 'North America',
        value: 'North America',
        type: FILTER_TYPE_BY_CONTINENT
      }, {
        name: 'South America',
        value: 'South America',
        type: FILTER_TYPE_BY_CONTINENT
      }, {
        name: 'Africa',
        value: 'Africa',
        type: FILTER_TYPE_BY_CONTINENT
      }, {
        name: 'Asia',
        value: 'Asia',
        type: FILTER_TYPE_BY_CONTINENT
      }, {
        name: 'Oceania',
        value: 'Oceania',
        type: FILTER_TYPE_BY_CONTINENT
      }, {
        name: 'eyeball network',
        value: 'eyeball-network',
        type: FILTER_TYPE_BY_NETWORK
      }, {
        name: 'datacenter',
        value: 'datacenter-network',
        type: FILTER_TYPE_BY_NETWORK
      }],
      filtersSet: null
    };
  },
  computed: {
    locationTooltipContent() {
      return [`This magic field supports names of continents, regions, countries, US states, cities, ${this.get('addNetworks') ? 'networks, ' : ''}and our custom tags.`, '', 'Use + to combine multiple filters.', 'Use , to select multiple locations.'];
    },
    supportedFeaturesMessage() {
      if (this.get('addNetworks')) {
        return undefined;
      }
      return 'Our magic search supports names of continents, regions, countries, US states, cities, and custom tags.';
    },
    reshapeResults() {
      if (this.get('addNetworks')) {
        return sources => sources;
      }
      return sources => sources.filter(source => source.sourceId !== 'networks');
    }
  },
  oninit() {
    if (!ractive.isServer) {
      this.observe('location', () => {
        this.updateFiltersSet();
      });
    }
  },
  updateFiltersSet() {
    let location = this.get('location');
    let availableFilters = this.get('availableFilters');
    availableFilters.forEach(f => f.selected = false);
    if (!location) {
      this.set('filtersSet', []);
      this.set('availableFilters', availableFilters);
      return;
    }
    let parts = location.split(/[+,]/).map(p => p.trim().toLowerCase());
    let filtersSet = [];
    availableFilters.forEach((f, i) => {
      let part = parts.find(part => {
        return f.name.toLowerCase() === part || f.value.toLowerCase() === part;
      });
      if (part) {
        f.selected = true;
        f.avFiltersIdx = i;
        filtersSet.push(f);
      }
    });
    this.set('filtersSet', filtersSet);
    this.set('availableFilters', availableFilters);
  },
  setFilterRule(idx) {
    let availableFilters = this.get('availableFilters');
    let selectedFilter = availableFilters[idx];
    let location = this.get('location');
    if (!location) {
      this.set('location', selectedFilter.value);
    } else {
      let parts = location.split(',').map(query => query.split('+').map(p => p.trim().toLowerCase())).flat();
      let hasContinent = false;
      let hasNetwork = false;
      for (let f of availableFilters) {
        let matchingPart = parts.find(part => part === f.name.toLowerCase() || part === f.value.toLowerCase());
        if (matchingPart) {
          if (f.type === FILTER_TYPE_BY_CONTINENT) {
            hasContinent = true;
          } else if (f.type === FILTER_TYPE_BY_NETWORK) {
            hasNetwork = true;
          }
        }
      }
      if (selectedFilter.type === FILTER_TYPE_BY_NETWORK && hasContinent && !hasNetwork) {
        this.set('location', `${location}+${selectedFilter.value}`);
      } else if (selectedFilter.type === FILTER_TYPE_BY_CONTINENT && hasNetwork && !hasContinent) {
        this.set('location', `${location}+${selectedFilter.value}`);
      } else {
        this.set('location', selectedFilter.value);
      }
    }
    this.findComponent('c-location-input')?.fire('outsideLocationChange');
  },
  rmFilterRule(idx) {
    let filter = this.get('filtersSet')[idx];
    let selectedFilter = this.get('availableFilters').find(f => f.value === filter.value);
    let location = this.get('location');
    if (location.includes(selectedFilter.value)) {
      let parts = location.split(',');
      let updatedParts = parts.map(part => {
        let segments = part.split('+').map(s => s.trim());
        let filteredSegments = segments.filter(s => s.toLowerCase() !== filter.value.toLowerCase());
        return filteredSegments.join('+');
      }).filter(part => part.trim() !== '');
      this.set('location', updatedParts.join(',') || 'World');
    }
    this.findComponent('c-location-input')?.fire('outsideLocationChange');
  }
};
component$b.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "gp-probe-filters",
      g: 1
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "gp-probe-filters_row",
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-probe-filters_field gp-probe-filters_field--location",
          g: 1
        }],
        f: [{
          t: 7,
          e: "c-location-input",
          m: [{
            n: "rawProbes",
            f: [{
              t: 2,
              r: "rawProbes"
            }],
            t: 13
          }, {
            n: "value",
            f: [{
              t: 2,
              r: "location"
            }],
            t: 13
          }, {
            n: "error",
            f: [{
              t: 2,
              r: "locationError"
            }],
            t: 13
          }, {
            n: "placeholder",
            f: "Enter location",
            t: 13,
            g: 1
          }, {
            n: "labelText",
            f: "Location",
            t: 13,
            g: 1
          }, {
            n: "classList",
            f: "gp_map-block_settings-wrapper_settings_location gp_input",
            t: 13,
            g: 1
          }, {
            n: "ttPos",
            f: [{
              t: 2,
              r: "ttPositions.locationTtPos"
            }],
            t: 13
          }, {
            n: "exposeProbes",
            f: [{
              t: 2,
              x: {
                r: [],
                s: "true"
              }
            }],
            t: 13
          }, {
            n: "results",
            f: [{
              t: 2,
              r: "locationProbes"
            }],
            t: 13
          }, {
            n: "completedValue",
            f: [{
              t: 2,
              r: "locationCompletedValue"
            }],
            t: 13
          }, {
            n: "reshapeResults",
            f: [{
              t: 2,
              r: "reshapeResults"
            }],
            t: 13
          }, {
            n: "locationTooltipContent",
            f: [{
              t: 2,
              r: "locationTooltipContent"
            }],
            t: 13
          }, {
            n: "supportedFeaturesMessage",
            f: [{
              t: 2,
              r: "supportedFeaturesMessage"
            }],
            t: 13
          }],
          f: [],
          p: {
            labelIcon: [{
              t: 7,
              e: "img",
              m: [{
                n: "tooltip",
                t: 71,
                f: {
                  r: ["locationTooltipContent", "ttPos"],
                  s: "[_0,_1,undefined,undefined,\"multiline\"]"
                }
              }, {
                n: "width",
                f: "14",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "14",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/help-icon.svg"],
                t: 13
              }]
            }]
          }
        }]
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-probe-filters_field gp-probe-filters_field--group-by",
            g: 1
          }],
          f: [{
            t: 7,
            e: "label",
            f: ["Group by"]
          }, " ", {
            t: 7,
            e: "c-select",
            m: [{
              n: "options",
              f: [{
                t: 2,
                r: "groupingOptions"
              }],
              t: 13
            }, {
              n: "selected",
              f: [{
                t: 2,
                r: "groupBy"
              }],
              t: 13
            }, {
              n: "name",
              f: "group-by-select",
              t: 13,
              g: 1
            }]
          }]
        }],
        n: 50,
        r: "showGroupBy"
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-probe-filters_field gp-probe-filters_field--sort-by",
            g: 1
          }],
          f: [{
            t: 7,
            e: "label",
            f: ["Sort by"]
          }, " ", {
            t: 7,
            e: "c-select",
            m: [{
              n: "options",
              f: [{
                t: 2,
                r: "sortOptions"
              }],
              t: 13
            }, {
              n: "disabled",
              f: [{
                t: 2,
                x: {
                  r: ["showGroupBy", "groupBy"],
                  s: "_0&&_1===\"disabled\""
                }
              }],
              t: 13
            }, {
              n: "selected",
              f: [{
                t: 2,
                r: "sortOrder"
              }],
              t: 13
            }, {
              n: "name",
              f: "sort-by-select",
              t: 13,
              g: 1
            }]
          }]
        }],
        n: 50,
        r: "showSortOrder"
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "gp-probe-filters_quick",
        g: 1
      }],
      f: [{
        t: 7,
        e: "span",
        m: [{
          t: 13,
          n: "class",
          f: "gp-probe-filters_quick_title",
          g: 1
        }],
        f: [{
          t: 7,
          e: "span",
          f: ["Quick Filters:"]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-probe-filters_quick_list",
          g: 1
        }],
        f: [{
          t: 4,
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "gp-probe-filters_quick_list_selected",
              g: 1
            }],
            f: [{
              t: 2,
              r: "./name"
            }, " ", {
              t: 7,
              e: "button",
              m: [{
                t: 13,
                n: "class",
                f: "gp-probe-filters_quick_list_selected_remove",
                g: 1
              }, {
                n: "data-testid",
                f: ["quick-filter-", {
                  t: 2,
                  r: "./name"
                }],
                t: 13
              }, {
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this", "@key"],
                  s: "[_0.rmFilterRule(_1)]"
                }
              }, {
                n: "type",
                f: "button",
                t: 13,
                g: 1
              }, {
                n: "aria-label",
                f: ["Remove ", {
                  t: 2,
                  r: "./name"
                }, " filter"],
                t: 13
              }],
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "16",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "16",
                  t: 13,
                  g: 1
                }, {
                  n: "alt",
                  f: "",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/tag-input-close-icon.svg"],
                  t: 13
                }]
              }]
            }]
          }],
          n: 52,
          r: "filtersSet"
        }, " ", {
          t: 4,
          f: [{
            t: 4,
            f: [{
              t: 7,
              e: "button",
              m: [{
                t: 13,
                n: "class",
                f: "gp-probe-filters_quick_list_item",
                g: 1
              }, {
                n: "data-testid",
                f: ["quick-filter-", {
                  t: 2,
                  r: "./name"
                }],
                t: 13
              }, {
                n: ["click"],
                t: 70,
                f: {
                  r: ["@this", "@key"],
                  s: "[_0.setFilterRule(_1)]"
                }
              }, {
                n: "type",
                f: "button",
                t: 13,
                g: 1
              }],
              f: [{
                t: 2,
                r: "./name"
              }]
            }],
            n: 51,
            r: "./selected"
          }],
          n: 52,
          r: "availableFilters"
        }]
      }]
    }]
  }],
  e: {
    "true": function () {
      return true;
    },
    "[_0,_1,undefined,undefined,\"multiline\"]": function (_0, _1) {
      return [_0, _1, undefined, undefined, "multiline"];
    },
    "_0&&_1===\"disabled\"": function (_0, _1) {
      return _0 && _1 === "disabled";
    },
    "[_0.rmFilterRule(_1)]": function (_0, _1) {
      return [_0.rmFilterRule(_1)];
    },
    "[_0.setFilterRule(_1)]": function (_0, _1) {
      return [_0.setFilterRule(_1)];
    }
  }
};
component$b.exports.components = {
  "c-location-input": locationInput,
  "c-select": select
};
var probeFilters = ractive.extend(component$b.exports);

let popoverDecorator = (node, contentHtml) => {
  if (!contentHtml || typeof $(node).popover !== 'function') {
    return {
      teardown: () => {}
    };
  }
  let $node = $(node);
  $node.popover({
    container: 'body',
    html: true,
    content: contentHtml,
    placement: 'auto',
    trigger: 'manual',
    template: `<div class="popover gp-popover" role="dialog" tabindex="-1"><div class="arrow"></div><div class="popover-content"></div></div>`
  });
  let nodeClickHandler = e => {
    e.preventDefault();
    e.stopPropagation();
    $node.popover('toggle');
    $(document).trigger('click.gpPopover');
  };
  let keydownHandler = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      $node.popover('toggle');
      $(document).trigger('click.gpPopover');
    }
  };
  let shownHandler = () => {
    $(document).on('click.gpPopover', documentClickHandler);
    let popoverId = $node.attr('aria-describedby');
    if (!popoverId) {
      return;
    }
    let $popover = $('#' + popoverId);
    let $focusable = $popover.find('button, a, input, textarea, select, [tabindex]:not([tabindex="-1"])');
    if ($focusable.length) {
      $focusable.first().focus();
    } else {
      $popover.focus();
    }
    $popover.on('keydown.gpPopover', e => {
      if (e.key === 'Escape') {
        e.preventDefault();
        $node.popover('hide');
        $node.focus();
      }
    });
  };
  let hiddenHandler = () => {
    $(document).off('click.gpPopover', documentClickHandler);
    let popoverId = $node.attr('aria-describedby');
    if (popoverId) {
      $('#' + popoverId).off('keydown.gpPopover');
    }
  };
  let documentClickHandler = e => {
    let popoverId = $node.attr('aria-describedby');
    if (!popoverId) {
      return;
    }
    let $popover = $('#' + popoverId);

    // check if the click is outside the trigger and outside this specific popover instance
    if (!$node.is(e.target) && $node.has(e.target).length === 0 && !$popover.is(e.target) && $popover.has(e.target).length === 0) {
      $node.popover('hide');
    }
  };
  $node.on('click', nodeClickHandler);
  $node.on('keydown', keydownHandler);
  $node.on('shown.bs.popover', shownHandler);
  $node.on('hidden.bs.popover', hiddenHandler);
  return {
    update(newContentHtml) {
      $node.popover('hide');
      let popover = $(node).data('bs.popover');
      if (popover && popover.options) {
        popover.options.content = newContentHtml;
      }
    },
    teardown() {
      let popoverId = $node.attr('aria-describedby');
      $node.off('click', nodeClickHandler);
      $node.off('keydown', keydownHandler);
      $node.off('shown.bs.popover', shownHandler);
      $node.off('hidden.bs.popover', hiddenHandler);
      $(document).off('click.gpPopover', documentClickHandler);
      if (typeof $node.popover === 'function') {
        $node.popover('destroy');
      }
      if (popoverId) {
        $('#' + popoverId).remove();
      }
      $node.removeData('bs.popover');
      $node.removeAttr('aria-describedby');
    }
  };
};
var popover = popoverDecorator;

var component$a = {
  exports: {}
};
const CHAR_WIDTH = 5.8;
const PADDING = 2 * 6;
const GAP = 6;
const PLUS_TAG_WIDTH = PADDING + 2 * CHAR_WIDTH;
component$a.exports = {
  decorators: {
    popover,
    tooltip
  },
  data() {
    return {
      render: true,
      location: {},
      tags: [],
      visibleTags: [],
      hiddenTags: [],
      screenWidth: 0,
      locationFilter: ''
    };
  },
  oninit() {
    this.observe('location', location => {
      let network = location && location.network ? location.network : '';
      this.set('networkKey', network ? _.networkNameToKey(network) : '');
    }, {
      init: true
    });
    this.observe('screenWidth', () => {
      this.calculateTags();
    }, {
      init: false
    });
  },
  onrender() {
    if (!ractive.isServer) {
      this.calculateTags();
    }
  },
  calculateTags() {
    let card = document.getElementsByClassName('probe-single-card--visible')[0];
    if (!card) {
      return;
    }
    let tags = this.get('tags') || [];
    let visibleTags = [];
    let hiddenTags = [];
    let remainingWidth = card.clientWidth - 24;
    tags.forEach((tag, index) => {
      let tagSize = tag.length * CHAR_WIDTH + PADDING + GAP;
      let countPlusTag = index < tags.length - 1 || hiddenTags.length > 0;
      if (tagSize + (countPlusTag ? PLUS_TAG_WIDTH : 0) <= remainingWidth) {
        remainingWidth -= tagSize;
        visibleTags.push(tag);
      } else {
        hiddenTags.push(tag);
      }
    });
    this.set({
      visibleTags,
      hiddenTags
    });
  },
  getPopoverContent(locationValue, isNetwork = true) {
    let targetLoc = _.createLocationString(locationValue, this.get('locationFilter'));

    // a parent component MUST handle the click of this button
    let btnFocus = `
				<button type="button"
					class="popover-focus-loc"
					data-location="${_.escapeLocationString(targetLoc)}">
					<i class="fa fa-map-marker" aria-hidden="true" style="padding-right: 3px;"></i>
					Focus this ${isNetwork ? 'network' : 'location'}
				</button>`;
    let btnMeasure = `
				<a href="/?location=${encodeURIComponent(targetLoc.replaceAll('+', '%'))}">
					<i class="fa fa-crosshairs" aria-hidden="true"></i>
					Target in a measurement
				</a>`;
    let btnLookingGlass = '';
    if (isNetwork) {
      let networkKey = _.networkNameToKey(locationValue);
      btnLookingGlass = `
				<a href="/networks/${networkKey}">
					<i class="fa fa-search" aria-hidden="true"></i>
					<span>
						<span class="probe-single-card_popover_network-name">${_.escapeLocationString(locationValue)}</span>&nbsp;looking glass
					</span>
				</a>`;
    }
    return `<div class="gp-popover-menu">${btnFocus}${btnMeasure}${btnLookingGlass}</div>`;
  }
};
component$a.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      n: "class",
      f: ["probe-single-card probe-single-card--", {
        t: 4,
        f: ["hidden"],
        n: 50,
        x: {
          r: ["render"],
          s: "!_0"
        }
      }, {
        t: 4,
        f: ["visible"],
        n: 51,
        l: 1
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "probe-single-card_header",
        g: 1
      }],
      f: [{
        t: 7,
        e: "img",
        m: [{
          t: 13,
          n: "class",
          f: "probe-single-card_flag",
          g: 1
        }, {
          n: "loading",
          f: "lazy",
          t: 13,
          g: 1
        }, {
          n: "width",
          f: "27",
          t: 13,
          g: 1
        }, {
          n: "height",
          f: "18",
          t: 13,
          g: 1
        }, {
          n: "src",
          f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
            t: 2,
            r: "location.country"
          }, ".svg"],
          t: 13
        }, {
          n: "alt",
          f: "",
          t: 13,
          g: 1
        }, {
          n: "aria-hidden",
          f: "true",
          t: 13,
          g: 1
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "probe-single-card_title",
          g: 1
        }],
        f: [{
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "probe-single-card_title_location",
            g: 1
          }, {
            n: "tabindex",
            f: "0",
            t: 13,
            g: 1
          }, {
            n: "role",
            f: "button",
            t: 13,
            g: 1
          }, {
            n: "popover",
            t: 71,
            f: {
              r: ["@this", "location.city", "location.country"],
              s: "[_0.getPopoverContent((\"\"+(_1)+\"+\"+(_2)),false)]"
            }
          }],
          f: [{
            t: 2,
            r: "location.city"
          }, ", ", {
            t: 2,
            r: "location.country"
          }]
        }, " ", {
          t: 7,
          e: "span",
          m: [{
            t: 13,
            n: "class",
            f: "probe-single-card_title_network",
            g: 1
          }, {
            n: "tabindex",
            f: "0",
            t: 13,
            g: 1
          }, {
            n: "role",
            f: "button",
            t: 13,
            g: 1
          }, {
            n: "popover",
            t: 71,
            f: {
              r: ["@this", "location.network"],
              s: "[_0.getPopoverContent(_1)]"
            }
          }],
          f: [{
            t: 2,
            r: "location.network"
          }]
        }]
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "probe-single-card_tags",
          g: 1
        }],
        f: [{
          t: 4,
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "probe-single-card_tag",
              g: 1
            }],
            f: [{
              t: 2,
              r: "."
            }]
          }],
          n: 52,
          r: "visibleTags"
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "probe-single-card_tag probe-single-card_tag--more",
              g: 1
            }, {
              n: "tooltip",
              t: 71,
              f: {
                r: ["hiddenTags"],
                s: "[_0]"
              }
            }],
            f: ["+", {
              t: 2,
              r: "hiddenTags.length"
            }]
          }],
          n: 50,
          x: {
            r: ["hiddenTags.length"],
            s: "_0>0"
          }
        }]
      }],
      n: 50,
      x: {
        r: ["tags", "tags.length"],
        s: "_0&&_1>0"
      }
    }]
  }],
  e: {
    "!_0": function (_0) {
      return !_0;
    },
    "[_0.getPopoverContent((\"\"+(_1)+\"+\"+(_2)),false)]": function (_0, _1, _2) {
      return [_0.getPopoverContent("" + _1 + "+" + _2, false)];
    },
    "[_0.getPopoverContent(_1)]": function (_0, _1) {
      return [_0.getPopoverContent(_1)];
    },
    "[_0]": function (_0) {
      return [_0];
    },
    "_0>0": function (_0) {
      return _0 > 0;
    },
    "_0&&_1>0": function (_0, _1) {
      return _0 && _1 > 0;
    }
  }
};
var probeSingleCard = ractive.extend(component$a.exports);

var component$9 = {
  exports: {}
};
const DEFAULT_CARD_RENDER_LIMIT = 99;
const CONTINENT_MAP$1 = CONTINENTS.reduce((acc, continent) => {
  acc[continent.code] = continent.name;
  return acc;
}, {});
const COUNTRIES_MAP$1 = countries.reduce((acc, country) => {
  acc[country.code] = country.name;
  return acc;
}, {});
component$9.exports = {
  decorators: {
    popover
  },
  data() {
    return {
      _,
      locationError: '',
      groupingOptions: [{
        name: 'Country',
        value: 'country'
      }, {
        name: 'City',
        value: 'city'
      }, {
        name: 'Network',
        value: 'network'
      }, {
        name: 'Country + Network',
        value: 'country-network'
      }, {
        name: 'City + Network',
        value: 'city-network'
      }, {
        name: 'Disabled',
        value: 'disabled'
      }],
      sortOptions: [{
        name: 'Alphabetically',
        value: 'alphabetically'
      }, {
        name: 'Probe count',
        value: 'probe-count'
      }],
      defaultSortOptions: {},
      probeContinents: [],
      groupedProbes: null,
      locationProbes: null,
      preparedProbeBlocks: null,
      filteredMarkersData: null,
      selectedContinent: null,
      justClickedLocationFocus: false,
      skipNextSplit: false,
      hasManualSortBy: false,
      preFocusGroupBy: null,
      autoGroupedByFocus: false,
      isProgrammaticGroupByChange: false,
      visibleProbeCards: [],
      defaultCardRenderLimit: DEFAULT_CARD_RENDER_LIMIT,
      probeCardTimeout: null,
      loadingProbeCards: false,
      screenWidth: 0
    };
  },
  computed: {
    probeLocationCounts() {
      let probes = this.get('locationProbes');
      if (!probes) {
        return {
          continent: 0,
          country: 0,
          city: 0,
          network: 0
        };
      }
      let uniqueValues = probes.reduce((acc, probe) => {
        acc.continent.add(probe.location.continent);
        acc.country.add(probe.location.country);
        acc.city.add(probe.location.country + probe.location.city);
        acc.network.add(probe.location.network);
        return acc;
      }, {
        continent: new Set(),
        country: new Set(),
        city: new Set(),
        network: new Set()
      });
      return {
        continent: uniqueValues.continent.size,
        country: uniqueValues.country.size,
        city: uniqueValues.city.size,
        network: uniqueValues.network.size
      };
    },
    totalResults() {
      let probes = this.get('locationProbes');
      let groupBy = this.get('groupBy');
      if (!probes) {
        return 0;
      }
      if (groupBy === 'disabled') {
        return probes.length;
      }

      // do not recalculate the total if we already have it in probeLocationCounts
      if (!groupBy.includes('-')) {
        return this.get('probeLocationCounts')[groupBy];
      }
      let keyParts = {
        'country-network': ['country', 'network'],
        'city-network': ['country', 'city', 'network']
      }[groupBy];
      return probes.reduce((uniqueKeys, probe) => {
        uniqueKeys.add(keyParts.map(part => probe.location[part]).join());
        return uniqueKeys;
      }, new Set()).size;
    },
    hasCustomLocationApplied() {
      let location = this.get('location');
      return location && location.toLowerCase() !== 'world';
    }
  },
  oninit() {
    if (!ractive.isServer) {
      // set initial screenWidth value
      this.observe('screenWidth', screenWidth => {
        if (!screenWidth) {
          this.set('screenWidth', window.innerWidth);
          return;
        }

        // handle tooltips positions depending on the screen size
        let ttPositions = {};
        if (screenWidth >= 1272) {
          ttPositions.targetTtPos = 'top';
          ttPositions.locationTtPos = 'top';
          ttPositions.limitTtPos = 'top';
        } else if (screenWidth >= 768) {
          ttPositions.targetTtPos = 'top';
          ttPositions.locationTtPos = 'right';
          ttPositions.limitTtPos = 'top';
        } else {
          ttPositions.targetTtPos = 'right';
          ttPositions.locationTtPos = 'right';
          ttPositions.limitTtPos = 'right';
        }
        this.set('ttPositions', ttPositions);
      });
      this.observe('locationProbes', locationProbes => {
        this.set('filteredProbes', locationProbes);

        // we need to set sort, filter, and group query params simultaneously
        let payload = {};
        let doAtomicUpdate = false;
        let nextGroupBy = this.get('groupBy');
        if (this.get('justClickedLocationFocus')) {
          this.set('justClickedLocationFocus', false);
          if (!this.get('autoGroupedByFocus')) {
            this.set('preFocusGroupBy', this.get('groupBy'));
          }
          let {
            cities,
            countries,
            networks
          } = this.getLocationCounts(locationProbes || []);
          let newGroupBy = null;
          if (cities + countries + networks === 3) {
            newGroupBy = 'disabled';
          } else if (cities + countries === 2) {
            newGroupBy = 'network';
          } else if (cities > 1) {
            newGroupBy = 'city';
          }
          if (newGroupBy && newGroupBy !== this.get('groupBy')) {
            this.set('isProgrammaticGroupByChange', true);
            nextGroupBy = newGroupBy;
            payload = {
              groupBy: newGroupBy,
              locationCompletedValue: this.get('location'),
              autoGroupedByFocus: true
            };
            doAtomicUpdate = true;
          }
        } else {
          // restore previous groupBy value if the current groupBy value was set via "focus this location"
          if (this.get('autoGroupedByFocus')) {
            let previousGroupBy = this.get('preFocusGroupBy');
            if (previousGroupBy && previousGroupBy !== this.get('groupBy')) {
              this.set('isProgrammaticGroupByChange', true);
              nextGroupBy = previousGroupBy;
              payload = {
                groupBy: previousGroupBy,
                locationCompletedValue: this.get('location')
              };
              doAtomicUpdate = true;
            }
            this.set('autoGroupedByFocus', false);
            this.set('preFocusGroupBy', null);
          }
        }
        if (doAtomicUpdate) {
          let defaultSort = this.get('defaultSortOptions')[nextGroupBy];
          if (nextGroupBy !== 'disabled' && defaultSort && this.get('sortOrder') !== defaultSort && !this.get('hasManualSortBy')) {
            payload.skipNextSplit = true;
            payload.sortOrder = defaultSort;
          }
          this.set(payload);
        }
        let groupedProbes = this.groupProbes(locationProbes || []);
        this.set('groupedProbes', groupedProbes);
      });
      this.observe('groupBy', groupBy => {
        if (this.get('isProgrammaticGroupByChange')) {
          this.set('isProgrammaticGroupByChange', false);
          return;
        }
        this.set('autoGroupedByFocus', false);
        this.set('preFocusGroupBy', null);
        let defaultSort = this.get('defaultSortOptions')[groupBy];
        if (groupBy !== 'disabled' && defaultSort && this.get('sortOrder') !== defaultSort && !this.get('hasManualSortBy')) {
          this.set('skipNextSplit', true);
          this.set('sortOrder', defaultSort);
        }
        let locationProbes = this.get('locationProbes');
        let groupedProbes = this.groupProbes(locationProbes || []);
        this.set('groupedProbes', groupedProbes);
      }, {
        init: false
      });
      this.observe('sortOrder', sortOrder => {
        let groupBy = this.get('groupBy');
        if (groupBy === 'disabled') {
          return;
        }
        let defaultSort = this.get('defaultSortOptions')[groupBy];
        if (sortOrder === defaultSort) {
          this.set('hasManualSortBy', false);
        } else {
          this.set('hasManualSortBy', true);
        }
      });
      this.observe('groupedProbes', () => {
        this.recalculateProbeContinents();
      });
      this.observe('groupBy location', () => {
        clearTimeout(this.probeCardTimeout);
        this.set('loadingProbeCards', false);
      });
      this.observe('groupedProbes sortOrder screenWidth', () => {
        if (this.get('skipNextSplit')) {
          this.set('skipNextSplit', false);
          return;
        }
        let preparedProbeBlocks = this.splitDataIntoBlocks();
        this.set('preparedProbeBlocks', preparedProbeBlocks);
        if (this.get('groupBy') === 'disabled' && preparedProbeBlocks.length > 0) {
          this.set('visibleProbeCards', preparedProbeBlocks[0].items.slice(0, this.get('defaultCardRenderLimit')));
        }
      });
    }
  },
  onrender() {
    if (!ractive.isServer) {
      listeners.screenWidthListener(this);
      let handleFocusClick = e => {
        let location = $(e.currentTarget).data('location');
        if (location) {
          this.set('justClickedLocationFocus', true);
          this.set('location', location);
          this.findComponent('c-location-input')?.fire('outsideLocationChange');
        }
      };
      $('body').on('click', '.popover-focus-loc', handleFocusClick);
      this.on('teardown', () => {
        $('body').off('click', '.popover-focus-loc', handleFocusClick);
        clearTimeout(this.probeCardTimeout);
      });
    }
  },
  getPopoverContent(locationValue, networkName = '') {
    let groupBy = this.get('groupBy');
    let targetLoc = '';
    if (networkName) {
      targetLoc = `${networkName}+${locationValue}`;
    } else {
      targetLoc = _.createLocationString(locationValue, this.get('location'));
    }
    let focusTargetText = 'location';
    if (groupBy === 'network') {
      focusTargetText = 'network';
    } else if (groupBy.includes('network') && networkName) {
      focusTargetText = 'location + network';
    }
    let btnFocus = `
				<button type="button"
					class="popover-focus-loc"
					data-location="${_.escapeLocationString(targetLoc)}">
					<i class="fa fa-map-marker" aria-hidden="true" style="padding-right: 3px;"></i>
					Focus this ${focusTargetText}
				</button>`;
    let btnMeasure = `
				<a href="/?location=${encodeURIComponent(targetLoc.replaceAll('+', '%'))}">
					<i class="fa fa-crosshairs" aria-hidden="true"></i>
					Target in a measurement
				</a>`;
    let btnLookingGlass = '';
    if (groupBy === 'network' || !!networkName) {
      networkName = networkName || locationValue;
      let networkKey = _.networkNameToKey(networkName);
      btnLookingGlass = `
				<a href="/networks/${networkKey}">
					<i class="fa fa-search" aria-hidden="true"></i>
					<span>
						<span class="gp-filtered-list_popover_network-name">${_.escapeLocationString(networkName)}</span>&nbsp;looking glass
					</span>
				</a>`;
    }
    return `<div class="gp-popover-menu">${btnFocus}${btnMeasure}${btnLookingGlass}</div>`;
  },
  getLocationCounts(probes) {
    let maps = probes.reduce((res, probe) => {
      res.countries.add(probe.location.country);
      res.cities.add(probe.location.country + probe.location.city);
      res.networks.add(probe.location.network);
      return res;
    }, {
      countries: new Set(),
      cities: new Set(),
      networks: new Set()
    });
    return {
      countries: maps.countries.size,
      cities: maps.cities.size,
      networks: maps.networks.size
    };
  },
  groupProbes(probes) {
    let groupBy = this.get('groupBy');
    // group probes by Continents and Coordinates
    let groups = probes.reduce((res, probe) => {
      let location = `${probe.location.country}, ${probe.location.city}`;
      let groupKey = groupBy === 'disabled' ? 'disabled' : probe.location.continent;
      if (groupBy === 'disabled') {
        if (!Object.hasOwn(res, groupKey)) {
          res[groupKey] = [];
        }
        res[groupKey].push(probe);
      } else {
        if (!Object.hasOwn(res, groupKey)) {
          res[groupKey] = {};
        }
        if (!Object.hasOwn(res[groupKey], location)) {
          res[groupKey][location] = [];
        }
        res[groupKey][location].push(probe);
      }
      return res;
    }, {});
    if (groupBy !== 'disabled') {
      let byContinentSorted = Object.entries(groups).sort((a, b) => Object.keys(b[1]).length - Object.keys(a[1]).length);
      groups = Object.fromEntries(byContinentSorted);
    }
    return groups;
  },
  getContinentName(code) {
    return CONTINENT_MAP$1[code] || code;
  },
  getCountryName(code) {
    return COUNTRIES_MAP$1[code] || code;
  },
  onLogoError(item) {
    item.logoAsn = null;
    this.update('preparedProbeBlocks');
  },
  sortAndGroup(obj) {
    let groupBy = this.get('groupBy');
    let sortOrder = this.get('sortOrder');
    if (groupBy === 'disabled') {
      return Object.values(obj).flat();
    }
    if (groupBy === 'network') {
      let allNetworks = {};
      Object.keys(obj).forEach(continent => {
        let locations = Object.keys(obj[continent]);
        locations.forEach(location => {
          let probes = obj[continent][location];
          probes.forEach(probe => {
            let network = probe.location.network;
            let key = network.toLowerCase();
            if (!Object.hasOwn(allNetworks, key)) {
              allNetworks[key] = {
                name: network,
                probes: []
              };
            }
            allNetworks[key].probes.push(probe);
          });
        });
      });
      let alphComp = (a, b) => allNetworks[a].name.localeCompare(allNetworks[b].name);
      let cntComp = (a, b) => allNetworks[b].probes.length - allNetworks[a].probes.length;
      let sortedNetworks = Object.keys(allNetworks).sort((a, b) => {
        if (sortOrder === 'alphabetically') {
          return alphComp(a, b) || cntComp(a, b);
        }
        return cntComp(a, b) || alphComp(a, b);
      });
      return sortedNetworks.map(network => ({
        continent: null,
        name: allNetworks[network].name,
        from: allNetworks[network].name,
        location: allNetworks[network].name,
        logoAsn: allNetworks[network].probes[0].location.asn,
        probes: allNetworks[network].probes,
        networks: [],
        showFlag: false
      }));
    }
    let networkNameMap = {}; // make sure all networks have the same letter case across cities/countries

    let sortedArray = Object.keys(obj).sort((a, b) => {
      if (sortOrder === 'alphabetically') {
        return a.localeCompare(b);
      }
      let probesCountA = Object.values(obj[a]).reduce((sum, probes) => sum + probes.length, 0);
      let probesCountB = Object.values(obj[b]).reduce((sum, probes) => sum + probes.length, 0);
      return probesCountB - probesCountA;
    }).reduce((acc, continent) => {
      let locations = Object.keys(obj[continent]);
      let groupedLocations = locations.reduce((acc, location) => {
        let probes = obj[continent][location];
        let key;
        switch (groupBy) {
          case 'country-network':
            key = probes[0].location.country;
            break;
          case 'city-network':
            key = `${probes[0].location.country}, ${probes[0].location.city}`;
            break;
          case 'city':
            key = `${probes[0].location.country}, ${probes[0].location.city}`;
            break;
          case 'country':
          default:
            key = probes[0].location.country;
            break;
        }
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(...probes);
        return acc;
      }, {});
      let sortedLocations = Object.keys(groupedLocations).sort((a, b) => {
        if (sortOrder !== 'alphabetically') {
          return groupedLocations[b].length - groupedLocations[a].length;
        }
        let [countryA, cityA] = a.split(', ');
        let [countryB, cityB] = b.split(', ');
        let countryKeyA = groupBy.includes('country') ? this.getCountryName(countryA) : countryA;
        let countryKeyB = groupBy.includes('country') ? this.getCountryName(countryB) : countryB;
        return countryKeyA.localeCompare(countryKeyB) || (cityA && cityB ? cityA.localeCompare(cityB) : 0);
      });
      acc.push(...sortedLocations.map(location => {
        let probes = groupedLocations[location];
        let networks = [];
        if (groupBy === 'country-network' || groupBy === 'city-network') {
          // Count probes per network
          let networkCounts = probes.reduce((acc, probe) => {
            let network = probe.location.network;
            let key = network.toLowerCase();
            if (!Object.hasOwn(networkNameMap, key)) {
              networkNameMap[key] = network;
            }
            if (!Object.hasOwn(acc, key)) {
              acc[key] = {
                name: networkNameMap[key],
                count: 0
              };
            }
            acc[key].count += 1;
            return acc;
          }, {});
          networks = Object.entries(networkCounts).map(([, {
            name,
            count
          }]) => ({
            name,
            count
          }));
          if (sortOrder === 'alphabetically') {
            networks.sort((a, b) => a.name.localeCompare(b.name));
          } else {
            networks.sort((a, b) => b.count - a.count);
          }
        }
        let from;
        switch (groupBy) {
          case 'city':
          case 'city-network':
            from = `${probes[0].location.city}%${probes[0].location.country}`;
            break;
          case 'country-network':
          case 'country':
          default:
            from = this.getCountryName(probes[0].location.country);
            break;
        }
        return {
          continent,
          from,
          name: groupBy.startsWith('country') ? this.getCountryName(location) : location,
          location,
          probes,
          networks,
          showFlag: groupBy !== 'network'
        };
      }));
      return acc;
    }, []);
    return sortedArray;
  },
  splitDataIntoBlocks() {
    let groupedProbes = this.get('groupedProbes');
    if (!groupedProbes) {
      return [];
    }
    let data = this.sortAndGroup(groupedProbes);
    let groupBy = this.get('groupBy');
    if (groupBy === 'network' || groupBy === 'disabled') {
      return [{
        title: null,
        items: data
      }];
    }
    return data.reduce((res, item) => {
      let continentGroup = res.find(group => group.title === item.continent);
      if (!continentGroup) {
        continentGroup = {
          title: item.continent,
          items: []
        };
        res.push(continentGroup);
      }
      continentGroup.items.push(item);
      return res;
    }, []);
  },
  recalculateProbeContinents() {
    let groupBy = this.get('groupBy');
    let groupedProbes = this.get('groupedProbes');
    if (groupBy === 'disabled' || groupBy === 'network') {
      this.set('probeContinents', []);
      this.set('selectedContinent', null);
    } else {
      this.set('probeContinents', Object.keys(groupedProbes).map(continent => ({
        name: this.getContinentName(continent),
        value: continent
      })));
      let selectedContinent = this.get('selectedContinent');
      this.set('selectedContinent', this.get('probeContinents').some(c => c.value === selectedContinent) ? selectedContinent : null);
    }
  },
  scrollToContinent(continent) {
    let continentElement = document.getElementById(`probe-group-${continent}`);
    if (continentElement) {
      continentElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  },
  resetFilters() {
    this.set('location', 'World');
    this.findComponent('c-location-input')?.fire('outsideLocationChange');
  },
  showAllProbeCards() {
    let blocks = this.get('preparedProbeBlocks');
    if (!blocks?.length) {
      return;
    }
    let allItems = blocks[0].items;
    let totalProbes = allItems.length;
    let originalLocation = this.get('location');
    this.set('loadingProbeCards', true);
    let increaseDisplayedProbeCount = () => {
      let currentVisibleCount = this.get('visibleProbeCards').length;
      if (currentVisibleCount >= totalProbes || this.get('groupBy') !== 'disabled' || this.get('location') !== originalLocation) {
        this.set('loadingProbeCards', false);
        return;
      }
      clearTimeout(this.probeCardTimeout);
      let nextProbeSet = allItems.slice(currentVisibleCount, currentVisibleCount + 100);
      this.push('visibleProbeCards', ...nextProbeSet);
      this.probeCardTimeout = setTimeout(() => {
        requestAnimationFrame(increaseDisplayedProbeCount);
      }, 10);
    };
    increaseDisplayedProbeCount();
  }
};
component$9.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "gp-filtered-list",
      g: 1
    }],
    f: [{
      t: 7,
      e: "c-probe-filters",
      m: [{
        n: "rawProbes",
        f: [{
          t: 2,
          r: "rawProbes"
        }],
        t: 13
      }, {
        n: "location",
        f: [{
          t: 2,
          r: "location"
        }],
        t: 13
      }, {
        n: "locationError",
        f: [{
          t: 2,
          r: "locationError"
        }],
        t: 13
      }, {
        n: "locationProbes",
        f: [{
          t: 2,
          r: "locationProbes"
        }],
        t: 13
      }, {
        n: "locationCompletedValue",
        f: [{
          t: 2,
          r: "locationCompletedValue"
        }],
        t: 13
      }, {
        n: "ttPositions",
        f: [{
          t: 2,
          r: "ttPositions"
        }],
        t: 13
      }, {
        n: "groupingOptions",
        f: [{
          t: 2,
          r: "groupingOptions"
        }],
        t: 13
      }, {
        n: "groupBy",
        f: [{
          t: 2,
          r: "groupBy"
        }],
        t: 13
      }, {
        n: "sortOptions",
        f: [{
          t: 2,
          r: "sortOptions"
        }],
        t: 13
      }, {
        n: "sortOrder",
        f: [{
          t: 2,
          r: "sortOrder"
        }],
        t: 13
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "p",
        m: [{
          t: 13,
          n: "class",
          f: "gp-filtered-list_result-count",
          g: 1
        }],
        f: [{
          t: 7,
          e: "span",
          f: ["Showing ", {
            t: 7,
            e: "b",
            f: [{
              t: 2,
              r: "totalResults"
            }, " unique ", {
              t: 2,
              x: {
                r: ["_", "totalResults"],
                s: "_0.pluralize(\"result\",_1)"
              }
            }]
          }, {
            t: 4,
            f: ["."],
            n: 50,
            x: {
              r: ["groupBy"],
              s: "_0===\"network\""
            }
          }, " ", {
            t: 4,
            f: ["from ", {
              t: 7,
              e: "b",
              f: [{
                t: 2,
                r: "probeLocationCounts.continent"
              }, " ", {
                t: 2,
                x: {
                  r: ["_", "probeLocationCounts.continent"],
                  s: "_0.pluralize(\"continent\",_1)"
                }
              }]
            }, "."],
            n: 50,
            x: {
              r: ["groupBy"],
              s: "_0===\"country\""
            }
          }, {
            t: 4,
            f: ["from ", {
              t: 7,
              e: "b",
              f: [{
                t: 2,
                r: "probeLocationCounts.country"
              }, " ", {
                t: 2,
                x: {
                  r: ["_", "probeLocationCounts.country"],
                  s: "_0.pluralize(\"country\",\"countries\",_1)"
                }
              }]
            }, " and ", {
              t: 7,
              e: "b",
              f: [{
                t: 2,
                r: "probeLocationCounts.continent"
              }, " ", {
                t: 2,
                x: {
                  r: ["_", "probeLocationCounts.continent"],
                  s: "_0.pluralize(\"continent\",_1)"
                }
              }]
            }, ". "],
            n: 50,
            x: {
              r: ["groupBy"],
              s: "_0===\"city\"||_0===\"country-network\""
            },
            l: 1
          }, {
            t: 4,
            f: [" from ", {
              t: 7,
              e: "b",
              f: [{
                t: 2,
                r: "probeLocationCounts.city"
              }, " ", {
                t: 2,
                x: {
                  r: ["_", "probeLocationCounts.city"],
                  s: "_0.pluralize(\"city\",\"cities\",_1)"
                }
              }]
            }, ", ", {
              t: 7,
              e: "b",
              f: [{
                t: 2,
                r: "probeLocationCounts.country"
              }, " ", {
                t: 2,
                x: {
                  r: ["_", "probeLocationCounts.country"],
                  s: "_0.pluralize(\"country\",\"countries\",_1)"
                }
              }]
            }, ", and ", {
              t: 7,
              e: "b",
              f: [{
                t: 2,
                r: "probeLocationCounts.continent"
              }, " ", {
                t: 2,
                x: {
                  r: ["_", "probeLocationCounts.continent"],
                  s: "_0.pluralize(\"continent\",_1)"
                }
              }]
            }, "."],
            n: 50,
            x: {
              r: ["groupBy"],
              s: "_0===\"city-network\"||_0===\"disabled\""
            },
            l: 1
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "button",
            m: [{
              n: "type",
              f: "button",
              t: 13,
              g: 1
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this"],
                s: "[_0.resetFilters()]"
              }
            }, {
              n: "tabindex",
              f: "0",
              t: 13,
              g: 1
            }],
            f: ["Show all"]
          }],
          n: 50,
          r: "hasCustomLocationApplied"
        }]
      }],
      n: 50,
      x: {
        r: ["preparedProbeBlocks", "preparedProbeBlocks.length"],
        s: "_0&&_1>0"
      }
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-filtered-list_jump",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-filtered-list_jump_field",
            g: 1
          }],
          f: [{
            t: 7,
            e: "label",
            f: ["Jump to"]
          }, " ", {
            t: 7,
            e: "c-select",
            m: [{
              n: "options",
              f: [{
                t: 2,
                r: "probeContinents"
              }],
              t: 13
            }, {
              n: "selected",
              f: [{
                t: 2,
                r: "selectedContinent"
              }],
              t: 13
            }, {
              n: "placeholder",
              f: "Choose continent",
              t: 13,
              g: 1
            }, {
              n: "onSelect",
              f: [{
                t: 2,
                r: "@this.scrollToContinent"
              }],
              t: 13
            }, {
              n: "name",
              f: "jump-to-select",
              t: 13,
              g: 1
            }]
          }]
        }]
      }],
      n: 50,
      x: {
        r: ["probeContinents.length"],
        s: "_0>1"
      }
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        n: "class",
        f: ["gp-filtered-list_list ", {
          t: 2,
          x: {
            r: ["groupBy"],
            s: "_0===\"disabled\"?\"disabled-group-by\":\"\""
          }
        }],
        t: 13
      }],
      f: [{
        t: 7,
        e: "c-probe-loading-state",
        m: [{
          n: "loading",
          f: [{
            t: 2,
            r: "probesLoading"
          }],
          t: 13
        }, {
          n: "error",
          f: [{
            t: 2,
            r: "probesError"
          }],
          t: 13
        }, {
          n: "hasData",
          f: [{
            t: 2,
            r: "locationProbes.length"
          }],
          t: 13
        }, {
          n: "filter",
          f: [{
            t: 2,
            r: "filter"
          }],
          t: 13
        }]
      }, " ", {
        t: 4,
        f: [{
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              n: "class",
              f: ["gp-filtered-list_list_block group-by-", {
                t: 2,
                r: "groupBy"
              }],
              t: 13
            }],
            f: [{
              t: 4,
              f: [{
                t: 4,
                f: [{
                  t: 7,
                  e: "c-probe-single-card",
                  m: [{
                    n: "location",
                    f: [{
                      t: 2,
                      r: "item.location"
                    }],
                    t: 13
                  }, {
                    n: "tags",
                    f: [{
                      t: 2,
                      r: "item.tags"
                    }],
                    t: 13
                  }, {
                    n: "render",
                    f: [{
                      t: 2,
                      x: {
                        r: ["loadingProbeCards", "index", "defaultCardRenderLimit"],
                        s: "!_0||_1<_2"
                      }
                    }],
                    t: 13
                  }, {
                    n: "screenWidth",
                    f: [{
                      t: 2,
                      r: "screenWidth"
                    }],
                    t: 13
                  }, {
                    n: "locationFilter",
                    f: [{
                      t: 2,
                      r: "~/location"
                    }],
                    t: 13
                  }],
                  f: []
                }],
                n: 52,
                z: [{
                  n: "item",
                  x: {
                    r: "."
                  }
                }],
                i: "index",
                r: "visibleProbeCards"
              }, " ", {
                t: 4,
                f: [{
                  t: 7,
                  e: "button",
                  m: [{
                    n: "type",
                    f: "button",
                    t: 13,
                    g: 1
                  }, {
                    n: ["click"],
                    t: 70,
                    f: {
                      r: ["@this"],
                      s: "[_0.showAllProbeCards()]"
                    }
                  }, {
                    t: 4,
                    f: [{
                      n: "disabled",
                      f: 0,
                      t: 13
                    }],
                    n: 50,
                    r: "loadingProbeCards"
                  }],
                  f: [{
                    t: 4,
                    f: [{
                      t: 7,
                      e: "i",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-circle-o-notch fa-spin",
                        g: 1
                      }, {
                        n: "aria-hidden",
                        f: "true",
                        t: 13,
                        g: 1
                      }]
                    }],
                    n: 50,
                    r: "loadingProbeCards"
                  }, " Show all"]
                }],
                n: 50,
                x: {
                  r: ["visibleProbeCards.length", "block.items.length", "loadingProbeCards"],
                  s: "_0<_1||_2"
                }
              }],
              n: 50,
              x: {
                r: ["groupBy"],
                s: "_0===\"disabled\""
              }
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "div",
                m: [{
                  n: "class",
                  f: ["gp-filtered-list_list_block_group group-by-", {
                    t: 2,
                    r: "groupBy"
                  }],
                  t: 13
                }, {
                  n: "data-testid",
                  f: "probe-block-group",
                  t: 13,
                  g: 1
                }],
                f: [{
                  t: 4,
                  f: [{
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "gp-filtered-list_list_block_group_item cont-header",
                      g: 1
                    }, {
                      n: "id",
                      f: ["probe-group-", {
                        t: 2,
                        r: "block.title"
                      }],
                      t: 13
                    }],
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "width",
                        f: "24",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "24",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/network/continent-", {
                          t: 2,
                          x: {
                            r: ["block.title"],
                            s: "_0.toLowerCase()"
                          }
                        }, ".svg"],
                        t: 13
                      }, {
                        n: "alt",
                        f: "",
                        t: 13,
                        g: 1
                      }, {
                        n: "aria-hidden",
                        f: "true",
                        t: 13,
                        g: 1
                      }]
                    }, " ", {
                      t: 2,
                      x: {
                        r: ["@this", "block.title"],
                        s: "_0.getContinentName(_1)"
                      }
                    }]
                  }],
                  n: 50,
                  r: "block.title"
                }, " ", {
                  t: 4,
                  f: [{
                    t: 4,
                    f: [{
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "gp-filtered-list_list_block_group_networks-item",
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "span",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "gp-filtered-list_list_block_group_networks-item_country",
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "img",
                          m: [{
                            n: "loading",
                            f: "lazy",
                            t: 13,
                            g: 1
                          }, {
                            n: "width",
                            f: "17",
                            t: 13,
                            g: 1
                          }, {
                            n: "height",
                            f: "20",
                            t: 13,
                            g: 1
                          }, {
                            n: "alt",
                            f: "",
                            t: 13,
                            g: 1
                          }, {
                            n: "aria-hidden",
                            f: "true",
                            t: 13,
                            g: 1
                          }, {
                            n: "src",
                            f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
                              t: 2,
                              x: {
                                r: ["item.location"],
                                s: "_0.split(\", \")[0]"
                              }
                            }, ".svg"],
                            t: 13
                          }]
                        }, " ", {
                          t: 7,
                          e: "span",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "gp-filtered-list_popover-root",
                            g: 1
                          }, {
                            n: "tabindex",
                            f: "0",
                            t: 13,
                            g: 1
                          }, {
                            n: "role",
                            f: "button",
                            t: 13,
                            g: 1
                          }, {
                            n: "popover",
                            t: 71,
                            f: {
                              r: ["@this", "item.from"],
                              s: "[_0.getPopoverContent(_1)]"
                            }
                          }],
                          f: [{
                            t: 2,
                            r: "item.name"
                          }]
                        }]
                      }, " ", {
                        t: 7,
                        e: "div",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "gp-filtered-list_list_block_group_networks-item_networks",
                          g: 1
                        }],
                        f: [{
                          t: 4,
                          f: [{
                            t: 7,
                            e: "span",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "gp-filtered-list_popover-root",
                              g: 1
                            }, {
                              n: "tabindex",
                              f: "0",
                              t: 13,
                              g: 1
                            }, {
                              n: "role",
                              f: "button",
                              t: 13,
                              g: 1
                            }, {
                              n: "popover",
                              t: 71,
                              f: {
                                r: ["@this", "item.from", "./name"],
                                s: "[_0.getPopoverContent(_1,_2)]"
                              }
                            }],
                            f: [{
                              t: 7,
                              e: "span",
                              m: [{
                                t: 13,
                                n: "class",
                                f: "gp-filtered-list_list_block_group_networks-item_network",
                                g: 1
                              }],
                              f: [{
                                t: 2,
                                r: "name"
                              }, {
                                t: 4,
                                f: [" (x", {
                                  t: 2,
                                  r: "./count"
                                }, ")"],
                                n: 50,
                                x: {
                                  r: ["count"],
                                  s: "_0>1"
                                }
                              }]
                            }]
                          }],
                          n: 52,
                          r: "item.networks"
                        }]
                      }]
                    }],
                    n: 50,
                    x: {
                      r: ["item.networks", "item.networks.length"],
                      s: "_0&&_1"
                    }
                  }, {
                    t: 4,
                    f: [{
                      t: 7,
                      e: "div",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "gp-filtered-list_list_block_group_item gp-filtered-list_popover-root",
                        g: 1
                      }, {
                        n: "tabindex",
                        f: "0",
                        t: 13,
                        g: 1
                      }, {
                        n: "role",
                        f: "button",
                        t: 13,
                        g: 1
                      }, {
                        n: "popover",
                        t: 71,
                        f: {
                          r: ["@this", "item.from"],
                          s: "[_0.getPopoverContent(_1)]"
                        }
                      }],
                      f: [{
                        t: 4,
                        f: [{
                          t: 7,
                          e: "img",
                          m: [{
                            n: "loading",
                            f: "lazy",
                            t: 13,
                            g: 1
                          }, {
                            n: "width",
                            f: "17",
                            t: 13,
                            g: 1
                          }, {
                            n: "height",
                            f: "20",
                            t: 13,
                            g: 1
                          }, {
                            n: "alt",
                            f: "",
                            t: 13,
                            g: 1
                          }, {
                            n: "aria-hidden",
                            f: "true",
                            t: 13,
                            g: 1
                          }, {
                            n: "src",
                            f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
                              t: 2,
                              x: {
                                r: ["item.location"],
                                s: "_0.split(\", \")[0]"
                              }
                            }, ".svg"],
                            t: 13
                          }]
                        }],
                        n: 50,
                        r: "item.showFlag"
                      }, {
                        t: 4,
                        f: [{
                          t: 7,
                          e: "span",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "gp-filtered-list_network-logo",
                            g: 1
                          }],
                          f: [{
                            t: 4,
                            f: [{
                              t: 7,
                              e: "img",
                              m: [{
                                n: "width",
                                f: "20",
                                t: 13,
                                g: 1
                              }, {
                                n: "height",
                                f: "20",
                                t: 13,
                                g: 1
                              }, {
                                n: "src",
                                f: ["/asn-logo/AS", {
                                  t: 2,
                                  r: "item.logoAsn"
                                }, "?v=", {
                                  t: 2,
                                  r: "@shared.assetsVersion"
                                }, "&size=40"],
                                t: 13
                              }, {
                                n: "loading",
                                f: "lazy",
                                t: 13,
                                g: 1
                              }, {
                                n: "alt",
                                f: "",
                                t: 13,
                                g: 1
                              }, {
                                n: "aria-hidden",
                                f: "true",
                                t: 13,
                                g: 1
                              }, {
                                n: ["error"],
                                t: 70,
                                f: {
                                  r: ["@this", "item"],
                                  s: "[_0.onLogoError(_1)]"
                                }
                              }]
                            }],
                            n: 50,
                            r: "item.logoAsn"
                          }, {
                            t: 4,
                            f: [{
                              t: 2,
                              r: "item.name.0"
                            }],
                            n: 51,
                            l: 1
                          }]
                        }],
                        n: 50,
                        x: {
                          r: ["groupBy"],
                          s: "_0===\"network\""
                        },
                        l: 1
                      }, " ", {
                        t: 7,
                        e: "span",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "gp-filtered-list_list_block_group_item_location",
                          g: 1
                        }],
                        f: [{
                          t: 2,
                          r: "item.name"
                        }]
                      }, " ", {
                        t: 7,
                        e: "span",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "gp-filtered-list_list_block_group_item_count",
                          g: 1
                        }],
                        f: [{
                          t: 2,
                          r: "item.probes.length"
                        }]
                      }]
                    }],
                    n: 51,
                    l: 1
                  }],
                  n: 52,
                  z: [{
                    n: "item",
                    x: {
                      r: "."
                    }
                  }],
                  r: "block.items"
                }]
              }],
              n: 51,
              l: 1
            }]
          }],
          n: 52,
          z: [{
            n: "block",
            x: {
              r: "."
            }
          }],
          r: "preparedProbeBlocks"
        }],
        n: 50,
        r: "preparedProbeBlocks.length"
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-filtered-list_logos-by",
          g: 1
        }],
        f: [{
          t: 7,
          e: "a",
          m: [{
            n: "href",
            f: "https://logo.dev",
            t: 13,
            g: 1
          }, {
            n: "target",
            f: "_blank",
            t: 13,
            g: 1
          }, {
            n: "rel",
            f: "noreferrer",
            t: 13,
            g: 1
          }],
          f: ["Network logos provided by Logo.dev"]
        }]
      }],
      n: 50,
      x: {
        r: ["groupBy"],
        s: "_0===\"network\""
      }
    }]
  }],
  e: {
    "_0.pluralize(\"result\",_1)": function (_0, _1) {
      return _0.pluralize("result", _1);
    },
    "_0===\"network\"": function (_0) {
      return _0 === "network";
    },
    "_0.pluralize(\"continent\",_1)": function (_0, _1) {
      return _0.pluralize("continent", _1);
    },
    "_0===\"country\"": function (_0) {
      return _0 === "country";
    },
    "_0.pluralize(\"country\",\"countries\",_1)": function (_0, _1) {
      return _0.pluralize("country", "countries", _1);
    },
    "_0===\"city\"||_0===\"country-network\"": function (_0) {
      return _0 === "city" || _0 === "country-network";
    },
    "_0.pluralize(\"city\",\"cities\",_1)": function (_0, _1) {
      return _0.pluralize("city", "cities", _1);
    },
    "_0===\"city-network\"||_0===\"disabled\"": function (_0) {
      return _0 === "city-network" || _0 === "disabled";
    },
    "[_0.resetFilters()]": function (_0) {
      return [_0.resetFilters()];
    },
    "_0&&_1>0": function (_0, _1) {
      return _0 && _1 > 0;
    },
    "_0>1": function (_0) {
      return _0 > 1;
    },
    "_0===\"disabled\"?\"disabled-group-by\":\"\"": function (_0) {
      return _0 === "disabled" ? "disabled-group-by" : "";
    },
    "!_0||_1<_2": function (_0, _1, _2) {
      return !_0 || _1 < _2;
    },
    "[_0.showAllProbeCards()]": function (_0) {
      return [_0.showAllProbeCards()];
    },
    "_0<_1||_2": function (_0, _1, _2) {
      return _0 < _1 || _2;
    },
    "_0===\"disabled\"": function (_0) {
      return _0 === "disabled";
    },
    "_0.toLowerCase()": function (_0) {
      return _0.toLowerCase();
    },
    "_0.getContinentName(_1)": function (_0, _1) {
      return _0.getContinentName(_1);
    },
    "_0.split(\", \")[0]": function (_0) {
      return _0.split(", ")[0];
    },
    "[_0.getPopoverContent(_1)]": function (_0, _1) {
      return [_0.getPopoverContent(_1)];
    },
    "[_0.getPopoverContent(_1,_2)]": function (_0, _1, _2) {
      return [_0.getPopoverContent(_1, _2)];
    },
    "_0&&_1": function (_0, _1) {
      return _0 && _1;
    },
    "[_0.onLogoError(_1)]": function (_0, _1) {
      return [_0.onLogoError(_1)];
    }
  }
};
component$9.exports.components = {
  "c-probe-loading-state": probeLoadingState,
  "c-probe-filters": probeFilters,
  "c-probe-single-card": probeSingleCard,
  "c-select": select
};
var filteredProbeList = ractive.extend(component$9.exports);

var component$8 = {
  exports: {}
};

/* global markerClusterer */

const MAP_MIN_ZOOM = 2;
const MAP_MAX_ZOOM = 22;
const MAP_ZOOM_REG = 3.74;
const MAP_ZOOM_ALT = 2.14;
const MAP_CENTER_REG = {
  lat: 48,
  lng: 16
};
const MAP_CENTER_ALT = {
  lat: 30,
  lng: 18
};
const getMarkerSize = (probeCount, zoom) => {
  let size = {
    svgWidth: 16,
    svgHeight: 16,
    circleRadius: 4.5,
    strokeWidth: 1.5
  };
  if (probeCount > 1) {
    let scalingFactor = probeCount.toString().length;
    size.svgWidth += 4 * scalingFactor + 4;
    size.svgHeight += 4 * scalingFactor + 4;
    size.circleRadius += 2 * scalingFactor + 1.5;
    size.strokeWidth += .5;
  }
  if (zoom >= 5) {
    size.svgWidth *= 1.1;
    size.svgHeight *= 1.1;
  }
  if (zoom >= 10) {
    size.svgWidth *= 1.1;
    size.svgHeight *= 1.1;
  }
  return size;
};
let map;
let infoWindows = [];
let mapMarkers = [];
let markerCluster;
component$8.exports = {
  data() {
    return {
      class: '',
      iwClass: '',
      hasCluster: false,
      probesByCoords: null,
      onProbesByCoordsChange: null,
      onMarkerClick: null,
      selectedLocation: null,
      displayInfoWindow: true,
      lockMapBoundaries: false,
      mapMinZoom: MAP_MIN_ZOOM
    };
  },
  onrender() {
    if (!ractive.isServer) {
      this.set('@shared.googleMapsLoaded', true);
      app.initMap = this.initMap.bind(this);
      if (app.loaded) {
        setTimeout(this.initMap.bind(this));
      }
    }
  },
  onunrender() {
    if (!ractive.isServer) {
      map = null;
      markerCluster = null;
      infoWindows = [];
      mapMarkers = [];
    }
  },
  initMap() {
    let mq = window.matchMedia('(min-width: 768px)');
    let lockMapBoundaries = this.get('lockMapBoundaries');
    map = new google.maps.Map(this.find('#gp-map'), {
      zoom: MAP_ZOOM_REG,
      center: MAP_CENTER_REG,
      mapTypeId: 'roadmap',
      draggableCursor: 'default',
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      minZoom: this.get('mapMinZoom'),
      maxZoom: MAP_MAX_ZOOM,
      mapId: 'ce04bbf9d49b6f34',
      ...(lockMapBoundaries && {
        restriction: {
          latLngBounds: new google.maps.LatLngBounds({
            lat: -85,
            lng: -179.5
          }, {
            lat: 85,
            lng: 179.5
          }),
          strictBounds: false
        }
      })
    });
    if (mq.matches) {
      map.setCenter(MAP_CENTER_ALT);
      map.setZoom(MAP_ZOOM_ALT);
    }
    map.addListener('zoom_changed', () => {
      markerCluster?.clusters.forEach(c => {
        let m = c.marker;
        let {
          svgWidth,
          svgHeight
        } = getMarkerSize(Number(m.content.getAttribute('data-probe-count')), map.zoom);
        m.content.style.width = `${svgWidth}px`;
        m.content.style.height = `${svgHeight}px`;
      });
      mapMarkers.forEach(m => {
        let {
          svgWidth,
          svgHeight
        } = getMarkerSize(Number(m.content.getAttribute('data-probe-count')), map.zoom);
        m.content.style.width = `${svgWidth}px`;
        m.content.style.height = `${svgHeight}px`;
        m.content.setAttribute('data-zoom', map.zoom);
      });
      infoWindows.forEach(iw => iw.close());
    });
    this.observe('selectedLocation', (selectedLocation, prevSelectedLocation) => {
      // find markers whose coordinates are contained in the (previously) selected location
      let markersToHighlight = mapMarkers.filter(mm => selectedLocation.coords.some(c => c.latitude === mm.position.lat && c.longitude === mm.position.lng));
      let markersToFade = mapMarkers.filter(mm => !markersToHighlight.includes(mm) && prevSelectedLocation.coords.some(c => c.latitude === mm.position.lat && c.longitude === mm.position.lng));

      // update marker bg colors
      markersToFade.forEach(markerToFade => {
        let svgUnselected = this.createClusterMarkerSVG(markerToFade.markersCount || 0, false);
        markerToFade.content.style.backgroundImage = `url('data:image/svg+xml;base64,${svgUnselected}')`;
      });
      markersToHighlight.forEach(markerToHighlight => {
        let svgSelected = this.createClusterMarkerSVG(markerToHighlight.markersCount || 0, true);
        markerToHighlight.content.style.backgroundImage = `url('data:image/svg+xml;base64,${svgSelected}')`;
      });

      // update cluster marker bg colors
      markerCluster?.clusters.forEach(cluster => {
        if (cluster.markers.length <= 1) {
          return;
        }
        let totalProbeCount = cluster.markers.reduce((sum, marker) => sum + (marker.markersCount || 0), 0);
        if (markersToHighlight.some(markerToHighlight => cluster.markers.includes(markerToHighlight))) {
          let svgHighlighted = this.createClusterMarkerSVG(totalProbeCount, true);
          cluster.marker.content.style.backgroundImage = `url('data:image/svg+xml;base64,${svgHighlighted}')`;
        } else if (markersToFade.some(markerToFade => cluster.markers.includes(markerToFade))) {
          let svgUnselected = this.createClusterMarkerSVG(totalProbeCount, false);
          cluster.marker.content.style.backgroundImage = `url('data:image/svg+xml;base64,${svgUnselected}')`;
        }
      });
      if (!selectedLocation) {
        return;
      }

      // make sure the selected location is visible
      let bounds = map.getBounds();
      let probesByCoords = this.get('probesByCoords');
      let position = {
        lat: selectedLocation.coords[0].latitude,
        lng: selectedLocation.coords[0].longitude
      };
      if (!bounds?.contains(position)) {
        this.focusMapOnMarkers(probesByCoords);
      }
    });
    this.observe('probesByCoords', (markersData, prevMarkersData) => {
      if (markersData && JSON.stringify(markersData) !== JSON.stringify(prevMarkersData)) {
        // hide all existing markers from the map
        mapMarkers.forEach(mm => mm.map = null);

        // show the marker or create one if it is missing
        let filteredMarkers = Object.keys(markersData).map(key => {
          let [lat, lng] = key.split(', ');
          let marker = mapMarkers.find(mm => mm.position.lat === lat && mm.position.lng === lng);
          if (!marker) {
            marker = this.createMapMarkerWithIW(key, markersData[key]);
            mapMarkers.push(marker);
          }
          marker.map = map;
          return marker;
        });
        let createClusterMarkerSVG = this.createClusterMarkerSVG;
        let getSelectedLocation = () => this.get('selectedLocation');
        if (markerCluster) {
          markerCluster.clearMarkers();
          markerCluster.addMarkers(filteredMarkers);
        } else if (this.get('hasCluster')) {
          markerCluster = new markerClusterer.MarkerClusterer({
            map,
            markers: filteredMarkers,
            renderer: {
              render({
                markers,
                position
              }) {
                let totalCustomNumber = markers.reduce((sum, marker) => sum + (marker.markersCount || 0), 0);
                let selectedLocation = getSelectedLocation();
                let shouldHighlight = !selectedLocation || markers.some(m => selectedLocation.coords.some(pos => m.position.lat === pos.latitude && m.position.lng === pos.longitude));
                let svg = createClusterMarkerSVG(totalCustomNumber, shouldHighlight);
                let clusterDiv = document.createElement('div');
                clusterDiv.setAttribute('data-probe-count', totalCustomNumber);
                clusterDiv.setAttribute('data-zoom', map.zoom);
                clusterDiv.style.position = 'relative';
                clusterDiv.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
                clusterDiv.style.backgroundRepeat = 'no-repeat';
                clusterDiv.style.backgroundPosition = 'center';
                clusterDiv.style.backgroundSize = 'contain';
                let {
                  svgWidth,
                  svgHeight
                } = getMarkerSize(totalCustomNumber, map.zoom);
                clusterDiv.style.width = `${svgWidth}px`;
                clusterDiv.style.height = `${svgHeight}px`;
                return new google.maps.marker.AdvancedMarkerElement({
                  position,
                  content: clusterDiv,
                  zIndex: totalCustomNumber
                });
              }
            },
            algorithm: new markerClusterer.SuperClusterAlgorithm({
              radius: 40
            }),
            onClusterClick: (e, cluster, map) => {
              // temporarily remove restriction to allow proper fit
              let prevRestriction = map.get('restriction');
              map.setOptions({
                restriction: undefined
              });

              // default handler
              markerClusterer.defaultOnClusterClickHandler(e, cluster, map);

              // restore restriction after the map settles
              google.maps.event.addListenerOnce(map, 'idle', () => {
                map.setOptions({
                  restriction: prevRestriction
                });
              });
            }
          });
        }
        if (this.get('onProbesByCoordsChange') && this.get('onProbesByCoordsChange')() || this.get('focusOnChange')) {
          this.focusMapOnMarkers(markersData);
        } else {
          if (!mq.matches) {
            map.setCenter(MAP_CENTER_REG);
            map.setZoom(MAP_ZOOM_REG);
          } else {
            map.setCenter(MAP_CENTER_ALT);
            map.setZoom(MAP_ZOOM_ALT);
          }
        }
      }
    });

    // close IWs on click on Map
    google.maps.event.addListener(map, 'click', () => {
      infoWindows.forEach(iw => iw.close());
    });
  },
  createMapMarkerWithIW(key, markerData) {
    let [lat, lng] = key.split(', ');
    let onMarkerClick = this.get('onMarkerClick');
    let selectedLocation = this.get('selectedLocation');
    let shouldHighlight = !selectedLocation || selectedLocation.coords.some(pos => pos.latitude === Number(lat) && pos.longitude === Number(lng));
    let svg = this.createMapMarkerSvg(markerData, shouldHighlight);
    let markerContent = document.createElement('div');
    markerContent.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
    markerContent.style.backgroundRepeat = 'no-repeat';
    markerContent.style.backgroundPosition = 'center';
    markerContent.style.backgroundSize = 'contain';
    markerContent.setAttribute('data-probe-count', markerData.length);
    let {
      svgWidth,
      svgHeight
    } = getMarkerSize(markerData.length, map.zoom);
    markerContent.style.width = `${svgWidth}px`;
    markerContent.style.height = `${svgHeight}px`;

    // Create a new AdvancedMarkerView
    let marker = new google.maps.marker.AdvancedMarkerElement({
      map,
      content: markerContent,
      position: {
        lat: Number(lat),
        lng: Number(lng)
      },
      zIndex: 1
    });
    marker.markersCount = markerData.length || 0;

    // Handle closing of all InfoWindows on a click on a marker
    marker.addListener('click', () => {
      onMarkerClick && onMarkerClick({
        latitude: Number(lat),
        longitude: Number(lng)
      });
    });
    if (this.get('displayInfoWindow')) {
      let infoWindow = new google.maps.InfoWindow();
      infoWindows.push(infoWindow);
      infoWindow.setContent(this.createInfoWindowContent(markerData));
      marker.addListener('click', () => {
        infoWindows.forEach(iw => iw.close());
        infoWindow.open({
          map,
          anchor: marker
        });
      });
    }
    return marker;
  },
  createMapMarkerSvg(markerData, shouldHighlight = true) {
    return this.createClusterMarkerSVG(markerData.length, shouldHighlight);
  },
  createInfoWindowContent(markersByCoords) {
    let markersCnt = markersByCoords.length;
    let groupedNetworks = markersByCoords.reduce((res, m) => {
      let marker = res.find(i => i.location.network === m.location.network);
      if (marker) {
        marker.cnt += 1;
      } else {
        res.push({
          ...m,
          cnt: 1,
          sortKey: m.location.network.toLowerCase()
        });
      }
      return res;
    }, []).sort((a, b) => a.sortKey < b.sortKey ? -1 : a.sortKey > b.sortKey);
    let infoWindowContent = `<div class="${this.get('iwClass')}">`;
    if (markersCnt === 1) {
      let {
        network,
        city,
        country
      } = markersByCoords[0].location;
      infoWindowContent += `<span>${network} (${city}, ${country})</span>`;
    } else {
      // in this case we should render a list of probes
      groupedNetworks.forEach((m, mIdx) => {
        if (mIdx === 0) {
          // add header content
          infoWindowContent += `<span class="${this.get('iwClass')}_header">`;
          infoWindowContent += `<img width="16" height="16" src="${this.get('@shared.assetsHost')}/img/location-icon.svg">`;
          infoWindowContent += `<span class="${this.get('iwClass')}_header_location">${m.location.city}, ${m.location.country}</span>`;
          infoWindowContent += `<span class="${this.get('iwClass')}_header_cnt">${markersByCoords.length}</span>`;
          infoWindowContent += '</span>';
        }

        // render the list of the probes, grouped by the same network
        infoWindowContent += `<span class="${this.get('iwClass')}_row">${m.location.network} ${m.cnt > 1 ? `<span class="${this.get('iwClass')}_row_network-cnt">${m.cnt}</span>` : ''}</span>`;
      });
    }
    infoWindowContent += '</div>';
    return infoWindowContent;
  },
  createClusterMarkerSVG(elementsCnt, shouldHighlight = true) {
    let {
      svgWidth,
      svgHeight,
      circleRadius,
      strokeWidth
    } = getMarkerSize(elementsCnt, 1); // here zoom must always be 1
    let backgroundColor = shouldHighlight ? '#17D4A7' : '#202020';
    return window.btoa(`
				<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius}" fill="${backgroundColor}"/>
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius + 1}" stroke="white" stroke-width="${strokeWidth}"/>
					</g>
					${elementsCnt !== 1 ? `<text x="${svgWidth / 2}" y="${svgHeight / 2}" text-anchor="middle" dy=".35em" font-family="Arial" font-size="10" font-weight="bold" fill="#fff">${elementsCnt}</text>` : ''}
					<defs>
						<filter id="filter0_d_6106_3045" x="0" y="0" width="${svgWidth}" height="${svgHeight}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix"/>
							<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
							<feOffset dy="1"/>
							<feGaussianBlur stdDeviation="1"/>
							<feComposite in2="hardAlpha" operator="out"/>
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
						</filter>
					</defs>
				</svg>
			`);
  },
  focusMapOnMarkers(markersData) {
    let locationStrings = Object.keys(markersData);
    let selectedLocation = this.get('selectedLocation');
    let minZoom = this.get('mapMinZoom');
    if (locationStrings.length === 0) {
      return;
    }

    // first, create the map bounds
    let bounds = new google.maps.LatLngBounds();
    locationStrings.forEach(str => {
      let [lat, lng] = str.split(', ');
      bounds.extend({
        lat: Number(lat),
        lng: Number(lng)
      });
    });
    let shouldSnapToSelected = false;
    let mapDiv = map.getDiv();

    // if there is a selected location, check whether we can fit all markers on the map
    // if not, snap the map to the selected location with min zoom
    // otherwise we cannot guarantee that the selected location will be visible
    // https://wiki.openstreetmap.org/wiki/Slippy_map_tilenames
    // https://en.wikipedia.org/wiki/Web_Mercator_projection
    if (selectedLocation && mapDiv && mapDiv.offsetWidth > 0) {
      let ne = bounds.getNorthEast();
      let sw = bounds.getSouthWest();

      // --- find lng span (in deg) ---
      let boundsSpanLng = ne.lng() - sw.lng();
      if (boundsSpanLng < 0) {
        boundsSpanLng += 360;
      }

      // calculate the visible longitude span at MinZoom (Zoom 2)
      // formula: (map width / tile size) * (360 degrees / 2^zoom)
      let degreesPerTile = 360 / Math.pow(2, minZoom);
      let visibleSpanLng = mapDiv.offsetWidth / 256 * degreesPerTile;

      // --- find lat span (in px -- cannot rely on degrees because of projection distortion) ---
      let latToWorldY = lat => {
        let sin = Math.sin(lat * Math.PI / 180);
        // clip to prevent infinity at the poles
        sin = Math.max(Math.min(sin, 0.9999), -0.9999);
        let latPosRadians = 0.5 * Math.log((1 + sin) / (1 - sin)); // = log(tan(lat/2))
        let scaler = 256 / (2 * Math.PI);
        return 128 + 0.5 * latPosRadians * scaler; // scale and center
      };
      let neY = latToWorldY(ne.lat());
      let swY = latToWorldY(sw.lat());

      // calculate height in pixels at the current minZoom
      let boundsHeightPx = Math.abs(neY - swY) * Math.pow(2, minZoom);
      let mapHeightPx = mapDiv.offsetHeight;

      // check overflow
      if (boundsSpanLng > visibleSpanLng || boundsHeightPx > mapHeightPx) {
        shouldSnapToSelected = true;
      }
    }
    if (shouldSnapToSelected) {
      let position = {
        lat: _.clamp(selectedLocation.coords[0].latitude, 15, 35),
        lng: selectedLocation.coords[0].longitude
      };
      map.setCenter(position);
      map.setZoom(minZoom);
    } else {
      let TEMP_MAX_ZOOM = 6;

      // temp limit for zooming
      map.setZoom(TEMP_MAX_ZOOM);
      map.setOptions({
        maxZoom: TEMP_MAX_ZOOM
      });
      map.fitBounds(bounds);
      google.maps.event.addListenerOnce(map, 'idle', () => {
        // restore zooming to initial
        map.setOptions({
          maxZoom: MAP_MAX_ZOOM
        });
      });
    }
  }
};
component$8.exports.template = {
  v: 4,
  t: [{
    t: 4,
    f: [{
      t: 7,
      e: "script",
      f: ["\t\tfunction onDocumentReady (fn) {\n\t\t\tif (document.readyState !== 'loading') {\n\t\t\t\tfn();\n\t\t\t} else {\n\t\t\t\tdocument.addEventListener('DOMContentLoaded', fn);\n\t\t\t}\n\t\t}\n\t\t/* eslint-disable */\n\t\tfunction initMap () {\n\t\t\tonDocumentReady(function () {\n\t\t\t\tapp.loaded = true;\n\n\t\t\t\tif (app.initMap && app.router.route.view) {\n\t\t\t\t\tapp.initMap();\n\t\t\t\t}\n\t\t\t});\n\t\t}\n\t"]
    }, " ", {
      t: 7,
      e: "script",
      m: [{
        n: "src",
        f: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBTICLY5LgWNJ0Uly61Q1sNXz_1KZIECwg&language=en&callback=initMap&libraries=marker&loading=async",
        t: 13,
        g: 1
      }, {
        n: "async",
        f: 0,
        t: 13
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "script",
        m: [{
          n: "src",
          f: "https://cdn.jsdelivr.net/npm/@googlemaps/markerclusterer@2.5.3/dist/index.umd.min.js",
          t: 13,
          g: 1
        }]
      }],
      n: 50,
      r: "hasCluster"
    }],
    n: 50,
    x: {
      r: ["@shared.isServer", "@shared.googleMapsLoaded"],
      s: "!_0&&!_1"
    }
  }, {
    t: 7,
    e: "div",
    m: [{
      n: "id",
      f: "gp-map",
      t: 13,
      g: 1
    }, {
      n: "class",
      f: [{
        t: 2,
        r: "class"
      }],
      t: 13
    }]
  }],
  e: {
    "!_0&&!_1": function (_0, _1) {
      return !_0 && !_1;
    }
  }
};
var googleMaps = ractive.extend(component$8.exports);

var component$7 = {
  exports: {}
};
const GROUP_DEFAULT$1 = 'city';
const DEFAULT_SORT_OPTIONS$1 = {
  'country': 'alphabetically',
  'city': 'alphabetically',
  'network': 'probe-count',
  'country-network': 'alphabetically',
  'city-network': 'alphabetically',
  'disabled': 'alphabetically'
};
component$7.exports = {
  data() {
    return {
      _,
      title: 'Network - Globalping',
      description: 'Explore the global network map of Globalping probes.',
      location: 'World',
      locationCompletedValue: '',
      groupBy: GROUP_DEFAULT$1,
      sortOrder: DEFAULT_SORT_OPTIONS$1[GROUP_DEFAULT$1],
      defaultSortOptions: DEFAULT_SORT_OPTIONS$1,
      probesResponse: null,
      probesLoading: false,
      probesError: null,
      filteredProbes: null,
      filteredMarkersData: null,
      filteredProbesStats: null
    };
  },
  computed: {
    filter: {
      get() {
        let location = this.get('locationCompletedValue') || '';
        if (location.toLowerCase() === 'world') {
          return '';
        }
        return location.replace(/\+/g, '%');
      },
      set(location) {
        this.set('location', location.replace(/%/g, '+'));
        this.set('locationCompletedValue', location.replace(/%/g, '+'));
      }
    },
    group: {
      get() {
        return this.get('groupBy') === GROUP_DEFAULT$1 ? '' : this.get('groupBy');
      },
      set(group) {
        this.set('groupBy', group);
        if (Object.hasOwn(DEFAULT_SORT_OPTIONS$1, group)) {
          this.set('sortOrder', DEFAULT_SORT_OPTIONS$1[group]);
        }
      }
    },
    sort: {
      get() {
        return this.get('sortOrder') === DEFAULT_SORT_OPTIONS$1[this.get('groupBy')] || this.get('groupBy') === 'disabled' ? '' : this.get('sortOrder');
      },
      set(sort) {
        this.set('sortOrder', sort);
      }
    }
  },
  oninit() {
    if (!ractive.isServer) {
      this.getProbesData();
      this.observe('filteredProbes', filteredProbes => {
        if (filteredProbes === null) {
          return;
        }

        // recalculate ASNs
        let asns = filteredProbes.reduce((asns, probe) => {
          asns.add(probe.location.asn);
          return asns;
        }, new Set());
        this.set('filteredProbesStats', {
          count: filteredProbes.length,
          asns: asns.size
        });

        // recalculate map markers
        let groupedByCoords = filteredProbes.reduce((res, probe) => {
          let coords = `${probe.location.latitude}, ${probe.location.longitude}`;

          // group by Coordinates
          if (!Object.hasOwn(res, coords)) {
            res[coords] = [];
          }
          res[coords].push(probe);
          return res;
        }, {});
        setTimeout(() => this.set('filteredMarkersData', groupedByCoords), 50);
      });
    }
  },
  onrender() {
    if (!ractive.isServer) {
      listeners.screenWidthListener(this);
    }
  },
  getProbesData() {
    this.set('probesLoading', true);
    this.set('probesError', null);
    dataCache.getCache('probesResponse', 60 * 1000, http.fetchGlobalpingProbes).then(value => this.set('probesResponse', value)).catch(error => {
      console.error('Failed to fetch probes', error);
      this.set('probesError', error);
    }).finally(() => this.set('probesLoading', false));
  },
  handleProbesByCoordsChange() {
    let locationCompletedValue = this.get('locationCompletedValue');
    return !!locationCompletedValue?.length;
  }
};
component$7.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "r-page",
    m: [{
      n: "noYield",
      f: [{
        t: 2,
        r: "noYield"
      }],
      t: 13
    }, {
      n: "title",
      f: [{
        t: 2,
        r: "title"
      }],
      t: 13
    }, {
      n: "description",
      f: [{
        t: 2,
        r: "description"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "c-notification"
    }, " ", {
      t: 7,
      e: "c-gp-header",
      m: [{
        n: "additionalClasses",
        f: "header-with-globalping-bg",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "gp-network",
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-network_hero",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-network_stats",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-network_stats_item",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/radio.svg"],
                t: 13
              }]
            }, " ", {
              t: 7,
              e: "b",
              f: [{
                t: 2,
                r: "filteredProbesStats.count"
              }]
            }, " ", {
              t: 2,
              x: {
                r: ["_", "filteredProbesStats.count"],
                s: "_0.pluralize(\"probe\",_1)"
              }
            }]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp-network_stats_item",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/file-text.svg"],
                t: 13
              }]
            }, " ", {
              t: 7,
              e: "b",
              f: [{
                t: 2,
                r: "filteredProbesStats.asns"
              }]
            }, " ", {
              t: 2,
              x: {
                r: ["_", "filteredProbesStats.asns"],
                s: "_0.pluralize(\"ASN\",_1)"
              }
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "gp-network_hero_map-wrapper",
            g: 1
          }],
          f: [{
            t: 7,
            e: "c-google-maps",
            m: [{
              t: 13,
              n: "class",
              f: "gp-network_hero_map-wrapper_map",
              g: 1
            }, {
              n: "iwClass",
              f: "gp-network_iw",
              t: 13,
              g: 1
            }, {
              n: "probesByCoords",
              f: [{
                t: 2,
                r: "filteredMarkersData"
              }],
              t: 13
            }, {
              n: "hasCluster",
              f: [{
                t: 2,
                x: {
                  r: [],
                  s: "true"
                }
              }],
              t: 13
            }, {
              n: "onProbesByCoordsChange",
              f: [{
                t: 2,
                r: "@this.handleProbesByCoordsChange"
              }],
              t: 13
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "gp-network_filtered-list",
          g: 1
        }],
        f: [{
          t: 7,
          e: "c-filtered-probe-list",
          m: [{
            n: "rawProbes",
            f: [{
              t: 2,
              r: "probesResponse"
            }],
            t: 13
          }, {
            n: "filteredProbes",
            f: [{
              t: 2,
              r: "filteredProbes"
            }],
            t: 13
          }, {
            n: "location",
            f: [{
              t: 2,
              r: "location"
            }],
            t: 13
          }, {
            n: "locationCompletedValue",
            f: [{
              t: 2,
              r: "locationCompletedValue"
            }],
            t: 13
          }, {
            n: "groupBy",
            f: [{
              t: 2,
              r: "groupBy"
            }],
            t: 13
          }, {
            n: "sortOrder",
            f: [{
              t: 2,
              r: "sortOrder"
            }],
            t: 13
          }, {
            n: "refresh",
            f: [{
              t: 2,
              r: "@this.getProbesData"
            }],
            t: 13
          }, {
            n: "probesLoading",
            f: [{
              t: 2,
              r: "probesLoading"
            }],
            t: 13
          }, {
            n: "probesError",
            f: [{
              t: 2,
              r: "probesError"
            }],
            t: 13
          }, {
            n: "defaultSortOptions",
            f: [{
              t: 2,
              r: "defaultSortOptions"
            }],
            t: 13
          }, {
            n: "filter",
            f: [{
              t: 2,
              r: "filter"
            }],
            t: 13
          }]
        }]
      }]
    }, " ", {
      t: 7,
      e: "c-gp-footer"
    }]
  }],
  e: {
    "_0.pluralize(\"probe\",_1)": function (_0, _1) {
      return _0.pluralize("probe", _1);
    },
    "_0.pluralize(\"ASN\",_1)": function (_0, _1) {
      return _0.pluralize("ASN", _1);
    },
    "true": function () {
      return true;
    }
  }
};
component$7.exports.components = {
  "c-filtered-probe-list": filteredProbeList,
  "c-notification": notification,
  "c-gp-footer": footer,
  "c-google-maps": googleMaps,
  "c-gp-header": header,
  "r-page": rPage
};
var network = ractive.extend(component$7.exports);

var getIteratorFlattenable = function (obj, stringHandling) {
  if (!stringHandling || typeof obj !== 'string') anObject(obj);
  var method = getIteratorMethod(obj);
  return getIteratorDirect(anObject(method !== undefined ? functionCall(method, obj) : obj));
};

var FLAT_MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('flatMap', function () {/* empty */});
var flatMapWithoutClosingOnEarlyError = !FLAT_MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError('flatMap', TypeError);
var FORCED = FLAT_MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR || flatMapWithoutClosingOnEarlyError;
var IteratorProxy = iteratorCreateProxy(function () {
  var iterator = this.iterator;
  var mapper = this.mapper;
  var result, inner;
  while (true) {
    if (inner = this.inner) try {
      result = anObject(functionCall(inner.next, inner.iterator));
      if (!result.done) return result.value;
      this.inner = null;
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    result = anObject(functionCall(this.next, iterator));
    if (this.done = !!result.done) return;
    try {
      this.inner = getIteratorFlattenable(mapper(result.value, this.counter++), false);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
  }
});

// `Iterator.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-iterator.prototype.flatmap
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: FORCED
}, {
  flatMap: function flatMap(mapper) {
    anObject(this);
    try {
      aCallable(mapper);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (flatMapWithoutClosingOnEarlyError) return functionCall(flatMapWithoutClosingOnEarlyError, this, mapper);
    return new IteratorProxy(getIteratorDirect(this), {
      mapper: mapper,
      inner: null
    });
  }
});

var component$6 = {
  exports: {}
};
const DEFAULT_SORT_ORDER = 'location-count';
const CONTINENT_MAP = CONTINENTS.reduce((acc, continent) => {
  acc[continent.code] = continent.name;
  return acc;
}, {});
const COUNTRIES_MAP = countries.reduce((acc, country) => {
  acc[country.code] = country.name;
  return acc;
}, {});
component$6.exports = {
  decorators: {
    popover
  },
  data() {
    return {
      _,
      title: 'Network Providers - Globalping',
      description: 'Browse and search providers to explore network coverage and location distribution.',
      probesLoading: true,
      probesError: null,
      rawProbes: null,
      locationProbes: null,
      probesByCoords: null,
      location: 'World',
      locationCompletedValue: '',
      locationError: '',
      ttPositions: {},
      providerCount: 0,
      providerCountLength: 0,
      continentCount: 0,
      topProviders: [],
      topProvidersDisplayedField: 'continents',
      getTopProviderLocationText: n => `${_.pluralize('location', n)} worldwide`,
      allProviders: [],
      sortOrder: DEFAULT_SORT_ORDER,
      networkStats: Object.create(null),
      uniqueLocations: [],
      allLocationsPopoverListKey: 'countries',
      sortOptions: [{
        name: 'Alphabetically',
        value: 'alphabetically'
      }, {
        name: 'Location count',
        value: 'location-count'
      }]
    };
  },
  computed: {
    filter: {
      get() {
        let location = this.get('locationCompletedValue') || '';
        if (location.toLowerCase() === 'world') {
          return '';
        }
        return location.replace(/\+/g, '%');
      },
      set(location) {
        this.set('location', location.replace(/%/g, '+'));
        this.set('locationCompletedValue', location.replace(/%/g, '+'));
      }
    },
    sort: {
      get() {
        return this.get('sortOrder') === DEFAULT_SORT_ORDER ? null : this.get('sortOrder');
      },
      set(sort) {
        this.set('sortOrder', sort);
      }
    }
  },
  oninit() {
    if (!ractive.isServer) {
      this.getProbeData();
      this.observe('locationProbes', probes => {
        if (probes === null) {
          return;
        }
        this.setUniqueLocations(probes);
        this.setNetworkStats();
        this.setTopProviders();
        this.setAllProviders();
      });
      this.observe('sortOrder', () => {
        this.setAllProviders();
      }, {
        init: false
      });
    }
  },
  handleProbesResponse(response) {
    this.set('rawProbes', response);
    let counts = response.reduce((acc, probe) => {
      acc.providers.add(probe.location.network);
      acc.continents.add(probe.location.continent);
      return acc;
    }, {
      providers: new Set(),
      continents: new Set()
    });
    let providerCount = Math.floor(counts.providers.size / 100) * 100;
    this.set('providerCountLength', Math.floor(Math.log10(providerCount)) + 1);
    this.animate('providerCount', providerCount, {
      duration: 1500
    });
    this.set('continentCount', counts.continents.size);
  },
  getProbeData() {
    this.set('probesLoading', true);
    this.set('probesError', null);
    dataCache.getCache('probesResponse', 60 * 1000, http.fetchGlobalpingProbes).then(value => this.handleProbesResponse(value)).catch(error => this.set('probesError', error)).finally(() => this.set('probesLoading', false));
  },
  setUniqueLocations(probes) {
    let added = new Set();
    let uniqueLocations = probes.filter(probe => {
      let key = `${probe.location.network}|${probe.location.continent}|${probe.location.country}|${probe.location.city}`;
      if (added.has(key)) {
        return false;
      }
      added.add(key);
      return true;
    });
    this.set('uniqueLocations', uniqueLocations);
  },
  setNetworkStats() {
    let uniqueLocations = this.get('uniqueLocations');
    let networkStats = uniqueLocations.reduce((acc, loc) => {
      let networkKey = _.networkNameToKey(loc.location.network);
      if (!acc[networkKey]) {
        acc[networkKey] = {
          name: loc.location.network,
          locations: 0,
          countries: {},
          continents: {},
          cities: {},
          key: networkKey,
          logoAsn: loc.location.asn
        };
      }
      acc[networkKey].locations++;
      acc[networkKey].countries[loc.location.country] = (acc[networkKey].countries[loc.location.country] || 0) + 1;
      acc[networkKey].continents[loc.location.continent] = (acc[networkKey].continents[loc.location.continent] || 0) + 1;
      acc[networkKey].cities[loc.location.city] = (acc[networkKey].cities[loc.location.city] || 0) + 1;
      return acc;
    }, Object.create(null));
    let uniqueContinents = new Set(Object.values(networkStats).flatMap(network => Object.keys(network.continents)));
    let uniqueCountries = new Set(Object.values(networkStats).flatMap(network => Object.keys(network.countries)));
    if (uniqueContinents.size > 1) {
      this.set('allLocationsPopoverListKey', 'continents');
    } else if (uniqueCountries.size > 1) {
      this.set('allLocationsPopoverListKey', 'countries');
    } else {
      this.set('allLocationsPopoverListKey', 'cities');
    }
    let toSortedArray = obj => {
      let sorted = Object.entries(obj).map(([name, count]) => ({
        name,
        count
      })).sort((a, b) => b.count - a.count);
      if (sorted.length > 6) {
        let topItems = sorted.slice(0, 5);
        let otherCount = sorted.slice(5).reduce((sum, item) => sum + item.count, 0);
        topItems.push({
          name: 'Other',
          count: otherCount
        });
        return topItems;
      }
      return sorted;
    };
    Object.values(networkStats).forEach(network => {
      network.countries = toSortedArray(network.countries);
      network.continents = toSortedArray(network.continents);
      network.cities = toSortedArray(network.cities);
    });
    this.set('networkStats', networkStats);
  },
  setTopProviders() {
    let networkStats = this.get('networkStats');
    let topProviders = Object.values(networkStats).filter(network => network.locations > 3).sort((lhs, rhs) => rhs.locations - lhs.locations).slice(0, 6);
    let topProvidersDisplayedField = this.getTopProvidersDisplayedField(topProviders);
    let location = this.get('location');
    let locationLc = location.toLowerCase();
    let getTopProviderLocationText = n => `matching ${_.pluralize('location', n)}`;
    if (locationLc === 'world') {
      getTopProviderLocationText = n => `${_.pluralize('location', n)} worldwide`;
    } else if (CONTINENTS.some(c => c.name.toLowerCase() === locationLc) || countries.some(c => c.name.toLowerCase() === locationLc)) {
      getTopProviderLocationText = n => `${_.pluralize('location', n)} in ${location}`;
    }
    this.set({
      topProviders,
      topProvidersDisplayedField,
      getTopProviderLocationText
    });
  },
  setAllProviders() {
    let locations = this.get('uniqueLocations');
    let networks = locations.reduce((acc, loc) => {
      let networkName = loc.location.network;
      let networkKey = _.networkNameToKey(networkName);
      if (!acc[networkKey]) {
        acc[networkKey] = {
          name: networkName,
          key: networkKey,
          count: 0,
          logoAsn: loc.location.asn
        };
      }
      acc[networkKey].count++;
      return acc;
    }, Object.create(null));
    let sortOrder = this.get('sortOrder');
    let allProviders = Object.values(networks).sort((a, b) => {
      if (sortOrder === 'alphabetically') {
        return a.name.localeCompare(b.name) || b.count - a.count;
      }
      return b.count - a.count || a.name.localeCompare(b.name);
    });
    this.set('allProviders', allProviders);
  },
  getTopProvidersDisplayedField(topProviders) {
    for (let field of ['continents', 'countries']) {
      if (topProviders.some(provider => provider[field].length > 1)) {
        return field;
      }
    }
    return 'cities';
  },
  getFieldName(code) {
    let topProvidersDisplayedField = this.get('topProvidersDisplayedField');
    switch (topProvidersDisplayedField) {
      case 'continents':
        return CONTINENT_MAP[code] || code;
      case 'countries':
        return COUNTRIES_MAP[code] || code;
      default:
        return code;
    }
  },
  onLogoError(network, source) {
    network.logoAsn = null;
    this.update(source);
  },
  getPopoverContent(network, groupCode, targetOnly = false, showBreakdown = true) {
    let groupName = CONTINENT_MAP[groupCode] || COUNTRIES_MAP[groupCode] || groupCode;
    let locationValue = `${groupName ? groupName + '+' : ''}${network}`;
    let targetLoc = _.createLocationString(locationValue, this.get('location'));
    let btnMeasure = `
				<a href="/?location=${encodeURIComponent(targetLoc.replaceAll('+', '%'))}">
					<i class="fa fa-crosshairs" aria-hidden="true"></i>
					Target in a measurement
				</a>`;
    let btnLookingGlass = '';
    let networkKey = _.networkNameToKey(network);
    btnLookingGlass = targetOnly ? '' : `
					<a href="/networks/${networkKey}">
						<i class="fa fa-search" aria-hidden="true"></i>
						<span>
							<span class="p-providers_popover_network-name">${_.escapeLocationString(network)}</span>&nbsp;looking glass
						</span>
					</a>`;
    let breakdownHtml = '';
    let stats = this.get('networkStats')[networkKey];
    if (stats && !targetOnly && showBreakdown) {
      let breakdownKey = this.get('allLocationsPopoverListKey');
      let breakdownEntries = stats[breakdownKey];
      if (breakdownEntries) {
        let listItems = breakdownEntries.map(item => `
						<div class="p-providers_popover_item ${item.name === 'Other' ? 'p-providers_popover_item--other' : ''}">
							<span class="p-providers_popover_item_name">
								${breakdownKey === 'continents' && CONTINENT_MAP[item.name] || breakdownKey === 'countries' && COUNTRIES_MAP[item.name] || item.name}
							</span>
							${breakdownKey !== 'cities' || item.name === 'Other' ? `<span class="p-providers_popover_item_count">${item.count}</span>` : ''}
						</div>
					`).join('');
        breakdownHtml = `
						<div class="p-providers_popover_list">
							${listItems}
						</div>
					`;
      }
    }
    return `<div class="gp-popover-menu">${breakdownHtml}${btnMeasure}${btnLookingGlass}</div>`;
  }
};
component$6.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "r-page",
    m: [{
      n: "noYield",
      f: [{
        t: 2,
        r: "noYield"
      }],
      t: 13
    }, {
      n: "title",
      f: [{
        t: 2,
        r: "title"
      }],
      t: 13
    }, {
      n: "description",
      f: [{
        t: 2,
        r: "description"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "c-notification"
    }, " ", {
      t: 7,
      e: "c-gp-header",
      m: [{
        n: "additionalClasses",
        f: "header-with-globalping-bg",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "main",
      m: [{
        t: 13,
        n: "class",
        f: "p-providers",
        g: 1
      }],
      f: [{
        t: 7,
        e: "section",
        m: [{
          t: 13,
          n: "class",
          f: "p-providers_hero",
          g: 1
        }],
        f: [{
          t: 7,
          e: "h1",
          f: ["Network providers"]
        }, " ", {
          t: 7,
          e: "p",
          f: ["Globalping is powered by ", {
            t: 7,
            e: "strong",
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "p-providers_count",
                g: 1
              }, {
                n: "style",
                f: ["min-width: ", {
                  t: 2,
                  x: {
                    r: ["providerCountLength"],
                    s: "_0+1"
                  }
                }, "ch"],
                t: 13
              }],
              f: [{
                t: 2,
                x: {
                  r: ["providerCount"],
                  s: "Math.floor(_0)"
                }
              }, "+"]
            }, " network providers"]
          }, " across ", {
            t: 2,
            r: "continentCount"
          }, " continents. ", {
            t: 7,
            e: "br"
          }, " Browse and search providers to explore network coverage and probe distribution."]
        }, " ", {
          t: 7,
          e: "img",
          m: [{
            n: "alt",
            f: "",
            t: 13,
            g: 1
          }, {
            n: "aria-hidden",
            f: "true",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/img/arrows.svg"],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "p-providers_hero_glow",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "p-providers_hero_glow_blob p-providers_hero_glow_blob--right",
              g: 1
            }]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "p-providers_hero_glow_blob p-providers_hero_glow_blob--center",
              g: 1
            }]
          }, " ", {
            t: 7,
            e: "span",
            m: [{
              t: 13,
              n: "class",
              f: "p-providers_hero_glow_blob p-providers_hero_glow_blob--left",
              g: 1
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "section",
        m: [{
          t: 13,
          n: "class",
          f: "p-providers_content",
          g: 1
        }],
        f: [{
          t: 7,
          e: "c-probe-filters",
          m: [{
            n: "showGroupBy",
            f: [{
              t: 2,
              x: {
                r: [],
                s: "false"
              }
            }],
            t: 13
          }, {
            n: "showSortOrder",
            f: [{
              t: 2,
              x: {
                r: [],
                s: "false"
              }
            }],
            t: 13
          }, {
            n: "rawProbes",
            f: [{
              t: 2,
              r: "rawProbes"
            }],
            t: 13
          }, {
            n: "location",
            f: [{
              t: 2,
              r: "location"
            }],
            t: 13
          }, {
            n: "locationError",
            f: [{
              t: 2,
              r: "locationError"
            }],
            t: 13
          }, {
            n: "locationProbes",
            f: [{
              t: 2,
              r: "locationProbes"
            }],
            t: 13
          }, {
            n: "locationCompletedValue",
            f: [{
              t: 2,
              r: "locationCompletedValue"
            }],
            t: 13
          }, {
            n: "ttPositions",
            f: [{
              t: 2,
              r: "ttPositions"
            }],
            t: 13
          }, {
            n: "addNetworks",
            f: [{
              t: 2,
              x: {
                r: [],
                s: "false"
              }
            }],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "c-probe-loading-state",
          m: [{
            n: "loading",
            f: [{
              t: 2,
              r: "probesLoading"
            }],
            t: 13
          }, {
            n: "error",
            f: [{
              t: 2,
              r: "probesError"
            }],
            t: 13
          }, {
            n: "hasData",
            f: [{
              t: 2,
              r: "allProviders.length"
            }],
            t: 13
          }, {
            n: "filter",
            f: [{
              t: 2,
              r: "filter"
            }],
            t: 13
          }, {
            n: "loadingText",
            f: "Loading network providers...",
            t: 13,
            g: 1
          }, {
            n: "noDataFilterText",
            f: "No providers found. Please try adjusting the filter.",
            t: 13,
            g: 1
          }, {
            n: "noDataText",
            f: "No providers found. Please try again later.",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "p-providers_largest",
              g: 1
            }],
            f: [{
              t: 7,
              e: "h2",
              f: ["Largest providers"]
            }, " ", {
              t: 7,
              e: "div",
              f: [{
                t: 4,
                f: [{
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "p-providers_provider",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "h3",
                    f: [{
                      t: 7,
                      e: "a",
                      m: [{
                        n: "tabindex",
                        f: "0",
                        t: 13,
                        g: 1
                      }, {
                        n: "role",
                        f: "button",
                        t: 13,
                        g: 1
                      }, {
                        n: "href",
                        f: ["/networks/", {
                          t: 2,
                          r: "key"
                        }],
                        t: 13
                      }, {
                        n: "popover",
                        t: 71,
                        f: {
                          r: ["@this", "./name"],
                          s: "[_0.getPopoverContent(_1,null,false,false)]"
                        }
                      }],
                      f: [{
                        t: 7,
                        e: "span",
                        m: [{
                          t: 13,
                          n: "class",
                          f: "p-providers_provider_logo p-providers_logo",
                          g: 1
                        }],
                        f: [{
                          t: 4,
                          f: [{
                            t: 7,
                            e: "img",
                            m: [{
                              n: "width",
                              f: "36",
                              t: 13,
                              g: 1
                            }, {
                              n: "height",
                              f: "36",
                              t: 13,
                              g: 1
                            }, {
                              n: "src",
                              f: ["/asn-logo/AS", {
                                t: 2,
                                r: "./logoAsn"
                              }, "?v=", {
                                t: 2,
                                r: "@shared.assetsVersion"
                              }, "&size=72"],
                              t: 13
                            }, {
                              n: "loading",
                              f: "lazy",
                              t: 13,
                              g: 1
                            }, {
                              n: "alt",
                              f: "",
                              t: 13,
                              g: 1
                            }, {
                              n: "aria-hidden",
                              f: "true",
                              t: 13,
                              g: 1
                            }, {
                              n: ["error"],
                              t: 70,
                              f: {
                                r: ["@this", "."],
                                s: "[_0.onLogoError(_1,\"topProviders\")]"
                              }
                            }]
                          }],
                          n: 50,
                          r: "./logoAsn"
                        }, {
                          t: 4,
                          f: [{
                            t: 2,
                            r: "./name.0"
                          }],
                          n: 51,
                          l: 1
                        }]
                      }, " ", {
                        t: 2,
                        r: "./name"
                      }]
                    }]
                  }, " ", {
                    t: 7,
                    e: "h4",
                    f: [{
                      t: 2,
                      x: {
                        r: ["./locations"],
                        s: "_0.toLocaleString(\"en-US\")"
                      }
                    }, " ", {
                      t: 2,
                      x: {
                        r: ["~/getTopProviderLocationText", "./locations"],
                        s: "_0(_1)"
                      }
                    }]
                  }, " ", {
                    t: 7,
                    e: "div",
                    f: [{
                      t: 4,
                      f: [{
                        t: 7,
                        e: "div",
                        m: [{
                          n: "class",
                          f: ["p-providers_provider_item ", {
                            t: 4,
                            f: ["p-providers_provider_item--other"],
                            n: 50,
                            x: {
                              r: ["./name"],
                              s: "_0===\"Other\""
                            }
                          }],
                          t: 13
                        }],
                        f: [{
                          t: 4,
                          f: [{
                            t: 7,
                            e: "span",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "p-providers_provider_item_name",
                              g: 1
                            }],
                            f: [{
                              t: 2,
                              r: "./name"
                            }]
                          }],
                          n: 50,
                          x: {
                            r: ["./name"],
                            s: "_0===\"Other\""
                          }
                        }, {
                          t: 4,
                          f: [{
                            t: 7,
                            e: "span",
                            m: [{
                              t: 13,
                              n: "class",
                              f: "p-providers_provider_item_name",
                              g: 1
                            }, {
                              n: "tabindex",
                              f: "0",
                              t: 13,
                              g: 1
                            }, {
                              n: "role",
                              f: "button",
                              t: 13,
                              g: 1
                            }, {
                              n: "popover",
                              t: 71,
                              f: {
                                r: ["@this", "provider.name", "./name"],
                                s: "[_0.getPopoverContent(_1,_2,true)]"
                              }
                            }],
                            f: [{
                              t: 2,
                              x: {
                                r: ["@this", "./name"],
                                s: "_0.getFieldName(_1)"
                              }
                            }]
                          }],
                          n: 51,
                          l: 1
                        }, " ", {
                          t: 7,
                          e: "span",
                          m: [{
                            t: 13,
                            n: "class",
                            f: "p-providers_provider_item_count",
                            g: 1
                          }],
                          f: [{
                            t: 2,
                            r: "./count"
                          }]
                        }]
                      }],
                      n: 52,
                      rx: {
                        r: ".",
                        m: [{
                          t: 30,
                          n: "~/topProvidersDisplayedField"
                        }]
                      }
                    }]
                  }]
                }],
                n: 52,
                z: [{
                  n: "provider",
                  x: {
                    r: "."
                  }
                }],
                r: "topProviders"
              }]
            }]
          }],
          n: 50,
          x: {
            r: ["topProviders.length"],
            s: "_0>=3"
          }
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "p-providers_all",
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "p-providers_all_header",
                g: 1
              }],
              f: [{
                t: 7,
                e: "h2",
                f: ["All providers"]
              }, " ", {
                t: 7,
                e: "div",
                m: [{
                  t: 13,
                  n: "class",
                  f: "p-providers_all_sort-by",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "label",
                  f: ["Sort by"]
                }, " ", {
                  t: 7,
                  e: "c-select",
                  m: [{
                    n: "options",
                    f: [{
                      t: 2,
                      r: "sortOptions"
                    }],
                    t: 13
                  }, {
                    n: "selected",
                    f: [{
                      t: 2,
                      r: "sortOrder"
                    }],
                    t: 13
                  }, {
                    n: "name",
                    f: "sort-by-select",
                    t: 13,
                    g: 1
                  }]
                }]
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "p-providers_all_networks",
                g: 1
              }],
              f: [{
                t: 4,
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "p-providers_all_network",
                    g: 1
                  }, {
                    n: "tabindex",
                    f: "0",
                    t: 13,
                    g: 1
                  }, {
                    n: "role",
                    f: "button",
                    t: 13,
                    g: 1
                  }, {
                    n: "href",
                    f: ["/networks/", {
                      t: 2,
                      r: "key"
                    }],
                    t: 13
                  }, {
                    n: "popover",
                    t: 71,
                    f: {
                      r: ["@this", "./name"],
                      s: "[_0.getPopoverContent(_1)]"
                    }
                  }],
                  f: [{
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "p-providers_all_network_logo p-providers_logo",
                      g: 1
                    }],
                    f: [{
                      t: 4,
                      f: [{
                        t: 7,
                        e: "img",
                        m: [{
                          n: "width",
                          f: "20",
                          t: 13,
                          g: 1
                        }, {
                          n: "height",
                          f: "20",
                          t: 13,
                          g: 1
                        }, {
                          n: "src",
                          f: ["/asn-logo/AS", {
                            t: 2,
                            r: "./logoAsn"
                          }, "?v=", {
                            t: 2,
                            r: "@shared.assetsVersion"
                          }, "&size=40"],
                          t: 13
                        }, {
                          n: "loading",
                          f: "lazy",
                          t: 13,
                          g: 1
                        }, {
                          n: "alt",
                          f: "",
                          t: 13,
                          g: 1
                        }, {
                          n: "aria-hidden",
                          f: "true",
                          t: 13,
                          g: 1
                        }, {
                          n: ["error"],
                          t: 70,
                          f: {
                            r: ["@this", "."],
                            s: "[_0.onLogoError(_1,\"allProviders\")]"
                          }
                        }]
                      }],
                      n: 50,
                      r: "./logoAsn"
                    }, {
                      t: 4,
                      f: [{
                        t: 2,
                        r: "./name.0"
                      }],
                      n: 51,
                      l: 1
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "p-providers_all_network_name",
                      g: 1
                    }],
                    f: [{
                      t: 2,
                      r: "./name"
                    }]
                  }, " ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "p-providers_all_network_count",
                      g: 1
                    }],
                    f: [{
                      t: 2,
                      r: "./count"
                    }]
                  }]
                }],
                n: 52,
                r: "allProviders"
              }]
            }]
          }],
          n: 50,
          r: "allProviders.length"
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "p-providers_logos-by",
            g: 1
          }],
          f: [{
            t: 7,
            e: "a",
            m: [{
              n: "href",
              f: "https://logo.dev",
              t: 13,
              g: 1
            }, {
              n: "target",
              f: "_blank",
              t: 13,
              g: 1
            }, {
              n: "rel",
              f: "noreferrer",
              t: 13,
              g: 1
            }],
            f: ["Network logos provided by Logo.dev"]
          }]
        }]
      }]
    }, " ", {
      t: 7,
      e: "c-gp-footer"
    }]
  }],
  e: {
    "_0+1": function (_0) {
      return _0 + 1;
    },
    "Math.floor(_0)": function (_0) {
      return Math.floor(_0);
    },
    "false": function () {
      return false;
    },
    "[_0.getPopoverContent(_1,null,false,false)]": function (_0, _1) {
      return [_0.getPopoverContent(_1, null, false, false)];
    },
    "[_0.onLogoError(_1,\"topProviders\")]": function (_0, _1) {
      return [_0.onLogoError(_1, "topProviders")];
    },
    "_0.toLocaleString(\"en-US\")": function (_0) {
      return _0.toLocaleString("en-US");
    },
    "_0(_1)": function (_0, _1) {
      return _0(_1);
    },
    "_0===\"Other\"": function (_0) {
      return _0 === "Other";
    },
    "[_0.getPopoverContent(_1,_2,true)]": function (_0, _1, _2) {
      return [_0.getPopoverContent(_1, _2, true)];
    },
    "_0.getFieldName(_1)": function (_0, _1) {
      return _0.getFieldName(_1);
    },
    "_0>=3": function (_0) {
      return _0 >= 3;
    },
    "[_0.getPopoverContent(_1)]": function (_0, _1) {
      return [_0.getPopoverContent(_1)];
    },
    "[_0.onLogoError(_1,\"allProviders\")]": function (_0, _1) {
      return [_0.onLogoError(_1, "allProviders")];
    }
  }
};
component$6.exports.components = {
  "c-probe-loading-state": probeLoadingState,
  "c-probe-filters": probeFilters,
  "c-notification": notification,
  "c-gp-footer": footer,
  "c-google-maps": googleMaps,
  "c-gp-header": header,
  "c-select": select,
  "r-page": rPage
};
var networkProviders = ractive.extend(component$6.exports);

var component$5 = {
  exports: {}
};
const ITEMS_TO_SHOW_LIMIT = 4;
component$5.exports = {
  data() {
    return {
      wrapperHeight: 'auto',
      expanded: false,
      limitedList: null,
      initialHeight: null,
      restList: [],
      limit: ITEMS_TO_SHOW_LIMIT
    };
  },
  onrender() {
    if (!ractive.isServer) {
      listeners.addManagedListener(this, window, 'resize', this.handleResize.bind(this));
      let wrapperEl = this.find('#showMoreLinkListWrapperEl');
      this.observe('expanded', expanded => {
        let list = this.get('list') || [];
        let limit = this.get('limit');
        this.set('limitedList', expanded ? list : list.slice(0, limit));
        if (expanded) {
          requestAnimationFrame(() => {
            this.set('wrapperHeight', `${wrapperEl.scrollHeight}px`);
          });
        } else {
          this.set('wrapperHeight', `${wrapperEl.scrollHeight}px`);
          requestAnimationFrame(() => {
            this.set('wrapperHeight', this.get('initialHeight'));
          });
        }
      });
      this.observe('limitedList', limitedList => {
        let initialHeight = this.get('initialHeight');
        if (initialHeight === null && limitedList && limitedList.length) {
          requestAnimationFrame(() => {
            let height = `${wrapperEl.scrollHeight}px`;
            this.set('initialHeight', height);
            this.set('wrapperHeight', height);
          });
        }
      });
    }
  },
  handleResize() {
    let wrapperEl = this.find('#showMoreLinkListWrapperEl');
    let expanded = this.get('expanded');
    if (expanded) {
      this.set('wrapperHeight', `${wrapperEl.scrollHeight}px`);
      this.set('expanded', false);
      requestAnimationFrame(() => {
        this.set('wrapperHeight', 'auto');
      });
    }
    requestAnimationFrame(() => {
      let height = `${wrapperEl.scrollHeight}px`;
      this.set('initialHeight', height);
      this.set('wrapperHeight', height);
    });
  },
  makeURLFromASN(id) {
    let method = this.get('method')?.toLowerCase() || 'ping';
    let prefix = this.get('prefix') ?? '';
    return `/network-tools/${method}-from-${prefix}${id}`;
  }
};
component$5.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      n: "id",
      f: "showMoreLinkListWrapperEl",
      t: 13,
      g: 1
    }, {
      n: "class",
      f: ["c-show-more-link-list ", {
        t: 2,
        x: {
          r: ["addClass"],
          s: "_0||\"\""
        }
      }],
      t: 13
    }, {
      n: "style",
      f: ["height: ", {
        t: 2,
        r: "wrapperHeight"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "c-show-more-link-list_inner",
        g: 1
      }],
      f: [{
        t: 4,
        f: [{
          t: 7,
          e: "a",
          m: [{
            t: 13,
            n: "class",
            f: "c-show-more-link-list_inner_item",
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              x: {
                r: ["@this", "item"],
                s: "_0.makeURLFromASN(_1)"
              }
            }],
            t: 13
          }],
          f: [{
            t: 2,
            x: {
              r: ["prefix"],
              s: "_0||\"\""
            }
          }, {
            t: 2,
            r: "item"
          }]
        }],
        n: 52,
        z: [{
          n: "item",
          x: {
            r: "."
          }
        }],
        r: "limitedList"
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "button",
          m: [{
            t: 13,
            n: "class",
            f: "c-show-more-link-list_toggle-button",
            g: 1
          }, {
            n: ["click"],
            t: 70,
            f: {
              r: ["@this", "expanded"],
              s: "[_0.set(\"expanded\",!_1)]"
            }
          }],
          f: [{
            t: 2,
            x: {
              r: ["expanded"],
              s: "_0?\"Show less\":\"Show more\""
            }
          }]
        }],
        n: 50,
        x: {
          r: ["list.length", "limit"],
          s: "_0>_1"
        }
      }]
    }]
  }],
  e: {
    "_0||\"\"": function (_0) {
      return _0 || "";
    },
    "_0.makeURLFromASN(_1)": function (_0, _1) {
      return _0.makeURLFromASN(_1);
    },
    "[_0.set(\"expanded\",!_1)]": function (_0, _1) {
      return [_0.set("expanded", !_1)];
    },
    "_0?\"Show less\":\"Show more\"": function (_0) {
      return _0 ? "Show less" : "Show more";
    },
    "_0>_1": function (_0, _1) {
      return _0 > _1;
    }
  }
};
var showMoreLinkList = ractive.extend(component$5.exports);

var component$4 = {
  exports: {}
};
const DEFAULT_LIMIT = 1;
const OTHER_NETWORKS_DISPLAYED = 12;
const INITIAL_OPTS_VALUES = {
  type: 'Ping',
  target: 'cdn.jsdelivr.net'
};
const RATE_LIMIT_HEADERS = ['x-ratelimit-remaining', 'x-ratelimit-reset', 'x-credits-remaining', 'x-request-cost'];
const PROBE_NO_TIMING_VALUE = _.getProbeTimeOutValue();
const PROBE_STATUS_OFFLINE = _.getProbeStatusOfflineValue();
component$4.exports = {
  decorators: {
    tooltip
  },
  data() {
    return {
      title: '',
      description: '',
      locationsList: [],
      selectedLocation: null,
      selectedTestType: 'ping',
      testTypesList: ['ping', 'traceroute', 'DNS', 'MTR', 'HTTP'],
      probesResponse: null,
      probesParsed: false,
      userIP: null,
      asnList: [],
      networkLogoAsn: null,
      testResults: null,
      testInProgress: false,
      testReqCancelFn: null,
      testReqParams: null,
      testOpts: {
        target: INITIAL_OPTS_VALUES.target,
        limit: DEFAULT_LIMIT
      },
      inputErrors: {},
      serverErrorMessage: null,
      creditErrorMessage: null,
      otherNetworks: [],
      probesByCoords: null,
      mapExpanded: false
    };
  },
  computed: {
    shouldDisplayLogoDevLink() {
      let otherNetworks = this.get('otherNetworks');
      return this.get('networkLogoAsn') || otherNetworks && otherNetworks.filter(n => n.networkLogoAsn).length;
    },
    measurementLocationText() {
      let testResults = this.get('testResults');
      if (!testResults || !testResults.length) {
        return '';
      }
      let probe = testResults[0].probe;
      return `> ${probe.city}${probe.state ? ` (${probe.state})` : ''}, ${probe.country}, ${probe.continent}, ${probe.network} (AS${probe.asn})\n`;
    }
  },
  onconfig() {
    let networkName = this.get('networkName');
    let tempNetworkName = this.getTempNetworkName(networkName);
    this.set('networkName', networkName);
    this.set('networkFullName', this.getTempNetworkName(networkName));
    this.setTitleAndDescr(tempNetworkName);
  },
  oninit() {
    if (!ractive.isServer) {
      this.getGlobalpingProbesData();
      this.fetchAndSetUserIP();
      this.observe('networkFullName', networkFullName => {
        this.setTitleAndDescr(networkFullName);
      });

      // set default location value
      this.observe('locationsList', locationsList => {
        if (locationsList && locationsList.length) {
          this.set('selectedLocation', locationsList[0]);
        }
      });
      this.observe('probesParsed', async probesParsed => {
        if (probesParsed === false) {
          return;
        }
        let networkName = this.get('networkName');
        let parsedLocations = this.get('parsedLocations');
        let {
          name: networkFullName,
          asnList = [],
          locations = {},
          probesByCoords = {}
        } = parsedLocations[networkName] || {};
        if (networkFullName) {
          this.set('networkFullName', networkFullName);
        } else {
          window.location.replace('/404');
          return;
        }
        let locationsList = Object.values(locations).sort((lhs, rhs) => lhs.country.localeCompare(rhs.country) || lhs.city.localeCompare(rhs.city));
        this.set('asnList', asnList);
        this.set('networkLogoAsn', asnList[0] || null);
        this.set('locationsList', locationsList);
        this.set('probesByCoords', probesByCoords);
        let otherNetworks = await this.findOtherNetworks();
        this.set('otherNetworks', otherNetworks);
      });
      this.observe('realTimeTestResResponse', realTimeTestResResponse => {
        if (!realTimeTestResResponse) {
          return;
        }
        if (realTimeTestResResponse.status === 'finished') {
          this.get('testReqCancelFn')?.();
          this.set('testInProgress', false);
        }
        let prevTestResults = this.get('testResults') || [];
        let updTestResults = realTimeTestResResponse.results.filter(res => {
          // if it is no in-progress then it is already finished or failed
          if (res.result.status !== 'in-progress') {
            return true;
          }
          return false;
        });

        // filter out results that have already been drawn
        let newTestResults = updTestResults.filter(updRes => {
          return !prevTestResults.some(prevRes => JSON.stringify(prevRes) === JSON.stringify(updRes));
        });
        this.set('testResults', [...prevTestResults, ...newTestResults]);
      }, {
        init: false
      });

      // set measurementsMetadata for the c-gp-results-share component
      this.observe('testReqParams', testReqParams => {
        if (!testReqParams) {
          return;
        }
        let measurementsMetadata = {
          0: {
            target: testReqParams.target,
            measurementId: testReqParams.id
          }
        };
        this.set('measurementsMetadata', measurementsMetadata);
      });
    }
  },
  onrender() {
    if (!ractive.isServer) {
      // run the test if user is pressed Enter inside of any of options inputs
      let ipOrHostnameEl = this.find('#ipOrHostname');
      listeners.addManagedListener(this, ipOrHostnameEl, 'keydown', this.handleEnterBtn.bind(this));
    }
  },
  onunrender() {
    this.get('testReqCancelFn')?.();
  },
  setLocation(newLocation) {
    this.set('selectedLocation', newLocation);
  },
  setTestType(newTestType) {
    this.set('selectedTestType', newTestType);
  },
  getGlobalpingProbesData() {
    // get probes from sessionStorage or fetch them
    dataCache.getCache('probesResponse', 60 * 1000, http.fetchGlobalpingProbes).then(response => {
      this.set('parsedLocations', this.parseProbesResponse(response));
      this.set('probesParsed', true);
    }).catch(error => {
      console.error('Failed to fetch probes', error);
    });
  },
  async findOtherNetworks() {
    let networkName = this.get('networkName');
    let parsedLocations = this.get('parsedLocations');
    if (!parsedLocations || !networkName) {
      return [];
    }

    // create a sorted list of networks by the number of locations and name
    let sortedNetworks = Object.entries(parsedLocations).sort((lhs, rhs) => lhs[1].probeCount - rhs[1].probeCount || lhs[0].localeCompare(rhs[0]));
    let currentNetworkIndex = sortedNetworks.findIndex(([key]) => key === networkName);

    // find ideal upper and lower network indices
    let upperBound = Math.ceil(OTHER_NETWORKS_DISPLAYED / 2);
    let lowerBound = Math.floor(OTHER_NETWORKS_DISPLAYED / 2);

    // find index over/underflows
    let upperOverflow = Math.max(0, currentNetworkIndex + upperBound + 1 - sortedNetworks.length);
    let lowerUnderflow = Math.max(0, lowerBound - currentNetworkIndex);

    // correct the over/underflows
    let indexShift = lowerUnderflow - upperOverflow;
    let lowerIndex = currentNetworkIndex - lowerBound + indexShift;
    let upperIndex = currentNetworkIndex + upperBound + indexShift;

    // find similar networks
    let lowerNetworks = sortedNetworks.slice(lowerIndex, currentNetworkIndex);
    let upperNetworks = sortedNetworks.slice(currentNetworkIndex + 1, upperIndex + 1);
    return [...lowerNetworks, ...upperNetworks].map(([key, {
      name,
      asnList
    }]) => ({
      name: key,
      fullName: name,
      networkLogoAsn: asnList?.[0] || null
    }));
  },
  parseProbesResponse(data) {
    let extractLocationInfo = location => {
      let country = countries.find(i => i.code.toLowerCase() === location.country.toLowerCase())?.name || location.country;
      let {
        city,
        latitude,
        longitude
      } = location;
      return {
        city,
        country,
        countryCode: location.country.split(', ')[0],
        latitude,
        longitude
      };
    };
    let byNetwork = data.reduce((res, probe) => {
      let {
        location
      } = probe;
      let {
        latitude,
        longitude,
        ...locationInfo
      } = extractLocationInfo(location);
      let networkNameAsKey = _.networkNameToKey(location.network);
      let coords = `${latitude}, ${longitude}`;
      let locationKey = `${location.country}, ${location.city}`;

      // collect uniques Networks and count amount of probes per Network
      if (!Object.hasOwn(res, networkNameAsKey)) {
        res[networkNameAsKey] = {
          name: location.network,
          asnList: [location.asn],
          probesByCoords: {
            [coords]: [probe]
          },
          locations: {
            [locationKey]: {
              ...locationInfo,
              coords: [{
                latitude,
                longitude
              }]
            }
          },
          probeCount: 1
        };
        return res;
      }
      res[networkNameAsKey].probeCount++;

      // collect all unique network's ASNs
      if (!res[networkNameAsKey].asnList.includes(location.asn)) {
        res[networkNameAsKey].asnList.push(location.asn);
      }

      // group probes by location (for select)
      if (!Object.hasOwn(res[networkNameAsKey].locations, locationKey)) {
        res[networkNameAsKey].locations[locationKey] = {
          ...locationInfo,
          coords: []
        };
      }

      // group probes by coords (for the map)
      if (!Object.hasOwn(res[networkNameAsKey].probesByCoords, coords)) {
        res[networkNameAsKey].probesByCoords[coords] = [];
        res[networkNameAsKey].locations[locationKey].coords.push({
          latitude,
          longitude
        });
      }
      res[networkNameAsKey].probesByCoords[coords].push(probe);
      return res;
    }, {});
    Object.values(byNetwork).forEach(network => {
      network.asnList.sort((a, b) => a - b);
    });
    return byNetwork;
  },
  onMarkerClick({
    latitude,
    longitude
  }) {
    // find the location which contains the clicked marker's coordinates
    let newSelectedLocation = this.get('locationsList').find(loc => loc.coords.some(c => c.latitude === latitude && c.longitude === longitude));
    if (newSelectedLocation) {
      this.set('selectedLocation', newSelectedLocation);
    }
  },
  setTitleAndDescr(networkFullName) {
    this.set('title', `${networkFullName} Looking Glass - Globalping`);
    this.set('description', `Looking glass network tools for all ${networkFullName} locations`);
  },
  getTempNetworkName(networkName) {
    return _.capitalizeStrEveryFirstLetter(networkName.split('-').join(' '));
  },
  proceedToTest() {
    let type = this.get('selectedTestType').toLowerCase();
    let testOpts = this.get('testOpts');
    let {
      city,
      country
    } = this.get('selectedLocation');
    let networkFullName = this.get('networkFullName');
    let magic = `${city}+${country}+${networkFullName}`;
    let reqParams = {
      type,
      ...testOpts,
      locations: [{
        magic
      }]
    };

    // clear all data from the previous test, show spinner
    this.set('testResults', null);
    this.set('testInProgress', true);
    this.set('testReqParams', null);
    this.set('serverErrorMessage', null);
    this.set('creditErrorMessage', null);
    http.postGlobalpingMeasurement(reqParams, RATE_LIMIT_HEADERS).then(res => {
      this.getTestMeasurementById(res.response.id);
    }).catch(err => {
      let errBody = err?.error;
      this.set('testInProgress', false);
      if (errBody?.type === 'validation_error') {
        let inputErrors = _.parseValidationErrors(errBody);
        this.set('inputErrors', inputErrors);
      } else if (err?.responseStatusCode === 429) {
        let measurementErrMsg = _.createMeasCreditsErrMsg(err.responseHeaders, this.get('@shared.user'));
        this.set('creditErrorMessage', measurementErrMsg);
      } else {
        this.set('serverErrorMessage', err.error?.message ?? 'An unexpected error occurred.');
      }
    });
  },
  getTestMeasurementById(measurementId) {
    let cancelled = false;
    let timeout = null;
    let cancel = () => {
      cancelled = true;
      clearTimeout(timeout);
      timeout = null;
    };
    let fetch = () => {
      if (cancelled) {
        return;
      }
      http.getGlobalpingMeasurement(measurementId).then(testRes => {
        // prepare and set request params to pass them to gp-test-results
        let testReqParams = JSON.parse(JSON.stringify(testRes));
        delete testReqParams.results;
        delete testReqParams.status;
        delete testReqParams.updatedAt;
        delete testReqParams.createdAt;
        testReqParams = {
          inProgressUpdates: true,
          limit: DEFAULT_LIMIT,
          ...testReqParams,
          measurementOptions: {
            trace: false,
            ...testReqParams.measurementOptions
          }
        };

        // set testReqParams to pass them to c-gp-results-raw-output
        this.set('testReqParams', testReqParams);

        // should be after the mainOptions.type was set
        this.set('realTimeTestResResponse', testRes);
        if (!cancelled) {
          timeout = setTimeout(fetch, 500);
        }
      }).catch(() => {
        cancel();
        this.set('serverErrorMessage', 'An unexpected error occurred.');
        this.set('testInProgress', false);
      });
    };
    fetch();
    this.set('testReqCancelFn', cancel);
  },
  prepareRegularResults(testResults) {
    let dnsTraceEnabled = this.get('testReqParams.measurementOptions.trace');
    let selectedTestType = this.get('selectedTestType');
    return testResults.map(res => {
      let preparedRes = {
        ...res.probe,
        statsPerTarget: [{
          target: res.target
        }]
      };
      if (res.result.status !== 'in-progress') {
        let {
          isFailed = false,
          lastTiming,
          value: avgTiming,
          extraValues
        } = _.calcGpTestResTiming(selectedTestType, res, dnsTraceEnabled);
        let {
          packetsTotal
        } = _.parseGpRawOutputForTimings(res.result.rawOutput);
        let minTiming = res.result?.stats?.min || PROBE_NO_TIMING_VALUE;
        let maxTiming = res.result?.stats?.max || PROBE_NO_TIMING_VALUE;
        let isOffline = res.result.status === PROBE_STATUS_OFFLINE;
        preparedRes.statsPerTarget = [{
          ...preparedRes.statsPerTarget[0],
          avgTiming,
          isFailed,
          isOffline,
          extraValues,
          rawOutput: res.result.rawOutput,
          areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal)
        }];
      }
      return preparedRes;
    });
  },
  checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal) {
    if (!packetsTotal || typeof lastTiming === 'undefined' || typeof maxTiming === 'undefined' || typeof minTiming === 'undefined' || typeof avgTiming === 'undefined') {
      return false;
    }
    return true;
  },
  fetchAndSetUserIP() {
    fetch('https://cloudflare-dns.com/cdn-cgi/trace').then(res => res.text()).then(text => {
      let data = Object.fromEntries(text.trim().split('\n').map(line => line.split('=')));
      this.set('userIP', data.ip || null);
    }).catch(err => {
      console.error('Failed to fetch user\'s IP:', err);
      this.set('userIP', null);
    });
  },
  onLogoError(network) {
    network.networkLogoAsn = null;
    // trigger re-render
    this.update('otherNetworks');
  },
  handleEnterBtn(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.proceedToTest();
    }
  }
};
component$4.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "r-page",
    m: [{
      n: "noYield",
      f: [{
        t: 2,
        r: "noYield"
      }],
      t: 13
    }, {
      n: "title",
      f: [{
        t: 2,
        r: "title"
      }],
      t: 13
    }, {
      n: "description",
      f: [{
        t: 2,
        r: "description"
      }],
      t: 13
    }, {
      n: "openGraphImage",
      f: [{
        t: 2,
        r: "@shared.serverHost"
      }, "/open-graph/image/networks/", {
        t: 2,
        r: "networkName"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "c-notification"
    }, " ", {
      t: 7,
      e: "c-gp-header",
      m: [{
        n: "additionalClasses",
        f: "header-with-globalping-bg",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "p-globalping-networks",
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "p-globalping-networks_head",
          g: 1
        }],
        f: [{
          t: 7,
          e: "h1",
          m: [{
            t: 13,
            n: "class",
            f: "p-globalping-networks_head_title",
            g: 1
          }],
          f: ["Looking Glass - ", {
            t: 2,
            r: "networkFullName"
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 9,
            c: " The component can't handle updates, so wait for the data first. "
          }, " ", {
            t: 7,
            e: "c-show-more-link-list",
            m: [{
              n: "method",
              f: [{
                t: 2,
                r: "selectedTestType"
              }],
              t: 13
            }, {
              n: "list",
              f: [{
                t: 2,
                r: "asnList"
              }],
              t: 13
            }, {
              n: "limit",
              f: "4",
              t: 13,
              g: 1
            }, {
              n: "prefix",
              f: "AS",
              t: 13,
              g: 1
            }, {
              n: "addClass",
              f: "p-globalping-networks_head_asn-list",
              t: 13,
              g: 1
            }]
          }],
          n: 50,
          r: "asnList"
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "p-globalping-networks_network",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "p-globalping-networks_network_head",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            f: ["Network"]
          }, " ", {
            t: 4,
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "32",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "32",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: ["/asn-logo/AS", {
                  t: 2,
                  r: "networkLogoAsn"
                }, "?v=", {
                  t: 2,
                  r: "@shared.assetsVersion"
                }, "&size=64"],
                t: 13
              }, {
                n: "loading",
                f: "lazy",
                t: 13,
                g: 1
              }, {
                n: "alt",
                f: [{
                  t: 2,
                  r: "networkFullName"
                }, " logo"],
                t: 13
              }, {
                n: "tooltip",
                t: 71,
                f: {
                  r: ["networkFullName"],
                  s: "[_0]"
                }
              }, {
                n: ["error"],
                t: 70,
                f: {
                  r: ["@this"],
                  s: "[_0.set(\"networkLogoAsn\",null)]"
                }
              }]
            }],
            n: 50,
            r: "networkLogoAsn"
          }, {
            t: 4,
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "p-globalping-networks_img-placeholder",
                g: 1
              }],
              f: [{
                t: 2,
                r: "networkFullName.0"
              }]
            }],
            n: 51,
            l: 1
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "p-globalping-networks_network_body",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_dropdown_reg p-globalping-networks_network_body_select",
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              f: ["Location"]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "btn-group",
                g: 1
              }],
              f: [{
                t: 7,
                e: "button",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-toggle",
                  g: 1
                }, {
                  n: "type",
                  f: "button",
                  t: 13,
                  g: 1
                }, {
                  n: "data-toggle",
                  f: "dropdown",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-haspopup",
                  f: "true",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-expanded",
                  f: "false",
                  t: 13,
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "dropdown-item",
                    g: 1
                  }],
                  f: [{
                    t: 4,
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "height",
                        f: "14",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
                          t: 2,
                          r: "selectedLocation.countryCode"
                        }, ".svg"],
                        t: 13
                      }]
                    }, " ", {
                      t: 2,
                      r: "~/selectedLocation.countryCode"
                    }, ", ", {
                      t: 2,
                      r: "~/selectedLocation.city"
                    }],
                    n: 50,
                    r: "selectedLocation"
                  }]
                }, " ", {
                  t: 7,
                  e: "i",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "fa fa-angle-down",
                    g: 1
                  }, {
                    n: "aria-hidden",
                    f: "true",
                    t: 13,
                    g: 1
                  }]
                }]
              }, " ", {
                t: 7,
                e: "ul",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-menu",
                  g: 1
                }, {
                  n: "role",
                  f: "listbox",
                  t: 13,
                  g: 1
                }],
                f: [{
                  t: 4,
                  f: [{
                    t: 7,
                    e: "li",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "dropdown-item",
                      g: 1
                    }, {
                      n: "aria-selected",
                      f: [{
                        t: 2,
                        x: {
                          r: [".", "selectedLocation"],
                          s: "_0===_1"
                        }
                      }],
                      t: 13
                    }, {
                      n: "role",
                      f: "option",
                      t: 13,
                      g: 1
                    }, {
                      n: ["click"],
                      t: 70,
                      f: {
                        r: ["@this", "."],
                        s: "[_0.setLocation(_1)]"
                      }
                    }],
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "height",
                        f: "14",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
                          t: 2,
                          r: "./countryCode"
                        }, ".svg"],
                        t: 13
                      }]
                    }, " ", {
                      t: 2,
                      r: "./countryCode"
                    }, ", ", {
                      t: 2,
                      r: "./city"
                    }]
                  }],
                  n: 52,
                  r: "~/locationsList"
                }]
              }]
            }]
          }, " ", {
            t: 7,
            e: "c-controlled-input",
            m: [{
              n: "id",
              f: "ipAddress",
              t: 13,
              g: 1
            }, {
              n: "value",
              f: [{
                t: 2,
                r: "userIP"
              }],
              t: 13
            }, {
              n: "userIP",
              f: [{
                t: 2,
                r: "userIP"
              }],
              t: 13
            }, {
              n: "error",
              f: "",
              t: 13,
              g: 1
            }, {
              n: "placeholder",
              f: "Your IP",
              t: 13,
              g: 1
            }, {
              n: "labelText",
              f: "Your IP",
              t: 13,
              g: 1
            }, {
              n: "classList",
              f: "p-globalping-networks_network_body_input gp_input",
              t: 13,
              g: 1
            }, {
              n: "locked",
              f: "true",
              t: 13,
              g: 1
            }],
            f: [],
            p: {
              copyBtn: [{
                t: 4,
                f: [{
                  t: 7,
                  e: "button",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "p-globalping-networks_network_body_input_copy-btn",
                    g: 1
                  }, {
                    n: "clipboard",
                    t: 71
                  }, {
                    n: "data-clipboard-text",
                    f: [{
                      t: 2,
                      r: "userIP"
                    }],
                    t: 13
                  }],
                  f: ["Copy"]
                }],
                n: 50,
                r: "userIP"
              }]
            }
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            n: "class",
            f: ["p-globalping-networks_network_map-wrapper ", {
              t: 4,
              f: ["is-expanded"],
              n: 50,
              r: "mapExpanded"
            }],
            t: 13
          }],
          f: [{
            t: 7,
            e: "button",
            m: [{
              n: "type",
              f: "button",
              t: 13,
              g: 1
            }, {
              n: "aria-label",
              f: [{
                t: 2,
                x: {
                  r: ["mapExpanded"],
                  s: "_0?\"Collapse map\":\"Expand map\""
                }
              }],
              t: 13
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this"],
                s: "[_0.toggle(\"mapExpanded\")]"
              }
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "20",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "20",
                t: 13,
                g: 1
              }, {
                n: "alt",
                f: "",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/", {
                  t: 4,
                  f: ["minimize-icon.svg"],
                  n: 50,
                  r: "mapExpanded"
                }, {
                  t: 4,
                  f: ["maximize-icon.svg"],
                  n: 51,
                  l: 1
                }],
                t: 13
              }]
            }]
          }, " ", {
            t: 7,
            e: "c-google-maps",
            m: [{
              t: 13,
              n: "class",
              f: "p-globalping-networks_network_map-wrapper_map",
              g: 1
            }, {
              n: "probesByCoords",
              f: [{
                t: 2,
                r: "probesByCoords"
              }],
              t: 13
            }, {
              n: "hasCluster",
              f: [{
                t: 2,
                x: {
                  r: [],
                  s: "true"
                }
              }],
              t: 13
            }, {
              n: "onMarkerClick",
              f: [{
                t: 2,
                r: "@this.onMarkerClick"
              }],
              t: 13
            }, {
              n: "displayInfoWindow",
              f: [{
                t: 2,
                x: {
                  r: [],
                  s: "false"
                }
              }],
              t: 13
            }, {
              n: "selectedLocation",
              f: [{
                t: 2,
                r: "selectedLocation"
              }],
              t: 13
            }, {
              n: "focusOnChange",
              f: [{
                t: 2,
                x: {
                  r: [],
                  s: "true"
                }
              }],
              t: 13
            }, {
              n: "lockMapBoundaries",
              f: [{
                t: 2,
                x: {
                  r: [],
                  s: "true"
                }
              }],
              t: 13
            }, {
              n: "mapMinZoom",
              f: [{
                t: 2,
                x: {
                  r: [],
                  s: "2"
                }
              }],
              t: 13
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "p-globalping-networks_network-tests",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "p-globalping-networks_network_head",
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            f: ["Network tests"]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "p-globalping-networks_network-tests_body",
            g: 1
          }],
          f: [{
            t: 7,
            e: "c-controlled-input",
            m: [{
              n: "id",
              f: "ipOrHostname",
              t: 13,
              g: 1
            }, {
              n: "value",
              f: [{
                t: 2,
                r: "testOpts.target"
              }],
              t: 13
            }, {
              n: "error",
              f: [{
                t: 2,
                r: "inputErrors.target"
              }],
              t: 13
            }, {
              n: "placeholder",
              f: "IP or Hostname",
              t: 13,
              g: 1
            }, {
              n: "labelText",
              f: "IP or Hostname",
              t: 13,
              g: 1
            }, {
              n: "classList",
              f: "p-globalping-networks_network-tests_body_input gp_input",
              t: 13,
              g: 1
            }],
            f: []
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "gp_dropdown_reg p-globalping-networks_network-tests_body_select",
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              f: ["Method"]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "btn-group",
                g: 1
              }],
              f: [{
                t: 7,
                e: "button",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-toggle",
                  g: 1
                }, {
                  n: "type",
                  f: "button",
                  t: 13,
                  g: 1
                }, {
                  n: "data-toggle",
                  f: "dropdown",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-haspopup",
                  f: "true",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-expanded",
                  f: "false",
                  t: 13,
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  f: [{
                    t: 2,
                    r: "~/selectedTestType"
                  }]
                }, " ", {
                  t: 7,
                  e: "i",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "fa fa-angle-down",
                    g: 1
                  }, {
                    n: "aria-hidden",
                    f: "true",
                    t: 13,
                    g: 1
                  }]
                }]
              }, " ", {
                t: 7,
                e: "ul",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-menu",
                  g: 1
                }, {
                  n: "role",
                  f: "listbox",
                  t: 13,
                  g: 1
                }],
                f: [{
                  t: 4,
                  f: [{
                    t: 7,
                    e: "li",
                    m: [{
                      n: "aria-selected",
                      f: [{
                        t: 2,
                        x: {
                          r: [".", "selectedTestType"],
                          s: "_0===_1"
                        }
                      }],
                      t: 13
                    }, {
                      n: "role",
                      f: "option",
                      t: 13,
                      g: 1
                    }, {
                      n: ["click"],
                      t: 70,
                      f: {
                        r: ["@this", "."],
                        s: "[_0.setTestType(_1)]"
                      }
                    }],
                    f: [{
                      t: 2,
                      r: "."
                    }]
                  }],
                  n: 52,
                  r: "~/testTypesList"
                }]
              }]
            }]
          }, " ", {
            t: 7,
            e: "button",
            m: [{
              n: "type",
              f: "button",
              t: 13,
              g: 1
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this"],
                s: "[_0.proceedToTest()]"
              }
            }, {
              n: "class",
              f: [" p-globalping-networks_network-tests_body_btn-test gp_btn_green ", {
                t: 4,
                f: ["gp_btn_green_disabled gp_btn_green_loading"],
                n: 50,
                r: "testInProgress"
              }],
              t: 13
            }, {
              n: "data-testid",
              f: "networks-run-test-btn",
              t: 13,
              g: 1
            }, {
              n: "disabled",
              f: [{
                t: 2,
                x: {
                  r: ["testInProgress", "selectedLocation"],
                  s: "_0||!_1"
                }
              }],
              t: 13
            }],
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "div"
              }, " ", {
                t: 7,
                e: "div"
              }, " ", {
                t: 7,
                e: "div"
              }, " ", {
                t: 7,
                e: "div"
              }],
              n: 50,
              r: "testInProgress"
            }, {
              t: 4,
              f: ["Run Test"],
              n: 51,
              l: 1
            }]
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "p-globalping-networks_network-tests_fail-msg",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                n: "width",
                f: "56",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "56",
                t: 13,
                g: 1
              }, {
                n: "alt",
                f: "Fail icon",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: [{
                  t: 2,
                  r: "@shared.assetsHost"
                }, "/img/fail-icon-big.svg"],
                t: 13
              }]
            }, " ", {
              t: 7,
              e: "p",
              f: [{
                t: 4,
                f: [{
                  t: 2,
                  r: "serverErrorMessage"
                }],
                n: 50,
                r: "serverErrorMessage"
              }, {
                t: 4,
                f: [{
                  t: 3,
                  r: "creditErrorMessage"
                }],
                n: 51,
                l: 1
              }]
            }]
          }],
          n: 50,
          x: {
            r: ["serverErrorMessage", "creditErrorMessage"],
            s: "_0||_1"
          }
        }, {
          t: 4,
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "p-globalping-networks_network-tests_results",
              g: 1
            }],
            f: [{
              t: 7,
              e: "pre",
              m: [{
                n: "data-testid",
                f: "networks-test-output",
                t: 13,
                g: 1
              }],
              f: [{
                t: 7,
                e: "em",
                f: [{
                  t: 2,
                  r: "measurementLocationText"
                }]
              }, {
                t: 2,
                r: "testResults.0.result.rawOutput"
              }]
            }]
          }, " "],
          n: 50,
          r: "testResults",
          l: 1
        }, {
          t: 4,
          f: [" ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "p-globalping-networks_network-tests_descr",
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "p-globalping-networks_network-tests_descr_msg",
                g: 1
              }, {
                n: "data-testid",
                f: "networks-test-placeholder",
                t: 13,
                g: 1
              }],
              f: ["Enter a target and click ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "highlighted",
                  g: 1
                }],
                f: ["\"Run Test\""]
              }, " to start a network test from: ", {
                t: 7,
                e: "br"
              }, " ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "highlighted",
                  g: 1
                }],
                f: [{
                  t: 2,
                  r: "selectedLocation.city"
                }, ", ", {
                  t: 2,
                  r: "selectedLocation.country"
                }]
              }, " with ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "highlighted",
                  g: 1
                }],
                f: [{
                  t: 2,
                  r: "networkFullName"
                }]
              }, "."]
            }]
          }],
          n: 51,
          l: 1
        }]
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "p-globalping-networks_explore",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "p-globalping-networks_explore_head",
              g: 1
            }],
            f: ["Explore other networks"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "p-globalping-networks_explore_body",
              g: 1
            }],
            f: [{
              t: 4,
              f: [{
                t: 7,
                e: "a",
                m: [{
                  t: 13,
                  n: "class",
                  f: "p-globalping-networks_explore_network",
                  g: 1
                }, {
                  n: "href",
                  f: ["/networks/", {
                    t: 2,
                    r: "./name"
                  }],
                  t: 13
                }, {
                  n: "data-testid",
                  f: "other-network",
                  t: 13,
                  g: 1
                }],
                f: [{
                  t: 4,
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "width",
                      f: "24",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "24",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: ["/asn-logo/AS", {
                        t: 2,
                        r: "./networkLogoAsn"
                      }, "?v=", {
                        t: 2,
                        r: "@shared.assetsVersion"
                      }, "&size=48"],
                      t: 13
                    }, {
                      n: "loading",
                      f: "lazy",
                      t: 13,
                      g: 1
                    }, {
                      n: ["error"],
                      t: 70,
                      f: {
                        r: ["@this", "."],
                        s: "[_0.onLogoError(_1)]"
                      }
                    }, {
                      n: "alt",
                      f: [{
                        t: 2,
                        r: "./fullName"
                      }, " logo"],
                      t: 13
                    }]
                  }],
                  n: 50,
                  r: "./networkLogoAsn"
                }, {
                  t: 4,
                  f: [{
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "p-globalping-networks_img-placeholder-sm",
                      g: 1
                    }],
                    f: [{
                      t: 2,
                      r: "./fullName.0"
                    }]
                  }],
                  n: 51,
                  l: 1
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "p-globalping-networks_explore_network_name",
                    g: 1
                  }],
                  f: [{
                    t: 2,
                    r: "./fullName"
                  }]
                }]
              }],
              n: 52,
              r: "otherNetworks"
            }]
          }]
        }],
        n: 50,
        r: "otherNetworks.length"
      }, " ", {
        t: 4,
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "p-globalping-networks_logos-by",
            g: 1
          }],
          f: [{
            t: 7,
            e: "a",
            m: [{
              n: "data-testid",
              f: "logo-dev-link",
              t: 13,
              g: 1
            }, {
              n: "href",
              f: "https://logo.dev",
              t: 13,
              g: 1
            }, {
              n: "target",
              f: "_blank",
              t: 13,
              g: 1
            }, {
              n: "rel",
              f: "noopener",
              t: 13,
              g: 1
            }],
            f: ["Network logos provided by Logo.dev"]
          }]
        }],
        n: 50,
        r: "shouldDisplayLogoDevLink"
      }]
    }, " ", {
      t: 7,
      e: "c-gp-footer"
    }]
  }],
  e: {
    "2": function () {
      return 2;
    },
    "[_0]": function (_0) {
      return [_0];
    },
    "[_0.set(\"networkLogoAsn\",null)]": function (_0) {
      return [_0.set("networkLogoAsn", null)];
    },
    "_0===_1": function (_0, _1) {
      return _0 === _1;
    },
    "[_0.setLocation(_1)]": function (_0, _1) {
      return [_0.setLocation(_1)];
    },
    "_0?\"Collapse map\":\"Expand map\"": function (_0) {
      return _0 ? "Collapse map" : "Expand map";
    },
    "[_0.toggle(\"mapExpanded\")]": function (_0) {
      return [_0.toggle("mapExpanded")];
    },
    "true": function () {
      return true;
    },
    "false": function () {
      return false;
    },
    "[_0.setTestType(_1)]": function (_0, _1) {
      return [_0.setTestType(_1)];
    },
    "[_0.proceedToTest()]": function (_0) {
      return [_0.proceedToTest()];
    },
    "_0||!_1": function (_0, _1) {
      return _0 || !_1;
    },
    "_0||_1": function (_0, _1) {
      return _0 || _1;
    },
    "[_0.onLogoError(_1)]": function (_0, _1) {
      return [_0.onLogoError(_1)];
    }
  }
};
component$4.exports.components = {
  "c-show-more-link-list": showMoreLinkList,
  "c-controlled-input": controlledInput,
  "c-notification": notification,
  "c-gp-footer": footer,
  "c-google-maps": googleMaps,
  "c-gp-header": header,
  "r-page": rPage
};
var _networks = ractive.extend(component$4.exports);

var component$3 = {
  exports: {}
};
const GROUP_DEFAULT = 'disabled';
const DEFAULT_SORT_OPTIONS = {
  'country': 'alphabetically',
  'city': 'alphabetically',
  'network': 'probe-count',
  'country-network': 'alphabetically',
  'city-network': 'alphabetically',
  'disabled': 'alphabetically'
};
component$3.exports = {
  data() {
    return {
      _,
      username: '',
      probesLoading: true,
      probesError: null,
      userProbes: null,
      probesByCoords: null,
      filteredProbes: null,
      location: 'World',
      locationCompletedValue: '',
      groupBy: GROUP_DEFAULT,
      sortOrder: DEFAULT_SORT_OPTIONS[GROUP_DEFAULT],
      defaultSortOptions: DEFAULT_SORT_OPTIONS,
      userStats: {
        asn: {
          name: ['ASN'],
          icon: 'file-text.svg',
          count: 0
        },
        city: {
          name: ['city', 'cities'],
          icon: 'city.svg',
          count: 0
        },
        country: {
          name: ['country', 'countries'],
          icon: 'country.svg',
          count: 0
        }
      }
    };
  },
  computed: {
    title() {
      return `${this.get('username')}'s Probes - Globalping`;
    },
    description() {
      return `Find ${this.get('username')}'s Globalping probes.`;
    },
    filter: {
      get() {
        let location = this.get('locationCompletedValue') || '';
        if (location.toLowerCase() === 'world') {
          return '';
        }
        return location.replace(/\+/g, '%');
      },
      set(location) {
        this.set('location', location.replace(/%/g, '+'));
        this.set('locationCompletedValue', location.replace(/%/g, '+'));
      }
    },
    group: {
      get() {
        return this.get('groupBy') === GROUP_DEFAULT ? '' : this.get('groupBy');
      },
      set(group) {
        if (Object.hasOwn(DEFAULT_SORT_OPTIONS, group)) {
          this.set('sortOrder', DEFAULT_SORT_OPTIONS[group]);
        }
        this.set('groupBy', group);
      }
    },
    sort: {
      get() {
        return this.get('sortOrder') === DEFAULT_SORT_OPTIONS[this.get('groupBy')] || this.get('groupBy') === 'disabled' ? '' : this.get('sortOrder');
      },
      set(sort) {
        this.set('sortOrder', sort);
      }
    }
  },
  oninit() {
    if (!ractive.isServer) {
      this.getProbesData();
      this.observe('filteredProbes', probes => {
        if (probes === null) {
          return;
        }
        let entries = Object.entries(this.get('userStats')).map(([key, value]) => {
          if (key === 'probe') {
            return [key, {
              ...value,
              count: probes.length
            }];
          }
          return [key, {
            ...value,
            count: [...new Set(probes.map(probe => probe.location[key]))].length
          }];
        }).sort((a, b) => b[1].count - a[1].count);
        this.set('userStats', {}); // force reordering
        this.set('userStats', Object.fromEntries(entries));
        let groupedByCoords = this.groupProbes(probes);
        setTimeout(() => this.set('probesByCoords', groupedByCoords), 50);
      });
    }
  },
  onrender() {
    if (!ractive.isServer) {
      listeners.screenWidthListener(this);
    }
  },
  handleProbesResponse(response) {
    let user = `u-${this.get('username')}`.toLowerCase();
    let userProbes = response.filter(probe => probe.tags.some(tag => tag.toLowerCase() === user)).sort((a, b) => {
      let aLocation = `${a.location.country}${a.location.city}`;
      let bLocation = `${b.location.country}${b.location.city}`;
      return aLocation < bLocation ? -1 : aLocation > bLocation ? 1 : 0;
    });
    this.set('userProbes', userProbes);
  },
  getProbesData() {
    this.set('probesLoading', true);
    this.set('probesError', null);
    dataCache.getCache('probesResponse', 60 * 1000, http.fetchGlobalpingProbes).then(value => this.handleProbesResponse(value)).catch(error => this.set('probesError', error)).finally(() => this.set('probesLoading', false));
  },
  groupProbes(probes) {
    // group probes by Coordinates
    return probes.reduce((groupedByCoords, probe) => {
      let coords = `${probe.location.latitude}, ${probe.location.longitude}`;
      if (!Object.hasOwn(groupedByCoords, coords)) {
        groupedByCoords[coords] = [];
      }
      groupedByCoords[coords].push(probe);
      return groupedByCoords;
    }, {});
  }
};
component$3.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "r-page",
    m: [{
      n: "noYield",
      f: [{
        t: 2,
        r: "noYield"
      }],
      t: 13
    }, {
      n: "title",
      f: [{
        t: 2,
        r: "title"
      }],
      t: 13
    }, {
      n: "description",
      f: [{
        t: 2,
        r: "description"
      }],
      t: 13
    }],
    f: [" ", {
      t: 7,
      e: "c-notification"
    }, " ", {
      t: 7,
      e: "c-gp-header",
      m: [{
        n: "additionalClasses",
        f: "header-with-globalping-bg",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "p-users",
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "p-users_hero",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "user-banner",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "user-banner_user",
              g: 1
            }],
            f: [{
              t: 7,
              e: "img",
              m: [{
                t: 13,
                n: "class",
                f: "user-banner_user_avatar",
                g: 1
              }, {
                n: "width",
                f: "48",
                t: 13,
                g: 1
              }, {
                n: "height",
                f: "48",
                t: 13,
                g: 1
              }, {
                n: "src",
                f: ["https://github.com/", {
                  t: 2,
                  r: "username"
                }, ".png"],
                t: 13
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "user-banner_user_contact",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "user-banner_user_contact_username",
                  g: 1
                }],
                f: [{
                  t: 2,
                  r: "username"
                }]
              }, " ", {
                t: 7,
                e: "span",
                m: [{
                  t: 13,
                  n: "class",
                  f: "user-banner_user_contact_gh",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "span",
                  f: [{
                    t: 7,
                    e: "img",
                    m: [{
                      n: "width",
                      f: "16",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "16",
                      t: 13,
                      g: 1
                    }, {
                      n: "src",
                      f: [{
                        t: 2,
                        r: "@shared.assetsHost"
                      }, "/img/github-outline.svg"],
                      t: 13
                    }]
                  }, " ", {
                    t: 7,
                    e: "a",
                    m: [{
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "rel",
                      f: "noreferrer",
                      t: 13,
                      g: 1
                    }, {
                      n: "href",
                      f: ["https://github.com/", {
                        t: 2,
                        r: "username"
                      }],
                      t: 13
                    }],
                    f: [{
                      t: 2,
                      r: "username"
                    }]
                  }]
                }]
              }]
            }]
          }, " ", {
            t: 4,
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "user-banner_stats",
                g: 1
              }],
              f: [{
                t: 7,
                e: "span",
                f: [{
                  t: 7,
                  e: "img",
                  m: [{
                    n: "width",
                    f: "20",
                    t: 13,
                    g: 1
                  }, {
                    n: "height",
                    f: "20",
                    t: 13,
                    g: 1
                  }, {
                    n: "src",
                    f: [{
                      t: 2,
                      r: "@shared.assetsHost"
                    }, "/img/radio.svg"],
                    t: 13
                  }]
                }, " ", {
                  t: 2,
                  r: "filteredProbes.length"
                }, " ", {
                  t: 2,
                  x: {
                    r: ["_", "filteredProbes.length"],
                    s: "_0.pluralize(\"probe\",_1)"
                  }
                }]
              }, " ", {
                t: 4,
                f: [{
                  t: 4,
                  f: [{
                    t: 7,
                    e: "span",
                    f: [{
                      t: 7,
                      e: "img",
                      m: [{
                        n: "width",
                        f: "20",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "20",
                        t: 13,
                        g: 1
                      }, {
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/", {
                          t: 2,
                          r: "icon"
                        }],
                        t: 13
                      }]
                    }, " ", {
                      t: 2,
                      r: "count"
                    }, " ", {
                      t: 2,
                      x: {
                        r: ["~/_", "name", "count"],
                        s: "(function(){var x$0;return((x$0=_0.pluralize).apply(x$0,[].concat(_1,[_2])));})()"
                      }
                    }]
                  }],
                  n: 50,
                  r: "count"
                }],
                n: 52,
                r: "userStats"
              }]
            }],
            n: 50,
            r: "filteredProbes"
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "p-users_hero_map-wrapper",
            g: 1
          }],
          f: [{
            t: 7,
            e: "c-google-maps",
            m: [{
              t: 13,
              n: "class",
              f: "p-users_hero_map-wrapper_map",
              g: 1
            }, {
              n: "iwClass",
              f: "p-users_iw",
              t: 13,
              g: 1
            }, {
              n: "probesByCoords",
              f: [{
                t: 2,
                r: "probesByCoords"
              }],
              t: 13
            }, {
              n: "hasCluster",
              f: [{
                t: 2,
                x: {
                  r: [],
                  s: "true"
                }
              }],
              t: 13
            }, {
              n: "focusOnChange",
              f: [{
                t: 2,
                x: {
                  r: [],
                  s: "true"
                }
              }],
              t: 13
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "p-users_filtered-list",
          g: 1
        }],
        f: [{
          t: 7,
          e: "c-filtered-probe-list",
          m: [{
            n: "rawProbes",
            f: [{
              t: 2,
              r: "userProbes"
            }],
            t: 13
          }, {
            n: "filteredProbes",
            f: [{
              t: 2,
              r: "filteredProbes"
            }],
            t: 13
          }, {
            n: "location",
            f: [{
              t: 2,
              r: "location"
            }],
            t: 13
          }, {
            n: "locationCompletedValue",
            f: [{
              t: 2,
              r: "locationCompletedValue"
            }],
            t: 13
          }, {
            n: "groupBy",
            f: [{
              t: 2,
              r: "groupBy"
            }],
            t: 13
          }, {
            n: "sortOrder",
            f: [{
              t: 2,
              r: "sortOrder"
            }],
            t: 13
          }, {
            n: "refresh",
            f: [{
              t: 2,
              r: "@this.getProbesData"
            }],
            t: 13
          }, {
            n: "probesLoading",
            f: [{
              t: 2,
              r: "probesLoading"
            }],
            t: 13
          }, {
            n: "probesError",
            f: [{
              t: 2,
              r: "probesError"
            }],
            t: 13
          }, {
            n: "defaultSortOptions",
            f: [{
              t: 2,
              r: "defaultSortOptions"
            }],
            t: 13
          }, {
            n: "filter",
            f: [{
              t: 2,
              r: "filter"
            }],
            t: 13
          }]
        }]
      }]
    }, " ", {
      t: 7,
      e: "c-gp-footer"
    }],
    p: {
      seo: [{
        t: 7,
        e: "meta",
        m: [{
          n: "name",
          f: "canonical",
          t: 13,
          g: 1
        }, {
          n: "content",
          f: ["/users/", {
            t: 2,
            r: "username"
          }],
          t: 13
        }]
      }]
    }
  }],
  e: {
    "_0.pluralize(\"probe\",_1)": function (_0, _1) {
      return _0.pluralize("probe", _1);
    },
    "(function(){var x$0;return((x$0=_0.pluralize).apply(x$0,[].concat(_1,[_2])));})()": function (_0, _1, _2) {
      return function () {
        var x$0;
        return (x$0 = _0.pluralize).apply(x$0, [].concat(_1, [_2]));
      }();
    },
    "true": function () {
      return true;
    }
  }
};
component$3.exports.components = {
  "c-filtered-probe-list": filteredProbeList,
  "c-notification": notification,
  "c-gp-footer": footer,
  "c-google-maps": googleMaps,
  "c-gp-header": header,
  "r-page": rPage
};
var _users = ractive.extend(component$3.exports);

var component$2 = {
  exports: {}
};
const ID_PREFIX = 'id-';
component$2.exports = {
  data() {
    return {
      _,
      html: '',
      markdown: ''
    };
  },
  oninit() {
    if (!ractive.isServer) {
      _.injectGlobalStyle('https://cdn.jsdelivr.net/gh/highlightjs/cdn-release@11.7.0/build/styles/github.min.css');
      Promise.all([
      // eslint-disable-next-line n/no-missing-import
      import('https://cdn.jsdelivr.net/npm/marked@17.0.1/+esm'),
      // eslint-disable-next-line n/no-missing-import
      import('https://cdn.jsdelivr.net/npm/marked-gfm-heading-id@4.1.3/+esm'),
      // eslint-disable-next-line n/no-missing-import
      import('https://cdn.jsdelivr.net/npm/marked-highlight@2.2.3/+esm'),
      // eslint-disable-next-line n/no-missing-import
      import('https://cdn.jsdelivr.net/npm/@highlightjs/cdn-assets@11.7.0/es/highlight.min.js')]).then(([{
        marked
      }, {
        gfmHeadingId
      }, {
        markedHighlight
      }, {
        default: hljs
      }]) => {
        marked.use({
          renderer: {
            table(...rows) {
              return `<div class="table-responsive"><table class="table table-striped">${rows.join('')}</table></div>`;
            }
          }
        });
        marked.use(gfmHeadingId({
          prefix: ID_PREFIX
        }));
        marked.use(markedHighlight({
          langPrefix: 'hljs language-',
          highlight(code, language) {
            return hljs.getLanguage(language) ? hljs.highlightAuto(code, ['html', 'javascript', 'sh', 'bash']).value : code;
          }
        }));
        this.observe('markdown', md => {
          this.set('html', marked.parse(md));
        });
      });
    }
  }
};
component$2.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-markdown",
      g: 1
    }],
    f: [{
      t: 7,
      e: "c-html",
      m: [{
        n: "html",
        f: [{
          t: 2,
          r: "html"
        }],
        t: 13
      }]
    }]
  }]
};
component$2.exports.components = {
  "c-html": html
};
var markdown = ractive.extend(component$2.exports);

var component$1 = {
  exports: {}
};
component$1.exports = {
  data() {
    return {};
  },
  oninit() {
    if (!ractive.isServer && !this.get('@shared.tuText')) {
      _.makeHTTPRequest({
        url: 'https://raw.githubusercontent.com/jsdelivr/globalping/master/docs/terms/Terms%20of%20Use.md',
        rawResponse: true
      }).then(response => {
        this.set('@shared.tuText', response);
      }).catch(() => {
        this.set('@shared.tuText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/globalping/blob/master/docs/terms/Terms%20of%20Use.md`);
      });
      _.makeHTTPRequest({
        url: 'https://raw.githubusercontent.com/jsdelivr/globalping/master/docs/terms/Privacy%20Policy.md',
        rawResponse: true
      }).then(response => {
        this.set('@shared.ppText', response);
      }).catch(() => {
        this.set('@shared.ppText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/globalping/blob/master/docs/terms/Privacy%20Policy.md`);
      });
      _.makeHTTPRequest({
        url: 'https://raw.githubusercontent.com/jsdelivr/globalping/master/docs/terms/Cookie%20Policy.md',
        rawResponse: true
      }).then(response => {
        this.set('@shared.cpText', response);
      }).catch(() => {
        this.set('@shared.cpText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/globalping/blob/master/docs/terms/Cookie%20Policy.md`);
      });
    }
  }
};
component$1.exports.template = {
  v: 4,
  t: []
};
var githubMdDocumentsPrefetch = ractive.extend(component$1.exports);

var component = {
  exports: {}
};
component.exports = {
  data() {
    return {
      title: 'Terms & Policies - Globalping',
      description: 'Learn about the terms of usage of the global network testing platform Globalping.',
      currentPolicy: 'terms-of-use'
    };
  },
  onrender() {
    if (!ractive.isServer) {
      listeners.stickySidebarScrollListener(this);
    }
  }
};
component.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "r-page",
    m: [{
      n: "noYield",
      f: [{
        t: 2,
        r: "noYield"
      }],
      t: 13
    }, {
      n: "title",
      f: [{
        t: 2,
        r: "title"
      }],
      t: 13
    }, {
      n: "description",
      f: [{
        t: 2,
        r: "description"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "c-gp-github-md-documents-prefetch"
    }, " ", {
      t: 7,
      e: "c-notification"
    }, " ", {
      t: 7,
      e: "c-gp-header",
      m: [{
        n: "additionalClasses",
        f: "header-with-globalping-bg",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "p-privacy-policy",
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          n: "class",
          f: ["please-wait-sign ", {
            t: 4,
            f: ["not-displayed"],
            n: 50,
            x: {
              r: ["@shared.tuText", "@shared.ppText", "@shared.cpText"],
              s: "_0&&_1&&_2"
            }
          }],
          t: 13
        }],
        f: ["Please wait while the document loads."]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          n: "class",
          f: ["dropdown ", {
            t: 4,
            f: ["not-displayed"],
            n: 51,
            x: {
              r: ["@shared.tuText", "@shared.ppText", "@shared.cpText"],
              s: "_0&&_1&&_2"
            }
          }],
          t: 13
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "dropdown-toggle",
            g: 1
          }, {
            n: "data-toggle",
            f: "dropdown",
            t: 13,
            g: 1
          }, {
            n: "aria-haspopup",
            f: "true",
            t: 13,
            g: 1
          }, {
            n: "aria-expanded",
            f: "false",
            t: 13,
            g: 1
          }],
          f: [{
            t: 7,
            e: "span",
            f: ["Navigation"]
          }, " ", {
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "toggle-icon",
              g: 1
            }],
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "toggle-bar",
                g: 1
              }]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "toggle-bar",
                g: 1
              }]
            }]
          }]
        }, " ", {
          t: 7,
          e: "ul",
          m: [{
            t: 13,
            n: "class",
            f: "dropdown-menu",
            g: 1
          }],
          f: [{
            t: 7,
            e: "li",
            f: [{
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "dropdown-subtitle",
                g: 1
              }],
              f: ["Documents:"]
            }]
          }, " ", {
            t: 7,
            e: "li",
            f: [{
              t: 7,
              e: "a",
              m: [{
                n: "href",
                f: "/terms/terms-of-use",
                t: 13,
                g: 1
              }, {
                n: "class",
                f: ["dropdown-item ", {
                  t: 4,
                  f: ["active"],
                  n: 50,
                  x: {
                    r: ["currentPolicy"],
                    s: "_0===\"terms-of-use\""
                  }
                }],
                t: 13
              }],
              f: ["Terms of Use"]
            }]
          }, " ", {
            t: 7,
            e: "li",
            f: [{
              t: 7,
              e: "a",
              m: [{
                n: "href",
                f: "/terms/privacy-policy",
                t: 13,
                g: 1
              }, {
                n: "class",
                f: ["dropdown-item ", {
                  t: 4,
                  f: ["active"],
                  n: 50,
                  x: {
                    r: ["currentPolicy"],
                    s: "_0===\"privacy-policy\""
                  }
                }],
                t: 13
              }],
              f: ["Privacy Policy"]
            }]
          }, " ", {
            t: 7,
            e: "li",
            f: [{
              t: 7,
              e: "a",
              m: [{
                n: "href",
                f: "/terms/cookie-policy",
                t: 13,
                g: 1
              }, {
                n: "class",
                f: ["dropdown-item ", {
                  t: 4,
                  f: ["active"],
                  n: 50,
                  x: {
                    r: ["currentPolicy"],
                    s: "_0===\"cookie-policy\""
                  }
                }],
                t: 13
              }],
              f: ["Cookie Policy"]
            }]
          }]
        }]
      }, " ", {
        t: 7,
        e: "div",
        m: [{
          n: "class",
          f: ["page-content ", {
            t: 4,
            f: ["not-displayed"],
            n: 51,
            x: {
              r: ["@shared.tuText", "@shared.ppText", "@shared.cpText"],
              s: "_0&&_1&&_2"
            }
          }],
          t: 13
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "page-content_side-menu",
            g: 1
          }],
          f: [{
            t: 7,
            e: "div",
            m: [{
              t: 13,
              n: "class",
              f: "menu-section",
              g: 1
            }],
            f: [{
              t: 7,
              e: "strong",
              m: [{
                t: 13,
                n: "class",
                f: "section-title",
                g: 1
              }],
              f: ["Documents:"]
            }, " ", {
              t: 7,
              e: "div",
              m: [{
                t: 13,
                n: "class",
                f: "section-list",
                g: 1
              }],
              f: [{
                t: 7,
                e: "div",
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "href",
                    f: "/terms/terms-of-use",
                    t: 13,
                    g: 1
                  }, {
                    n: "class",
                    f: [{
                      t: 4,
                      f: ["active"],
                      n: 50,
                      x: {
                        r: ["currentPolicy"],
                        s: "_0===\"terms-of-use\""
                      }
                    }],
                    t: 13
                  }, {
                    n: "data-testid",
                    f: "terms-of-use",
                    t: 13,
                    g: 1
                  }],
                  f: ["Terms of Use"]
                }]
              }, " ", {
                t: 7,
                e: "div",
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "href",
                    f: "/terms/privacy-policy",
                    t: 13,
                    g: 1
                  }, {
                    n: "class",
                    f: [{
                      t: 4,
                      f: ["active"],
                      n: 50,
                      x: {
                        r: ["currentPolicy"],
                        s: "_0===\"privacy-policy\""
                      }
                    }],
                    t: 13
                  }, {
                    n: "data-testid",
                    f: "privacy-policy",
                    t: 13,
                    g: 1
                  }],
                  f: ["Privacy Policy"]
                }]
              }, " ", {
                t: 7,
                e: "div",
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: "href",
                    f: "/terms/cookie-policy",
                    t: 13,
                    g: 1
                  }, {
                    n: "class",
                    f: [{
                      t: 4,
                      f: ["active"],
                      n: 50,
                      x: {
                        r: ["currentPolicy"],
                        s: "_0===\"cookie-policy\""
                      }
                    }],
                    t: 13
                  }, {
                    n: "data-testid",
                    f: "cookie-policy",
                    t: 13,
                    g: 1
                  }],
                  f: ["Cookie Policy"]
                }]
              }]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "page-content_main",
            g: 1
          }],
          f: [{
            t: 7,
            e: "h1",
            m: [{
              t: 13,
              n: "class",
              f: "page-content_main_title",
              g: 1
            }],
            f: ["Terms & Policies"]
          }, " ", {
            t: 4,
            f: [{
              t: 7,
              e: "c-markdown",
              m: [{
                n: "markdown",
                f: [{
                  t: 2,
                  r: "@shared.ppText"
                }],
                t: 13
              }]
            }],
            n: 50,
            x: {
              r: ["currentPolicy"],
              s: "_0===\"privacy-policy\""
            }
          }, {
            t: 4,
            f: [{
              t: 7,
              e: "c-markdown",
              m: [{
                n: "markdown",
                f: [{
                  t: 2,
                  r: "@shared.cpText"
                }],
                t: 13
              }]
            }, " "],
            n: 50,
            x: {
              r: ["currentPolicy"],
              s: "_0===\"cookie-policy\""
            },
            l: 1
          }, {
            t: 4,
            f: [" ", {
              t: 7,
              e: "c-markdown",
              m: [{
                n: "markdown",
                f: [{
                  t: 2,
                  r: "@shared.tuText"
                }],
                t: 13
              }]
            }],
            n: 51,
            l: 1
          }]
        }]
      }]
    }, " ", {
      t: 7,
      e: "c-gp-footer"
    }]
  }],
  e: {
    "_0&&_1&&_2": function (_0, _1, _2) {
      return _0 && _1 && _2;
    },
    "_0===\"terms-of-use\"": function (_0) {
      return _0 === "terms-of-use";
    },
    "_0===\"privacy-policy\"": function (_0) {
      return _0 === "privacy-policy";
    },
    "_0===\"cookie-policy\"": function (_0) {
      return _0 === "cookie-policy";
    }
  }
};
component.exports.components = {
  "c-markdown": markdown,
  "c-gp-github-md-documents-prefetch": githubMdDocumentsPrefetch,
  "c-notification": notification,
  "c-gp-footer": footer,
  "c-gp-header": header,
  "r-page": rPage
};
var terms = ractive.extend(component.exports);

const awaitScriptLoad = initApp => {
  let reqPlugins = Array.from(document.querySelectorAll('.prerequisite-script'));
  let pluginsReady = false;
  let pluginPromises = reqPlugins.map(plugin => {
    return new Promise(resolve => {
      if (plugin.loaded) {
        resolve(plugin);
        return;
      }
      plugin.addEventListener('load', () => resolve(plugin), {
        once: true
      });
      plugin.addEventListener('error', () => resolve(plugin), {
        once: true
      });
    });
  });
  Promise.all(pluginPromises).then(() => {
    pluginsReady = true;
    tryInitApp();
  });
  Promise.all([import('https://cdn.jsdelivr.net/npm/ractive@1.4.4/runtime.min.mjs'),
  // eslint-disable-next-line n/no-missing-import
  import('https://cdn.jsdelivr.net/npm/ractive-route@0.3.13/ractive-route.min.mjs')]).then(([{
    default: Ractive
  }, {
    Router
  }]) => {
    Ractive.Router = Router;
    commonjsGlobal.Ractive = Ractive;
    tryInitApp();
  });
  let tryInitApp = () => {
    if (typeof Ractive !== 'undefined' && pluginsReady) {
      initApp();
    }
  };
};
var awaitScriptLoad_1 = awaitScriptLoad;

const {
  getGlobalpingUser
} = http;
const initApp = () => {
  Ractive.DEBUG = location.hostname === 'localhost';
  commonjsGlobal.app = app$1;
  app$1.router = new Ractive.Router({
    el: '#page',
    data() {
      return {
        app: app$1
      };
    },
    globals: ['query', 'collection'],
    history: historyProxy
  });
  app$1.router.addRoute('/', _index, {
    qs: ['location', 'measurement', 'display', 'map', 'by', 'order', 'collapse', 'view']
  });
  app$1.router.addRoute('/network-tools/:params?', networkTools);
  app$1.router.addRoute('/sponsors', sponsors);
  app$1.router.addRoute('/credits', credits);
  app$1.router.addRoute('/network', network, {
    qs: ['filter', 'group', 'sort']
  });
  app$1.router.addRoute('/network-providers', networkProviders, {
    qs: ['filter', 'sort']
  });
  app$1.router.addRoute('/terms', terms);
  app$1.router.addRoute('/terms/:currentPolicy', terms);
  app$1.router.addRoute('/networks/:networkName', _networks);
  app$1.router.addRoute('/users/:username', _users, {
    qs: ['filter', 'group', 'sort']
  });
  app$1.router.replaceQueryParam = function (name, newValue, view = this.route.view) {
    let urlSearchParams = new URLSearchParams(location.search);
    if (newValue !== null && newValue !== undefined) {
      urlSearchParams.set(name, newValue);
    } else {
      urlSearchParams.delete(name);
    }
    let queryString = urlSearchParams.size ? `?${urlSearchParams.toString()}` : '';
    let hash = location.hash || '';
    this.history.replaceState(this.history.state, document.title, `${location.pathname}${queryString}${hash}`);
    view?.set(name, newValue);
    return this;
  };
  app$1.getSignInLink = () => {
    let url = new URL('https://dash-directus.globalping.io/auth/login/github');
    url.searchParams.set('redirect', `https://globalping.io/auth/callback?redirect=${encodeURIComponent(location.href)}`);
    return url.toString();
  };
  app$1.signIn = () => {
    location.href = app$1.getSignInLink();
  };
  app$1.signOut = () => {
    http.gpLogOut().then(() => Ractive.sharedSet('user', null));
  };
  _.onDocumentReady(() => {
    let state = {};
    let ractive = new Ractive();
    ractive.set('@shared.app', app$1);
    ractive.set('@shared.escape', escape);
    function escape(string) {
      return string.replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
    }
    let setUser = user => {
      ractive.set('@shared.user', user);
    };
    getGlobalpingUser(setUser).then(setUser);
    try {
      let shared = JSON.parse(document.querySelector('#ractive-shared').innerHTML.trim());
      if (shared) {
        Object.keys(shared).forEach(key => {
          ractive.set(`@shared.${key}`, shared[key]);
        });
      }
    } catch {}
    try {
      state = JSON.parse(document.querySelector('#ractive-data').innerHTML.trim());
    } catch {}
    if (!document.title.includes('not found')) {
      app$1.router.init({
        noScroll: true,
        state: {
          ...state,
          ...app$1.router.data()
        }
      }).watchLinks().watchState();
    }
  });
};
const historyChangeMethods = ['pushState', 'replaceState', 'back', 'forward', 'go'];
const historyProxy = new Proxy(history, {
  get(target, prop) {
    let value = target[prop];

    // If it's a method that changes history, wrap it to emit an event
    if (historyChangeMethods.includes(prop) && typeof value === 'function') {
      return function (...args) {
        let result = value.apply(target, args);

        // Emit historyChange event
        let event = new CustomEvent('historyChange', {
          detail: {
            method: prop,
            args
          }
        });
        window.dispatchEvent(event);
        return result;
      };
    }

    // For all other properties/methods, return as-is
    if (typeof value === 'function') {
      return value.bind(target);
    }
    return value;
  },
  set(target, prop, value) {
    target[prop] = value;
    return true;
  }
});
let app$1 = {
  config: {}
};
awaitScriptLoad_1(initApp);
var app_1 = app$1;

export { app_1 as default };
